
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("YEraZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4992e440af50537c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $8BZ1O = parcelRequire("8BZ1O");

var $4oKWa = parcelRequire("4oKWa");

var $6cwrM = parcelRequire("6cwrM");

var $bWbSz = parcelRequire("bWbSz");

var $1aMZc = parcelRequire("1aMZc");

var $aeIT6 = parcelRequire("aeIT6");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $jK1pm = parcelRequire("jK1pm");
const $4992e440af50537c$var$JiraBusinessSummaryApp = ()=>{
    const { data: project } = (0, $aeIT6.useProject)();
    const urlBuilder = (0, $eUqFw.useMemo)(()=>(0, $6cwrM.projectUrlBuilderFactory)(project?.key ?? ''), [
        project
    ]);
    const hasAdministerProjectPermission = Boolean(project?.permissions.administerProject);
    const hasCreateItem = Boolean(project?.permissions.createIssues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jira-business-summary-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BZ1O.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bWbSz.default), {
        // @ts-expect-error delete when cleaning up fun-1194_decouple_overview_summary_page
        DetailsComponent: (0, $1aMZc.default),
        hasCreateItem: hasCreateItem,
        hasInviteTeammateButton: hasAdministerProjectPermission,
        hasManageTypesButton: hasAdministerProjectPermission,
        urlBuilder: urlBuilder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4oKWa.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "core"
    })));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$4992e440af50537c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4992e440af50537c$var$JiraBusinessSummaryApp);

});
parcelRegister("8BZ1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $80390eebeffb6a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDUCT = parcelRequire("bDUCT");

var $fDLFb = parcelRequire("fDLFb");

var $eZbpk = parcelRequire("eZbpk");

var $ePgRW = parcelRequire("ePgRW");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jWIW7 = parcelRequire("jWIW7");

var $7IBv4 = parcelRequire("7IBv4");

var $8WuJm = parcelRequire("8WuJm");

var $aeIT6 = parcelRequire("aeIT6");

var $dWLk9 = parcelRequire("dWLk9");

var $lB25E = parcelRequire("lB25E");

var $hCCuu = parcelRequire("hCCuu");

var $k4xGW = parcelRequire("k4xGW");
const $80390eebeffb6a20$var$ProjectContextProvider = ({ children: children })=>{
    const { data: project, loading: loading, error: error } = (0, $aeIT6.useProject)();
    const { replace: replace } = (0, $lB25E.useRouterActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = project?.id;
    const projectKey = project?.key;
    const projectType = project?.type;
    const isTeamManaged = Boolean(project?.isSimplified);
    const jqlContext = projectKey ? `project = '${projectKey}'` : '';
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            projectType: projectType
        }), [
        projectId,
        isTeamManaged,
        projectType
    ]);
    const entityData = (0, $eUqFw.useMemo)(()=>project?.permissions?.viewIssues ? {
            name: project.name,
            id: String(project.id)
        } : null, [
        project
    ]);
    const projects = (0, $eUqFw.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $eUqFw.useMemo)(()=>projectId ? [
            projectId
        ] : undefined, [
        projectId
    ]);
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    if (project?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    else if (project == null || entityData == null || error) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4xGW.default), null), error && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE),
        error: error
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQAZu.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDLFb.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePgRW.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDUCT.AriProvider), {
        ari: projectAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZbpk.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWIW7.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: String(project?.id),
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: String(project?.id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    }), content);
};
var $80390eebeffb6a20$export$2e2bcd8739ae039 = $80390eebeffb6a20$var$ProjectContextProvider;

});
parcelRegister("bDUCT", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $76c0a50c757f3bcd$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $76c0a50c757f3bcd$export$badcacdc306567b8);

var $eUqFw = parcelRequire("eUqFw");
const $76c0a50c757f3bcd$var$AriContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $76c0a50c757f3bcd$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76c0a50c757f3bcd$var$AriContext.Provider, {
        value: ari
    }, children);
const $76c0a50c757f3bcd$export$badcacdc306567b8 = ()=>(0, $eUqFw.useContext)($76c0a50c757f3bcd$var$AriContext);

});

parcelRegister("fDLFb", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $984e8248b41af828$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $984e8248b41af828$export$ff2574b00bc1c100);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $984e8248b41af828$var$BusinessEntityContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $984e8248b41af828$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($984e8248b41af828$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $984e8248b41af828$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $eUqFw.useContext)($984e8248b41af828$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("eZbpk", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $28ab7b3257a6571c$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $28ab7b3257a6571c$export$f32e2f688fc08561);

var $eUqFw = parcelRequire("eUqFw");
const $28ab7b3257a6571c$var$JqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $28ab7b3257a6571c$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28ab7b3257a6571c$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $28ab7b3257a6571c$export$f32e2f688fc08561 = ()=>(0, $eUqFw.useContext)($28ab7b3257a6571c$var$JqlContext);

});

parcelRegister("ePgRW", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $d87d469a5640e4cf$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $d87d469a5640e4cf$export$f39c07717ad8c35b);

var $eUqFw = parcelRequire("eUqFw");
const $d87d469a5640e4cf$var$RealtimeContext = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d87d469a5640e4cf$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $eUqFw.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87d469a5640e4cf$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $d87d469a5640e4cf$export$f39c07717ad8c35b = ()=>(0, $eUqFw.useContext)($d87d469a5640e4cf$var$RealtimeContext);

});

parcelRegister("kQAZu", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $5a070342b3707183$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $5a070342b3707183$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5a070342b3707183$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5a070342b3707183$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a070342b3707183$var$Context.Provider, {
        value: project
    }, children);
const $5a070342b3707183$export$51b1383ef8844a7 = ()=>{
    const project = (0, $eUqFw.useContext)($5a070342b3707183$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("jWIW7", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $85c94258ff14c8b6$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $85c94258ff14c8b6$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $85c94258ff14c8b6$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $85c94258ff14c8b6$export$9dc8a291956c2fa9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");
const $85c94258ff14c8b6$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $85c94258ff14c8b6$var$FiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($85c94258ff14c8b6$var$DEFAULT_VALUE);
const $85c94258ff14c8b6$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>{
        if (!projects) return $85c94258ff14c8b6$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85c94258ff14c8b6$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $85c94258ff14c8b6$export$f39bce8705b01ff5 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).assigneeQuery;
const $85c94258ff14c8b6$export$b71768ffb8163578 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).projectFilter;
const $85c94258ff14c8b6$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext);
    return (0, $eUqFw.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $9TEHc.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $lO4Or.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("9TEHc", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $199ced4cefdf295b$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $199ced4cefdf295b$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $199ced4cefdf295b$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $199ced4cefdf295b$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $199ced4cefdf295b$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", () => $199ced4cefdf295b$export$fb22dccd99438559);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $199ced4cefdf295b$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $199ced4cefdf295b$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $199ced4cefdf295b$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $199ced4cefdf295b$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $199ced4cefdf295b$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $199ced4cefdf295b$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $199ced4cefdf295b$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $199ced4cefdf295b$export$1989c7236a398e8a);

var $c9TLT = parcelRequire("c9TLT");

var $lO4Or = parcelRequire("lO4Or");
const $199ced4cefdf295b$export$b6d617db656efcca = 360;
const $199ced4cefdf295b$export$90bfd0dcc25478e1 = (0, $c9TLT.gridSize) * 2.5;
const $199ced4cefdf295b$export$dd535f74d98d8b3 = 32;
const $199ced4cefdf295b$export$dba112976ea61483 = $199ced4cefdf295b$export$b6d617db656efcca - $199ced4cefdf295b$export$90bfd0dcc25478e1 * 2;
const $199ced4cefdf295b$export$fe1082abeeda69ed = (0, $c9TLT.gridSize) / 2;
const $199ced4cefdf295b$export$17ed91292eb6c163 = (0, $c9TLT.gridSize) * 2;
const $199ced4cefdf295b$export$fb22dccd99438559 = 14;
const $199ced4cefdf295b$export$15839778e99d81e7 = 215;
const $199ced4cefdf295b$export$de3cbeaaf9d2669 = 28;
const $199ced4cefdf295b$export$39aa3a14ebf850c7 = 150;
const $199ced4cefdf295b$export$1178808c606e043b = 'dateRange';
const $199ced4cefdf295b$export$c269ba5d631cb115 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.CREATED),
    $199ced4cefdf295b$export$1178808c606e043b,
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PROJECT_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.GOALS_CF_TYPE),
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    (0, $lO4Or.PARENT_FIELD_TYPE)
];
const $199ced4cefdf295b$export$232814e45256d5dc = [
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE)
];
const $199ced4cefdf295b$export$9615a3d79408a88a = new Set([
    ...$199ced4cefdf295b$export$c269ba5d631cb115,
    ...$199ced4cefdf295b$export$232814e45256d5dc
]);
const $199ced4cefdf295b$export$a21166a4b76932b5 = new Set([
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
]);
const $199ced4cefdf295b$export$90ca377eb0b24ff1 = {
    assignee: (0, $lO4Or.ASSIGNEE_TYPE),
    component: (0, $lO4Or.COMPONENTS_TYPE),
    created: (0, $lO4Or.CREATED),
    issuetype: (0, $lO4Or.ISSUE_TYPE),
    labels: (0, $lO4Or.LABELS_TYPE),
    priority: (0, $lO4Or.PRIORITY_TYPE),
    project: (0, $lO4Or.PROJECT_TYPE),
    reporter: (0, $lO4Or.REPORTER_TYPE),
    status: (0, $lO4Or.STATUS_TYPE),
    type: (0, $lO4Or.ISSUE_TYPE),
    updated: (0, $lO4Or.UPDATED)
};
const $199ced4cefdf295b$export$6a2e733db5135f27 = (0, $c9TLT.gridSize) * 3.5;
const $199ced4cefdf295b$export$1989c7236a398e8a = 50;
const $199ced4cefdf295b$export$91fc9d65fca142a3 = 'users';
const $199ced4cefdf295b$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hCCuu", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $be9e1adc5e199dda$export$cb40bbf7ea51db63);
const $be9e1adc5e199dda$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("k4xGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1de8d4690ad3f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e1de8d4690ad3f8$var$NotFoundComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8UKUA")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $7e1de8d4690ad3f8$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e1de8d4690ad3f8$var$NotFoundComponent, null));
var $7e1de8d4690ad3f8$export$2e2bcd8739ae039 = $7e1de8d4690ad3f8$var$NotFoundAsync;

});
parcelRegister("8UKUA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("dX4bq")
]).then(()=>parcelRequire('gutLJ'));

});



parcelRegister("4oKWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0452a1a9b365a8a8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7e8pf = parcelRequire("7e8pf");

var $4G5xU = parcelRequire("4G5xU");

var $hpCMA = parcelRequire("hpCMA");

var $eI5EY = parcelRequire("eI5EY");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $h5SwL = parcelRequire("h5SwL");

var $bWbSz = parcelRequire("bWbSz");

var $cGyoW = parcelRequire("cGyoW");



const $0452a1a9b365a8a8$var$Summary = ()=>{
    const { hasPrefetching: hasPrefetching } = (0, $bWbSz.useSummaryFeatures)();
    const view = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpCMA.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $h5SwL.MAIN_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "summary",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "summary"
    }, (0, $eI5EY.fg)('fun-1194_decouple_overview_summary_page') || hasPrefetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGyoW.PrefetchedSummaryProvider), null, view) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGyoW.SummaryProvider), null, view), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))));
};
var $0452a1a9b365a8a8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0452a1a9b365a8a8$var$Summary);

});
parcelRegister("7e8pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed5a3ae63b1b20d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kar7l = parcelRequire("kar7l");


var $hSCS8 = parcelRequire("hSCS8");

var $eUu4u = parcelRequire("eUu4u");

var $2ESAZ = parcelRequire("2ESAZ");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $3ed5a3ae63b1b20d$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent }] = (0, $hSCS8.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUu4u.SidebarLayout), {
        theme: sidebarTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $3ed5a3ae63b1b20d$var$contentWrapperStyles,
            isSidebarOpen && $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ThemedContainer), {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $d02be44255a1478f$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className
    }, content);
};
const $3ed5a3ae63b1b20d$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $kar7l.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $3ed5a3ae63b1b20d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3ed5a3ae63b1b20d$var$BusinessAppWrapper);

});
const $d02be44255a1478f$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("hSCS8", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $cda1eebb5d053035$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $cda1eebb5d053035$export$54c70f22f548bff8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jGcn0 = parcelRequire("jGcn0");

var $iclz4 = parcelRequire("iclz4");

var $WBLbN = parcelRequire("WBLbN");

var $l0jym = parcelRequire("l0jym");
const $cda1eebb5d053035$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $cda1eebb5d053035$export$b16f75f2e0c3c029 = 360;
const $cda1eebb5d053035$export$ddc11e4d41e7cf62 = ()=>[
        (0, $jGcn0.SELECTED_ISSUE_PARAM),
        (0, $jGcn0.SELECTED_COMMENT_PARAM)
    ];
const $cda1eebb5d053035$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $cda1eebb5d053035$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $cda1eebb5d053035$export$b16f75f2e0c3c029);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $l0jym.localStorage).set($cda1eebb5d053035$export$86880b4b2e1a2384, newWidth);
    };
const $cda1eebb5d053035$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $cda1eebb5d053035$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        });
    };
const $cda1eebb5d053035$var$actions = {
    setSidebarContent: $cda1eebb5d053035$var$setSidebarContent,
    setSidebarWidth: $cda1eebb5d053035$var$setSidebarWidth,
    setSidebarOnClose: $cda1eebb5d053035$var$setSidebarOnClose,
    closeSidebar: $cda1eebb5d053035$var$closeSidebar
};
const $cda1eebb5d053035$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $l0jym.localStorage).get($cda1eebb5d053035$export$86880b4b2e1a2384) || $cda1eebb5d053035$export$b16f75f2e0c3c029,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $cda1eebb5d053035$var$actions,
    name: 'JWMSidebarStore'
});
const $cda1eebb5d053035$var$useHook = (0, $WBLbN.createHook)($cda1eebb5d053035$var$Store);
const $cda1eebb5d053035$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $cda1eebb5d053035$var$useHook();
    const sidebarQueryParams = $cda1eebb5d053035$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("jGcn0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $15ed10c690a013f2$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $15ed10c690a013f2$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $15ed10c690a013f2$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $15ed10c690a013f2$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $15ed10c690a013f2$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $15ed10c690a013f2$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $15ed10c690a013f2$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $15ed10c690a013f2$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $15ed10c690a013f2$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $15ed10c690a013f2$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $15ed10c690a013f2$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $15ed10c690a013f2$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $15ed10c690a013f2$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $15ed10c690a013f2$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $15ed10c690a013f2$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$c72ea455b368cdd9);

const $15ed10c690a013f2$export$8386e51ba415e85d = (0, $44cab0426b6cf0d7$export$1dee026a19752d6b);
const $15ed10c690a013f2$export$159fe44438c210e9 = '48x48';
const $15ed10c690a013f2$export$d8301e0b33832d94 = 'filter';
const $15ed10c690a013f2$export$599c163c1570a353 = 'inlineCreate';
const $15ed10c690a013f2$export$3a74d1a195d2f007 = 'inviteOpen';
const $15ed10c690a013f2$export$e1e3f9fa6f04d6d = 'quickFilters';
const $15ed10c690a013f2$export$c070acdc9b0f1be5 = 'selectedIssue';
const $15ed10c690a013f2$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $15ed10c690a013f2$export$dba794af6c0f2afc = 'assignee';
const $15ed10c690a013f2$export$56ecb5d2dfb80edc = 'priority';
const $15ed10c690a013f2$export$22ef551f315f2786 = 'category';
const $15ed10c690a013f2$export$6d69efb296b78a = 'status';
const $15ed10c690a013f2$export$e23e1d1ea45171c2 = 'startdate';
const $15ed10c690a013f2$export$e35c6e217c75dc4b = 'rank';
const $15ed10c690a013f2$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $15ed10c690a013f2$export$a311e1b78816c048 = 'commentsummary';
const $15ed10c690a013f2$export$f5583ff4ab4d63e5 = 'cardCovers';
const $15ed10c690a013f2$export$5716e8bcb003888d = 25;
const $15ed10c690a013f2$export$1f9fb9f15184100f = 'storypoints';
const $15ed10c690a013f2$export$c72ea455b368cdd9 = 'storypointestimate';
const $15ed10c690a013f2$export$786b42b4618e6ee4 = 'sprint';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("l0jym", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $9c968063af1d87e8$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $9c968063af1d87e8$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("eUu4u", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $b41642a7c0ef06fe$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $h585o = parcelRequire("h585o");

var $h5BJf = parcelRequire("h5BJf");

var $hSCS8 = parcelRequire("hSCS8");

var $lRBAz = parcelRequire("lRBAz");
const $b41642a7c0ef06fe$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $b41642a7c0ef06fe$var$sidebarStyles,
            theme === 'business' && $b41642a7c0ef06fe$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children);
const $b41642a7c0ef06fe$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $h585o.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $h5BJf.useResizer)();
    // reset sidebar content on view unmount
    (0, $eUqFw.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41642a7c0ef06fe$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarContent), null, content)));
};
const $b41642a7c0ef06fe$var$sidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $b41642a7c0ef06fe$var$businessSidebarStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("h585o", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $357741b682c79613$export$34adbeffbeceba68);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iclz4 = parcelRequire("iclz4");

var $hSCS8 = parcelRequire("hSCS8");
const $357741b682c79613$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $357741b682c79613$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $hSCS8.useSidebar)();
    const sidebarQueryParams = (0, $hSCS8.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $hzcvF.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $eUqFw.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        resetSidebarQueryParams();
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $eUqFw.useEffect)(()=>{
        sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $eUqFw.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && (0, $eI5EY.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($357741b682c79613$var$isEscapeEvent(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("h5BJf", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $2c653e9e7bda86ce$export$faede3f1542958fc);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hSCS8 = parcelRequire("hSCS8");
const $2c653e9e7bda86ce$var$THROTTLE_TIME = 16;
const $2c653e9e7bda86ce$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $hSCS8.useSidebar)();
    const startRef = (0, $eUqFw.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $eUqFw.useRef)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $2c653e9e7bda86ce$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("lRBAz", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $8c2051301c5af547$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarContent", () => $8c2051301c5af547$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $8c2051301c5af547$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8c2051301c5af547$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ESAZ", function(module, exports) {

$parcel$export(module.exports, "ThemedContainer", () => $c8a88c0524c1629a$export$2a4209ec8a7db359);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c8a88c0524c1629a$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syaz1c2q",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hpCMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1d3764f68b3d831$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hJYsP = parcelRequire("hJYsP");

var $gCyQH = parcelRequire("gCyQH");

var $4G5xU = parcelRequire("4G5xU");


var $6HWvN = parcelRequire("6HWvN");

var $ZvXTS = parcelRequire("ZvXTS");

var $eRpjy = parcelRequire("eRpjy");

var $kar7l = parcelRequire("kar7l");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $h5SwL = parcelRequire("h5SwL");

var $izUon = parcelRequire("izUon");

var $bWbSz = parcelRequire("bWbSz");

var $cGyoW = parcelRequire("cGyoW");

var $f5AEi = parcelRequire("f5AEi");

var $jSzWg = parcelRequire("jSzWg");

var $dtGkG = parcelRequire("dtGkG");

var $4Xy73 = parcelRequire("4Xy73");

var $4kds4 = parcelRequire("4kds4");

var $5STtf = parcelRequire("5STtf");

var $3lpii = parcelRequire("3lpii");

var $1aMZc = parcelRequire("1aMZc");

var $9imnc = parcelRequire("9imnc");

var $eCQJQ = parcelRequire("eCQJQ");

var $iVxJ1 = parcelRequire("iVxJ1");
const $e1d3764f68b3d831$var$cardFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.ErrorCard), null);
const $e1d3764f68b3d831$var$SummaryView = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { DetailsComponent: DetailsComponent, featureView: featureView, hasActivityFeed: hasActivityFeed, hasFeedbackFooter: hasFeedbackFooter, hasHeader: hasHeader, hasRelatedProjects: hasRelatedProjects } = (0, $bWbSz.useSummaryFeatures)();
    const { data: data, loading: loading, error: error } = (0, $cGyoW.useSummaryContext)();
    const isReady = data != null && !loading && !error;
    (0, $eUqFw.useEffect)(()=>{
        if (loading) (0, $ZvXTS.markViewMetric)('summary', (0, $78bb8734d7176028$export$23e322eb7c526958));
        else (0, $ZvXTS.markViewMetric)('summary', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
    }, [
        loading
    ]);
    const pageHeading = formatMessage((0, $4kds4.default).summaryHeading);
    if (error != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCyQH.ErrorPage), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $h5SwL.MAIN_EXPERIENCE),
        error: error
    }));
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e1d3764f68b3d831$var$HeaderWrapperStyles
    }, hasHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Xy73.default), {
        isLoading: loading
    }), (0, $eI5EY.fg)('fun-1194_decouple_overview_summary_page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1aMZc.default), {
        isSkeleton: loading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DetailsComponent, {
        isSkeleton: loading
    }));
    let position = 0; // eslint-disable-next-line no-return-assign
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: "summary",
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1d3764f68b3d831$var$ResponsiveContainer, null, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5STtf.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1d3764f68b3d831$var$CardGrid, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lpii.default), {
        position: position += 1
    }), ((0, $eI5EY.fg)('fun-1194_decouple_overview_summary_page') || hasActivityFeed) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $h5SwL.ACTIVITY_FEED_EXPERIENCE),
        shouldStartExperience: true,
        fallback: $e1d3764f68b3d831$var$cardFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5AEi.default), {
        position: position += 1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSzWg.default), {
        position: position += 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCQJQ.default), {
        position: position += 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVxJ1.default), {
        position: position += 1
    }), ((0, $eI5EY.fg)('fun-1194_decouple_overview_summary_page') || hasRelatedProjects) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $h5SwL.RELATED_PROJECTS_EXPERIENCE),
        shouldStartExperience: true,
        fallback: $e1d3764f68b3d831$var$cardFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9imnc.default), {
        position: position += 1
    }))), hasFeedbackFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("footer", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dtGkG.default), {
        isLoading: loading
    }))), isReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.PageLoadMetrics), {
        view: featureView
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $h5SwL.MAIN_EXPERIENCE)
    })), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRpjy.JWMSpaStatePageReady), null));
};
var $e1d3764f68b3d831$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e1d3764f68b3d831$var$SummaryView);
const $e1d3764f68b3d831$var$HeaderWrapperStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $kar7l.Tokens).ELEVATION_SURFACE_CONTRAST,
    borderRadius: 'border.radius.200',
    paddingLeft: 'space.400',
    paddingRight: 'space.400',
    paddingTop: 'space.300',
    paddingBottom: 'space.100',
    marginTop: 'space.200',
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1d3764f68b3d831$var$ResponsiveContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12ftgmt _1bsb1osq _1wpz1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1d3764f68b3d831$var$CardGrid = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1bs0 _otyridpf _18u01bs0 _1e0c1txw _1n261g80 _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hJYsP", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $08e74678968dfe67$export$416064ba09d98e69);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $fDLFb = parcelRequire("fDLFb");
const $08e74678968dfe67$export$416064ba09d98e69 = /*#__PURE__*/ (0, $eUqFw.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});


const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("6HWvN", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $ebb8060987b09135$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $ebb8060987b09135$export$66b33c055cbb625e);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");


var $ZvXTS = parcelRequire("ZvXTS");
const $ebb8060987b09135$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$b78f0bbf209e5f4));
    return null;
};
const $ebb8060987b09135$export$66b33c055cbb625e = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$88ea1e280513690f));
    const metric = (0, $ZvXTS.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("eRpjy", function(module, exports) {

$parcel$export(module.exports, "JWMSpaStatePageReady", () => $beaa0dc8e8f2a3dd$export$d54524c142a057f);

var $eUqFw = parcelRequire("eUqFw");

var $iJHZm = parcelRequire("iJHZm");
const $beaa0dc8e8f2a3dd$export$d54524c142a057f = ()=>{
    const [isReady, setIsReady] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Waiting for 2 animation frames is equivalent to waiting for react to paint the DOM.
		 */ let id = window.requestAnimationFrame(()=>{
            id = window.requestAnimationFrame(()=>{
                setIsReady(true);
            });
        });
        return ()=>{
            window.cancelAnimationFrame(id);
        };
    }, []);
    if (!isReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null);
};

});

parcelRegister("h5SwL", function(module, exports) {

$parcel$export(module.exports, "MAIN_EXPERIENCE", () => $0b8e4f28a57f8c0d$export$b3d8a68bfc68a411);
$parcel$export(module.exports, "ACTIVITY_FEED_EXPERIENCE", () => $0b8e4f28a57f8c0d$export$f313e3e286755e5f);
$parcel$export(module.exports, "OVERVIEW_DETAILS_EXPERIENCE", () => $0b8e4f28a57f8c0d$export$9380dfa5ed375ae4);
$parcel$export(module.exports, "PROJECT_DETAILS_EXPERIENCE", () => $0b8e4f28a57f8c0d$export$75f46ca6094c53d1);
$parcel$export(module.exports, "RELATED_PROJECTS_EXPERIENCE", () => $0b8e4f28a57f8c0d$export$35e64816b2aad93b);

var $c9TLT = parcelRequire("c9TLT");
const $0b8e4f28a57f8c0d$var$PACKAGE_NAME = 'jiraBusinessSummary';
const $0b8e4f28a57f8c0d$export$d5647771ea34eda2 = 420;
const $0b8e4f28a57f8c0d$export$eddd9cbfc15b85f8 = (0, $c9TLT.gridSize);
const $0b8e4f28a57f8c0d$export$eb2dc4deee1bebc8 = 8;
const $0b8e4f28a57f8c0d$export$b3d8a68bfc68a411 = {
    experience: 'summary',
    experienceId: 'main',
    packageName: $0b8e4f28a57f8c0d$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $0b8e4f28a57f8c0d$export$f313e3e286755e5f = {
    experience: 'activity-feed',
    packageName: $0b8e4f28a57f8c0d$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $0b8e4f28a57f8c0d$export$9380dfa5ed375ae4 = {
    experience: 'overview-details',
    packageName: $0b8e4f28a57f8c0d$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $0b8e4f28a57f8c0d$export$75f46ca6094c53d1 = {
    experience: 'project-details',
    packageName: $0b8e4f28a57f8c0d$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $0b8e4f28a57f8c0d$export$35e64816b2aad93b = {
    experience: 'related-projects',
    packageName: $0b8e4f28a57f8c0d$var$PACKAGE_NAME,
    teamName: 'wanjel'
};

});

parcelRegister("izUon", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5601777ce4817a9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ErrorCard", () => $a5601777ce4817a9$export$a2c93507c97cd090);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bxZG8 = parcelRequire("bxZG8");

var $4JbjA = parcelRequire("4JbjA");
const $a5601777ce4817a9$var$Card = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, testId: testId, title: title, isLoading: isLoading = false, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave }, ref)=>{
    let header;
    if (isLoading) header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5601777ce4817a9$var$TitleSkeleton, null);
    else header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5601777ce4817a9$var$Title, null, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5601777ce4817a9$var$Container, {
        ref: ref,
        "data-testid": testId,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave
    }, header, children);
});
var $a5601777ce4817a9$export$2e2bcd8739ae039 = $a5601777ce4817a9$var$Card;
const $a5601777ce4817a9$export$a2c93507c97cd090 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const refresh = (0, $eUqFw.useCallback)(()=>window.location.reload(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5601777ce4817a9$var$ErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bxZG8.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5601777ce4817a9$var$ErrorHeader, {
        level: "h500",
        as: "h4"
    }, formatMessage((0, $4JbjA.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $4JbjA.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: refresh
    }, formatMessage((0, $4JbjA.default).refresh)));
});
const $a5601777ce4817a9$var$TITLE_MARGIN_BOTTOM = "var(--ds-space-200, 16px)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5601777ce4817a9$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _19pkftgi _2hwxftgi _otyrftgi _18u0ftgi _11q7hp5a _2rkoftgi _1yt4vkk0 _4t3i1kdj _16jlkb7n _1o9zkb7n _i0dlf1ug _1ul91pna _syaz1fxt _16qs1os1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5601777ce4817a9$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _16jlidpf _1o9zidpf _i0dl1wug _otyrpxbi _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5601777ce4817a9$var$TitleSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1pnw _2rko1y44 _otyrpxbi _16jlidpf _1o9zidpf _i0dl1wug _1bsb1lit _4t3igktf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5601777ce4817a9$var$ErrorContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $a5601777ce4817a9$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bah1h6o _4cvr1h6o _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5601777ce4817a9$var$ErrorHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bxZG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6485139437923c0c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $6485139437923c0c$var$ErrorIllustration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "160",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6485139437923c0c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6485139437923c0c$var$ErrorIllustration);

});

parcelRegister("4JbjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ad73a78df4bf15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b1ad73a78df4bf15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "business-summary.common.card.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "business-summary.common.card.description",
        "defaultMessage": "Looks like we're having trouble connecting to this section. Wait a few moments, then try again."
    },
    refresh: {
        "id": "business-summary.common.card.refresh",
        "defaultMessage": "Refresh"
    },
    new: {
        "id": "business-summary.common.card.new",
        "defaultMessage": "New"
    }
});

});


parcelRegister("bWbSz", function(module, exports) {

$parcel$export(module.exports, "useSummaryFeatures", () => $22ff932c6f4ef600$export$ab34b4f862c26cc7);
$parcel$export(module.exports, "default", () => $22ff932c6f4ef600$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $22ff932c6f4ef600$var$defaultFeaturesContext = {
    featureView: 'summary',
    /**
	 * @deprecated delete hasActivityFeed when cleaning up fun-1194_decouple_overview_summary_page
	 */ hasActivityFeed: true,
    hasCreateItem: true,
    hasFeedbackFooter: true,
    hasHeader: true,
    hasInviteTeammateButton: true,
    hasManageTypesButton: true,
    /**
	 * @deprecated delete hasPrefetching when cleaning up fun-1194_decouple_overview_summary_page
	 */ hasPrefetching: true,
    /**
	 * @deprecated delete hasRelatedProjects when cleaning up fun-1194_decouple_overview_summary_page
	 */ hasRelatedProjects: true,
    hasShareButton: true,
    linksTarget: '_self'
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $22ff932c6f4ef600$var$SummaryFeaturesContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $22ff932c6f4ef600$export$ab34b4f862c26cc7 = ()=>(0, $eUqFw.useContext)($22ff932c6f4ef600$var$SummaryFeaturesContext);
const $22ff932c6f4ef600$var$SummaryFeaturesProvider = ({ children: children, ...props })=>{
    const value = (0, $eUqFw.useMemo)(()=>({
            ...$22ff932c6f4ef600$var$defaultFeaturesContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22ff932c6f4ef600$var$SummaryFeaturesContext.Provider, {
        value: value
    }, children);
};
var $22ff932c6f4ef600$export$2e2bcd8739ae039 = $22ff932c6f4ef600$var$SummaryFeaturesProvider;

});

parcelRegister("cGyoW", function(module, exports) {

$parcel$export(module.exports, "PrefetchedSummaryProvider", () => $0a03c9bb8208c9ed$export$2fd85b6f3e7714fa);
$parcel$export(module.exports, "SummaryProvider", () => $0a03c9bb8208c9ed$export$85bc3d6c20ffee30);
$parcel$export(module.exports, "useSummaryContext", () => $0a03c9bb8208c9ed$export$fda0c570f177c6c0);
$parcel$export(module.exports, "useOverviewItems", () => $0a03c9bb8208c9ed$export$2c8a54273e8ece13);
$parcel$export(module.exports, "useIssuesByStatus", () => $0a03c9bb8208c9ed$export$e765c1bd3a21fadb);
$parcel$export(module.exports, "useIssuesByPriority", () => $0a03c9bb8208c9ed$export$ec9e74eb4d4222aa);
$parcel$export(module.exports, "useIssuesByAssignee", () => $0a03c9bb8208c9ed$export$90328bbff20c5812);
$parcel$export(module.exports, "useIssuesByType", () => $0a03c9bb8208c9ed$export$f3f76b41ba5a385);

var $eUqFw = parcelRequire("eUqFw");

var $dIJG1 = parcelRequire("dIJG1");

var $gfiub = parcelRequire("gfiub");
const $0a03c9bb8208c9ed$var$SummaryContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    data: undefined,
    loading: true,
    error: undefined
});
const $0a03c9bb8208c9ed$export$2fd85b6f3e7714fa = ({ children: children })=>{
    const { data: data, loading: loading, error: error } = (0, $dIJG1.useSummaryData)();
    const context = (0, $eUqFw.useMemo)(()=>({
            data: data,
            // we want to show loading state for server side rendering
            loading: false ? true : loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a03c9bb8208c9ed$var$SummaryContext.Provider, {
        value: context
    }, children);
};
const $0a03c9bb8208c9ed$export$85bc3d6c20ffee30 = ({ children: children })=>{
    const { data: data, loading: loading, error: error } = (0, $gfiub.useSummaryData)();
    const context = (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a03c9bb8208c9ed$var$SummaryContext.Provider, {
        value: context
    }, children);
};
const $0a03c9bb8208c9ed$export$fda0c570f177c6c0 = ()=>(0, $eUqFw.useContext)($0a03c9bb8208c9ed$var$SummaryContext);
const $0a03c9bb8208c9ed$export$2c8a54273e8ece13 = ()=>{
    const { data: data, loading: loading, error: error } = $0a03c9bb8208c9ed$export$fda0c570f177c6c0();
    return {
        data: data?.overviewItems,
        loading: loading,
        error: error
    };
};
const $0a03c9bb8208c9ed$export$e765c1bd3a21fadb = ()=>{
    const { data: data, loading: loading, error: error } = $0a03c9bb8208c9ed$export$fda0c570f177c6c0();
    return {
        data: data?.issuesByStatus,
        loading: loading,
        error: error
    };
};
const $0a03c9bb8208c9ed$export$ec9e74eb4d4222aa = ()=>{
    const { data: data, loading: loading, error: error } = $0a03c9bb8208c9ed$export$fda0c570f177c6c0();
    return {
        data: data?.issuesByPriority,
        loading: loading,
        error: error
    };
};
const $0a03c9bb8208c9ed$export$90328bbff20c5812 = ()=>{
    const { data: data, loading: loading, error: error } = $0a03c9bb8208c9ed$export$fda0c570f177c6c0();
    return {
        data: data?.issuesByAssignee,
        loading: loading,
        error: error
    };
};
const $0a03c9bb8208c9ed$export$f3f76b41ba5a385 = ()=>{
    const { data: data, loading: loading, error: error } = $0a03c9bb8208c9ed$export$fda0c570f177c6c0();
    return {
        data: data?.issuesByType,
        loading: loading,
        error: error
    };
};

});
parcelRegister("gfiub", function(module, exports) {

$parcel$export(module.exports, "useSummaryData", () => $d680957fe50055bc$export$c82acf736eaa253c);

var $eUqFw = parcelRequire("eUqFw");

var $eZbpk = parcelRequire("eZbpk");

var $dEAew = parcelRequire("dEAew");

var $gd0Sp = parcelRequire("gd0Sp");
const $d680957fe50055bc$var$initialState = {
    data: undefined,
    loading: true,
    error: undefined
};
const $d680957fe50055bc$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $d680957fe50055bc$var$initialState;
        case 'success':
            return {
                ...state,
                data: action.value,
                loading: false
            };
        case 'error':
            return {
                ...state,
                loading: false,
                error: action.value
            };
        default:
            return state;
    }
};
const $d680957fe50055bc$export$c82acf736eaa253c = ()=>{
    const [{ data: data, loading: loading, error: error }, dispatch] = (0, $eUqFw.useReducer)($d680957fe50055bc$var$reducer, $d680957fe50055bc$var$initialState);
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const executeQuery = (0, $eUqFw.useCallback)(async ()=>{
        dispatch({
            type: 'init'
        });
        try {
            const response = await (0, $dEAew.fetchSummaryPageData)({
                cloudId: cloudId,
                jqlContext: jqlContext
            });
            dispatch({
                type: 'success',
                value: response
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (serviceError) {
            dispatch({
                type: 'error',
                value: serviceError
            });
        }
    }, [
        cloudId,
        jqlContext
    ]);
    (0, $eUqFw.useEffect)(()=>{
        executeQuery();
    }, [
        executeQuery
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};

});


parcelRegister("f5AEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf84f687f67ccb7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6x1NF = parcelRequire("6x1NF");

var $jh9tF = parcelRequire("jh9tF");

var $iHCx5 = parcelRequire("iHCx5");

var $4Bees = parcelRequire("4Bees");

var $4G5xU = parcelRequire("4G5xU");

var $fJcKX = parcelRequire("fJcKX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jK1pm = parcelRequire("jK1pm");

var $apShl = parcelRequire("apShl");

var $h5SwL = parcelRequire("h5SwL");

var $izUon = parcelRequire("izUon");

var $jTuwe = parcelRequire("jTuwe");

var $6cwrM = parcelRequire("6cwrM");

var $8pktI = parcelRequire("8pktI");

var $bWbSz = parcelRequire("bWbSz");

var $eNKmP = parcelRequire("eNKmP");

var $l06MN = parcelRequire("l06MN");

var $hnFsb = parcelRequire("hnFsb");

var $kGo2G = parcelRequire("kGo2G");
const $9bf84f687f67ccb7$var$ActivityFeed = ({ position: position })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5JgJ2.default)();
    const { hasCreateItem: hasCreateItem, linksTarget: linksTarget, urlBuilder: urlBuilder } = (0, $bWbSz.useSummaryFeatures)();
    const { data: data, loading: loading, loadingNext: loadingNext, hasNextPage: hasNextPage, fetchNext: fetchNext, error: error } = (0, $8pktI.default)();
    const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, $6cwrM.useSectionAnalytics)(position, 'activityFeed');
    const { onScroll: onScroll } = (0, $fJcKX.useScrollToEnd)({
        onScrollToEnd: fetchNext,
        isDisabled: loadingNext || !hasNextPage,
        options: {
            onEndReachedThreshold: 150
        }
    });
    const itemsByDate = (0, $eUqFw.useMemo)(()=>data != null ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.reduce((groups, item)=>{
            const publishedDate = new Date(item.published);
            const key = (0, $6x1NF.default)(publishedDate, 'UTC', 'yyyy-MM-dd');
            const lastGroup = groups[groups.length - 1];
            if (lastGroup?.key === key) lastGroup.items.push(item);
            else {
                let label;
                if ((0, $jh9tF.default)(publishedDate)) label = formatMessage((0, $hnFsb.default).today);
                else if ((0, $iHCx5.default)(publishedDate)) label = formatMessage((0, $hnFsb.default).yesterday);
                else label = formatDate(key, {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                groups.push({
                    key: key,
                    label: label,
                    items: [
                        item
                    ]
                });
            }
            return groups;
        }, []) : null, [
        data,
        formatDate,
        formatMessage
    ]);
    if (error != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.ErrorCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $h5SwL.ACTIVITY_FEED_EXPERIENCE),
        error: error
    }));
    let content = null;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "activity-feed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$CenteredSkeleton, {
        testId: "business-summary.ui.summary-view.activity-feed.skeleton"
    }));
    else if (itemsByDate != null && itemsByDate.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$Description, null, formatMessage((0, $hnFsb.default).descriptionWhenEmpty), hasCreateItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTuwe.default), {
        href: `${urlBuilder('activityFeed')}?inlineCreate=true`,
        onClick: ()=>fireSectionAnalytics('view', {
                inlineCreate: true
            }),
        target: linksTarget
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$EmptyStateIllustration, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $h5SwL.ACTIVITY_FEED_EXPERIENCE)
    }));
    else if (itemsByDate != null) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$Description, null, formatMessage((0, $hnFsb.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$List, {
        onScroll: onScroll
    }, itemsByDate.map(({ key: key, label: label, items: items })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$GroupTitle, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$GroupContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$Items, null, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNKmP.default), {
                key: item.id,
                item: item,
                onClick: (target)=>fireSectionAnalytics(target)
            })))))), loadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bf84f687f67ccb7$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $h5SwL.ACTIVITY_FEED_EXPERIENCE)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-activity-feed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.default), {
        title: formatMessage((0, $hnFsb.default).title),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.activity-feed",
        onPointerEnter: startHoverTimer,
        onPointerLeave: stopHoverTimer
    }, content));
};
var $9bf84f687f67ccb7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($9bf84f687f67ccb7$var$ActivityFeed);
const $9bf84f687f67ccb7$var$CenteredSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kGo2G.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9bf84f687f67ccb7$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9bf84f687f67ccb7$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "dl", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _18s813hl _1yt41e2i _11q71mtt",
            __cmplp.className
        ])
    });
}); // necessary to override base styles
const $9bf84f687f67ccb7$var$GroupTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "dt", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _11c81vlj _k48p1wq8 _1p1dangw _18s8swc3 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1hk51b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9bf84f687f67ccb7$var$GroupContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "dd", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9bf84f687f67ccb7$var$Items = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9bf84f687f67ccb7$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _1bah1h6o _18s8utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9bf84f687f67ccb7$var$EmptyStateIllustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $l06MN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1lit _19pk1wug _2hwx1wug _otyr1wug _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fJcKX", function(module, exports) {

$parcel$export(module.exports, "useScrollToEnd", () => $28f4d506edcf52c1$export$296d94f94d195283);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");
const $28f4d506edcf52c1$var$DEFAULT_ON_END_REACHED_THRESHOLD = 300;
const $28f4d506edcf52c1$var$DEFAULT_THROTTLE_TIME = 16;
const $28f4d506edcf52c1$export$296d94f94d195283 = ({ onScrollToEnd: onScrollToEnd, isDisabled: isDisabled, options: options })=>{
    const onEndReachedThreshold = options?.onEndReachedThreshold ?? $28f4d506edcf52c1$var$DEFAULT_ON_END_REACHED_THRESHOLD;
    const throttleTime = options?.throttleTime ?? $28f4d506edcf52c1$var$DEFAULT_THROTTLE_TIME;
    const calculateEndReached = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(({ clientHeight: clientHeight, scrollTop: scrollTop, scrollHeight: scrollHeight })=>{
            const distanceFromEnd = scrollHeight - scrollTop - clientHeight;
            if (distanceFromEnd < onEndReachedThreshold && isDisabled !== true) onScrollToEnd();
        }, throttleTime), [
        onScrollToEnd,
        throttleTime,
        isDisabled,
        onEndReachedThreshold
    ]);
    const onScroll = (0, $eUqFw.useCallback)((event)=>{
        const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = event.currentTarget;
        calculateEndReached({
            clientHeight: clientHeight,
            scrollHeight: scrollHeight,
            scrollTop: scrollTop
        });
    }, [
        calculateEndReached
    ]);
    return {
        onScroll: onScroll
    };
};

});

parcelRegister("jTuwe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f62837a8fc2d4e92$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a2EFr = parcelRequire("a2EFr");

var $4tpou = parcelRequire("4tpou");
const $f62837a8fc2d4e92$var$CreateItemLink = ({ href: href, onClick: onClick, target: target })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2EFr.default), {
        target: target,
        href: href,
        onClick: onClick
    }, formatMessage((0, $4tpou.default).createAnItem));
};
var $f62837a8fc2d4e92$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($f62837a8fc2d4e92$var$CreateItemLink);

});
parcelRegister("a2EFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e46cb173b6fa6bf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lB25E = parcelRequire("lB25E");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0e46cb173b6fa6bf$var$AccessibleLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1",
            __cmplp.className
        ])
    });
});
var $0e46cb173b6fa6bf$export$2e2bcd8739ae039 = $0e46cb173b6fa6bf$var$AccessibleLink;

});

parcelRegister("4tpou", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f5bbb7cc9e6d9d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $50f5bbb7cc9e6d9d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createAnItem: {
        "id": "business-summary.common.create-item-link.create-an-item",
        "defaultMessage": "Create an item"
    }
});

});


parcelRegister("6cwrM", function(module, exports) {

$parcel$export(module.exports, "useSectionAnalytics", () => $7017640fb215eb6c$export$97a66dbbb82ca183);
$parcel$export(module.exports, "projectUrlBuilderFactory", () => $7017640fb215eb6c$export$f4af75f1e66c23b3);
$parcel$export(module.exports, "overviewUrlBuilderFactory", () => $7017640fb215eb6c$export$e0f4a3530de30b12);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $7017640fb215eb6c$export$97a66dbbb82ca183 = (position, sectionId)=>{
    const hasFiredAnalyticsEventRef = (0, $eUqFw.useRef)(false);
    const hoverStartTimeRef = (0, $eUqFw.useRef)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const startHoverTimer = (0, $eUqFw.useCallback)(()=>{
        if (!hasFiredAnalyticsEventRef.current) hoverStartTimeRef.current = new Date().getTime();
    }, [
        hasFiredAnalyticsEventRef
    ]);
    const stopHoverTimer = (0, $eUqFw.useCallback)(()=>{
        if (hasFiredAnalyticsEventRef.current) return;
        const secondsHovered = Math.floor((new Date().getTime() - hoverStartTimeRef.current) / 1000);
        if (secondsHovered >= 3) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'section hovered', 'summarySection', {
                position: position,
                sectionId: sectionId,
                secondsHovered: secondsHovered
            });
            hasFiredAnalyticsEventRef.current = true;
        }
    }, [
        createAnalyticsEvent,
        position,
        sectionId
    ]);
    const fireSectionAnalytics = (0, $eUqFw.useCallback)((target, attributes)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'item clicked', 'summarySection', {
            ...attributes,
            position: position,
            sectionId: sectionId,
            target: target
        }), [
        position,
        sectionId,
        createAnalyticsEvent
    ]);
    return {
        startHoverTimer: startHoverTimer,
        stopHoverTimer: stopHoverTimer,
        fireSectionAnalytics: fireSectionAnalytics
    };
};
const $7017640fb215eb6c$export$f4af75f1e66c23b3 = (projectKey)=>()=>`/jira/core/projects/${projectKey}/list`;
const $7017640fb215eb6c$export$e0f4a3530de30b12 = (overviewId)=>()=>`/jira/core/overviews/${overviewId}/timeline`;

});

parcelRegister("8pktI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b79082b907b7bdb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $kCIeX = parcelRequire("kCIeX");

var $1Y3Jh = parcelRequire("1Y3Jh");

var $XJw0F = parcelRequire("XJw0F");

var $cGyoW = parcelRequire("cGyoW");
const $6b79082b907b7bdb$var$useActivityFeed = ()=>{
    const { loading: loadingSummaryData } = (0, $cGyoW.useSummaryContext)();
    const { data: initialData, loading: loading } = (0, $XJw0F.useActivityFeed)();
    const project = (0, $kQAZu.useProject)();
    const fetchActivityFeed = (0, $eUqFw.useCallback)((after)=>(0, $1Y3Jh.fetchActivityFeed)(after, project.key), [
        project
    ]);
    const { data: data, loadingNext: loadingNext, error: error, hasNextPage: hasNextPage, reset: reset, fetchNext: fetchNext } = (0, $kCIeX.usePagination)(fetchActivityFeed, {
        fetchMode: 'replace'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (initialData != null) reset(initialData);
    }, [
        initialData,
        reset
    ]);
    return {
        data: data,
        loading: loadingSummaryData || loading,
        loadingNext: loadingNext,
        error: error,
        hasNextPage: hasNextPage,
        fetchNext: fetchNext
    };
};
var $6b79082b907b7bdb$export$2e2bcd8739ae039 = $6b79082b907b7bdb$var$useActivityFeed;

});
parcelRegister("kCIeX", function(module, exports) {

$parcel$export(module.exports, "usePagination", () => $1ff24d2ff465eea8$export$f80c710216eae131);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");
function $1ff24d2ff465eea8$var$init(options) {
    const fetchMode = options.fetchMode || 'append';
    return {
        data: null,
        pageInfo: null,
        ...options.initialData,
        loading: false,
        loadingNext: false,
        error: null,
        fetchMode: fetchMode
    };
}
function $1ff24d2ff465eea8$var$resetState(state, initialData) {
    return {
        ...state,
        data: null,
        pageInfo: null,
        ...initialData,
        loading: false,
        loadingNext: false,
        error: null
    };
}
function $1ff24d2ff465eea8$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return $1ff24d2ff465eea8$var$resetState(state, action.value);
        case 'fetch':
            return {
                ...$1ff24d2ff465eea8$var$resetState(state),
                loading: true
            };
        case 'fetch-next':
            if (state.pageInfo == null) return {
                ...state,
                loading: true
            };
            return {
                ...state,
                loadingNext: true
            };
        case 'success':
            return {
                ...state,
                data: state.data == null || state.fetchMode === 'replace' ? action.value.data : [
                    ...state.data,
                    ...action.value.data
                ],
                pageInfo: action.value.pageInfo,
                loading: false,
                loadingNext: false,
                error: null
            };
        case 'failure':
            return {
                ...state,
                loading: false,
                loadingNext: false,
                error: action.value
            };
        default:
            break;
    }
    return state;
}
function $1ff24d2ff465eea8$export$f80c710216eae131(fetchCallback, options = Object.freeze({})) {
    const [state, dispatch] = (0, $eUqFw.useReducer)($1ff24d2ff465eea8$var$reducer, options, $1ff24d2ff465eea8$var$init);
    const stateRef = (0, $eUqFw.useRef)(state);
    stateRef.current = state;
    const doFetch = (0, $eUqFw.useCallback)((action, args)=>{
        dispatch({
            type: action
        });
        const cursor = action === 'fetch-next' ? stateRef.current.pageInfo?.endCursor ?? null : null;
        return fetchCallback(cursor, args).then((response)=>{
            dispatch({
                type: 'success',
                value: response
            });
            return response;
        }).catch((error)=>{
            // if the request was aborted, keep showing the UI as loading
            if (error === (0, $NFHn0.ABORTED)) return null;
            dispatch({
                type: 'failure',
                value: error
            });
            throw error;
        });
    }, [
        fetchCallback
    ]);
    const fetch = (0, $eUqFw.useCallback)((args)=>doFetch('fetch', args), [
        doFetch
    ]);
    const fetchNext = (0, $eUqFw.useCallback)((args)=>{
        if (stateRef.current.loading || stateRef.current.error != null || stateRef.current.pageInfo?.hasNextPage === false) return Promise.resolve(null);
        return doFetch('fetch-next', args);
    }, [
        doFetch
    ]);
    const reset = (0, $eUqFw.useCallback)((resetData)=>dispatch({
            type: 'reset',
            value: resetData
        }), []);
    const { data: data, loading: loading, loadingNext: loadingNext, error: error, pageInfo: pageInfo } = state;
    const hasNextPage = pageInfo?.hasNextPage || false;
    return {
        data: data,
        loading: loading,
        loadingNext: loadingNext,
        error: error,
        hasNextPage: hasNextPage,
        fetch: fetch,
        fetchNext: fetchNext,
        reset: reset
    };
}

});
parcelRegister("NFHn0", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $f9f77c4f962e82bc$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $f9f77c4f962e82bc$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");
const $f9f77c4f962e82bc$export$23e29024ea698a35 = Symbol('ABORTED');
const $f9f77c4f962e82bc$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $eUqFw.useRef)(null);
    return (0, $eUqFw.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $f9f77c4f962e82bc$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});



parcelRegister("eNKmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $65d99f77defe270e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");

var $bWbSz = parcelRequire("bWbSz");

var $8HdWz = parcelRequire("8HdWz");
const $65d99f77defe270e$var$ActivityItem = ({ item: item, onClick: onClick })=>{
    const locale = (0, $4xHig.useLocale)();
    const { linksTarget: linksTarget } = (0, $bWbSz.useSummaryFeatures)();
    const title = (0, $eUqFw.useMemo)(()=>(0, $8HdWz.transformTitle)(item, onClick, linksTarget), [
        item,
        onClick,
        linksTarget
    ]);
    const content = (0, $eUqFw.useMemo)(()=>(0, $8HdWz.transformContent)(item), [
        item
    ]);
    const relativePublishedTime = (0, $eUqFw.useMemo)(()=>(0, $8K9kM.formatDistanceWithLocale)(new Date(item.published), new Date(), locale, true), [
        item,
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65d99f77defe270e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65d99f77defe270e$var$FirstRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: item.author.avatarUrl,
        name: item.author.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65d99f77defe270e$var$Title, null, title, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($65d99f77defe270e$var$Published, null, relativePublishedTime))), content);
};
var $65d99f77defe270e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($65d99f77defe270e$var$ActivityItem);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $65d99f77defe270e$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41bpf",
            __cmplp.className
        ])
    });
});
const $65d99f77defe270e$var$FirstRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $65d99f77defe270e$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $65d99f77defe270e$var$Published = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8HdWz", function(module, exports) {

$parcel$export(module.exports, "transformTitle", () => $4049becc2e14db97$export$b7844e8a25b12dea);
$parcel$export(module.exports, "transformContent", () => $4049becc2e14db97$export$b7cb80c25ebba28e);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable no-bitwise */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a2EFr = parcelRequire("a2EFr");
const $4049becc2e14db97$export$b7844e8a25b12dea = (item, onClick, linkTarget)=>{
    const parser = new DOMParser();
    const { body: body } = parser.parseFromString(item.title, 'text/html');
    if (body == null) return null;
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node = walker.firstChild();
    const result = [];
    let key = 0;
    do {
        if (node == null) continue;
        if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'A') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const href = node.getAttribute('href') || '';
            if (href.startsWith('/browse/')) result.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2EFr.default), {
                key: key++,
                target: linkTarget,
                href: href,
                onClick: ()=>onClick('issue')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4049becc2e14db97$var$TypeIcon, {
                src: item.iconUrl,
                alt: ""
            }), node.textContent));
            else result.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2EFr.default), {
                key: key++,
                target: linkTarget,
                href: href,
                onClick: ()=>onClick('user')
            }, node.textContent));
        } else result.push(node.textContent);
    // eslint-disable-next-line no-cond-assign
    }while (node = walker.nextSibling());
    return result;
};
function* $4049becc2e14db97$var$infinite() {
    let index = 0;
    while(true)yield index++;
}
const $4049becc2e14db97$var$mapSiblingNodes = (walker, keyGen)=>{
    const mappedNodes = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let currentNode = walker.currentNode;
    while(currentNode){
        const { nodeType: nodeType } = currentNode;
        if (nodeType === Node.TEXT_NODE) mappedNodes.push(currentNode.textContent);
        else if (nodeType === Node.ELEMENT_NODE) {
            const nodeName = currentNode.nodeName.toLowerCase();
            if (nodeName in $4049becc2e14db97$var$NODE_MAPPER_MAP) {
                const result = $4049becc2e14db97$var$NODE_MAPPER_MAP[nodeName](walker, keyGen);
                if (result != null) mappedNodes.push(result);
            }
        }
        currentNode = walker.nextSibling();
    }
    if (mappedNodes.length === 0) return null;
    return mappedNodes;
};
const $4049becc2e14db97$var$mapChildrenNodes = (walker, keyGen)=>{
    const firstChild = walker.firstChild();
    if (firstChild) {
        const result = $4049becc2e14db97$var$mapSiblingNodes(walker, keyGen);
        walker.parentNode();
        return result;
    }
    return null;
};
const $4049becc2e14db97$var$identity = (walker, keyGen)=>{
    const children = $4049becc2e14db97$var$mapChildrenNodes(walker, keyGen);
    return /*#__PURE__*/ (0, $eUqFw.createElement)(walker.currentNode.nodeName.toLowerCase(), {
        key: keyGen.next().value
    }, children);
};
const $4049becc2e14db97$var$isNodeEmpty = (children)=>children.length === 1 && typeof children[0] === 'string' && children[0].trim().length === 0;
const $4049becc2e14db97$var$NODE_MAPPER_MAP = {
    a: (walker, keyGen)=>{
        const children = $4049becc2e14db97$var$mapChildrenNodes(walker, keyGen);
        if (children == null || children.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4049becc2e14db97$var$StyledAnchor, {
            key: keyGen.next().value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            href: walker.currentNode.getAttribute('href'),
            target: "_blank"
        }, children);
    },
    b: $4049becc2e14db97$var$identity,
    blockquote: (walker, keyGen)=>{
        const children = $4049becc2e14db97$var$mapChildrenNodes(walker, keyGen);
        if (children == null || children.length === 0 || $4049becc2e14db97$var$isNodeEmpty(children)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("blockquote", {
            key: keyGen.next().value
        }, children);
    },
    br: $4049becc2e14db97$var$identity,
    div: (walker, keyGen)=>{
        const children = $4049becc2e14db97$var$mapChildrenNodes(walker, keyGen);
        if (children == null || children.length === 0) return null;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (walker.currentNode.classList.contains('user-content')) {
            // if there is only a text node as child and it's blank space, skip it (stupid stream...)
            if ($4049becc2e14db97$var$isNodeEmpty(children)) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("blockquote", {
                key: keyGen.next().value
            }, children);
        }
        return children;
    },
    em: $4049becc2e14db97$var$identity,
    font: $4049becc2e14db97$var$mapChildrenNodes,
    h1: $4049becc2e14db97$var$identity,
    h2: $4049becc2e14db97$var$identity,
    h3: $4049becc2e14db97$var$identity,
    h4: $4049becc2e14db97$var$identity,
    h5: $4049becc2e14db97$var$identity,
    h6: $4049becc2e14db97$var$identity,
    hr: $4049becc2e14db97$var$identity,
    img: (walker, keyGen)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            key: keyGen.next().value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            src: walker.currentNode.getAttribute('src'),
            alt: ""
        }),
    li: $4049becc2e14db97$var$identity,
    ol: $4049becc2e14db97$var$identity,
    p: $4049becc2e14db97$var$identity,
    pre: $4049becc2e14db97$var$identity,
    span: $4049becc2e14db97$var$mapChildrenNodes,
    sub: $4049becc2e14db97$var$identity,
    sup: $4049becc2e14db97$var$identity,
    table: $4049becc2e14db97$var$identity,
    tbody: $4049becc2e14db97$var$identity,
    td: $4049becc2e14db97$var$identity,
    th: $4049becc2e14db97$var$identity,
    thead: $4049becc2e14db97$var$identity,
    tr: $4049becc2e14db97$var$identity,
    ul: $4049becc2e14db97$var$identity
};
const $4049becc2e14db97$export$b7cb80c25ebba28e = (item)=>{
    if (item.content == null) return null;
    const parser = new DOMParser();
    const { body: body } = parser.parseFromString(item.content, 'text/html');
    if (body == null) return null;
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    const keyGen = $4049becc2e14db97$var$infinite();
    const children = $4049becc2e14db97$var$mapChildrenNodes(walker, keyGen);
    if (children == null || children.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4049becc2e14db97$var$Content, {
        "data-testid": "business-summary.ui.summary-view.activity-feed.activity-item.content"
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4049becc2e14db97$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81hqg _1nmz1hna _yc8jglyw _1uukyh40 _17q5zu5n _chq7muej _6qesidpf _12ogidpf _102oidpf _3fjiidpf _1kvxidpf _pezqidpf _1ysjidpf _1yf6idpf _17d4idpf _5jhz13xq _gxop13xq _d1n81wth _2uss1pyq _1qqaudwz _1hnyglyw _1jhyglyw _6n1uidpf _1uzxidpf _11ucidpf _lnp5idpf _1vt11bs6 _upcbzgxb _18iqiti9 _rtys1osq _19l3uuw1 _mezj1wug _bna71wug _wec71bs6 _wdakqbzx _kq6x1jtm _9cgvqk37 _16n385st _1d9ptcjq _b4pmglyw _1if6zgxb _r7x4zgxb _dzke18iy _1owe18iy _178i155y",
            __cmplp.className
        ])
    });
});
const $4049becc2e14db97$var$TypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz _2hwxv77o _s7n4nkob _1e0c116y _n3tdv77o",
            __cmplp.className
        ])
    });
});
const $4049becc2e14db97$var$StyledAnchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});


parcelRegister("l06MN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f5111c88e11f83e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $8f5111c88e11f83e$var$EmptyIllustration = ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 246 232",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#activity_0_clip)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M118.4 215.9C118.4 215.476 118.569 215.069 118.869 214.769C119.169 214.469 119.576 214.3 120 214.3C120.407 214.325 120.789 214.505 121.067 214.803C121.346 215.1 121.501 215.492 121.5 215.9C121.501 216.308 121.346 216.7 121.067 216.997C120.789 217.295 120.407 217.475 120 217.5C119.576 217.5 119.169 217.331 118.869 217.031C118.569 216.731 118.4 216.324 118.4 215.9ZM110.4 217.1C109.985 217.051 109.602 216.85 109.325 216.537C109.049 216.223 108.897 215.818 108.9 215.4C108.95 214.967 109.165 214.57 109.5 214.29C109.835 214.011 110.265 213.871 110.7 213.9C111.107 213.95 111.479 214.155 111.739 214.471C112 214.787 112.129 215.191 112.1 215.6C112.075 216.007 111.895 216.389 111.597 216.667C111.3 216.946 110.908 217.101 110.5 217.1H110.4ZM127.8 215.6C127.786 215.39 127.815 215.179 127.883 214.98C127.951 214.78 128.058 214.596 128.197 214.438C128.336 214.281 128.506 214.152 128.695 214.059C128.884 213.967 129.09 213.913 129.3 213.9C129.709 213.871 130.113 214.001 130.429 214.261C130.746 214.521 130.95 214.893 131 215.3C131.029 215.735 130.889 216.165 130.61 216.5C130.33 216.835 129.933 217.05 129.5 217.1H129.4C128.992 217.101 128.6 216.946 128.303 216.667C128.005 216.389 127.826 216.007 127.8 215.6ZM100.9 215.8C100.688 215.764 100.486 215.686 100.305 215.57C100.124 215.454 99.968 215.303 99.8467 215.126C99.7254 214.949 99.641 214.749 99.5986 214.538C99.5563 214.327 99.5567 214.11 99.6 213.9C99.6357 213.701 99.7111 213.512 99.8219 213.343C99.9326 213.174 100.076 213.029 100.244 212.917C100.413 212.805 100.602 212.728 100.8 212.69C100.999 212.653 101.203 212.656 101.4 212.7C101.608 212.723 101.808 212.79 101.989 212.895C102.169 213.001 102.326 213.143 102.448 213.312C102.571 213.482 102.656 213.675 102.7 213.88C102.743 214.084 102.743 214.295 102.7 214.5C102.65 214.88 102.456 215.227 102.159 215.468C101.861 215.71 101.482 215.829 101.1 215.8H100.9ZM137.2 214.5C137.139 214.078 137.239 213.648 137.479 213.296C137.72 212.945 138.085 212.696 138.5 212.6C138.91 212.542 139.327 212.645 139.662 212.887C139.998 213.129 140.227 213.493 140.3 213.9C140.344 214.097 140.347 214.301 140.31 214.5C140.272 214.698 140.195 214.887 140.083 215.056C139.971 215.224 139.826 215.367 139.657 215.478C139.489 215.589 139.299 215.664 139.1 215.7H138.8C138.441 215.695 138.092 215.576 137.805 215.36C137.517 215.145 137.306 214.843 137.2 214.5ZM91.5 213.6C91.1012 213.463 90.7677 213.182 90.5645 212.812C90.3612 212.442 90.3026 212.01 90.4 211.6C90.5375 211.201 90.8183 210.868 91.188 210.664C91.5576 210.461 91.9896 210.403 92.4 210.5C92.7863 210.655 93.107 210.939 93.3076 211.303C93.5081 211.668 93.5761 212.091 93.5 212.5C93.3908 212.833 93.1751 213.122 92.886 213.32C92.5968 213.519 92.2504 213.617 91.9 213.6H91.5ZM146.5 212.5C146.373 212.102 146.406 211.67 146.593 211.296C146.78 210.923 147.105 210.637 147.5 210.5C147.91 210.403 148.342 210.461 148.712 210.664C149.082 210.868 149.363 211.201 149.5 211.6C149.594 211.997 149.532 212.415 149.327 212.768C149.123 213.122 148.791 213.383 148.4 213.5H148C147.675 213.518 147.354 213.431 147.083 213.25C146.812 213.07 146.608 212.807 146.5 212.5ZM82.4 210.5C82.0235 210.344 81.7207 210.05 81.5534 209.678C81.3862 209.307 81.3671 208.885 81.5 208.5C81.656 208.123 81.9499 207.821 82.3216 207.653C82.6932 207.486 83.1147 207.467 83.5 207.6C83.6947 207.666 83.8737 207.772 84.0259 207.91C84.1781 208.049 84.3002 208.217 84.3846 208.404C84.469 208.592 84.5139 208.795 84.5166 209.001C84.5192 209.206 84.4796 209.41 84.4 209.6C84.3113 209.899 84.1253 210.159 83.8718 210.34C83.6182 210.522 83.3114 210.613 83 210.6H82.4V210.5ZM155.5 209.6C155.367 209.215 155.386 208.793 155.553 208.422C155.721 208.05 156.023 207.756 156.4 207.6C156.587 207.503 156.794 207.45 157.005 207.444C157.216 207.438 157.425 207.48 157.617 207.567C157.81 207.654 157.98 207.782 158.115 207.944C158.251 208.106 158.348 208.296 158.4 208.5C158.533 208.885 158.514 209.307 158.347 209.678C158.179 210.05 157.877 210.344 157.5 210.5H156.9C156.604 210.505 156.313 210.422 156.064 210.262C155.815 210.102 155.618 209.871 155.5 209.6ZM73.6 206.7C73.4065 206.605 73.2342 206.472 73.0935 206.308C72.9527 206.145 72.8465 205.955 72.7811 205.749C72.7157 205.544 72.6926 205.327 72.713 205.112C72.7334 204.898 72.797 204.689 72.9 204.5C73.0924 204.135 73.4182 203.859 73.8094 203.728C74.2007 203.598 74.6272 203.624 75 203.8C75.3649 203.992 75.6414 204.318 75.7718 204.709C75.9022 205.101 75.8765 205.527 75.7 205.9C75.5816 206.171 75.3854 206.402 75.1363 206.562C74.8872 206.722 74.5962 206.805 74.3 206.8H73.6V206.7ZM164.2 205.9C164.099 205.718 164.036 205.517 164.017 205.31C163.998 205.102 164.022 204.893 164.087 204.696C164.153 204.498 164.26 204.317 164.399 204.162C164.539 204.008 164.71 203.885 164.9 203.8C165.082 203.699 165.283 203.636 165.49 203.617C165.698 203.598 165.907 203.622 166.104 203.687C166.302 203.753 166.483 203.86 166.638 203.999C166.792 204.139 166.915 204.31 167 204.5C167.101 204.682 167.164 204.883 167.183 205.09C167.202 205.298 167.178 205.507 167.113 205.704C167.047 205.902 166.94 206.083 166.801 206.238C166.661 206.392 166.49 206.515 166.3 206.6L165.6 206.8C165.304 206.805 165.013 206.722 164.764 206.562C164.515 206.402 164.318 206.171 164.2 205.9ZM65.2 202C64.843 201.774 64.59 201.415 64.4963 201.003C64.4026 200.591 64.4758 200.158 64.7 199.8C64.9263 199.443 65.2847 199.19 65.6969 199.096C66.1091 199.003 66.5416 199.076 66.9 199.3C67.2379 199.542 67.4754 199.9 67.5676 200.305C67.6597 200.71 67.6001 201.136 67.4 201.5C67.2537 201.734 67.0456 201.924 66.7986 202.047C66.5515 202.171 66.2752 202.224 66 202.2L65.2 202ZM172.5 201.4C172.276 201.042 172.203 200.609 172.296 200.197C172.39 199.785 172.643 199.426 173 199.2C173.376 199.01 173.809 198.966 174.216 199.076C174.622 199.187 174.973 199.445 175.2 199.8C175.394 200.149 175.45 200.558 175.358 200.947C175.265 201.336 175.03 201.676 174.7 201.9L173.8 202.2C173.534 202.186 173.276 202.105 173.048 201.965C172.821 201.825 172.633 201.631 172.5 201.4ZM57.3 196.6C56.9681 196.326 56.7525 195.936 56.6968 195.509C56.6412 195.082 56.7495 194.65 57 194.3C57.2699 193.995 57.6405 193.796 58.0443 193.741C58.4481 193.686 58.8582 193.778 59.2 194C59.525 194.257 59.7378 194.629 59.7937 195.04C59.8497 195.45 59.7444 195.866 59.5 196.2C59.3621 196.419 59.1699 196.598 58.9421 196.721C58.7143 196.844 58.4587 196.905 58.2 196.9L57.3 196.6ZM180.4 196.2C180.156 195.866 180.05 195.45 180.106 195.04C180.162 194.629 180.375 194.257 180.7 194C180.86 193.866 181.047 193.766 181.248 193.708C181.448 193.65 181.659 193.635 181.866 193.663C182.074 193.691 182.273 193.763 182.451 193.872C182.629 193.982 182.782 194.128 182.9 194.3C183.144 194.634 183.25 195.05 183.194 195.461C183.138 195.871 182.925 196.243 182.6 196.5C182.306 196.702 181.957 196.807 181.6 196.8C181.368 196.793 181.141 196.735 180.934 196.632C180.727 196.528 180.545 196.381 180.4 196.2ZM49.9 190.4C49.6048 190.116 49.4299 189.729 49.4113 189.32C49.3927 188.911 49.5318 188.51 49.8 188.2C50.0842 187.905 50.4708 187.73 50.8801 187.711C51.2894 187.693 51.6903 187.832 52 188.1C52.1581 188.233 52.2868 188.398 52.3782 188.584C52.4695 188.769 52.5216 188.972 52.5309 189.178C52.5403 189.385 52.5069 189.591 52.4328 189.784C52.3586 189.977 52.2453 190.153 52.1 190.3C51.9708 190.466 51.8032 190.598 51.6116 190.686C51.42 190.773 51.2102 190.812 51 190.8C50.7992 190.81 50.5984 190.78 50.4094 190.712C50.2204 190.643 50.0472 190.537 49.9 190.4ZM187.7 190.2C187.453 189.881 187.327 189.485 187.346 189.082C187.364 188.679 187.525 188.295 187.8 188C188.126 187.725 188.544 187.583 188.97 187.601C189.396 187.62 189.799 187.798 190.1 188.1C190.368 188.41 190.507 188.811 190.489 189.22C190.47 189.629 190.295 190.016 190 190.3C189.713 190.604 189.318 190.784 188.9 190.8C188.67 190.787 188.445 190.727 188.238 190.623C188.032 190.52 187.849 190.376 187.7 190.2ZM43.1 183.6C42.8318 183.29 42.6927 182.889 42.7113 182.48C42.7299 182.071 42.9048 181.684 43.2 181.4C43.5098 181.132 43.9106 180.993 44.32 181.011C44.7293 181.03 45.1159 181.205 45.4 181.5C45.5453 181.647 45.6586 181.823 45.7327 182.016C45.8069 182.209 45.8403 182.415 45.831 182.622C45.8216 182.828 45.7695 183.031 45.6782 183.216C45.5868 183.402 45.4581 183.567 45.3 183.7C45.1766 183.848 45.0242 183.968 44.8521 184.054C44.6801 184.14 44.4921 184.19 44.3 184.2C44.0658 184.208 43.8331 184.158 43.6235 184.053C43.4138 183.948 43.2338 183.792 43.1 183.6ZM194.5 183.7C194.198 183.399 194.02 182.996 194.001 182.57C193.983 182.143 194.125 181.726 194.4 181.4C194.701 181.098 195.104 180.92 195.531 180.901C195.957 180.883 196.374 181.025 196.7 181.3C196.983 181.611 197.148 182.012 197.166 182.432C197.184 182.852 197.055 183.265 196.8 183.6C196.463 183.889 196.043 184.064 195.6 184.1C195.203 184.074 194.821 183.935 194.5 183.7ZM37 176.3C36.8634 176.131 36.7625 175.937 36.7035 175.728C36.6444 175.519 36.6284 175.301 36.6565 175.086C36.6845 174.87 36.7561 174.663 36.8667 174.477C36.9773 174.29 37.1248 174.128 37.3 174C37.6463 173.766 38.0704 173.677 38.4815 173.752C38.8926 173.827 39.2582 174.059 39.5 174.4C39.7444 174.734 39.8497 175.15 39.7937 175.561C39.7378 175.971 39.525 176.343 39.2 176.6C38.9064 176.802 38.5566 176.907 38.2 176.9C37.9658 176.908 37.7331 176.858 37.5235 176.753C37.3138 176.648 37.1338 176.492 37 176.3ZM200.7 176.5C200.375 176.243 200.162 175.871 200.106 175.461C200.05 175.05 200.156 174.634 200.4 174.3C200.518 174.128 200.672 173.982 200.85 173.872C201.028 173.763 201.226 173.691 201.434 173.663C201.641 173.635 201.852 173.65 202.052 173.708C202.253 173.766 202.44 173.866 202.6 174C202.925 174.257 203.138 174.629 203.194 175.04C203.25 175.45 203.144 175.866 202.9 176.2C202.745 176.394 202.547 176.549 202.321 176.654C202.095 176.758 201.848 176.808 201.6 176.8L200.7 176.5ZM31.5 168.3C31.3062 167.951 31.25 167.542 31.3425 167.153C31.435 166.764 31.6696 166.424 32 166.2C32.1729 166.075 32.3706 165.988 32.5798 165.945C32.7891 165.902 33.0051 165.904 33.2133 165.951C33.4216 165.999 33.6174 166.09 33.7876 166.219C33.9577 166.348 34.0983 166.512 34.2 166.7C34.4242 167.058 34.4975 167.491 34.4038 167.903C34.3101 168.315 34.0571 168.674 33.7 168.9L32.9 169.1C32.6167 169.103 32.3379 169.03 32.0919 168.889C31.8459 168.749 31.6417 168.545 31.5 168.3ZM206.2 168.8C205.845 168.573 205.587 168.222 205.476 167.816C205.366 167.409 205.41 166.976 205.6 166.6H205.7C205.791 166.415 205.922 166.252 206.083 166.123C206.244 165.995 206.432 165.903 206.632 165.855C206.833 165.808 207.042 165.805 207.243 165.847C207.445 165.889 207.635 165.976 207.8 166.1C207.985 166.191 208.148 166.322 208.277 166.483C208.405 166.644 208.497 166.832 208.545 167.032C208.592 167.233 208.595 167.442 208.553 167.643C208.511 167.845 208.424 168.035 208.3 168.2C208.167 168.431 207.979 168.625 207.752 168.765C207.525 168.905 207.266 168.986 207 169L206.2 168.8ZM26.8 160C26.6235 159.627 26.5978 159.201 26.7283 158.809C26.8587 158.418 27.1352 158.092 27.5 157.9C27.6895 157.797 27.8978 157.733 28.1125 157.713C28.3271 157.693 28.5437 157.716 28.7492 157.781C28.9547 157.846 29.1449 157.953 29.3083 158.093C29.4716 158.234 29.6049 158.406 29.7 158.6C29.8339 158.978 29.8378 159.39 29.711 159.77C29.5842 160.151 29.334 160.478 29 160.7H28.2C27.9277 160.704 27.6583 160.643 27.4147 160.521C27.171 160.399 26.9602 160.22 26.8 160ZM210.9 160.6C210.535 160.408 210.259 160.082 210.128 159.691C209.998 159.299 210.024 158.873 210.2 158.5C210.393 158.134 210.712 157.851 211.099 157.704C211.486 157.556 211.913 157.555 212.3 157.7C212.494 157.795 212.666 157.928 212.807 158.092C212.947 158.255 213.054 158.445 213.119 158.651C213.184 158.856 213.207 159.073 213.187 159.288C213.167 159.502 213.103 159.711 213 159.9C212.858 160.145 212.654 160.349 212.408 160.489C212.162 160.63 211.883 160.703 211.6 160.7H210.9V160.6ZM22.9 151.2C22.7624 150.801 22.7783 150.364 22.9447 149.976C23.111 149.588 23.4159 149.276 23.8 149.1C23.9968 149.019 24.2077 148.978 24.4204 148.98C24.6332 148.981 24.8435 149.025 25.039 149.109C25.2345 149.193 25.4114 149.315 25.5593 149.468C25.7071 149.621 25.8229 149.802 25.9 150C25.981 150.197 26.0218 150.408 26.0203 150.62C26.0187 150.833 25.9748 151.043 25.891 151.239C25.8072 151.435 25.6852 151.611 25.5322 151.759C25.3792 151.907 25.1983 152.023 25 152.1H24.4C24.0941 152.09 23.7958 152.002 23.5333 151.844C23.2709 151.687 23.0529 151.465 22.9 151.2ZM214.9 152C214.692 151.936 214.501 151.827 214.34 151.682C214.178 151.536 214.05 151.358 213.965 151.158C213.879 150.958 213.838 150.742 213.844 150.525C213.85 150.308 213.903 150.095 214 149.9C214.156 149.523 214.45 149.221 214.822 149.053C215.193 148.886 215.615 148.867 216 149C216.384 149.176 216.689 149.488 216.855 149.876C217.022 150.264 217.038 150.701 216.9 151.1C216.792 151.407 216.588 151.67 216.317 151.85C216.046 152.031 215.725 152.118 215.4 152.1H214.9V152ZM19.9 142.1C19.8232 141.897 19.7914 141.68 19.8067 141.463C19.822 141.247 19.884 141.036 19.9886 140.846C20.0932 140.656 20.2378 140.491 20.4124 140.362C20.587 140.233 20.7875 140.144 21 140.1C21.3973 140.006 21.8153 140.068 22.1685 140.273C22.5216 140.477 22.7834 140.809 22.9 141.2C22.9768 141.403 23.0087 141.62 22.9934 141.837C22.9781 142.053 22.916 142.264 22.8114 142.454C22.7069 142.644 22.5623 142.809 22.3877 142.938C22.213 143.067 22.0126 143.156 21.8 143.2H21.4C21.0627 143.212 20.7311 143.11 20.4589 142.911C20.1867 142.711 19.9898 142.425 19.9 142.1ZM218 143.1C217.614 142.945 217.293 142.661 217.092 142.297C216.892 141.932 216.824 141.509 216.9 141.1C217.037 140.701 217.318 140.368 217.688 140.164C218.058 139.961 218.49 139.903 218.9 140C219.295 140.137 219.621 140.423 219.807 140.796C219.994 141.17 220.028 141.602 219.9 142C219.81 142.325 219.613 142.611 219.341 142.811C219.069 143.01 218.737 143.112 218.4 143.1H218ZM17.7 132.7C17.6384 132.304 17.7275 131.9 17.9497 131.566C18.1719 131.233 18.511 130.995 18.9 130.9C19.1105 130.857 19.3275 130.856 19.5381 130.899C19.7487 130.941 19.9487 131.025 20.126 131.147C20.3033 131.268 20.4544 131.424 20.5702 131.605C20.686 131.786 20.7641 131.988 20.8 132.2C20.8584 132.61 20.7555 133.027 20.5131 133.362C20.2706 133.698 19.9075 133.926 19.5 134H19.2C18.8345 134.003 18.4804 133.873 18.2042 133.634C17.928 133.394 17.7487 133.062 17.7 132.7ZM220.3 133.9C219.885 133.804 219.52 133.555 219.279 133.204C219.039 132.852 218.939 132.422 219 132C219.095 131.59 219.348 131.235 219.704 131.01C220.059 130.786 220.489 130.71 220.9 130.8C221.099 130.836 221.288 130.911 221.457 131.022C221.626 131.133 221.771 131.276 221.883 131.444C221.995 131.613 222.072 131.802 222.11 132C222.147 132.199 222.144 132.403 222.1 132.6C222.051 132.962 221.872 133.294 221.596 133.534C221.32 133.773 220.965 133.903 220.6 133.9H220.3ZM16.4 123.2C16.3713 122.791 16.5005 122.387 16.761 122.071C17.0215 121.755 17.3934 121.55 17.8 121.5C18.2088 121.471 18.6129 121.601 18.9292 121.861C19.2455 122.121 19.4498 122.493 19.5 122.9C19.5312 123.32 19.4053 123.737 19.1466 124.07C18.8879 124.402 18.515 124.627 18.1 124.7H17.9C17.5022 124.7 17.1207 124.542 16.8394 124.261C16.5581 123.979 16.4 123.598 16.4 123.2ZM221.7 124.5C221.494 124.488 221.292 124.434 221.107 124.34C220.923 124.246 220.76 124.116 220.628 123.956C220.497 123.796 220.4 123.611 220.343 123.412C220.287 123.213 220.272 123.005 220.3 122.8C220.35 122.393 220.555 122.021 220.871 121.761C221.187 121.501 221.591 121.371 222 121.4C222.206 121.412 222.408 121.466 222.593 121.56C222.777 121.654 222.94 121.784 223.072 121.944C223.203 122.104 223.3 122.289 223.357 122.488C223.413 122.687 223.428 122.895 223.4 123.1C223.375 123.48 223.205 123.837 222.927 124.097C222.648 124.357 222.281 124.501 221.9 124.5H221.7ZM15.9 113.6C15.9255 113.193 16.1052 112.811 16.4026 112.533C16.6999 112.254 17.0924 112.099 17.5 112.1C17.9076 112.099 18.3001 112.254 18.5975 112.533C18.8948 112.811 19.0746 113.193 19.1 113.6C19.1 114.024 18.9315 114.431 18.6314 114.731C18.3313 115.031 17.9244 115.2 17.5 115.2C17.0757 115.2 16.6687 115.031 16.3687 114.731C16.0686 114.431 15.9 114.024 15.9 113.6ZM220.7 113.5C220.7 113.076 220.869 112.669 221.169 112.369C221.469 112.069 221.876 111.9 222.3 111.9C222.724 111.9 223.131 112.069 223.431 112.369C223.731 112.669 223.9 113.076 223.9 113.5C223.9 113.924 223.731 114.331 223.431 114.631C223.131 114.931 222.724 115.1 222.3 115.1C221.876 115.1 221.469 114.931 221.169 114.631C220.869 114.331 220.7 113.924 220.7 113.5ZM17.8 105.8C17.3847 105.751 17.002 105.55 16.7253 105.237C16.4485 104.923 16.2971 104.518 16.3 104.1C16.3128 103.89 16.3669 103.684 16.4593 103.495C16.5517 103.305 16.6806 103.136 16.8385 102.997C16.9965 102.858 17.1804 102.751 17.3797 102.683C17.579 102.615 17.7898 102.586 18 102.6C18.2103 102.613 18.416 102.667 18.6052 102.759C18.7945 102.852 18.9637 102.981 19.1031 103.138C19.2424 103.296 19.3492 103.48 19.4174 103.68C19.4855 103.879 19.5136 104.09 19.5 104.3C19.4746 104.707 19.2948 105.089 18.9975 105.367C18.7001 105.646 18.3076 105.801 17.9 105.8H17.8ZM220.3 104C220.272 103.795 220.287 103.587 220.343 103.388C220.4 103.189 220.497 103.004 220.628 102.844C220.76 102.684 220.923 102.554 221.107 102.46C221.292 102.366 221.494 102.312 221.7 102.3C221.905 102.272 222.113 102.287 222.312 102.343C222.511 102.4 222.696 102.497 222.856 102.628C223.016 102.76 223.146 102.923 223.24 103.107C223.334 103.292 223.388 103.494 223.4 103.7C223.428 103.905 223.413 104.113 223.357 104.312C223.3 104.511 223.203 104.696 223.072 104.856C222.94 105.016 222.777 105.146 222.593 105.24C222.408 105.334 222.206 105.388 222 105.4H221.9C221.703 105.414 221.505 105.388 221.318 105.325C221.131 105.262 220.958 105.162 220.809 105.032C220.66 104.902 220.539 104.744 220.452 104.567C220.364 104.39 220.313 104.197 220.3 104ZM18.9 96.4C18.4845 96.3041 18.1203 96.0555 17.8795 95.7035C17.6387 95.3516 17.5389 94.922 17.6 94.5C17.6955 94.0904 17.9483 93.7349 18.3039 93.5103C18.6595 93.2857 19.0892 93.2102 19.5 93.3C19.6989 93.3356 19.8885 93.4111 20.0575 93.5218C20.2265 93.6326 20.3713 93.7763 20.4834 93.9444C20.5955 94.1125 20.6724 94.3015 20.7097 94.5001C20.7469 94.6987 20.7436 94.9027 20.7 95.1C20.6513 95.4622 20.472 95.7942 20.1958 96.0336C19.9196 96.273 19.5655 96.4033 19.2 96.4H18.9ZM219 94.8C218.91 94.3891 218.986 93.9594 219.21 93.6039C219.435 93.2483 219.79 92.9954 220.2 92.9C220.622 92.8389 221.052 92.9386 221.404 93.1794C221.755 93.4202 222.004 93.7845 222.1 94.2C222.158 94.6099 222.055 95.0265 221.813 95.3622C221.571 95.6979 221.208 95.9265 220.8 96H220.5C220.149 96.0071 219.807 95.8909 219.533 95.6716C219.259 95.4523 219.07 95.1439 219 94.8ZM20.9 87.1C20.5089 86.9833 20.1772 86.7216 19.9727 86.3684C19.7683 86.0152 19.7065 85.5972 19.8 85.2C19.8575 84.9954 19.9551 84.8044 20.0872 84.6379C20.2193 84.4715 20.3832 84.333 20.5694 84.2306C20.7556 84.1282 20.9603 84.0639 21.1716 84.0415C21.3829 84.0191 21.5965 84.039 21.8 84.1C22.1911 84.2167 22.5228 84.4784 22.7273 84.8316C22.9318 85.1848 22.9936 85.6028 22.9 86C22.7944 86.3434 22.5826 86.6446 22.2952 86.8602C22.0077 87.0758 21.6593 87.1947 21.3 87.2H20.9V87.1ZM216.8 85.7C216.706 85.3027 216.768 84.8848 216.973 84.5316C217.177 84.1784 217.509 83.9167 217.9 83.8C218.298 83.6725 218.73 83.7058 219.104 83.8926C219.477 84.0795 219.763 84.4052 219.9 84.8C219.997 85.2104 219.939 85.6424 219.736 86.0121C219.532 86.3817 219.199 86.6625 218.8 86.8H218.4C218.05 86.8174 217.703 86.7192 217.414 86.5204C217.125 86.3217 216.909 86.0334 216.8 85.7ZM23.8 78.1C23.5956 78.0482 23.4055 77.951 23.244 77.8154C23.0824 77.6799 22.9536 77.5097 22.867 77.3174C22.7805 77.1251 22.7385 76.9157 22.7442 76.7049C22.7499 76.4941 22.8032 76.2873 22.9 76.1C23.056 75.7235 23.3499 75.4207 23.7216 75.2534C24.0932 75.0862 24.5147 75.0671 24.9 75.2C25.2766 75.356 25.5793 75.6499 25.7466 76.0215C25.9139 76.3932 25.933 76.8147 25.8 77.2C25.6922 77.5067 25.4876 77.7701 25.217 77.9505C24.9465 78.1308 24.6247 78.2184 24.3 78.2H23.8V78.1ZM213.9 76.9C213.819 76.7033 213.778 76.4923 213.78 76.2796C213.781 76.0669 213.825 75.8566 213.909 75.661C213.993 75.4655 214.115 75.2886 214.268 75.1408C214.421 74.9929 214.602 74.8771 214.8 74.8C215.185 74.6671 215.607 74.6862 215.978 74.8534C216.35 75.0207 216.644 75.3235 216.8 75.7C216.938 76.0993 216.922 76.5355 216.755 76.9237C216.589 77.3119 216.284 77.6243 215.9 77.8H215.3C215.004 77.805 214.713 77.7221 214.464 77.562C214.215 77.4018 214.018 77.1715 213.9 76.9ZM27.4 69.4C27.0352 69.2077 26.7587 68.8819 26.6283 68.4906C26.4978 68.0993 26.5235 67.6728 26.7 67.3C26.8924 66.9351 27.2182 66.6587 27.6094 66.5282C28.0007 66.3978 28.4272 66.4235 28.8 66.6C29.166 66.7928 29.4492 67.1124 29.5965 67.499C29.7438 67.8855 29.745 68.3126 29.6 68.7C29.4404 68.9592 29.2208 69.1763 28.9598 69.3329C28.6987 69.4895 28.4039 69.5811 28.1 69.6L27.4 69.4ZM210.1 68.4C209.999 68.2181 209.936 68.0171 209.917 67.8098C209.898 67.6024 209.922 67.3934 209.987 67.1958C210.053 66.9983 210.16 66.8166 210.299 66.6624C210.439 66.5082 210.61 66.3847 210.8 66.3C210.982 66.1987 211.183 66.1364 211.39 66.117C211.598 66.0976 211.807 66.1216 212.004 66.1874C212.202 66.2533 212.383 66.3595 212.538 66.4994C212.692 66.6393 212.815 66.8098 212.9 67C213.077 67.3728 213.102 67.7993 212.972 68.1906C212.841 68.5819 212.565 68.9077 212.2 69.1H211.5C211.226 69.113 210.954 69.0555 210.709 68.9329C210.463 68.8103 210.254 68.6268 210.1 68.4ZM31.9 61.1C31.543 60.8737 31.29 60.5153 31.1963 60.1031C31.1026 59.6909 31.1758 59.2584 31.4 58.9C31.5017 58.7122 31.6423 58.5482 31.8125 58.4191C31.9827 58.29 32.1784 58.1987 32.3867 58.1514C32.595 58.1041 32.811 58.1018 33.0202 58.1446C33.2295 58.1875 33.4271 58.2746 33.6 58.4C33.9305 58.6244 34.165 58.9644 34.2575 59.353C34.3501 59.7416 34.2939 60.1507 34.1 60.5C33.9584 60.7453 33.7541 60.9487 33.5082 61.0893C33.2622 61.2298 32.9833 61.3025 32.7 61.3L31.9 61.1ZM205.5 60.3C205.3 59.9356 205.24 59.5105 205.332 59.1051C205.425 58.6997 205.662 58.3421 206 58.1C206.173 57.9746 206.371 57.8875 206.58 57.8446C206.789 57.8018 207.005 57.8041 207.213 57.8514C207.422 57.8987 207.617 57.99 207.788 58.1191C207.958 58.2482 208.098 58.4122 208.2 58.6C208.424 58.9584 208.497 59.3909 208.404 59.8031C208.31 60.2153 208.057 60.5737 207.7 60.8L206.9 61C206.628 61.004 206.358 60.9425 206.115 60.8207C205.871 60.6989 205.66 60.5203 205.5 60.3ZM37.1 53.2C36.7751 52.9434 36.5622 52.5708 36.5063 52.1605C36.4504 51.7502 36.5556 51.3343 36.8 51C36.9184 50.8277 37.0715 50.682 37.2495 50.5724C37.4275 50.4627 37.6265 50.3915 37.8336 50.3632C38.0408 50.335 38.2516 50.3503 38.4524 50.4083C38.6533 50.4663 38.8398 50.5657 39 50.7C39.1723 50.8184 39.318 50.9715 39.4277 51.1495C39.5373 51.3275 39.6086 51.5265 39.6368 51.7336C39.6651 51.9408 39.6497 52.1515 39.5917 52.3524C39.5337 52.5533 39.4343 52.7398 39.3 52.9C39.1662 53.0925 38.9862 53.2483 38.7766 53.3531C38.5669 53.4579 38.3343 53.5084 38.1 53.5C37.7435 53.5074 37.3936 53.4024 37.1 53.2ZM200.2 52.6C199.978 52.2582 199.886 51.8481 199.941 51.4443C199.996 51.0404 200.195 50.6699 200.5 50.4C200.669 50.2634 200.863 50.1625 201.072 50.1034C201.281 50.0444 201.499 50.0284 201.714 50.0564C201.93 50.0845 202.137 50.156 202.323 50.2667C202.51 50.3773 202.672 50.5247 202.8 50.7C203.022 51.0418 203.114 51.4519 203.059 51.8557C203.004 52.2596 202.805 52.6301 202.5 52.9C202.201 53.0914 201.855 53.1953 201.5 53.2C201.254 53.1942 201.011 53.138 200.788 53.0348C200.564 52.9316 200.364 52.7836 200.2 52.6ZM43.1 45.8C42.7903 45.5293 42.5967 45.1497 42.5594 44.7401C42.5222 44.3304 42.6442 43.9221 42.9 43.6C43.0424 43.4391 43.2157 43.3085 43.4096 43.216C43.6036 43.1236 43.8141 43.0711 44.0288 43.0618C44.2434 43.0524 44.4578 43.0864 44.659 43.1617C44.8602 43.237 45.0442 43.3521 45.2 43.5C45.4952 43.7842 45.6701 44.1707 45.6888 44.5801C45.7074 44.9894 45.5682 45.3902 45.3 45.7C44.9763 46.0103 44.5483 46.1886 44.1 46.2C43.9144 46.2087 43.7292 46.1774 43.5567 46.1084C43.3842 46.0394 43.2284 45.9343 43.1 45.8ZM194.3 45.4C194.155 45.2528 194.041 45.0772 193.967 44.8841C193.893 44.691 193.86 44.4847 193.869 44.2781C193.878 44.0715 193.93 43.8691 194.022 43.6836C194.113 43.498 194.242 43.3334 194.4 43.2C194.71 42.9318 195.111 42.7927 195.52 42.8113C195.929 42.8299 196.316 43.0048 196.6 43.3C196.868 43.6098 197.007 44.0106 196.989 44.4199C196.97 44.8293 196.795 45.2158 196.5 45.5C196.353 45.637 196.18 45.743 195.991 45.8117C195.802 45.8804 195.601 45.9105 195.4 45.9C195.19 45.9119 194.98 45.8727 194.788 45.7856C194.597 45.6985 194.429 45.5662 194.3 45.4ZM49.6 39C49.3318 38.6902 49.1927 38.2894 49.2113 37.8801C49.2299 37.4707 49.4048 37.0842 49.7 36.8C49.8558 36.6521 50.0398 36.537 50.2411 36.4617C50.4423 36.3864 50.6566 36.3524 50.8713 36.3618C51.0859 36.3711 51.2965 36.4236 51.4904 36.516C51.6843 36.6085 51.8577 36.7391 52 36.9C52.2471 37.2189 52.3727 37.6153 52.3544 38.0184C52.3361 38.4214 52.175 38.8048 51.9 39.1C51.7528 39.237 51.5796 39.343 51.3907 39.4117C51.2017 39.4804 51.0008 39.5105 50.8 39.5C50.3517 39.4886 49.9238 39.3103 49.6 39ZM187.7 38.9C187.539 38.7576 187.409 38.5843 187.316 38.3904C187.224 38.1964 187.171 37.9859 187.162 37.7712C187.152 37.5566 187.186 37.3423 187.262 37.141C187.337 36.9398 187.452 36.7558 187.6 36.6C187.884 36.3048 188.271 36.1299 188.68 36.1113C189.089 36.0927 189.49 36.2318 189.8 36.5C190.102 36.801 190.28 37.2045 190.299 37.6305C190.317 38.0565 190.175 38.474 189.9 38.8C189.582 39.1191 189.15 39.2989 188.7 39.3C188.338 39.2559 187.993 39.118 187.7 38.9ZM56.8 32.8C56.5556 32.4657 56.4504 32.0498 56.5063 31.6395C56.5622 31.2292 56.7751 30.8566 57.1 30.6C57.4343 30.3556 57.8503 30.2503 58.2605 30.3063C58.6708 30.3622 59.0434 30.575 59.3 30.9C59.5444 31.2343 59.6497 31.6502 59.5937 32.0605C59.5378 32.4708 59.325 32.8434 59 33.1C58.743 33.3144 58.4314 33.4529 58.1 33.5C57.8447 33.4886 57.5951 33.4197 57.3701 33.2985C57.145 33.1773 56.9501 33.0069 56.8 32.8ZM180.5 32.9C180.175 32.6434 179.962 32.2708 179.906 31.8605C179.85 31.4502 179.956 31.0343 180.2 30.7C180.457 30.375 180.829 30.1622 181.24 30.1063C181.65 30.0503 182.066 30.1556 182.4 30.4C182.725 30.6566 182.938 31.0292 182.994 31.4395C183.05 31.8498 182.944 32.2657 182.7 32.6C182.545 32.7941 182.347 32.9494 182.121 33.0535C181.895 33.1577 181.648 33.2078 181.4 33.2C181.077 33.1933 180.763 33.0887 180.5 32.9ZM64.5 27.3C64.3914 27.1303 64.3181 26.9405 64.2844 26.7419C64.2508 26.5432 64.2575 26.3398 64.3041 26.1438C64.3508 25.9478 64.4365 25.7633 64.556 25.6011C64.6756 25.4389 64.8266 25.3025 65 25.2C65.1729 25.0746 65.3706 24.9875 65.5798 24.9446C65.7891 24.9018 66.0051 24.9041 66.2133 24.9514C66.4216 24.9987 66.6174 25.09 66.7876 25.2191C66.9577 25.3482 67.0983 25.5122 67.2 25.7C67.4001 26.0644 67.4597 26.4895 67.3676 26.8949C67.2754 27.3003 67.038 27.6579 66.7 27.9L65.8 28.1C65.5338 28.0855 65.2755 28.0047 65.0485 27.865C64.8214 27.7253 64.6329 27.5311 64.5 27.3ZM172.8 27.7C172.443 27.4737 172.19 27.1153 172.096 26.7031C172.003 26.2909 172.076 25.8584 172.3 25.5C172.526 25.1429 172.885 24.8899 173.297 24.7963C173.709 24.7026 174.142 24.7758 174.5 25C174.838 25.2421 175.075 25.5997 175.168 26.0051C175.26 26.4105 175.2 26.8356 175 27.2C174.84 27.4203 174.629 27.5989 174.385 27.7207C174.142 27.8425 173.872 27.904 173.6 27.9L172.8 27.7ZM72.7 22.6C72.5987 22.4181 72.5364 22.2171 72.517 22.0098C72.4976 21.8024 72.5216 21.5934 72.5875 21.3958C72.6533 21.1983 72.7596 21.0166 72.8995 20.8624C73.0394 20.7082 73.2098 20.5847 73.4 20.5C73.5819 20.3987 73.783 20.3364 73.9903 20.317C74.1976 20.2976 74.4067 20.3216 74.6042 20.3874C74.8017 20.4533 74.9834 20.5595 75.1376 20.6994C75.2919 20.8393 75.4153 21.0098 75.5 21.2C75.6013 21.3819 75.6637 21.5829 75.683 21.7902C75.7024 21.9976 75.6784 22.2066 75.6126 22.4042C75.5467 22.6017 75.4405 22.7834 75.3006 22.9376C75.1607 23.0918 74.9902 23.2153 74.8 23.3L74.1 23.5C73.8039 23.505 73.5129 23.4221 73.2638 23.262C73.0146 23.1018 72.8185 22.8715 72.7 22.6ZM164.7 23.1C164.51 23.0153 164.339 22.8918 164.199 22.7376C164.06 22.5834 163.953 22.4017 163.887 22.2042C163.822 22.0066 163.798 21.7976 163.817 21.5902C163.836 21.3829 163.899 21.1819 164 21C164.192 20.6351 164.518 20.3587 164.909 20.2282C165.301 20.0978 165.727 20.1235 166.1 20.3C166.465 20.4923 166.741 20.8181 166.872 21.2094C167.002 21.6007 166.977 22.0272 166.8 22.4C166.682 22.6715 166.485 22.9018 166.236 23.062C165.987 23.2221 165.696 23.305 165.4 23.3C165.276 23.3244 165.148 23.319 165.026 23.2842C164.904 23.2495 164.793 23.1863 164.7 23.1ZM81.3 18.6C81.1671 18.2147 81.1862 17.7932 81.3534 17.4215C81.5207 17.0499 81.8235 16.756 82.2 16.6C82.5853 16.4671 83.0068 16.4862 83.3785 16.6534C83.7502 16.8207 84.044 17.1235 84.2 17.5C84.333 17.8853 84.3139 18.3068 84.1466 18.6785C83.9794 19.0501 83.6766 19.344 83.3 19.5H82.7C82.4011 19.5195 82.1038 19.4426 81.8518 19.2806C81.5998 19.1186 81.4064 18.8801 81.3 18.6ZM156.1 19.4C155.723 19.244 155.421 18.9501 155.253 18.5785C155.086 18.2068 155.067 17.7853 155.2 17.4C155.264 17.1924 155.373 17.0013 155.518 16.8398C155.664 16.6783 155.842 16.5504 156.042 16.4648C156.242 16.3792 156.458 16.338 156.675 16.3441C156.892 16.3502 157.105 16.4034 157.3 16.5C157.677 16.656 157.979 16.9499 158.147 17.3215C158.314 17.6932 158.333 18.1147 158.2 18.5C158.06 18.7838 157.848 19.0258 157.584 19.2013C157.321 19.3769 157.016 19.4799 156.7 19.5H156.1V19.4ZM90.2 15.5C90.1232 15.297 90.0914 15.0798 90.1067 14.8634C90.122 14.6469 90.184 14.4364 90.2886 14.2462C90.3932 14.0561 90.5378 13.8909 90.7124 13.7621C90.887 13.6332 91.0875 13.5438 91.3 13.5C91.6973 13.4064 92.1153 13.4682 92.4685 13.6727C92.8216 13.8772 93.0834 14.2089 93.2 14.6C93.2611 14.8035 93.2809 15.0172 93.2585 15.2285C93.2361 15.4398 93.1718 15.6445 93.0694 15.8307C92.967 16.0168 92.8285 16.1808 92.6621 16.3128C92.4957 16.4449 92.3046 16.5426 92.1 16.6H91.7C91.3627 16.6122 91.0311 16.5102 90.7589 16.3106C90.4867 16.111 90.2898 15.8254 90.2 15.5ZM147.3 16.5C146.914 16.3452 146.593 16.0613 146.392 15.6967C146.192 15.332 146.124 14.9091 146.2 14.5C146.337 14.1012 146.618 13.7677 146.988 13.5644C147.358 13.3611 147.79 13.3025 148.2 13.4C148.599 13.5375 148.932 13.8183 149.136 14.1879C149.339 14.5576 149.397 14.9896 149.3 15.4C149.191 15.7334 148.975 16.0217 148.686 16.2204C148.397 16.4192 148.05 16.5174 147.7 16.5H147.3ZM99.4 13.2C99.3102 12.7891 99.3857 12.3594 99.6103 12.0039C99.8349 11.6483 100.19 11.3954 100.6 11.3C101.022 11.2389 101.452 11.3386 101.804 11.5794C102.156 11.8202 102.404 12.1845 102.5 12.6C102.558 13.0099 102.455 13.4265 102.213 13.7622C101.971 14.0979 101.608 14.3265 101.2 14.4H100.9C100.549 14.4071 100.207 14.2909 99.9327 14.0716C99.6587 13.8523 99.4702 13.5439 99.4 13.2ZM138.2 14.3C137.79 14.2046 137.435 13.9517 137.21 13.5961C136.986 13.2406 136.91 12.8109 137 12.4C137.094 12.0035 137.328 11.6542 137.658 11.4155C137.989 11.1769 138.394 11.0649 138.8 11.1C139.216 11.1959 139.58 11.4445 139.821 11.7965C140.061 12.1484 140.161 12.578 140.1 13C140.013 13.362 139.809 13.6853 139.52 13.9202C139.23 14.1551 138.872 14.2885 138.5 14.3H138.2ZM108.7 11.7C108.671 11.2913 108.801 10.8871 109.061 10.5708C109.321 10.2545 109.693 10.0502 110.1 10C110.305 9.97208 110.513 9.98684 110.712 10.0434C110.911 10.0999 111.096 10.1969 111.256 10.3284C111.416 10.4598 111.546 10.6229 111.64 10.8073C111.734 10.9917 111.788 11.1935 111.8 11.4C111.828 11.6049 111.813 11.8134 111.757 12.0123C111.7 12.2113 111.603 12.3964 111.472 12.556C111.34 12.7157 111.177 12.8464 110.993 12.94C110.808 13.0336 110.606 13.0881 110.4 13.1H110.3C109.908 13.1031 109.529 12.9622 109.234 12.7042C108.939 12.4461 108.749 12.0888 108.7 11.7ZM129 13.1C128.593 13.0498 128.221 12.8455 127.961 12.5292C127.701 12.2129 127.571 11.8087 127.6 11.4C127.613 11.1897 127.667 10.9841 127.759 10.7948C127.852 10.6055 127.981 10.4363 128.139 10.2969C128.296 10.1576 128.48 10.0508 128.68 9.98266C128.879 9.91454 129.09 9.88645 129.3 9.9C129.511 9.92468 129.715 9.99104 129.899 10.0952C130.084 10.1994 130.247 10.3393 130.377 10.5068C130.507 10.6744 130.603 10.8661 130.658 11.071C130.714 11.2758 130.728 11.4896 130.7 11.7C130.675 12.0802 130.505 12.4366 130.227 12.6966C129.948 12.9566 129.581 13.1008 129.2 13.1H129ZM118.1 11.1C118.1 10.6757 118.269 10.2687 118.569 9.96863C118.869 9.66857 119.276 9.5 119.7 9.5C120.124 9.5 120.531 9.66857 120.831 9.96863C121.131 10.2687 121.3 10.6757 121.3 11.1C121.3 11.5243 121.131 11.9313 120.831 12.2314C120.531 12.5314 120.124 12.7 119.7 12.7C119.276 12.7 118.869 12.5314 118.569 12.2314C118.269 11.9313 118.1 11.5243 118.1 11.1Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M112.8 131.5H62.4C51.5791 131.5 41.2015 135.799 33.55 143.45C25.8985 151.102 21.6 161.479 21.6 172.3C21.6 183.121 25.8985 193.498 33.55 201.15C41.2015 208.801 51.5791 213.1 62.4 213.1H64.8C70.1395 213.065 75.3444 214.775 79.6226 217.97C83.9008 221.165 87.0181 225.67 88.5 230.8C88.5 230.9 88.6 231 88.6 231.1H88.9C88.9362 231.059 88.9637 231.012 88.9809 230.96C88.9981 230.909 89.0046 230.854 89 230.8C90.5012 225.662 93.6373 221.154 97.9324 217.96C102.228 214.765 107.447 213.059 112.8 213.1C123.621 213.1 133.998 208.801 141.65 201.15C149.301 193.498 153.6 183.121 153.6 172.3C153.6 161.479 149.301 151.102 141.65 143.45C133.998 135.799 123.621 131.5 112.8 131.5Z",
        fill: "url(#activity_0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M112.8 131.5H72.7999C75.1944 143.066 81.5064 153.451 90.6704 160.903C99.8344 168.354 111.289 172.415 123.1 172.4H126C130.954 172.379 135.841 173.539 140.258 175.782C144.675 178.025 148.494 181.288 151.4 185.3C152.858 181.121 153.602 176.726 153.6 172.3C153.6 161.479 149.301 151.102 141.65 143.45C133.998 135.799 123.621 131.5 112.8 131.5Z",
        fill: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M194.4 61.6992H131C117.368 61.6992 104.294 67.1146 94.6547 76.7539C85.0153 86.3933 79.6 99.4671 79.6 113.099C79.6 126.731 85.0153 139.805 94.6547 149.445C104.294 159.084 117.368 164.499 131 164.499H133.9C140.633 164.451 147.197 166.603 152.594 170.629C157.992 174.654 161.926 180.332 163.8 186.799C163.8 186.899 163.9 186.999 163.9 187.099C163.927 187.14 163.964 187.174 164.008 187.198C164.052 187.221 164.1 187.233 164.15 187.233C164.199 187.233 164.248 187.221 164.292 187.198C164.335 187.174 164.373 187.14 164.4 187.099V186.799C166.308 180.333 170.265 174.661 175.676 170.639C181.087 166.617 187.658 164.462 194.4 164.499C208.032 164.499 221.106 159.084 230.745 149.445C240.385 139.805 245.8 126.731 245.8 113.099C245.8 99.4671 240.385 86.3933 230.745 76.7539C221.106 67.1146 208.032 61.6992 194.4 61.6992Z",
        fill: "url(#activity_1_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M124 68.5992C124.036 66.4549 123.869 64.3119 123.5 62.1992C112.25 63.8756 101.872 69.2289 93.9849 77.4237C86.0977 85.6185 81.1451 96.1938 79.9 107.499C81.8913 106.975 83.941 106.706 86 106.699C90.9987 106.699 95.9482 105.713 100.565 103.797C105.182 101.881 109.376 99.0732 112.906 95.5339C116.435 91.9947 119.232 87.7938 121.136 83.1719C123.04 78.55 124.013 73.5979 124 68.5992Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M93.8001 21.0997H46.8001C41.8014 21.0997 36.8519 22.0859 32.235 24.0019C27.6181 25.9178 23.4245 28.7258 19.8946 32.265C16.3646 35.8042 13.5677 40.0051 11.6639 44.6271C9.7601 49.249 8.7869 54.2011 8.80006 59.1997C8.80006 69.278 12.8036 78.9434 19.93 86.0698C27.0564 93.1962 36.7218 97.1997 46.8001 97.1997H49.0001C54.0022 97.1762 58.8757 98.784 62.8818 101.78C66.8879 104.775 69.8082 108.995 71.2001 113.8V114C71.2001 114.2 71.4001 114.2 71.5001 114C71.6001 113.8 71.5001 113.8 71.6001 113.8C72.9622 108.978 75.8749 104.739 79.8876 101.739C83.9004 98.738 88.7898 97.1429 93.8001 97.1997C98.7987 97.2129 103.751 96.2397 108.373 94.3359C112.995 92.4321 117.196 89.6352 120.735 86.1052C124.274 82.5753 127.082 78.3818 128.998 73.7649C130.914 69.1479 131.9 64.1984 131.9 59.1997C131.913 54.1927 130.937 49.2324 129.027 44.6039C127.117 39.9754 124.311 35.7701 120.77 32.2296C117.23 28.689 113.024 25.8831 108.396 23.9731C103.767 22.063 98.8071 21.0865 93.8001 21.0997Z",
        fill: "url(#activity_2_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M152 33.7996C161.168 33.7996 168.6 26.3675 168.6 17.1996C168.6 8.03168 161.168 0.599609 152 0.599609C142.832 0.599609 135.4 8.03168 135.4 17.1996C135.4 26.3675 142.832 33.7996 152 33.7996Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M157.6 20.9997C158.62 20.1721 159.432 19.1167 159.971 17.9183C160.509 16.72 160.759 15.4121 160.7 14.0997C160.436 11.9677 159.393 10.0088 157.771 8.60018C156.149 7.19156 154.063 6.43281 151.915 6.47006C149.767 6.50731 147.709 7.33791 146.137 8.80192C144.565 10.2659 143.59 12.2598 143.4 14.3997C143.389 15.6518 143.652 16.8912 144.171 18.0312C144.689 19.1712 145.45 20.1843 146.4 20.9997C146.933 21.4137 147.363 21.9446 147.658 22.5515C147.953 23.1584 148.104 23.825 148.1 24.4997C148.073 25.4047 147.784 26.2825 147.27 27.0276C146.755 27.7727 146.037 28.3533 145.2 28.6997C143.184 29.4935 141.348 30.6836 139.8 32.1997C143.608 33.7774 147.679 34.6254 151.8 34.6996C156.088 34.6741 160.332 33.8254 164.3 32.1997C161.8 31.0997 160.3 29.2997 158.9 28.6997C158.056 28.3641 157.33 27.7862 156.814 27.0387C156.298 26.2913 156.015 25.4078 156 24.4997C156.011 23.8374 156.159 23.1846 156.434 22.5823C156.709 21.9799 157.106 21.4411 157.6 20.9997Z",
        fill: "#97A0AF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M143.6 25.7988C143.386 25.7988 143.175 25.746 142.987 25.645C142.798 25.544 142.637 25.398 142.518 25.2199C142.4 25.0419 142.327 24.8372 142.306 24.6242C142.285 24.4112 142.318 24.1964 142.4 23.9988C142.922 22.977 143.196 21.8464 143.2 20.6988V14.4988C143.255 12.7498 143.825 11.0558 144.837 9.62864C145.85 8.2015 147.261 7.10454 148.893 6.47493C150.526 5.84532 152.308 5.711 154.017 6.08876C155.726 6.46652 157.285 7.33959 158.5 8.59882C159.26 9.37738 159.855 10.3011 160.25 11.3147C160.646 12.3284 160.833 13.4113 160.8 14.4988V20.6988C160.79 21.8608 161.101 23.0029 161.7 23.9988C161.782 24.1964 161.815 24.4112 161.794 24.6242C161.773 24.8372 161.7 25.0419 161.582 25.2199C161.463 25.398 161.302 25.544 161.113 25.645C160.925 25.746 160.714 25.7988 160.5 25.7988H143.6Z",
        fill: "#97A0AF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.5 144.399C26.668 144.399 34.1 136.967 34.1 127.799C34.1 118.631 26.668 111.199 17.5 111.199C8.3321 111.199 0.900024 118.631 0.900024 127.799C0.900024 136.967 8.3321 144.399 17.5 144.399Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.8 131.398C23.8028 130.556 24.6024 129.498 25.1392 128.303C25.6759 127.108 25.936 125.808 25.9 124.498C25.8042 122.318 24.9019 120.252 23.3682 118.7C21.8345 117.147 19.7787 116.22 17.6 116.098C15.7947 116.028 14.0122 116.521 12.4999 117.51C10.9877 118.499 9.82079 119.934 9.16117 121.616C8.50156 123.298 8.38197 125.143 8.81901 126.896C9.25604 128.649 10.228 130.223 11.6 131.398C12.1036 131.832 12.5074 132.369 12.7836 132.973C13.0598 133.577 13.2019 134.234 13.2 134.898C13.1935 135.795 12.925 136.671 12.4276 137.417C11.9301 138.163 11.2254 138.748 10.4 139.098C8.35457 139.892 6.48563 141.082 4.90002 142.598C8.71488 144.154 12.7813 145.001 16.9 145.098C21.2217 145.083 25.4999 144.234 29.5 142.598C26.9 141.498 25.4 139.698 24 139.098C23.2845 138.791 22.6587 138.307 22.1813 137.692C21.7039 137.076 21.3905 136.35 21.2706 135.58C21.1507 134.811 21.2281 134.023 21.4956 133.292C21.7631 132.561 22.2119 131.909 22.8 131.398Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M189.6 206.1C198.768 206.1 206.2 198.668 206.2 189.5C206.2 180.332 198.768 172.9 189.6 172.9C180.432 172.9 173 180.332 173 189.5C173 198.668 180.432 206.1 189.6 206.1Z",
        fill: "#FFE380"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M190.1 207.402C193.994 207.32 197.835 206.471 201.4 204.902C199.944 203.415 198.211 202.226 196.3 201.402C195.493 201.036 194.81 200.445 194.331 199.7C193.852 198.955 193.598 198.088 193.6 197.202C193.604 196.548 193.738 195.901 193.996 195.3C194.254 194.699 194.629 194.156 195.1 193.702C196.022 192.869 196.757 191.85 197.257 190.712C197.757 189.575 198.01 188.344 198 187.102C198 182.102 194.2 178.202 189.5 178.402C184.8 178.602 181 182.102 181 187.102C180.995 188.334 181.241 189.555 181.723 190.689C182.204 191.824 182.911 192.849 183.8 193.702C184.304 194.135 184.707 194.672 184.984 195.277C185.26 195.881 185.402 196.538 185.4 197.202C185.402 198.088 185.148 198.955 184.669 199.7C184.19 200.445 183.507 201.036 182.7 201.402C180.789 202.226 179.056 203.415 177.6 204.902C181.165 206.471 185.006 207.32 188.9 207.402H190.1Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M197.4 197.701H181.6C181.351 197.702 181.111 197.611 180.926 197.444C180.741 197.278 180.625 197.049 180.6 196.801V186.601C180.628 184.246 181.559 181.991 183.2 180.301C184.878 178.642 187.14 177.708 189.5 177.701C191.86 177.701 194.124 178.639 195.793 180.308C197.462 181.977 198.4 184.241 198.4 186.601V196.801C198.401 196.928 198.375 197.054 198.323 197.17C198.272 197.287 198.197 197.391 198.102 197.476C198.008 197.561 197.896 197.625 197.775 197.664C197.654 197.702 197.526 197.715 197.4 197.701Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M103.8 46.9004H35.9V48.9004H103.8V46.9004Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M103.8 57.5996H35.9V59.5996H103.8V57.5996Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M103.8 68.4004H35.9V70.4004H103.8V68.4004Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M214.4 107.799C209 107.799 206.2 105.599 203.6 103.599C201 101.599 198.8 99.7988 194 99.7988C189.2 99.7988 186.9 101.599 184.4 103.599C181.9 105.599 179 107.799 173.6 107.799C168.2 107.799 165.4 105.599 162.7 103.599C160 101.599 157.9 99.7988 153.1 99.7988C148.3 99.7988 146 101.599 143.5 103.599C141 105.599 138.1 107.799 132.7 107.799C127.3 107.799 124.5 105.599 121.9 103.599C119.3 101.599 117 99.7988 112.3 99.7988V97.7988C117.7 97.7988 120.4 99.8988 123.1 101.999C125.8 104.099 127.9 105.799 132.7 105.799C137.5 105.799 139.8 103.899 142.3 101.999C144.8 100.099 147.7 97.7988 153.1 97.7988C158.5 97.7988 161.3 99.8988 164 101.999C166.7 104.099 168.8 105.799 173.6 105.799C178.4 105.799 180.7 103.899 183.2 101.999C185.7 100.099 188.5 97.7988 194 97.7988C199.5 97.7988 202.2 99.8988 204.8 101.999C207.4 104.099 209.7 105.799 214.4 105.799V107.799Z",
        fill: "#0049B0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M214.4 118.5C209 118.5 206.2 116.4 203.6 114.3C201 112.2 198.8 110.5 194 110.5C189.2 110.5 186.9 112.4 184.4 114.3C181.9 116.2 179 118.5 173.6 118.5C168.2 118.5 165.4 116.4 162.7 114.3C160 112.2 157.9 110.5 153.1 110.5C148.3 110.5 146 112.4 143.5 114.3C141 116.2 138.1 118.5 132.7 118.5C127.3 118.5 124.5 116.4 121.9 114.3C119.3 112.2 117 110.5 112.3 110.5V108.5C117.7 108.5 120.4 110.7 123.1 112.7C125.8 114.7 127.9 116.5 132.7 116.5C137.5 116.5 139.8 114.7 142.3 112.7C144.8 110.7 147.7 108.5 153.1 108.5C158.5 108.5 161.3 110.7 164 112.7C166.7 114.7 168.8 116.5 173.6 116.5C178.4 116.5 180.7 114.7 183.2 112.7C185.7 110.7 188.5 108.5 194 108.5C199.5 108.5 202.2 110.7 204.8 112.7C207.4 114.7 209.7 116.5 214.4 116.5V118.5Z",
        fill: "#0049B0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M214.4 129.199C209 129.199 206.2 127.099 203.6 124.999C201 122.899 198.8 121.199 194 121.199C189.2 121.199 186.9 123.099 184.4 124.999C181.9 126.899 179 129.199 173.6 129.199C168.2 129.199 165.4 127.099 162.7 124.999C160 122.899 157.9 121.199 153.1 121.199C148.3 121.199 146 123.099 143.5 124.999C141 126.899 138.1 129.199 132.7 129.199C127.3 129.199 124.5 127.099 121.9 124.999C119.3 122.899 117 121.199 112.3 121.199V119.199C117.7 119.199 120.4 121.399 123.1 123.499C125.8 125.599 127.9 127.199 132.7 127.199C137.5 127.199 139.8 125.399 142.3 123.499C144.8 121.599 147.7 119.199 153.1 119.199C158.5 119.199 161.3 121.399 164 123.499C166.7 125.599 168.8 127.199 173.6 127.199C178.4 127.199 180.7 125.399 183.2 123.499C185.7 121.599 188.5 119.199 194 119.199C199.5 119.199 202.2 121.399 204.8 123.499C207.4 125.599 209.7 127.199 214.4 127.199V129.199Z",
        fill: "#0049B0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.6001 183.3C61.0376 183.3 59.5102 182.837 58.2111 181.969C56.9119 181.101 55.8994 179.867 55.3014 178.423C54.7035 176.98 54.5471 175.391 54.8519 173.859C55.1567 172.326 55.9091 170.919 57.0139 169.814C58.1188 168.709 59.5264 167.957 61.0589 167.652C62.5913 167.347 64.1797 167.503 65.6233 168.101C67.0668 168.699 68.3006 169.712 69.1687 171.011C70.0367 172.31 70.5001 173.838 70.5001 175.4C70.5001 177.495 69.6678 179.505 68.1862 180.986C66.7047 182.468 64.6953 183.3 62.6001 183.3ZM62.6001 169.6C61.4289 169.6 60.2844 169.949 59.3121 170.602C58.3398 171.255 57.5837 172.182 57.1403 173.266C56.6968 174.35 56.586 175.541 56.8218 176.688C57.0577 177.835 57.6296 178.886 58.4648 179.707C59.3 180.528 60.3606 181.082 61.5116 181.299C62.6626 181.515 63.8519 181.384 64.9281 180.922C66.0042 180.46 66.9186 179.688 67.5547 178.705C68.1908 177.721 68.5199 176.571 68.5001 175.4C68.4738 173.853 67.8407 172.377 66.737 171.293C65.6334 170.208 64.1477 169.6 62.6001 169.6Z",
        fill: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M87.6 183.299C86.4947 183.424 85.3755 183.314 84.3157 182.976C83.2558 182.639 82.2791 182.081 81.4496 181.34C80.62 180.599 79.9563 179.691 79.5019 178.676C79.0475 177.661 78.8126 176.561 78.8126 175.449C78.8126 174.337 79.0475 173.237 79.5019 172.221C79.9563 171.206 80.62 170.298 81.4496 169.557C82.2791 168.816 83.2558 168.259 84.3157 167.921C85.3755 167.584 86.4947 167.474 87.6 167.599C88.7053 167.474 89.8245 167.584 90.8844 167.921C91.9443 168.259 92.921 168.816 93.7505 169.557C94.58 170.298 95.2437 171.206 95.6981 172.221C96.1525 173.237 96.3874 174.337 96.3874 175.449C96.3874 176.561 96.1525 177.661 95.6981 178.676C95.2437 179.691 94.58 180.599 93.7505 181.34C92.921 182.081 91.9443 182.639 90.8844 182.976C89.8245 183.314 88.7053 183.424 87.6 183.299ZM87.6 169.599C86.4289 169.599 85.2843 169.948 84.312 170.601C83.3397 171.253 82.5837 172.181 82.1402 173.265C81.6968 174.349 81.5859 175.54 81.8218 176.687C82.0577 177.834 82.6296 178.885 83.4648 179.706C84.2999 180.527 85.3605 181.081 86.5115 181.297C87.6625 181.514 88.8518 181.382 89.928 180.92C91.0042 180.459 91.9186 179.687 92.5547 178.703C93.1908 177.72 93.5199 176.57 93.5 175.399C93.4738 173.851 92.8406 172.376 91.737 171.291C90.6334 170.206 89.1476 169.599 87.6 169.599Z",
        fill: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M112.6 183.299C111.495 183.424 110.376 183.314 109.316 182.976C108.256 182.639 107.279 182.081 106.45 181.34C105.62 180.599 104.956 179.691 104.502 178.676C104.048 177.661 103.813 176.561 103.813 175.449C103.813 174.337 104.048 173.237 104.502 172.221C104.956 171.206 105.62 170.298 106.45 169.557C107.279 168.816 108.256 168.259 109.316 167.921C110.376 167.584 111.495 167.474 112.6 167.599C113.705 167.474 114.825 167.584 115.884 167.921C116.944 168.259 117.921 168.816 118.75 169.557C119.58 170.298 120.244 171.206 120.698 172.221C121.153 173.237 121.387 174.337 121.387 175.449C121.387 176.561 121.153 177.661 120.698 178.676C120.244 179.691 119.58 180.599 118.75 181.34C117.921 182.081 116.944 182.639 115.884 182.976C114.825 183.314 113.705 183.424 112.6 183.299ZM112.6 169.599C111.429 169.599 110.284 169.948 109.312 170.601C108.34 171.253 107.584 172.181 107.14 173.265C106.697 174.349 106.586 175.54 106.822 176.687C107.058 177.834 107.63 178.885 108.465 179.706C109.3 180.527 110.361 181.081 111.512 181.297C112.663 181.514 113.852 181.382 114.928 180.92C116.004 180.459 116.919 179.687 117.555 178.703C118.191 177.72 118.52 176.57 118.5 175.399C118.474 173.851 117.841 172.376 116.737 171.291C115.633 170.206 114.148 169.599 112.6 169.599Z",
        fill: "#7A869A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "activity_0_linear",
        x1: "46.18",
        y1: "213.75",
        x2: "129.04",
        y2: "130.89",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#8993A4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.17",
        stopColor: "#939DAC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.46",
        stopColor: "#B0B6C1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.83",
        stopColor: "#DDDFE3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.85",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "activity_1_linear",
        x1: "110.47",
        y1: "165.289",
        x2: "214.86",
        y2: "60.8992",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.16",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: "#0059E0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.36",
        stopColor: "#0060F1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.48",
        stopColor: "#0064FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.62",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.67",
        stopColor: "#0568FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.72",
        stopColor: "#1572FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.79",
        stopColor: "#2E82FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.86",
        stopColor: "#5198FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.93",
        stopColor: "#7EB4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "activity_2_linear",
        x1: "31.6601",
        y1: "97.8397",
        x2: "109.03",
        y2: "20.4697",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.16",
        stopColor: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.21",
        stopColor: "#FF9E1B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.49",
        stopColor: "#FFBA07"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.66",
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.81",
        stopColor: "#FFD340"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.94",
        stopColor: "#FFDF6E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#FFE380"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "activity_0_clip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.900024 0.599609H245.8V231.2H0.900024V0.599609Z",
        fill: "white"
    }))));
var $8f5111c88e11f83e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8f5111c88e11f83e$var$EmptyIllustration);

});

parcelRegister("hnFsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8b56b97a81f8db$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1b8b56b97a81f8db$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    today: {
        "id": "business-summary.summary-view.activity-feed.today",
        "defaultMessage": "Today"
    },
    yesterday: {
        "id": "business-summary.summary-view.activity-feed.yesterday",
        "defaultMessage": "Yesterday"
    },
    title: {
        "id": "business-summary.summary-view.activity-feed.title",
        "defaultMessage": "Recent activity"
    },
    description: {
        "id": "business-summary.summary-view.activity-feed.description",
        "defaultMessage": "Stay up to date with what's happening across the project. "
    },
    descriptionWhenEmpty: {
        "id": "business-summary.summary-view.activity-feed.description-when-empty",
        "defaultMessage": "Create a few items and invite teammates to your project to see your project activity."
    }
});

});

parcelRegister("kGo2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d1138ecc187798$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $b0d1138ecc187798$var$Skeleton = ({ className: className, testId: testId })=>{
    const skeletonColor = `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 476 296",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "476",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "16",
        width: "320",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "4",
        y: "70",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "60",
        width: "420",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "80",
        width: "420",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "100",
        width: "93",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "4",
        y: "162",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "152",
        width: "420",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "172",
        width: "420",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "192",
        width: "93",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "4",
        y: "254",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "244",
        width: "420",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "264",
        width: "420",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "52",
        y: "284",
        width: "93",
        height: "12",
        rx: "6",
        fill: skeletonColor
    }));
};
var $b0d1138ecc187798$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b0d1138ecc187798$var$Skeleton);

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("jSzWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7542d87aed909c75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2JyHi = parcelRequire("2JyHi");

var $2dbu3 = parcelRequire("2dbu3");

var $fbiaz = parcelRequire("fbiaz");

var $5vRmQ = parcelRequire("5vRmQ");

var $63e1b = parcelRequire("63e1b");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $apShl = parcelRequire("apShl");

var $a2EFr = parcelRequire("a2EFr");

var $izUon = parcelRequire("izUon");

var $jTuwe = parcelRequire("jTuwe");

var $6cwrM = parcelRequire("6cwrM");

var $bWbSz = parcelRequire("bWbSz");

var $cGyoW = parcelRequire("cGyoW");

var $8AIRh = parcelRequire("8AIRh");

var $6mTfs = parcelRequire("6mTfs");

var $4a4D1 = parcelRequire("4a4D1");

var $zfROv = parcelRequire("zfROv");
$5vRmQ.use([
    (0, $2dbu3.install),
    (0, $fbiaz.install),
    (0, $63e1b.install)
]);
const $7542d87aed909c75$var$CHART_OPTIONS = {
    renderer: 'svg'
};
const $7542d87aed909c75$var$BreakdownByPriority = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, loading: loading } = (0, $cGyoW.useIssuesByPriority)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const { hasCreateItem: hasCreateItem, linksTarget: linksTarget, urlBuilder: urlBuilder } = (0, $bWbSz.useSummaryFeatures)();
    const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, $6cwrM.useSectionAnalytics)(position, 'breakdownByPriority');
    const sendClickAnalytics = (0, $eUqFw.useCallback)((count)=>{
        fireSectionAnalytics('viewWithFilter', {
            count: count
        });
    }, [
        fireSectionAnalytics
    ]);
    const chartData = (0, $eUqFw.useMemo)(()=>(0, $4a4D1.buildChartData)(data, formatMessage, urlBuilder), [
        urlBuilder,
        data,
        formatMessage
    ]);
    const chartEvents = (0, $eUqFw.useMemo)(()=>({
            click: ({ dataIndex: dataIndex, value: value })=>{
                if (chartData != null) {
                    // dataIndex can be thought of as the index of each bar on the chart.
                    if (linksTarget === '_self') push(chartData.filterUrls[dataIndex]);
                    else window.open(chartData.filterUrls[dataIndex], '_blank');
                    sendClickAnalytics(value);
                }
            }
        }), [
        chartData,
        sendClickAnalytics,
        push,
        linksTarget
    ]);
    let content = null;
    if (!loading && chartData != null) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mTfs.Description), null, chartData.totalCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $8AIRh.default).descriptionWhenEmpty), hasCreateItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTuwe.default), {
        href: `${urlBuilder('breakdownByPriority')}?inlineCreate=true`,
        onClick: ()=>fireSectionAnalytics('view', {
                inlineCreate: true
            }),
        target: linksTarget
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        message: formatMessage((0, $8AIRh.default).description, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2EFr.default), {
                    href: `${urlBuilder('breakdownByPriority')}?direction=DESC&sortBy=priority`,
                    target: linksTarget,
                    onClick: ()=>fireSectionAnalytics('view', {
                            inlineCreate: false
                        })
                }, children)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2JyHi))), {
        echarts: $5vRmQ,
        option: chartData.option,
        opts: $7542d87aed909c75$var$CHART_OPTIONS,
        onEvents: chartEvents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zfROv.default), {
        points: chartData.xAxisPoints,
        onClick: sendClickAnalytics
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "breakdown-by-priority"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mTfs.StyledSkeleton), {
        testId: "business-summary.ui.summary-view.breakdown-by-priority.skeleton"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-breakdown-by-priority"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.default), {
        title: formatMessage((0, $8AIRh.default).title),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.breakdown-by-priority",
        onPointerEnter: startHoverTimer,
        onPointerLeave: stopHoverTimer
    }, content));
};
var $7542d87aed909c75$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($7542d87aed909c75$var$BreakdownByPriority);

});
parcelRegister("2JyHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $1fdab2e1e227f900$var$react_1 = (0, $fKE23.__importStar)((parcelRequire("eUqFw")));

var $eUpRa = parcelRequire("eUpRa");

var $11Oi5 = parcelRequire("11Oi5");

var $ayOoE = parcelRequire("ayOoE");

var $5joMY = parcelRequire("5joMY");

var $6fivB = parcelRequire("6fivB");
/**
 * core component for echarts binding
 */ var $1fdab2e1e227f900$var$EChartsReactCore = /** @class */ function(_super) {
    (0, $fKE23.__extends)(EChartsReactCore, _super);
    function EChartsReactCore(props) {
        var _this = _super.call(this, props) || this;
        _this.echarts = props.echarts;
        _this.ele = null;
        _this.isInitialResize = true;
        return _this;
    }
    EChartsReactCore.prototype.componentDidMount = function() {
        this.renderNewEcharts();
    };
    // update
    EChartsReactCore.prototype.componentDidUpdate = function(prevProps) {
        /**
         * if shouldSetOption return false, then return, not update echarts options
         * default is true
         */ var shouldSetOption = this.props.shouldSetOption;
        if ((0, $ayOoE.isFunction)(shouldSetOption) && !shouldSetOption(prevProps, this.props)) return;
        // 以下属性修改的时候，需要 dispose 之后再新建
        // 1. 切换 theme 的时候
        // 2. 修改 opts 的时候
        // 3. 修改 onEvents 的时候，这样可以取消所有之前绑定的事件 issue #151
        if (!(0, $6fivB.isEqual)(prevProps.theme, this.props.theme) || !(0, $6fivB.isEqual)(prevProps.opts, this.props.opts) || !(0, $6fivB.isEqual)(prevProps.onEvents, this.props.onEvents)) {
            this.dispose();
            this.renderNewEcharts(); // 重建
            return;
        }
        // when these props are not isEqual, update echarts
        var pickKeys = [
            'option',
            'notMerge',
            'lazyUpdate',
            'showLoading',
            'loadingOption'
        ];
        if (!(0, $6fivB.isEqual)((0, $11Oi5.pick)(this.props, pickKeys), (0, $11Oi5.pick)(prevProps, pickKeys))) this.updateEChartsOption();
        /**
         * when style or class name updated, change size.
         */ if (!(0, $6fivB.isEqual)(prevProps.style, this.props.style) || !(0, $6fivB.isEqual)(prevProps.className, this.props.className)) this.resize();
    };
    EChartsReactCore.prototype.componentWillUnmount = function() {
        this.dispose();
    };
    /**
     * return the echart object
     * 1. if exist, return the existed instance
     * 2. or new one instance
     */ EChartsReactCore.prototype.getEchartsInstance = function() {
        return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
    };
    /**
     * dispose echarts and clear size-sensor
     */ EChartsReactCore.prototype.dispose = function() {
        if (this.ele) {
            try {
                (0, $eUpRa.clear)(this.ele);
            } catch (e) {
                console.warn(e);
            }
            // dispose echarts instance
            this.echarts.dispose(this.ele);
        }
    };
    /**
     * render a new echarts instance
     */ EChartsReactCore.prototype.renderNewEcharts = function() {
        var _this = this;
        var _a = this.props, onEvents = _a.onEvents, onChartReady = _a.onChartReady;
        // 1. new echarts instance
        var echartsInstance = this.updateEChartsOption();
        // 2. bind events
        this.bindEvents(echartsInstance, onEvents || {});
        // 3. on chart ready
        if ((0, $ayOoE.isFunction)(onChartReady)) onChartReady(echartsInstance);
        // 4. on resize
        if (this.ele) (0, $eUpRa.bind)(this.ele, function() {
            _this.resize();
        });
    };
    // bind the events
    EChartsReactCore.prototype.bindEvents = function(instance, events) {
        function _bindEvent(eventName, func) {
            // ignore the event config which not satisfy
            if ((0, $5joMY.isString)(eventName) && (0, $ayOoE.isFunction)(func)) // binding event
            instance.on(eventName, function(param) {
                func(param, instance);
            });
        }
        // loop and bind
        for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
    };
    /**
     * render the echarts
     */ EChartsReactCore.prototype.updateEChartsOption = function() {
        var _a = this.props, option = _a.option, _b = _a.notMerge, notMerge = _b === void 0 ? false : _b, _c = _a.lazyUpdate, lazyUpdate = _c === void 0 ? false : _c, showLoading = _a.showLoading, _d = _a.loadingOption, loadingOption = _d === void 0 ? null : _d;
        // 1. get or initial the echarts object
        var echartInstance = this.getEchartsInstance();
        // 2. set the echarts option
        echartInstance.setOption(option, notMerge, lazyUpdate);
        // 3. set loading mask
        if (showLoading) echartInstance.showLoading(loadingOption);
        else echartInstance.hideLoading();
        return echartInstance;
    };
    /**
     * resize wrapper
     */ EChartsReactCore.prototype.resize = function() {
        // 1. get the echarts object
        var echartsInstance = this.getEchartsInstance();
        // 2. call echarts instance resize if not the initial resize
        // resize should not happen on first render as it will cancel initial echarts animations
        if (!this.isInitialResize) try {
            echartsInstance.resize();
        } catch (e) {
            console.warn(e);
        }
        // 3. update variable for future calls
        this.isInitialResize = false;
    };
    EChartsReactCore.prototype.render = function() {
        var _this = this;
        var _a = this.props, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
        // default height = 300
        var newStyle = (0, $fKE23.__assign)({
            height: 300
        }, style);
        return $1fdab2e1e227f900$var$react_1.default.createElement("div", {
            ref: function(e) {
                _this.ele = e;
            },
            style: newStyle,
            className: "echarts-for-react " + className
        });
    };
    return EChartsReactCore;
}($1fdab2e1e227f900$var$react_1.PureComponent);
module.exports.default = $1fdab2e1e227f900$var$EChartsReactCore;

});
parcelRegister("eUpRa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ver = module.exports.clear = module.exports.bind = void 0;

var $IT7qM = parcelRequire("IT7qM");
/**
 * Created by hustcc on 18/6/9.[高考时间]
 * Contract: i@hust.cc
 */ /**
 * bind an element with resize callback function
 * @param {*} element
 * @param {*} cb
 */ var $adaa5a3ed1b746ee$var$bind = function bind(element, cb) {
    var sensor = (0, $IT7qM.getSensor)(element); // listen with callback
    sensor.bind(cb); // return unbind function
    return function() {
        sensor.unbind(cb);
    };
};
/**
 * clear all the listener and sensor of an element
 * @param element
 */ module.exports.bind = $adaa5a3ed1b746ee$var$bind;
var $adaa5a3ed1b746ee$var$clear = function clear(element) {
    var sensor = (0, $IT7qM.getSensor)(element);
    (0, $IT7qM.removeSensor)(sensor);
};
module.exports.clear = $adaa5a3ed1b746ee$var$clear;
var $adaa5a3ed1b746ee$var$ver = "1.0.1";
module.exports.ver = $adaa5a3ed1b746ee$var$ver;

});
parcelRegister("IT7qM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeSensor = module.exports.getSensor = void 0;

var $086edda1bd856c9f$var$_id = $086edda1bd856c9f$var$_interopRequireDefault((parcelRequire("kEStO")));

var $ef2F5 = parcelRequire("ef2F5");

var $4S1UF = parcelRequire("4S1UF");
function $086edda1bd856c9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ /**
 * all the sensor objects.
 * sensor pool
 */ var $086edda1bd856c9f$var$Sensors = {};
/**
 * get one sensor
 * @param element
 * @returns {*}
 */ var $086edda1bd856c9f$var$getSensor = function getSensor(element) {
    var sensorId = element.getAttribute($4S1UF.SizeSensorId); // 1. if the sensor exists, then use it
    if (sensorId && $086edda1bd856c9f$var$Sensors[sensorId]) return $086edda1bd856c9f$var$Sensors[sensorId];
     // 2. not exist, then create one
    var newId = (0, $086edda1bd856c9f$var$_id["default"])();
    element.setAttribute($4S1UF.SizeSensorId, newId);
    var sensor = (0, $ef2F5.createSensor)(element); // add sensor into pool
    $086edda1bd856c9f$var$Sensors[newId] = sensor;
    return sensor;
};
/**
 * 移除 sensor
 * @param sensor
 */ module.exports.getSensor = $086edda1bd856c9f$var$getSensor;
var $086edda1bd856c9f$var$removeSensor = function removeSensor(sensor) {
    var sensorId = sensor.element.getAttribute($4S1UF.SizeSensorId); // remove attribute
    sensor.element.removeAttribute($4S1UF.SizeSensorId); // remove event, dom of the sensor used
    sensor.destroy(); // exist, then remove from pool
    if (sensorId && $086edda1bd856c9f$var$Sensors[sensorId]) delete $086edda1bd856c9f$var$Sensors[sensorId];
};
module.exports.removeSensor = $086edda1bd856c9f$var$removeSensor;

});
parcelRegister("kEStO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $f0a1cda51de6078c$var$id = 1;
/**
 * generate unique id in application
 * @return {string}
 */ var $f0a1cda51de6078c$var$_default = function _default() {
    return "".concat($f0a1cda51de6078c$var$id++);
};
module.exports["default"] = $f0a1cda51de6078c$var$_default;

});

parcelRegister("ef2F5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $ez7Ma = parcelRequire("ez7Ma");

var $9i5xi = parcelRequire("9i5xi");
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ /**
 * sensor strategies
 */ // export const createSensor = createObjectSensor;
var $a5e487f26edb520a$var$createSensor = typeof ResizeObserver !== 'undefined' ? $9i5xi.createSensor : $ez7Ma.createSensor;
module.exports.createSensor = $a5e487f26edb520a$var$createSensor;

});
parcelRegister("ez7Ma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $a9aa5dae3a4fed45$var$_debounce = $a9aa5dae3a4fed45$var$_interopRequireDefault((parcelRequire("41C6E")));

var $4S1UF = parcelRequire("4S1UF");
function $a9aa5dae3a4fed45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $a9aa5dae3a4fed45$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * create object DOM of sensor
   * @returns {HTMLObjectElement}
   */ var newSensor = function newSensor() {
        // adjust style
        if (getComputedStyle(element).position === 'static') element.style.position = 'relative';
        var obj = document.createElement('object');
        obj.onload = function() {
            obj.contentDocument.defaultView.addEventListener('resize', resizeListener); // 直接触发一次 resize
            resizeListener();
        };
        obj.style.display = 'block';
        obj.style.position = 'absolute';
        obj.style.top = '0';
        obj.style.left = '0';
        obj.style.height = '100%';
        obj.style.width = '100%';
        obj.style.overflow = 'hidden';
        obj.style.pointerEvents = 'none';
        obj.style.zIndex = '-1';
        obj.style.opacity = '0';
        obj.setAttribute('class', $4S1UF.SensorClassName);
        obj.setAttribute('tabindex', $4S1UF.SensorTabIndex);
        obj.type = 'text/html'; // append into dom
        element.appendChild(obj); // for ie, should set data attribute delay, or will be white screen
        obj.data = 'about:blank';
        return obj;
    };
    /**
   * trigger listeners
   */ var resizeListener = (0, $a9aa5dae3a4fed45$var$_debounce["default"])(function() {
        // trigger all listener
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * listen with one callback function
   * @param cb
   */ var bind = function bind(cb) {
        // if not exist sensor, then create one
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy all
   */ var destroy = function destroy() {
        if (sensor && sensor.parentNode) {
            if (sensor.contentDocument) // remote event
            sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
             // remove dom
            sensor.parentNode.removeChild(sensor); // initial variable
            sensor = undefined;
            listeners = [];
        }
    };
    /**
   * cancel listener bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $a9aa5dae3a4fed45$var$createSensor;

});
parcelRegister("41C6E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $2ee4d0893728450c$var$_default = function _default(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
    var timer = null;
    return function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, delay);
    };
};
module.exports["default"] = $2ee4d0893728450c$var$_default;

});

parcelRegister("4S1UF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SensorTabIndex = module.exports.SensorClassName = module.exports.SizeSensorId = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $38bdb0710e4d1feb$var$SizeSensorId = 'size-sensor-id';
module.exports.SizeSensorId = $38bdb0710e4d1feb$var$SizeSensorId;
var $38bdb0710e4d1feb$var$SensorClassName = 'size-sensor-object';
module.exports.SensorClassName = $38bdb0710e4d1feb$var$SensorClassName;
var $38bdb0710e4d1feb$var$SensorTabIndex = '-1';
module.exports.SensorTabIndex = $38bdb0710e4d1feb$var$SensorTabIndex;

});


parcelRegister("9i5xi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $6c3a16dc23f0575f$var$_debounce = $6c3a16dc23f0575f$var$_interopRequireDefault((parcelRequire("41C6E")));
function $6c3a16dc23f0575f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ var $6c3a16dc23f0575f$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * trigger listeners
   */ var resizeListener = (0, $6c3a16dc23f0575f$var$_debounce["default"])(function() {
        // trigger all
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * create ResizeObserver sensor
   * @returns
   */ var newSensor = function newSensor() {
        var s = new ResizeObserver(resizeListener); // listen element
        s.observe(element); // trigger once
        resizeListener();
        return s;
    };
    /**
   * listen with callback
   * @param cb
   */ var bind = function bind(cb) {
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy
   */ var destroy = function destroy() {
        sensor.disconnect();
        listeners = [];
        sensor = undefined;
    };
    /**
   * cancel bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $6c3a16dc23f0575f$var$createSensor;

});




parcelRegister("11Oi5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pick = void 0;
/**
 * 保留 object 中的部分内容
 * @param obj
 * @param keys
 */ function $0bfce51b76d9ff5d$var$pick(obj, keys) {
    var r = {};
    keys.forEach(function(key) {
        r[key] = obj[key];
    });
    return r;
}
module.exports.pick = $0bfce51b76d9ff5d$var$pick;

});

parcelRegister("ayOoE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFunction = void 0;
function $7b042c163e4bbffb$var$isFunction(v) {
    return typeof v === 'function';
}
module.exports.isFunction = $7b042c163e4bbffb$var$isFunction;

});

parcelRegister("5joMY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isString = void 0;
function $3de1f4aa7ad186c9$var$isString(v) {
    return typeof v === 'string';
}
module.exports.isString = $3de1f4aa7ad186c9$var$isString;

});

parcelRegister("6fivB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEqual = void 0;

var $fKE23 = parcelRequire("fKE23");

var $48c28041ff9688c4$var$fast_deep_equal_1 = (0, $fKE23.__importDefault)((parcelRequire("aG7FO")));
module.exports.isEqual = $48c28041ff9688c4$var$fast_deep_equal_1.default;

});
parcelRegister("aG7FO", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});



parcelRegister("2dbu3", function(module, exports) {

$parcel$export(module.exports, "install", () => $19c5b41da25eadef$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $hMtFz = parcelRequire("hMtFz");

var $d1Jiw = parcelRequire("d1Jiw");

var $gKps2 = parcelRequire("gKps2");

var $78h3O = parcelRequire("78h3O");
function $19c5b41da25eadef$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $78h3O.default));
    registers.registerSeriesModel((0, $gKps2.default));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $hzBt5.curry((0, $hMtFz.layout), 'bar')); // Use higher prority to avoid to be blocked by other overall layout, which do not
    // only exist in this module, but probably also exist in other modules, like `barPolar`.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $hMtFz.largeLayout)); // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $d1Jiw.default)('bar'));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

});
parcelRegister("hzBt5", function(module, exports) {

$parcel$export(module.exports, "$override", () => $ccb2c4ef73c7c1d9$export$d35a04b83ea6803e);
$parcel$export(module.exports, "guid", () => $ccb2c4ef73c7c1d9$export$46e8f25c7328f77e);
$parcel$export(module.exports, "logError", () => $ccb2c4ef73c7c1d9$export$58da9968c3170cb1);
$parcel$export(module.exports, "clone", () => $ccb2c4ef73c7c1d9$export$9cd59f9826255e47);
$parcel$export(module.exports, "isPrimitive", () => $ccb2c4ef73c7c1d9$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isDom", () => $ccb2c4ef73c7c1d9$export$9f57505b7bd8dae);
$parcel$export(module.exports, "merge", () => $ccb2c4ef73c7c1d9$export$4950aa0f605343fb);
$parcel$export(module.exports, "isObject", () => $ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isArray", () => $ccb2c4ef73c7c1d9$export$43bee75e5e14138e);
$parcel$export(module.exports, "isBuiltInObject", () => $ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f);
$parcel$export(module.exports, "mergeAll", () => $ccb2c4ef73c7c1d9$export$18aef43295bbe906);
$parcel$export(module.exports, "extend", () => $ccb2c4ef73c7c1d9$export$8b58be045bf06082);
$parcel$export(module.exports, "defaults", () => $ccb2c4ef73c7c1d9$export$ebe90cb607ad99e);
$parcel$export(module.exports, "keys", () => $ccb2c4ef73c7c1d9$export$ed97f33186d4b816);
$parcel$export(module.exports, "createCanvas", () => $ccb2c4ef73c7c1d9$export$cd3d1f114b139967);
$parcel$export(module.exports, "indexOf", () => $ccb2c4ef73c7c1d9$export$305f7d4e9d4624f2);
$parcel$export(module.exports, "inherits", () => $ccb2c4ef73c7c1d9$export$69f1b2dcda23c5f8);
$parcel$export(module.exports, "mixin", () => $ccb2c4ef73c7c1d9$export$e36fc9d62a853069);
$parcel$export(module.exports, "isArrayLike", () => $ccb2c4ef73c7c1d9$export$1e2f57719e155213);
$parcel$export(module.exports, "each", () => $ccb2c4ef73c7c1d9$export$79b2f7037acddd43);
$parcel$export(module.exports, "map", () => $ccb2c4ef73c7c1d9$export$871de8747c9eaa88);
$parcel$export(module.exports, "slice", () => $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f);
$parcel$export(module.exports, "reduce", () => $ccb2c4ef73c7c1d9$export$533b26079ad0b4b);
$parcel$export(module.exports, "filter", () => $ccb2c4ef73c7c1d9$export$3dea766d36a8935f);
$parcel$export(module.exports, "find", () => $ccb2c4ef73c7c1d9$export$71aa6c912b956294);
$parcel$export(module.exports, "bind", () => $ccb2c4ef73c7c1d9$export$2385a24977818dd0);
$parcel$export(module.exports, "isFunction", () => $ccb2c4ef73c7c1d9$export$f6e2535fb5126e54);
$parcel$export(module.exports, "curry", () => $ccb2c4ef73c7c1d9$export$c3095a23b368d1f2);
$parcel$export(module.exports, "isString", () => $ccb2c4ef73c7c1d9$export$844ec244b1367d54);
$parcel$export(module.exports, "isStringSafe", () => $ccb2c4ef73c7c1d9$export$29d0bb2a4e07b252);
$parcel$export(module.exports, "isNumber", () => $ccb2c4ef73c7c1d9$export$7e4aa119212bc614);
$parcel$export(module.exports, "isTypedArray", () => $ccb2c4ef73c7c1d9$export$b119cc7e1840e59c);
$parcel$export(module.exports, "isGradientObject", () => $ccb2c4ef73c7c1d9$export$fa2c283003ed971c);
$parcel$export(module.exports, "isImagePatternObject", () => $ccb2c4ef73c7c1d9$export$a49bbf3a55dcef7b);
$parcel$export(module.exports, "isRegExp", () => $ccb2c4ef73c7c1d9$export$49841c62b9eff15);
$parcel$export(module.exports, "eqNaN", () => $ccb2c4ef73c7c1d9$export$7d667b9a0c48c975);
$parcel$export(module.exports, "retrieve", () => $ccb2c4ef73c7c1d9$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "retrieve2", () => $ccb2c4ef73c7c1d9$export$995e01f2f5c9d030);
$parcel$export(module.exports, "retrieve3", () => $ccb2c4ef73c7c1d9$export$2e94551289abb95b);
$parcel$export(module.exports, "normalizeCssArray", () => $ccb2c4ef73c7c1d9$export$f3a38102c49f4268);
$parcel$export(module.exports, "assert", () => $ccb2c4ef73c7c1d9$export$a7a9523472993e97);
$parcel$export(module.exports, "trim", () => $ccb2c4ef73c7c1d9$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "setAsPrimitive", () => $ccb2c4ef73c7c1d9$export$112e66431016387b);
$parcel$export(module.exports, "HashMap", () => $ccb2c4ef73c7c1d9$export$60ef0b43d585640a);
$parcel$export(module.exports, "createHashMap", () => $ccb2c4ef73c7c1d9$export$55f8aa7ef875b0a4);
$parcel$export(module.exports, "concatArray", () => $ccb2c4ef73c7c1d9$export$4fd8af2c48c43416);
$parcel$export(module.exports, "createObject", () => $ccb2c4ef73c7c1d9$export$79c7e160a7743efd);
$parcel$export(module.exports, "hasOwn", () => $ccb2c4ef73c7c1d9$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "noop", () => $ccb2c4ef73c7c1d9$export$8793edee2d425525);
var $ccb2c4ef73c7c1d9$var$BUILTIN_OBJECT = {
    '[object Function]': true,
    '[object RegExp]': true,
    '[object Date]': true,
    '[object Error]': true,
    '[object CanvasGradient]': true,
    '[object CanvasPattern]': true,
    '[object Image]': true,
    '[object Canvas]': true
};
var $ccb2c4ef73c7c1d9$var$TYPED_ARRAY = {
    '[object Int8Array]': true,
    '[object Uint8Array]': true,
    '[object Uint8ClampedArray]': true,
    '[object Int16Array]': true,
    '[object Uint16Array]': true,
    '[object Int32Array]': true,
    '[object Uint32Array]': true,
    '[object Float32Array]': true,
    '[object Float64Array]': true
};
var $ccb2c4ef73c7c1d9$var$objToString = Object.prototype.toString;
var $ccb2c4ef73c7c1d9$var$arrayProto = Array.prototype;
var $ccb2c4ef73c7c1d9$var$nativeForEach = $ccb2c4ef73c7c1d9$var$arrayProto.forEach;
var $ccb2c4ef73c7c1d9$var$nativeFilter = $ccb2c4ef73c7c1d9$var$arrayProto.filter;
var $ccb2c4ef73c7c1d9$var$nativeSlice = $ccb2c4ef73c7c1d9$var$arrayProto.slice;
var $ccb2c4ef73c7c1d9$var$nativeMap = $ccb2c4ef73c7c1d9$var$arrayProto.map;
var $ccb2c4ef73c7c1d9$var$ctorFunction = (function() {}).constructor;
var $ccb2c4ef73c7c1d9$var$protoFunction = $ccb2c4ef73c7c1d9$var$ctorFunction ? $ccb2c4ef73c7c1d9$var$ctorFunction.prototype : null;
var $ccb2c4ef73c7c1d9$var$protoKey = '__proto__';
var $ccb2c4ef73c7c1d9$var$methods = {};
function $ccb2c4ef73c7c1d9$export$d35a04b83ea6803e(name, fn) {
    $ccb2c4ef73c7c1d9$var$methods[name] = fn;
}
var $ccb2c4ef73c7c1d9$var$idStart = 0x0907;
function $ccb2c4ef73c7c1d9$export$46e8f25c7328f77e() {
    return $ccb2c4ef73c7c1d9$var$idStart++;
}
function $ccb2c4ef73c7c1d9$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $ccb2c4ef73c7c1d9$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[i]);
        }
    } else if ($ccb2c4ef73c7c1d9$var$TYPED_ARRAY[typeStr]) {
        if (!$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[i]);
            }
        }
    } else if (!$ccb2c4ef73c7c1d9$var$BUILTIN_OBJECT[typeStr] && !$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(source) && !$ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $ccb2c4ef73c7c1d9$var$protoKey) result[key] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $ccb2c4ef73c7c1d9$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(source) || !$ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(target)) return overwrite ? $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $ccb2c4ef73c7c1d9$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(sourceProp) && $ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(targetProp) && !$ccb2c4ef73c7c1d9$export$43bee75e5e14138e(sourceProp) && !$ccb2c4ef73c7c1d9$export$43bee75e5e14138e(targetProp) && !$ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(sourceProp) && !$ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(targetProp) && !$ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f(sourceProp) && !$ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f(targetProp) && !$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(sourceProp) && !$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(targetProp)) $ccb2c4ef73c7c1d9$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $ccb2c4ef73c7c1d9$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $ccb2c4ef73c7c1d9$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $ccb2c4ef73c7c1d9$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $ccb2c4ef73c7c1d9$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $ccb2c4ef73c7c1d9$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $ccb2c4ef73c7c1d9$export$ed97f33186d4b816(source);
    for(var i = 0; i < keysArr.length; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $ccb2c4ef73c7c1d9$export$cd3d1f114b139967 = function() {
    return $ccb2c4ef73c7c1d9$var$methods.createCanvas();
};
$ccb2c4ef73c7c1d9$var$methods.createCanvas = function() {
    return document.createElement('canvas');
};
function $ccb2c4ef73c7c1d9$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $ccb2c4ef73c7c1d9$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $ccb2c4ef73c7c1d9$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $ccb2c4ef73c7c1d9$export$ebe90cb607ad99e(target, source, override);
}
function $ccb2c4ef73c7c1d9$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $ccb2c4ef73c7c1d9$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $ccb2c4ef73c7c1d9$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $ccb2c4ef73c7c1d9$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $ccb2c4ef73c7c1d9$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $ccb2c4ef73c7c1d9$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $ccb2c4ef73c7c1d9$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $ccb2c4ef73c7c1d9$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $ccb2c4ef73c7c1d9$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $ccb2c4ef73c7c1d9$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $ccb2c4ef73c7c1d9$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($ccb2c4ef73c7c1d9$var$nativeSlice.call(arguments)));
    };
}
var $ccb2c4ef73c7c1d9$export$2385a24977818dd0 = $ccb2c4ef73c7c1d9$var$protoFunction && $ccb2c4ef73c7c1d9$export$f6e2535fb5126e54($ccb2c4ef73c7c1d9$var$protoFunction.bind) ? $ccb2c4ef73c7c1d9$var$protoFunction.call.bind($ccb2c4ef73c7c1d9$var$protoFunction.bind) : $ccb2c4ef73c7c1d9$var$bindPolyfill;
function $ccb2c4ef73c7c1d9$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($ccb2c4ef73c7c1d9$var$nativeSlice.call(arguments)));
    };
}
function $ccb2c4ef73c7c1d9$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $ccb2c4ef73c7c1d9$var$objToString.call(value) === '[object Array]';
}
function $ccb2c4ef73c7c1d9$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $ccb2c4ef73c7c1d9$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $ccb2c4ef73c7c1d9$export$29d0bb2a4e07b252(value) {
    return $ccb2c4ef73c7c1d9$var$objToString.call(value) === '[object String]';
}
function $ccb2c4ef73c7c1d9$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f(value) {
    return !!$ccb2c4ef73c7c1d9$var$BUILTIN_OBJECT[$ccb2c4ef73c7c1d9$var$objToString.call(value)];
}
function $ccb2c4ef73c7c1d9$export$b119cc7e1840e59c(value) {
    return !!$ccb2c4ef73c7c1d9$var$TYPED_ARRAY[$ccb2c4ef73c7c1d9$var$objToString.call(value)];
}
function $ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $ccb2c4ef73c7c1d9$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $ccb2c4ef73c7c1d9$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $ccb2c4ef73c7c1d9$export$49841c62b9eff15(value) {
    return $ccb2c4ef73c7c1d9$var$objToString.call(value) === '[object RegExp]';
}
function $ccb2c4ef73c7c1d9$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $ccb2c4ef73c7c1d9$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $ccb2c4ef73c7c1d9$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $ccb2c4ef73c7c1d9$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $ccb2c4ef73c7c1d9$var$nativeSlice.apply(arr, args);
}
function $ccb2c4ef73c7c1d9$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $ccb2c4ef73c7c1d9$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $ccb2c4ef73c7c1d9$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $ccb2c4ef73c7c1d9$var$primitiveKey = '__ec_primitive__';
function $ccb2c4ef73c7c1d9$export$112e66431016387b(obj) {
    obj[$ccb2c4ef73c7c1d9$var$primitiveKey] = true;
}
function $ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(obj) {
    return obj[$ccb2c4ef73c7c1d9$var$primitiveKey];
}
var $ccb2c4ef73c7c1d9$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        this.data = {};
        var isArr = $ccb2c4ef73c7c1d9$export$43bee75e5e14138e(obj);
        this.data = {};
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $ccb2c4ef73c7c1d9$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.get = function(key) {
        return this.data.hasOwnProperty(key) ? this.data[key] : null;
    };
    HashMap.prototype.set = function(key, value) {
        return this.data[key] = value;
    };
    HashMap.prototype.each = function(cb, context) {
        for(var key in this.data)if (this.data.hasOwnProperty(key)) cb.call(context, this.data[key], key);
    };
    HashMap.prototype.keys = function() {
        return $ccb2c4ef73c7c1d9$export$ed97f33186d4b816(this.data);
    };
    HashMap.prototype.removeKey = function(key) {
        delete this.data[key];
    };
    return HashMap;
}();
function $ccb2c4ef73c7c1d9$export$55f8aa7ef875b0a4(obj) {
    return new $ccb2c4ef73c7c1d9$export$60ef0b43d585640a(obj);
}
function $ccb2c4ef73c7c1d9$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $ccb2c4ef73c7c1d9$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $ccb2c4ef73c7c1d9$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $ccb2c4ef73c7c1d9$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $ccb2c4ef73c7c1d9$export$8793edee2d425525() {}

});

parcelRegister("hMtFz", function(module, exports) {

$parcel$export(module.exports, "getLayoutOnAxis", () => $cf1def1f853d8378$export$658df087977b9e84);
$parcel$export(module.exports, "prepareLayoutBarSeries", () => $cf1def1f853d8378$export$efbd0c3f5ab0d5e4);
$parcel$export(module.exports, "makeColumnLayout", () => $cf1def1f853d8378$export$20769dafc84e0299);
$parcel$export(module.exports, "retrieveColumnLayout", () => $cf1def1f853d8378$export$35920bb6556da1c2);
$parcel$export(module.exports, "layout", () => $cf1def1f853d8378$export$b3219800bda33a1f);
$parcel$export(module.exports, "largeLayout", () => $cf1def1f853d8378$export$1fcd87ee6628f095);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $lljDt = parcelRequire("lljDt");

var $xPMeE = parcelRequire("xPMeE");
var $cf1def1f853d8378$var$STACK_PREFIX = '__ec_stack_';
var $cf1def1f853d8378$var$LARGE_BAR_MIN_WIDTH = 0.5;
var $cf1def1f853d8378$var$LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
function $cf1def1f853d8378$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $cf1def1f853d8378$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $cf1def1f853d8378$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $cf1def1f853d8378$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push($hzBt5.defaults({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $cf1def1f853d8378$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $cf1def1f853d8378$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$cf1def1f853d8378$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $cf1def1f853d8378$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($cf1def1f853d8378$var$isOnCartesian(seriesModel) && !$cf1def1f853d8378$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $cf1def1f853d8378$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    $hzBt5.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
             // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            } // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $cf1def1f853d8378$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $cf1def1f853d8378$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    $hzBt5.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $5BQXp.parsePercent)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $5BQXp.parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $5BQXp.parsePercent)(// the auto-calculated bar width might be less than 1.
        seriesModel.get('barMinWidth') || 1, bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $cf1def1f853d8378$var$getAxisKey(baseAxis),
            stackId: $cf1def1f853d8378$var$getSeriesStackId(seriesModel)
        });
    });
    return $cf1def1f853d8378$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $cf1def1f853d8378$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    $hzBt5.each(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: '20%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        }; // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $hzBt5.each(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = $hzBt5.keys(stacks).length; // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $5BQXp.parsePercent)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $5BQXp.parsePercent)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
        $hzBt5.each(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                 // `minWidth` has higher priority. `minWidth` decide that wheter the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Becuase barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                 // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        }); // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $hzBt5.each(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $hzBt5.each(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $cf1def1f853d8378$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$cf1def1f853d8378$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$cf1def1f853d8378$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $cf1def1f853d8378$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $cf1def1f853d8378$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $cf1def1f853d8378$export$20769dafc84e0299(seriesModels);
    var lastStackCoords = {};
    $hzBt5.each(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $cf1def1f853d8378$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$cf1def1f853d8378$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var barMinHeight = seriesModel.get('barMinHeight') || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $lljDt.isDimensionStacked)(data, valueDim);
        var isValueAxisH = valueAxis.isHorizontal();
        var valueAxisStart = $cf1def1f853d8378$var$getValueAxisStart(baseAxis, valueAxis, stacked);
        var store = data.getStore();
        var valueDimIdx = data.getDimensionIndex(valueDim);
        var baseDimIdx = data.getDimensionIndex(baseDim);
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var value = store.get(valueDimIdx, idx);
            var baseValue = store.get(baseDimIdx, idx);
            var sign = value >= 0 ? 'p' : 'n';
            var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            if (stacked) {
                // Only ordinal axis can be stacked.
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                 // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;
            if (isValueAxisH) {
                var coord = cartesian.dataToPoint([
                    value,
                    baseValue
                ]);
                x = baseCoord;
                y = coord[1] + columnOffset;
                width = coord[0] - valueAxisStart;
                height = columnWidth;
                if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
            } else {
                var coord = cartesian.dataToPoint([
                    baseValue,
                    value
                ]);
                x = coord[0] + columnOffset;
                y = baseCoord;
                width = columnWidth;
                height = coord[1] - valueAxisStart;
                if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                height = (height <= 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
            }
            data.setItemLayout(idx, {
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
    });
} // TODO: Do not support stack in large mode yet.
var $cf1def1f853d8378$export$1fcd87ee6628f095 = {
    seriesType: 'bar',
    plan: (0, $xPMeE.default)(),
    reset: function(seriesModel) {
        if (!$cf1def1f853d8378$var$isOnCartesian(seriesModel) || !$cf1def1f853d8378$var$isInLargeMode(seriesModel)) return;
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var coordLayout = cartesian.master.getRect();
        var baseAxis = cartesian.getBaseAxis();
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var valueDimI = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
        var baseDimI = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var valueAxisHorizontal = valueAxis.isHorizontal();
        var valueDimIdx = valueAxisHorizontal ? 0 : 1;
        var barWidth = $cf1def1f853d8378$export$35920bb6556da1c2($cf1def1f853d8378$export$20769dafc84e0299([
            seriesModel
        ]), baseAxis, seriesModel).width;
        if (!(barWidth > $cf1def1f853d8378$var$LARGE_BAR_MIN_WIDTH)) // jshint ignore:line
        barWidth = $cf1def1f853d8378$var$LARGE_BAR_MIN_WIDTH;
        return {
            progress: function(params, data) {
                var count = params.count;
                var largePoints = new $cf1def1f853d8378$var$LargeArr(count * 2);
                var largeBackgroundPoints = new $cf1def1f853d8378$var$LargeArr(count * 2);
                var largeDataIndices = new $cf1def1f853d8378$var$LargeArr(count);
                var dataIndex;
                var coord = [];
                var valuePair = [];
                var pointsOffset = 0;
                var idxOffset = 0;
                var store = data.getStore();
                while((dataIndex = params.next()) != null){
                    valuePair[valueDimIdx] = store.get(valueDimI, dataIndex);
                    valuePair[1 - valueDimIdx] = store.get(baseDimI, dataIndex);
                    coord = cartesian.dataToPoint(valuePair, null); // Data index might not be in order, depends on `progressiveChunkMode`.
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                    largePoints[pointsOffset++] = coord[0];
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                    largePoints[pointsOffset++] = coord[1];
                    largeDataIndices[idxOffset++] = dataIndex;
                }
                data.setLayout({
                    largePoints: largePoints,
                    largeDataIndices: largeDataIndices,
                    largeBackgroundPoints: largeBackgroundPoints,
                    barWidth: barWidth,
                    valueAxisStart: $cf1def1f853d8378$var$getValueAxisStart(baseAxis, valueAxis, false),
                    backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                    valueAxisHorizontal: valueAxisHorizontal
                });
            }
        };
    }
};
function $cf1def1f853d8378$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $cf1def1f853d8378$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $cf1def1f853d8378$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

});
parcelRegister("5BQXp", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => $41597ca18f9f4bbd$export$d3f68fbaa670562);
$parcel$export(module.exports, "parsePercent", () => $41597ca18f9f4bbd$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "round", () => $41597ca18f9f4bbd$export$2077e0241d6afd3c);
$parcel$export(module.exports, "asc", () => $41597ca18f9f4bbd$export$debe6e778e0a6d32);
$parcel$export(module.exports, "getPrecision", () => $41597ca18f9f4bbd$export$e0c74b50bbd10f68);
$parcel$export(module.exports, "getPrecisionSafe", () => $41597ca18f9f4bbd$export$6d86ba4ca4984d31);
$parcel$export(module.exports, "getPixelPrecision", () => $41597ca18f9f4bbd$export$666260d9a2dda8a7);
$parcel$export(module.exports, "getPercentWithPrecision", () => $41597ca18f9f4bbd$export$70cc11b075afeb90);
$parcel$export(module.exports, "addSafe", () => $41597ca18f9f4bbd$export$d3389a301c3a5706);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => $41597ca18f9f4bbd$export$18510406f204a1b9);
$parcel$export(module.exports, "remRadian", () => $41597ca18f9f4bbd$export$2ca6dd70a288b1c3);
$parcel$export(module.exports, "isRadianAroundZero", () => $41597ca18f9f4bbd$export$d1df570aea2868f);
$parcel$export(module.exports, "parseDate", () => $41597ca18f9f4bbd$export$6b862160d295c8e);
$parcel$export(module.exports, "quantity", () => $41597ca18f9f4bbd$export$82dd68b83a44b253);
$parcel$export(module.exports, "quantityExponent", () => $41597ca18f9f4bbd$export$97256a17b20a0c24);
$parcel$export(module.exports, "nice", () => $41597ca18f9f4bbd$export$7a695fe44258210b);
$parcel$export(module.exports, "quantile", () => $41597ca18f9f4bbd$export$651fb4afdb6caa4b);
$parcel$export(module.exports, "reformIntervals", () => $41597ca18f9f4bbd$export$12f7386070bc380a);
$parcel$export(module.exports, "numericToNumber", () => $41597ca18f9f4bbd$export$8b4007b942b45a96);
$parcel$export(module.exports, "isNumeric", () => $41597ca18f9f4bbd$export$e90fb89750dba83f);
$parcel$export(module.exports, "getRandomIdBase", () => $41597ca18f9f4bbd$export$474d2ec9aa44a22);
$parcel$export(module.exports, "getLeastCommonMultiple", () => $41597ca18f9f4bbd$export$680a45b749323f49);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $41597ca18f9f4bbd$var$RADIAN_EPSILON = 1e-4; // Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $41597ca18f9f4bbd$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $41597ca18f9f4bbd$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
function $41597ca18f9f4bbd$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
     // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $41597ca18f9f4bbd$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case 'center':
        case 'middle':
            percent = '50%';
            break;
        case 'left':
        case 'top':
            percent = '0%';
            break;
        case 'right':
        case 'bottom':
            percent = '100%';
            break;
    }
    if (typeof percent === 'string') {
        if ($41597ca18f9f4bbd$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $41597ca18f9f4bbd$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
     // Avoid range error
    precision = Math.min(Math.max(0, precision), $41597ca18f9f4bbd$var$ROUND_SUPPORTED_PRECISION_MAX); // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $41597ca18f9f4bbd$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $41597ca18f9f4bbd$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
     // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $41597ca18f9f4bbd$export$6d86ba4ca4984d31(val);
}
function $41597ca18f9f4bbd$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase(); // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $41597ca18f9f4bbd$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $41597ca18f9f4bbd$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var sum = $hzBt5.reduce(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return 0;
    var digits = Math.pow(10, precision);
    var votesPerQuota = $hzBt5.map(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $hzBt5.map(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $hzBt5.reduce(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $hzBt5.map(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    }); // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
         // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return seats[idx] / digits;
}
function $41597ca18f9f4bbd$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($41597ca18f9f4bbd$export$e0c74b50bbd10f68(val0), $41597ca18f9f4bbd$export$e0c74b50bbd10f68(val1)); // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1; // // PENDING: support more?
    return maxPrecision > $41597ca18f9f4bbd$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $41597ca18f9f4bbd$export$2077e0241d6afd3c(sum, maxPrecision);
} // Number.MAX_SAFE_INTEGER, ie do not support.
var $41597ca18f9f4bbd$export$18510406f204a1b9 = 9007199254740991;
function $41597ca18f9f4bbd$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $41597ca18f9f4bbd$export$d1df570aea2868f(val) {
    return val > -$41597ca18f9f4bbd$var$RADIAN_EPSILON && val < $41597ca18f9f4bbd$var$RADIAN_EPSILON;
} // eslint-disable-next-line
var $41597ca18f9f4bbd$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $41597ca18f9f4bbd$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if (typeof value === 'string') {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $41597ca18f9f4bbd$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
         // Use local time when no timezone offset specifed.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $41597ca18f9f4bbd$export$82dd68b83a44b253(val) {
    return Math.pow(10, $41597ca18f9f4bbd$export$97256a17b20a0c24(val));
}
function $41597ca18f9f4bbd$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $41597ca18f9f4bbd$export$7a695fe44258210b(val, round) {
    var exponent = $41597ca18f9f4bbd$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $41597ca18f9f4bbd$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $41597ca18f9f4bbd$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $41597ca18f9f4bbd$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || typeof val !== 'string' || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $41597ca18f9f4bbd$export$e90fb89750dba83f(val) {
    return !isNaN($41597ca18f9f4bbd$export$8b4007b942b45a96(val));
}
function $41597ca18f9f4bbd$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $41597ca18f9f4bbd$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $41597ca18f9f4bbd$export$a368fd580c0d0fe4(b, a % b);
}
function $41597ca18f9f4bbd$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $41597ca18f9f4bbd$export$a368fd580c0d0fe4(a, b);
}

});

parcelRegister("lljDt", function(module, exports) {

$parcel$export(module.exports, "enableDataStack", () => $f89aca61ae1a2e7b$export$f2165f9e8499b278);
$parcel$export(module.exports, "isDimensionStacked", () => $f89aca61ae1a2e7b$export$1dedc39359ae35c);
$parcel$export(module.exports, "getStackedDimension", () => $f89aca61ae1a2e7b$export$909db2be4938fbdf);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $kJQdt = parcelRequire("kJQdt");
function $f89aca61ae1a2e7b$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($f89aca61ae1a2e7b$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    } // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $hzBt5.each)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $hzBt5.isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
             // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
     // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id; // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $hzBt5.each)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $f89aca61ae1a2e7b$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $kJQdt.isSeriesDataSchema)(dimensionsInput.schema);
}
function $f89aca61ae1a2e7b$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $f89aca61ae1a2e7b$export$909db2be4938fbdf(data, targetDim) {
    return $f89aca61ae1a2e7b$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

});
parcelRegister("kJQdt", function(module, exports) {

$parcel$export(module.exports, "SeriesDataSchema", () => $f19083ac152d0db4$export$a1ef064685775f3e);
$parcel$export(module.exports, "ensureSourceDimNameMap", () => $f19083ac152d0db4$export$be39ae17310c33f7);
$parcel$export(module.exports, "shouldOmitUnusedDimensions", () => $f19083ac152d0db4$export$238b87930d825d87);
$parcel$export(module.exports, "isSeriesDataSchema", () => $f19083ac152d0db4$export$fafbc856132a3a0e);
$parcel$export(module.exports, "createDimNameMap", () => $f19083ac152d0db4$export$a477f5bebfd07944);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $8AzOm = parcelRequire("8AzOm");
var $f19083ac152d0db4$var$inner = (0, $ckizb.makeInner)();
var $f19083ac152d0db4$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $f19083ac152d0db4$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $f19083ac152d0db4$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $hzBt5.retrieve2)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $8AzOm.shouldRetrieveDataByName)(this.source);
        var makeHashStrict = !$f19083ac152d0db4$export$238b87930d825d87(dimCount); // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            }); // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Becuase in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null // For data stack, we have make sure each series has its own dim on this store.
             && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict // Use escape character '`' in case that property name contains '$'.
             ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') // For better performance, when there are large dimensions, tolerant this defects that hardly meet.
             : property;
            dimHash += '$';
            dimHash += $f19083ac152d0db4$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        } // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++; // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $f19083ac152d0db4$export$fafbc856132a3a0e(schema) {
    return schema instanceof $f19083ac152d0db4$export$a1ef064685775f3e;
}
function $f19083ac152d0db4$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $hzBt5.createHashMap)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $hzBt5.isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $f19083ac152d0db4$export$be39ae17310c33f7(source) {
    var innerSource = $f19083ac152d0db4$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $f19083ac152d0db4$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $f19083ac152d0db4$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}

});
parcelRegister("ckizb", function(module, exports) {

$parcel$export(module.exports, "normalizeToArray", () => $8f95c1371be5a40a$export$4f07b212a02c8051);
$parcel$export(module.exports, "defaultEmphasis", () => $8f95c1371be5a40a$export$abdcc6a26372f94b);
$parcel$export(module.exports, "TEXT_STYLE_OPTIONS", () => $8f95c1371be5a40a$export$df45610347a602ad);
$parcel$export(module.exports, "getDataItemValue", () => $8f95c1371be5a40a$export$2c944e12edb48d4b);
$parcel$export(module.exports, "isDataItemOption", () => $8f95c1371be5a40a$export$3e1a543f33ef6883);
$parcel$export(module.exports, "mappingToExists", () => $8f95c1371be5a40a$export$574f818966e4da87);
$parcel$export(module.exports, "isComponentIdInternal", () => $8f95c1371be5a40a$export$feece3e7d52a102b);
$parcel$export(module.exports, "convertOptionIdName", () => $8f95c1371be5a40a$export$fb1a222ba5dd6e51);
$parcel$export(module.exports, "isNameSpecified", () => $8f95c1371be5a40a$export$beae19a2652b3368);
$parcel$export(module.exports, "makeInternalComponentId", () => $8f95c1371be5a40a$export$1753133c42e665e8);
$parcel$export(module.exports, "setComponentTypeToKeyInfo", () => $8f95c1371be5a40a$export$5ac61aca2ba0282d);
$parcel$export(module.exports, "compressBatches", () => $8f95c1371be5a40a$export$6d12cabb0c9bf8e3);
$parcel$export(module.exports, "queryDataIndex", () => $8f95c1371be5a40a$export$42b26cae8b8d10);
$parcel$export(module.exports, "makeInner", () => $8f95c1371be5a40a$export$64df9f8d92ae083f);
$parcel$export(module.exports, "parseFinder", () => $8f95c1371be5a40a$export$95de80076abac814);
$parcel$export(module.exports, "preParseFinder", () => $8f95c1371be5a40a$export$fe600815775d9400);
$parcel$export(module.exports, "queryReferringComponents", () => $8f95c1371be5a40a$export$dc741340f7e5f186);
$parcel$export(module.exports, "SINGLE_REFERRING", () => $8f95c1371be5a40a$export$f076738ec84e693c);
$parcel$export(module.exports, "MULTIPLE_REFERRING", () => $8f95c1371be5a40a$export$48d598924ce4892c);
$parcel$export(module.exports, "setAttribute", () => $8f95c1371be5a40a$export$9fec4d97f1922e0b);
$parcel$export(module.exports, "getAttribute", () => $8f95c1371be5a40a$export$735ee1799fd02602);
$parcel$export(module.exports, "getTooltipRenderMode", () => $8f95c1371be5a40a$export$cc0a17a5d27b4e17);
$parcel$export(module.exports, "groupData", () => $8f95c1371be5a40a$export$7ab5bda43e13168f);
$parcel$export(module.exports, "interpolateRawValues", () => $8f95c1371be5a40a$export$bd0439821a1869f3);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $5BQXp = parcelRequire("5BQXp");

var $fyp5g = parcelRequire("fyp5g");

/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $8f95c1371be5a40a$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $8f95c1371be5a40a$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $8f95c1371be5a40a$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $8f95c1371be5a40a$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $8f95c1371be5a40a$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
]; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
function $8f95c1371be5a40a$export$2c944e12edb48d4b(dataItem) {
    return (0, $hzBt5.isObject)(dataItem) && !(0, $hzBt5.isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $8f95c1371be5a40a$export$3e1a543f33ef6883(dataItem) {
    return (0, $hzBt5.isObject)(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $8f95c1371be5a40a$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $hzBt5.createHashMap)(); // Validate id and name on user input option.
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $hzBt5.isObject)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $8f95c1371be5a40a$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $8f95c1371be5a40a$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $8f95c1371be5a40a$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $8f95c1371be5a40a$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $8f95c1371be5a40a$var$mappingInReplaceAllMode(result, newCmptOptions);
    $8f95c1371be5a40a$var$makeIdAndName(result); // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will ommit those items and result in incorrect result.
    return result;
}
function $8f95c1371be5a40a$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
     // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be ommited.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index]; // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
         // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $8f95c1371be5a40a$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $8f95c1371be5a40a$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $8f95c1371be5a40a$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $hzBt5.assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption; // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $8f95c1371be5a40a$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$8f95c1371be5a40a$export$feece3e7d52a102b(cmptOption) && !$8f95c1371be5a40a$export$feece3e7d52a102b(existing) && $8f95c1371be5a40a$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $8f95c1371be5a40a$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
         // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while((resultItem = result[nextIdx]) && // after mapping performed, model will always be assigned with an id if user not given.
        // After that all models have id.
        // (2) If new option has id, it can only set to a hole or append to the last. It should
        // not be merged to the existings with different id. Because id should not be overwritten.
        // (3) Name can be overwritten, because axis use name as 'show label text'.
        (resultItem.newOption || $8f95c1371be5a40a$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$8f95c1371be5a40a$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $8f95c1371be5a40a$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that compoennt index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $8f95c1371be5a40a$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $hzBt5.createHashMap)();
    (0, $hzBt5.each)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $hzBt5.each)(mapResult, function(item) {
        var opt = item.newOption; // Force ensure id not duplicated.
        (0, $hzBt5.assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    }); // Make name and id.
    (0, $hzBt5.each)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $hzBt5.isObject)(opt)) return;
         // name can be overwitten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $8f95c1371be5a40a$var$makeComparableKey(opt.name) : existing ? existing.name // Avoid diffferent series has the same name,
         : $8f95c1371be5a40a$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $8f95c1371be5a40a$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $8f95c1371be5a40a$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $8f95c1371be5a40a$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $8f95c1371be5a40a$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $8f95c1371be5a40a$export$fb1a222ba5dd6e51(obj2[attr], null); // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $8f95c1371be5a40a$var$makeComparableKey(val) {
    return $8f95c1371be5a40a$export$fb1a222ba5dd6e51(val, '');
}
function $8f95c1371be5a40a$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    var type = typeof idOrName;
    return type === 'string' ? idOrName : type === 'number' || (0, $hzBt5.isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
}
function $8f95c1371be5a40a$var$warnInvalidateIdOrName(idOrName) {}
function $8f95c1371be5a40a$var$isValidIdOrName(idOrName) {
    return (0, $hzBt5.isStringSafe)(idOrName) || (0, $5BQXp.isNumeric)(idOrName);
}
function $8f95c1371be5a40a$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($8f95c1371be5a40a$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $8f95c1371be5a40a$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $8f95c1371be5a40a$var$makeComparableKey(cmptOption.id).indexOf($8f95c1371be5a40a$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $8f95c1371be5a40a$export$1753133c42e665e8(idSuffix) {
    return $8f95c1371be5a40a$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $8f95c1371be5a40a$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $hzBt5.each)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $hzBt5.isObject)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $8f95c1371be5a40a$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $8f95c1371be5a40a$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
     : componentModelCtor.determineSubType(mainType, newCmptOption); // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $8f95c1371be5a40a$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $8f95c1371be5a40a$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $8f95c1371be5a40a$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $8f95c1371be5a40a$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $hzBt5.isArray)(payload.dataIndex) ? (0, $hzBt5.map)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $hzBt5.isArray)(payload.name) ? (0, $hzBt5.map)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $8f95c1371be5a40a$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $8f95c1371be5a40a$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $8f95c1371be5a40a$var$innerUniqueIndex = (0, $5BQXp.getRandomIdBase)();
function $8f95c1371be5a40a$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $8f95c1371be5a40a$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $8f95c1371be5a40a$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $8f95c1371be5a40a$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $hzBt5.isString)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $hzBt5.createHashMap)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $hzBt5.each)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $hzBt5.indexOf)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $8f95c1371be5a40a$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $8f95c1371be5a40a$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $8f95c1371be5a40a$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $8f95c1371be5a40a$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        (0, $hzBt5.assert)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    } // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        (0, $hzBt5.assert)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $8f95c1371be5a40a$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $8f95c1371be5a40a$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $8f95c1371be5a40a$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $gZXYp.default).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $8f95c1371be5a40a$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $hzBt5.createHashMap)();
    var keys = [];
    (0, $hzBt5.each)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $8f95c1371be5a40a$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if (typeof targetValue === 'number') {
        var value = (0, $fyp5g.interpolateNumber)(sourceValue || 0, targetValue, percent);
        return (0, $5BQXp.round)(value, isAutoPrecision ? Math.max((0, $5BQXp.getPrecision)(sourceValue || 0), (0, $5BQXp.getPrecision)(targetValue)) : precision);
    } else if (typeof targetValue === 'string') return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i); // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = (0, $fyp5g.interpolateNumber)(leftVal, rightVal, percent);
                interpolated[i] = (0, $5BQXp.round)(value, isAutoPrecision ? Math.max((0, $5BQXp.getPrecision)(leftVal), (0, $5BQXp.getPrecision)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}

});
parcelRegister("gZXYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c600dd4dc583a2a4$export$2e2bcd8739ae039);
var $c600dd4dc583a2a4$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $c600dd4dc583a2a4$var$Env = function() {
    function Env() {
        this.browser = new $c600dd4dc583a2a4$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.canvasSupported = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
    }
    return Env;
}();
var $c600dd4dc583a2a4$var$env = new $c600dd4dc583a2a4$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $c600dd4dc583a2a4$var$env.wxa = true;
    $c600dd4dc583a2a4$var$env.canvasSupported = true;
    $c600dd4dc583a2a4$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
    $c600dd4dc583a2a4$var$env.worker = true;
    $c600dd4dc583a2a4$var$env.canvasSupported = true;
} else if (typeof navigator === 'undefined') {
    $c600dd4dc583a2a4$var$env.node = true;
    $c600dd4dc583a2a4$var$env.canvasSupported = true;
    $c600dd4dc583a2a4$var$env.svgSupported = true;
} else $c600dd4dc583a2a4$var$detect(navigator.userAgent, $c600dd4dc583a2a4$var$env);
function $c600dd4dc583a2a4$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.canvasSupported = !!document.createElement('canvas').getContext;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $c600dd4dc583a2a4$export$2e2bcd8739ae039 = $c600dd4dc583a2a4$var$env;

});

parcelRegister("fyp5g", function(module, exports) {

$parcel$export(module.exports, "interpolateNumber", () => $b52d7d2323499a1c$export$d871d53bd7eeb390);
$parcel$export(module.exports, "cloneValue", () => $b52d7d2323499a1c$export$c5e92b7f105af84e);
$parcel$export(module.exports, "default", () => $b52d7d2323499a1c$export$2e2bcd8739ae039);

var $aU7WT = parcelRequire("aU7WT");

var $f7lrR = parcelRequire("f7lrR");

var $hzBt5 = parcelRequire("hzBt5");
var $b52d7d2323499a1c$var$arraySlice = Array.prototype.slice;
function $b52d7d2323499a1c$export$d871d53bd7eeb390(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $b52d7d2323499a1c$export$35d34bc0ed591a92(p0, p1, percent) {
    return percent > 0.5 ? p1 : p0;
}
function $b52d7d2323499a1c$export$f8938d924b05a6eb(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $b52d7d2323499a1c$export$d871d53bd7eeb390(p0[i], p1[i], percent);
}
function $b52d7d2323499a1c$export$3297a85eaaa37024(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $b52d7d2323499a1c$export$d871d53bd7eeb390(p0[i][j], p1[i][j], percent);
    }
}
function $b52d7d2323499a1c$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $b52d7d2323499a1c$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $b52d7d2323499a1c$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $b52d7d2323499a1c$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $b52d7d2323499a1c$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $b52d7d2323499a1c$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $b52d7d2323499a1c$var$catmullRomInterpolate1DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $b52d7d2323499a1c$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
}
function $b52d7d2323499a1c$var$catmullRomInterpolate2DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    var len2 = p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[1] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $b52d7d2323499a1c$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
    }
}
function $b52d7d2323499a1c$export$c5e92b7f105af84e(value) {
    if ((0, $hzBt5.isArrayLike)(value)) {
        var len = value.length;
        if ((0, $hzBt5.isArrayLike)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($b52d7d2323499a1c$var$arraySlice.call(value[i]));
            return ret;
        }
        return $b52d7d2323499a1c$var$arraySlice.call(value);
    }
    return value;
}
function $b52d7d2323499a1c$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]);
    rgba[1] = Math.floor(rgba[1]);
    rgba[2] = Math.floor(rgba[2]);
    return 'rgba(' + rgba.join(',') + ')';
}
function $b52d7d2323499a1c$var$guessArrayDim(value) {
    return (0, $hzBt5.isArrayLike)(value && value[0]) ? 2 : 1;
}
var $b52d7d2323499a1c$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $b52d7d2323499a1c$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.maxTime = 0;
        this.arrDim = 0;
        this.interpolable = true;
        this._needsSort = false;
        this._isAllValueEqual = true;
        this._lastFrame = 0;
        this._lastFramePercent = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return !this._isAllValueEqual && this.keyframes.length >= 2 && this.interpolable && this.maxTime > 0;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, value) {
        if (time >= this.maxTime) this.maxTime = time;
        else this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        if (this.interpolable) {
            if ((0, $hzBt5.isArrayLike)(value)) {
                var arrayDim = $b52d7d2323499a1c$var$guessArrayDim(value);
                if (len > 0 && this.arrDim !== arrayDim) {
                    this.interpolable = false;
                    return;
                }
                if (arrayDim === 1 && typeof value[0] !== 'number' || arrayDim === 2 && typeof value[0][0] !== 'number') {
                    this.interpolable = false;
                    return;
                }
                if (len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this._isAllValueEqual) {
                        if (arrayDim === 1) {
                            if (!$b52d7d2323499a1c$var$is1DArraySame(value, lastFrame.value)) this._isAllValueEqual = false;
                        } else this._isAllValueEqual = false;
                    }
                }
                this.arrDim = arrayDim;
            } else {
                if (this.arrDim > 0) {
                    this.interpolable = false;
                    return;
                }
                if (typeof value === 'string') {
                    var colorArray = $f7lrR.parse(value);
                    if (colorArray) {
                        value = colorArray;
                        this.isValueColor = true;
                    } else this.interpolable = false;
                } else if (typeof value !== 'number' || isNaN(value)) {
                    this.interpolable = false;
                    return;
                }
                if (this._isAllValueEqual && len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this.isValueColor && !$b52d7d2323499a1c$var$is1DArraySame(lastFrame.value, value)) this._isAllValueEqual = false;
                    else if (lastFrame.value !== value) this._isAllValueEqual = false;
                }
            }
        }
        var kf = {
            time: time,
            value: value,
            percent: 0
        };
        this.keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var arrDim = this.arrDim;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        for(var i = 0; i < kfsLen; i++){
            kfs[i].percent = kfs[i].time / this.maxTime;
            if (arrDim > 0 && i !== kfsLen - 1) $b52d7d2323499a1c$var$fillArray(kfs[i].value, lastKf.value, arrDim);
        }
        if (additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && arrDim === additiveTrack.arrDim && this.isValueColor === additiveTrack.isValueColor && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (arrDim === 0) {
                    if (this.isValueColor) kfs[i].additiveValue = $b52d7d2323499a1c$var$add1DArray([], kfs[i].value, startValue, -1);
                    else kfs[i].additiveValue = kfs[i].value - startValue;
                } else if (arrDim === 1) kfs[i].additiveValue = $b52d7d2323499a1c$var$add1DArray([], kfs[i].value, startValue, -1);
                else if (arrDim === 2) kfs[i].additiveValue = $b52d7d2323499a1c$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var keyframes = this.keyframes;
        var kfsNum = this.keyframes.length;
        var propName = this.propName;
        var arrDim = this.arrDim;
        var isValueColor = this.isValueColor;
        var frameIdx;
        if (percent < 0) frameIdx = 0;
        else if (percent < this._lastFramePercent) {
            var start = Math.min(this._lastFrame + 1, kfsNum - 1);
            for(frameIdx = start; frameIdx >= 0; frameIdx--){
                if (keyframes[frameIdx].percent <= percent) break;
            }
            frameIdx = Math.min(frameIdx, kfsNum - 2);
        } else {
            for(frameIdx = this._lastFrame; frameIdx < kfsNum; frameIdx++){
                if (keyframes[frameIdx].percent > percent) break;
            }
            frameIdx = Math.min(frameIdx - 1, kfsNum - 2);
        }
        var nextFrame = keyframes[frameIdx + 1];
        var frame = keyframes[frameIdx];
        if (!(frame && nextFrame)) return;
        this._lastFrame = frameIdx;
        this._lastFramePercent = percent;
        var range = nextFrame.percent - frame.percent;
        if (range === 0) return;
        var w = (percent - frame.percent) / range;
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $b52d7d2323499a1c$var$tmpRgba : target[propName];
        if ((arrDim > 0 || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.useSpline) {
            var p1 = keyframes[frameIdx][valueKey];
            var p0 = keyframes[frameIdx === 0 ? frameIdx : frameIdx - 1][valueKey];
            var p2 = keyframes[frameIdx > kfsNum - 2 ? kfsNum - 1 : frameIdx + 1][valueKey];
            var p3 = keyframes[frameIdx > kfsNum - 3 ? kfsNum - 1 : frameIdx + 2][valueKey];
            if (arrDim > 0) arrDim === 1 ? $b52d7d2323499a1c$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w) : $b52d7d2323499a1c$var$catmullRomInterpolate2DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
            else if (isValueColor) {
                $b52d7d2323499a1c$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                if (!isAdditive) target[propName] = $b52d7d2323499a1c$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = p2;
                else value = $b52d7d2323499a1c$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        } else {
            if (arrDim > 0) arrDim === 1 ? $b52d7d2323499a1c$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w) : $b52d7d2323499a1c$export$3297a85eaaa37024(targetArr, frame[valueKey], nextFrame[valueKey], w);
            else if (isValueColor) {
                $b52d7d2323499a1c$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w);
                if (!isAdditive) target[propName] = $b52d7d2323499a1c$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = $b52d7d2323499a1c$export$35d34bc0ed591a92(frame[valueKey], nextFrame[valueKey], w);
                else value = $b52d7d2323499a1c$export$d871d53bd7eeb390(frame[valueKey], nextFrame[valueKey], w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var arrDim = this.arrDim;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (arrDim === 0) {
            if (this.isValueColor) {
                $f7lrR.parse(target[propName], $b52d7d2323499a1c$var$tmpRgba);
                $b52d7d2323499a1c$var$add1DArray($b52d7d2323499a1c$var$tmpRgba, $b52d7d2323499a1c$var$tmpRgba, additiveValue, 1);
                target[propName] = $b52d7d2323499a1c$var$rgba2String($b52d7d2323499a1c$var$tmpRgba);
            } else target[propName] = target[propName] + additiveValue;
        } else if (arrDim === 1) $b52d7d2323499a1c$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (arrDim === 2) $b52d7d2323499a1c$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $b52d7d2323499a1c$var$Animator = function() {
    function Animator(target, loop, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._delay = 0;
        this._maxTime = 0;
        this._paused = false;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $hzBt5.logError)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
    }
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props) {
        return this.whenWithKeys(time, props, (0, $hzBt5.keys)(props));
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $b52d7d2323499a1c$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var lastFinalKf = additiveTrack.keyframes[additiveTrack.keyframes.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.isValueColor && initialValue) initialValue = $b52d7d2323499a1c$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time !== 0) track.addKeyframe(0, $b52d7d2323499a1c$export$c5e92b7f105af84e(initialValue));
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $b52d7d2323499a1c$export$c5e92b7f105af84e(props[propName]));
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing, forceAnimate) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            track.prepare(additiveTrack);
            if (track.needsAnimate()) tracks.push(track);
            else if (!track.interpolable) {
                var lastKf = kfs[kfs.length - 1];
                if (lastKf) self._target[track.propName] = lastKf.value;
            }
        }
        if (tracks.length || forceAnimate) {
            var clip = new (0, $aU7WT.default)({
                life: this._maxTime,
                loop: this._loop,
                delay: this._delay,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing && easing !== 'spline') clip.easing = easing;
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveFinalToTarget = function(target, trackKeys) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var lastKf = kfs[kfs.length - 1];
            if (lastKf) {
                var val = $b52d7d2323499a1c$export$c5e92b7f105af84e(lastKf.value);
                if (track.isValueColor) val = $b52d7d2323499a1c$var$rgba2String(val);
                target[propName] = val;
            }
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $hzBt5.keys)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $b52d7d2323499a1c$export$2e2bcd8739ae039 = $b52d7d2323499a1c$var$Animator;

});
parcelRegister("aU7WT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f054cd398e1cf20$export$2e2bcd8739ae039);

var $ir4Gx = parcelRequire("ir4Gx");
var $7f054cd398e1cf20$var$Clip = function() {
    function Clip(opts) {
        this._initialized = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop == null ? false : opts.loop;
        this.gap = opts.gap || 0;
        this.easing = opts.easing || 'linear';
        this.onframe = opts.onframe;
        this.ondestroy = opts.ondestroy;
        this.onrestart = opts.onrestart;
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._initialized) {
            this._startTime = globalTime + this._delay;
            this._initialized = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var percent = (globalTime - this._startTime - this._pausedTime) / this._life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easing = this.easing;
        var easingFunc = typeof easing === 'string' ? (0, $ir4Gx.default)[easing] : easing;
        var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
        this.onframe && this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                this._restart(globalTime);
                this.onrestart && this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype._restart = function(globalTime) {
        var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
        this._startTime = globalTime - remainder + this.gap;
        this._pausedTime = 0;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    return Clip;
}();
var $7f054cd398e1cf20$export$2e2bcd8739ae039 = $7f054cd398e1cf20$var$Clip;

});
parcelRegister("ir4Gx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6be61faf3db9f54$export$2e2bcd8739ae039);
var $d6be61faf3db9f54$var$easing = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $d6be61faf3db9f54$var$easing.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $d6be61faf3db9f54$var$easing.bounceIn(k * 2) * 0.5;
        return $d6be61faf3db9f54$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $d6be61faf3db9f54$export$2e2bcd8739ae039 = $d6be61faf3db9f54$var$easing;

});


parcelRegister("f7lrR", function(module, exports) {

$parcel$export(module.exports, "parse", () => $b01825ad73760605$export$98e6a39c04603d36);
$parcel$export(module.exports, "lift", () => $b01825ad73760605$export$590e8b2c435046d9);
$parcel$export(module.exports, "stringify", () => $b01825ad73760605$export$fac44ee5b035f737);
$parcel$export(module.exports, "toHex", () => $b01825ad73760605$export$7ea66e3774a60b67);
$parcel$export(module.exports, "fastLerp", () => $b01825ad73760605$export$66cb3c0e9efc61c8);
$parcel$export(module.exports, "fastMapToColor", () => $b01825ad73760605$export$daa5a65daad5df58);
$parcel$export(module.exports, "lerp", () => $b01825ad73760605$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "mapToColor", () => $b01825ad73760605$export$296e08242b78a3ec);
$parcel$export(module.exports, "modifyHSL", () => $b01825ad73760605$export$d898ae866e27bf18);
$parcel$export(module.exports, "modifyAlpha", () => $b01825ad73760605$export$ab4754bf42583a26);
$parcel$export(module.exports, "lum", () => $b01825ad73760605$export$16c0ec21a6f9ef95);
$parcel$export(module.exports, "random", () => $b01825ad73760605$export$4385e60b38654f68);

var $lXNaK = parcelRequire("lXNaK");
var $b01825ad73760605$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $b01825ad73760605$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $b01825ad73760605$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $b01825ad73760605$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $b01825ad73760605$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $b01825ad73760605$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $b01825ad73760605$var$clampCssByte(parseInt(str, 10));
}
function $b01825ad73760605$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $b01825ad73760605$var$clampCssFloat(parseFloat(str) / 100);
    return $b01825ad73760605$var$clampCssFloat(parseFloat(str));
}
function $b01825ad73760605$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $b01825ad73760605$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $b01825ad73760605$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $b01825ad73760605$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $b01825ad73760605$var$colorCache = new (0, $lXNaK.default)(20);
var $b01825ad73760605$var$lastRemovedArr = null;
function $b01825ad73760605$var$putToCache(colorStr, rgbaArr) {
    if ($b01825ad73760605$var$lastRemovedArr) $b01825ad73760605$var$copyRgba($b01825ad73760605$var$lastRemovedArr, rgbaArr);
    $b01825ad73760605$var$lastRemovedArr = $b01825ad73760605$var$colorCache.put(colorStr, $b01825ad73760605$var$lastRemovedArr || rgbaArr.slice());
}
function $b01825ad73760605$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $b01825ad73760605$var$colorCache.get(colorStr);
    if (cached) return $b01825ad73760605$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $b01825ad73760605$var$kCSSColorTable) {
        $b01825ad73760605$var$copyRgba(rgbaArr, $b01825ad73760605$var$kCSSColorTable[str]);
        $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $b01825ad73760605$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $b01825ad73760605$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $b01825ad73760605$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $b01825ad73760605$var$parseCssFloat(params.pop());
            case 'rgb':
                if (params.length !== 3) {
                    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $b01825ad73760605$var$setRgba(rgbaArr, $b01825ad73760605$var$parseCssInt(params[0]), $b01825ad73760605$var$parseCssInt(params[1]), $b01825ad73760605$var$parseCssInt(params[2]), alpha);
                $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsla':
                if (params.length !== 4) {
                    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $b01825ad73760605$var$parseCssFloat(params[3]);
                $b01825ad73760605$var$hsla2rgba(params, rgbaArr);
                $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $b01825ad73760605$var$hsla2rgba(params, rgbaArr);
                $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $b01825ad73760605$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $b01825ad73760605$var$parseCssFloat(hsla[1]);
    var l = $b01825ad73760605$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $b01825ad73760605$var$setRgba(rgba, $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$cssHueToRgb(m1, m2, h) * 255), $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $b01825ad73760605$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $b01825ad73760605$export$590e8b2c435046d9(color, level) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $b01825ad73760605$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $b01825ad73760605$export$7ea66e3774a60b67(color) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $b01825ad73760605$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $b01825ad73760605$var$clampCssFloat($b01825ad73760605$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $b01825ad73760605$export$daa5a65daad5df58 = $b01825ad73760605$export$66cb3c0e9efc61c8;
function $b01825ad73760605$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $b01825ad73760605$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $b01825ad73760605$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $b01825ad73760605$export$fac44ee5b035f737([
        $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $b01825ad73760605$var$clampCssFloat($b01825ad73760605$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $b01825ad73760605$export$296e08242b78a3ec = $b01825ad73760605$export$3a89f8d6f6bf6c9f;
function $b01825ad73760605$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $b01825ad73760605$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $b01825ad73760605$var$clampCssAngle(h));
        s != null && (colorArr[1] = $b01825ad73760605$var$parseCssFloat(s));
        l != null && (colorArr[2] = $b01825ad73760605$var$parseCssFloat(l));
        return $b01825ad73760605$export$fac44ee5b035f737($b01825ad73760605$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $b01825ad73760605$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $b01825ad73760605$var$clampCssFloat(alpha);
        return $b01825ad73760605$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $b01825ad73760605$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $b01825ad73760605$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $b01825ad73760605$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $b01825ad73760605$export$4385e60b38654f68() {
    var r = Math.round(Math.random() * 255);
    var g = Math.round(Math.random() * 255);
    var b = Math.round(Math.random() * 255);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
}

});
parcelRegister("lXNaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd540418ef47102$export$2e2bcd8739ae039);
var $ffd540418ef47102$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $ffd540418ef47102$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $ffd540418ef47102$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $ffd540418ef47102$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $ffd540418ef47102$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $ffd540418ef47102$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $ffd540418ef47102$export$2e2bcd8739ae039 = $ffd540418ef47102$var$LRU;

});




parcelRegister("8AzOm", function(module, exports) {

$parcel$export(module.exports, "isSourceInstance", () => $640d76e96b117dfa$export$22b808bc02a60488);
$parcel$export(module.exports, "createSource", () => $640d76e96b117dfa$export$1921362e86c73c88);
$parcel$export(module.exports, "detectSourceFormat", () => $640d76e96b117dfa$export$52a469afa4653e57);
$parcel$export(module.exports, "createSourceFromSeriesDataOption", () => $640d76e96b117dfa$export$75aef3f97c0a5edf);
$parcel$export(module.exports, "cloneSourceShallow", () => $640d76e96b117dfa$export$e0365e7e3555ddd4);
$parcel$export(module.exports, "shouldRetrieveDataByName", () => $640d76e96b117dfa$export$8911336b527f8517);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8tpV4 = parcelRequire("8tpV4");

var $ckizb = parcelRequire("ckizb");

var $be33G = parcelRequire("be33G");
var $640d76e96b117dfa$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $8tpV4.SOURCE_FORMAT_UNKNOWN); // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $be33G.guessOrdinal)(this, i) === (0, $be33G.BE_ORDINAL).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $640d76e96b117dfa$export$22b808bc02a60488(val) {
    return val instanceof $640d76e96b117dfa$var$SourceImpl;
}
function $640d76e96b117dfa$export$1921362e86c73c88(sourceData, thisMetaRawOption, sourceFormat) {
    sourceFormat = sourceFormat || $640d76e96b117dfa$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $640d76e96b117dfa$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $640d76e96b117dfa$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $hzBt5.clone)(thisMetaRawOption)
    });
    return source;
}
function $640d76e96b117dfa$export$75aef3f97c0a5edf(data) {
    return new $640d76e96b117dfa$var$SourceImpl({
        data: data,
        sourceFormat: (0, $hzBt5.isTypedArray)(data) ? (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY) : (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)
    });
}
function $640d76e96b117dfa$export$e0365e7e3555ddd4(source) {
    return new $640d76e96b117dfa$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $hzBt5.clone)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $640d76e96b117dfa$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $8tpV4.SOURCE_FORMAT_UNKNOWN);
    if ((0, $hzBt5.isTypedArray)(data)) sourceFormat = (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY);
    else if ((0, $hzBt5.isArray)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $hzBt5.isArray)(item)) {
                sourceFormat = (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS);
                break;
            } else if ((0, $hzBt5.isObject)(item)) {
                sourceFormat = (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS);
                break;
            }
        }
    } else if ((0, $hzBt5.isObject)(data)) {
        for(var key in data)if ((0, $hzBt5.hasOwn)(data, key) && (0, $hzBt5.isArrayLike)(data[key])) {
            sourceFormat = (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $640d76e96b117dfa$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex; // PEDING: could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $640d76e96b117dfa$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data; // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $640d76e96b117dfa$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $hzBt5.isString)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            } // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $hzBt5.isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $640d76e96b117dfa$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $8tpV4.SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) {
        if (!dimensionsDefine) dimensionsDefine = $640d76e96b117dfa$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $hzBt5.each)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) {
        var value0 = (0, $ckizb.getDataItemValue)(data[0]);
        dimensionsDetectedCount = (0, $hzBt5.isArray)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $640d76e96b117dfa$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $640d76e96b117dfa$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) {
        var dimensions_1 = [];
        (0, $hzBt5.each)(obj, function(value, key) {
            dimensions_1.push(key);
        });
        return dimensions_1;
    }
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.
function $640d76e96b117dfa$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $hzBt5.createHashMap)();
    return (0, $hzBt5.map)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $hzBt5.isObject)(rawItem) ? rawItem : {
            name: rawItem
        }; // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        }; // User can set null in dimensions.
        // We dont auto specify name, othewise a given name may
        // cause it be refered unexpectedly.
        if (item.name == null) return item;
         // Also consider number form like 2012.
        item.name += ''; // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $640d76e96b117dfa$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $8tpV4.SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $640d76e96b117dfa$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS);
}

});
parcelRegister("8tpV4", function(module, exports) {

$parcel$export(module.exports, "VISUAL_DIMENSIONS", () => $62b52338a5a1f9d7$export$cd51b5ca77f6f0e4);
$parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", () => $62b52338a5a1f9d7$export$2823037fb9d8f0c6);
$parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", () => $62b52338a5a1f9d7$export$fcd62ebf51387903);
$parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", () => $62b52338a5a1f9d7$export$703ae8a2d83f441);
$parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", () => $62b52338a5a1f9d7$export$6a32b42c754a3cb8);
$parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", () => $62b52338a5a1f9d7$export$a918cb016a382d45);
$parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", () => $62b52338a5a1f9d7$export$c78f1330778d30d);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", () => $62b52338a5a1f9d7$export$7b3f3c6551b4949b);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", () => $62b52338a5a1f9d7$export$d55da1467cdf7804);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $62b52338a5a1f9d7$export$cd51b5ca77f6f0e4 = (0, $hzBt5.createHashMap)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'seriesName'
]);
var $62b52338a5a1f9d7$export$2823037fb9d8f0c6 = 'original';
var $62b52338a5a1f9d7$export$fcd62ebf51387903 = 'arrayRows';
var $62b52338a5a1f9d7$export$703ae8a2d83f441 = 'objectRows';
var $62b52338a5a1f9d7$export$6a32b42c754a3cb8 = 'keyedColumns';
var $62b52338a5a1f9d7$export$a918cb016a382d45 = 'typedArray';
var $62b52338a5a1f9d7$export$c78f1330778d30d = 'unknown';
var $62b52338a5a1f9d7$export$7b3f3c6551b4949b = 'column';
var $62b52338a5a1f9d7$export$d55da1467cdf7804 = 'row';

});

parcelRegister("be33G", function(module, exports) {

$parcel$export(module.exports, "BE_ORDINAL", () => $82c35fde694ebd4c$export$328749e9c5b40760);
$parcel$export(module.exports, "resetSourceDefaulter", () => $82c35fde694ebd4c$export$b30cdea50aa00e6);
$parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", () => $82c35fde694ebd4c$export$37682b8fdd2e83d);
$parcel$export(module.exports, "querySeriesUpstreamDatasetModel", () => $82c35fde694ebd4c$export$8da66f73a1eda454);
$parcel$export(module.exports, "makeSeriesEncodeForNameBased", () => $82c35fde694ebd4c$export$60b8a57d1f2fed26);
$parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", () => $82c35fde694ebd4c$export$397ba553479711e7);
$parcel$export(module.exports, "guessOrdinal", () => $82c35fde694ebd4c$export$c51adf1a2be01b9c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $8tpV4 = parcelRequire("8tpV4");
var $82c35fde694ebd4c$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $82c35fde694ebd4c$var$innerGlobalModel = (0, $ckizb.makeInner)();
function $82c35fde694ebd4c$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $82c35fde694ebd4c$var$innerGlobalModel(ecModel).datasetMap = (0, $hzBt5.createHashMap)();
}
function $82c35fde694ebd4c$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $82c35fde694ebd4c$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $82c35fde694ebd4c$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $hzBt5.each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $hzBt5.isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    }); // TODO
    // Auto detect first time axis and do arrangement.
    (0, $hzBt5.each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when mutiple series share one dimension
        // category axis, series name should better use
        // the other dimsion name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $82c35fde694ebd4c$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $82c35fde694ebd4c$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS)) (0, $hzBt5.each)(dimensionsDefine, function(dim, idx) {
        if (((0, $hzBt5.isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = []; // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $82c35fde694ebd4c$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $82c35fde694ebd4c$export$328749e9c5b40760.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $82c35fde694ebd4c$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $82c35fde694ebd4c$export$328749e9c5b40760.Not) return idxRes0;
             // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $82c35fde694ebd4c$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ]; // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
        // So we dont set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $82c35fde694ebd4c$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $ckizb.queryReferringComponents)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $ckizb.SINGLE_REFERRING)).models[0];
}
function $82c35fde694ebd4c$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by defualt reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $ckizb.queryReferringComponents)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $ckizb.SINGLE_REFERRING)).models;
}
function $82c35fde694ebd4c$export$c51adf1a2be01b9c(source, dimIndex) {
    return $82c35fde694ebd4c$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $82c35fde694ebd4c$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result; // Experience value.
    var maxLoop = 5;
    if ((0, $hzBt5.isTypedArray)(data)) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
     // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $hzBt5.isObject)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $hzBt5.isString)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $82c35fde694ebd4c$export$328749e9c5b40760.Must : $82c35fde694ebd4c$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $8tpV4.SERIES_LAYOUT_BY_ROW)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) {
        var dataObjectRows = data;
        if (!dimName) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS)) {
        var dataKeyedColumns = data;
        if (!dimName) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $hzBt5.isTypedArray)(sample)) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $ckizb.getDataItemValue)(item);
            if (!(0, $hzBt5.isArray)(val)) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $hzBt5.isString)(val); // Consider usage convenience, '1', '2' will be treated as "number".
        // `isFinit('')` get `true`.
        if (val != null && isFinite(val) && val !== '') return beStr ? $82c35fde694ebd4c$export$328749e9c5b40760.Might : $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $82c35fde694ebd4c$export$328749e9c5b40760.Must;
    }
    return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
}

});




parcelRegister("xPMeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $065b3f0378fb8022$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");
function $065b3f0378fb8022$export$2e2bcd8739ae039() {
    var inner = (0, $ckizb.makeInner)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}

});


parcelRegister("d1Jiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $97be818e11f33dce$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $97be818e11f33dce$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
         // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $97be818e11f33dce$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $97be818e11f33dce$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count(); // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio(); // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if (typeof sampling === 'string') sampler = $97be818e11f33dce$var$samplers[sampling];
                    else if (typeof sampling === 'function') sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $97be818e11f33dce$var$indexSampler));
                }
            }
        }
    };
}

});

parcelRegister("gKps2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c314af4e515d536e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $jLEqt = parcelRequire("jLEqt");

var $3OWAv = parcelRequire("3OWAv");

var $9aOrz = parcelRequire("9aOrz");
var $c314af4e515d536e$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $3OWAv.default)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get('progressiveThreshold');
        var largeThreshold = this.get('largeThreshold');
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.bar';
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $9aOrz.inheritDefaultOption)((0, $jLEqt.default).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $jLEqt.default));
var $c314af4e515d536e$export$2e2bcd8739ae039 = $c314af4e515d536e$var$BarSeriesModel;

});
parcelRegister("jLEqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e641c3d899c4d9e4$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $5vVec = parcelRequire("5vVec");

var $3OWAv = parcelRequire("3OWAv");
var $e641c3d899c4d9e4$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $3OWAv.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var pt = coordSys.dataToPoint(coordSys.clampData(value));
            var data = this.getData();
            var offset = data.getLayout('offset');
            var size = data.getLayout('size');
            var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
            pt[offsetIndex] += offset + size / 2;
            return pt;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod'
    };
    return BaseBarSeriesModel;
}((0, $5vVec.default));
(0, $5vVec.default).registerClass($e641c3d899c4d9e4$var$BaseBarSeriesModel);
var $e641c3d899c4d9e4$export$2e2bcd8739ae039 = $e641c3d899c4d9e4$var$BaseBarSeriesModel;

});
parcelRegister("5vVec", function(module, exports) {

$parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", () => $403c3d48f4c3b330$export$e960441116ae2799);
$parcel$export(module.exports, "default", () => $403c3d48f4c3b330$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $ckizb = parcelRequire("ckizb");

var $6IEE1 = parcelRequire("6IEE1");

var $b7fr8 = parcelRequire("b7fr8");

var $93uXC = parcelRequire("93uXC");

var $e4mIu = parcelRequire("e4mIu");

var $bw304 = parcelRequire("bw304");

var $jKrBG = parcelRequire("jKrBG");

var $kNy1J = parcelRequire("kNy1J");

var $4OBOS = parcelRequire("4OBOS");
var $403c3d48f4c3b330$var$inner = $ckizb.makeInner();
function $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $403c3d48f4c3b330$export$e960441116ae2799 = '__universalTransitionEnabled';
var $403c3d48f4c3b330$var$SeriesModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Becuase this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this; // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $bw304.createTask)({
            count: $403c3d48f4c3b330$var$dataTaskCount,
            reset: $403c3d48f4c3b330$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $403c3d48f4c3b330$var$inner(this).sourceManager = new (0, $kNy1J.SourceManager)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $403c3d48f4c3b330$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $403c3d48f4c3b330$var$inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $403c3d48f4c3b330$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $e4mIu.fetchLayoutMode)(this);
        var inputPositionParams = layoutMode ? (0, $e4mIu.getLayoutParams)(option) : {}; // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $6IEE1.default).hasClass(themeSubType)) themeSubType += 'Series';
        $hzBt5.merge(option, ecModel.getTheme().get(this.subType));
        $hzBt5.merge(option, this.getDefaultOption()); // Default label emphasis `show`
        $ckizb.defaultEmphasis(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $e4mIu.mergeLayoutParam)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $hzBt5.merge(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $e4mIu.fetchLayoutMode)(this);
        if (layoutMode) (0, $e4mIu.mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $403c3d48f4c3b330$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $403c3d48f4c3b330$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $403c3d48f4c3b330$var$inner(this).dataBeforeProcessed = data;
        $403c3d48f4c3b330$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$hzBt5.isTypedArray(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $ckizb.defaultEmphasis(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overriden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $403c3d48f4c3b330$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $403c3d48f4c3b330$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $403c3d48f4c3b330$var$getCurrentTask(this);
        if (task) {
            var context = task.context; // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data; // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $403c3d48f4c3b330$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $hzBt5.createHashMap(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $403c3d48f4c3b330$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $403c3d48f4c3b330$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem; // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $4OBOS.defaultSeriesFormatTooltip)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        if ((0, $gZXYp.default).node) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel; // PENDING
        var color = (0, $b7fr8.PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    }; // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var data = this.getData(dataType);
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $hzBt5.keys(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex);
        return selectedMap[nameOrId] || false;
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$403c3d48f4c3b330$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition; // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
         // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var selectedMode = this.option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'multiple') {
            var selectedMap = this.option.selectedMap || (this.option.selectedMap = {});
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i]; // TODO diffrent types of data share same object.
                var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, lastDataIndex);
            this.option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    }; // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $6IEE1.default).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle'; // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $6IEE1.default));
$hzBt5.mixin($403c3d48f4c3b330$var$SeriesModel, (0, $93uXC.DataFormatMixin));
$hzBt5.mixin($403c3d48f4c3b330$var$SeriesModel, (0, $b7fr8.PaletteMixin));
(0, $jKrBG.mountExtend)($403c3d48f4c3b330$var$SeriesModel, (0, $6IEE1.default));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $403c3d48f4c3b330$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$ckizb.isNameSpecified(seriesModel)) seriesModel.name = $403c3d48f4c3b330$var$getSeriesAutoName(seriesModel) || name;
}
function $403c3d48f4c3b330$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $hzBt5.each(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $403c3d48f4c3b330$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $403c3d48f4c3b330$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $403c3d48f4c3b330$var$dataTaskProgress;
}
function $403c3d48f4c3b330$var$dataTaskProgress(param, context) {
    // Avoid repead cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
} // TODO refactor
function $403c3d48f4c3b330$var$wrapData(data, seriesModel) {
    $hzBt5.each($hzBt5.concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $hzBt5.curry($403c3d48f4c3b330$var$onDataChange, seriesModel));
    });
}
function $403c3d48f4c3b330$var$onDataChange(seriesModel, newList) {
    var task = $403c3d48f4c3b330$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $403c3d48f4c3b330$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $403c3d48f4c3b330$export$2e2bcd8739ae039 = $403c3d48f4c3b330$var$SeriesModel;

});
parcelRegister("6IEE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e46614b9b2e23c5$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $fR3z1 = parcelRequire("fR3z1");

var $9aOrz = parcelRequire("9aOrz");

var $jKrBG = parcelRequire("jKrBG");

var $ckizb = parcelRequire("ckizb");

var $e4mIu = parcelRequire("e4mIu");
var $4e46614b9b2e23c5$var$inner = (0, $ckizb.makeInner)();
var $4e46614b9b2e23c5$var$ComponentModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $9aOrz.getUID('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $e4mIu.fetchLayoutMode(this);
        var inputPositionParams = layoutMode ? $e4mIu.getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        $hzBt5.merge(option, themeModel.get(this.mainType));
        $hzBt5.merge(option, this.getDefaultOption());
        if (layoutMode) $e4mIu.mergeLayoutParam(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $hzBt5.merge(this.option, option, true);
        var layoutMode = $e4mIu.fetchLayoutMode(this);
        if (layoutMode) $e4mIu.mergeLayoutParam(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component';
   * import {XxxModel, XxxOption} from './XxxModel';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor; // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $jKrBG.isExtendedClass)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
         // FIXME: remove this approach?
        var fields = $4e46614b9b2e23c5$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $hzBt5.merge(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $ckizb.queryReferringComponents)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get('left'),
            top: boxLayoutModel.get('top'),
            right: boxLayoutModel.get('right'),
            bottom: boxLayoutModel.get('bottom'),
            width: boxLayoutModel.get('width'),
            height: boxLayoutModel.get('height')
        };
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $fR3z1.default));
(0, $jKrBG.mountExtend)($4e46614b9b2e23c5$var$ComponentModel, (0, $fR3z1.default));
(0, $jKrBG.enableClassManagement)($4e46614b9b2e23c5$var$ComponentModel);
$9aOrz.enableSubTypeDefaulter($4e46614b9b2e23c5$var$ComponentModel);
$9aOrz.enableTopologicalTravel($4e46614b9b2e23c5$var$ComponentModel, $4e46614b9b2e23c5$var$getDependencies);
function $4e46614b9b2e23c5$var$getDependencies(componentType) {
    var deps = [];
    $hzBt5.each($4e46614b9b2e23c5$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    }); // Ensure main type.
    deps = $hzBt5.map(deps, function(type) {
        return (0, $jKrBG.parseClassType)(type).main;
    }); // Hack dataset for convenience.
    if (componentType !== 'dataset' && $hzBt5.indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $4e46614b9b2e23c5$export$2e2bcd8739ae039 = $4e46614b9b2e23c5$var$ComponentModel;

});
parcelRegister("fR3z1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ae91f82b16bb49$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gZXYp = parcelRequire("gZXYp");

var $jKrBG = parcelRequire("jKrBG");

var $jdsea = parcelRequire("jdsea");

var $2A2Wy = parcelRequire("2A2Wy");

var $5jmEk = parcelRequire("5jmEk");

var $9N9yS = parcelRequire("9N9yS");

var $hzBt5 = parcelRequire("hzBt5");
var $b8ae91f82b16bb49$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option; // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $hzBt5.merge)(this.option, option, true);
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'xxx.yyy.zzz' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * Squash option stack into one.
   * parentModel will be removed after squashed.
   *
   * NOTE: resolveParentPath will not be applied here for simplicity. DON'T use this function
   * if resolveParentPath is modified.
   *
   * @param deepMerge If do deep merge. Default to be false.
   */ // squash(
    //     deepMerge?: boolean,
    //     handleCallback?: (func: () => object) => object
    // ) {
    //     const optionStack = [];
    //     let model: Model = this;
    //     while (model) {
    //         if (model.option) {
    //             optionStack.push(model.option);
    //         }
    //         model = model.parentModel;
    //     }
    //     const newOption = {} as Opt;
    //     let option;
    //     while (option = optionStack.pop()) {    // Top down merge
    //         if (isFunction(option) && handleCallback) {
    //             option = handleCallback(option);
    //         }
    //         if (deepMerge) {
    //             merge(newOption, option);
    //         }
    //         else {
    //             extend(newOption, option);
    //         }
    //     }
    //     // Remove parentModel
    //     this.option = newOption;
    //     this.parentModel = null;
    // }
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {}; // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $hzBt5.clone)(this.option));
    }; // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    }; // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    }; // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $gZXYp.default).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
             // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
(0, $jKrBG.enableClassExtend)($b8ae91f82b16bb49$var$Model);
(0, $jKrBG.enableClassCheck)($b8ae91f82b16bb49$var$Model);
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $5jmEk.LineStyleMixin));
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $9N9yS.ItemStyleMixin));
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $jdsea.AreaStyleMixin));
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $2A2Wy.default));
var $b8ae91f82b16bb49$export$2e2bcd8739ae039 = $b8ae91f82b16bb49$var$Model;

});
parcelRegister("jKrBG", function(module, exports) {

$parcel$export(module.exports, "parseClassType", () => $e607ba58dd731678$export$fbe18865d303bf01);
$parcel$export(module.exports, "isExtendedClass", () => $e607ba58dd731678$export$4f3b818f3dd2d182);
$parcel$export(module.exports, "enableClassExtend", () => $e607ba58dd731678$export$cd4c3a4dca301c70);
$parcel$export(module.exports, "mountExtend", () => $e607ba58dd731678$export$c9c2d87774f1275d);
$parcel$export(module.exports, "enableClassCheck", () => $e607ba58dd731678$export$e1aac4552ae82081);
$parcel$export(module.exports, "enableClassManagement", () => $e607ba58dd731678$export$241315e45585454d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");
var $e607ba58dd731678$var$TYPE_DELIMITER = '.';
var $e607ba58dd731678$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $e607ba58dd731678$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $e607ba58dd731678$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($e607ba58dd731678$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $e607ba58dd731678$var$checkClassType(componentType) {
    $hzBt5.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $e607ba58dd731678$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$e607ba58dd731678$var$IS_EXTENDED_CLASS]);
}
function $e607ba58dd731678$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this; // For backward compat, we both support ts class inheritance and this
        // "extend" approach.
        // The constructor should keep the same behavior as ts class inheritance:
        // If this constructor/$constructor is not declared, auto invoke the super
        // constructor.
        // If this constructor/$constructor is declared, it is responsible for
        // calling the super constructor.
        function ExtendedClass() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (!proto.$constructor) {
                if (!$e607ba58dd731678$var$isESClass(superClass)) // Will throw error if superClass is an es6 native class.
                superClass.apply(this, arguments);
                else {
                    var ins = $hzBt5.createObject(ExtendedClass.prototype, new (superClass.bind.apply(superClass, (0, $fKE23.__spreadArray)([
                        void 0
                    ], args)))());
                    return ins;
                }
            } else proto.$constructor.apply(this, arguments);
        }
        ExtendedClass[$e607ba58dd731678$var$IS_EXTENDED_CLASS] = true;
        $hzBt5.extend(ExtendedClass.prototype, proto);
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $e607ba58dd731678$var$superCall;
        ExtendedClass.superApply = $e607ba58dd731678$var$superApply;
        $hzBt5.inherits(ExtendedClass, this);
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $e607ba58dd731678$var$isESClass(fn) {
    return typeof fn === 'function' && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $e607ba58dd731678$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
} // A random offset.
var $e607ba58dd731678$var$classBase = Math.round(Math.random() * 10);
function $e607ba58dd731678$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $e607ba58dd731678$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.
function $e607ba58dd731678$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $e607ba58dd731678$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $e607ba58dd731678$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance memeber".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we stil support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $e607ba58dd731678$var$checkClassType(componentFullType); // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $e607ba58dd731678$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$e607ba58dd731678$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$e607ba58dd731678$var$IS_CONTAINER]) $hzBt5.each(obj, function(o, type) {
            type !== $e607ba58dd731678$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $hzBt5.each(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$e607ba58dd731678$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$e607ba58dd731678$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$e607ba58dd731678$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }

});

parcelRegister("jdsea", function(module, exports) {

$parcel$export(module.exports, "AreaStyleMixin", () => $dfd52098e56aabb6$export$a3a0ed7e2dd84c9e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6CLz8 = parcelRequire("6CLz8");
var $dfd52098e56aabb6$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $dfd52098e56aabb6$var$getAreaStyle = (0, $6CLz8.default)($dfd52098e56aabb6$export$52de6e304d934d85);
var $dfd52098e56aabb6$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $dfd52098e56aabb6$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();

});
parcelRegister("6CLz8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d2b30416931ea4c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

var $hzBt5 = parcelRequire("hzBt5");
function $4d2b30416931ea4c$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $hzBt5.indexOf(excludes, propName) >= 0 || includes && $hzBt5.indexOf(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        } // TODO Text or image?
        return style;
    };
}

});


parcelRegister("2A2Wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e113a126e4524bf$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hcRXD = parcelRequire("hcRXD");

var $kiooD = parcelRequire("kiooD");
var $1e113a126e4524bf$var$PATH_COLOR = [
    'textStyle',
    'color'
]; // TODO Performance improvement?
var $1e113a126e4524bf$var$tmpRichText = new (0, $kiooD.default)();
var $1e113a126e4524bf$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($1e113a126e4524bf$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $hcRXD.getFont)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        $1e113a126e4524bf$var$tmpRichText.useStyle({
            text: text,
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily'),
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline'),
            padding: this.getShallow('padding'),
            lineHeight: this.getShallow('lineHeight'),
            rich: this.getShallow('rich')
        });
        $1e113a126e4524bf$var$tmpRichText.update();
        return $1e113a126e4524bf$var$tmpRichText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $1e113a126e4524bf$export$2e2bcd8739ae039 = $1e113a126e4524bf$var$TextStyleMixin;

});
parcelRegister("hcRXD", function(module, exports) {

$parcel$export(module.exports, "setLabelStyle", () => $c86d6a2391ab42dd$export$9a13992917966657);
$parcel$export(module.exports, "createTextStyle", () => $c86d6a2391ab42dd$export$f8998c3d0a13de59);
$parcel$export(module.exports, "createTextConfig", () => $c86d6a2391ab42dd$export$e149afab8df6e053);
$parcel$export(module.exports, "labelInner", () => $c86d6a2391ab42dd$export$f62786d3261ab0f4);
$parcel$export(module.exports, "getLabelStatesModels", () => $c86d6a2391ab42dd$export$9739a32674be5893);
$parcel$export(module.exports, "getFont", () => $c86d6a2391ab42dd$export$155316a870a9d61e);
$parcel$export(module.exports, "setLabelValueAnimation", () => $c86d6a2391ab42dd$export$7bdbceaf9ab378f2);
$parcel$export(module.exports, "animateLabelValue", () => $c86d6a2391ab42dd$export$dd6101605f5c186);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kiooD = parcelRequire("kiooD");

var $hzBt5 = parcelRequire("hzBt5");

var $51xyq = parcelRequire("51xyq");


var $ckizb = parcelRequire("ckizb");

var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");
var $c86d6a2391ab42dd$var$EMPTY_OBJ = {};
function $c86d6a2391ab42dd$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $c86d6a2391ab42dd$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $hzBt5.isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $hzBt5.retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $c86d6a2391ab42dd$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified // TODO specified position?
) {
    opt = opt || $c86d6a2391ab42dd$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $kiooD.default);
    var needsCreateText = false;
    for(var i = 0; i < (0, $51xyq.DISPLAY_STATES).length; i++){
        var stateModel = labelStatesModels[(0, $51xyq.DISPLAY_STATES)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $kiooD.default)();
                targetEl.setTextContent(textContent);
            } // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $c86d6a2391ab42dd$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $c86d6a2391ab42dd$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($c86d6a2391ab42dd$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
            var stateName = (0, $51xyq.SPECIAL_STATES)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $hzBt5.retrieve2)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $c86d6a2391ab42dd$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $c86d6a2391ab42dd$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        } // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto slient is those cases.
        textContent.silent = !!normalModel.getShallow('silent'); // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal; // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $c86d6a2391ab42dd$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $c86d6a2391ab42dd$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $c86d6a2391ab42dd$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $c86d6a2391ab42dd$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $c86d6a2391ab42dd$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $c86d6a2391ab42dd$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $hzBt5.extend)(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $c86d6a2391ab42dd$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
     // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $c86d6a2391ab42dd$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $c86d6a2391ab42dd$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $c86d6a2391ab42dd$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]); // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $c86d6a2391ab42dd$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get('minMargin');
    if (margin != null) textStyle.margin = margin;
    $c86d6a2391ab42dd$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $c86d6a2391ab42dd$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $c86d6a2391ab42dd$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $hzBt5.keys)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $c86d6a2391ab42dd$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $c86d6a2391ab42dd$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign'
];
var $c86d6a2391ab42dd$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $c86d6a2391ab42dd$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $c86d6a2391ab42dd$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
     // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    } // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $c86d6a2391ab42dd$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $c86d6a2391ab42dd$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $hzBt5.retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $c86d6a2391ab42dd$var$TEXT_PROPS_SELF.length; i++){
        var key = $c86d6a2391ab42dd$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $c86d6a2391ab42dd$var$TEXT_PROPS_BOX.length; i++){
            var key = $c86d6a2391ab42dd$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $c86d6a2391ab42dd$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $hzBt5.trim)([
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $c86d6a2391ab42dd$export$f62786d3261ab0f4 = (0, $ckizb.makeInner)();
function $c86d6a2391ab42dd$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $c86d6a2391ab42dd$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $c86d6a2391ab42dd$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $c86d6a2391ab42dd$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation) return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText; // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $hzBt5.retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $ckizb.interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $c86d6a2391ab42dd$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $c86d6a2391ab42dd$export$b533918394a58529(textEl, labelText);
    }
    (labelInnerStore.prevValue == null ? (0, $9ubot.initProps) : (0, $9ubot.updateProps))(textEl, {}, animatableModel, dataIndex, null, during);
}

});
parcelRegister("kiooD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec6869b798380d79$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $h0yya = parcelRequire("h0yya");

var $lm58d = parcelRequire("lm58d");

var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");

var $agXnr = parcelRequire("agXnr");

var $aeCKo = parcelRequire("aeCKo");

var $lGSv6 = parcelRequire("lGSv6");

var $g1Uer = parcelRequire("g1Uer");
var $ec6869b798380d79$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $ec6869b798380d79$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $ec6869b798380d79$export$21aaaa0607ee0e2b = {
    style: (0, $hzBt5.defaults)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $g1Uer.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $ec6869b798380d79$var$ZRText = function(_super) {
    (0, $fKE23.__extends)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $ec6869b798380d79$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $ec6869b798380d79$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $lGSv6.default)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $ec6869b798380d79$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {
        throw new Error('Can\'t attach text on another text');
    };
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $hzBt5.extend)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $hzBt5.keys)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $hzBt5.extend)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $ec6869b798380d79$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $02NbV.DEFAULT_FONT);
        var textPadding = style.padding;
        var text = $ec6869b798380d79$var$getStyleText(style);
        var contentBlock = (0, $h0yya.parsePlainText)(text, style);
        var needDrawBg = $ec6869b798380d79$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = (0, $02NbV.adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var outerWidth_1 = contentBlock.width;
            textPadding && (outerWidth_1 += textPadding[1] + textPadding[3]);
            var boxX = (0, $02NbV.adjustTextX)(baseX, outerWidth_1, textAlign);
            var boxY = (0, $02NbV.adjustTextY)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth_1, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $ec6869b798380d79$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $ec6869b798380d79$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $ec6869b798380d79$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $ec6869b798380d79$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $lm58d.default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            if (textStroke) {
                subElStyle.stroke = textStroke;
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            if (textFill) subElStyle.fill = textFill;
            subElStyle.font = textFont;
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $lGSv6.default)((0, $02NbV.adjustTextX)(subElStyle.x, style.width, subElStyle.textAlign), (0, $02NbV.adjustTextY)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), style.width, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $ec6869b798380d79$var$getStyleText(style);
        var contentBlock = (0, $h0yya.parseRichText)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = (0, $02NbV.adjustTextX)(baseX, outerWidth, textAlign);
        var boxY = (0, $02NbV.adjustTextY)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($ec6869b798380d79$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $ec6869b798380d79$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $ec6869b798380d79$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $lm58d.default));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $ec6869b798380d79$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $ec6869b798380d79$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $ec6869b798380d79$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $02NbV.DEFAULT_FONT);
        subElStyle.opacity = (0, $hzBt5.retrieve3)(tokenStyle.opacity, style.opacity, 1);
        if (textStroke) {
            subElStyle.lineWidth = (0, $hzBt5.retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $hzBt5.retrieve2)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $lGSv6.default)((0, $02NbV.adjustTextX)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $02NbV.adjustTextY)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $aeCKo.default));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $hzBt5.retrieve2)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $agXnr.default));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $hzBt5.retrieve2)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $hzBt5.retrieve3)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if (style.fontSize || style.fontFamily || style.fontWeight) {
            var fontSize = '';
            if (typeof style.fontSize === 'string' && (style.fontSize.indexOf('px') !== -1 || style.fontSize.indexOf('rem') !== -1 || style.fontSize.indexOf('em') !== -1)) fontSize = style.fontSize;
            else if (!isNaN(+style.fontSize)) fontSize = style.fontSize + 'px';
            else fontSize = '12px';
            font = [
                style.fontStyle,
                style.fontWeight,
                fontSize,
                style.fontFamily || 'sans-serif'
            ].join(' ');
        }
        return font && (0, $hzBt5.trim)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $g1Uer.default));
var $ec6869b798380d79$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $ec6869b798380d79$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
function $ec6869b798380d79$export$176336068cc5371f(style) {
    $ec6869b798380d79$var$normalizeStyle(style);
    (0, $hzBt5.each)(style.rich, $ec6869b798380d79$var$normalizeStyle);
    return style;
}
function $ec6869b798380d79$var$normalizeStyle(style) {
    if (style) {
        style.font = $ec6869b798380d79$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $ec6869b798380d79$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $ec6869b798380d79$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $hzBt5.normalizeCssArray)(style.padding);
    }
}
function $ec6869b798380d79$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $ec6869b798380d79$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $ec6869b798380d79$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $ec6869b798380d79$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $ec6869b798380d79$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $ec6869b798380d79$export$2e2bcd8739ae039 = $ec6869b798380d79$var$ZRText;

});
parcelRegister("h0yya", function(module, exports) {

$parcel$export(module.exports, "truncateText", () => $c61d3caa01110056$export$59a943b34a82e690);
$parcel$export(module.exports, "parsePlainText", () => $c61d3caa01110056$export$5772575e34ef80f9);
$parcel$export(module.exports, "parseRichText", () => $c61d3caa01110056$export$15ec9472ff2d721);

var $3RCXB = parcelRequire("3RCXB");

var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");
var $c61d3caa01110056$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $c61d3caa01110056$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) return '';
    var textLines = (text + '').split('\n');
    options = $c61d3caa01110056$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $c61d3caa01110056$var$truncateSingleLine(textLines[i], options);
    return textLines.join('\n');
}
function $c61d3caa01110056$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $hzBt5.extend)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $hzBt5.retrieve2)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $hzBt5.retrieve2)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $hzBt5.retrieve2)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $02NbV.getWidth)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $02NbV.getWidth)('a', font);
    preparedOpts.placeholder = (0, $hzBt5.retrieve2)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $02NbV.getWidth)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $c61d3caa01110056$var$truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) return '';
    var lineWidth = (0, $02NbV.getWidth)(textLine, font);
    if (lineWidth <= containerWidth) return textLine;
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $c61d3caa01110056$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $02NbV.getWidth)(textLine, font);
    }
    if (textLine === '') textLine = options.placeholder;
    return textLine;
}
function $c61d3caa01110056$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $c61d3caa01110056$export$5772575e34ef80f9(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $02NbV.getLineHeight)(font);
    var lineHeight = (0, $hzBt5.retrieve2)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var width = style.width;
    var lines;
    if (width != null && overflow === 'break' || overflow === 'breakAll') lines = text ? $c61d3caa01110056$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $hzBt5.retrieve2)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    var outerHeight = height;
    var outerWidth = width;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        if (outerWidth != null) outerWidth += padding[1] + padding[3];
    }
    if (text && truncate && outerWidth != null) {
        var options = $c61d3caa01110056$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for(var i = 0; i < lines.length; i++)lines[i] = $c61d3caa01110056$var$truncateSingleLine(lines[i], options);
    }
    if (width == null) {
        var maxWidth = 0;
        for(var i = 0; i < lines.length; i++)maxWidth = Math.max((0, $02NbV.getWidth)(lines[i], font), maxWidth);
        width = maxWidth;
    }
    return {
        lines: lines,
        height: height,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentHeight: contentHeight,
        width: width
    };
}
var $c61d3caa01110056$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $c61d3caa01110056$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $c61d3caa01110056$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}();
function $c61d3caa01110056$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $c61d3caa01110056$export$ca607d3c98caaf7e();
    text != null && (text += '');
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $c61d3caa01110056$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $c61d3caa01110056$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $c61d3caa01110056$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $c61d3caa01110056$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $c61d3caa01110056$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $c61d3caa01110056$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $02NbV.getLineHeight)(font);
            var tokenHeight = (0, $hzBt5.retrieve2)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $hzBt5.retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $02NbV.getWidth)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $3RCXB.findExistImage(bgImg);
                        if ($3RCXB.isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        token.text = $c61d3caa01110056$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.width = token.contentWidth = (0, $02NbV.getWidth)(token.text, font);
                    }
                } else token.contentWidth = (0, $02NbV.getWidth)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $hzBt5.retrieve2)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $hzBt5.retrieve2)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $c61d3caa01110056$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $02NbV.parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $c61d3caa01110056$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split('\n');
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $c61d3caa01110056$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $02NbV.getWidth)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $c61d3caa01110056$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $c61d3caa01110056$var$RichTextLine([
            token
        ]));
    }
}
function $c61d3caa01110056$var$isLatin(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x21 && code <= 0xFF;
}
var $c61d3caa01110056$var$breakCharMap = (0, $hzBt5.reduce)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $c61d3caa01110056$var$isWordBreakChar(ch) {
    if ($c61d3caa01110056$var$isLatin(ch)) {
        if ($c61d3caa01110056$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $c61d3caa01110056$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $02NbV.getWidth)(ch, font);
        var inWord = isBreakAll ? false : !$c61d3caa01110056$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        accumWidth += currentWordWidth;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}

});
parcelRegister("3RCXB", function(module, exports) {

$parcel$export(module.exports, "findExistImage", () => $2d048b0f2d40f336$export$1b614f30ac2c8867);
$parcel$export(module.exports, "createOrUpdateImage", () => $2d048b0f2d40f336$export$46c791b69ff9a0f);
$parcel$export(module.exports, "isImageReady", () => $2d048b0f2d40f336$export$37ca7dd901d0236d);

var $lXNaK = parcelRequire("lXNaK");
var $2d048b0f2d40f336$var$globalImageCache = new (0, $lXNaK.default)(50);
function $2d048b0f2d40f336$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $2d048b0f2d40f336$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $2d048b0f2d40f336$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $2d048b0f2d40f336$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$2d048b0f2d40f336$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = new Image();
            image.onload = image.onerror = $2d048b0f2d40f336$var$imageOnLoad;
            $2d048b0f2d40f336$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
            image.src = image.__zrImageSrc = newImageOrSrc;
        }
        return image;
    } else return newImageOrSrc;
}
function $2d048b0f2d40f336$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $2d048b0f2d40f336$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}

});

parcelRegister("02NbV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT", () => $00865865f57df308$export$7d7a232b6d2cc80c);
$parcel$export(module.exports, "getWidth", () => $00865865f57df308$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getLineHeight", () => $00865865f57df308$export$56204a27a2958a55);
$parcel$export(module.exports, "adjustTextX", () => $00865865f57df308$export$eb5a525ef00ef9a4);
$parcel$export(module.exports, "adjustTextY", () => $00865865f57df308$export$bf7d6802d2badd9);
$parcel$export(module.exports, "getBoundingRect", () => $00865865f57df308$export$c381147bfed79d9f);
$parcel$export(module.exports, "parsePercent", () => $00865865f57df308$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "calculateTextPosition", () => $00865865f57df308$export$eee3603b512feab7);

var $lGSv6 = parcelRequire("lGSv6");

var $hzBt5 = parcelRequire("hzBt5");

var $lXNaK = parcelRequire("lXNaK");
var $00865865f57df308$var$textWidthCache = {};
var $00865865f57df308$export$7d7a232b6d2cc80c = '12px sans-serif';
var $00865865f57df308$var$_ctx;
var $00865865f57df308$var$_cachedFont;
function $00865865f57df308$var$defaultMeasureText(text, font) {
    if (!$00865865f57df308$var$_ctx) $00865865f57df308$var$_ctx = (0, $hzBt5.createCanvas)().getContext('2d');
    if ($00865865f57df308$var$_cachedFont !== font) $00865865f57df308$var$_cachedFont = $00865865f57df308$var$_ctx.font = font || $00865865f57df308$export$7d7a232b6d2cc80c;
    return $00865865f57df308$var$_ctx.measureText(text);
}
var $00865865f57df308$var$methods = {
    measureText: $00865865f57df308$var$defaultMeasureText
};
function $00865865f57df308$export$d35a04b83ea6803e(name, fn) {
    $00865865f57df308$var$methods[name] = fn;
}
function $00865865f57df308$export$3c49c185de0c2bfc(text, font) {
    font = font || $00865865f57df308$export$7d7a232b6d2cc80c;
    var cacheOfFont = $00865865f57df308$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $00865865f57df308$var$textWidthCache[font] = new (0, $lXNaK.default)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = $00865865f57df308$var$methods.measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $00865865f57df308$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $00865865f57df308$export$3c49c185de0c2bfc(text, font);
    var height = $00865865f57df308$export$56204a27a2958a55(font);
    var x = $00865865f57df308$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $00865865f57df308$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $lGSv6.default)(x, y, width, height);
    return rect;
}
function $00865865f57df308$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $00865865f57df308$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $lGSv6.default)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $00865865f57df308$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $00865865f57df308$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === 'right') x -= width;
    else if (textAlign === 'center') x -= width / 2;
    return x;
}
function $00865865f57df308$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === 'middle') y -= height / 2;
    else if (verticalAlign === 'bottom') y -= height;
    return y;
}
function $00865865f57df308$export$56204a27a2958a55(font) {
    return $00865865f57df308$export$3c49c185de0c2bfc("\u56FD", font);
}
function $00865865f57df308$export$866cc30a33805630(text, font) {
    return $00865865f57df308$var$methods.measureText(text, font);
}
function $00865865f57df308$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $00865865f57df308$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $00865865f57df308$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $00865865f57df308$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}

});
parcelRegister("lGSv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca7cbed3c1846ab$export$2e2bcd8739ae039);

var $crEgd = parcelRequire("crEgd");

var $4vVC3 = parcelRequire("4vVC3");
var $fca7cbed3c1846ab$var$mathMin = Math.min;
var $fca7cbed3c1846ab$var$mathMax = Math.max;
var $fca7cbed3c1846ab$var$lt = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$rb = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$lb = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$rt = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$minTv = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$maxTv = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $fca7cbed3c1846ab$var$mathMin(other.x, this.x);
        var y = $fca7cbed3c1846ab$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $fca7cbed3c1846ab$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $fca7cbed3c1846ab$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $crEgd.create();
        $crEgd.translate(m, m, [
            -a.x,
            -a.y
        ]);
        $crEgd.scale(m, m, [
            sx,
            sy
        ]);
        $crEgd.translate(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, -d0, 0);
                    else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, d0, 0);
                else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, 0, -d2);
                    else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, 0, d2);
                else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $4vVC3.default).copy(mtv, overlap ? $fca7cbed3c1846ab$var$minTv : $fca7cbed3c1846ab$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $fca7cbed3c1846ab$var$lt.x = $fca7cbed3c1846ab$var$lb.x = source.x;
        $fca7cbed3c1846ab$var$lt.y = $fca7cbed3c1846ab$var$rt.y = source.y;
        $fca7cbed3c1846ab$var$rb.x = $fca7cbed3c1846ab$var$rt.x = source.x + source.width;
        $fca7cbed3c1846ab$var$rb.y = $fca7cbed3c1846ab$var$lb.y = source.y + source.height;
        $fca7cbed3c1846ab$var$lt.transform(m);
        $fca7cbed3c1846ab$var$rt.transform(m);
        $fca7cbed3c1846ab$var$rb.transform(m);
        $fca7cbed3c1846ab$var$lb.transform(m);
        target.x = $fca7cbed3c1846ab$var$mathMin($fca7cbed3c1846ab$var$lt.x, $fca7cbed3c1846ab$var$rb.x, $fca7cbed3c1846ab$var$lb.x, $fca7cbed3c1846ab$var$rt.x);
        target.y = $fca7cbed3c1846ab$var$mathMin($fca7cbed3c1846ab$var$lt.y, $fca7cbed3c1846ab$var$rb.y, $fca7cbed3c1846ab$var$lb.y, $fca7cbed3c1846ab$var$rt.y);
        var maxX = $fca7cbed3c1846ab$var$mathMax($fca7cbed3c1846ab$var$lt.x, $fca7cbed3c1846ab$var$rb.x, $fca7cbed3c1846ab$var$lb.x, $fca7cbed3c1846ab$var$rt.x);
        var maxY = $fca7cbed3c1846ab$var$mathMax($fca7cbed3c1846ab$var$lt.y, $fca7cbed3c1846ab$var$rb.y, $fca7cbed3c1846ab$var$lb.y, $fca7cbed3c1846ab$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $fca7cbed3c1846ab$export$2e2bcd8739ae039 = $fca7cbed3c1846ab$var$BoundingRect;

});
parcelRegister("crEgd", function(module, exports) {

$parcel$export(module.exports, "create", () => $90f73c92e4c09026$export$185802fd694ee1f5);
$parcel$export(module.exports, "identity", () => $90f73c92e4c09026$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $90f73c92e4c09026$export$784d13d8ee351f07);
$parcel$export(module.exports, "mul", () => $90f73c92e4c09026$export$6e3a27864ab166fe);
$parcel$export(module.exports, "translate", () => $90f73c92e4c09026$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "rotate", () => $90f73c92e4c09026$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $90f73c92e4c09026$export$dcdf75081b88279d);
$parcel$export(module.exports, "invert", () => $90f73c92e4c09026$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "clone", () => $90f73c92e4c09026$export$9cd59f9826255e47);
function $90f73c92e4c09026$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $90f73c92e4c09026$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $90f73c92e4c09026$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $90f73c92e4c09026$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $90f73c92e4c09026$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $90f73c92e4c09026$export$bb628a54ab399bc9(out, a, rad) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * atx + st * aty;
    out[5] = ct * aty - st * atx;
    return out;
}
function $90f73c92e4c09026$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $90f73c92e4c09026$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $90f73c92e4c09026$export$9cd59f9826255e47(a) {
    var b = $90f73c92e4c09026$export$185802fd694ee1f5();
    $90f73c92e4c09026$export$784d13d8ee351f07(b, a);
    return b;
}

});

parcelRegister("4vVC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3496bf65801d919c$export$2e2bcd8739ae039);
var $3496bf65801d919c$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $3496bf65801d919c$export$2e2bcd8739ae039 = $3496bf65801d919c$var$Point;

});




parcelRegister("lm58d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8bfa2133f4d35a8$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $02NbV = parcelRequire("02NbV");

var $hMiip = parcelRequire("hMiip");

var $hzBt5 = parcelRequire("hzBt5");
var $f8bfa2133f4d35a8$export$5fbb6d98091bcb56 = (0, $hzBt5.defaults)({
    strokeFirst: true,
    font: (0, $02NbV.DEFAULT_FONT),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $hMiip.DEFAULT_PATH_STYLE));
var $f8bfa2133f4d35a8$var$TSpan = function(_super) {
    (0, $fKE23.__extends)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($f8bfa2133f4d35a8$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += '' : text = '';
            var rect = (0, $02NbV.getBoundingRect)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $g1Uer.default));
$f8bfa2133f4d35a8$var$TSpan.prototype.type = 'tspan';
var $f8bfa2133f4d35a8$export$2e2bcd8739ae039 = $f8bfa2133f4d35a8$var$TSpan;

});
parcelRegister("g1Uer", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COMMON_STYLE", () => $bab85bd1aedea063$export$737672163db00fe3);
$parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", () => $bab85bd1aedea063$export$9908943fb57fbe51);
$parcel$export(module.exports, "default", () => $bab85bd1aedea063$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $3MGIU = parcelRequire("3MGIU");

var $lGSv6 = parcelRequire("lGSv6");

var $hzBt5 = parcelRequire("hzBt5");

var $4rgPt = parcelRequire("4rgPt");
var $bab85bd1aedea063$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $bab85bd1aedea063$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $bab85bd1aedea063$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$bab85bd1aedea063$export$737672163db00fe3[$bab85bd1aedea063$var$STYLE_MAGIC_KEY] = true;
var $bab85bd1aedea063$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $bab85bd1aedea063$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $bab85bd1aedea063$var$Displayable = function(_super) {
    (0, $fKE23.__extends)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $hzBt5.keys)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $bab85bd1aedea063$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $lGSv6.default)(0, 0, 0, 0));
            if (transform) (0, $lGSv6.default).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $lGSv6.default)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $hzBt5.extend)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $4rgPt.STYLE_CHANGED_BIT);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $4rgPt.STYLE_CHANGED_BIT));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $4rgPt.STYLE_CHANGED_BIT);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($bab85bd1aedea063$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$bab85bd1aedea063$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$bab85bd1aedea063$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $bab85bd1aedea063$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $hzBt5.keys)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $hzBt5.keys)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $bab85bd1aedea063$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $bab85bd1aedea063$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $hzBt5.extend)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $bab85bd1aedea063$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $4rgPt.REDRAW_BIT) | (0, $4rgPt.STYLE_CHANGED_BIT);
    }();
    return Displayable;
}((0, $3MGIU.default));
var $bab85bd1aedea063$var$tmpRect = new (0, $lGSv6.default)(0, 0, 0, 0);
var $bab85bd1aedea063$var$viewRect = new (0, $lGSv6.default)(0, 0, 0, 0);
function $bab85bd1aedea063$var$isDisplayableCulled(el, width, height) {
    $bab85bd1aedea063$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $bab85bd1aedea063$var$tmpRect.applyTransform(el.transform);
    $bab85bd1aedea063$var$viewRect.width = width;
    $bab85bd1aedea063$var$viewRect.height = height;
    return !$bab85bd1aedea063$var$tmpRect.intersect($bab85bd1aedea063$var$viewRect);
}
var $bab85bd1aedea063$export$2e2bcd8739ae039 = $bab85bd1aedea063$var$Displayable;

});
parcelRegister("3MGIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c16fec6ca39fd98$export$2e2bcd8739ae039);

var $kVlB5 = parcelRequire("kVlB5");

var $fyp5g = parcelRequire("fyp5g");

var $lGSv6 = parcelRequire("lGSv6");

var $1J7Ke = parcelRequire("1J7Ke");

var $02NbV = parcelRequire("02NbV");

var $hzBt5 = parcelRequire("hzBt5");

var $2MY1H = parcelRequire("2MY1H");

var $f7lrR = parcelRequire("f7lrR");

var $gZXYp = parcelRequire("gZXYp");

var $4rgPt = parcelRequire("4rgPt");
var $2c16fec6ca39fd98$export$97b5e845c7286801 = '__zr_normal__';
var $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS = [
    'x',
    'y',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'rotation',
    'ignore'
];
var $2c16fec6ca39fd98$var$DEFAULT_ANIMATABLE_MAP = {
    x: true,
    y: true,
    scaleX: true,
    scaleY: true,
    originX: true,
    originY: true,
    rotation: true,
    ignore: false
};
var $2c16fec6ca39fd98$var$tmpTextPosCalcRes = {};
var $2c16fec6ca39fd98$var$tmpBoundingRect = new (0, $lGSv6.default)(0, 0, 0, 0);
var $2c16fec6ca39fd98$var$Element = function() {
    function Element(props) {
        this.id = (0, $hzBt5.guid)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $2c16fec6ca39fd98$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($2c16fec6ca39fd98$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $02NbV.calculateTextPosition)($2c16fec6ca39fd98$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.y;
                textAlign = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $02NbV.parsePercent)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $02NbV.parsePercent)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $4rgPt.REDRAW_BIT);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $2MY1H.LIGHT_LABEL_COLOR) : (0, $2MY1H.DARK_LABEL_COLOR);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $f7lrR.parse)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $f7lrR.stringify)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $hzBt5.extend)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $hzBt5.isObject)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $hzBt5.keys)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (fromStateTransition && fromStateTransition !== $2c16fec6ca39fd98$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveFinalToTarget(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($2c16fec6ca39fd98$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $2c16fec6ca39fd98$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $hzBt5.indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $hzBt5.logError)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $4rgPt.REDRAW_BIT);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $4rgPt.REDRAW_BIT);
            }
        }
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $hzBt5.indexOf)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $hzBt5.indexOf)(currentStates, oldState);
        var newStateExists = (0, $hzBt5.indexOf)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $hzBt5.extend)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $hzBt5.extend)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $hzBt5.extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $hzBt5.extend)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $2c16fec6ca39fd98$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        if (componentEl === this) throw new Error('Recursive component attachment.');
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        if (textEl.__zr && !textEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        textEl.innerTransformable = new (0, $kVlB5.default)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $hzBt5.extend)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $4rgPt.REDRAW_BIT);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop) {
        var target = key ? this[key] : this;
        if (!target) {
            (0, $hzBt5.logError)('Property "' + key + '" is not existed in element ' + this.id);
            return;
        }
        var animator = new (0, $fyp5g.default)(target, loop);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $hzBt5.indexOf)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $2c16fec6ca39fd98$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $2c16fec6ca39fd98$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $2c16fec6ca39fd98$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = false;
        elProto.silent = false;
        elProto.isGroup = false;
        elProto.draggable = false;
        elProto.dragging = false;
        elProto.ignoreClip = false;
        elProto.__inHover = false;
        elProto.__dirty = (0, $4rgPt.REDRAW_BIT);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    logDeprecatedError(key, xKey, yKey);
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    logDeprecatedError(key, xKey, yKey);
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty && (!(0, $gZXYp.default).browser.ie || (0, $gZXYp.default).browser.version > 8)) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $hzBt5.mixin)($2c16fec6ca39fd98$var$Element, (0, $1J7Ke.default));
(0, $hzBt5.mixin)($2c16fec6ca39fd98$var$Element, (0, $kVlB5.default));
function $2c16fec6ca39fd98$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $2c16fec6ca39fd98$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        animator.start(cfg.easing, cfg.force);
    }
    return animators;
}
function $2c16fec6ca39fd98$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $2c16fec6ca39fd98$var$is2DArray(value) {
    return (0, $hzBt5.isArrayLike)(value[0]);
}
function $2c16fec6ca39fd98$var$copyValue(target, source, key) {
    if ((0, $hzBt5.isArrayLike)(source[key])) {
        if (!(0, $hzBt5.isArrayLike)(target[key])) target[key] = [];
        if ((0, $hzBt5.isTypedArray)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $2c16fec6ca39fd98$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($2c16fec6ca39fd98$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $2c16fec6ca39fd98$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $2c16fec6ca39fd98$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $2c16fec6ca39fd98$var$animateToShallow(animatable, topKey, source, target, cfg, animationProps, animators, reverse) {
    var animatableKeys = [];
    var changedKeys = [];
    var targetKeys = (0, $hzBt5.keys)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $hzBt5.isObject)(animationProps);
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        if (source[innerKey] != null && target[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $hzBt5.isObject)(target[innerKey]) && !(0, $hzBt5.isArrayLike)(target[innerKey])) {
                if (topKey) {
                    if (!reverse) {
                        source[innerKey] = target[innerKey];
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $2c16fec6ca39fd98$var$animateToShallow(animatable, innerKey, source[innerKey], target[innerKey], cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else {
                animatableKeys.push(innerKey);
                changedKeys.push(innerKey);
            }
        } else if (!reverse) {
            source[innerKey] = target[innerKey];
            animatable.updateDuringAnimation(topKey);
            changedKeys.push(innerKey);
        }
    }
    var keyLen = animatableKeys.length;
    if (keyLen > 0 || cfg.force && !animators.length) {
        var existsAnimators = animatable.animators;
        var existsAnimatorsOnSameTarget = [];
        for(var i = 0; i < existsAnimators.length; i++)if (existsAnimators[i].targetName === topKey) existsAnimatorsOnSameTarget.push(existsAnimators[i]);
        if (!additive && existsAnimatorsOnSameTarget.length) for(var i = 0; i < existsAnimatorsOnSameTarget.length; i++){
            var allAborted = existsAnimatorsOnSameTarget[i].stopTracks(changedKeys);
            if (allAborted) {
                var idx = (0, $hzBt5.indexOf)(existsAnimators, existsAnimatorsOnSameTarget[i]);
                existsAnimators.splice(idx, 1);
            }
        }
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                reversedTarget[innerKey] = source[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else source[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                sourceClone[innerKey] = (0, $fyp5g.cloneValue)(source[innerKey]);
                $2c16fec6ca39fd98$var$copyValue(source, target, innerKey);
            }
        }
        var animator = new (0, $fyp5g.default)(source, false, additive ? existsAnimatorsOnSameTarget : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animatableKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animatableKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animatableKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $2c16fec6ca39fd98$export$2e2bcd8739ae039 = $2c16fec6ca39fd98$var$Element;

});
parcelRegister("kVlB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b9e247faabbfb1$export$2e2bcd8739ae039);

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");
var $f3b9e247faabbfb1$var$mIdentity = $crEgd.identity;
var $f3b9e247faabbfb1$var$EPSILON = 5e-5;
function $f3b9e247faabbfb1$var$isNotAroundZero(val) {
    return val > $f3b9e247faabbfb1$var$EPSILON || val < -$f3b9e247faabbfb1$var$EPSILON;
}
var $f3b9e247faabbfb1$var$scaleTmp = [];
var $f3b9e247faabbfb1$var$tmpTransform = [];
var $f3b9e247faabbfb1$var$originTransform = $crEgd.create();
var $f3b9e247faabbfb1$var$abs = Math.abs;
var $f3b9e247faabbfb1$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $f3b9e247faabbfb1$var$isNotAroundZero(this.rotation) || $f3b9e247faabbfb1$var$isNotAroundZero(this.x) || $f3b9e247faabbfb1$var$isNotAroundZero(this.y) || $f3b9e247faabbfb1$var$isNotAroundZero(this.scaleX - 1) || $f3b9e247faabbfb1$var$isNotAroundZero(this.scaleY - 1);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            m && $f3b9e247faabbfb1$var$mIdentity(m);
            return;
        }
        m = m || $crEgd.create();
        if (needLocalTransform) this.getLocalTransform(m);
        else $f3b9e247faabbfb1$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $crEgd.mul(m, parentTransform, m);
            else $crEgd.copy(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($f3b9e247faabbfb1$var$scaleTmp);
            var relX = $f3b9e247faabbfb1$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $f3b9e247faabbfb1$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($f3b9e247faabbfb1$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $f3b9e247faabbfb1$var$scaleTmp[0] || 0;
            var sy = (($f3b9e247faabbfb1$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $f3b9e247faabbfb1$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $crEgd.create();
        $crEgd.invert(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            $crEgd.mul($f3b9e247faabbfb1$var$tmpTransform, parent.invTransform, m);
            m = $f3b9e247faabbfb1$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $f3b9e247faabbfb1$var$originTransform[4] = ox;
            $f3b9e247faabbfb1$var$originTransform[5] = oy;
            $crEgd.mul($f3b9e247faabbfb1$var$tmpTransform, m, $f3b9e247faabbfb1$var$originTransform);
            $f3b9e247faabbfb1$var$tmpTransform[4] -= ox;
            $f3b9e247faabbfb1$var$tmpTransform[5] -= oy;
            m = $f3b9e247faabbfb1$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $ef5pP.applyTransform(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $ef5pP.applyTransform(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $f3b9e247faabbfb1$var$abs(m[0] - 1) > 1e-10 && $f3b9e247faabbfb1$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($f3b9e247faabbfb1$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        var target = this;
        for(var i = 0; i < $f3b9e247faabbfb1$export$98ab6203ec3396e2.length; i++){
            var propName = $f3b9e247faabbfb1$export$98ab6203ec3396e2[i];
            target[propName] = source[propName];
        }
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy) {
            m[4] = -ox * sx - skewX * oy * sy;
            m[5] = -oy * sy - skewY * ox * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $crEgd.rotate(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.x = 0;
        proto.y = 0;
        proto.scaleX = 1;
        proto.scaleY = 1;
        proto.originX = 0;
        proto.originY = 0;
        proto.skewX = 0;
        proto.skewY = 0;
        proto.rotation = 0;
        proto.globalScaleRatio = 1;
    }();
    return Transformable;
}();
var $f3b9e247faabbfb1$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
var $f3b9e247faabbfb1$export$2e2bcd8739ae039 = $f3b9e247faabbfb1$var$Transformable;

});
parcelRegister("ef5pP", function(module, exports) {

$parcel$export(module.exports, "create", () => $a5e6aad6152849a4$export$185802fd694ee1f5);
$parcel$export(module.exports, "copy", () => $a5e6aad6152849a4$export$784d13d8ee351f07);
$parcel$export(module.exports, "clone", () => $a5e6aad6152849a4$export$9cd59f9826255e47);
$parcel$export(module.exports, "set", () => $a5e6aad6152849a4$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $a5e6aad6152849a4$export$e16d8520af44a096);
$parcel$export(module.exports, "scaleAndAdd", () => $a5e6aad6152849a4$export$19cedf1da84ba854);
$parcel$export(module.exports, "sub", () => $a5e6aad6152849a4$export$f93b5905241a7cca);
$parcel$export(module.exports, "len", () => $a5e6aad6152849a4$export$fc1400facf92c78);
$parcel$export(module.exports, "lenSquare", () => $a5e6aad6152849a4$export$48e33bc611e4c25a);
$parcel$export(module.exports, "length", () => $a5e6aad6152849a4$export$f24224f1c91d8156);
$parcel$export(module.exports, "lengthSquare", () => $a5e6aad6152849a4$export$2f106540dd9a5136);
$parcel$export(module.exports, "mul", () => $a5e6aad6152849a4$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $a5e6aad6152849a4$export$159d9494db57879b);
$parcel$export(module.exports, "dot", () => $a5e6aad6152849a4$export$94132a0e348806d4);
$parcel$export(module.exports, "scale", () => $a5e6aad6152849a4$export$dcdf75081b88279d);
$parcel$export(module.exports, "normalize", () => $a5e6aad6152849a4$export$a3295358bff77e);
$parcel$export(module.exports, "distance", () => $a5e6aad6152849a4$export$9f17032d917177de);
$parcel$export(module.exports, "dist", () => $a5e6aad6152849a4$export$6c4a311cc157c764);
$parcel$export(module.exports, "distanceSquare", () => $a5e6aad6152849a4$export$137c0a69d1ff4a79);
$parcel$export(module.exports, "distSquare", () => $a5e6aad6152849a4$export$c68db45a034c13b0);
$parcel$export(module.exports, "negate", () => $a5e6aad6152849a4$export$aef51622e549b8b0);
$parcel$export(module.exports, "lerp", () => $a5e6aad6152849a4$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "applyTransform", () => $a5e6aad6152849a4$export$9f9dcb98c894b623);
$parcel$export(module.exports, "min", () => $a5e6aad6152849a4$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $a5e6aad6152849a4$export$8960430cfd85939f);
function $a5e6aad6152849a4$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $a5e6aad6152849a4$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $a5e6aad6152849a4$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $a5e6aad6152849a4$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $a5e6aad6152849a4$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $a5e6aad6152849a4$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $a5e6aad6152849a4$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $a5e6aad6152849a4$export$fc1400facf92c78(v) {
    return Math.sqrt($a5e6aad6152849a4$export$48e33bc611e4c25a(v));
}
var $a5e6aad6152849a4$export$f24224f1c91d8156 = $a5e6aad6152849a4$export$fc1400facf92c78;
function $a5e6aad6152849a4$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $a5e6aad6152849a4$export$2f106540dd9a5136 = $a5e6aad6152849a4$export$48e33bc611e4c25a;
function $a5e6aad6152849a4$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $a5e6aad6152849a4$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $a5e6aad6152849a4$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $a5e6aad6152849a4$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $a5e6aad6152849a4$export$a3295358bff77e(out, v) {
    var d = $a5e6aad6152849a4$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $a5e6aad6152849a4$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $a5e6aad6152849a4$export$6c4a311cc157c764 = $a5e6aad6152849a4$export$9f17032d917177de;
function $a5e6aad6152849a4$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $a5e6aad6152849a4$export$c68db45a034c13b0 = $a5e6aad6152849a4$export$137c0a69d1ff4a79;
function $a5e6aad6152849a4$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $a5e6aad6152849a4$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $a5e6aad6152849a4$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $a5e6aad6152849a4$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $a5e6aad6152849a4$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}

});


parcelRegister("1J7Ke", function(module, exports) {

$parcel$export(module.exports, "default", () => $1420005adaadc5c8$export$2e2bcd8739ae039);
var $1420005adaadc5c8$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $1420005adaadc5c8$export$2e2bcd8739ae039 = $1420005adaadc5c8$var$Eventful;

});

parcelRegister("2MY1H", function(module, exports) {

$parcel$export(module.exports, "devicePixelRatio", () => $207ea070da30923d$export$508f096bfcdaac40);
$parcel$export(module.exports, "DARK_MODE_THRESHOLD", () => $207ea070da30923d$export$fd81e7ebc7dae256);
$parcel$export(module.exports, "DARK_LABEL_COLOR", () => $207ea070da30923d$export$f8ce94761f39398d);
$parcel$export(module.exports, "LIGHT_LABEL_COLOR", () => $207ea070da30923d$export$3c6e95f318c8369b);
$parcel$export(module.exports, "LIGHTER_LABEL_COLOR", () => $207ea070da30923d$export$27682248795c3c6b);
var $207ea070da30923d$var$dpr = 1;
if (typeof window !== 'undefined') $207ea070da30923d$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $207ea070da30923d$export$7cdcde344c85339c = 0;
var $207ea070da30923d$export$508f096bfcdaac40 = $207ea070da30923d$var$dpr;
var $207ea070da30923d$export$fd81e7ebc7dae256 = 0.4;
var $207ea070da30923d$export$f8ce94761f39398d = '#333';
var $207ea070da30923d$export$3c6e95f318c8369b = '#ccc';
var $207ea070da30923d$export$27682248795c3c6b = '#eee';

});

parcelRegister("4rgPt", function(module, exports) {

$parcel$export(module.exports, "REDRAW_BIT", () => $33b6bcf503d104f6$export$a7b6db622c6c7dbd);
$parcel$export(module.exports, "STYLE_CHANGED_BIT", () => $33b6bcf503d104f6$export$ada8b2beb3d76671);
$parcel$export(module.exports, "SHAPE_CHANGED_BIT", () => $33b6bcf503d104f6$export$f75fe89a33ebe115);
var $33b6bcf503d104f6$export$a7b6db622c6c7dbd = 1;
var $33b6bcf503d104f6$export$ada8b2beb3d76671 = 2;
var $33b6bcf503d104f6$export$f75fe89a33ebe115 = 4;

});



parcelRegister("hMiip", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PATH_STYLE", () => $cf151c8ba16a6ddf$export$deade517576e293a);
$parcel$export(module.exports, "default", () => $cf151c8ba16a6ddf$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $fvvgx = parcelRequire("fvvgx");

var $ldshw = parcelRequire("ldshw");

var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");

var $2MY1H = parcelRequire("2MY1H");

var $4rgPt = parcelRequire("4rgPt");
var $cf151c8ba16a6ddf$export$deade517576e293a = (0, $hzBt5.defaults)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $g1Uer.DEFAULT_COMMON_STYLE));
var $cf151c8ba16a6ddf$export$71bb6c3c6862c6a5 = {
    style: (0, $hzBt5.defaults)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $g1Uer.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $cf151c8ba16a6ddf$var$pathCopyParams = [
    'x',
    'y',
    'rotation',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
];
var $cf151c8ba16a6ddf$var$Path = function(_super) {
    (0, $fKE23.__extends)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $cf151c8ba16a6ddf$var$pathCopyParams.length; ++i)decalEl[$cf151c8ba16a6ddf$var$pathCopyParams[i]] = this[$cf151c8ba16a6ddf$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $4rgPt.REDRAW_BIT);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $hzBt5.keys)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $hzBt5.extend)(this.style, value);
            } else if (key === 'shape') (0, $hzBt5.extend)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $hzBt5.isString)(pathFill)) {
                var fillLum = (0, $f7lrR.lum)(pathFill, 0);
                if (fillLum > 0.5) return 0, $2MY1H.DARK_LABEL_COLOR;
                else if (fillLum > 0.2) return 0, $2MY1H.LIGHTER_LABEL_COLOR;
                return 0, $2MY1H.LIGHT_LABEL_COLOR;
            } else if (pathFill) return 0, $2MY1H.LIGHT_LABEL_COLOR;
        }
        return 0, $2MY1H.DARK_LABEL_COLOR;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $hzBt5.isString)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $f7lrR.lum)(textFill, 0) < (0, $2MY1H.DARK_MODE_THRESHOLD);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $4rgPt.SHAPE_CHANGED_BIT);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $fvvgx.default)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $4rgPt.SHAPE_CHANGED_BIT)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectWithStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectWithStroke.width += w / lineScale;
                    rectWithStroke.height += w / lineScale;
                    rectWithStroke.x -= w / lineScale / 2;
                    rectWithStroke.y -= w / lineScale / 2;
                }
            }
            return rectWithStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($ldshw.containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $ldshw.contain(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $4rgPt.SHAPE_CHANGED_BIT);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $hzBt5.extend)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $4rgPt.SHAPE_CHANGED_BIT));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($cf151c8ba16a6ddf$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $hzBt5.extend)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $hzBt5.extend)({}, normalState.shape);
                    (0, $hzBt5.extend)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $hzBt5.extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $hzBt5.extend)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $hzBt5.extend)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $hzBt5.keys)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $cf151c8ba16a6ddf$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $fKE23.__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $hzBt5.clone)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $hzBt5.clone)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $4rgPt.REDRAW_BIT) | (0, $4rgPt.STYLE_CHANGED_BIT) | (0, $4rgPt.SHAPE_CHANGED_BIT);
    }();
    return Path;
}((0, $g1Uer.default));
var $cf151c8ba16a6ddf$export$2e2bcd8739ae039 = $cf151c8ba16a6ddf$var$Path;

});
parcelRegister("fvvgx", function(module, exports) {

$parcel$export(module.exports, "normalizeArcAngles", () => $b4a200f8bdc7ccae$export$bc668021e937022a);
$parcel$export(module.exports, "default", () => $b4a200f8bdc7ccae$export$2e2bcd8739ae039);

var $ef5pP = parcelRequire("ef5pP");

var $lGSv6 = parcelRequire("lGSv6");

var $2MY1H = parcelRequire("2MY1H");

var $eVhyd = parcelRequire("eVhyd");

var $jEMPh = parcelRequire("jEMPh");
var $b4a200f8bdc7ccae$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $b4a200f8bdc7ccae$var$tmpOutX = [];
var $b4a200f8bdc7ccae$var$tmpOutY = [];
var $b4a200f8bdc7ccae$var$min = [];
var $b4a200f8bdc7ccae$var$max = [];
var $b4a200f8bdc7ccae$var$min2 = [];
var $b4a200f8bdc7ccae$var$max2 = [];
var $b4a200f8bdc7ccae$var$mathMin = Math.min;
var $b4a200f8bdc7ccae$var$mathMax = Math.max;
var $b4a200f8bdc7ccae$var$mathCos = Math.cos;
var $b4a200f8bdc7ccae$var$mathSin = Math.sin;
var $b4a200f8bdc7ccae$var$mathSqrt = Math.sqrt;
var $b4a200f8bdc7ccae$var$mathAbs = Math.abs;
var $b4a200f8bdc7ccae$var$PI = Math.PI;
var $b4a200f8bdc7ccae$var$PI2 = $b4a200f8bdc7ccae$var$PI * 2;
var $b4a200f8bdc7ccae$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $b4a200f8bdc7ccae$var$tmpAngles = [];
function $b4a200f8bdc7ccae$var$modPI2(radian) {
    var n = Math.round(radian / $b4a200f8bdc7ccae$var$PI * 1e8) / 1e8;
    return n % 2 * $b4a200f8bdc7ccae$var$PI;
}
function $b4a200f8bdc7ccae$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $b4a200f8bdc7ccae$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $b4a200f8bdc7ccae$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $b4a200f8bdc7ccae$var$PI2) newEndAngle = newStartAngle + $b4a200f8bdc7ccae$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $b4a200f8bdc7ccae$var$PI2) newEndAngle = newStartAngle - $b4a200f8bdc7ccae$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($b4a200f8bdc7ccae$var$PI2 - $b4a200f8bdc7ccae$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($b4a200f8bdc7ccae$var$PI2 - $b4a200f8bdc7ccae$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $b4a200f8bdc7ccae$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $b4a200f8bdc7ccae$var$mathAbs(segmentIgnoreThreshold / (0, $2MY1H.devicePixelRatio) / sx) || 0;
            this._uy = $b4a200f8bdc7ccae$var$mathAbs(segmentIgnoreThreshold / (0, $2MY1H.devicePixelRatio) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._lineDash) {
            this._lineDash = null;
            this._dashOffset = 0;
        }
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $b4a200f8bdc7ccae$var$mathAbs(x - this._xi);
        var dy = $b4a200f8bdc7ccae$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($b4a200f8bdc7ccae$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._needsDash ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._needsDash ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._needsDash ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $b4a200f8bdc7ccae$var$tmpAngles[0] = startAngle;
        $b4a200f8bdc7ccae$var$tmpAngles[1] = endAngle;
        $b4a200f8bdc7ccae$export$bc668021e937022a($b4a200f8bdc7ccae$var$tmpAngles, anticlockwise);
        startAngle = $b4a200f8bdc7ccae$var$tmpAngles[0];
        endAngle = $b4a200f8bdc7ccae$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($b4a200f8bdc7ccae$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * r + cx;
        this._yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($b4a200f8bdc7ccae$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) {
            this._needsDash && this._dashedLineTo(x0, y0);
            ctx.closePath();
        }
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.setLineDash = function(lineDash) {
        if (lineDash instanceof Array) {
            this._lineDash = lineDash;
            this._dashIdx = 0;
            var lineDashSum = 0;
            for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
            this._dashSum = lineDashSum;
            this._needsDash = true;
        } else {
            this._lineDash = null;
            this._needsDash = false;
        }
        return this;
    };
    PathProxy.prototype.setLineDashOffset = function(offset) {
        this._dashOffset = offset;
        return this;
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $b4a200f8bdc7ccae$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($b4a200f8bdc7ccae$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype._dashedLineTo = function(x1, y1) {
        var dashSum = this._dashSum;
        var lineDash = this._lineDash;
        var ctx = this._ctx;
        var offset = this._dashOffset;
        var x0 = this._xi;
        var y0 = this._yi;
        var dx = x1 - x0;
        var dy = y1 - y0;
        var dist = $b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
        var x = x0;
        var y = y0;
        var nDash = lineDash.length;
        var dash;
        var idx;
        dx /= dist;
        dy /= dist;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        x -= offset * dx;
        y -= offset * dy;
        while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
            idx = this._dashIdx;
            dash = lineDash[idx];
            x += dx * dash;
            y += dy * dash;
            this._dashIdx = (idx + 1) % nDash;
            if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
            ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? $b4a200f8bdc7ccae$var$mathMin(x, x1) : $b4a200f8bdc7ccae$var$mathMax(x, x1), dy >= 0 ? $b4a200f8bdc7ccae$var$mathMin(y, y1) : $b4a200f8bdc7ccae$var$mathMax(y, y1));
        }
        dx = x - x1;
        dy = y - y1;
        this._dashOffset = -$b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedBezierTo = function(x1, y1, x2, y2, x3, y3) {
        var ctx = this._ctx;
        var dashSum = this._dashSum;
        var offset = this._dashOffset;
        var lineDash = this._lineDash;
        var x0 = this._xi;
        var y0 = this._yi;
        var bezierLen = 0;
        var idx = this._dashIdx;
        var nDash = lineDash.length;
        var t;
        var dx;
        var dy;
        var x;
        var y;
        var tmpLen = 0;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        for(t = 0; t < 1; t += 0.1){
            dx = (0, $jEMPh.cubicAt)(x0, x1, x2, x3, t + 0.1) - (0, $jEMPh.cubicAt)(x0, x1, x2, x3, t);
            dy = (0, $jEMPh.cubicAt)(y0, y1, y2, y3, t + 0.1) - (0, $jEMPh.cubicAt)(y0, y1, y2, y3, t);
            bezierLen += $b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
        }
        for(; idx < nDash; idx++){
            tmpLen += lineDash[idx];
            if (tmpLen > offset) break;
        }
        t = (tmpLen - offset) / bezierLen;
        while(t <= 1){
            x = (0, $jEMPh.cubicAt)(x0, x1, x2, x3, t);
            y = (0, $jEMPh.cubicAt)(y0, y1, y2, y3, t);
            idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
            t += lineDash[idx] / bezierLen;
            idx = (idx + 1) % nDash;
        }
        idx % 2 !== 0 && ctx.lineTo(x3, y3);
        dx = x3 - x;
        dy = y3 - y;
        this._dashOffset = -$b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedQuadraticTo = function(x1, y1, x2, y2) {
        var x3 = x2;
        var y3 = y2;
        x2 = (x2 + 2 * x1) / 3;
        y2 = (y2 + 2 * y1) / 3;
        x1 = (this._xi + 2 * x1) / 3;
        y1 = (this._yi + 2 * y1) / 3;
        this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($b4a200f8bdc7ccae$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $b4a200f8bdc7ccae$var$min[0] = $b4a200f8bdc7ccae$var$min[1] = $b4a200f8bdc7ccae$var$min2[0] = $b4a200f8bdc7ccae$var$min2[1] = Number.MAX_VALUE;
        $b4a200f8bdc7ccae$var$max[0] = $b4a200f8bdc7ccae$var$max[1] = $b4a200f8bdc7ccae$var$max2[0] = $b4a200f8bdc7ccae$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $b4a200f8bdc7ccae$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $b4a200f8bdc7ccae$var$min2[0] = x0;
                    $b4a200f8bdc7ccae$var$min2[1] = y0;
                    $b4a200f8bdc7ccae$var$max2[0] = x0;
                    $b4a200f8bdc7ccae$var$max2[1] = y0;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.L:
                    (0, $eVhyd.fromLine)(xi, yi, data[i], data[i + 1], $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.C:
                    (0, $eVhyd.fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Q:
                    (0, $eVhyd.fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $b4a200f8bdc7ccae$var$mathCos(startAngle) * rx + cx;
                        y0 = $b4a200f8bdc7ccae$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $eVhyd.fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * rx + cx;
                    yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $eVhyd.fromLine)(x0, y0, x0 + width, y0 + height, $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $ef5pP.min($b4a200f8bdc7ccae$var$min, $b4a200f8bdc7ccae$var$min, $b4a200f8bdc7ccae$var$min2);
            $ef5pP.max($b4a200f8bdc7ccae$var$max, $b4a200f8bdc7ccae$var$max, $b4a200f8bdc7ccae$var$max2);
        }
        if (i === 0) $b4a200f8bdc7ccae$var$min[0] = $b4a200f8bdc7ccae$var$min[1] = $b4a200f8bdc7ccae$var$max[0] = $b4a200f8bdc7ccae$var$max[1] = 0;
        return new (0, $lGSv6.default)($b4a200f8bdc7ccae$var$min[0], $b4a200f8bdc7ccae$var$min[1], $b4a200f8bdc7ccae$var$max[0] - $b4a200f8bdc7ccae$var$min[0], $b4a200f8bdc7ccae$var$max[1] - $b4a200f8bdc7ccae$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $b4a200f8bdc7ccae$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($b4a200f8bdc7ccae$var$mathAbs(dx) > ux || $b4a200f8bdc7ccae$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $b4a200f8bdc7ccae$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $jEMPh.cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $jEMPh.quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $b4a200f8bdc7ccae$var$mathCos(startAngle) * rx + cx;
                        y0 = $b4a200f8bdc7ccae$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $b4a200f8bdc7ccae$var$mathMax(rx, ry) * $b4a200f8bdc7ccae$var$mathMin($b4a200f8bdc7ccae$var$PI2, Math.abs(delta));
                    xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * rx + cx;
                    yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $b4a200f8bdc7ccae$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $b4a200f8bdc7ccae$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $b4a200f8bdc7ccae$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $b4a200f8bdc7ccae$var$mathAbs(x - xi);
                    var dy = $b4a200f8bdc7ccae$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $b4a200f8bdc7ccae$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $jEMPh.cubicSubdivide)(xi, x1, x2, x3, t, $b4a200f8bdc7ccae$var$tmpOutX);
                            (0, $jEMPh.cubicSubdivide)(yi, y1, y2, y3, t, $b4a200f8bdc7ccae$var$tmpOutY);
                            ctx.bezierCurveTo($b4a200f8bdc7ccae$var$tmpOutX[1], $b4a200f8bdc7ccae$var$tmpOutY[1], $b4a200f8bdc7ccae$var$tmpOutX[2], $b4a200f8bdc7ccae$var$tmpOutY[2], $b4a200f8bdc7ccae$var$tmpOutX[3], $b4a200f8bdc7ccae$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $jEMPh.quadraticSubdivide)(xi, x1, x2, t, $b4a200f8bdc7ccae$var$tmpOutX);
                            (0, $jEMPh.quadraticSubdivide)(yi, y1, y2, t, $b4a200f8bdc7ccae$var$tmpOutY);
                            ctx.quadraticCurveTo($b4a200f8bdc7ccae$var$tmpOutX[1], $b4a200f8bdc7ccae$var$tmpOutY[1], $b4a200f8bdc7ccae$var$tmpOutX[2], $b4a200f8bdc7ccae$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $b4a200f8bdc7ccae$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $b4a200f8bdc7ccae$var$mathCos(startAngle) * rx + cx;
                        y0 = $b4a200f8bdc7ccae$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * rx + cx;
                    yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $b4a200f8bdc7ccae$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $b4a200f8bdc7ccae$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $b4a200f8bdc7ccae$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $b4a200f8bdc7ccae$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $b4a200f8bdc7ccae$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._needsDash = false;
        proto._dashOffset = 0;
        proto._dashIdx = 0;
        proto._dashSum = 0;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $b4a200f8bdc7ccae$export$2e2bcd8739ae039 = $b4a200f8bdc7ccae$var$PathProxy;

});
parcelRegister("eVhyd", function(module, exports) {

$parcel$export(module.exports, "fromPoints", () => $add400cfec361073$export$188c3cd07b4129dd);
$parcel$export(module.exports, "fromLine", () => $add400cfec361073$export$d2b1491e4450bf2c);
$parcel$export(module.exports, "fromCubic", () => $add400cfec361073$export$c1bc6be456bb6609);
$parcel$export(module.exports, "fromQuadratic", () => $add400cfec361073$export$16fbe795323a1f4c);
$parcel$export(module.exports, "fromArc", () => $add400cfec361073$export$161c8bb0e1d9ef49);

var $ef5pP = parcelRequire("ef5pP");

var $jEMPh = parcelRequire("jEMPh");
var $add400cfec361073$var$mathMin = Math.min;
var $add400cfec361073$var$mathMax = Math.max;
var $add400cfec361073$var$mathSin = Math.sin;
var $add400cfec361073$var$mathCos = Math.cos;
var $add400cfec361073$var$PI2 = Math.PI * 2;
var $add400cfec361073$var$start = $ef5pP.create();
var $add400cfec361073$var$end = $ef5pP.create();
var $add400cfec361073$var$extremity = $ef5pP.create();
function $add400cfec361073$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $add400cfec361073$var$mathMin(left, p[0]);
        right = $add400cfec361073$var$mathMax(right, p[0]);
        top = $add400cfec361073$var$mathMin(top, p[1]);
        bottom = $add400cfec361073$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $add400cfec361073$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $add400cfec361073$var$mathMin(x0, x1);
    min[1] = $add400cfec361073$var$mathMin(y0, y1);
    max[0] = $add400cfec361073$var$mathMax(x0, x1);
    max[1] = $add400cfec361073$var$mathMax(y0, y1);
}
var $add400cfec361073$var$xDim = [];
var $add400cfec361073$var$yDim = [];
function $add400cfec361073$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $jEMPh.cubicExtrema;
    var cubicAt = $jEMPh.cubicAt;
    var n = cubicExtrema(x0, x1, x2, x3, $add400cfec361073$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $add400cfec361073$var$xDim[i]);
        min[0] = $add400cfec361073$var$mathMin(x, min[0]);
        max[0] = $add400cfec361073$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $add400cfec361073$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $add400cfec361073$var$yDim[i]);
        min[1] = $add400cfec361073$var$mathMin(y, min[1]);
        max[1] = $add400cfec361073$var$mathMax(y, max[1]);
    }
    min[0] = $add400cfec361073$var$mathMin(x0, min[0]);
    max[0] = $add400cfec361073$var$mathMax(x0, max[0]);
    min[0] = $add400cfec361073$var$mathMin(x3, min[0]);
    max[0] = $add400cfec361073$var$mathMax(x3, max[0]);
    min[1] = $add400cfec361073$var$mathMin(y0, min[1]);
    max[1] = $add400cfec361073$var$mathMax(y0, max[1]);
    min[1] = $add400cfec361073$var$mathMin(y3, min[1]);
    max[1] = $add400cfec361073$var$mathMax(y3, max[1]);
}
function $add400cfec361073$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $jEMPh.quadraticExtremum;
    var quadraticAt = $jEMPh.quadraticAt;
    var tx = $add400cfec361073$var$mathMax($add400cfec361073$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $add400cfec361073$var$mathMax($add400cfec361073$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $add400cfec361073$var$mathMin(x0, x2, x);
    min[1] = $add400cfec361073$var$mathMin(y0, y2, y);
    max[0] = $add400cfec361073$var$mathMax(x0, x2, x);
    max[1] = $add400cfec361073$var$mathMax(y0, y2, y);
}
function $add400cfec361073$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $ef5pP.min;
    var vec2Max = $ef5pP.max;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $add400cfec361073$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $add400cfec361073$var$start[0] = $add400cfec361073$var$mathCos(startAngle) * rx + x;
    $add400cfec361073$var$start[1] = $add400cfec361073$var$mathSin(startAngle) * ry + y;
    $add400cfec361073$var$end[0] = $add400cfec361073$var$mathCos(endAngle) * rx + x;
    $add400cfec361073$var$end[1] = $add400cfec361073$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $add400cfec361073$var$start, $add400cfec361073$var$end);
    vec2Max(max, $add400cfec361073$var$start, $add400cfec361073$var$end);
    startAngle = startAngle % $add400cfec361073$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $add400cfec361073$var$PI2;
    endAngle = endAngle % $add400cfec361073$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $add400cfec361073$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $add400cfec361073$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $add400cfec361073$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $add400cfec361073$var$extremity[0] = $add400cfec361073$var$mathCos(angle) * rx + x;
        $add400cfec361073$var$extremity[1] = $add400cfec361073$var$mathSin(angle) * ry + y;
        vec2Min(min, $add400cfec361073$var$extremity, min);
        vec2Max(max, $add400cfec361073$var$extremity, max);
    }
}

});
parcelRegister("jEMPh", function(module, exports) {

$parcel$export(module.exports, "cubicAt", () => $e4f7a0998f396fe9$export$547c21de482bbcb2);
$parcel$export(module.exports, "cubicDerivativeAt", () => $e4f7a0998f396fe9$export$55fce925c60b6271);
$parcel$export(module.exports, "cubicRootAt", () => $e4f7a0998f396fe9$export$ca5d13faa10b167e);
$parcel$export(module.exports, "cubicExtrema", () => $e4f7a0998f396fe9$export$df1a172f100d0457);
$parcel$export(module.exports, "cubicSubdivide", () => $e4f7a0998f396fe9$export$a2ee23a0567039da);
$parcel$export(module.exports, "cubicProjectPoint", () => $e4f7a0998f396fe9$export$dbaa3801d1284367);
$parcel$export(module.exports, "cubicLength", () => $e4f7a0998f396fe9$export$af1875d576f60d7c);
$parcel$export(module.exports, "quadraticAt", () => $e4f7a0998f396fe9$export$af17094a950f5073);
$parcel$export(module.exports, "quadraticDerivativeAt", () => $e4f7a0998f396fe9$export$7e161e77e6fff8cb);
$parcel$export(module.exports, "quadraticRootAt", () => $e4f7a0998f396fe9$export$fd895ac7ee764967);
$parcel$export(module.exports, "quadraticExtremum", () => $e4f7a0998f396fe9$export$752e1f8c6e7f7e11);
$parcel$export(module.exports, "quadraticSubdivide", () => $e4f7a0998f396fe9$export$117c659e21a7a060);
$parcel$export(module.exports, "quadraticProjectPoint", () => $e4f7a0998f396fe9$export$81915a594fe10dee);
$parcel$export(module.exports, "quadraticLength", () => $e4f7a0998f396fe9$export$8a68adee46f3cf55);

var $ef5pP = parcelRequire("ef5pP");
var $e4f7a0998f396fe9$var$mathPow = Math.pow;
var $e4f7a0998f396fe9$var$mathSqrt = Math.sqrt;
var $e4f7a0998f396fe9$var$EPSILON = 1e-8;
var $e4f7a0998f396fe9$var$EPSILON_NUMERIC = 1e-4;
var $e4f7a0998f396fe9$var$THREE_SQRT = $e4f7a0998f396fe9$var$mathSqrt(3);
var $e4f7a0998f396fe9$var$ONE_THIRD = 1 / 3;
var $e4f7a0998f396fe9$var$_v0 = (0, $ef5pP.create)();
var $e4f7a0998f396fe9$var$_v1 = (0, $ef5pP.create)();
var $e4f7a0998f396fe9$var$_v2 = (0, $ef5pP.create)();
function $e4f7a0998f396fe9$var$isAroundZero(val) {
    return val > -$e4f7a0998f396fe9$var$EPSILON && val < $e4f7a0998f396fe9$var$EPSILON;
}
function $e4f7a0998f396fe9$var$isNotAroundZero(val) {
    return val > $e4f7a0998f396fe9$var$EPSILON || val < -$e4f7a0998f396fe9$var$EPSILON;
}
function $e4f7a0998f396fe9$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $e4f7a0998f396fe9$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $e4f7a0998f396fe9$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($e4f7a0998f396fe9$var$isAroundZero(A) && $e4f7a0998f396fe9$var$isAroundZero(B)) {
        if ($e4f7a0998f396fe9$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($e4f7a0998f396fe9$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $e4f7a0998f396fe9$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$e4f7a0998f396fe9$var$mathPow(-Y1, $e4f7a0998f396fe9$var$ONE_THIRD);
            else Y1 = $e4f7a0998f396fe9$var$mathPow(Y1, $e4f7a0998f396fe9$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$e4f7a0998f396fe9$var$mathPow(-Y2, $e4f7a0998f396fe9$var$ONE_THIRD);
            else Y2 = $e4f7a0998f396fe9$var$mathPow(Y2, $e4f7a0998f396fe9$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $e4f7a0998f396fe9$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $e4f7a0998f396fe9$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $e4f7a0998f396fe9$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $e4f7a0998f396fe9$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $e4f7a0998f396fe9$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($e4f7a0998f396fe9$var$isAroundZero(a)) {
        if ($e4f7a0998f396fe9$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($e4f7a0998f396fe9$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $e4f7a0998f396fe9$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $e4f7a0998f396fe9$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $e4f7a0998f396fe9$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $e4f7a0998f396fe9$var$_v0[0] = x;
    $e4f7a0998f396fe9$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v0, $e4f7a0998f396fe9$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $e4f7a0998f396fe9$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v1, $e4f7a0998f396fe9$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $e4f7a0998f396fe9$var$_v2[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $e4f7a0998f396fe9$var$_v2[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v2, $e4f7a0998f396fe9$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $e4f7a0998f396fe9$var$mathSqrt(d);
}
function $e4f7a0998f396fe9$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $e4f7a0998f396fe9$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $e4f7a0998f396fe9$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $e4f7a0998f396fe9$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($e4f7a0998f396fe9$var$isAroundZero(a)) {
        if ($e4f7a0998f396fe9$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($e4f7a0998f396fe9$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $e4f7a0998f396fe9$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $e4f7a0998f396fe9$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $e4f7a0998f396fe9$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $e4f7a0998f396fe9$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $e4f7a0998f396fe9$var$_v0[0] = x;
    $e4f7a0998f396fe9$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, _t);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v0, $e4f7a0998f396fe9$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $e4f7a0998f396fe9$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, prev);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v1, $e4f7a0998f396fe9$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $e4f7a0998f396fe9$var$_v2[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, next);
            $e4f7a0998f396fe9$var$_v2[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v2, $e4f7a0998f396fe9$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $e4f7a0998f396fe9$var$mathSqrt(d);
}
function $e4f7a0998f396fe9$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, t);
        var y = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}

});



parcelRegister("ldshw", function(module, exports) {

$parcel$export(module.exports, "contain", () => $f720bffe7cfa30e1$export$8893e2b90ba10d92);
$parcel$export(module.exports, "containStroke", () => $f720bffe7cfa30e1$export$8d36b1b5d19157c5);

var $fvvgx = parcelRequire("fvvgx");

var $k0aU5 = parcelRequire("k0aU5");

var $dvSDV = parcelRequire("dvSDV");

var $hTnmd = parcelRequire("hTnmd");

var $30IXf = parcelRequire("30IXf");

var $jEMPh = parcelRequire("jEMPh");

var $j53mu = parcelRequire("j53mu");
var $f720bffe7cfa30e1$var$CMD = (0, $fvvgx.default).CMD;
var $f720bffe7cfa30e1$var$PI2 = Math.PI * 2;
var $f720bffe7cfa30e1$var$EPSILON = 1e-4;
function $f720bffe7cfa30e1$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $f720bffe7cfa30e1$var$EPSILON;
}
var $f720bffe7cfa30e1$var$roots = [
    -1,
    -1,
    -1
];
var $f720bffe7cfa30e1$var$extrema = [
    -1,
    -1
];
function $f720bffe7cfa30e1$var$swapExtrema() {
    var tmp = $f720bffe7cfa30e1$var$extrema[0];
    $f720bffe7cfa30e1$var$extrema[0] = $f720bffe7cfa30e1$var$extrema[1];
    $f720bffe7cfa30e1$var$extrema[1] = tmp;
}
function $f720bffe7cfa30e1$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $jEMPh.cubicRootAt(y0, y1, y2, y3, y, $f720bffe7cfa30e1$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $f720bffe7cfa30e1$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $jEMPh.cubicAt(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $jEMPh.cubicExtrema(y0, y1, y2, y3, $f720bffe7cfa30e1$var$extrema);
                if ($f720bffe7cfa30e1$var$extrema[1] < $f720bffe7cfa30e1$var$extrema[0] && nExtrema > 1) $f720bffe7cfa30e1$var$swapExtrema();
                y0_ = $jEMPh.cubicAt(y0, y1, y2, y3, $f720bffe7cfa30e1$var$extrema[0]);
                if (nExtrema > 1) y1_ = $jEMPh.cubicAt(y0, y1, y2, y3, $f720bffe7cfa30e1$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $f720bffe7cfa30e1$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $f720bffe7cfa30e1$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $f720bffe7cfa30e1$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $f720bffe7cfa30e1$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $jEMPh.quadraticRootAt(y0, y1, y2, y, $f720bffe7cfa30e1$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $jEMPh.quadraticExtremum(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $jEMPh.quadraticAt(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $f720bffe7cfa30e1$var$roots[i] === 0 || $f720bffe7cfa30e1$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $jEMPh.quadraticAt(x0, x1, x2, $f720bffe7cfa30e1$var$roots[i]);
                if (x_ < x) continue;
                if ($f720bffe7cfa30e1$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $f720bffe7cfa30e1$var$roots[0] === 0 || $f720bffe7cfa30e1$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $jEMPh.quadraticAt(x0, x1, x2, $f720bffe7cfa30e1$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $f720bffe7cfa30e1$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $f720bffe7cfa30e1$var$roots[0] = -tmp;
    $f720bffe7cfa30e1$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $f720bffe7cfa30e1$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $f720bffe7cfa30e1$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $f720bffe7cfa30e1$var$roots[0] + cx && x <= $f720bffe7cfa30e1$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $f720bffe7cfa30e1$var$PI2;
        endAngle += $f720bffe7cfa30e1$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $f720bffe7cfa30e1$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $f720bffe7cfa30e1$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $f720bffe7cfa30e1$var$PI2 >= startAngle && angle + $f720bffe7cfa30e1$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $f720bffe7cfa30e1$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $f720bffe7cfa30e1$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $j53mu.default)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $f720bffe7cfa30e1$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $f720bffe7cfa30e1$var$CMD.L:
                if (isStroke) {
                    if ($k0aU5.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $j53mu.default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $f720bffe7cfa30e1$var$CMD.C:
                if (isStroke) {
                    if ($dvSDV.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $f720bffe7cfa30e1$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $f720bffe7cfa30e1$var$CMD.Q:
                if (isStroke) {
                    if ($hTnmd.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $f720bffe7cfa30e1$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $f720bffe7cfa30e1$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $j53mu.default)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($30IXf.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $f720bffe7cfa30e1$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $f720bffe7cfa30e1$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($k0aU5.containStroke(x0, y0, x1, y0, lineWidth, x, y) || $k0aU5.containStroke(x1, y0, x1, y1, lineWidth, x, y) || $k0aU5.containStroke(x1, y1, x0, y1, lineWidth, x, y) || $k0aU5.containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $j53mu.default)(x1, y0, x1, y1, x, y);
                    w += (0, $j53mu.default)(x0, y1, x0, y0, x, y);
                }
                break;
            case $f720bffe7cfa30e1$var$CMD.Z:
                if (isStroke) {
                    if ($k0aU5.containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $j53mu.default)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$f720bffe7cfa30e1$var$isAroundEqual(yi, y0)) w += (0, $j53mu.default)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $f720bffe7cfa30e1$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $f720bffe7cfa30e1$var$containPath(pathProxy, 0, false, x, y);
}
function $f720bffe7cfa30e1$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $f720bffe7cfa30e1$var$containPath(pathProxy, lineWidth, true, x, y);
}

});
parcelRegister("k0aU5", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $e8fc43f3b1e989f4$export$8d36b1b5d19157c5);
function $e8fc43f3b1e989f4$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}

});

parcelRegister("dvSDV", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $9d688e91b9345274$export$8d36b1b5d19157c5);

var $jEMPh = parcelRequire("jEMPh");
function $9d688e91b9345274$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $jEMPh.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("hTnmd", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $d069b1000d43791a$export$8d36b1b5d19157c5);

var $jEMPh = parcelRequire("jEMPh");
function $d069b1000d43791a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $jEMPh.quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("30IXf", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $23143e3badbfbe00$export$8d36b1b5d19157c5);

var $kqaXh = parcelRequire("kqaXh");
var $23143e3badbfbe00$var$PI2 = Math.PI * 2;
function $23143e3badbfbe00$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $23143e3badbfbe00$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kqaXh.normalizeRadian)(endAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kqaXh.normalizeRadian)(startAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $23143e3badbfbe00$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $23143e3badbfbe00$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $23143e3badbfbe00$var$PI2 >= startAngle && angle + $23143e3badbfbe00$var$PI2 <= endAngle;
}

});
parcelRegister("kqaXh", function(module, exports) {

$parcel$export(module.exports, "normalizeRadian", () => $eddebbd6c444578f$export$d44861331f213635);
var $eddebbd6c444578f$var$PI2 = Math.PI * 2;
function $eddebbd6c444578f$export$d44861331f213635(angle) {
    angle %= $eddebbd6c444578f$var$PI2;
    if (angle < 0) angle += $eddebbd6c444578f$var$PI2;
    return angle;
}

});


parcelRegister("j53mu", function(module, exports) {

$parcel$export(module.exports, "default", () => $de4117845188b405$export$2e2bcd8739ae039);
function $de4117845188b405$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}

});




parcelRegister("agXnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $77a9750da057fbd9$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $lGSv6 = parcelRequire("lGSv6");

var $hzBt5 = parcelRequire("hzBt5");
var $77a9750da057fbd9$export$8993f922aeeac642 = (0, $hzBt5.defaults)({
    x: 0,
    y: 0
}, (0, $g1Uer.DEFAULT_COMMON_STYLE));
var $77a9750da057fbd9$export$4aba8ad70847a488 = {
    style: (0, $hzBt5.defaults)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $g1Uer.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
function $77a9750da057fbd9$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $77a9750da057fbd9$var$ZRImage = function(_super) {
    (0, $fKE23.__extends)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($77a9750da057fbd9$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $77a9750da057fbd9$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $77a9750da057fbd9$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $lGSv6.default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $g1Uer.default));
$77a9750da057fbd9$var$ZRImage.prototype.type = 'image';
var $77a9750da057fbd9$export$2e2bcd8739ae039 = $77a9750da057fbd9$var$ZRImage;

});

parcelRegister("aeCKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7739449dac61132f$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $b7hGQ = parcelRequire("b7hGQ");

var $kXoFx = parcelRequire("kXoFx");
var $7739449dac61132f$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $7739449dac61132f$var$subPixelOptimizeOutputShape = {};
var $7739449dac61132f$var$Rect = function(_super) {
    (0, $fKE23.__extends)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $7739449dac61132f$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $kXoFx.subPixelOptimizeRect)($7739449dac61132f$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $b7hGQ.buildPath(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $hMiip.default));
$7739449dac61132f$var$Rect.prototype.type = 'rect';
var $7739449dac61132f$export$2e2bcd8739ae039 = $7739449dac61132f$var$Rect;

});
parcelRegister("b7hGQ", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $817e120940349974$export$5cc7f731b5937e99);
function $817e120940349974$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

});

parcelRegister("kXoFx", function(module, exports) {

$parcel$export(module.exports, "subPixelOptimizeLine", () => $f41c740f33c8dcd8$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimize", () => $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $f41c740f33c8dcd8$export$60e2aa74957d0b9d);
var $f41c740f33c8dcd8$var$round = Math.round;
function $f41c740f33c8dcd8$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($f41c740f33c8dcd8$var$round(x1 * 2) === $f41c740f33c8dcd8$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($f41c740f33c8dcd8$var$round(y1 * 2) === $f41c740f33c8dcd8$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $f41c740f33c8dcd8$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $f41c740f33c8dcd8$var$round(position * 2);
    return (doubledPosition + $f41c740f33c8dcd8$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

});



parcelRegister("51xyq", function(module, exports) {

$parcel$export(module.exports, "HOVER_STATE_BLUR", () => $3a8712efe6873d0c$export$1307d6a87d56baa);
$parcel$export(module.exports, "HOVER_STATE_EMPHASIS", () => $3a8712efe6873d0c$export$f0f2bee145debb31);
$parcel$export(module.exports, "SPECIAL_STATES", () => $3a8712efe6873d0c$export$151308dceb52d5b);
$parcel$export(module.exports, "DISPLAY_STATES", () => $3a8712efe6873d0c$export$57ee5306b85ad7d5);
$parcel$export(module.exports, "Z2_EMPHASIS_LIFT", () => $3a8712efe6873d0c$export$1cb9fc6ed5b9836c);
$parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", () => $3a8712efe6873d0c$export$df035d873a9de64f);
$parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", () => $3a8712efe6873d0c$export$f8a2f7807cc185ea);
$parcel$export(module.exports, "SELECT_ACTION_TYPE", () => $3a8712efe6873d0c$export$89616263e7d38fe9);
$parcel$export(module.exports, "UNSELECT_ACTION_TYPE", () => $3a8712efe6873d0c$export$7636ad95c0f68a79);
$parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", () => $3a8712efe6873d0c$export$1e90ed8a25542516);
$parcel$export(module.exports, "setStatesFlag", () => $3a8712efe6873d0c$export$868ba38adffa9e39);
$parcel$export(module.exports, "setDefaultStateProxy", () => $3a8712efe6873d0c$export$20f39bbe322fb9ab);
$parcel$export(module.exports, "enterEmphasis", () => $3a8712efe6873d0c$export$b2d02638cc34c042);
$parcel$export(module.exports, "leaveEmphasis", () => $3a8712efe6873d0c$export$11be6f716239ac55);
$parcel$export(module.exports, "enterBlur", () => $3a8712efe6873d0c$export$207f9cb3e1099375);
$parcel$export(module.exports, "leaveBlur", () => $3a8712efe6873d0c$export$fd4a9ec75456d3c1);
$parcel$export(module.exports, "enterSelect", () => $3a8712efe6873d0c$export$252d028dda8ef765);
$parcel$export(module.exports, "leaveSelect", () => $3a8712efe6873d0c$export$ea9a904bd6e32bd3);
$parcel$export(module.exports, "allLeaveBlur", () => $3a8712efe6873d0c$export$b2a593c7b5243584);
$parcel$export(module.exports, "blurComponent", () => $3a8712efe6873d0c$export$569da03256c8a55f);
$parcel$export(module.exports, "blurSeriesFromHighlightPayload", () => $3a8712efe6873d0c$export$64f1fd4daefef21b);
$parcel$export(module.exports, "findComponentHighDownDispatchers", () => $3a8712efe6873d0c$export$f31a644ccca0ef23);
$parcel$export(module.exports, "handleGlobalMouseOverForHighDown", () => $3a8712efe6873d0c$export$416765b6198234ff);
$parcel$export(module.exports, "handleGlboalMouseOutForHighDown", () => $3a8712efe6873d0c$export$2cbc9e6f4b583c84);
$parcel$export(module.exports, "toggleSelectionFromPayload", () => $3a8712efe6873d0c$export$1c7d489f62372d73);
$parcel$export(module.exports, "isSelectChangePayload", () => $3a8712efe6873d0c$export$72aea10e60e45351);
$parcel$export(module.exports, "updateSeriesElementSelection", () => $3a8712efe6873d0c$export$e4ea08ef52e0a73);
$parcel$export(module.exports, "getAllSelectedIndices", () => $3a8712efe6873d0c$export$c529643b619af6b3);
$parcel$export(module.exports, "enableHoverEmphasis", () => $3a8712efe6873d0c$export$5f393df0b5aee2e7);
$parcel$export(module.exports, "setAsHighDownDispatcher", () => $3a8712efe6873d0c$export$9ba15aea1e048d48);
$parcel$export(module.exports, "enableHoverFocus", () => $3a8712efe6873d0c$export$24972466b2b62ac2);
$parcel$export(module.exports, "setStatesStylesFromModel", () => $3a8712efe6873d0c$export$48b68047d330bbc9);
$parcel$export(module.exports, "isHighDownDispatcher", () => $3a8712efe6873d0c$export$77d1445f699c58b5);
$parcel$export(module.exports, "enableComponentHighDownFeatures", () => $3a8712efe6873d0c$export$4da05a9639f01954);
$parcel$export(module.exports, "getHighlightDigit", () => $3a8712efe6873d0c$export$824af40eb714530d);
$parcel$export(module.exports, "isHighDownPayload", () => $3a8712efe6873d0c$export$aebe71265c1b77bf);
$parcel$export(module.exports, "savePathStates", () => $3a8712efe6873d0c$export$9fe78019e6f395b6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lXNaK = parcelRequire("lXNaK");

var $hzBt5 = parcelRequire("hzBt5");

var $aly4X = parcelRequire("aly4X");

var $f7lrR = parcelRequire("f7lrR");

var $ckizb = parcelRequire("ckizb");

var $hMiip = parcelRequire("hMiip");

var $3a8712efe6873d0c$var$_highlightNextDigit = 1;
var $3a8712efe6873d0c$var$_highlightKeyMap = {};
var $3a8712efe6873d0c$var$getSavedStates = (0, $ckizb.makeInner)();
var $3a8712efe6873d0c$export$5542daa30722333e = 0;
var $3a8712efe6873d0c$export$1307d6a87d56baa = 1;
var $3a8712efe6873d0c$export$f0f2bee145debb31 = 2;
var $3a8712efe6873d0c$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $3a8712efe6873d0c$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $3a8712efe6873d0c$export$1cb9fc6ed5b9836c = 10;
var $3a8712efe6873d0c$export$3a2f97d39514bbc = 9;
var $3a8712efe6873d0c$export$df035d873a9de64f = 'highlight';
var $3a8712efe6873d0c$export$f8a2f7807cc185ea = 'downplay';
var $3a8712efe6873d0c$export$89616263e7d38fe9 = 'select';
var $3a8712efe6873d0c$export$7636ad95c0f68a79 = 'unselect';
var $3a8712efe6873d0c$export$1e90ed8a25542516 = 'toggleSelect';
function $3a8712efe6873d0c$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.
var $3a8712efe6873d0c$var$liftedColorCache = new (0, $lXNaK.default)(100);
function $3a8712efe6873d0c$var$liftColor(color) {
    if (typeof color !== 'string') return color;
    var liftedColor = $3a8712efe6873d0c$var$liftedColorCache.get(color);
    if (!liftedColor) {
        liftedColor = $f7lrR.lift(color, -0.1);
        $3a8712efe6873d0c$var$liftedColorCache.put(color, liftedColor);
    }
    return liftedColor;
}
function $3a8712efe6873d0c$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $3a8712efe6873d0c$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $3a8712efe6873d0c$var$doChangeHoverState(el, 'emphasis', $3a8712efe6873d0c$export$f0f2bee145debb31);
}
function $3a8712efe6873d0c$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $3a8712efe6873d0c$export$f0f2bee145debb31) $3a8712efe6873d0c$var$doChangeHoverState(el, 'normal', $3a8712efe6873d0c$export$5542daa30722333e);
}
function $3a8712efe6873d0c$var$singleEnterBlur(el) {
    $3a8712efe6873d0c$var$doChangeHoverState(el, 'blur', $3a8712efe6873d0c$export$1307d6a87d56baa);
}
function $3a8712efe6873d0c$var$singleLeaveBlur(el) {
    if (el.hoverState === $3a8712efe6873d0c$export$1307d6a87d56baa) $3a8712efe6873d0c$var$doChangeHoverState(el, 'normal', $3a8712efe6873d0c$export$5542daa30722333e);
}
function $3a8712efe6873d0c$var$singleEnterSelect(el) {
    el.selected = true;
}
function $3a8712efe6873d0c$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $3a8712efe6873d0c$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $3a8712efe6873d0c$var$traverseUpdateState(el, updater, commonParam) {
    $3a8712efe6873d0c$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $3a8712efe6873d0c$var$updateElementState(child, updater, commonParam);
    });
}
function $3a8712efe6873d0c$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $3a8712efe6873d0c$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $3a8712efe6873d0c$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $3a8712efe6873d0c$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $3a8712efe6873d0c$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $3a8712efe6873d0c$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition // Dont consider the animation to emphasis state.
         && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveFinalToTarget(fromState, props);
    }
    return fromState;
}
function $3a8712efe6873d0c$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $hzBt5.indexOf)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $hMiip.default)) {
        var store = $3a8712efe6873d0c$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($3a8712efe6873d0c$var$hasFillOrStroke(fromFill) || $3a8712efe6873d0c$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {}; // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $hzBt5.extend)({}, state);
                emphasisStyle = (0, $hzBt5.extend)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$3a8712efe6873d0c$var$hasFillOrStroke(emphasisStyle.fill) && $3a8712efe6873d0c$var$hasFillOrStroke(fromFill)) {
                cloned = true; // Not modify the original value.
                state = (0, $hzBt5.extend)({}, state);
                emphasisStyle = (0, $hzBt5.extend)({}, emphasisStyle); // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = $3a8712efe6873d0c$var$liftColor(fromFill);
            } else if (!$3a8712efe6873d0c$var$hasFillOrStroke(emphasisStyle.stroke) && $3a8712efe6873d0c$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $hzBt5.extend)({}, state);
                    emphasisStyle = (0, $hzBt5.extend)({}, emphasisStyle);
                }
                emphasisStyle.stroke = $3a8712efe6873d0c$var$liftColor(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $hzBt5.extend)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $3a8712efe6873d0c$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $3a8712efe6873d0c$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $hzBt5.extend)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $3a8712efe6873d0c$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $3a8712efe6873d0c$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $hzBt5.indexOf)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $3a8712efe6873d0c$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $hzBt5.extend)({}, state);
        blurStyle = (0, $hzBt5.extend)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $3a8712efe6873d0c$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $3a8712efe6873d0c$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $3a8712efe6873d0c$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $3a8712efe6873d0c$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $3a8712efe6873d0c$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $3a8712efe6873d0c$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $3a8712efe6873d0c$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $3a8712efe6873d0c$var$elementStateProxy;
}
function $3a8712efe6873d0c$export$d899507e2598e4ae(el, e) {
    !$3a8712efe6873d0c$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterEmphasis);
}
function $3a8712efe6873d0c$export$784cba1f7fe58cca(el, e) {
    !$3a8712efe6873d0c$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveEmphasis);
}
function $3a8712efe6873d0c$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterEmphasis);
}
function $3a8712efe6873d0c$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveEmphasis);
}
function $3a8712efe6873d0c$export$207f9cb3e1099375(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterBlur);
}
function $3a8712efe6873d0c$export$fd4a9ec75456d3c1(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveBlur);
}
function $3a8712efe6873d0c$export$252d028dda8ef765(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterSelect);
}
function $3a8712efe6873d0c$export$ea9a904bd6e32bd3(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveSelect);
}
function $3a8712efe6873d0c$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $3a8712efe6873d0c$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    model.eachComponent(function(componentType, componentModel) {
        var view = componentType === 'series' ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel); // Leave blur anyway
        view.group.traverse(function(child) {
            $3a8712efe6873d0c$var$singleLeaveBlur(child);
        });
    });
}
function $3a8712efe6873d0c$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $3a8712efe6873d0c$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!(blurScope === 'series' && !sameSeries // Not blur other coordinate system if blurScope is coordinateSystem
         || blurScope === 'coordinateSystem' && !sameCoordSys // Not blur self series if focus is series.
         || focus === 'series' && sameSeries // TODO blurScope: coordinate system
        )) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                $3a8712efe6873d0c$var$singleEnterBlur(child);
            });
            if ((0, $hzBt5.isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $hzBt5.isObject)(focus)) {
                var dataTypes = (0, $hzBt5.keys)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.blurSeries) view.blurSeries(blurredSeries, ecModel);
    });
}
function $3a8712efe6873d0c$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $3a8712efe6873d0c$var$singleEnterBlur(child);
    });
}
function $3a8712efe6873d0c$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    var dataIndex = (0, $ckizb.queryDataIndex)(data, payload); // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $hzBt5.isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0; // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $aly4X.getECData)(el);
        $3a8712efe6873d0c$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $3a8712efe6873d0c$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $3a8712efe6873d0c$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name); // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $aly4X.getECData)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $3a8712efe6873d0c$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $aly4X.getECData)(dispatcher);
    var _a = $3a8712efe6873d0c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf; // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $3a8712efe6873d0c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $hzBt5.each)(dispatchers, function(dispatcher) {
            return $3a8712efe6873d0c$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $3a8712efe6873d0c$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $3a8712efe6873d0c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
         // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $3a8712efe6873d0c$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $3a8712efe6873d0c$export$2cbc9e6f4b583c84(dispatcher, e, api) {
    $3a8712efe6873d0c$export$b2a593c7b5243584(api);
    var ecData = (0, $aly4X.getECData)(dispatcher);
    var dispatchers = $3a8712efe6873d0c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $hzBt5.each)(dispatchers, function(dispatcher) {
        return $3a8712efe6873d0c$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $3a8712efe6873d0c$export$784cba1f7fe58cca(dispatcher, e);
}
function $3a8712efe6873d0c$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$3a8712efe6873d0c$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $ckizb.queryDataIndex)(data, payload);
    if (!(0, $hzBt5.isArray)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $3a8712efe6873d0c$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $3a8712efe6873d0c$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $3a8712efe6873d0c$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $hzBt5.each)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $3a8712efe6873d0c$export$252d028dda8ef765(el) : $3a8712efe6873d0c$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $3a8712efe6873d0c$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $hzBt5.each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $3a8712efe6873d0c$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $3a8712efe6873d0c$export$9ba15aea1e048d48(el, true);
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$export$20f39bbe322fb9ab);
    $3a8712efe6873d0c$export$24972466b2b62ac2(el, focus, blurScope);
}
function $3a8712efe6873d0c$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $aly4X.getECData)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope; // }
    } else if (ecData.focus) ecData.focus = null;
}
var $3a8712efe6873d0c$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $3a8712efe6873d0c$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $3a8712efe6873d0c$export$48b68047d330bbc9(el, itemModel, styleType, getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $3a8712efe6873d0c$var$OTHER_STATES.length; i++){
        var stateName = $3a8712efe6873d0c$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName); // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$3a8712efe6873d0c$var$defaultStyleGetterMap[styleType]]();
    }
}
function $3a8712efe6873d0c$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el; // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
     // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $3a8712efe6873d0c$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $3a8712efe6873d0c$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $aly4X.getECData)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $3a8712efe6873d0c$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $3a8712efe6873d0c$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $3a8712efe6873d0c$var$_highlightNextDigit <= 32) highlightDigit = $3a8712efe6873d0c$var$_highlightKeyMap[highlightKey] = $3a8712efe6873d0c$var$_highlightNextDigit++;
    return highlightDigit;
}
function $3a8712efe6873d0c$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $3a8712efe6873d0c$export$89616263e7d38fe9 || payloadType === $3a8712efe6873d0c$export$7636ad95c0f68a79 || payloadType === $3a8712efe6873d0c$export$1e90ed8a25542516;
}
function $3a8712efe6873d0c$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $3a8712efe6873d0c$export$df035d873a9de64f || payloadType === $3a8712efe6873d0c$export$f8a2f7807cc185ea;
}
function $3a8712efe6873d0c$export$9fe78019e6f395b6(el) {
    var store = $3a8712efe6873d0c$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}

});
parcelRegister("aly4X", function(module, exports) {

$parcel$export(module.exports, "getECData", () => $78864ce604e5f33a$export$b1c39b2bacd1ddc2);
$parcel$export(module.exports, "setCommonECData", () => $78864ce604e5f33a$export$30d6736ebb8e18d5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");
var $78864ce604e5f33a$export$b1c39b2bacd1ddc2 = (0, $ckizb.makeInner)();
var $78864ce604e5f33a$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $78864ce604e5f33a$export$b1c39b2bacd1ddc2(el); // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex; // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $78864ce604e5f33a$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
        });
    }
};

});


parcelRegister("9ubot", function(module, exports) {

$parcel$export(module.exports, "getAnimationConfig", () => $6e7fc0f961bc64aa$export$5cc7add7ab591d0a);
$parcel$export(module.exports, "updateProps", () => $6e7fc0f961bc64aa$export$c8dce3c08436e91e);
$parcel$export(module.exports, "initProps", () => $6e7fc0f961bc64aa$export$a121566aadcfe021);
$parcel$export(module.exports, "isElementRemoved", () => $6e7fc0f961bc64aa$export$5b89d4b643713034);
$parcel$export(module.exports, "removeElement", () => $6e7fc0f961bc64aa$export$f883456a56996078);
$parcel$export(module.exports, "removeElementWithFadeOut", () => $6e7fc0f961bc64aa$export$6d0fd725cb4aee8a);
$parcel$export(module.exports, "saveOldStyle", () => $6e7fc0f961bc64aa$export$bca7290a9faf0ec9);
$parcel$export(module.exports, "getOldStyle", () => $6e7fc0f961bc64aa$export$ccb1f1e4d2fa86ac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
var $6e7fc0f961bc64aa$export$ae7433df314f6ec3 = (0, $ckizb.makeInner)();
function $6e7fc0f961bc64aa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, extraOpts, extraDelayParams) {
    var animationPayload; // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $hzBt5.retrieve2)(extraOpts.duration, 200);
            easing = (0, $hzBt5.retrieve2)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        } // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if (typeof delay === 'function') delay = delay(dataIndex, extraDelayParams);
        if (typeof duration === 'function') duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $6e7fc0f961bc64aa$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if (typeof dataIndex === 'function') {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $hzBt5.isObject)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'remove';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('remove');
    var animationConfig = $6e7fc0f961bc64aa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation(); // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props); // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $6e7fc0f961bc64aa$export$c8dce3c08436e91e(el, props, animatableModel, dataIndex, cb, during) {
    $6e7fc0f961bc64aa$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $6e7fc0f961bc64aa$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $6e7fc0f961bc64aa$var$animateOrSetProps('init', el, props, animatableModel, dataIndex, cb, during);
}
function $6e7fc0f961bc64aa$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'remove') return true;
    }
    return false;
}
function $6e7fc0f961bc64aa$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($6e7fc0f961bc64aa$export$5b89d4b643713034(el)) return;
    $6e7fc0f961bc64aa$var$animateOrSetProps('remove', el, props, animatableModel, dataIndex, cb, during);
}
function $6e7fc0f961bc64aa$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $6e7fc0f961bc64aa$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $6e7fc0f961bc64aa$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    } // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $6e7fc0f961bc64aa$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $6e7fc0f961bc64aa$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $6e7fc0f961bc64aa$export$bca7290a9faf0ec9(el) {
    $6e7fc0f961bc64aa$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $6e7fc0f961bc64aa$export$ccb1f1e4d2fa86ac(el) {
    return $6e7fc0f961bc64aa$export$ae7433df314f6ec3(el).oldStyle;
}

});

parcelRegister("8q0E1", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => $621140689cf5f5fc$export$d0d5398c9d612037);
$parcel$export(module.exports, "extendPath", () => $621140689cf5f5fc$export$53b54a3137026af0);
$parcel$export(module.exports, "registerShape", () => $621140689cf5f5fc$export$2b95b62e3aaf6fdd);
$parcel$export(module.exports, "getShapeClass", () => $621140689cf5f5fc$export$51df4b5565a58189);
$parcel$export(module.exports, "makePath", () => $621140689cf5f5fc$export$aa9bab72412f5613);
$parcel$export(module.exports, "resizePath", () => $621140689cf5f5fc$export$566dbf1c62b04fc7);
$parcel$export(module.exports, "makeImage", () => $621140689cf5f5fc$export$7a2bdede98851ac5);
$parcel$export(module.exports, "mergePath", () => $621140689cf5f5fc$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "subPixelOptimizeLine", () => $621140689cf5f5fc$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $621140689cf5f5fc$export$60e2aa74957d0b9d);
$parcel$export(module.exports, "subPixelOptimize", () => $621140689cf5f5fc$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "getTransform", () => $621140689cf5f5fc$export$fce0c6cfca85ed96);
$parcel$export(module.exports, "applyTransform", () => $621140689cf5f5fc$export$9f9dcb98c894b623);
$parcel$export(module.exports, "transformDirection", () => $621140689cf5f5fc$export$fff94e9792354cfa);
$parcel$export(module.exports, "groupTransition", () => $621140689cf5f5fc$export$64fcab7860c216ae);
$parcel$export(module.exports, "clipPointsByRect", () => $621140689cf5f5fc$export$e2f409471bbbc1dc);
$parcel$export(module.exports, "clipRectByRect", () => $621140689cf5f5fc$export$d0d3709202b8b2a);
$parcel$export(module.exports, "createIcon", () => $621140689cf5f5fc$export$274edc73af1ae9c8);
$parcel$export(module.exports, "linePolygonIntersect", () => $621140689cf5f5fc$export$4f47c855a5e9ae9);
$parcel$export(module.exports, "lineLineIntersect", () => $621140689cf5f5fc$export$6c0a70ea1d8d158b);
$parcel$export(module.exports, "setTooltipConfig", () => $621140689cf5f5fc$export$fc6410d97fab306c);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("9ubot")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("9ubot")).initProps);
$parcel$export(module.exports, "removeElement", () => (parcelRequire("9ubot")).removeElement);
$parcel$export(module.exports, "removeElementWithFadeOut", () => (parcelRequire("9ubot")).removeElementWithFadeOut);
$parcel$export(module.exports, "isElementRemoved", () => (parcelRequire("9ubot")).isElementRemoved);
$parcel$export(module.exports, "Group", () => (parcelRequire("hXAsm")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("agXnr")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("kiooD")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("aYBv9")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("gwELx")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("rnA7j")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("IXyXP")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("cjY1b")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("9dsiU")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("aeCKo")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("15UDR")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("6RZy2")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("iMbRE")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("4Nii9")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("juJV6")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("4kdki")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("hkgm4")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("lGSv6")).default);
$parcel$export(module.exports, "OrientedBoundingRect", () => (parcelRequire("fi3eW")).default);
$parcel$export(module.exports, "Point", () => (parcelRequire("4vVC3")).default);
$parcel$export(module.exports, "Path", () => (parcelRequire("hMiip")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lJlYD = parcelRequire("lJlYD");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $hMiip = parcelRequire("hMiip");

var $kVlB5 = parcelRequire("kVlB5");

var $agXnr = parcelRequire("agXnr");

var $hXAsm = parcelRequire("hXAsm");

var $kiooD = parcelRequire("kiooD");

var $aYBv9 = parcelRequire("aYBv9");

var $gwELx = parcelRequire("gwELx");

var $rnA7j = parcelRequire("rnA7j");

var $IXyXP = parcelRequire("IXyXP");

var $cjY1b = parcelRequire("cjY1b");

var $9dsiU = parcelRequire("9dsiU");

var $aeCKo = parcelRequire("aeCKo");

var $15UDR = parcelRequire("15UDR");

var $6RZy2 = parcelRequire("6RZy2");

var $iMbRE = parcelRequire("iMbRE");

var $juJV6 = parcelRequire("juJV6");

var $4kdki = parcelRequire("4kdki");

var $hkgm4 = parcelRequire("hkgm4");

var $lGSv6 = parcelRequire("lGSv6");

var $fi3eW = parcelRequire("fi3eW");

var $4vVC3 = parcelRequire("4vVC3");

var $4Nii9 = parcelRequire("4Nii9");

var $kXoFx = parcelRequire("kXoFx");

var $hzBt5 = parcelRequire("hzBt5");

var $aly4X = parcelRequire("aly4X");

var $9ubot = parcelRequire("9ubot");
var $621140689cf5f5fc$var$mathMax = Math.max;
var $621140689cf5f5fc$var$mathMin = Math.min;
var $621140689cf5f5fc$var$_customShapeMap = {};
function $621140689cf5f5fc$export$d0d5398c9d612037(opts) {
    return (0, $hMiip.default).extend(opts);
}
var $621140689cf5f5fc$var$extendPathFromString = $lJlYD.extendFromString;
function $621140689cf5f5fc$export$53b54a3137026af0(pathData, opts) {
    return $621140689cf5f5fc$var$extendPathFromString(pathData, opts);
}
function $621140689cf5f5fc$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $621140689cf5f5fc$var$_customShapeMap[name] = ShapeClass;
}
function $621140689cf5f5fc$export$51df4b5565a58189(name) {
    if ($621140689cf5f5fc$var$_customShapeMap.hasOwnProperty(name)) return $621140689cf5f5fc$var$_customShapeMap[name];
}
function $621140689cf5f5fc$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $lJlYD.createFromString(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $621140689cf5f5fc$var$centerGraphic(rect, path.getBoundingRect());
        $621140689cf5f5fc$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $621140689cf5f5fc$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $agXnr.default)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($621140689cf5f5fc$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $621140689cf5f5fc$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $621140689cf5f5fc$export$7b1dd269fbc4e903 = $lJlYD.mergePath;
function $621140689cf5f5fc$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $621140689cf5f5fc$export$8b4b620d7f4aad1b(param) {
    $kXoFx.subPixelOptimizeLine(param.shape, param.shape, param.style);
    return param;
}
function $621140689cf5f5fc$export$60e2aa74957d0b9d(param) {
    $kXoFx.subPixelOptimizeRect(param.shape, param.shape, param.style);
    return param;
}
var $621140689cf5f5fc$export$72c4fd4c1b8fcb10 = $kXoFx.subPixelOptimize;
function $621140689cf5f5fc$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $crEgd.identity([]);
    while(target && target !== ancestor){
        $crEgd.mul(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $621140689cf5f5fc$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $hzBt5.isArrayLike)(transform)) transform = (0, $kVlB5.default).getLocalTransform(transform);
    if (invert) transform = $crEgd.invert([], transform);
    return $ef5pP.applyTransform([], target, transform);
}
function $621140689cf5f5fc$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $621140689cf5f5fc$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $621140689cf5f5fc$var$isNotGroup(el) {
    return !el.isGroup;
}
function $621140689cf5f5fc$var$isPath(el) {
    return el.shape != null;
}
function $621140689cf5f5fc$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($621140689cf5f5fc$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($621140689cf5f5fc$var$isPath(el)) obj.shape = (0, $hzBt5.extend)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($621140689cf5f5fc$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $9ubot.updateProps)(el, newProp, animatableModel, (0, $aly4X.getECData)(el).dataIndex);
            }
        }
    });
}
function $621140689cf5f5fc$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: this way migth be incorrect when grpahic clipped by a corner.
    // and when element have border.
    return (0, $hzBt5.map)(points, function(point) {
        var x = point[0];
        x = $621140689cf5f5fc$var$mathMax(x, rect.x);
        x = $621140689cf5f5fc$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $621140689cf5f5fc$var$mathMax(y, rect.y);
        y = $621140689cf5f5fc$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $621140689cf5f5fc$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $621140689cf5f5fc$var$mathMax(targetRect.x, rect.x);
    var x2 = $621140689cf5f5fc$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $621140689cf5f5fc$var$mathMax(targetRect.y, rect.y);
    var y2 = $621140689cf5f5fc$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $621140689cf5f5fc$export$274edc73af1ae9c8(iconStr, opt, rect) {
    var innerOpts = (0, $hzBt5.extend)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $hzBt5.defaults)(style, rect), new (0, $agXnr.default)(innerOpts)) : $621140689cf5f5fc$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $621140689cf5f5fc$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($621140689cf5f5fc$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $621140689cf5f5fc$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
    //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $621140689cf5f5fc$var$crossProduct2d(nx, ny, mx, my);
    if ($621140689cf5f5fc$var$nearZero(nmCrossProduct)) return false;
     // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $621140689cf5f5fc$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $621140689cf5f5fc$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $621140689cf5f5fc$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $621140689cf5f5fc$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $621140689cf5f5fc$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $hzBt5.isString)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $hzBt5.each)((0, $hzBt5.keys)(formatterParamsExtra), function(key) {
        if (!(0, $hzBt5.hasOwn)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $aly4X.getECData)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $hzBt5.defaults)({
            content: itemName,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('circle', (0, $aYBv9.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('ellipse', (0, $gwELx.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('sector', (0, $rnA7j.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('ring', (0, $IXyXP.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('polygon', (0, $cjY1b.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('polyline', (0, $9dsiU.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('rect', (0, $aeCKo.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('line', (0, $15UDR.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('bezierCurve', (0, $6RZy2.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('arc', (0, $iMbRE.default));

});
parcelRegister("lJlYD", function(module, exports) {

$parcel$export(module.exports, "createFromString", () => $fd1ed9183e095324$export$ae5b259626f00aeb);
$parcel$export(module.exports, "extendFromString", () => $fd1ed9183e095324$export$68e3a51ba2ed417c);
$parcel$export(module.exports, "mergePath", () => $fd1ed9183e095324$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "clonePath", () => $fd1ed9183e095324$export$18711d956bf1c3eb);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $fvvgx = parcelRequire("fvvgx");

var $hjFOF = parcelRequire("hjFOF");

var $hzBt5 = parcelRequire("hzBt5");
var $fd1ed9183e095324$var$mathSqrt = Math.sqrt;
var $fd1ed9183e095324$var$mathSin = Math.sin;
var $fd1ed9183e095324$var$mathCos = Math.cos;
var $fd1ed9183e095324$var$PI = Math.PI;
function $fd1ed9183e095324$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $fd1ed9183e095324$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($fd1ed9183e095324$var$vMag(u) * $fd1ed9183e095324$var$vMag(v));
}
function $fd1ed9183e095324$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($fd1ed9183e095324$var$vRatio(u, v));
}
function $fd1ed9183e095324$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($fd1ed9183e095324$var$PI / 180.0);
    var xp = $fd1ed9183e095324$var$mathCos(psi) * (x1 - x2) / 2.0 + $fd1ed9183e095324$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $fd1ed9183e095324$var$mathSin(psi) * (x1 - x2) / 2.0 + $fd1ed9183e095324$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $fd1ed9183e095324$var$mathSqrt(lambda);
        ry *= $fd1ed9183e095324$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $fd1ed9183e095324$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $fd1ed9183e095324$var$mathCos(psi) * cxp - $fd1ed9183e095324$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $fd1ed9183e095324$var$mathSin(psi) * cxp + $fd1ed9183e095324$var$mathCos(psi) * cyp;
    var theta = $fd1ed9183e095324$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $fd1ed9183e095324$var$vAngle(u, v);
    if ($fd1ed9183e095324$var$vRatio(u, v) <= -1) dTheta = $fd1ed9183e095324$var$PI;
    if ($fd1ed9183e095324$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $fd1ed9183e095324$var$PI * 1e6) / 1e6;
        dTheta = $fd1ed9183e095324$var$PI * 2 + n % 2 * $fd1ed9183e095324$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $fd1ed9183e095324$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $fd1ed9183e095324$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $fd1ed9183e095324$var$createPathProxyFromString(data) {
    var path = new (0, $fvvgx.default)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $fvvgx.default).CMD;
    var cmdList = data.match($fd1ed9183e095324$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($fd1ed9183e095324$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $fd1ed9183e095324$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $fd1ed9183e095324$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $fd1ed9183e095324$var$SVGPath = function(_super) {
    (0, $fKE23.__extends)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $hMiip.default));
function $fd1ed9183e095324$var$isPathProxy(path) {
    return path.setData != null;
}
function $fd1ed9183e095324$var$createPathOptions(str, opts) {
    var pathProxy = $fd1ed9183e095324$var$createPathProxyFromString(str);
    var innerOpts = (0, $hzBt5.extend)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($fd1ed9183e095324$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $hjFOF.default)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $fd1ed9183e095324$export$ae5b259626f00aeb(str, opts) {
    return new $fd1ed9183e095324$var$SVGPath($fd1ed9183e095324$var$createPathOptions(str, opts));
}
function $fd1ed9183e095324$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $fd1ed9183e095324$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $fKE23.__extends)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($fd1ed9183e095324$var$SVGPath);
    return Sub;
}
function $fd1ed9183e095324$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $hMiip.default)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($fd1ed9183e095324$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $fd1ed9183e095324$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $hMiip.default)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $hjFOF.default)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}

});
parcelRegister("hjFOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b4a5d419004a39$export$2e2bcd8739ae039);

var $fvvgx = parcelRequire("fvvgx");

var $ef5pP = parcelRequire("ef5pP");
var $c9b4a5d419004a39$var$CMD = (0, $fvvgx.default).CMD;
var $c9b4a5d419004a39$var$points = [
    [],
    [],
    []
];
var $c9b4a5d419004a39$var$mathSqrt = Math.sqrt;
var $c9b4a5d419004a39$var$mathAtan2 = Math.atan2;
function $c9b4a5d419004a39$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $c9b4a5d419004a39$var$CMD.M;
    var C = $c9b4a5d419004a39$var$CMD.C;
    var L = $c9b4a5d419004a39$var$CMD.L;
    var R = $c9b4a5d419004a39$var$CMD.R;
    var A = $c9b4a5d419004a39$var$CMD.A;
    var Q = $c9b4a5d419004a39$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $c9b4a5d419004a39$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $c9b4a5d419004a39$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $c9b4a5d419004a39$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $ef5pP.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $ef5pP.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $c9b4a5d419004a39$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $ef5pP.applyTransform)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}

});


parcelRegister("hXAsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13439d8c81e093b$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $3MGIU = parcelRequire("3MGIU");

var $lGSv6 = parcelRequire("lGSv6");
var $d13439d8c81e093b$var$Group = function(_super) {
    (0, $fKE23.__extends)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
            if (child.__hostTarget) throw 'This elemenet has been used as an attachment';
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $hzBt5.indexOf(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $hzBt5.indexOf(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $lGSv6.default)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $lGSv6.default).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $3MGIU.default));
$d13439d8c81e093b$var$Group.prototype.type = 'group';
var $d13439d8c81e093b$export$2e2bcd8739ae039 = $d13439d8c81e093b$var$Group;

});

parcelRegister("aYBv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fdc99017af94d1f$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $7fdc99017af94d1f$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $7fdc99017af94d1f$var$Circle = function(_super) {
    (0, $fKE23.__extends)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $7fdc99017af94d1f$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape, inBundle) {
        if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $hMiip.default));
$7fdc99017af94d1f$var$Circle.prototype.type = 'circle';
var $7fdc99017af94d1f$export$2e2bcd8739ae039 = $7fdc99017af94d1f$var$Circle;

});

parcelRegister("gwELx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c07f41b602501a44$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $c07f41b602501a44$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $c07f41b602501a44$var$Ellipse = function(_super) {
    (0, $fKE23.__extends)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $c07f41b602501a44$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $hMiip.default));
$c07f41b602501a44$var$Ellipse.prototype.type = 'ellipse';
var $c07f41b602501a44$export$2e2bcd8739ae039 = $c07f41b602501a44$var$Ellipse;

});

parcelRegister("rnA7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $0524d088410d535e$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $lX4Sm = parcelRequire("lX4Sm");
var $0524d088410d535e$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
        this.innerCornerRadius = 0;
    }
    return SectorShape;
}();
var $0524d088410d535e$var$Sector = function(_super) {
    (0, $fKE23.__extends)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $0524d088410d535e$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $lX4Sm.buildPath(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $hMiip.default));
$0524d088410d535e$var$Sector.prototype.type = 'sector';
var $0524d088410d535e$export$2e2bcd8739ae039 = $0524d088410d535e$var$Sector;

});
parcelRegister("lX4Sm", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $ffb2e3e576a3f168$export$5cc7f731b5937e99);

var $fvvgx = parcelRequire("fvvgx");
var $ffb2e3e576a3f168$var$PI = Math.PI;
var $ffb2e3e576a3f168$var$PI2 = $ffb2e3e576a3f168$var$PI * 2;
var $ffb2e3e576a3f168$var$mathSin = Math.sin;
var $ffb2e3e576a3f168$var$mathCos = Math.cos;
var $ffb2e3e576a3f168$var$mathACos = Math.acos;
var $ffb2e3e576a3f168$var$mathATan2 = Math.atan2;
var $ffb2e3e576a3f168$var$mathAbs = Math.abs;
var $ffb2e3e576a3f168$var$mathSqrt = Math.sqrt;
var $ffb2e3e576a3f168$var$mathMax = Math.max;
var $ffb2e3e576a3f168$var$mathMin = Math.min;
var $ffb2e3e576a3f168$var$e = 1e-4;
function $ffb2e3e576a3f168$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0;
    var y10 = y1 - y0;
    var x32 = x3 - x2;
    var y32 = y3 - y2;
    var t = y32 * x10 - x32 * y10;
    if (t * t < $ffb2e3e576a3f168$var$e) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
function $ffb2e3e576a3f168$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $ffb2e3e576a3f168$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $ffb2e3e576a3f168$var$mathSqrt($ffb2e3e576a3f168$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (radius / r - 1),
        y11: cy0 * (radius / r - 1)
    };
}
function $ffb2e3e576a3f168$export$5cc7f731b5937e99(ctx, shape) {
    var radius = $ffb2e3e576a3f168$var$mathMax(shape.r, 0);
    var innerRadius = $ffb2e3e576a3f168$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var clockwise = !!shape.clockwise;
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var arc;
    if (startAngle === endAngle) arc = 0;
    else {
        var tmpAngles = [
            startAngle,
            endAngle
        ];
        (0, $fvvgx.normalizeArcAngles)(tmpAngles, !clockwise);
        arc = $ffb2e3e576a3f168$var$mathAbs(tmpAngles[0] - tmpAngles[1]);
    }
    var x = shape.cx;
    var y = shape.cy;
    var cornerRadius = shape.cornerRadius || 0;
    var innerCornerRadius = shape.innerCornerRadius || 0;
    if (!(radius > $ffb2e3e576a3f168$var$e)) ctx.moveTo(x, y);
    else if (arc > $ffb2e3e576a3f168$var$PI2 - $ffb2e3e576a3f168$var$e) {
        ctx.moveTo(x + radius * $ffb2e3e576a3f168$var$mathCos(startAngle), y + radius * $ffb2e3e576a3f168$var$mathSin(startAngle));
        ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $ffb2e3e576a3f168$var$e) {
            ctx.moveTo(x + innerRadius * $ffb2e3e576a3f168$var$mathCos(endAngle), y + innerRadius * $ffb2e3e576a3f168$var$mathSin(endAngle));
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var halfRd = $ffb2e3e576a3f168$var$mathAbs(radius - innerRadius) / 2;
        var cr = $ffb2e3e576a3f168$var$mathMin(halfRd, cornerRadius);
        var icr = $ffb2e3e576a3f168$var$mathMin(halfRd, innerCornerRadius);
        var cr0 = icr;
        var cr1 = cr;
        var xrs = radius * $ffb2e3e576a3f168$var$mathCos(startAngle);
        var yrs = radius * $ffb2e3e576a3f168$var$mathSin(startAngle);
        var xire = innerRadius * $ffb2e3e576a3f168$var$mathCos(endAngle);
        var yire = innerRadius * $ffb2e3e576a3f168$var$mathSin(endAngle);
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        if (cr > $ffb2e3e576a3f168$var$e || icr > $ffb2e3e576a3f168$var$e) {
            xre = radius * $ffb2e3e576a3f168$var$mathCos(endAngle);
            yre = radius * $ffb2e3e576a3f168$var$mathSin(endAngle);
            xirs = innerRadius * $ffb2e3e576a3f168$var$mathCos(startAngle);
            yirs = innerRadius * $ffb2e3e576a3f168$var$mathSin(startAngle);
            if (arc < $ffb2e3e576a3f168$var$PI) {
                var it_1 = $ffb2e3e576a3f168$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                if (it_1) {
                    var x0 = xrs - it_1[0];
                    var y0 = yrs - it_1[1];
                    var x1 = xre - it_1[0];
                    var y1 = yre - it_1[1];
                    var a = 1 / $ffb2e3e576a3f168$var$mathSin($ffb2e3e576a3f168$var$mathACos((x0 * x1 + y0 * y1) / ($ffb2e3e576a3f168$var$mathSqrt(x0 * x0 + y0 * y0) * $ffb2e3e576a3f168$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                    var b = $ffb2e3e576a3f168$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                    cr0 = $ffb2e3e576a3f168$var$mathMin(icr, (innerRadius - b) / (a - 1));
                    cr1 = $ffb2e3e576a3f168$var$mathMin(cr, (radius - b) / (a + 1));
                }
            }
        }
        if (!(arc > $ffb2e3e576a3f168$var$e)) ctx.moveTo(x + xrs, y + yrs);
        else if (cr1 > $ffb2e3e576a3f168$var$e) {
            var ct0 = $ffb2e3e576a3f168$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, cr1, clockwise);
            var ct1 = $ffb2e3e576a3f168$var$computeCornerTangents(xre, yre, xire, yire, radius, cr1, clockwise);
            ctx.moveTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr1 < cr) ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, radius, $ffb2e3e576a3f168$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), !clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr1, $ffb2e3e576a3f168$var$mathATan2(ct1.y11, ct1.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.moveTo(x + xrs, y + yrs);
            ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $ffb2e3e576a3f168$var$e) || !(arc > $ffb2e3e576a3f168$var$e)) ctx.lineTo(x + xire, y + yire);
        else if (cr0 > $ffb2e3e576a3f168$var$e) {
            var ct0 = $ffb2e3e576a3f168$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -cr0, clockwise);
            var ct1 = $ffb2e3e576a3f168$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -cr0, clockwise);
            ctx.lineTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr0 < icr) ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, innerRadius, $ffb2e3e576a3f168$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr0, $ffb2e3e576a3f168$var$mathATan2(ct1.y11, ct1.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.lineTo(x + xire, y + yire);
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}

});


parcelRegister("IXyXP", function(module, exports) {

$parcel$export(module.exports, "default", () => $08725022250d2ecb$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $08725022250d2ecb$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $08725022250d2ecb$var$Ring = function(_super) {
    (0, $fKE23.__extends)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $08725022250d2ecb$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $hMiip.default));
$08725022250d2ecb$var$Ring.prototype.type = 'ring';
var $08725022250d2ecb$export$2e2bcd8739ae039 = $08725022250d2ecb$var$Ring;

});

parcelRegister("cjY1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f85d0bf48aed645$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $gF8aT = parcelRequire("gF8aT");
var $8f85d0bf48aed645$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $8f85d0bf48aed645$var$Polygon = function(_super) {
    (0, $fKE23.__extends)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $8f85d0bf48aed645$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $gF8aT.buildPath(ctx, shape, true);
    };
    return Polygon;
}((0, $hMiip.default));
$8f85d0bf48aed645$var$Polygon.prototype.type = 'polygon';
var $8f85d0bf48aed645$export$2e2bcd8739ae039 = $8f85d0bf48aed645$var$Polygon;

});
parcelRegister("gF8aT", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $c216d0fd1dc1bba6$export$5cc7f731b5937e99);

var $6hEuz = parcelRequire("6hEuz");

var $hvEAg = parcelRequire("hvEAg");
function $c216d0fd1dc1bba6$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth && smooth !== 'spline') {
            var controlPoints = (0, $hvEAg.default)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            if (smooth === 'spline') points = (0, $6hEuz.default)(points, closePath);
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}

});
parcelRegister("6hEuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4933bd7906b6b27a$export$2e2bcd8739ae039);

var $ef5pP = parcelRequire("ef5pP");
function $4933bd7906b6b27a$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $4933bd7906b6b27a$export$2e2bcd8739ae039(points, isLoop) {
    var len = points.length;
    var ret = [];
    var distance = 0;
    for(var i = 1; i < len; i++)distance += (0, $ef5pP.distance)(points[i - 1], points[i]);
    var segs = distance / 2;
    segs = segs < len ? len : segs;
    for(var i = 0; i < segs; i++){
        var pos = i / (segs - 1) * (isLoop ? len : len - 1);
        var idx = Math.floor(pos);
        var w = pos - idx;
        var p0 = void 0;
        var p1 = points[idx % len];
        var p2 = void 0;
        var p3 = void 0;
        if (!isLoop) {
            p0 = points[idx === 0 ? idx : idx - 1];
            p2 = points[idx > len - 2 ? len - 1 : idx + 1];
            p3 = points[idx > len - 3 ? len - 1 : idx + 2];
        } else {
            p0 = points[(idx - 1 + len) % len];
            p2 = points[(idx + 1) % len];
            p3 = points[(idx + 2) % len];
        }
        var w2 = w * w;
        var w3 = w * w2;
        ret.push([
            $4933bd7906b6b27a$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
            $4933bd7906b6b27a$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
        ]);
    }
    return ret;
}

});

parcelRegister("hvEAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf4d0096e4ba68b$export$2e2bcd8739ae039);

var $ef5pP = parcelRequire("ef5pP");
function $cbf4d0096e4ba68b$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $ef5pP.min)(min, min, points[i]);
            (0, $ef5pP.max)(max, max, points[i]);
        }
        (0, $ef5pP.min)(min, min, constraint[0]);
        (0, $ef5pP.max)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $ef5pP.clone)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $ef5pP.sub)(v, nextPoint, prevPoint);
        (0, $ef5pP.scale)(v, v, smooth);
        var d0 = (0, $ef5pP.distance)(point, prevPoint);
        var d1 = (0, $ef5pP.distance)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $ef5pP.scale)(v1, v, -d0);
        (0, $ef5pP.scale)(v2, v, d1);
        var cp0 = (0, $ef5pP.add)([], point, v1);
        var cp1 = (0, $ef5pP.add)([], point, v2);
        if (constraint) {
            (0, $ef5pP.max)(cp0, cp0, min);
            (0, $ef5pP.min)(cp0, cp0, max);
            (0, $ef5pP.max)(cp1, cp1, min);
            (0, $ef5pP.min)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}

});



parcelRegister("9dsiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5b488d42c0217d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $gF8aT = parcelRequire("gF8aT");
var $6b5b488d42c0217d$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $6b5b488d42c0217d$var$Polyline = function(_super) {
    (0, $fKE23.__extends)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $6b5b488d42c0217d$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $gF8aT.buildPath(ctx, shape, false);
    };
    return Polyline;
}((0, $hMiip.default));
$6b5b488d42c0217d$var$Polyline.prototype.type = 'polyline';
var $6b5b488d42c0217d$export$2e2bcd8739ae039 = $6b5b488d42c0217d$var$Polyline;

});

parcelRegister("15UDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc231f8d897ee0c$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $kXoFx = parcelRequire("kXoFx");
var $0cc231f8d897ee0c$var$subPixelOptimizeOutputShape = {};
var $0cc231f8d897ee0c$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $0cc231f8d897ee0c$var$Line = function(_super) {
    (0, $fKE23.__extends)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $0cc231f8d897ee0c$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $kXoFx.subPixelOptimizeLine)($0cc231f8d897ee0c$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $hMiip.default));
$0cc231f8d897ee0c$var$Line.prototype.type = 'line';
var $0cc231f8d897ee0c$export$2e2bcd8739ae039 = $0cc231f8d897ee0c$var$Line;

});

parcelRegister("6RZy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $50076f79052695ed$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $ef5pP = parcelRequire("ef5pP");

var $jEMPh = parcelRequire("jEMPh");
var $50076f79052695ed$var$out = [];
var $50076f79052695ed$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $50076f79052695ed$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 === null || cpy2 === null) return [
        (isTangent ? (0, $jEMPh.cubicDerivativeAt) : (0, $jEMPh.cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $jEMPh.cubicDerivativeAt) : (0, $jEMPh.cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $jEMPh.quadraticDerivativeAt) : (0, $jEMPh.quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $jEMPh.quadraticDerivativeAt) : (0, $jEMPh.quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $50076f79052695ed$var$BezierCurve = function(_super) {
    (0, $fKE23.__extends)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $50076f79052695ed$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $jEMPh.quadraticSubdivide)(x1, cpx1, x2, percent, $50076f79052695ed$var$out);
                cpx1 = $50076f79052695ed$var$out[1];
                x2 = $50076f79052695ed$var$out[2];
                (0, $jEMPh.quadraticSubdivide)(y1, cpy1, y2, percent, $50076f79052695ed$var$out);
                cpy1 = $50076f79052695ed$var$out[1];
                y2 = $50076f79052695ed$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $jEMPh.cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $50076f79052695ed$var$out);
                cpx1 = $50076f79052695ed$var$out[1];
                cpx2 = $50076f79052695ed$var$out[2];
                x2 = $50076f79052695ed$var$out[3];
                (0, $jEMPh.cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $50076f79052695ed$var$out);
                cpy1 = $50076f79052695ed$var$out[1];
                cpy2 = $50076f79052695ed$var$out[2];
                y2 = $50076f79052695ed$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $50076f79052695ed$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $50076f79052695ed$var$someVectorAt(this.shape, t, true);
        return $ef5pP.normalize(p, p);
    };
    return BezierCurve;
}((0, $hMiip.default));
$50076f79052695ed$var$BezierCurve.prototype.type = 'bezier-curve';
var $50076f79052695ed$export$2e2bcd8739ae039 = $50076f79052695ed$var$BezierCurve;

});

parcelRegister("iMbRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab5e9b2fa9b51ae$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $dab5e9b2fa9b51ae$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $dab5e9b2fa9b51ae$var$Arc = function(_super) {
    (0, $fKE23.__extends)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $dab5e9b2fa9b51ae$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $hMiip.default));
$dab5e9b2fa9b51ae$var$Arc.prototype.type = 'arc';
var $dab5e9b2fa9b51ae$export$2e2bcd8739ae039 = $dab5e9b2fa9b51ae$var$Arc;

});

parcelRegister("juJV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e314706e508ffa50$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $e314706e508ffa50$var$CompoundPath = function(_super) {
    (0, $fKE23.__extends)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $hMiip.default).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $hMiip.default));
var $e314706e508ffa50$export$2e2bcd8739ae039 = $e314706e508ffa50$var$CompoundPath;

});

parcelRegister("4kdki", function(module, exports) {

$parcel$export(module.exports, "default", () => $32635dfe908dc66c$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $7hVfq = parcelRequire("7hVfq");
var $32635dfe908dc66c$var$LinearGradient = function(_super) {
    (0, $fKE23.__extends)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $7hVfq.default));
var $32635dfe908dc66c$export$2e2bcd8739ae039 = $32635dfe908dc66c$var$LinearGradient;

});
parcelRegister("7hVfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e6872524c8c1af$export$2e2bcd8739ae039);
var $54e6872524c8c1af$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $54e6872524c8c1af$export$2e2bcd8739ae039 = $54e6872524c8c1af$var$Gradient;

});


parcelRegister("hkgm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9d0fda966ea171f$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $7hVfq = parcelRequire("7hVfq");
var $c9d0fda966ea171f$var$RadialGradient = function(_super) {
    (0, $fKE23.__extends)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $7hVfq.default));
var $c9d0fda966ea171f$export$2e2bcd8739ae039 = $c9d0fda966ea171f$var$RadialGradient;

});

parcelRegister("fi3eW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21b0cd71807fe19$export$2e2bcd8739ae039);

var $4vVC3 = parcelRequire("4vVC3");
var $b21b0cd71807fe19$var$extent = [
    0,
    0
];
var $b21b0cd71807fe19$var$extent2 = [
    0,
    0
];
var $b21b0cd71807fe19$var$minTv = new (0, $4vVC3.default)();
var $b21b0cd71807fe19$var$maxTv = new (0, $4vVC3.default)();
var $b21b0cd71807fe19$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $4vVC3.default)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $4vVC3.default)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $4vVC3.default).sub(axes[0], corners[1], corners[0]);
        (0, $4vVC3.default).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $b21b0cd71807fe19$var$minTv.set(Infinity, Infinity);
        $b21b0cd71807fe19$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $b21b0cd71807fe19$var$minTv, $b21b0cd71807fe19$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $b21b0cd71807fe19$var$minTv, $b21b0cd71807fe19$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $4vVC3.default).copy(mtv, overlapped ? $b21b0cd71807fe19$var$minTv : $b21b0cd71807fe19$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $b21b0cd71807fe19$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $b21b0cd71807fe19$var$extent2);
            if ($b21b0cd71807fe19$var$extent[1] < $b21b0cd71807fe19$var$extent2[0] || $b21b0cd71807fe19$var$extent[0] > $b21b0cd71807fe19$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($b21b0cd71807fe19$var$extent2[0] - $b21b0cd71807fe19$var$extent[1]);
                var dist1 = Math.abs($b21b0cd71807fe19$var$extent[0] - $b21b0cd71807fe19$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $4vVC3.default).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $4vVC3.default).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($b21b0cd71807fe19$var$extent2[0] - $b21b0cd71807fe19$var$extent[1]);
                var dist1 = Math.abs($b21b0cd71807fe19$var$extent[0] - $b21b0cd71807fe19$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $4vVC3.default).scale(minTv, axis, dist0 * inverse);
                    else (0, $4vVC3.default).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $b21b0cd71807fe19$export$2e2bcd8739ae039 = $b21b0cd71807fe19$var$OrientedBoundingRect;

});

parcelRegister("4Nii9", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d9ed60c64c2e63$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $lGSv6 = parcelRequire("lGSv6");
var $37d9ed60c64c2e63$var$m = [];
var $37d9ed60c64c2e63$var$IncrementalDisplayable = function(_super) {
    (0, $fKE23.__extends)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $lGSv6.default)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($37d9ed60c64c2e63$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $g1Uer.default));
var $37d9ed60c64c2e63$export$2e2bcd8739ae039 = $37d9ed60c64c2e63$var$IncrementalDisplayable;

});




parcelRegister("5jmEk", function(module, exports) {

$parcel$export(module.exports, "LINE_STYLE_KEY_MAP", () => $3de04bca35753861$export$9f34de5b59222949);
$parcel$export(module.exports, "LineStyleMixin", () => $3de04bca35753861$export$91eeeeed4a69a7e7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6CLz8 = parcelRequire("6CLz8");
var $3de04bca35753861$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $3de04bca35753861$var$getLineStyle = (0, $6CLz8.default)($3de04bca35753861$export$9f34de5b59222949);
var $3de04bca35753861$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $3de04bca35753861$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();

});

parcelRegister("9N9yS", function(module, exports) {

$parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", () => $72101b64c983bec9$export$ffb0bba5dde0130b);
$parcel$export(module.exports, "ItemStyleMixin", () => $72101b64c983bec9$export$e4f01e48d6fda412);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6CLz8 = parcelRequire("6CLz8");
var $72101b64c983bec9$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $72101b64c983bec9$var$getItemStyle = (0, $6CLz8.default)($72101b64c983bec9$export$ffb0bba5dde0130b);
var $72101b64c983bec9$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $72101b64c983bec9$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();

});


parcelRegister("9aOrz", function(module, exports) {

$parcel$export(module.exports, "getUID", () => $6adc2d455c74fe49$export$6d2b3473b0986646);
$parcel$export(module.exports, "enableSubTypeDefaulter", () => $6adc2d455c74fe49$export$b9faf30b7d655a6f);
$parcel$export(module.exports, "enableTopologicalTravel", () => $6adc2d455c74fe49$export$ce592d345a3ec040);
$parcel$export(module.exports, "inheritDefaultOption", () => $6adc2d455c74fe49$export$68acc510e46fef2);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $jKrBG = parcelRequire("jKrBG");

var $6adc2d455c74fe49$var$base = Math.round(Math.random() * 10);
function $6adc2d455c74fe49$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $6adc2d455c74fe49$var$base++
    ].join('_');
}
function $6adc2d455c74fe49$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $jKrBG.parseClassType)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $jKrBG.parseClassType)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $6adc2d455c74fe49$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $hzBt5.each(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $hzBt5.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $hzBt5.each(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        } // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $hzBt5.each(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $hzBt5.each(availableDeps, function(dependentName) {
                if ($hzBt5.indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($hzBt5.indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $hzBt5.each(originalDeps, function(dep) {
            $hzBt5.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $6adc2d455c74fe49$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $hzBt5.merge($hzBt5.merge({}, superOption, true), subOption, true);
}

});

parcelRegister("e4mIu", function(module, exports) {

$parcel$export(module.exports, "LOCATION_PARAMS", () => $a3e30f76c81a3bfd$export$a9aa2cc018afbed);
$parcel$export(module.exports, "box", () => $a3e30f76c81a3bfd$export$827f4ee28efc37);
$parcel$export(module.exports, "getAvailableSize", () => $a3e30f76c81a3bfd$export$145a8938a85a22b1);
$parcel$export(module.exports, "getLayoutRect", () => $a3e30f76c81a3bfd$export$4517a5ca639a7293);
$parcel$export(module.exports, "positionElement", () => $a3e30f76c81a3bfd$export$74054bd96b5eeef1);
$parcel$export(module.exports, "sizeCalculable", () => $a3e30f76c81a3bfd$export$7ede609e8ebc9650);
$parcel$export(module.exports, "fetchLayoutMode", () => $a3e30f76c81a3bfd$export$3968a28a7cbd6063);
$parcel$export(module.exports, "mergeLayoutParam", () => $a3e30f76c81a3bfd$export$1754cb91f16ca028);
$parcel$export(module.exports, "getLayoutParams", () => $a3e30f76c81a3bfd$export$4b0d20af19c9875e);
$parcel$export(module.exports, "copyLayoutParams", () => $a3e30f76c81a3bfd$export$7438999faea9b6cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning

var $hzBt5 = parcelRequire("hzBt5");

var $lGSv6 = parcelRequire("lGSv6");

var $5BQXp = parcelRequire("5BQXp");

var $gyplX = parcelRequire("gyplX");
var $a3e30f76c81a3bfd$var$each = $hzBt5.each;
var $a3e30f76c81a3bfd$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $a3e30f76c81a3bfd$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $a3e30f76c81a3bfd$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $a3e30f76c81a3bfd$export$827f4ee28efc37 = $a3e30f76c81a3bfd$var$boxLayout;
var $a3e30f76c81a3bfd$export$be20d9158c17374c = $hzBt5.curry($a3e30f76c81a3bfd$var$boxLayout, 'vertical');
var $a3e30f76c81a3bfd$export$ae65a483d943e7a7 = $hzBt5.curry($a3e30f76c81a3bfd$var$boxLayout, 'horizontal');
function $a3e30f76c81a3bfd$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $5BQXp.parsePercent)(positionInfo.left, containerWidth);
    var y = (0, $5BQXp.parsePercent)(positionInfo.top, containerHeight);
    var x2 = (0, $5BQXp.parsePercent)(positionInfo.right, containerWidth);
    var y2 = (0, $5BQXp.parsePercent)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $gyplX.normalizeCssArray(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $a3e30f76c81a3bfd$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $gyplX.normalizeCssArray(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $5BQXp.parsePercent)(positionInfo.left, containerWidth);
    var top = (0, $5BQXp.parsePercent)(positionInfo.top, containerHeight);
    var right = (0, $5BQXp.parsePercent)(positionInfo.right, containerWidth);
    var bottom = (0, $5BQXp.parsePercent)(positionInfo.bottom, containerHeight);
    var width = (0, $5BQXp.parsePercent)(positionInfo.width, containerWidth);
    var height = (0, $5BQXp.parsePercent)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        } // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    } // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
     // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    } // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $lGSv6.default)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $a3e30f76c81a3bfd$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    if (!h && !v) return;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $lGSv6.default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    } // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $a3e30f76c81a3bfd$export$4517a5ca639a7293($hzBt5.defaults({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        el.x = dx;
        el.y = dy;
    } else {
        el.x += dx;
        el.y += dy;
    }
    el.markRedraw();
}
function $a3e30f76c81a3bfd$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$a3e30f76c81a3bfd$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$a3e30f76c81a3bfd$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$a3e30f76c81a3bfd$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $a3e30f76c81a3bfd$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $hzBt5.isObject(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $a3e30f76c81a3bfd$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$hzBt5.isArray(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($a3e30f76c81a3bfd$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($a3e30f76c81a3bfd$export$d7fd4338c7b20804[1], 1);
    copy($a3e30f76c81a3bfd$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($a3e30f76c81a3bfd$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $a3e30f76c81a3bfd$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $a3e30f76c81a3bfd$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        } // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $a3e30f76c81a3bfd$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $a3e30f76c81a3bfd$export$4b0d20af19c9875e(source) {
    return $a3e30f76c81a3bfd$export$7438999faea9b6cc({}, source);
}
function $a3e30f76c81a3bfd$export$7438999faea9b6cc(target, source) {
    source && target && $a3e30f76c81a3bfd$var$each($a3e30f76c81a3bfd$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}

});
parcelRegister("gyplX", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => $c0d37cf36ea6f267$export$b6fe44657ce35c42);
$parcel$export(module.exports, "toCamelCase", () => $c0d37cf36ea6f267$export$86f54f62aa7a7514);
$parcel$export(module.exports, "normalizeCssArray", () => $c0d37cf36ea6f267$export$f3a38102c49f4268);
$parcel$export(module.exports, "encodeHTML", () => $c0d37cf36ea6f267$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "makeValueReadable", () => $c0d37cf36ea6f267$export$3cd8db88714decfc);
$parcel$export(module.exports, "formatTpl", () => $c0d37cf36ea6f267$export$2028496a35766e41);
$parcel$export(module.exports, "formatTplSimple", () => $c0d37cf36ea6f267$export$2fa08233ee42f8e1);
$parcel$export(module.exports, "getTooltipMarker", () => $c0d37cf36ea6f267$export$1987a3dbdf3c45ca);
$parcel$export(module.exports, "formatTime", () => $c0d37cf36ea6f267$export$3203edd9e5edd663);
$parcel$export(module.exports, "capitalFirst", () => $c0d37cf36ea6f267$export$38a1e7552f497c0e);
$parcel$export(module.exports, "convertToColorString", () => $c0d37cf36ea6f267$export$cda04d03233e5555);
$parcel$export(module.exports, "windowOpen", () => $c0d37cf36ea6f267$export$13e13f9b96dbe8fa);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $24InP = parcelRequire("24InP");


var $h0yya = parcelRequire("h0yya");

var $iluMW = parcelRequire("iluMW");
function $c0d37cf36ea6f267$export$b6fe44657ce35c42(x) {
    if (!(0, $5BQXp.isNumeric)(x)) return $hzBt5.isString(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $c0d37cf36ea6f267$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $c0d37cf36ea6f267$export$f3a38102c49f4268 = $hzBt5.normalizeCssArray;
var $c0d37cf36ea6f267$var$replaceReg = /([&<>"'])/g;
var $c0d37cf36ea6f267$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $c0d37cf36ea6f267$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($c0d37cf36ea6f267$var$replaceReg, function(str, c) {
        return $c0d37cf36ea6f267$var$replaceMap[c];
    });
}
function $c0d37cf36ea6f267$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $hzBt5.trim(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $5BQXp.parseDate)(value) : value;
        if (!isNaN(+date)) return (0, $24InP.format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
         // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $hzBt5.isStringSafe(value) ? stringToUserReadable(value) : $hzBt5.isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
     // By default.
    var numericResult = (0, $5BQXp.numericToNumber)(value);
    return isNumberUserReadable(numericResult) ? $c0d37cf36ea6f267$export$b6fe44657ce35c42(numericResult) : $hzBt5.isStringSafe(value) ? stringToUserReadable(value) : '-';
}
var $c0d37cf36ea6f267$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $c0d37cf36ea6f267$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $c0d37cf36ea6f267$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$hzBt5.isArray(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $c0d37cf36ea6f267$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($c0d37cf36ea6f267$var$wrapVar(alias), $c0d37cf36ea6f267$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($c0d37cf36ea6f267$var$wrapVar($c0d37cf36ea6f267$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $c0d37cf36ea6f267$export$f9d6449b9af28dc1(val) : val);
    }
    return tpl;
}
function $c0d37cf36ea6f267$export$2fa08233ee42f8e1(tpl, param, encode) {
    $hzBt5.each(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? $c0d37cf36ea6f267$export$f9d6449b9af28dc1(value) : value);
    });
    return tpl;
}
function $c0d37cf36ea6f267$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $hzBt5.isString(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' // Only support string
     + $c0d37cf36ea6f267$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + $c0d37cf36ea6f267$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $c0d37cf36ea6f267$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $5BQXp.parseDate)(value);
    var utc = isUTC ? 'UTC' : '';
    var y = date['get' + utc + 'FullYear']();
    var M = date['get' + utc + 'Month']() + 1;
    var d = date['get' + utc + 'Date']();
    var h = date['get' + utc + 'Hours']();
    var m = date['get' + utc + 'Minutes']();
    var s = date['get' + utc + 'Seconds']();
    var S = date['get' + utc + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $24InP.pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', (0, $24InP.pad)(d, 2)).replace('d', d).replace('hh', (0, $24InP.pad)(h, 2)).replace('h', h).replace('mm', (0, $24InP.pad)(m, 2)).replace('m', m).replace('ss', (0, $24InP.pad)(s, 2)).replace('s', s).replace('SSS', (0, $24InP.pad)(S, 3));
    return tpl;
}
function $c0d37cf36ea6f267$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $c0d37cf36ea6f267$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $hzBt5.isString(color) ? color : $hzBt5.isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $c0d37cf36ea6f267$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}

});
parcelRegister("24InP", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", () => $182e621785d53987$export$32c0454ceff7f92d);
$parcel$export(module.exports, "ONE_MINUTE", () => $182e621785d53987$export$35acaebf644db34e);
$parcel$export(module.exports, "ONE_HOUR", () => $182e621785d53987$export$82541edf19e5e3b0);
$parcel$export(module.exports, "ONE_DAY", () => $182e621785d53987$export$a97a1358cbb650ab);
$parcel$export(module.exports, "ONE_YEAR", () => $182e621785d53987$export$99cafda57477293d);
$parcel$export(module.exports, "fullLeveledFormatter", () => $182e621785d53987$export$445bdbd8d2334e40);
$parcel$export(module.exports, "timeUnits", () => $182e621785d53987$export$833c398a55654bb7);
$parcel$export(module.exports, "pad", () => $182e621785d53987$export$5d04458e2a6c373e);
$parcel$export(module.exports, "getPrimaryTimeUnit", () => $182e621785d53987$export$1da4b91a25d7e1c8);
$parcel$export(module.exports, "isPrimaryTimeUnit", () => $182e621785d53987$export$beb5920b69c13da);
$parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", () => $182e621785d53987$export$124c820721c4f66b);
$parcel$export(module.exports, "format", () => $182e621785d53987$export$d9468344d3651243);
$parcel$export(module.exports, "fullYearGetterName", () => $182e621785d53987$export$8d046fefed9a548e);
$parcel$export(module.exports, "monthGetterName", () => $182e621785d53987$export$5c242a801a23eec7);
$parcel$export(module.exports, "dateGetterName", () => $182e621785d53987$export$4189e6cbc9753260);
$parcel$export(module.exports, "hoursGetterName", () => $182e621785d53987$export$8b40b55b3c06cbe2);
$parcel$export(module.exports, "minutesGetterName", () => $182e621785d53987$export$8807847c5c71eded);
$parcel$export(module.exports, "secondsGetterName", () => $182e621785d53987$export$8f49e73e2eebd168);
$parcel$export(module.exports, "millisecondsGetterName", () => $182e621785d53987$export$312207a92d041116);
$parcel$export(module.exports, "leveledFormat", () => $182e621785d53987$export$fe777b6293828b5d);
$parcel$export(module.exports, "getUnitValue", () => $182e621785d53987$export$e04e41a1e24ffd3f);
$parcel$export(module.exports, "fullYearSetterName", () => $182e621785d53987$export$43fbeac90913b151);
$parcel$export(module.exports, "monthSetterName", () => $182e621785d53987$export$233f59998ed71c09);
$parcel$export(module.exports, "dateSetterName", () => $182e621785d53987$export$82fd379a67f37fa0);
$parcel$export(module.exports, "hoursSetterName", () => $182e621785d53987$export$b6f943e8d23c15bb);
$parcel$export(module.exports, "minutesSetterName", () => $182e621785d53987$export$50303078793fc7d);
$parcel$export(module.exports, "secondsSetterName", () => $182e621785d53987$export$a4a908acda9c3118);
$parcel$export(module.exports, "millisecondsSetterName", () => $182e621785d53987$export$c047afab75f6d84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $6FMoP = parcelRequire("6FMoP");

var $fR3z1 = parcelRequire("fR3z1");
var $182e621785d53987$export$32c0454ceff7f92d = 1000;
var $182e621785d53987$export$35acaebf644db34e = $182e621785d53987$export$32c0454ceff7f92d * 60;
var $182e621785d53987$export$82541edf19e5e3b0 = $182e621785d53987$export$35acaebf644db34e * 60;
var $182e621785d53987$export$a97a1358cbb650ab = $182e621785d53987$export$82541edf19e5e3b0 * 24;
var $182e621785d53987$export$99cafda57477293d = $182e621785d53987$export$a97a1358cbb650ab * 365;
var $182e621785d53987$export$f7854271ddbda64e = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}',
    none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var $182e621785d53987$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $182e621785d53987$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $182e621785d53987$var$fullDayFormatter,
    hour: $182e621785d53987$var$fullDayFormatter + ' ' + $182e621785d53987$export$f7854271ddbda64e.hour,
    minute: $182e621785d53987$var$fullDayFormatter + ' ' + $182e621785d53987$export$f7854271ddbda64e.minute,
    second: $182e621785d53987$var$fullDayFormatter + ' ' + $182e621785d53987$export$f7854271ddbda64e.second,
    millisecond: $182e621785d53987$export$f7854271ddbda64e.none
};
var $182e621785d53987$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $182e621785d53987$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $182e621785d53987$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $182e621785d53987$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $182e621785d53987$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $182e621785d53987$export$1da4b91a25d7e1c8(timeUnit);
}
function $182e621785d53987$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $182e621785d53987$export$d9468344d3651243(// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $5BQXp.parseDate(time);
    var y = date[$182e621785d53987$export$8d046fefed9a548e(isUTC)]();
    var M = date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 4) + 1;
    var d = date[$182e621785d53987$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$182e621785d53987$export$8807847c5c71eded(isUTC)]();
    var s = date[$182e621785d53987$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$182e621785d53987$export$312207a92d041116(isUTC)]();
    var localeModel = lang instanceof (0, $fR3z1.default) ? lang : (0, $6FMoP.getLocaleModel)(lang || (0, $6FMoP.SYSTEM_LANG)) || (0, $6FMoP.getDefaultLocaleModel)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $182e621785d53987$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $182e621785d53987$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $182e621785d53987$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $182e621785d53987$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $182e621785d53987$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $182e621785d53987$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $182e621785d53987$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $182e621785d53987$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if (typeof formatter === 'string') // Single formatter for all units at all levels
    template = formatter;
    else if (typeof formatter === 'function') // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $hzBt5.extend({}, $182e621785d53987$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $182e621785d53987$export$87100da04d711986.length; ++i)defaults[$182e621785d53987$export$87100da04d711986[i]] = "{primary|" + defaults[$182e621785d53987$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $hzBt5.defaults(formatter, defaults) : defaults;
        var unit = $182e621785d53987$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $182e621785d53987$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($hzBt5.isArray(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $182e621785d53987$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $182e621785d53987$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $5BQXp.parseDate(value);
    var M = date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$182e621785d53987$export$4189e6cbc9753260(isUTC)]();
    var h = date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$182e621785d53987$export$8807847c5c71eded(isUTC)]();
    var s = date[$182e621785d53987$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$182e621785d53987$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $182e621785d53987$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = typeof value === 'number' ? $5BQXp.parseDate(value) : value;
    unit = unit || $182e621785d53987$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case 'year':
            return date[$182e621785d53987$export$8d046fefed9a548e(isUTC)]();
        case 'half-year':
            return date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case 'quarter':
            return Math.floor((date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case 'month':
            return date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]();
        case 'day':
            return date[$182e621785d53987$export$4189e6cbc9753260(isUTC)]();
        case 'half-day':
            return date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case 'hour':
            return date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]();
        case 'minute':
            return date[$182e621785d53987$export$8807847c5c71eded(isUTC)]();
        case 'second':
            return date[$182e621785d53987$export$8f49e73e2eebd168(isUTC)]();
        case 'millisecond':
            return date[$182e621785d53987$export$312207a92d041116(isUTC)]();
    }
}
function $182e621785d53987$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $182e621785d53987$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $182e621785d53987$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $182e621785d53987$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $182e621785d53987$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $182e621785d53987$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $182e621785d53987$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $182e621785d53987$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $182e621785d53987$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $182e621785d53987$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $182e621785d53987$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $182e621785d53987$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $182e621785d53987$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $182e621785d53987$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}

});
parcelRegister("6FMoP", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_LANG", () => $4dbc1d8df02dcff2$export$9a2147b3808d4c6b);
$parcel$export(module.exports, "registerLocale", () => $4dbc1d8df02dcff2$export$bab6a7822cc1e2cd);
$parcel$export(module.exports, "createLocaleObject", () => $4dbc1d8df02dcff2$export$ddc371781a6af754);
$parcel$export(module.exports, "getLocaleModel", () => $4dbc1d8df02dcff2$export$37cc638e0e11865f);
$parcel$export(module.exports, "getDefaultLocaleModel", () => $4dbc1d8df02dcff2$export$1188f179b2597821);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fR3z1 = parcelRequire("fR3z1");

var $gZXYp = parcelRequire("gZXYp");

var $4Osf0 = parcelRequire("4Osf0");

var $jOSzM = parcelRequire("jOSzM");

var $hzBt5 = parcelRequire("hzBt5");
var $4dbc1d8df02dcff2$var$LOCALE_ZH = 'ZH';
var $4dbc1d8df02dcff2$var$LOCALE_EN = 'EN';
var $4dbc1d8df02dcff2$var$DEFAULT_LOCALE = $4dbc1d8df02dcff2$var$LOCALE_EN;
var $4dbc1d8df02dcff2$var$localeStorage = {};
var $4dbc1d8df02dcff2$var$localeModels = {};
var $4dbc1d8df02dcff2$export$9a2147b3808d4c6b = !(0, $gZXYp.default).domSupported ? $4dbc1d8df02dcff2$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
    return langStr.indexOf($4dbc1d8df02dcff2$var$LOCALE_ZH) > -1 ? $4dbc1d8df02dcff2$var$LOCALE_ZH : $4dbc1d8df02dcff2$var$DEFAULT_LOCALE;
}();
function $4dbc1d8df02dcff2$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $4dbc1d8df02dcff2$var$localeModels[locale] = new (0, $fR3z1.default)(localeObj);
    $4dbc1d8df02dcff2$var$localeStorage[locale] = localeObj;
} // export function getLocale(locale: string) {
function $4dbc1d8df02dcff2$export$ddc371781a6af754(locale) {
    if ((0, $hzBt5.isString)(locale)) {
        var localeObj = $4dbc1d8df02dcff2$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $4dbc1d8df02dcff2$var$LOCALE_ZH || locale === $4dbc1d8df02dcff2$var$LOCALE_EN) return (0, $hzBt5.clone)(localeObj);
        else return (0, $hzBt5.merge)((0, $hzBt5.clone)(localeObj), (0, $hzBt5.clone)($4dbc1d8df02dcff2$var$localeStorage[$4dbc1d8df02dcff2$var$DEFAULT_LOCALE]), false);
    } else return (0, $hzBt5.merge)((0, $hzBt5.clone)(locale), (0, $hzBt5.clone)($4dbc1d8df02dcff2$var$localeStorage[$4dbc1d8df02dcff2$var$DEFAULT_LOCALE]), false);
}
function $4dbc1d8df02dcff2$export$37cc638e0e11865f(lang) {
    return $4dbc1d8df02dcff2$var$localeModels[lang];
}
function $4dbc1d8df02dcff2$export$1188f179b2597821() {
    return $4dbc1d8df02dcff2$var$localeModels[$4dbc1d8df02dcff2$var$DEFAULT_LOCALE];
} // Default locale
$4dbc1d8df02dcff2$export$bab6a7822cc1e2cd($4dbc1d8df02dcff2$var$LOCALE_EN, (0, $4Osf0.default));
$4dbc1d8df02dcff2$export$bab6a7822cc1e2cd($4dbc1d8df02dcff2$var$LOCALE_ZH, (0, $jOSzM.default));

});
parcelRegister("4Osf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3811bd09e64260b5$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Language: English.
 */ var $3811bd09e64260b5$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};

});

parcelRegister("jOSzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6dd057bfc6d051a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $e6dd057bfc6d051a$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};

});



parcelRegister("iluMW", function(module, exports) {

$parcel$export(module.exports, "getTextRect", () => $d5b21213a7d74d8d$export$372ffda650a6e70d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kiooD = parcelRequire("kiooD");

var $6ds7H = parcelRequire("6ds7H");
function $d5b21213a7d74d8d$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
    (0, $6ds7H.deprecateLog)('getTextRect is deprecated.');
    var textEl = new (0, $kiooD.default)({
        style: {
            text: text,
            font: font,
            align: align,
            verticalAlign: verticalAlign,
            padding: padding,
            rich: rich,
            overflow: truncate ? 'truncate' : null,
            lineHeight: lineHeight
        }
    });
    return textEl.getBoundingRect();
}

});
parcelRegister("6ds7H", function(module, exports) {

$parcel$export(module.exports, "warn", () => $4869c5acb29c5c18$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $4869c5acb29c5c18$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "deprecateLog", () => $4869c5acb29c5c18$export$4a9c0b74eb885aa1);
$parcel$export(module.exports, "throwError", () => $4869c5acb29c5c18$export$8bf7aba4a9e09055);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4869c5acb29c5c18$var$ECHARTS_PREFIX = '[ECharts] ';
var $4869c5acb29c5c18$var$storedLogs = {};
var $4869c5acb29c5c18$var$hasConsole = typeof console !== 'undefined' // eslint-disable-next-line
 && console.warn && console.log;
function $4869c5acb29c5c18$export$bef1f36f5486a6a3(str) {
    if ($4869c5acb29c5c18$var$hasConsole) // eslint-disable-next-line
    console.log($4869c5acb29c5c18$var$ECHARTS_PREFIX + str);
}
function $4869c5acb29c5c18$export$c106dd0671a0fc2d(str) {
    if ($4869c5acb29c5c18$var$hasConsole) console.warn($4869c5acb29c5c18$var$ECHARTS_PREFIX + str);
}
function $4869c5acb29c5c18$export$a3bc9b8ed74fc(str) {
    if ($4869c5acb29c5c18$var$hasConsole) console.error($4869c5acb29c5c18$var$ECHARTS_PREFIX + str);
}
function $4869c5acb29c5c18$export$4a9c0b74eb885aa1(str) {}
function $4869c5acb29c5c18$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $4869c5acb29c5c18$export$c3747c611a35af25() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
}
function $4869c5acb29c5c18$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $4869c5acb29c5c18$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}

});





parcelRegister("b7fr8", function(module, exports) {

$parcel$export(module.exports, "PaletteMixin", () => $817c5287d8edb57b$export$55a3c39e852b90f4);
$parcel$export(module.exports, "getDecalFromPalette", () => $817c5287d8edb57b$export$e4d892222945a227);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");
var $817c5287d8edb57b$var$innerColor = (0, $ckizb.makeInner)();
var $817c5287d8edb57b$var$innerDecal = (0, $ckizb.makeInner)();
var $817c5287d8edb57b$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $ckizb.normalizeToArray)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $817c5287d8edb57b$var$getFromPalette(this, $817c5287d8edb57b$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $817c5287d8edb57b$var$clearPalette(this, $817c5287d8edb57b$var$innerColor);
    };
    return PaletteMixin;
}();
function $817c5287d8edb57b$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $ckizb.normalizeToArray)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $817c5287d8edb57b$var$getFromPalette(ecModel, $817c5287d8edb57b$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $817c5287d8edb57b$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length; // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $817c5287d8edb57b$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $817c5287d8edb57b$var$getNearestPalette(layeredPalette, requestNum); // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $817c5287d8edb57b$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}

});

parcelRegister("93uXC", function(module, exports) {

$parcel$export(module.exports, "DataFormatMixin", () => $697c68fc7d38226f$export$f23396ae04ea95a7);
$parcel$export(module.exports, "normalizeTooltipFormatResult", () => $697c68fc7d38226f$export$2d16fa82a50c4741);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $kWuWu = parcelRequire("kWuWu");

var $gyplX = parcelRequire("gyplX");

var $697c68fc7d38226f$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $697c68fc7d38226f$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $hzBt5.isArray(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex); // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if (typeof formatter === 'function') {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if (typeof formatter === 'string') {
            var str = (0, $gyplX.formatTpl)(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($697c68fc7d38226f$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $kWuWu.retrieveRawValue)(data, dataIndex, dimLoose);
                if (extendParams && $hzBt5.isArray(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $kWuWu.retrieveRawValue)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $697c68fc7d38226f$export$2d16fa82a50c4741(result // markersExisting: Dictionary<ColorString>
) {
    var markupText; // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($hzBt5.isObject(result)) {
        if (result.type) markupFragment = result;
         // else {
    } else markupText = result;
    return {
        markupText: markupText,
        // markers: markers || markersExisting,
        markupFragment: markupFragment
    };
}

});
parcelRegister("kWuWu", function(module, exports) {

$parcel$export(module.exports, "DefaultDataProvider", () => $f3f139f138e24c84$export$b900d7c4c3952a40);
$parcel$export(module.exports, "getRawSourceItemGetter", () => $f3f139f138e24c84$export$92c8ea8642b3957d);
$parcel$export(module.exports, "getRawSourceDataCounter", () => $f3f139f138e24c84$export$803742e832f4b52c);
$parcel$export(module.exports, "getRawSourceValueGetter", () => $f3f139f138e24c84$export$1752de8084789a14);
$parcel$export(module.exports, "retrieveRawValue", () => $f3f139f138e24c84$export$cde9373da9aad801);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $8AzOm = parcelRequire("8AzOm");

var $8tpV4 = parcelRequire("8tpV4");
var $f3f139f138e24c84$var$_a, $f3f139f138e24c84$var$_b, $f3f139f138e24c84$var$_c; // TODO
var $f3f139f138e24c84$var$providerMethods;
var $f3f139f138e24c84$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $f3f139f138e24c84$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $8AzOm.isSourceInstance)(sourceParam) ? (0, $8AzOm.createSourceFromSeriesDataOption)(sourceParam) : sourceParam; // declare source is Source;
        this._source = source;
        var data = this._data = source.data; // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $f3f139f138e24c84$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $f3f139f138e24c84$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $f3f139f138e24c84$var$providerMethods[$f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $hzBt5.extend)(provider, methods);
            if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $f3f139f138e24c84$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $hzBt5.bind)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $f3f139f138e24c84$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $hzBt5.bind)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $f3f139f138e24c84$var$providerMethods = (_a = {}, _a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_ROW)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $hzBt5.each)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = {
            appendData: appendDataSimply
        }, _a[0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $f3f139f138e24c84$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $f3f139f138e24c84$var$rawSourceItemGetterMap = ($f3f139f138e24c84$var$_a = {}, $f3f139f138e24c84$var$_a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $f3f139f138e24c84$var$_a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $f3f139f138e24c84$var$_a[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = $f3f139f138e24c84$var$getItemSimply, $f3f139f138e24c84$var$_a[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $f3f139f138e24c84$var$_a[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = $f3f139f138e24c84$var$getItemSimply, $f3f139f138e24c84$var$_a);
function $f3f139f138e24c84$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $f3f139f138e24c84$var$rawSourceItemGetterMap[$f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $f3f139f138e24c84$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $f3f139f138e24c84$var$rawSourceDataCounterMap = ($f3f139f138e24c84$var$_b = {}, $f3f139f138e24c84$var$_b[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $f3f139f138e24c84$var$_b[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $f3f139f138e24c84$var$_b[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = $f3f139f138e24c84$var$countSimply, $f3f139f138e24c84$var$_b[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $f3f139f138e24c84$var$_b[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = $f3f139f138e24c84$var$countSimply, $f3f139f138e24c84$var$_b);
function $f3f139f138e24c84$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $f3f139f138e24c84$var$rawSourceDataCounterMap[$f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $f3f139f138e24c84$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $f3f139f138e24c84$var$rawSourceValueGetterMap = ($f3f139f138e24c84$var$_c = {}, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS] = $f3f139f138e24c84$var$getRawValueSimply, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = $f3f139f138e24c84$var$getRawValueSimply, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $ckizb.getDataItemValue)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY] = $f3f139f138e24c84$var$getRawValueSimply, $f3f139f138e24c84$var$_c);
function $f3f139f138e24c84$export$1752de8084789a14(sourceFormat) {
    var method = $f3f139f138e24c84$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
function $f3f139f138e24c84$export$cde9373da9aad801(data, dataIndex, // Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
     // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $f3f139f138e24c84$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) result = (0, $ckizb.getDataItemValue)(dataItem);
        return result;
    }
}
function $f3f139f138e24c84$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $8tpV4.SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL) && !(0, $hzBt5.isObject)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}

});


parcelRegister("bw304", function(module, exports) {

$parcel$export(module.exports, "createTask", () => $862502a1f4d033e1$export$f7292ab7796be73c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
function $862502a1f4d033e1$export$f7292ab7796be73c(define) {
    return new $862502a1f4d033e1$export$2dea7024bcdd7731(define);
}
var $862502a1f4d033e1$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip; // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
         // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
         // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $hzBt5.isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $862502a1f4d033e1$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $862502a1f4d033e1$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            } // To simplify no progress checking, array must has item.
            if ((0, $hzBt5.isArray)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happend in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the setted end, in case
        // that the stub of dataZoom perform again and earse the
        // setted end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $862502a1f4d033e1$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
         : current;
        current++;
        return result;
    }
}(); ///////////////////////////////////////////////////////////
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };

});

parcelRegister("kNy1J", function(module, exports) {

$parcel$export(module.exports, "SourceManager", () => $f242c74a81525470$export$af4db9ec7e200ea2);
$parcel$export(module.exports, "disableTransformOptionMerge", () => $f242c74a81525470$export$9451f4e9047441ec);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8AzOm = parcelRequire("8AzOm");

var $8tpV4 = parcelRequire("8tpV4");

var $be33G = parcelRequire("be33G");

var $jjR5M = parcelRequire("jjR5M");

var $6Bzg6 = parcelRequire("6Bzg6");

var $kWuWu = parcelRequire("kWuWu");
/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transfroms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $f242c74a81525470$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = []; // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($f242c74a81525470$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0; // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $hzBt5.isTypedArray)(data) ? (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY) : (0, $8tpV4.SOURCE_FORMAT_ORIGINAL);
                upstreamSignList = [];
            } // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $hzBt5.retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $hzBt5.retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader) || null; // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $hzBt5.retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions); // We share source with dataset as much as possible
            // to avoid extra memroy cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $8AzOm.createSource)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost; // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $8AzOm.createSource)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $f242c74a81525470$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $hzBt5.each)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $f242c74a81525470$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $jjR5M.applyDataTransform)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $8AzOm.cloneSourceShallow)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
         // All sourceList is from the some upsteam.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By defualt 0, means "main source".
   *                    Most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($f242c74a81525470$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $6Bzg6.default)(); // Always create store from source of series.
                cachedStore.initData(new (0, $kWuWu.DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PEDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // no need to update them when change happen.
        var sourceHost = this._sourceHost;
        if ($f242c74a81525470$var$isSeries(sourceHost)) {
            var datasetModel = (0, $be33G.querySeriesUpstreamDatasetModel)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $hzBt5.map)((0, $be33G.queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($f242c74a81525470$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $f242c74a81525470$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $hzBt5.setAsPrimitive)(datasetModel.option.transform);
}
function $f242c74a81525470$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $f242c74a81525470$var$doThrow(errMsg) {
    throw new Error(errMsg);
}

});
parcelRegister("jjR5M", function(module, exports) {

$parcel$export(module.exports, "registerExternalTransform", () => $e108f9b2e624d0da$export$92c96c6d8b255b7d);
$parcel$export(module.exports, "applyDataTransform", () => $e108f9b2e624d0da$export$42a68f09db16803f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8tpV4 = parcelRequire("8tpV4");

var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $kWuWu = parcelRequire("kWuWu");

var $fJfRY = parcelRequire("fJfRY");

var $6ds7H = parcelRequire("6ds7H");

var $8AzOm = parcelRequire("8AzOm");
/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $e108f9b2e624d0da$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * becuase transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $fJfRY.parseDataValue)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $e108f9b2e624d0da$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $e108f9b2e624d0da$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)) (0, $6ds7H.throwError)(errMsg);
     // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Becuase the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is relialbe and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $hzBt5.each)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt); // Users probably not sepcify dimension name. For simplicity, data transform
        // do not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbid name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $hzBt5.hasOwn)(dimsByName, name)) (0, $6ds7H.throwError)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
     // Implement public methods:
    var rawItemGetter = (0, $kWuWu.getRawSourceItemGetter)(sourceFormat, (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $hzBt5.bind)($e108f9b2e624d0da$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $hzBt5.bind)($e108f9b2e624d0da$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $kWuWu.getRawSourceDataCounter)(sourceFormat, (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN));
    extSource.count = (0, $hzBt5.bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $kWuWu.getRawSourceValueGetter)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex]; // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $hzBt5.bind)($e108f9b2e624d0da$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $hzBt5.bind)($e108f9b2e624d0da$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $e108f9b2e624d0da$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $6ds7H.throwError)(errMsg);
    }
    return upstream.data;
}
function $e108f9b2e624d0da$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $6ds7H.throwError)(errMsg);
    }
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $hzBt5.extend)({}, data[i]));
        return result;
    }
}
function $e108f9b2e624d0da$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
     // Keep the same logic as `List::getDimension` did.
    if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
     || !isNaN(dim) && !(0, $hzBt5.hasOwn)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $hzBt5.hasOwn)(dimsByName, dim)) return dimsByName[dim];
}
function $e108f9b2e624d0da$var$cloneAllDimensionInfo(dimensions) {
    return (0, $hzBt5.clone)(dimensions);
}
var $e108f9b2e624d0da$var$externalTransformMap = (0, $hzBt5.createHashMap)();
function $e108f9b2e624d0da$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $hzBt5.clone)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $6ds7H.throwError)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $6ds7H.throwError)(errMsg);
     // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $e108f9b2e624d0da$var$externalTransformMap.set(type, externalTransform);
}
function $e108f9b2e624d0da$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $ckizb.normalizeToArray)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $6ds7H.throwError)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $e108f9b2e624d0da$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i); // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $e108f9b2e624d0da$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $6ds7H.throwError)(errMsg);
    if (!(0, $hzBt5.isObject)(transOption)) (0, $6ds7H.throwError)(errMsg);
    var transType = transOption.type;
    var externalTransform = $e108f9b2e624d0da$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $6ds7H.throwError)(errMsg);
     // Prepare source
    var extUpSourceList = (0, $hzBt5.map)(upSourceList, function(upSource) {
        return $e108f9b2e624d0da$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $ckizb.normalizeToArray)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $hzBt5.clone)(transOption.config)
    }));
    var printStrArr;
    return (0, $hzBt5.map)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $hzBt5.isObject)(result)) (0, $6ds7H.throwError)(errMsg);
        if (!result.data) (0, $6ds7H.throwError)(errMsg);
        var sourceFormat = (0, $8AzOm.detectSourceFormat)(result.data);
        if (!$e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat)) (0, $6ds7H.throwError)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 // If transformer returns `dimensions`, it means that the transformer has different
         && !result.dimensions) {
            var startIndex = firstUpSource.startIndex; // We copy the header of upstream to the result becuase:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $8AzOm.createSource)(result.data, resultMetaRawOption, null);
    });
}
function $e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS);
}

});
parcelRegister("fJfRY", function(module, exports) {

$parcel$export(module.exports, "parseDataValue", () => $b7375e5792a781ae$export$cc7175145baad076);
$parcel$export(module.exports, "getRawValueParser", () => $b7375e5792a781ae$export$c88237b7c265b36b);
$parcel$export(module.exports, "SortOrderComparator", () => $b7375e5792a781ae$export$ed75a5d7b0144167);
$parcel$export(module.exports, "createFilterComparator", () => $b7375e5792a781ae$export$f2644c3485f94c4e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

var $hzBt5 = parcelRequire("hzBt5");

var $6ds7H = parcelRequire("6ds7H");
function $b7375e5792a781ae$export$cc7175145baad076(value, opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' // spead up when using timestamp
     && typeof value !== 'number' && value != null && value !== '-') value = +(0, $5BQXp.parseDate)(value);
     // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
     : +value;
}
var $b7375e5792a781ae$var$valueParserMap = (0, $hzBt5.createHashMap)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have by defualt `numericToNumber`.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $5BQXp.parseDate)(val);
    },
    'trim': function(val) {
        return typeof val === 'string' ? (0, $hzBt5.trim)(val) : val;
    }
});
function $b7375e5792a781ae$export$c88237b7c265b36b(type) {
    return $b7375e5792a781ae$var$valueParserMap.get(type);
}
var $b7375e5792a781ae$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $b7375e5792a781ae$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (typeof rval !== 'number') {
            var errMsg = '';
            (0, $6ds7H.throwError)(errMsg);
        }
        this._opFn = $b7375e5792a781ae$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $5BQXp.numericToNumber)(rval);
    } // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return typeof lval === 'number' ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $5BQXp.numericToNumber)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $b7375e5792a781ae$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by defualt: 'asc'
   * @param incomparable by defualt: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE]
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    } // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalTypeof = typeof lval;
        var rvalTypeof = typeof rval;
        var lvalFloat = lvalTypeof === 'number' ? lval : (0, $5BQXp.numericToNumber)(lval);
        var rvalFloat = rvalTypeof === 'number' ? rval : (0, $5BQXp.numericToNumber)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = lvalTypeof === 'string';
            var rvalIsStr = rvalTypeof === 'string';
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $b7375e5792a781ae$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $5BQXp.numericToNumber)(rval);
    } // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $5BQXp.numericToNumber)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $b7375e5792a781ae$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $b7375e5792a781ae$var$FilterEqualityComparator(op === 'eq', rval) : (0, $hzBt5.hasOwn)($b7375e5792a781ae$var$ORDER_COMPARISON_OP_MAP, op) ? new $b7375e5792a781ae$var$FilterOrderComparator(op, rval) : null;
}

});


parcelRegister("6Bzg6", function(module, exports) {

$parcel$export(module.exports, "CtorInt32Array", () => $4cf18c6cfc4197e3$export$b60d945128546f53);
$parcel$export(module.exports, "default", () => $4cf18c6cfc4197e3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $fJfRY = parcelRequire("fJfRY");

var $8AzOm = parcelRequire("8AzOm");
var $4cf18c6cfc4197e3$var$UNDEFINED = 'undefined';
var $4cf18c6cfc4197e3$export$859a1fa4f1106aa0 = typeof Uint32Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Uint32Array;
var $4cf18c6cfc4197e3$export$78cf73566f32c185 = typeof Uint16Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Uint16Array;
var $4cf18c6cfc4197e3$export$b60d945128546f53 = typeof Int32Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Int32Array;
var $4cf18c6cfc4197e3$export$365b104db51a490a = typeof Float64Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $4cf18c6cfc4197e3$var$dataCtors = {
    'float': $4cf18c6cfc4197e3$export$365b104db51a490a,
    'int': $4cf18c6cfc4197e3$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $4cf18c6cfc4197e3$export$365b104db51a490a
};
var $4cf18c6cfc4197e3$var$defaultDimValueGetters;
function $4cf18c6cfc4197e3$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $4cf18c6cfc4197e3$export$859a1fa4f1106aa0 : $4cf18c6cfc4197e3$export$78cf73566f32c185;
}
function $4cf18c6cfc4197e3$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $4cf18c6cfc4197e3$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $4cf18c6cfc4197e3$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $4cf18c6cfc4197e3$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end); // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $4cf18c6cfc4197e3$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = []; // It will not be calculated util needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $hzBt5.createHashMap)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider; // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $4cf18c6cfc4197e3$var$defaultDimValueGetters[source.sourceFormat]; // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter; // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $8AzOm.shouldRetrieveDataByName)(source);
        this._dimensions = (0, $hzBt5.map)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $4cf18c6cfc4197e3$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $4cf18c6cfc4197e3$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $4cf18c6cfc4197e3$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx]; // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
            dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $4cf18c6cfc4197e3$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start; // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $4cf18c6cfc4197e3$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $hzBt5.map)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $4cf18c6cfc4197e3$var$getInitialExtent();
            $4cf18c6cfc4197e3$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem); // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx]; // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end; // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions; // TODO get all from store?
            dimensions = []; // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = []; // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        }); // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count(); // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retreive the index with given raw data index
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
         // Indices are ascending
        var indices = this._indices; // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we chose the one that `diff >= 0` in this csae.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $4cf18c6cfc4197e3$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $4cf18c6cfc4197e3$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i); // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        } // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $hzBt5.keys)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $4cf18c6cfc4197e3$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i]; // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex]; // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex]; // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        } // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    }; // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $4cf18c6cfc4197e3$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($4cf18c6cfc4197e3$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) + 2); // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart; // Find a point from current frame that construct a triangel with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                 // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        } // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $4cf18c6cfc4197e3$var$getInitialExtent();
        var newIndices = new ($4cf18c6cfc4197e3$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1)); // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i); // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                     // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $4cf18c6cfc4197e3$var$getInitialExtent();
        if (!dimData) return initialExtent;
         // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count(); // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $hzBt5.reduce)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $4cf18c6cfc4197e3$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $hzBt5.clone)(this._extent);
        target._rawExtent = (0, $hzBt5.clone)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $fJfRY.parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $4cf18c6cfc4197e3$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $fJfRY.parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $fJfRY.parseDataValue)(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
                 : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $4cf18c6cfc4197e3$export$2e2bcd8739ae039 = $4cf18c6cfc4197e3$var$DataStore;

});


parcelRegister("4OBOS", function(module, exports) {

$parcel$export(module.exports, "defaultSeriesFormatTooltip", () => $38192b222cde5ead$export$3a110b9fb5c88b34);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $e0Zyb = parcelRequire("e0Zyb");

var $kWuWu = parcelRequire("kWuWu");

var $ckizb = parcelRequire("ckizb");
function $38192b222cde5ead$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $hzBt5.isArray)(value);
    var markerColor = (0, $e0Zyb.retrieveVisualColorForTooltipMarker)(series, dataIndex); // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $38192b222cde5ead$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks; // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $kWuWu.retrieveRawValue)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
     // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $ckizb.isNameSpecified)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $e0Zyb.createTooltipMarkup)('section', {
        header: seriesName,
        // When series name not specified, do not show a header line with only '-'.
        // This case alway happen in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $e0Zyb.createTooltipMarkup)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $hzBt5.trim)(inlineName),
                value: inlineValue,
                valueType: inlineValueType
            })
        ].concat(subBlocks || [])
    });
}
function $38192b222cde5ead$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $hzBt5.reduce)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $hzBt5.each)(tooltipDims, function(dim) {
        setEachItem((0, $kWuWu.retrieveRawValue)(data, dataIndex, dim), dim);
    }) // By default, all dims is used on tooltip.
     : (0, $hzBt5.each)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $e0Zyb.createTooltipMarkup)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}

});
parcelRegister("e0Zyb", function(module, exports) {

$parcel$export(module.exports, "createTooltipMarkup", () => $a340cf5f38f316a7$export$cf63b23ce77d1921);
$parcel$export(module.exports, "buildTooltipMarkup", () => $a340cf5f38f316a7$export$6969ffb02c1cb49a);
$parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", () => $a340cf5f38f316a7$export$ea15628039c0fa93);
$parcel$export(module.exports, "getPaddingFromTooltipModel", () => $a340cf5f38f316a7$export$3048212c802df496);
$parcel$export(module.exports, "TooltipMarkupStyleCreator", () => $a340cf5f38f316a7$export$2fba3afbcdcf3e18);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gyplX = parcelRequire("gyplX");

var $hzBt5 = parcelRequire("hzBt5");

var $fJfRY = parcelRequire("fJfRY");

var $5BQXp = parcelRequire("5BQXp");
var $a340cf5f38f316a7$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1'; // TODO: more textStyle option
function $a340cf5f38f316a7$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || '#6e7079';
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || '#464646';
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $gyplX.encodeHTML)(nameFontSize + '') + "px;color:" + (0, $gyplX.encodeHTML)(nameFontColor) + ";font-weight:" + (0, $gyplX.encodeHTML)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $gyplX.encodeHTML)(valueFontSize + '') + "px;color:" + (0, $gyplX.encodeHTML)(valueFontColor) + ";font-weight:" + (0, $gyplX.encodeHTML)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
} // See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $a340cf5f38f316a7$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $a340cf5f38f316a7$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
]; // eslint-disable-next-line max-len
function $a340cf5f38f316a7$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $a340cf5f38f316a7$var$getBuilder(fragment) {
    return (0, $hzBt5.hasOwn)($a340cf5f38f316a7$var$builderMap, fragment.type) && $a340cf5f38f316a7$var$builderMap[fragment.type];
}
var $a340cf5f38f316a7$var$builderMap = {
    /**
   * A `section` block is like:
   * ```
   * header
   * subBlock
   * subBlock
   * ...
   * ```
   */ section: {
        planLayout: function(fragment) {
            var subBlockLen = fragment.blocks.length;
            var thisBlockHasInnerGap = subBlockLen > 1 || subBlockLen > 0 && !fragment.noHeader;
            var thisGapLevelBetweenSubBlocks = 0;
            (0, $hzBt5.each)(fragment.blocks, function(subBlock) {
                $a340cf5f38f316a7$var$getBuilder(subBlock).planLayout(subBlock);
                var subGapLevel = subBlock.__gapLevelBetweenSubBlocks; // If the some of the sub-blocks have some gaps (like 10px) inside, this block
                // should use a larger gap (like 20px) to distinguish those sub-blocks.
                if (subGapLevel >= thisGapLevelBetweenSubBlocks) thisGapLevelBetweenSubBlocks = subGapLevel + (thisBlockHasInnerGap && (!subGapLevel // If no header, always keep the sub gap level. Otherwise
                 || subBlock.type === 'section' && !subBlock.noHeader) ? 1 : 0);
            });
            fragment.__gapLevelBetweenSubBlocks = thisGapLevelBetweenSubBlocks;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var noHeader = fragment.noHeader;
            var gaps = $a340cf5f38f316a7$var$getGap(fragment);
            var subMarkupText = $a340cf5f38f316a7$var$buildSubBlocks(ctx, fragment, noHeader ? topMarginForOuterGap : gaps.html, toolTipTextStyle);
            if (noHeader) return subMarkupText;
            var displayableHeader = (0, $gyplX.makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
            var nameStyle = $a340cf5f38f316a7$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
            if (ctx.renderMode === 'richText') return $a340cf5f38f316a7$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
            else return $a340cf5f38f316a7$var$wrapBlockHTML("<div style=\"" + nameStyle + ";" + $a340cf5f38f316a7$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + (0, $gyplX.encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
        }
    },
    /**
   * A `nameValue` block is like:
   * ```
   * marker  name  value
   * ```
   */ nameValue: {
        planLayout: function(fragment) {
            fragment.__gapLevelBetweenSubBlocks = 0;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var renderMode = ctx.renderMode;
            var noName = fragment.noName;
            var noValue = fragment.noValue;
            var noMarker = !fragment.markerType;
            var name = fragment.name;
            var value = fragment.value;
            var useUTC = ctx.useUTC;
            if (noName && noValue) return;
            var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
            var readableName = noName ? '' : (0, $gyplX.makeValueReadable)(name, 'ordinal', useUTC);
            var valueTypeOption = fragment.valueType;
            var readableValueList = noValue ? [] : (0, $hzBt5.isArray)(value) ? (0, $hzBt5.map)(value, function(val, idx) {
                return (0, $gyplX.makeValueReadable)(val, (0, $hzBt5.isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
            }) : [
                (0, $gyplX.makeValueReadable)(value, (0, $hzBt5.isArray)(valueTypeOption) ? valueTypeOption[0] : valueTypeOption, useUTC)
            ];
            var valueAlignRight = !noMarker || !noName; // It little weird if only value next to marker but far from marker.
            var valueCloseToMarker = !noMarker && noName;
            var _a = $a340cf5f38f316a7$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
            return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $a340cf5f38f316a7$var$wrapInlineNameRichText(ctx, readableName, nameStyle) // Value has commas inside, so use ' ' as delimiter for multiple values.
            ) + (noValue ? '' : $a340cf5f38f316a7$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $a340cf5f38f316a7$var$wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : $a340cf5f38f316a7$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $a340cf5f38f316a7$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
        }
    }
};
function $a340cf5f38f316a7$var$buildSubBlocks(ctx, fragment, topMarginForOuterGap, tooltipTextStyle) {
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $hzBt5.assert)(!subBlocks || (0, $hzBt5.isArray)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $hzBt5.hasOwn)(orderMap, orderMode)) {
            var comparator_1 = new (0, $fJfRY.SortOrderComparator)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    var gaps = $a340cf5f38f316a7$var$getGap(fragment);
    (0, $hzBt5.each)(subBlocks, function(subBlock, idx) {
        var subMarkupText = $a340cf5f38f316a7$var$getBuilder(subBlock).build(ctx, subBlock, idx > 0 ? gaps.html : 0, tooltipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    if (!subMarkupTextList.length) return;
    return ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $a340cf5f38f316a7$var$wrapBlockHTML(subMarkupTextList.join(''), topMarginForOuterGap);
}
function $a340cf5f38f316a7$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $a340cf5f38f316a7$var$getBuilder(fragment);
    builder.planLayout(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator
    };
    return builder.build(ctx, fragment, 0, toolTipTextStyle);
}
function $a340cf5f38f316a7$var$getGap(fragment) {
    var gapLevelBetweenSubBlocks = fragment.__gapLevelBetweenSubBlocks;
    return {
        html: $a340cf5f38f316a7$var$HTML_GAPS[gapLevelBetweenSubBlocks],
        richText: $a340cf5f38f316a7$var$RICH_TEXT_GAPS[gapLevelBetweenSubBlocks]
    };
}
function $a340cf5f38f316a7$var$wrapBlockHTML(encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    return "<div style=\"" + marginCSS + ";" + $a340cf5f38f316a7$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
}
function $a340cf5f38f316a7$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $gyplX.encodeHTML)(name) + '</span>';
}
function $a340cf5f38f316a7$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    return "<span style=\"" + alignCSS + ";" + style + "\">" // Value has commas inside, so use '  ' as delimiter for multiple values.
     + (0, $hzBt5.map)(valueList, function(value) {
        return (0, $gyplX.encodeHTML)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $a340cf5f38f316a7$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $a340cf5f38f316a7$var$wrapInlineValueRichText(ctx, valueList, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    }); // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle(valueList.join('  '), styles);
}
function $a340cf5f38f316a7$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $gyplX.convertToColorString)(color);
}
function $a340cf5f38f316a7$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding // We give slightly different to look pretty.
     : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $a340cf5f38f316a7$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {}; // Notice that "generate a style name" usuall happens repeatly when mouse moving and
        // displaying a tooltip. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $5BQXp.getRandomIdBase)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $gyplX.getTooltipMarker)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $hzBt5.isString)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $hzBt5.isArray)(styles)) (0, $hzBt5.each)(styles, function(stl) {
            return (0, $hzBt5.extend)(finalStl, stl);
        });
        else (0, $hzBt5.extend)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();

});



parcelRegister("3OWAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c837ce8a6b25399$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $kyX7l = parcelRequire("kyX7l");

var $jrSv6 = parcelRequire("jrSv6");

var $eNXvv = parcelRequire("eNXvv");

var $ckizb = parcelRequire("ckizb");

var $gwjrp = parcelRequire("gwjrp");

var $6LGi5 = parcelRequire("6LGi5");

var $8AzOm = parcelRequire("8AzOm");

var $lljDt = parcelRequire("lljDt");

var $be33G = parcelRequire("be33G");

var $8tpV4 = parcelRequire("8tpV4");
function $2c837ce8a6b25399$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $gwjrp.default).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $hzBt5.map(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $eNXvv.getDimensionTypeByAxis)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $2c837ce8a6b25399$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $hzBt5.each(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $2c837ce8a6b25399$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $8AzOm.createSourceFromSeriesDataOption)(sourceRaw);
    } else {
        source = sourceManager.getSource(); // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL);
    }
    var coordSysInfo = (0, $6LGi5.getCoordSysInfoBySeries)(seriesModel);
    var coordSysDimDefs = $2c837ce8a6b25399$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $hzBt5.isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $hzBt5.curry((0, $be33G.makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $jrSv6.default)(source, createDimensionOptions);
    var firstCategoryDimIndex = $2c837ce8a6b25399$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $lljDt.enableDataStack)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $kyX7l.default)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $2c837ce8a6b25399$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $2c837ce8a6b25399$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) {
        var sampleItem = $2c837ce8a6b25399$var$firstDataNotNull(source.data || []);
        return sampleItem != null && !$hzBt5.isArray((0, $ckizb.getDataItemValue)(sampleItem));
    }
}
function $2c837ce8a6b25399$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $2c837ce8a6b25399$export$2e2bcd8739ae039 = $2c837ce8a6b25399$var$createSeriesData;

});
parcelRegister("kyX7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef84d7185c8a372d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 
var $hzBt5 = parcelRequire("hzBt5");

var $fR3z1 = parcelRequire("fR3z1");

var $ddlYG = parcelRequire("ddlYG");

var $kWuWu = parcelRequire("kWuWu");

var $eNXvv = parcelRequire("eNXvv");

var $3JGxt = parcelRequire("3JGxt");

var $8tpV4 = parcelRequire("8tpV4");

var $ckizb = parcelRequire("ckizb");

var $aly4X = parcelRequire("aly4X");

var $8AzOm = parcelRequire("8AzOm");

var $6Bzg6 = parcelRequire("6Bzg6");

var $kJQdt = parcelRequire("kJQdt");
var $ef84d7185c8a372d$var$isObject = $hzBt5.isObject;
var $ef84d7185c8a372d$var$map = $hzBt5.map;
var $ef84d7185c8a372d$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.
var $ef84d7185c8a372d$var$ID_PREFIX = 'e\0\0';
var $ef84d7185c8a372d$var$INDEX_NOT_FOUND = -1; // type SeriesDimensionIndex = DimensionIndex;
var $ef84d7185c8a372d$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $ef84d7185c8a372d$var$CLONE_PROPERTIES = [
    '_approximateExtent'
]; // -----------------------------
// Internal method declarations:
// -----------------------------
var $ef84d7185c8a372d$var$prepareInvertedIndex;
var $ef84d7185c8a372d$var$getId;
var $ef84d7185c8a372d$var$getIdNameFromStore;
var $ef84d7185c8a372d$var$normalizeDimensions;
var $ef84d7185c8a372d$var$transferProperties;
var $ef84d7185c8a372d$var$cloneListForMapAndSample;
var $ef84d7185c8a372d$var$makeIdFromName;
var $ef84d7185c8a372d$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = []; // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {}; // Globel layout properties.
        this._layout = {}; // Item visual properties after visual coding
        this._itemVisuals = []; // Item layout properties after layout
        this._itemLayouts = []; // Graphic elemnents
        this._graphicEls = []; // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {}; // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false; // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'lttbDownSample',
            'map'
        ]; // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $kJQdt.isSeriesDataSchema)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $hzBt5.isString(dimInfoInput) ? new (0, $3JGxt.default)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $3JGxt.default)) ? new (0, $3JGxt.default)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $hzBt5.createHashMap();
            $hzBt5.each(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Becuause of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
         // Retrieve from series dimension definition becuase it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatbility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recogonized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if (typeof dim === 'number' // If being a number-like string but not being defined as a dimension name.
         || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $6Bzg6.default)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $8AzOm.isSourceInstance)(data) || $hzBt5.isArrayLike(data) ? new (0, $kWuWu.DefaultDataProvider)(data, dimensions.length) : data;
            store = new (0, $6Bzg6.default)();
            var dimensionInfos = $ef84d7185c8a372d$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store; // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count()); // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $eNXvv.summarizeDimensions)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exaclty cooresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $ef84d7185c8a372d$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL); // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $ckizb.isDataItemOption)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $ckizb.convertOptionIdName)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $ckizb.convertOptionIdName)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$ef84d7185c8a372d$var$makeIdFromName(this, idx);
        $ef84d7185c8a372d$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculte extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $ef84d7185c8a372d$var$isObject(key) ? $hzBt5.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Becuase:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $ef84d7185c8a372d$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Becuase:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $ef84d7185c8a372d$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $hzBt5.isArray(dimensions) ? store.getValues($ef84d7185c8a372d$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Inlcuding '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retreive the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $ef84d7185c8a372d$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $hzBt5.keys(range);
        var dimIndices = [];
        $hzBt5.each(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict'; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $ef84d7185c8a372d$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this); // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, becuase `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each sereis
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $ef84d7185c8a372d$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $ef84d7185c8a372d$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $fR3z1.default)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $ddlYG.default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $ef84d7185c8a372d$var$getId(otherList, idx);
        }, function(idx) {
            return $ef84d7185c8a372d$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($ef84d7185c8a372d$var$isObject(kvObj)) $hzBt5.extend(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key); // TODO Performance?
            if ($hzBt5.isArray(val)) val = val.slice();
            else if ($ef84d7185c8a372d$var$isObject(val)) val = $hzBt5.extend({}, val);
            itemVisual[key] = val;
        }
        return val;
    }; // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($ef84d7185c8a372d$var$isObject(key)) $hzBt5.extend(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        if ($ef84d7185c8a372d$var$isObject(key)) {
            for(var name_1 in key)if (key.hasOwnProperty(name_1)) this.setLayout(name_1, key[name_1]);
            return;
        }
        this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $hzBt5.extend(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $aly4X.setCommonECData)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $hzBt5.each(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $ef84d7185c8a372d$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $ef84d7185c8a372d$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (typeof originalMethod !== 'function') return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($hzBt5.slice(arguments)));
        };
    }; // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $ef84d7185c8a372d$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $hzBt5.each(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $ef84d7185c8a372d$var$CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $ef84d7185c8a372d$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $ef84d7185c8a372d$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $ckizb.convertOptionIdName)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $ef84d7185c8a372d$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $ef84d7185c8a372d$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $ef84d7185c8a372d$var$ID_PREFIX + rawIndex;
            return id;
        };
        $ef84d7185c8a372d$var$normalizeDimensions = function(dimensions) {
            if (!$hzBt5.isArray(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transfered.
     */ $ef84d7185c8a372d$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $ef84d7185c8a372d$var$map(original.dimensions, original._getDimInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
            $ef84d7185c8a372d$var$transferProperties(list, original);
            return list;
        };
        $ef84d7185c8a372d$var$transferProperties = function(target, source) {
            $hzBt5.each($ef84d7185c8a372d$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $hzBt5.each($ef84d7185c8a372d$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $hzBt5.clone(source[propName]);
            });
            target._calculationInfo = $hzBt5.extend({}, source._calculationInfo);
        };
        $ef84d7185c8a372d$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $ef84d7185c8a372d$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $ef84d7185c8a372d$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $ef84d7185c8a372d$export$2e2bcd8739ae039 = $ef84d7185c8a372d$var$SeriesData;

});
parcelRegister("ddlYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ed899115b3ba9b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $99ed899115b3ba9b$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $99ed899115b3ba9b$var$defaultKeyGetter(item) {
    return item;
}
var $99ed899115b3ba9b$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $99ed899115b3ba9b$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $99ed899115b3ba9b$var$defaultKeyGetter; // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(newIdxMapVal); // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
             // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, map, // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $99ed899115b3ba9b$export$2e2bcd8739ae039 = $99ed899115b3ba9b$var$DataDiffer;

});

parcelRegister("eNXvv", function(module, exports) {

$parcel$export(module.exports, "summarizeDimensions", () => $ac73cd3093eea71d$export$505a22c3734846f1);
$parcel$export(module.exports, "getDimensionTypeByAxis", () => $ac73cd3093eea71d$export$af1622903e71278e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8tpV4 = parcelRequire("8tpV4");
var $ac73cd3093eea71d$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $ac73cd3093eea71d$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $hzBt5.createHashMap)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $hzBt5.each)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $ac73cd3093eea71d$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($ac73cd3093eea71d$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                 // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $ac73cd3093eea71d$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $8tpV4.VISUAL_DIMENSIONS).each(function(v, otherDim) {
            var encodeArr = $ac73cd3093eea71d$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $hzBt5.map)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
    // in this way. Use label.formatter instead. May be remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $ac73cd3093eea71d$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $ac73cd3093eea71d$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
} // FIXME:TS should be type `AxisType`
function $ac73cd3093eea71d$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $ac73cd3093eea71d$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }

});

parcelRegister("3JGxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b869261fc396a82$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $2b869261fc396a82$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $hzBt5.extend(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $2b869261fc396a82$export$2e2bcd8739ae039 = $2b869261fc396a82$var$SeriesDimensionDefine;

});


parcelRegister("jrSv6", function(module, exports) {

$parcel$export(module.exports, "createDimensions", () => $e28ad0a468fa8898$export$8066c1b52b2e9504);
$parcel$export(module.exports, "default", () => $e28ad0a468fa8898$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8tpV4 = parcelRequire("8tpV4");

var $3JGxt = parcelRequire("3JGxt");

var $hzBt5 = parcelRequire("hzBt5");

var $8AzOm = parcelRequire("8AzOm");

var $6Bzg6 = parcelRequire("6Bzg6");

var $ckizb = parcelRequire("ckizb");

var $be33G = parcelRequire("be33G");

var $kJQdt = parcelRequire("kJQdt");
function $e28ad0a468fa8898$export$8066c1b52b2e9504(source, opt) {
    return $e28ad0a468fa8898$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $e28ad0a468fa8898$export$2e2bcd8739ae039(source, opt) {
    if (!(0, $8AzOm.isSourceInstance)(source)) source = (0, $8AzOm.createSourceFromSeriesDataOption)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $hzBt5.createHashMap)();
    var resultList = [];
    var dimCount = $e28ad0a468fa8898$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount); // Try to ignore unsed dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $kJQdt.shouldOmitUnusedDimensions)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $kJQdt.ensureSourceDimNameMap)(source) : (0, $kJQdt.createDimNameMap)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $hzBt5.createHashMap)(encodeDef);
    var indicesMap = new (0, $6Bzg6.CtorInt32Array)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $hzBt5.isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $3JGxt.default)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be diplayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
     // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $ckizb.normalizeToArray)(dataDimsRaw).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $hzBt5.isString)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $hzBt5.each)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $hzBt5.isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    }); // Apply templetes and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $hzBt5.each)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $hzBt5.isString)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $hzBt5.extend)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim); // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $ckizb.normalizeToArray)(dataDims); // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
         // Apply templates.
        (0, $hzBt5.each)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx); // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $hzBt5.defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $hzBt5.isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $hzBt5.defaults)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $8tpV4.VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    } // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    } // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $e28ad0a468fa8898$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0; // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $be33G.guessOrdinal)(source, resultDimIdx) === (0, $be33G.BE_ORDINAL).Must // Consider the case:
         || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $hzBt5.each)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        }); // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $e28ad0a468fa8898$var$removeDuplication(resultList);
    return new (0, $kJQdt.SeriesDataSchema)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $e28ad0a468fa8898$var$removeDuplication(result) {
    var duplicationMap = (0, $hzBt5.createHashMap)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $e28ad0a468fa8898$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $hzBt5.each)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $hzBt5.isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $e28ad0a468fa8898$var$genCoordDimName(name, map, fromZero) {
    var mapData = map.data;
    if (fromZero || mapData.hasOwnProperty(name)) {
        var i = 0;
        while(mapData.hasOwnProperty(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}

});

parcelRegister("gwjrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06eb7162ee6d39e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $c06eb7162ee6d39e$var$coordinateSystemCreators = {};
var $c06eb7162ee6d39e$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $hzBt5.each($c06eb7162ee6d39e$var$coordinateSystemCreators, function(creater, type) {
            var list = creater.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $hzBt5.each(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $c06eb7162ee6d39e$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $c06eb7162ee6d39e$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $c06eb7162ee6d39e$export$2e2bcd8739ae039 = $c06eb7162ee6d39e$var$CoordinateSystemManager;

});

parcelRegister("6LGi5", function(module, exports) {

$parcel$export(module.exports, "getCoordSysInfoBySeries", () => $4ed7efe73ca3066c$export$f2befeb2f4933656);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".

var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $4ed7efe73ca3066c$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $hzBt5.createHashMap)();
        this.categoryAxisMap = (0, $hzBt5.createHashMap)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $4ed7efe73ca3066c$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $4ed7efe73ca3066c$var$CoordSysInfo(coordSysName);
    var fetch = $4ed7efe73ca3066c$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $4ed7efe73ca3066c$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($4ed7efe73ca3066c$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($4ed7efe73ca3066c$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($4ed7efe73ca3066c$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($4ed7efe73ca3066c$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($4ed7efe73ca3066c$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $hzBt5.each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($4ed7efe73ca3066c$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $4ed7efe73ca3066c$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}

});




parcelRegister("78h3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $5316839f42959d64$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $hXAsm = parcelRequire("hXAsm");

var $hzBt5 = parcelRequire("hzBt5");

var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");
var $rnA7j = parcelRequire("rnA7j");
var $9ubot = parcelRequire("9ubot");

var $aly4X = parcelRequire("aly4X");

var $51xyq = parcelRequire("51xyq");

var $hcRXD = parcelRequire("hcRXD");

var $7b8YY = parcelRequire("7b8YY");

var $gNqT1 = parcelRequire("gNqT1");

var $hzMcH = parcelRequire("hzMcH");

var $azEx8 = parcelRequire("azEx8");

var $PS5GS = parcelRequire("PS5GS");

var $bY5Ss = parcelRequire("bY5Ss");


var $4L1H1 = parcelRequire("4L1H1");

var $9ubot = parcelRequire("9ubot");
var $5316839f42959d64$var$_eventPos = [
    0,
    0
];
var $5316839f42959d64$var$mathMax = Math.max;
var $5316839f42959d64$var$mathMin = Math.min;
function $5316839f42959d64$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $PS5GS.isCoordinateSystemType)(coord, 'cartesian2d')) {
        var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== 'category' || !baseAxis.onBand) {
            var expandWidth = data.getLayout('bandWidth');
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $5316839f42959d64$var$BarView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel); // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $5316839f42959d64$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        var coordSysClipArea = $5316839f42959d64$var$getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
        group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $5316839f42959d64$var$getLayout[coord.type](data, dataIndex);
            var bgEl = $5316839f42959d64$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $5316839f42959d64$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (drawBackground) createBackground(dataIndex);
             // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$5316839f42959d64$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $5316839f42959d64$var$clip[coord.type](coordSysClipArea, layout);
            var el = $5316839f42959d64$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            $5316839f42959d64$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $5316839f42959d64$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $9ubot.initProps)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $5316839f42959d64$var$getLayout[coord.type](data, newIndex, itemModel);
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $5316839f42959d64$var$getLayout[coord.type](data, newIndex);
                var shape = $5316839f42959d64$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $9ubot.updateProps)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$5316839f42959d64$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $5316839f42959d64$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            if (!el) el = $5316839f42959d64$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
            else (0, $9ubot.saveOldStyle)(el);
             // Not change anything if only order changed.
            // Especially not change label.
            if (!isChangeOrder) $5316839f42959d64$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $5316839f42959d64$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $9ubot.updateProps)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $9ubot.removeElementWithFadeOut)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $hXAsm.default)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $5316839f42959d64$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $5316839f42959d64$var$createLarge(seriesModel, this.group, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) ? (0, $gNqT1.createClipPath)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this; // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                if (el) {
                    var shape = el.shape; // If data is NaN, shape.xxx may be NaN, so use || 0 here in case
                    return (baseAxis.isHorizontal() // The result should be consistent with the initial sort by data value.
                     ? Math.abs(shape.height) : Math.abs(shape.width)) || 0;
                } else return 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $hzBt5.map)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 // If some tick have no bar, the tick will be treated as min.
             ? Number.MIN_VALUE // PENDING: if dataZoom on baseAxis exits, is it a performance issue?
             : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $9ubot.removeElementWithFadeOut)(el, model, (0, $aly4X.getECData)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = 'bar';
    return BarView;
}((0, $azEx8.default));
var $5316839f42959d64$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $5316839f42959d64$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $5316839f42959d64$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $5316839f42959d64$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $5316839f42959d64$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y; // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Beause if data changed and the bar show again, its transition animaiton
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y; // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $5316839f42959d64$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $5316839f42959d64$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0; // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $5316839f42959d64$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $aeCKo.default)({
            shape: (0, $hzBt5.extend)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $hzMcH.default) : (0, $rnA7j.default);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $5316839f42959d64$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $4L1H1.createSectorCalculateTextPosition)(positionMap, {
            isRoundCap: ShapeClass === (0, $hzMcH.default)
        }); // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $9ubot.updateProps) : (0, $9ubot.initProps))(sector, {
                shape: animateTarget // __value: typeof dataValue === 'string' ? parseInt(dataValue, 10) : dataValue
            }, animationModel);
        }
        return sector;
    }
};
function $5316839f42959d64$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $5316839f42959d64$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $9ubot.updateProps) : (0, $9ubot.initProps))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $9ubot.updateProps) : (0, $9ubot.initProps))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $5316839f42959d64$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $5316839f42959d64$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $5316839f42959d64$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $5316839f42959d64$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$5316839f42959d64$var$checkPropertiesNotValid(layout, $5316839f42959d64$var$rectPropties);
    },
    polar: function(layout) {
        return !$5316839f42959d64$var$checkPropertiesNotValid(layout, $5316839f42959d64$var$polarPropties);
    }
};
var $5316839f42959d64$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        var fixedLineWidth = itemModel ? $5316839f42959d64$var$getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $5316839f42959d64$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $5316839f42959d64$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $5316839f42959d64$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) el.setShape('r', itemModel.get([
        'itemStyle',
        'borderRadius'
    ]) || 0);
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
    var labelStatesModels = (0, $hcRXD.getLabelStatesModels)(itemModel);
    (0, $hcRXD.setLabelStyle)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $bY5Ss.getDefaultLabel)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $4L1H1.setSectorTextRotation)(el, position === 'outside' ? labelPositionOutside : position, $5316839f42959d64$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $hcRXD.setLabelValueAnimation)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $bY5Ss.getDefaultInterpolatedLabel)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $51xyq.enableHoverEmphasis)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'));
    (0, $51xyq.setStatesStylesFromModel)(el, itemModel);
    if ($5316839f42959d64$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $hzBt5.each)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
} // In case width or height are too small.
function $5316839f42959d64$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0; // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $5316839f42959d64$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $5316839f42959d64$var$LargePath = /** @class */ function(_super) {
    (0, $fKE23.__extends)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $5316839f42959d64$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var startPoint = this.__startPoint;
        var baseDimIdx = this.__baseDimIdx;
        for(var i = 0; i < points.length; i += 2){
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            ctx.moveTo(startPoint[0], startPoint[1]);
            ctx.lineTo(points[i], points[i + 1]);
        }
    };
    return LargePath;
}((0, $hMiip.default));
function $5316839f42959d64$var$createLarge(seriesModel, group, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var startPoint = [];
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('barWidth');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var drawBackground = seriesModel.get('showBackground', true);
    if (drawBackground) {
        var points = data.getLayout('largeBackgroundPoints');
        var backgroundStartPoint = [];
        backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
        var bgEl = new $5316839f42959d64$var$LargePath({
            shape: {
                points: points
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.__startPoint = backgroundStartPoint;
        bgEl.__baseDimIdx = baseDimIdx;
        bgEl.__largeDataIndices = largeDataIndices;
        bgEl.__barWidth = barWidth;
        $5316839f42959d64$var$setLargeBackgroundStyle(bgEl, backgroundModel, data);
        group.add(bgEl);
    }
    var el = new $5316839f42959d64$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: !!incremental
    });
    el.__startPoint = startPoint;
    el.__baseDimIdx = baseDimIdx;
    el.__largeDataIndices = largeDataIndices;
    el.__barWidth = barWidth;
    group.add(el);
    $5316839f42959d64$var$setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.
    (0, $aly4X.getECData)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $5316839f42959d64$var$largePathUpdateDataIndex);
        el.on('mousemove', $5316839f42959d64$var$largePathUpdateDataIndex);
    }
} // Use throttle to avoid frequently traverse to find dataIndex.
var $5316839f42959d64$var$largePathUpdateDataIndex = (0, $7b8YY.throttle)(function(event) {
    var largePath = this;
    var dataIndex = $5316839f42959d64$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $aly4X.getECData)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $5316839f42959d64$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.__baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.__largeDataIndices;
    var barWidthHalf = Math.abs(largePath.__barWidth / 2);
    var startValueVal = largePath.__startPoint[valueDimIdx];
    $5316839f42959d64$var$_eventPos[0] = x;
    $5316839f42959d64$var$_eventPos[1] = y;
    var pointerBaseVal = $5316839f42959d64$var$_eventPos[baseDimIdx];
    var pointerValueVal = $5316839f42959d64$var$_eventPos[1 - baseDimIdx];
    var baseLowerBound = pointerBaseVal - barWidthHalf;
    var baseUpperBound = pointerBaseVal + barWidthHalf;
    for(var i = 0, len = points.length / 2; i < len; i++){
        var ii = i * 2;
        var barBaseVal = points[ii + baseDimIdx];
        var barValueVal = points[ii + valueDimIdx];
        if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) return largeDataIndices[i];
    }
    return -1;
}
function $5316839f42959d64$var$setLargeStyle(el, seriesModel, data) {
    var globalStyle = data.getVisual('style');
    el.useStyle((0, $hzBt5.extend)({}, globalStyle)); // Use stroke instead of fill.
    el.style.fill = null;
    el.style.stroke = globalStyle.fill;
    el.style.lineWidth = data.getLayout('barWidth');
}
function $5316839f42959d64$var$setLargeBackgroundStyle(el, backgroundModel, data) {
    var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
    var itemStyle = backgroundModel.getItemStyle();
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
    el.style.lineWidth = data.getLayout('barWidth');
}
function $5316839f42959d64$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $PS5GS.isCoordinateSystemType)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $5316839f42959d64$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $rnA7j.default) : (0, $aeCKo.default);
    return new ElementClz({
        shape: $5316839f42959d64$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $5316839f42959d64$export$2e2bcd8739ae039 = $5316839f42959d64$var$BarView;

});
parcelRegister("7b8YY", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $53a0873be950d098$export$de363e709c412c8a);
$parcel$export(module.exports, "createOrUpdate", () => $53a0873be950d098$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "clear", () => $53a0873be950d098$export$42ffd38884aecdac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $53a0873be950d098$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $53a0873be950d098$var$RATE = '\0__throttleRate';
var $53a0873be950d098$var$THROTTLE_TYPE = '\0__throttleType';
function $53a0873be950d098$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $53a0873be950d098$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$53a0873be950d098$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$53a0873be950d098$var$THROTTLE_TYPE];
    var lastRate = fn[$53a0873be950d098$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $53a0873be950d098$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$53a0873be950d098$var$ORIGIN_METHOD] = originFn;
        fn[$53a0873be950d098$var$THROTTLE_TYPE] = throttleType;
        fn[$53a0873be950d098$var$RATE] = rate;
    }
    return fn;
}
function $53a0873be950d098$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$53a0873be950d098$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$53a0873be950d098$var$ORIGIN_METHOD];
}

});

parcelRegister("gNqT1", function(module, exports) {

$parcel$export(module.exports, "createGridClipPath", () => $c3a6140b1e4a0074$export$83958787eb658d14);
$parcel$export(module.exports, "createPolarClipPath", () => $c3a6140b1e4a0074$export$13dc2b2230df3cb5);
$parcel$export(module.exports, "createClipPath", () => $c3a6140b1e4a0074$export$e0fe5081209d01c9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");
var $rnA7j = parcelRequire("rnA7j");

var $5BQXp = parcelRequire("5BQXp");
function $c3a6140b1e4a0074$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
    x = Math.floor(x);
    width = Math.round(width);
    var clipPath = new $aeCKo.default({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = typeof during === 'function' ? function(percent) {
            during(percent, clipPath);
        } : null;
        $9ubot.initProps(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $c3a6140b1e4a0074$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $5BQXp.round)(sectorArea.r0, 1);
    var r = (0, $5BQXp.round)(sectorArea.r, 1);
    var clipPath = new $rnA7j.default({
        shape: {
            cx: (0, $5BQXp.round)(polar.cx, 1),
            cy: (0, $5BQXp.round)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $9ubot.initProps(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $c3a6140b1e4a0074$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $c3a6140b1e4a0074$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $c3a6140b1e4a0074$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}

});

parcelRegister("hzMcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccbb18d0f74c8c01$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");
parcelRequire("8q0E1");
var $hMiip = parcelRequire("hMiip");
/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $ccbb18d0f74c8c01$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $ccbb18d0f74c8c01$var$SausagePath = /** @class */ function(_super) {
    (0, $fKE23.__extends)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $ccbb18d0f74c8c01$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
            ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
        }
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
        ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
        ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) {
            ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
            ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
        }
        ctx.closePath();
    };
    return SausagePath;
}((0, $hMiip.default));
var $ccbb18d0f74c8c01$export$2e2bcd8739ae039 = $ccbb18d0f74c8c01$var$SausagePath;

});

parcelRegister("azEx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b2c9d57df7f60e3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $hXAsm = parcelRequire("hXAsm");

var $9aOrz = parcelRequire("9aOrz");

var $jKrBG = parcelRequire("jKrBG");

var $ckizb = parcelRequire("ckizb");

var $51xyq = parcelRequire("51xyq");

var $bw304 = parcelRequire("bw304");

var $xPMeE = parcelRequire("xPMeE");
var $7b2c9d57df7f60e3$var$inner = $ckizb.makeInner();
var $7b2c9d57df7f60e3$var$renderPlanner = (0, $xPMeE.default)();
var $7b2c9d57df7f60e3$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $hXAsm.default)();
        this.uid = $9aOrz.getUID('viewChart');
        this.renderTask = (0, $bw304.createTask)({
            plan: $7b2c9d57df7f60e3$var$renderTaskPlan,
            reset: $7b2c9d57df7f60e3$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        $7b2c9d57df7f60e3$var$toggleHighlight(seriesModel.getData(), payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        $7b2c9d57df7f60e3$var$toggleHighlight(seriesModel.getData(), payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $7b2c9d57df7f60e3$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $7b2c9d57df7f60e3$var$elSetState(el, state, highlightDigit) {
    if (el) (state === 'emphasis' ? (0, $51xyq.enterEmphasis) : (0, $51xyq.leaveEmphasis))(el, highlightDigit);
}
function $7b2c9d57df7f60e3$var$toggleHighlight(data, payload, state) {
    var dataIndex = $ckizb.queryDataIndex(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $51xyq.getHighlightDigit)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $hzBt5.each)($ckizb.normalizeToArray(dataIndex), function(dataIdx) {
        $7b2c9d57df7f60e3$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $7b2c9d57df7f60e3$var$elSetState(el, state, highlightDigit);
    });
}
$jKrBG.enableClassExtend($7b2c9d57df7f60e3$var$ChartView, [
    'dispose'
]);
$jKrBG.enableClassManagement($7b2c9d57df7f60e3$var$ChartView);
function $7b2c9d57df7f60e3$var$renderTaskPlan(context) {
    return $7b2c9d57df7f60e3$var$renderPlanner(context.model);
}
function $7b2c9d57df7f60e3$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload; // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $7b2c9d57df7f60e3$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
     : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $7b2c9d57df7f60e3$var$progressMethodMap[methodName];
}
var $7b2c9d57df7f60e3$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $7b2c9d57df7f60e3$export$2e2bcd8739ae039 = $7b2c9d57df7f60e3$var$ChartView;

});

parcelRegister("PS5GS", function(module, exports) {

$parcel$export(module.exports, "isCoordinateSystemType", () => $09beb8d67d3f2200$export$8567506e6336616);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $09beb8d67d3f2200$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}

});

parcelRegister("bY5Ss", function(module, exports) {

$parcel$export(module.exports, "getDefaultLabel", () => $8b69db686b4b90ad$export$5ff20667590927ed);
$parcel$export(module.exports, "getDefaultInterpolatedLabel", () => $8b69db686b4b90ad$export$5f84815e91ca6775);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kWuWu = parcelRequire("kWuWu");

var $hzBt5 = parcelRequire("hzBt5");
function $8b69db686b4b90ad$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $kWuWu.retrieveRawValue)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $kWuWu.retrieveRawValue)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $8b69db686b4b90ad$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $hzBt5.isArray)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}

});

parcelRegister("4L1H1", function(module, exports) {

$parcel$export(module.exports, "createSectorCalculateTextPosition", () => $376cdd6515ca3bdb$export$359a1e2d210ed734);
$parcel$export(module.exports, "setSectorTextRotation", () => $376cdd6515ca3bdb$export$672ce504c0db395a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $02NbV = parcelRequire("02NbV");

var $hzBt5 = parcelRequire("hzBt5");
function $376cdd6515ca3bdb$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $02NbV.calculateTextPosition)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin; // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $376cdd6515ca3bdb$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $02NbV.calculateTextPosition)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $376cdd6515ca3bdb$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if (typeof rotateType === 'number') {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $hzBt5.isArray)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $376cdd6515ca3bdb$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $376cdd6515ca3bdb$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}

});



parcelRegister("fbiaz", function(module, exports) {

$parcel$export(module.exports, "install", () => $b0d5fa2ea927ad97$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jTM8g = parcelRequire("jTM8g");

var $aw6hh = parcelRequire("aw6hh");

var $lDnHX = parcelRequire("lDnHX");
function $b0d5fa2ea927ad97$export$4b3e715f166fdd78(registers) {
    (0, $lDnHX.use)((0, $jTM8g.install));
    (0, $lDnHX.use)((0, $aw6hh.install));
}

});
parcelRegister("jTM8g", function(module, exports) {

$parcel$export(module.exports, "install", () => $e7c87d713e83226d$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $4uCJH = parcelRequire("4uCJH");

var $9iciO = parcelRequire("9iciO");
parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");

var $hzBt5 = parcelRequire("hzBt5");

var $db0cX = parcelRequire("db0cX");

var $5gJmr = parcelRequire("5gJmr");

var $a91qA = parcelRequire("a91qA");

var $9SXxl = parcelRequire("9SXxl");
var $e7c87d713e83226d$var$GridView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $aeCKo.default)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $hzBt5.defaults)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $4uCJH.default));
var $e7c87d713e83226d$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $e7c87d713e83226d$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($e7c87d713e83226d$var$GridView);
    registers.registerComponentModel((0, $9iciO.default));
    registers.registerCoordinateSystem('cartesian2d', (0, $a91qA.default));
    (0, $5gJmr.default)(registers, 'x', (0, $db0cX.CartesianAxisModel), $e7c87d713e83226d$var$extraOption);
    (0, $5gJmr.default)(registers, 'y', (0, $db0cX.CartesianAxisModel), $e7c87d713e83226d$var$extraOption);
    registers.registerComponentView((0, $9SXxl.CartesianXAxisView));
    registers.registerComponentView((0, $9SXxl.CartesianYAxisView));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}

});
parcelRegister("4uCJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $345802f60717b6ff$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hXAsm = parcelRequire("hXAsm");

var $9aOrz = parcelRequire("9aOrz");

var $jKrBG = parcelRequire("jKrBG");
var $345802f60717b6ff$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $hXAsm.default)();
        this.uid = $9aOrz.getUID('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {};
    /**
   * Hook for blur target series.
   * Can be used in marker for blur the markers
   */ ComponentView.prototype.blurSeries = function(seriesModels, ecModel) {};
    return ComponentView;
}();
$jKrBG.enableClassExtend($345802f60717b6ff$var$ComponentView);
$jKrBG.enableClassManagement($345802f60717b6ff$var$ComponentView);
var $345802f60717b6ff$export$2e2bcd8739ae039 = $345802f60717b6ff$var$ComponentView;

});

parcelRegister("9iciO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3f567a5987591d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $6IEE1 = parcelRequire("6IEE1");
var $6c3f567a5987591d$var$GridModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        zlevel: 0,
        z: 0,
        left: '10%',
        top: 60,
        right: '10%',
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: 'rgba(0,0,0,0)',
        borderWidth: 1,
        borderColor: '#ccc'
    };
    return GridModel;
}((0, $6IEE1.default));
var $6c3f567a5987591d$export$2e2bcd8739ae039 = $6c3f567a5987591d$var$GridModel;

});

parcelRegister("db0cX", function(module, exports) {

$parcel$export(module.exports, "CartesianAxisModel", () => $997c76b868ef464d$export$483dc37e6ad83a3c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $6IEE1 = parcelRequire("6IEE1");

var $kN6By = parcelRequire("kN6By");

var $ckizb = parcelRequire("ckizb");
var $997c76b868ef464d$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $ckizb.SINGLE_REFERRING)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $6IEE1.default));
$hzBt5.mixin($997c76b868ef464d$export$483dc37e6ad83a3c, (0, $kN6By.AxisModelCommonMixin));
var $997c76b868ef464d$export$2e2bcd8739ae039 = $997c76b868ef464d$export$483dc37e6ad83a3c;

});
parcelRegister("kN6By", function(module, exports) {

$parcel$export(module.exports, "AxisModelCommonMixin", () => $f22d81d59d03880b$export$5c54b224726edb5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $f22d81d59d03880b$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();

});


parcelRegister("5gJmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d61a220882361ee$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $aBFQR = parcelRequire("aBFQR");

var $e4mIu = parcelRequire("e4mIu");

var $gVr2C = parcelRequire("gVr2C");

var $8qCTD = parcelRequire("8qCTD");

var $hzBt5 = parcelRequire("hzBt5");
function $3d61a220882361ee$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $hzBt5.each)((0, $8qCTD.AXIS_TYPES), function(v, axisType) {
        var defaultOption = (0, $hzBt5.merge)((0, $hzBt5.merge)({}, (0, $aBFQR.default)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $fKE23.__extends)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $e4mIu.fetchLayoutMode)(this);
                var inputPositionParams = layoutMode ? (0, $e4mIu.getLayoutParams)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $hzBt5.merge)(option, themeModel.get(axisType + 'Axis'));
                (0, $hzBt5.merge)(option, this.getDefaultOption());
                option.type = $3d61a220882361ee$var$getAxisType(option);
                if (layoutMode) (0, $e4mIu.mergeLayoutParam)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $gVr2C.default).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option; // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $3d61a220882361ee$var$getAxisType);
}
function $3d61a220882361ee$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}

});
parcelRegister("aBFQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b8dd2ed4a973225$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $7b8dd2ed4a973225$var$defaultOption = {
    show: true,
    zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: '#6E7079',
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        lineStyle: {
            color: [
                '#E0E6F1'
            ],
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                'rgba(250,250,250,0.2)',
                'rgba(210,219,238,0.2)'
            ]
        }
    }
};
var $7b8dd2ed4a973225$var$categoryAxis = $hzBt5.merge({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $7b8dd2ed4a973225$var$defaultOption);
var $7b8dd2ed4a973225$var$valueAxis = $hzBt5.merge({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Lenght of minor tick
        length: 3,
        // Line style
        lineStyle: {}
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: '#F4F7FD',
            width: 1
        }
    }
}, $7b8dd2ed4a973225$var$defaultOption);
var $7b8dd2ed4a973225$var$timeAxis = $hzBt5.merge({
    scale: true,
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $7b8dd2ed4a973225$var$valueAxis);
var $7b8dd2ed4a973225$var$logAxis = $hzBt5.defaults({
    scale: true,
    logBase: 10
}, $7b8dd2ed4a973225$var$valueAxis);
var $7b8dd2ed4a973225$export$2e2bcd8739ae039 = {
    category: $7b8dd2ed4a973225$var$categoryAxis,
    value: $7b8dd2ed4a973225$var$valueAxis,
    time: $7b8dd2ed4a973225$var$timeAxis,
    log: $7b8dd2ed4a973225$var$logAxis
};

});

parcelRegister("gVr2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $c526f20861d11227$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $c526f20861d11227$var$uidBase = 0;
var $c526f20861d11227$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$c526f20861d11227$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $hzBt5.map)(data, $c526f20861d11227$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (typeof category !== 'string' && !needCollect) return category;
         // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap(); // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category; // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    }; // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $hzBt5.createHashMap)(this.categories));
    };
    return OrdinalMeta;
}();
function $c526f20861d11227$var$getName(obj) {
    if ((0, $hzBt5.isObject)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $c526f20861d11227$export$2e2bcd8739ae039 = $c526f20861d11227$var$OrdinalMeta;

});

parcelRegister("8qCTD", function(module, exports) {

$parcel$export(module.exports, "AXIS_TYPES", () => $622eec6b1b3cf382$export$2e0057d176d6f690);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $622eec6b1b3cf382$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};

});


parcelRegister("a91qA", function(module, exports) {

$parcel$export(module.exports, "default", () => $762bda27db553b3c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 
var $hzBt5 = parcelRequire("hzBt5");

var $e4mIu = parcelRequire("e4mIu");

var $ekDcz = parcelRequire("ekDcz");

var $4OY0R = parcelRequire("4OY0R");

var $jhbA1 = parcelRequire("jhbA1");

var $ckizb = parcelRequire("ckizb");

var $aV7Yx = parcelRequire("aV7Yx");
var $762bda27db553b3c$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $4OY0R.cartesian2DDimensions);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        (0, $hzBt5.each)(axesMap.x, function(xAxis) {
            (0, $ekDcz.niceScaleExtent)(xAxis.scale, xAxis.model);
        });
        (0, $hzBt5.each)(axesMap.y, function(yAxis) {
            (0, $ekDcz.niceScaleExtent)(yAxis.scale, yAxis.model);
        }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $hzBt5.each)(axesMap.x, function(xAxis) {
            $762bda27db553b3c$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $hzBt5.each)(axesMap.y, function(yAxis) {
            $762bda27db553b3c$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        }); // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
        var gridRect = (0, $e4mIu.getLayoutRect)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes(); // Minus label size
        if (isContainLabel) {
            (0, $hzBt5.each)(axesList, function(axis) {
                if (!axis.model.get([
                    'axisLabel',
                    'inside'
                ])) {
                    var labelUnionRect = (0, $ekDcz.estimateLabelUnionRect)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? 'height' : 'width';
                        var margin = axis.model.get([
                            'axisLabel',
                            'margin'
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $hzBt5.each)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $hzBt5.each)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $762bda27db553b3c$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0]; // if (axisIndex == null) {
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $hzBt5.isObject)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $hzBt5.indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        }; /// Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap; /// Create cartesian2d
        (0, $hzBt5.each)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $hzBt5.each)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $4OY0R.default)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$762bda27db553b3c$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $jhbA1.default)(dimName, (0, $ekDcz.createScaleByModel)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
                axisModel.axis = axis; // Inject axisModel into axis
                axis.model = axisModel; // Inject grid info axis
                axis.grid = grid; // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $hzBt5.each)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $aV7Yx.isCartesian2DSeries)(seriesModel)) {
                var axesModelMap = (0, $aV7Yx.findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$762bda27db553b3c$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$762bda27db553b3c$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                if (data.type === 'list') {
                    unionExtent(data, xAxis);
                    unionExtent(data, yAxis);
                }
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $hzBt5.each)((0, $ekDcz.getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $hzBt5.each)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $hzBt5.indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $hzBt5.indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        }); // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $aV7Yx.isCartesian2DSeries)(seriesModel)) return;
            var axesModelMap = (0, $aV7Yx.findAxisModels)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    }; // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $4OY0R.cartesian2DDimensions);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $762bda27db553b3c$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $762bda27db553b3c$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    }; // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
     // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($762bda27db553b3c$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $762bda27db553b3c$var$canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
         && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $762bda27db553b3c$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $ekDcz.ifAxisCrossZero)(axis);
}
function $762bda27db553b3c$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $762bda27db553b3c$export$2e2bcd8739ae039 = $762bda27db553b3c$var$Grid;

});
parcelRegister("ekDcz", function(module, exports) {

$parcel$export(module.exports, "getScaleExtent", () => $a6f1579ebd91fed2$export$9c0ba8df7eb7b328);
$parcel$export(module.exports, "niceScaleExtent", () => $a6f1579ebd91fed2$export$51f3e70a54405d5a);
$parcel$export(module.exports, "createScaleByModel", () => $a6f1579ebd91fed2$export$8941c4cacdc8f5a5);
$parcel$export(module.exports, "ifAxisCrossZero", () => $a6f1579ebd91fed2$export$3eac36a69f37d52);
$parcel$export(module.exports, "makeLabelFormatter", () => $a6f1579ebd91fed2$export$742f19a75415b2ae);
$parcel$export(module.exports, "getAxisRawValue", () => $a6f1579ebd91fed2$export$a5a32f324c1fa457);
$parcel$export(module.exports, "estimateLabelUnionRect", () => $a6f1579ebd91fed2$export$fef1c7f0af0b48d);
$parcel$export(module.exports, "getOptionCategoryInterval", () => $a6f1579ebd91fed2$export$6d0bc2429155c088);
$parcel$export(module.exports, "shouldShowAllLabels", () => $a6f1579ebd91fed2$export$c2911c025243d6a6);
$parcel$export(module.exports, "getDataDimensionsOnAxis", () => $a6f1579ebd91fed2$export$e4cf30b1e74cd69d);
$parcel$export(module.exports, "unionAxisExtentFromData", () => $a6f1579ebd91fed2$export$635fe7f20d0f4c70);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $7eBWJ = parcelRequire("7eBWJ");

var $aRcTH = parcelRequire("aRcTH");

var $fUFf0 = parcelRequire("fUFf0");

var $hMtFz = parcelRequire("hMtFz");

var $lGSv6 = parcelRequire("lGSv6");

var $kXmQc = parcelRequire("kXmQc");

var $76hW4 = parcelRequire("76hW4");

var $lljDt = parcelRequire("lljDt");

var $h3hFK = parcelRequire("h3hFK");
function $a6f1579ebd91fed2$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $h3hFK.ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max; // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time') {
        var barSeriesModels = (0, $hMtFz.prepareLayoutBarSeries)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $hzBt5.each(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $hMtFz.makeColumnLayout)(barSeriesModels); // Adjust axis min and max to account for overflow
            var adjustedScale = $a6f1579ebd91fed2$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $a6f1579ebd91fed2$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $hMtFz.retrieveColumnLayout)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $hzBt5.each(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $hzBt5.each(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow; // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
} // Precondition of calling this method:
function $a6f1579ebd91fed2$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $a6f1579ebd91fed2$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $76hW4.default)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    scale.setExtent(extent[0], extent[1]);
    scale.niceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
        maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
    }); // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    var interval = model.get('interval');
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $a6f1579ebd91fed2$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $7eBWJ.default)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $kXmQc.default)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $fUFf0.default).getClass(axisType) || (0, $aRcTH.default))();
    }
}
function $a6f1579ebd91fed2$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $a6f1579ebd91fed2$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === 'time') return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'string') return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace('{value}', label != null ? label : '');
            return text;
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'function') return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($a6f1579ebd91fed2$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $a6f1579ebd91fed2$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $a6f1579ebd91fed2$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        'axisLabel',
        'show'
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $7eBWJ.default)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $a6f1579ebd91fed2$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1; // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $a6f1579ebd91fed2$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $a6f1579ebd91fed2$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $lGSv6.default)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $a6f1579ebd91fed2$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $a6f1579ebd91fed2$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $a6f1579ebd91fed2$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $a6f1579ebd91fed2$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {}; // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $hzBt5.each(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $lljDt.getStackedDimension)(data, dataDim)] = true;
    });
    return $hzBt5.keys(dataDimMap);
}
function $a6f1579ebd91fed2$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $hzBt5.each($a6f1579ebd91fed2$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}

});
parcelRegister("7eBWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5447468bef84e5be$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $fUFf0 = parcelRequire("fUFf0");

var $gVr2C = parcelRequire("gVr2C");

var $9A4zx = parcelRequire("9A4zx");

var $hzBt5 = parcelRequire("hzBt5");
var $5447468bef84e5be$var$OrdinalScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta'); // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $gVr2C.default)({});
        if ((0, $hzBt5.isArray)(ordinalMeta)) ordinalMeta = new (0, $gVr2C.default)({
            categories: (0, $hzBt5.map)(ordinalMeta, function(item) {
                return (0, $hzBt5.isObject)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
         : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $9A4zx.contain(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $9A4zx.normalize(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($9A4zx.scale(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = []; // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        } // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber; // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick; // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber]; // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.niceTicks = function() {};
    OrdinalScale.prototype.niceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $fUFf0.default));
(0, $fUFf0.default).registerClass($5447468bef84e5be$var$OrdinalScale);
var $5447468bef84e5be$export$2e2bcd8739ae039 = $5447468bef84e5be$var$OrdinalScale;

});
parcelRegister("fUFf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95c139b91880cb7$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jKrBG = parcelRequire("jKrBG");
var $b95c139b91880cb7$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$jKrBG.enableClassManagement($b95c139b91880cb7$var$Scale);
var $b95c139b91880cb7$export$2e2bcd8739ae039 = $b95c139b91880cb7$var$Scale;

});

parcelRegister("9A4zx", function(module, exports) {

$parcel$export(module.exports, "intervalScaleNiceTicks", () => $6f9b05c8b09f6a8d$export$eeea879a611eb991);
$parcel$export(module.exports, "getIntervalPrecision", () => $6f9b05c8b09f6a8d$export$86a060b060d3d31a);
$parcel$export(module.exports, "contain", () => $6f9b05c8b09f6a8d$export$8893e2b90ba10d92);
$parcel$export(module.exports, "normalize", () => $6f9b05c8b09f6a8d$export$a3295358bff77e);
$parcel$export(module.exports, "scale", () => $6f9b05c8b09f6a8d$export$dcdf75081b88279d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");
var $6f9b05c8b09f6a8d$var$roundNumber = $5BQXp.round;
function $6f9b05c8b09f6a8d$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = $5BQXp.nice(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
     // Tow more digital for tick.
    var precision = result.intervalPrecision = $6f9b05c8b09f6a8d$export$86a060b060d3d31a(interval); // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        $6f9b05c8b09f6a8d$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
        $6f9b05c8b09f6a8d$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $6f9b05c8b09f6a8d$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $6f9b05c8b09f6a8d$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return $5BQXp.getPrecision(interval) + 2;
}
function $6f9b05c8b09f6a8d$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
function $6f9b05c8b09f6a8d$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $6f9b05c8b09f6a8d$var$clamp(niceTickExtent, 0, extent);
    $6f9b05c8b09f6a8d$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $6f9b05c8b09f6a8d$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $6f9b05c8b09f6a8d$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $6f9b05c8b09f6a8d$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}

});


parcelRegister("aRcTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e78dbc9db2b6379$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $5BQXp = parcelRequire("5BQXp");

var $gyplX = parcelRequire("gyplX");

var $fUFf0 = parcelRequire("fUFf0");

var $9A4zx = parcelRequire("9A4zx");
var $7e78dbc9db2b6379$var$roundNumber = $5BQXp.round;
var $7e78dbc9db2b6379$var$IntervalScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval'; // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $9A4zx.contain(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $9A4zx.normalize(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $9A4zx.scale(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent; // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
        // We assume user wan't to set both interval, min, max to get a better result
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $9A4zx.getIntervalPrecision(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
         // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $7e78dbc9db2b6379$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            }); // Avoid rounding error
            tick = $7e78dbc9db2b6379$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        } // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $7e78dbc9db2b6379$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $7e78dbc9db2b6379$var$roundNumber(prevTick.value + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $5BQXp.getPrecision(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
         // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $7e78dbc9db2b6379$var$roundNumber(data.value, precision, true);
        return $gyplX.addCommas(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.niceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
         // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $9A4zx.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                var expandSize = extent[0]; // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $7e78dbc9db2b6379$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $7e78dbc9db2b6379$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $fUFf0.default));
(0, $fUFf0.default).registerClass($7e78dbc9db2b6379$var$IntervalScale);
var $7e78dbc9db2b6379$export$2e2bcd8739ae039 = $7e78dbc9db2b6379$var$IntervalScale;

});

parcelRegister("kXmQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41b090cc8e9c237$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $5BQXp = parcelRequire("5BQXp");

var $24InP = parcelRequire("24InP");

var $9A4zx = parcelRequire("9A4zx");

var $aRcTH = parcelRequire("aRcTH");

var $fUFf0 = parcelRequire("fUFf0");


var $hzBt5 = parcelRequire("hzBt5");
var $f41b090cc8e9c237$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $f41b090cc8e9c237$var$TimeScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $24InP.format)(tick.value, (0, $24InP.fullLeveledFormatter)[(0, $24InP.getDefaultFormatPrecisionOfInterval)((0, $24InP.getPrimaryTimeUnit)(this._minLevelUnit))] || (0, $24InP.fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $24InP.leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ TimeScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting('useUTC');
        var innerTicks = $f41b090cc8e9c237$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $24InP.ONE_DAY);
            extent[1] += (0, $24InP.ONE_DAY);
        } // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $24InP.ONE_DAY);
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.niceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $f41b090cc8e9c237$var$scaleIntervals.length;
        var idx = Math.min($f41b090cc8e9c237$var$bisect($f41b090cc8e9c237$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1); // Interval that can be used to calculate ticks
        this._interval = $f41b090cc8e9c237$var$scaleIntervals[idx][1]; // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $f41b090cc8e9c237$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return typeof val === 'number' ? val : +$5BQXp.parseDate(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $9A4zx.contain(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $9A4zx.normalize(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $9A4zx.scale(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $aRcTH.default));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $f41b090cc8e9c237$var$scaleIntervals = [
    [
        'second',
        (0, $24InP.ONE_SECOND)
    ],
    [
        'minute',
        (0, $24InP.ONE_MINUTE)
    ],
    [
        'hour',
        (0, $24InP.ONE_HOUR)
    ],
    [
        'quarter-day',
        (0, $24InP.ONE_HOUR) * 6
    ],
    [
        'half-day',
        (0, $24InP.ONE_HOUR) * 12
    ],
    [
        'day',
        (0, $24InP.ONE_DAY) * 1.2
    ],
    [
        'half-week',
        (0, $24InP.ONE_DAY) * 3.5
    ],
    [
        'week',
        (0, $24InP.ONE_DAY) * 7
    ],
    [
        'month',
        (0, $24InP.ONE_DAY) * 31
    ],
    [
        'quarter',
        (0, $24InP.ONE_DAY) * 95
    ],
    [
        'half-year',
        (0, $24InP.ONE_YEAR) / 2
    ],
    [
        'year',
        (0, $24InP.ONE_YEAR)
    ] // 1Y
];
function $f41b090cc8e9c237$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $5BQXp.parseDate(valueA);
    var dateB = $5BQXp.parseDate(valueB);
    var isSame = function(unit) {
        return (0, $24InP.getUnitValue)(dateA, unit, isUTC) === (0, $24InP.getUnitValue)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame('year');
    }; // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame('month');
    };
    var isSameDay = function() {
        return isSameMonth() && isSame('day');
    }; // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame('hour');
    };
    var isSameMinute = function() {
        return isSameHour() && isSame('minute');
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame('second');
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame('millisecond');
    };
    switch(unit){
        case 'year':
            return isSameYear();
        case 'month':
            return isSameMonth();
        case 'day':
            return isSameDay();
        case 'hour':
            return isSameHour();
        case 'minute':
            return isSameMinute();
        case 'second':
            return isSameSecond();
        case 'millisecond':
            return isSameMilliSecond();
    }
} // const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $f41b090cc8e9c237$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $24InP.ONE_DAY);
    return approxInterval > 16 ? 16 // Math.floor(daysInMonth / 2) + 1  // In this case we only want one tick betwen two month.
     : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $24InP.ONE_DAY);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $24InP.ONE_HOUR);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $24InP.ONE_MINUTE) : (0, $24InP.ONE_SECOND);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getMillisecondsInterval(approxInterval) {
    return $5BQXp.nice(approxInterval, true);
}
function $f41b090cc8e9c237$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $24InP.getPrimaryTimeUnit)(unitName)){
        case 'year':
        case 'month':
            outDate[(0, $24InP.monthSetterName)(isUTC)](0);
        case 'day':
            outDate[(0, $24InP.dateSetterName)(isUTC)](1);
        case 'hour':
            outDate[(0, $24InP.hoursSetterName)(isUTC)](0);
        case 'minute':
            outDate[(0, $24InP.minutesSetterName)(isUTC)](0);
        case 'second':
            outDate[(0, $24InP.secondsSetterName)(isUTC)](0);
            outDate[(0, $24InP.millisecondsSetterName)(isUTC)](0);
    }
    return outDate.getTime();
}
function $f41b090cc8e9c237$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $24InP.timeUnits);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName](); // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        } // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($f41b090cc8e9c237$var$isUnitValueSame((0, $24InP.getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $f41b090cc8e9c237$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $24InP.ONE_DAY) / 365));
                    getterName = (0, $24InP.fullYearGetterName)(isUTC);
                    setterName = (0, $24InP.fullYearSetterName)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $f41b090cc8e9c237$var$getMonthInterval(approxInterval);
                    getterName = (0, $24InP.monthGetterName)(isUTC);
                    setterName = (0, $24InP.monthSetterName)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $f41b090cc8e9c237$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $24InP.dateGetterName)(isUTC);
                    setterName = (0, $24InP.dateSetterName)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $f41b090cc8e9c237$var$getHourInterval(approxInterval);
                    getterName = (0, $24InP.hoursGetterName)(isUTC);
                    setterName = (0, $24InP.hoursSetterName)(isUTC);
                    break;
                case 'minute':
                    interval = $f41b090cc8e9c237$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $24InP.minutesGetterName)(isUTC);
                    setterName = (0, $24InP.minutesSetterName)(isUTC);
                    break;
                case 'second':
                    interval = $f41b090cc8e9c237$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $24InP.secondsGetterName)(isUTC);
                    setterName = (0, $24InP.secondsSetterName)(isUTC);
                    break;
                case 'millisecond':
                    interval = $f41b090cc8e9c237$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $24InP.millisecondsGetterName)(isUTC);
                    setterName = (0, $24InP.millisecondsSetterName)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
         // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $24InP.getPrimaryTimeUnit)(unitNames[i]);
        if (!(0, $24InP.isPrimaryTimeUnit)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $24InP.getPrimaryTimeUnit)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount; // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval; // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                 // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            } // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $hzBt5.filter)((0, $hzBt5.map)(levelsTicks, function(levelTicks) {
        return (0, $hzBt5.filter)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    }); // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $fUFf0.default).registerClass($f41b090cc8e9c237$var$TimeScale);
var $f41b090cc8e9c237$export$2e2bcd8739ae039 = $f41b090cc8e9c237$var$TimeScale;

});

parcelRegister("76hW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $52b70196934cb73f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $fUFf0 = parcelRequire("fUFf0");

var $5BQXp = parcelRequire("5BQXp");

var $9A4zx = parcelRequire("9A4zx");

var $aRcTH = parcelRequire("aRcTH");
var $52b70196934cb73f$var$scaleProto = (0, $fUFf0.default).prototype; // FIXME:TS refactor: not good to call it directly with `this`?
var $52b70196934cb73f$var$intervalScaleProto = (0, $aRcTH.default).prototype;
var $52b70196934cb73f$var$roundingErrorFix = $5BQXp.round;
var $52b70196934cb73f$var$mathFloor = Math.floor;
var $52b70196934cb73f$var$mathCeil = Math.ceil;
var $52b70196934cb73f$var$mathPow = Math.pow;
var $52b70196934cb73f$var$mathLog = Math.log;
var $52b70196934cb73f$var$LogScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $aRcTH.default)(); // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $52b70196934cb73f$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $hzBt5.map(ticks, function(tick) {
            var val = tick.value;
            var powVal = $5BQXp.round($52b70196934cb73f$var$mathPow(this.base, val)); // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $52b70196934cb73f$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $52b70196934cb73f$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = this.base;
        start = $52b70196934cb73f$var$mathLog(start) / $52b70196934cb73f$var$mathLog(base);
        end = $52b70196934cb73f$var$mathLog(end) / $52b70196934cb73f$var$mathLog(base);
        $52b70196934cb73f$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $52b70196934cb73f$var$scaleProto.getExtent.call(this);
        extent[0] = $52b70196934cb73f$var$mathPow(base, extent[0]);
        extent[1] = $52b70196934cb73f$var$mathPow(base, extent[1]); // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $52b70196934cb73f$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $52b70196934cb73f$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $52b70196934cb73f$var$mathLog(extent[0]) / $52b70196934cb73f$var$mathLog(base);
        extent[1] = $52b70196934cb73f$var$mathLog(extent[1]) / $52b70196934cb73f$var$mathLog(base);
        $52b70196934cb73f$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.niceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $5BQXp.quantity(span);
        var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
         // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $5BQXp.round($52b70196934cb73f$var$mathCeil(extent[0] / interval) * interval),
            $5BQXp.round($52b70196934cb73f$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.niceExtent = function(opt) {
        $52b70196934cb73f$var$intervalScaleProto.niceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $52b70196934cb73f$var$mathLog(val) / $52b70196934cb73f$var$mathLog(this.base);
        return $9A4zx.contain(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $52b70196934cb73f$var$mathLog(val) / $52b70196934cb73f$var$mathLog(this.base);
        return $9A4zx.normalize(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $9A4zx.scale(val, this._extent);
        return $52b70196934cb73f$var$mathPow(this.base, val);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $fUFf0.default));
var $52b70196934cb73f$var$proto = $52b70196934cb73f$var$LogScale.prototype;
$52b70196934cb73f$var$proto.getMinorTicks = $52b70196934cb73f$var$intervalScaleProto.getMinorTicks;
$52b70196934cb73f$var$proto.getLabel = $52b70196934cb73f$var$intervalScaleProto.getLabel;
function $52b70196934cb73f$var$fixRoundingError(val, originalVal) {
    return $52b70196934cb73f$var$roundingErrorFix(val, $5BQXp.getPrecision(originalVal));
}
(0, $fUFf0.default).registerClass($52b70196934cb73f$var$LogScale);
var $52b70196934cb73f$export$2e2bcd8739ae039 = $52b70196934cb73f$var$LogScale;

});

parcelRegister("h3hFK", function(module, exports) {

$parcel$export(module.exports, "parseAxisModelMinMax", () => $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b);
$parcel$export(module.exports, "ensureScaleRawExtentInfo", () => $c6a06cd3efaf7d9a$export$5c3dbcbeb9ce7f5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");
var $c6a06cd3efaf7d9a$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on ouside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = model.getNeedCrossZero && model.getNeedCrossZero();
        var modelMinRaw = this._modelMinRaw = model.get('min', true);
        if ((0, $hzBt5.isFunction)(modelMinRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMinNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $hzBt5.isFunction)(modelMaxRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMaxNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $hzBt5.isArray)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $02NbV.parsePercent)(boundaryGapArr[0], 1),
                (0, $02NbV.parsePercent)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null; // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum; // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        if (min > max) {
            min = NaN;
            max = NaN;
        }
        var isBlank = (0, $hzBt5.eqNaN)(min) || (0, $hzBt5.eqNaN)(max) || isOrdinal && !axisDataLen; // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0; // minFixed = true;
             // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0; // maxFixed = true;
             // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        } // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$c6a06cd3efaf7d9a$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $c6a06cd3efaf7d9a$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $c6a06cd3efaf7d9a$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $c6a06cd3efaf7d9a$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $c6a06cd3efaf7d9a$export$5c3dbcbeb9ce7f5a(scale, model, originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $c6a06cd3efaf7d9a$export$c35454f678e99c82(scale, model, originalExtent); // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $hzBt5.eqNaN)(minMax) ? NaN : scale.parse(minMax);
}

});


parcelRegister("4OY0R", function(module, exports) {

$parcel$export(module.exports, "cartesian2DDimensions", () => $382a624382bad5e0$export$988a008d2b9120f4);
$parcel$export(module.exports, "default", () => $382a624382bad5e0$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $lGSv6 = parcelRequire("lGSv6");

var $gdoyf = parcelRequire("gdoyf");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");
var $382a624382bad5e0$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $382a624382bad5e0$var$canCalculateAffineTransform(scale) {
    return scale.type === 'interval' || scale.type === 'time';
}
var $382a624382bad5e0$var$Cartesian2D = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $382a624382bad5e0$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$382a624382bad5e0$var$canCalculateAffineTransform(xAxisScale) || !$382a624382bad5e0$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
         // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $crEgd.invert)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1]; // Fast path
        if (this._transform // It's supported that if data is like `[Inifity, 123]`, where only Y pixel calculated.
         && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $ef5pP.applyTransform)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $ef5pP.applyTransform)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function() {
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]);
        var y = Math.min(yExtent[0], yExtent[1]);
        var width = Math.max(xExtent[0], xExtent[1]) - x;
        var height = Math.max(yExtent[0], yExtent[1]) - y;
        return new (0, $lGSv6.default)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $gdoyf.default));
var $382a624382bad5e0$export$2e2bcd8739ae039 = $382a624382bad5e0$var$Cartesian2D;

});
parcelRegister("gdoyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce0e7a893aee0b4$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $bce0e7a893aee0b4$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $hzBt5.map(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $hzBt5.filter(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $bce0e7a893aee0b4$export$2e2bcd8739ae039 = $bce0e7a893aee0b4$var$Cartesian;

});


parcelRegister("jhbA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e08896631375e7ab$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $ewaMj = parcelRequire("ewaMj");
var $e08896631375e7ab$var$Axis2D = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $ewaMj.default));
var $e08896631375e7ab$export$2e2bcd8739ae039 = $e08896631375e7ab$var$Axis2D;

});
parcelRegister("ewaMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91c6a27dcb231fa$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $avVVg = parcelRequire("avVVg");
var $a91c6a27dcb231fa$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $a91c6a27dcb231fa$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $5BQXp.getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $a91c6a27dcb231fa$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $5BQXp.linearMap)(data, $a91c6a27dcb231fa$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $a91c6a27dcb231fa$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $5BQXp.linearMap)(coord, extent, $a91c6a27dcb231fa$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $avVVg.createAxisTicks)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $hzBt5.map)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $a91c6a27dcb231fa$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber'); // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $hzBt5.map)(minorTicks, function(minorTicksGroup) {
            return (0, $hzBt5.map)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $avVVg.createAxisLabels)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $avVVg.calculateCategoryInterval)(this);
    };
    return Axis;
}();
function $a91c6a27dcb231fa$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $a91c6a27dcb231fa$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[0]
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $hzBt5.each)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unecessary tick added.
        a = (0, $5BQXp.round)(a);
        b = (0, $5BQXp.round)(b);
        return inverse ? a > b : a < b;
    }
}
var $a91c6a27dcb231fa$export$2e2bcd8739ae039 = $a91c6a27dcb231fa$var$Axis;

});
parcelRegister("avVVg", function(module, exports) {

$parcel$export(module.exports, "createAxisLabels", () => $7a79bad7d16623cc$export$10216ebd3e3e485e);
$parcel$export(module.exports, "createAxisTicks", () => $7a79bad7d16623cc$export$7cccf6836ae8323c);
$parcel$export(module.exports, "calculateCategoryInterval", () => $7a79bad7d16623cc$export$9ea1d3f146a5a65f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");

var $ckizb = parcelRequire("ckizb");

var $ekDcz = parcelRequire("ekDcz");
var $7a79bad7d16623cc$var$inner = (0, $ckizb.makeInner)();
function $7a79bad7d16623cc$export$10216ebd3e3e485e(axis) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $7a79bad7d16623cc$var$makeCategoryLabels(axis) : $7a79bad7d16623cc$var$makeRealNumberLabels(axis);
}
function $7a79bad7d16623cc$export$7cccf6836ae8323c(axis, tickModel) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $7a79bad7d16623cc$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $hzBt5.map(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $7a79bad7d16623cc$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $7a79bad7d16623cc$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $7a79bad7d16623cc$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $7a79bad7d16623cc$var$getListCache(axis, 'labels');
    var optionLabelInterval = (0, $ekDcz.getOptionCategoryInterval)(labelModel);
    var result = $7a79bad7d16623cc$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($hzBt5.isFunction(optionLabelInterval)) labels = $7a79bad7d16623cc$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $7a79bad7d16623cc$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $7a79bad7d16623cc$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    } // Cache to avoid calling interval function repeatly.
    return $7a79bad7d16623cc$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $7a79bad7d16623cc$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $7a79bad7d16623cc$var$getListCache(axis, 'ticks');
    var optionTickInterval = (0, $ekDcz.getOptionCategoryInterval)(tickModel);
    var result = $7a79bad7d16623cc$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($hzBt5.isFunction(optionTickInterval)) ticks = $7a79bad7d16623cc$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $7a79bad7d16623cc$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $hzBt5.map(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $7a79bad7d16623cc$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.
    return $7a79bad7d16623cc$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $7a79bad7d16623cc$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    return {
        labels: $hzBt5.map(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $7a79bad7d16623cc$var$getListCache(axis, prop) {
    // Because key can be funciton, and cache size always be small, we use array cache.
    return $7a79bad7d16623cc$var$inner(axis)[prop] || ($7a79bad7d16623cc$var$inner(axis)[prop] = []);
}
function $7a79bad7d16623cc$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $7a79bad7d16623cc$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $7a79bad7d16623cc$var$makeAutoCategoryInterval(axis) {
    var result = $7a79bad7d16623cc$var$inner(axis).autoInterval;
    return result != null ? result : $7a79bad7d16623cc$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $7a79bad7d16623cc$export$9ea1d3f146a5a65f(axis) {
    var params = $7a79bad7d16623cc$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0; // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0; // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $02NbV.getBoundingRect(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top'); // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3; // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $7a79bad7d16623cc$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
     && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
     && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $7a79bad7d16623cc$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $7a79bad7d16623cc$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
     // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $ekDcz.shouldShowAllLabels)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
     // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $7a79bad7d16623cc$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    var result = [];
    $hzBt5.each(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}

});



parcelRegister("aV7Yx", function(module, exports) {

$parcel$export(module.exports, "layout", () => $7f3569ffac744ed1$export$b3219800bda33a1f);
$parcel$export(module.exports, "isCartesian2DSeries", () => $7f3569ffac744ed1$export$c2a0b77974c5e35d);
$parcel$export(module.exports, "findAxisModels", () => $7f3569ffac744ed1$export$8220131ac1d61d28);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
function $7f3569ffac744ed1$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    } // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ]; // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($hzBt5.retrieve(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
     // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $7f3569ffac744ed1$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $7f3569ffac744ed1$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $hzBt5.each(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $ckizb.SINGLE_REFERRING)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}

});


parcelRegister("9SXxl", function(module, exports) {

$parcel$export(module.exports, "CartesianXAxisView", () => $732756f43565e121$export$b6d40cd875b8a1c8);
$parcel$export(module.exports, "CartesianYAxisView", () => $732756f43565e121$export$417e1bdd0616e0dc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $hXAsm = parcelRequire("hXAsm");
var $8q0E1 = parcelRequire("8q0E1");
var $15UDR = parcelRequire("15UDR");

var $3yIQS = parcelRequire("3yIQS");

var $75jQl = parcelRequire("75jQl");

var $aV7Yx = parcelRequire("aV7Yx");

var $1MvRH = parcelRequire("1MvRH");
var $732756f43565e121$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $732756f43565e121$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine'
];
var $732756f43565e121$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $hXAsm.default();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $aV7Yx.layout(gridModel, axisModel);
        var axisBuilder = new (0, $3yIQS.default)(axisModel, $hzBt5.extend({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    var otherAxisType = cartesians[i].getOtherAxis(axisModel.axis).type;
                    if (otherAxisType === 'value' || otherAxisType === 'log') // Still show axis tick or axisLine if other axis is value / log
                    return true;
                } // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $hzBt5.each($732756f43565e121$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $hzBt5.each($732756f43565e121$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $732756f43565e121$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this); // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $8q0E1.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $1MvRH.rectCoordAxisHandleRemove)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $75jQl.default));
var $732756f43565e121$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        lineColors = $hzBt5.isArray(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var tickValue = ticksCoords[i].tickValue;
            axisGroup.add(new $15UDR.default({
                anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $hzBt5.defaults({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            }));
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            axisGroup.add(new $15UDR.default({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            }));
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $1MvRH.rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $732756f43565e121$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($732756f43565e121$var$CartesianAxisView);
var $732756f43565e121$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $732756f43565e121$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($732756f43565e121$var$CartesianAxisView);
var $732756f43565e121$export$2e2bcd8739ae039 = $732756f43565e121$var$CartesianAxisView;

});
parcelRegister("3yIQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $297756b269af41f1$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $hXAsm = parcelRequire("hXAsm");parcelRequire("8q0E1");
var $15UDR = parcelRequire("15UDR");
var $8q0E1 = parcelRequire("8q0E1");
var $kiooD = parcelRequire("kiooD");

var $aly4X = parcelRequire("aly4X");

var $hcRXD = parcelRequire("hcRXD");

var $fR3z1 = parcelRequire("fR3z1");

var $5BQXp = parcelRequire("5BQXp");

var $4TnMt = parcelRequire("4TnMt");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $ekDcz = parcelRequire("ekDcz");

var $hJQJ0 = parcelRequire("hJQJ0");
var $297756b269af41f1$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $297756b269af41f1$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $hXAsm.default();
        this.opt = opt;
        this.axisModel = axisModel; // Default value
        (0, $hzBt5.defaults)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        }); // FIXME Not use a seperate text group?
        var transformGroup = new $hXAsm.default({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        }); // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$297756b269af41f1$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $297756b269af41f1$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $5BQXp.remRadian)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $5BQXp.isRadianAroundZero)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $5BQXp.isRadianAroundZero)(rotationDiff - $297756b269af41f1$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $297756b269af41f1$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
         || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $297756b269af41f1$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        if (matrix) {
            (0, $ef5pP.applyTransform)(pt1, pt1, matrix);
            (0, $ef5pP.applyTransform)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $hzBt5.extend)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var line = new $15UDR.default({
            // Id for animation
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        line.anid = 'line';
        group.add(line);
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if (typeof arrows === 'string') // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if (typeof arrowSize === 'string' || typeof arrowSize === 'number') // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $4TnMt.normalizeSymbolOffset)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $hzBt5.each)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $4TnMt.createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true); // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt1[0] + r * Math.cos(opt.rotation),
                        y: pt1[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $297756b269af41f1$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $297756b269af41f1$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $297756b269af41f1$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $297756b269af41f1$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection); // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            'axisLabel',
            'hideOverlap'
        ])) {
            var labelList = (0, $hJQJ0.prepareLayoutList)((0, $hzBt5.map)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $hJQJ0.hideOverlap)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $hzBt5.retrieve)(opt.axisName, axisModel.get('name'));
        if (!name) return;
        var nameLocation = axisModel.get('nameLocation');
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            $297756b269af41f1$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $297756b269af41f1$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($297756b269af41f1$var$isNameLocationCenter(nameLocation)) labelLayout = $297756b269af41f1$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
        else {
            labelLayout = $297756b269af41f1$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $hzBt5.retrieve)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $kiooD.default({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $297756b269af41f1$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $hcRXD.createTextStyle)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $8q0E1.setTooltipConfig({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name; // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $297756b269af41f1$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $aly4X.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $297756b269af41f1$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $5BQXp.remRadian)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $5BQXp.isRadianAroundZero)(rotationDiff - $297756b269af41f1$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $5BQXp.isRadianAroundZero)(rotationDiff - $297756b269af41f1$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $297756b269af41f1$var$PI * 1.5 && rotationDiff > $297756b269af41f1$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $297756b269af41f1$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $ekDcz.shouldShowAllLabels)(axisModel.axis)) return;
     // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]); // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $297756b269af41f1$var$ignoreEl(firstLabel);
        $297756b269af41f1$var$ignoreEl(firstTick);
    } else if ($297756b269af41f1$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $297756b269af41f1$var$ignoreEl(nextLabel);
            $297756b269af41f1$var$ignoreEl(nextTick);
        } else {
            $297756b269af41f1$var$ignoreEl(firstLabel);
            $297756b269af41f1$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $297756b269af41f1$var$ignoreEl(lastLabel);
        $297756b269af41f1$var$ignoreEl(lastTick);
    } else if ($297756b269af41f1$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $297756b269af41f1$var$ignoreEl(prevLabel);
            $297756b269af41f1$var$ignoreEl(prevTick);
        } else {
            $297756b269af41f1$var$ignoreEl(lastLabel);
            $297756b269af41f1$var$ignoreEl(lastTick);
        }
    }
}
function $297756b269af41f1$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $297756b269af41f1$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
     // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $crEgd.identity([]);
    $crEgd.rotate(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($crEgd.mul([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($crEgd.mul([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $297756b269af41f1$var$isNameLocationCenter(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $297756b269af41f1$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $ef5pP.applyTransform)(pt1, pt1, tickTransform);
            (0, $ef5pP.applyTransform)(pt2, pt2, tickTransform);
        } // Tick line, Not use group transform to have better line draw
        var tickEl = new $15UDR.default({
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $297756b269af41f1$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = opt.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $297756b269af41f1$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $hzBt5.defaults)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $297756b269af41f1$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $hzBt5.defaults)(lineStyleModel.getLineStyle(), (0, $hzBt5.defaults)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $297756b269af41f1$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $297756b269af41f1$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $hzBt5.retrieve)(opt.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel('axisLabel');
    var labelMargin = labelModel.get('margin');
    var labels = axis.getViewLabels(); // Special label rotate.
    var labelRotation = ((0, $hzBt5.retrieve)(opt.labelRotate, labelModel.get('rotate')) || 0) * $297756b269af41f1$var$PI / 180;
    var labelLayout = $297756b269af41f1$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $297756b269af41f1$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get('triggerEvent');
    (0, $hzBt5.each)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $hzBt5.isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $fR3z1.default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var textEl = new $kiooD.default({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $hcRXD.createTextStyle)(itemLabelModel, {
                text: formattedLabel,
                align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
                verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
                fill: typeof textColor === 'function' ? textColor(// index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user repalce ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue; // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $297756b269af41f1$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            (0, $aly4X.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $297756b269af41f1$export$2e2bcd8739ae039 = $297756b269af41f1$var$AxisBuilder;

});
parcelRegister("4TnMt", function(module, exports) {

$parcel$export(module.exports, "symbolBuildProxies", () => $38febedb95292fd7$export$33fc3b478d332725);
$parcel$export(module.exports, "createSymbol", () => $38febedb95292fd7$export$af050e04da3a02e8);
$parcel$export(module.exports, "normalizeSymbolSize", () => $38febedb95292fd7$export$a84524f03e8e8dfb);
$parcel$export(module.exports, "normalizeSymbolOffset", () => $38febedb95292fd7$export$e3e292895c033f6d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory

var $hzBt5 = parcelRequire("hzBt5");
parcelRequire("8q0E1");
var $aYBv9 = parcelRequire("aYBv9");
var $15UDR = parcelRequire("15UDR");
var $8q0E1 = parcelRequire("8q0E1");
var $hMiip = parcelRequire("hMiip");
var $aeCKo = parcelRequire("aeCKo");

var $lGSv6 = parcelRequire("lGSv6");

var $02NbV = parcelRequire("02NbV");

var $5BQXp = parcelRequire("5BQXp");
/**
 * Triangle shape
 * @inner
 */ var $38febedb95292fd7$var$Triangle = $hMiip.default.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $38febedb95292fd7$var$Diamond = $hMiip.default.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $38febedb95292fd7$var$Pin = $hMiip.default.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3; // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2; // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $38febedb95292fd7$var$Arrow = $hMiip.default.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path contructors
 */ // TODO Use function to build symbol path.
var $38febedb95292fd7$var$symbolCtors = {
    line: $15UDR.default,
    rect: $aeCKo.default,
    roundRect: $aeCKo.default,
    square: $aeCKo.default,
    circle: $aYBv9.default,
    diamond: $38febedb95292fd7$var$Diamond,
    pin: $38febedb95292fd7$var$Pin,
    arrow: $38febedb95292fd7$var$Arrow,
    triangle: $38febedb95292fd7$var$Triangle
};
var $38febedb95292fd7$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $38febedb95292fd7$export$33fc3b478d332725 = {};
(0, $hzBt5.each)($38febedb95292fd7$var$symbolCtors, function(Ctor, name) {
    $38febedb95292fd7$export$33fc3b478d332725[name] = new Ctor();
});
var $38febedb95292fd7$var$SymbolClz = $hMiip.default.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $02NbV.calculateTextPosition)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $38febedb95292fd7$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $38febedb95292fd7$export$33fc3b478d332725[symbolType];
            }
            $38febedb95292fd7$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
function $38febedb95292fd7$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || '#fff'; // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $38febedb95292fd7$export$af050e04da3a02e8(symbolType, x, y, w, h, color, keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $8q0E1.makeImage(symbolType.slice(8), new (0, $lGSv6.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $8q0E1.makePath(symbolType.slice(7), {}, new (0, $lGSv6.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $38febedb95292fd7$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty; // TODO Should deprecate setColor
    symbolPath.setColor = $38febedb95292fd7$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $38febedb95292fd7$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $hzBt5.isArray)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $38febedb95292fd7$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $hzBt5.isArray)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $5BQXp.parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $5BQXp.parsePercent)((0, $hzBt5.retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}

});

parcelRegister("hJQJ0", function(module, exports) {

$parcel$export(module.exports, "prepareLayoutList", () => $ce9f89b610653ca5$export$6c403cad1ae3e239);
$parcel$export(module.exports, "shiftLayoutOnX", () => $ce9f89b610653ca5$export$b6b2b07f8ed32bd6);
$parcel$export(module.exports, "shiftLayoutOnY", () => $ce9f89b610653ca5$export$118c25e0932528e4);
$parcel$export(module.exports, "hideOverlap", () => $ce9f89b610653ca5$export$8ce774e164a49410);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lGSv6 = parcelRequire("lGSv6");
var $fi3eW = parcelRequire("fi3eW");
function $ce9f89b610653ca5$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform(); // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $fi3eW.default)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $ce9f89b610653ca5$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
     // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap(); // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1); // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    } // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent; // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $ce9f89b610653ca5$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $ce9f89b610653ca5$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
function $ce9f89b610653ca5$export$118c25e0932528e4(list, topBound, bottomBound, balanceShift) {
    return $ce9f89b610653ca5$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function $ce9f89b610653ca5$export$8ce774e164a49410(labelList) {
    var displayedLabels = []; // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $lGSv6.default)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect); // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j]; // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $fi3eW.default)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $fi3eW.default)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        } // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr('ignore', labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}

});


parcelRegister("75jQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5288647e8c2800b1$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $bztnt = parcelRequire("bztnt");

var $4uCJH = parcelRequire("4uCJH");
var $5288647e8c2800b1$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $5288647e8c2800b1$var$AxisView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $bztnt.fixValue(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $bztnt.getAxisPointerModel(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $5288647e8c2800b1$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $5288647e8c2800b1$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $4uCJH.default));
var $5288647e8c2800b1$export$2e2bcd8739ae039 = $5288647e8c2800b1$var$AxisView;

});
parcelRegister("bztnt", function(module, exports) {

$parcel$export(module.exports, "collect", () => $86c9c06360945b11$export$bb44f104e3c54dae);
$parcel$export(module.exports, "makeKey", () => $86c9c06360945b11$export$d01b444bafb1a792);
$parcel$export(module.exports, "fixValue", () => $86c9c06360945b11$export$f5ea32e3629d8043);
$parcel$export(module.exports, "getAxisInfo", () => $86c9c06360945b11$export$bd39458db76002ab);
$parcel$export(module.exports, "getAxisPointerModel", () => $86c9c06360945b11$export$3b06fce3f68b734);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fR3z1 = parcelRequire("fR3z1");

var $hzBt5 = parcelRequire("hzBt5");
function $86c9c06360945b11$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $86c9c06360945b11$var$collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $86c9c06360945b11$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $86c9c06360945b11$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = []; // Collect axes info.
    (0, $hzBt5.each)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $86c9c06360945b11$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
        // for user. So we enable seting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $hzBt5.each)(coordSys.getAxes(), (0, $hzBt5.curry)(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
         && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $hzBt5.each)(tooltipAxes.baseAxes, (0, $hzBt5.curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $hzBt5.each)(tooltipAxes.otherAxes, (0, $hzBt5.curry)(saveTooltipAxisInfo, 'cross', false));
        } // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$86c9c06360945b11$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $86c9c06360945b11$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var axisKey = $86c9c06360945b11$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $86c9c06360945b11$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $86c9c06360945b11$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $86c9c06360945b11$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $hzBt5.each)(fields, function(field) {
        volatileOption[field] = (0, $hzBt5.clone)(tooltipAxisPointerModel.get(field));
    }); // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
    // Only these properties can be overrided from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $hzBt5.defaults)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $fR3z1.default)(volatileOption, globalAxisPointerModel, ecModel));
}
function $86c9c06360945b11$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $hzBt5.each)(result.coordSysAxesInfo[$86c9c06360945b11$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $86c9c06360945b11$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($86c9c06360945b11$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $86c9c06360945b11$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $86c9c06360945b11$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $86c9c06360945b11$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $hzBt5.isArray)(linkPropValue) && (0, $hzBt5.indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $86c9c06360945b11$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $86c9c06360945b11$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $86c9c06360945b11$var$isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
     || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $86c9c06360945b11$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$86c9c06360945b11$export$d01b444bafb1a792(axisModel)];
}
function $86c9c06360945b11$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $86c9c06360945b11$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $86c9c06360945b11$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $86c9c06360945b11$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}

});


parcelRegister("1MvRH", function(module, exports) {

$parcel$export(module.exports, "rectCoordAxisBuildSplitArea", () => $14c2fde1996caecc$export$c80b7ef1527ec8c9);
$parcel$export(module.exports, "rectCoordAxisHandleRemove", () => $14c2fde1996caecc$export$48ebf2d6ce8ad076);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");

var $ckizb = parcelRequire("ckizb");
var $14c2fde1996caecc$var$inner = (0, $ckizb.makeInner)();
function $14c2fde1996caecc$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
     // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
     // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $14c2fde1996caecc$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $hzBt5.createHashMap();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $hzBt5.isArray(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $aeCKo.default({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $hzBt5.defaults({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $14c2fde1996caecc$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $14c2fde1996caecc$export$48ebf2d6ce8ad076(axisView) {
    $14c2fde1996caecc$var$inner(axisView).splitAreaColors = null;
}

});



parcelRegister("aw6hh", function(module, exports) {

$parcel$export(module.exports, "install", () => $7a81c32cf46f7806$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $75jQl = parcelRequire("75jQl");

var $7nTJK = parcelRequire("7nTJK");

var $dZhKR = parcelRequire("dZhKR");

var $d7lrG = parcelRequire("d7lrG");

var $hzBt5 = parcelRequire("hzBt5");

var $bztnt = parcelRequire("bztnt");

var $7KJPQ = parcelRequire("7KJPQ");
function $7a81c32cf46f7806$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $75jQl.default).registerAxisPointerClass('CartesianAxisPointer', (0, $7nTJK.default));
    registers.registerComponentModel((0, $dZhKR.default));
    registers.registerComponentView((0, $d7lrG.default));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $hzBt5.isArray)(link)) option.axisPointer.link = [
                link
            ];
        }
    }); // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $bztnt.collect)(ecModel, api);
    }); // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $7KJPQ.default));
}

});
parcelRegister("7nTJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5605ea9498afdc26$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $3l2JP = parcelRequire("3l2JP");

var $35drB = parcelRequire("35drB");

var $aV7Yx = parcelRequire("aV7Yx");
var $5605ea9498afdc26$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $5605ea9498afdc26$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $35drB.buildElStyle(axisPointerModel);
            var pointerOption = $5605ea9498afdc26$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $aV7Yx.layout(grid.model, axisModel);
        $35drB.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $aV7Yx.layout(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        }); // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $35drB.getTransformedPosition(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $5605ea9498afdc26$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $3l2JP.default));
function $5605ea9498afdc26$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $5605ea9498afdc26$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $35drB.makeLineShape([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $5605ea9498afdc26$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $35drB.makeRectShape([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $5605ea9498afdc26$var$getAxisDimIndex(axis))
        };
    }
};
function $5605ea9498afdc26$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $5605ea9498afdc26$export$2e2bcd8739ae039 = $5605ea9498afdc26$var$CartesianAxisPointer;

});
parcelRegister("3l2JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e574fff45e59ab$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8q0E1 = parcelRequire("8q0E1");

var $bztnt = parcelRequire("bztnt");

var $kcVwz = parcelRequire("kcVwz");

var $7b8YY = parcelRequire("7b8YY");

var $ckizb = parcelRequire("ckizb");
var $26e574fff45e59ab$var$inner = (0, $ckizb.makeInner)();
var $26e574fff45e59ab$var$clone = $hzBt5.clone;
var $26e574fff45e59ab$var$bind = $hzBt5.bind;
/**
 * Base axis pointer class in 2D.
 */ var $26e574fff45e59ab$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api; // Optimize: `render` will be called repeatly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show(); // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $8q0E1.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $hzBt5.curry($26e574fff45e59ab$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $26e574fff45e59ab$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
             // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $bztnt.getAxisInfo(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent(); // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {};
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $26e574fff45e59ab$var$inner(group).pointerEl = new $8q0E1[pointerOption.type]($26e574fff45e59ab$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $26e574fff45e59ab$var$inner(group).labelEl = new $8q0E1.Text($26e574fff45e59ab$var$clone(elOption.label));
            group.add(labelEl);
            $26e574fff45e59ab$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $26e574fff45e59ab$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $26e574fff45e59ab$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $26e574fff45e59ab$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $8q0E1.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // Fot mobile devicem, prevent screen slider on the button.
                    $kcVwz.stop(e.event);
                },
                onmousedown: $26e574fff45e59ab$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $26e574fff45e59ab$var$bind(this._onHandleDragMove, this),
                ondragend: $26e574fff45e59ab$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $26e574fff45e59ab$var$updateMandatoryProps(handle, axisPointerModel, false); // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ])); // update position
        var handleSize = handleModel.get('size');
        if (!$hzBt5.isArray(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $7b8YY.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $26e574fff45e59ab$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $26e574fff45e59ab$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true; // Persistent for throttle.
        var trans = this.updateHandleTransform($26e574fff45e59ab$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($26e574fff45e59ab$var$getHandleTransProps(trans));
        $26e574fff45e59ab$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {};
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $26e574fff45e59ab$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$26e574fff45e59ab$var$propsEqual($26e574fff45e59ab$var$inner(el).lastProp, props)) {
        $26e574fff45e59ab$var$inner(el).lastProp = props;
        moveAnimation ? $8q0E1.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $26e574fff45e59ab$var$propsEqual(lastProps, newProps) {
    if ($hzBt5.isObject(lastProps) && $hzBt5.isObject(newProps)) {
        var equals_1 = true;
        $hzBt5.each(newProps, function(item, key) {
            equals_1 = equals_1 && $26e574fff45e59ab$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $26e574fff45e59ab$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $26e574fff45e59ab$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $26e574fff45e59ab$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $26e574fff45e59ab$export$2e2bcd8739ae039 = $26e574fff45e59ab$var$BaseAxisPointer;

});
parcelRegister("kcVwz", function(module, exports) {

$parcel$export(module.exports, "clientToLocal", () => $eb618cc8e782fd94$export$7d5fecde839eee88);
$parcel$export(module.exports, "getNativeEvent", () => $eb618cc8e782fd94$export$4abe0e945399ac1d);
$parcel$export(module.exports, "normalizeEvent", () => $eb618cc8e782fd94$export$40fadb093aebad71);
$parcel$export(module.exports, "addEventListener", () => $eb618cc8e782fd94$export$3f65cefe8380dbea);
$parcel$export(module.exports, "removeEventListener", () => $eb618cc8e782fd94$export$8ff9f68337b520c0);
$parcel$export(module.exports, "stop", () => $eb618cc8e782fd94$export$fa6813432f753b0d);
$parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", () => $eb618cc8e782fd94$export$b7ae4cded3e71bd2);


var $gZXYp = parcelRequire("gZXYp");

var $bZSeh = parcelRequire("bZSeh");
var $eb618cc8e782fd94$var$isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var $eb618cc8e782fd94$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $eb618cc8e782fd94$var$_calcOut = [];
function $eb618cc8e782fd94$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate || !(0, $gZXYp.default).canvasSupported) $eb618cc8e782fd94$var$calculateZrXY(el, e, out);
    else if ((0, $gZXYp.default).browser.firefox && (0, $gZXYp.default).browser.version < '39' && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $eb618cc8e782fd94$var$calculateZrXY(el, e, out);
    return out;
}
function $eb618cc8e782fd94$var$calculateZrXY(el, e, out) {
    if ((0, $gZXYp.default).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $bZSeh.isCanvasEl)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $bZSeh.transformCoordWithViewport)($eb618cc8e782fd94$var$_calcOut, el, ex, ey)) {
            out.zrX = $eb618cc8e782fd94$var$_calcOut[0];
            out.zrY = $eb618cc8e782fd94$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $eb618cc8e782fd94$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $eb618cc8e782fd94$export$40fadb093aebad71(el, e, calculate) {
    e = $eb618cc8e782fd94$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $eb618cc8e782fd94$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $eb618cc8e782fd94$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $eb618cc8e782fd94$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $eb618cc8e782fd94$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $eb618cc8e782fd94$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $eb618cc8e782fd94$export$3f65cefe8380dbea(el, name, handler, opt) {
    if ($eb618cc8e782fd94$var$isDomLevel2) el.addEventListener(name, handler, opt);
    else el.attachEvent('on' + name, handler);
}
function $eb618cc8e782fd94$export$8ff9f68337b520c0(el, name, handler, opt) {
    if ($eb618cc8e782fd94$var$isDomLevel2) el.removeEventListener(name, handler, opt);
    else el.detachEvent('on' + name, handler);
}
var $eb618cc8e782fd94$export$fa6813432f753b0d = $eb618cc8e782fd94$var$isDomLevel2 ? function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
} : function(e) {
    e.returnValue = false;
    e.cancelBubble = true;
};
function $eb618cc8e782fd94$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}
function $eb618cc8e782fd94$export$a564e1c0090572c3(e) {
    return e.which > 1;
}

});
parcelRegister("bZSeh", function(module, exports) {

$parcel$export(module.exports, "transformLocalCoord", () => $8bbf75058a6b57c9$export$8c5c02e118307e20);
$parcel$export(module.exports, "transformCoordWithViewport", () => $8bbf75058a6b57c9$export$1219648acc517df4);
$parcel$export(module.exports, "isCanvasEl", () => $8bbf75058a6b57c9$export$1b92e4fe606eff6d);

var $gZXYp = parcelRequire("gZXYp");

var $81CZA = parcelRequire("81CZA");
var $8bbf75058a6b57c9$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $8bbf75058a6b57c9$var$_calcOut = [];
function $8bbf75058a6b57c9$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $8bbf75058a6b57c9$export$1219648acc517df4($8bbf75058a6b57c9$var$_calcOut, elFrom, inX, inY, true) && $8bbf75058a6b57c9$export$1219648acc517df4(out, elTarget, $8bbf75058a6b57c9$var$_calcOut[0], $8bbf75058a6b57c9$var$_calcOut[1]);
}
function $8bbf75058a6b57c9$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $gZXYp.default).domSupported && !$8bbf75058a6b57c9$export$1b92e4fe606eff6d(el)) {
        var saved = el[$8bbf75058a6b57c9$var$EVENT_SAVED_PROP] || (el[$8bbf75058a6b57c9$var$EVENT_SAVED_PROP] = {});
        var markers = $8bbf75058a6b57c9$var$prepareCoordMarkers(el, saved);
        var transformer = $8bbf75058a6b57c9$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $8bbf75058a6b57c9$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $8bbf75058a6b57c9$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $81CZA.buildTransformer)(destCoords, srcCoords) : (0, $81CZA.buildTransformer)(srcCoords, destCoords));
}
function $8bbf75058a6b57c9$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}

});
parcelRegister("81CZA", function(module, exports) {

$parcel$export(module.exports, "buildTransformer", () => $5d7ca9ca97ec0f53$export$fbdb2748a8171a7e);
var $5d7ca9ca97ec0f53$var$LN2 = Math.log(2);
function $5d7ca9ca97ec0f53$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $5d7ca9ca97ec0f53$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $5d7ca9ca97ec0f53$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $5d7ca9ca97ec0f53$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $5d7ca9ca97ec0f53$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $5d7ca9ca97ec0f53$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}

});




parcelRegister("35drB", function(module, exports) {

$parcel$export(module.exports, "buildElStyle", () => $23ec447b978aad75$export$b7fe459c7cc50060);
$parcel$export(module.exports, "buildLabelElOption", () => $23ec447b978aad75$export$8206a9937c45910f);
$parcel$export(module.exports, "getValueLabel", () => $23ec447b978aad75$export$7cffee0f9aed39d0);
$parcel$export(module.exports, "getTransformedPosition", () => $23ec447b978aad75$export$4bb66440324c3a3d);
$parcel$export(module.exports, "buildCartesianSingleLabelElOption", () => $23ec447b978aad75$export$fd3eb3812211a173);
$parcel$export(module.exports, "makeLineShape", () => $23ec447b978aad75$export$885fa0ad5a826207);
$parcel$export(module.exports, "makeRectShape", () => $23ec447b978aad75$export$a8b35248bcc02756);
$parcel$export(module.exports, "makeSectorShape", () => $23ec447b978aad75$export$b0cf82e7ebc0d7d0);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8q0E1 = parcelRequire("8q0E1");

var $02NbV = parcelRequire("02NbV");

var $gyplX = parcelRequire("gyplX");

var $crEgd = parcelRequire("crEgd");

var $ekDcz = parcelRequire("ekDcz");

var $3yIQS = parcelRequire("3yIQS");

var $hcRXD = parcelRequire("hcRXD");
function $23ec447b978aad75$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $23ec447b978aad75$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $23ec447b978aad75$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $gyplX.normalizeCssArray(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $02NbV.getBoundingRect(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
    $23ec447b978aad75$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $hcRXD.createTextStyle)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Lable should be over axisPointer.
        z2: 10
    };
} // Do not overflow ec container
function $23ec447b978aad75$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $23ec447b978aad75$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $ekDcz.getAxisRawValue(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $hzBt5.each(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($hzBt5.isString(formatter)) text = formatter.replace('{value}', text);
        else if ($hzBt5.isFunction(formatter)) text = formatter(params_1);
    }
    return text;
}
function $23ec447b978aad75$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $crEgd.create();
    $crEgd.rotate(transform, transform, layoutInfo.rotation);
    $crEgd.translate(transform, transform, layoutInfo.position);
    return $8q0E1.applyTransform([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $23ec447b978aad75$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $3yIQS.default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $23ec447b978aad75$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $23ec447b978aad75$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $23ec447b978aad75$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $23ec447b978aad75$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $23ec447b978aad75$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}

});


parcelRegister("dZhKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2eebe9e7e405bcb$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $6IEE1 = parcelRequire("6IEE1");
var $a2eebe9e7e405bcb$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: '#B9BEC9',
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: 'rgba(210,219,238,0.2)'
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: '#fff',
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: 'auto',
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: '#333',
            shadowBlur: 3,
            shadowColor: '#aaa',
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $6IEE1.default));
var $a2eebe9e7e405bcb$export$2e2bcd8739ae039 = $a2eebe9e7e405bcb$var$AxisPointerModel;

});

parcelRegister("d7lrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $98cc9074b5c0aca3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $lMUEI = parcelRequire("lMUEI");

var $4uCJH = parcelRequire("4uCJH");
var $98cc9074b5c0aca3$var$AxisPointerView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $lMUEI.register('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $lMUEI.unregister('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $lMUEI.unregister('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $4uCJH.default));
var $98cc9074b5c0aca3$export$2e2bcd8739ae039 = $98cc9074b5c0aca3$var$AxisPointerView;

});
parcelRegister("lMUEI", function(module, exports) {

$parcel$export(module.exports, "register", () => $fdca075177a2cf01$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $fdca075177a2cf01$export$d07f55d4c15c0440);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $ckizb = parcelRequire("ckizb");
var $fdca075177a2cf01$var$inner = (0, $ckizb.makeInner)();
var $fdca075177a2cf01$var$each = $hzBt5.each;
function $fdca075177a2cf01$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $gZXYp.default).node) return;
    var zr = api.getZr();
    $fdca075177a2cf01$var$inner(zr).records || ($fdca075177a2cf01$var$inner(zr).records = {});
    $fdca075177a2cf01$var$initGlobalListeners(zr, api);
    var record = $fdca075177a2cf01$var$inner(zr).records[key] || ($fdca075177a2cf01$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $fdca075177a2cf01$var$initGlobalListeners(zr, api) {
    if ($fdca075177a2cf01$var$inner(zr).initialized) return;
    $fdca075177a2cf01$var$inner(zr).initialized = true;
    useHandler('click', $hzBt5.curry($fdca075177a2cf01$var$doEnter, 'click'));
    useHandler('mousemove', $hzBt5.curry($fdca075177a2cf01$var$doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
    useHandler('globalout', $fdca075177a2cf01$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $fdca075177a2cf01$var$makeDispatchAction(api);
            $fdca075177a2cf01$var$each($fdca075177a2cf01$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $fdca075177a2cf01$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $fdca075177a2cf01$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $fdca075177a2cf01$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $fdca075177a2cf01$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $fdca075177a2cf01$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    }; // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $fdca075177a2cf01$export$d07f55d4c15c0440(key, api) {
    if ((0, $gZXYp.default).node) return;
    var zr = api.getZr();
    var record = ($fdca075177a2cf01$var$inner(zr).records || {})[key];
    if (record) $fdca075177a2cf01$var$inner(zr).records[key] = null;
}

});


parcelRegister("7KJPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a50622cb8cf958a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $bztnt = parcelRequire("bztnt");

var $hKxet = parcelRequire("hKxet");

var $hzBt5 = parcelRequire("hzBt5");
var $5a50622cb8cf958a$var$inner = (0, $ckizb.makeInner)();
function $5a50622cb8cf958a$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $hzBt5.bind)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($5a50622cb8cf958a$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $hKxet.default)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $5a50622cb8cf958a$var$illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $5a50622cb8cf958a$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $hzBt5.curry)($5a50622cb8cf958a$var$showPointer, showValueMap),
        showTooltip: (0, $hzBt5.curry)($5a50622cb8cf958a$var$showTooltip, dataByCoordSys)
    }; // Process for triggered axes.
    (0, $hzBt5.each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $hzBt5.each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $5a50622cb8cf958a$var$findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $5a50622cb8cf958a$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    }); // Process for linked axes.
    var linkTriggers = {};
    (0, $hzBt5.each)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $hzBt5.each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $5a50622cb8cf958a$var$makeMapperParam(srcAxisInfo), $5a50622cb8cf958a$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $hzBt5.each)(linkTriggers, function(val, tarKey) {
        $5a50622cb8cf958a$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $5a50622cb8cf958a$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $5a50622cb8cf958a$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $5a50622cb8cf958a$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $5a50622cb8cf958a$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    } // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $5a50622cb8cf958a$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $hzBt5.extend)(outputFinder, payloadBatch[0]);
     // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch); // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $5a50622cb8cf958a$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $hzBt5.each)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff); // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $hzBt5.each)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $5a50622cb8cf958a$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $5a50622cb8cf958a$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $bztnt.makeKey(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $5a50622cb8cf958a$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $hzBt5.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value; // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
         // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $5a50622cb8cf958a$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($5a50622cb8cf958a$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    } // In most case only one axis (or event one series is used). It is
    // convinient to fetch payload.seriesIndex and payload.dataIndex
    // dirtectly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $5a50622cb8cf958a$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification shoule be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $5a50622cb8cf958a$var$inner(zr)[highDownKey] || {};
    var newHighlights = $5a50622cb8cf958a$var$inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $hzBt5.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && (0, $hzBt5.each)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    }); // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $hzBt5.each)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $hzBt5.each)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $5a50622cb8cf958a$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $5a50622cb8cf958a$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $5a50622cb8cf958a$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

});
parcelRegister("hKxet", function(module, exports) {

$parcel$export(module.exports, "default", () => $0355af8786b7b54e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
function $0355af8786b7b54e$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $ckizb.queryDataIndex(data, finder);
    if (dataIndex == null || dataIndex < 0 || $hzBt5.isArray(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($hzBt5.map(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}

});



parcelRegister("lDnHX", function(module, exports) {

$parcel$export(module.exports, "use", () => $fbffa16771d86969$export$1f96ae73734a86cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eLPvY = parcelRequire("eLPvY");

var $4uCJH = parcelRequire("4uCJH");

var $azEx8 = parcelRequire("azEx8");

var $6IEE1 = parcelRequire("6IEE1");

var $5vVec = parcelRequire("5vVec");

var $hzBt5 = parcelRequire("hzBt5");

var $fK0Gs = parcelRequire("fK0Gs");
var $fbffa16771d86969$var$extensions = [];
var $fbffa16771d86969$var$extensionRegisters = {
    registerPreprocessor: (0, $eLPvY.registerPreprocessor),
    registerProcessor: (0, $eLPvY.registerProcessor),
    registerPostInit: (0, $eLPvY.registerPostInit),
    registerPostUpdate: (0, $eLPvY.registerPostUpdate),
    registerUpdateLifecycle: (0, $eLPvY.registerUpdateLifecycle),
    registerAction: (0, $eLPvY.registerAction),
    registerCoordinateSystem: (0, $eLPvY.registerCoordinateSystem),
    registerLayout: (0, $eLPvY.registerLayout),
    registerVisual: (0, $eLPvY.registerVisual),
    registerTransform: (0, $eLPvY.registerTransform),
    registerLoading: (0, $eLPvY.registerLoading),
    registerMap: (0, $eLPvY.registerMap),
    PRIORITY: (0, $eLPvY.PRIORITY),
    ComponentModel: (0, $6IEE1.default),
    ComponentView: (0, $4uCJH.default),
    SeriesModel: (0, $5vVec.default),
    ChartView: (0, $azEx8.default),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $6IEE1.default).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $4uCJH.default).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $5vVec.default).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $azEx8.default).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $6IEE1.default).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $fK0Gs.registerPainter)(painterType, PainterCtor);
    }
};
function $fbffa16771d86969$export$1f96ae73734a86cc(ext) {
    if ((0, $hzBt5.isArray)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $hzBt5.each)(ext, function(singleExt) {
            $fbffa16771d86969$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $hzBt5.indexOf)($fbffa16771d86969$var$extensions, ext) >= 0) return;
    $fbffa16771d86969$var$extensions.push(ext);
    if ((0, $hzBt5.isFunction)(ext)) ext = {
        install: ext
    };
    ext.install($fbffa16771d86969$var$extensionRegisters);
}

});
parcelRegister("eLPvY", function(module, exports) {

$parcel$export(module.exports, "version", () => $ac0d6a32e251a4a9$export$83d89fbfd8236492);
$parcel$export(module.exports, "dependencies", () => $ac0d6a32e251a4a9$export$b74ff737e0e298b5);
$parcel$export(module.exports, "PRIORITY", () => $ac0d6a32e251a4a9$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "init", () => $ac0d6a32e251a4a9$export$2cd8252107eb640b);
$parcel$export(module.exports, "getInstanceByDom", () => $ac0d6a32e251a4a9$export$33b6fbccd4f643f8);
$parcel$export(module.exports, "connect", () => $ac0d6a32e251a4a9$export$64605811ab45167f);
$parcel$export(module.exports, "disConnect", () => $ac0d6a32e251a4a9$export$87cd6834112ecb52);
$parcel$export(module.exports, "disconnect", () => $ac0d6a32e251a4a9$export$37dfea93db2e14ed);
$parcel$export(module.exports, "dispose", () => $ac0d6a32e251a4a9$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "getInstanceById", () => $ac0d6a32e251a4a9$export$89b4be35062c4a3f);
$parcel$export(module.exports, "registerTheme", () => $ac0d6a32e251a4a9$export$f9c59eed5de5ff80);
$parcel$export(module.exports, "registerPreprocessor", () => $ac0d6a32e251a4a9$export$77095792a057b768);
$parcel$export(module.exports, "registerProcessor", () => $ac0d6a32e251a4a9$export$d575e6557ac1729f);
$parcel$export(module.exports, "registerPostInit", () => $ac0d6a32e251a4a9$export$c8c249911ee8c1ed);
$parcel$export(module.exports, "registerUpdateLifecycle", () => $ac0d6a32e251a4a9$export$c9ec4b5faef04865);
$parcel$export(module.exports, "registerPostUpdate", () => $ac0d6a32e251a4a9$export$99560909c18c76bb);
$parcel$export(module.exports, "registerAction", () => $ac0d6a32e251a4a9$export$408c24786cd729c6);
$parcel$export(module.exports, "registerCoordinateSystem", () => $ac0d6a32e251a4a9$export$1dd5e025a8a37dd);
$parcel$export(module.exports, "getCoordinateSystemDimensions", () => $ac0d6a32e251a4a9$export$fc2638719e4159b9);
$parcel$export(module.exports, "registerLayout", () => $ac0d6a32e251a4a9$export$d768f97700ca6bea);
$parcel$export(module.exports, "registerVisual", () => $ac0d6a32e251a4a9$export$5f32c1eb94c381bb);
$parcel$export(module.exports, "registerLoading", () => $ac0d6a32e251a4a9$export$e06b68a82007c015);
$parcel$export(module.exports, "setCanvasCreator", () => $ac0d6a32e251a4a9$export$10425ea7a243b114);
$parcel$export(module.exports, "registerMap", () => $ac0d6a32e251a4a9$export$d456de060be2dba1);
$parcel$export(module.exports, "getMap", () => $ac0d6a32e251a4a9$export$b8586192aead8a7e);
$parcel$export(module.exports, "registerTransform", () => $ac0d6a32e251a4a9$export$f01d71dd0389d7e4);
$parcel$export(module.exports, "dataTool", () => $ac0d6a32e251a4a9$export$73cae5e090579589);
$parcel$export(module.exports, "registerLocale", () => (parcelRequire("6FMoP")).registerLocale);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $fKE23 = parcelRequire("fKE23");

var $fK0Gs = parcelRequire("fK0Gs");

var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");

var $gZXYp = parcelRequire("gZXYp");

var $ishiy = parcelRequire("ishiy");

var $1J7Ke = parcelRequire("1J7Ke");

var $2dhmo = parcelRequire("2dhmo");

var $4npYR = parcelRequire("4npYR");

var $gwjrp = parcelRequire("gwjrp");

var $lphfQ = parcelRequire("lphfQ");

var $7OS81 = parcelRequire("7OS81");

var $5kOH0 = parcelRequire("5kOH0");

var $5vVec = parcelRequire("5vVec");

var $4uCJH = parcelRequire("4uCJH");

var $azEx8 = parcelRequire("azEx8");
parcelRequire("8q0E1");
var $agXnr = parcelRequire("agXnr");
var $hMiip = parcelRequire("hMiip");
var $aeCKo = parcelRequire("aeCKo");
var $9ubot = parcelRequire("9ubot");

var $aly4X = parcelRequire("aly4X");

var $51xyq = parcelRequire("51xyq");

var $ckizb = parcelRequire("ckizb");

var $7b8YY = parcelRequire("7b8YY");

var $4fAPP = parcelRequire("4fAPP");

var $b0zNB = parcelRequire("b0zNB");

var $86dkp = parcelRequire("86dkp");

var $dsS8i = parcelRequire("dsS8i");

var $85Dmy = parcelRequire("85Dmy");

var $jKrBG = parcelRequire("jKrBG");

var $9xw3H = parcelRequire("9xw3H");

var $fTE3u = parcelRequire("fTE3u");

var $3uf7q = parcelRequire("3uf7q");

var $6ds7H = parcelRequire("6ds7H");

var $kPQAq = parcelRequire("kPQAq");

var $jjR5M = parcelRequire("jjR5M");

var $6FMoP = parcelRequire("6FMoP");

var $1MZkk = parcelRequire("1MZkk");

var $aXrNM = parcelRequire("aXrNM");

var $lIsFn = parcelRequire("lIsFn");

var $3Vx2a = parcelRequire("3Vx2a");
var $ac0d6a32e251a4a9$var$hasWindow = typeof window !== 'undefined';
var $ac0d6a32e251a4a9$export$83d89fbfd8236492 = '5.2.1';
var $ac0d6a32e251a4a9$export$b74ff737e0e298b5 = {
    zrender: '5.2.1'
};
var $ac0d6a32e251a4a9$var$TEST_FRAME_REMAIN_TIME = 1;
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800; // Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DATASTACK = 900; // "Data filter" will block the stream, so it should be
// put at the begining of data processing.
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART = 3000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_COMPONENT = 4000; // Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500; // Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_BRUSH = 5000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_ARIA = 6000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_DECAL = 7000;
var $ac0d6a32e251a4a9$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_ARIA,
        DECAL: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_DECAL
    }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var $ac0d6a32e251a4a9$var$PENDING_UPDATE = '__pendingUpdate';
var $ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $ac0d6a32e251a4a9$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_PENDING = 0;
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATING = 1;
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATED = 2;
function $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        return $ac0d6a32e251a4a9$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $ac0d6a32e251a4a9$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $ac0d6a32e251a4a9$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $1J7Ke.default).prototype[method].apply(host, args);
}
var $ac0d6a32e251a4a9$var$MessageCenter = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $1J7Ke.default));
var $ac0d6a32e251a4a9$var$messageCenterProto = $ac0d6a32e251a4a9$var$MessageCenter.prototype;
$ac0d6a32e251a4a9$var$messageCenterProto.on = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseMessageCenter('on');
$ac0d6a32e251a4a9$var$messageCenterProto.off = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseMessageCenter('off'); // ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $ac0d6a32e251a4a9$var$prepare;
var $ac0d6a32e251a4a9$var$prepareView;
var $ac0d6a32e251a4a9$var$updateDirectly;
var $ac0d6a32e251a4a9$var$updateMethods;
var $ac0d6a32e251a4a9$var$doConvertPixel;
var $ac0d6a32e251a4a9$var$updateStreamModes;
var $ac0d6a32e251a4a9$var$doDispatchAction;
var $ac0d6a32e251a4a9$var$flushPendingActions;
var $ac0d6a32e251a4a9$var$triggerUpdatedEvent;
var $ac0d6a32e251a4a9$var$bindRenderedEvent;
var $ac0d6a32e251a4a9$var$bindMouseEvent;
var $ac0d6a32e251a4a9$var$clearColorPalette;
var $ac0d6a32e251a4a9$var$render;
var $ac0d6a32e251a4a9$var$renderComponents;
var $ac0d6a32e251a4a9$var$renderSeries;
var $ac0d6a32e251a4a9$var$createExtensionAPI;
var $ac0d6a32e251a4a9$var$enableConnect;
var $ac0d6a32e251a4a9$var$markStatusToUpdate;
var $ac0d6a32e251a4a9$var$applyChangedStates;
var $ac0d6a32e251a4a9$var$ECharts = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ECharts, _super);
    function ECharts(dom, theme, opts) {
        var _this = _super.call(this, new (0, $9xw3H.ECEventProcessor)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {}; // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {}; // Get theme by name
        if (typeof theme === 'string') theme = $ac0d6a32e251a4a9$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultUseDirtyRect = false;
        var root, devUseDirtyRect;
        var zr = _this._zr = $fK0Gs.init(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
        }); // Expect 60 fps.
        _this._throttledZrFlush = (0, $7b8YY.throttle)((0, $hzBt5.bind)(zr.flush, zr), 17);
        theme = (0, $hzBt5.clone)(theme);
        theme && (0, $7OS81.default)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $6FMoP.createLocaleObject)(opts.locale || (0, $6FMoP.SYSTEM_LANG));
        _this._coordSysMgr = new (0, $gwjrp.default)();
        var api = _this._api = $ac0d6a32e251a4a9$var$createExtensionAPI(_this); // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $ishiy.default)($ac0d6a32e251a4a9$var$visualFuncs, prioritySortFunc);
        (0, $ishiy.default)($ac0d6a32e251a4a9$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $86dkp.default)(_this, api, $ac0d6a32e251a4a9$var$dataProcessorFuncs, $ac0d6a32e251a4a9$var$visualFuncs);
        _this._messageCenter = new $ac0d6a32e251a4a9$var$MessageCenter(); // Init mouse events
        _this._initEvents(); // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $hzBt5.bind)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $ac0d6a32e251a4a9$var$bindRenderedEvent(zr, _this);
        $ac0d6a32e251a4a9$var$bindMouseEvent(zr, _this); // ECharts instance can be used as value.
        (0, $hzBt5.setAsPrimitive)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $ac0d6a32e251a4a9$var$applyChangedStates(this);
        var scheduler = this._scheduler; // Lazy update
        if (this[$ac0d6a32e251a4a9$var$PENDING_UPDATE]) {
            var silent = this[$ac0d6a32e251a4a9$var$PENDING_UPDATE].silent;
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
            $ac0d6a32e251a4a9$var$prepare(this);
            $ac0d6a32e251a4a9$var$updateMethods.update.call(this, null, this[$ac0d6a32e251a4a9$var$PENDING_UPDATE].updateParams); // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
            $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
            $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $ac0d6a32e251a4a9$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $ac0d6a32e251a4a9$var$updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determin in the first frame (the
                // frame is executed immedietely after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $ac0d6a32e251a4a9$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
             // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $hzBt5.isObject)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $lphfQ.default)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $2dhmo.default)();
            ecModel.scheduler = this._scheduler;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $ac0d6a32e251a4a9$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false; // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            $ac0d6a32e251a4a9$var$prepare(this);
            $ac0d6a32e251a4a9$var$updateMethods.update.call(this, null, updateParams); // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            this._zr.flush();
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
            $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
            $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @DEPRECATED
   */ ECharts.prototype.setTheme = function() {
        console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
    }; // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || $ac0d6a32e251a4a9$var$hasWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        if (!(0, $gZXYp.default).canvasSupported) return;
        opts = opts || {};
        return this._zr.painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $gZXYp.default).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList(); // Stop animations
        (0, $hzBt5.each)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $hzBt5.each)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $hzBt5.each)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $gZXYp.default).canvasSupported) return;
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($ac0d6a32e251a4a9$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $hzBt5.each)($ac0d6a32e251a4a9$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas((0, $hzBt5.clone)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $hzBt5.createCanvas)();
            var zr_1 = $fK0Gs.init(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $hzBt5.each)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $aeCKo.default({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $hzBt5.each)(canvasList_1, function(item) {
                    var img = new $agXnr.default({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $ac0d6a32e251a4a9$var$doConvertPixel(this, 'convertToPixel', finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $ac0d6a32e251a4a9$var$doConvertPixel(this, 'convertFromPixel', finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $ckizb.parseFinder(ecModel, finder);
        (0, $hzBt5.each)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $hzBt5.each)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $ckizb.parseFinder(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $3uf7q.getItemVisualFromData)(data, dataIndexInside, visualType) : (0, $3uf7q.getVisualFromData)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $hzBt5.each)($ac0d6a32e251a4a9$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $1MZkk.findEventDispatcher)(el, function(parent) {
                    var ecData = (0, $aly4X.getECData)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $hzBt5.extend)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                 // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            }; // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $hzBt5.each)($ac0d6a32e251a4a9$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        }); // Extra events
        // TODO register?
        (0, $hzBt5.each)([
            'selectchanged'
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $kPQAq.handleLegacySelectEvents)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        $ckizb.setAttribute(this.getDom(), $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $hzBt5.each)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $hzBt5.each)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        }); // Dispose after all views disposed
        chart._zr.dispose(); // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $ac0d6a32e251a4a9$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model; // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent; // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$ac0d6a32e251a4a9$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$ac0d6a32e251a4a9$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
        }
        this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
        needPrepare && $ac0d6a32e251a4a9$var$prepare(this);
        $ac0d6a32e251a4a9$var$updateMethods.update.call(this, {
            type: 'resize',
            animation: (0, $hzBt5.extend)({
                // Disable animation
                duration: 0
            }, opts && opts.animation)
        });
        this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
        $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
        $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        if ((0, $hzBt5.isObject)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$ac0d6a32e251a4a9$var$loadingEffects[name]) return;
        var el = $ac0d6a32e251a4a9$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $hzBt5.extend)({}, eventObj);
        payload.type = $ac0d6a32e251a4a9$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $hzBt5.isObject)(opt)) opt = {
            silent: !!opt
        };
        if (!$ac0d6a32e251a4a9$var$actions[payload.type]) return;
         // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
         // May dispatchAction in rendering procedure
        if (this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $ac0d6a32e251a4a9$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $gZXYp.default).browser.weChat) // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh util user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
        $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $3Vx2a.default).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    }; // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $ac0d6a32e251a4a9$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $ac0d6a32e251a4a9$var$prepareView(ecIns, true);
            $ac0d6a32e251a4a9$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $ac0d6a32e251a4a9$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By defaut view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView; // This command should not work twice.
                model.__requireNewView = false; // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $jKrBG.parseClassType)(model.type);
                    var Clazz = isComponent ? (0, $4uCJH.default).getClass(classType.main, classType.sub) : // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $azEx8.default).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $ac0d6a32e251a4a9$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload); // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $hzBt5.each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $hzBt5.createHashMap)();
                (0, $hzBt5.each)($ckizb.normalizeToArray(excludeSeriesId), function(id) {
                    var modelId = $ckizb.convertOptionIdName(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            if ((0, $51xyq.isHighDownPayload)(payload)) (0, $51xyq.allLeaveBlur)(ecIns._api);
             // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                if ((0, $51xyq.isHighDownPayload)(payload)) {
                    if (model instanceof (0, $5vVec.default)) {
                        if (payload.type === (0, $51xyq.HIGHLIGHT_ACTION_TYPE) && !payload.notBlur) (0, $51xyq.blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $51xyq.findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $51xyq.HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, $51xyq.blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                         // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $hzBt5.each)(dispatchers, function(dispatcher) {
                            payload.type === (0, $51xyq.HIGHLIGHT_ACTION_TYPE) ? (0, $51xyq.enterEmphasis)(dispatcher) : (0, $51xyq.leaveEmphasis)(dispatcher);
                        });
                    }
                } else if ((0, $51xyq.isSelectChangePayload)(payload)) // TODO geo
                {
                    if (model instanceof (0, $5vVec.default)) {
                        (0, $51xyq.toggleSelectionFromPayload)(model, payload, ecIns._api);
                        (0, $51xyq.updateSeriesElementSelection)(model);
                        $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $ac0d6a32e251a4a9$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $ac0d6a32e251a4a9$var$prepare(this);
                $ac0d6a32e251a4a9$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel); // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the orignal point
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // deteming whether use progressive rendering.
                $ac0d6a32e251a4a9$var$updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not requied in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $ac0d6a32e251a4a9$var$render(this, ecModel, api, payload, updateParams); // Set background
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                var darkMode = ecModel.get('darkMode'); // In IE8
                if (!(0, $gZXYp.default).canvasSupported) {
                    var colorArr = $f7lrR.parse(backgroundColor);
                    backgroundColor = $f7lrR.stringify(colorArr, 'rgb');
                    if (colorArr[3] === 0) backgroundColor = 'transparent';
                } else {
                    zr.setBackgroundColor(backgroundColor); // Force set dark mode.
                    if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                }
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $hzBt5.createHashMap)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                }); // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $ac0d6a32e251a4a9$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $azEx8.default).markUpdateMethod(payload, 'updateView');
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $ac0d6a32e251a4a9$var$render(this, ecModel, this._api, payload, {});
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                }); // Perform visual
                (0, $azEx8.default).markUpdateMethod(payload, 'updateVisual');
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function(payload) {
                $ac0d6a32e251a4a9$var$updateMethods.update.call(this, payload);
            }
        };
        $ac0d6a32e251a4a9$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $ac0d6a32e251a4a9$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $ckizb.parseFinder(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $ac0d6a32e251a4a9$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $ac0d6a32e251a4a9$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $ac0d6a32e251a4a9$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $jKrBG.parseClassType)(cptTypeTmp[0]);
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false; // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $hzBt5.map)(payload.batch, function(item) {
                    item = (0, $hzBt5.defaults)((0, $hzBt5.extend)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $51xyq.isSelectChangePayload)(payload);
            var isHighDown = (0, $51xyq.isHighDownPayload)(payload);
            (0, $hzBt5.each)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api); // Emit event outside
                eventObj = eventObj || (0, $hzBt5.extend)({}, batchItem); // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $ckizb.preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $ac0d6a32e251a4a9$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $ac0d6a32e251a4a9$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(_this);
                } else if (cptType) $ac0d6a32e251a4a9$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
                // Still dirty
                if (this[$ac0d6a32e251a4a9$var$PENDING_UPDATE]) {
                    $ac0d6a32e251a4a9$var$prepare(this);
                    $ac0d6a32e251a4a9$var$updateMethods.update.call(this, payload);
                    this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
                } else $ac0d6a32e251a4a9$var$updateMethods[updateMethod].call(this, payload);
            } // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj); // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: 'selectchanged',
                        escapeConnect: escapeConnect,
                        selected: (0, $51xyq.getAllSelectedIndices)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $ac0d6a32e251a4a9$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $ac0d6a32e251a4a9$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $ac0d6a32e251a4a9$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $ac0d6a32e251a4a9$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params); // The `finished` event should not be triggered repeatly,
                // so it should only be triggered when rendering indeed happend
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$ac0d6a32e251a4a9$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $ac0d6a32e251a4a9$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $1MZkk.findEventDispatcher)(el, (0, $51xyq.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $51xyq.handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $1MZkk.findEventDispatcher)(el, (0, $51xyq.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $51xyq.handleGlboalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $1MZkk.findEventDispatcher)(el, function(target) {
                    return (0, $aly4X.getECData)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $aly4X.getECData)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        $ac0d6a32e251a4a9$var$clearColorPalette = function(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        };
        $ac0d6a32e251a4a9$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            $ac0d6a32e251a4a9$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $hzBt5.each)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $ac0d6a32e251a4a9$var$renderSeries(ecIns, ecModel, api, payload, updateParams); // Remove groups of unrendered charts
            (0, $hzBt5.each)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $ac0d6a32e251a4a9$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $hzBt5.each)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $ac0d6a32e251a4a9$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $hzBt5.extend)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            }); // TODO progressive?
            (0, $3Vx2a.default).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload); // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent'); // Should not call markRedraw on group, because it will disable zrender
                // increamental render (alway render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $51xyq.updateSeriesElementSelection)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $3Vx2a.default).trigger('series:layoutlabels', ecModel, api, updateParams); // transition after label is layouted.
            (0, $3Vx2a.default).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId]; // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView); // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            }); // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $3Vx2a.default).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $ac0d6a32e251a4a9$var$markStatusToUpdate = function(ecIns) {
            ecIns[$ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY] = true; // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $ac0d6a32e251a4a9$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($9ubot.isElementRemoved(el)) return;
                applyElementStates(el);
            });
            ecIns[$ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates; // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            } // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $51xyq.HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $51xyq.HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $gZXYp.default).node && !(0, $gZXYp.default).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.group.traverse(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.group.traverse(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DONT mark the element dirty. In case element is incremental and don't wan't to rerender.
                el.style.blend = blendMode;
                if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
                    displayable.style.blend = blendMode;
                });
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
             // Set z and zlevel
            _updateZ(view.group, model.get('z') || 0, model.get('zlevel') || 0, -Infinity);
        }
        function _updateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                // el.traverse((childEl: Element) => _updateZ(childEl, z, zlevel));
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(_updateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            } // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel; // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        } // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.group.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($9ubot.isElementRemoved(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                 // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing') // additive: stateAnimationModel.get('additive')
            } : null;
            view.group.traverse(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($9ubot.isElementRemoved(el)) return;
                    if (el instanceof $hMiip.default) (0, $51xyq.savePathStates)(el);
                     // Only updated on changed element. In case element is incremental and don't wan't to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates; // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    } // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine(); // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    } // The use higlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $ac0d6a32e251a4a9$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $fKE23.__extends)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $51xyq.enterEmphasis)(el, highlightDigit);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $51xyq.leaveEmphasis)(el, highlightDigit);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $51xyq.enterBlur)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $51xyq.leaveBlur)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $51xyq.enterSelect)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $51xyq.leaveSelect)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $4npYR.default)))(ecIns);
        };
        $ac0d6a32e251a4a9$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $hzBt5.each)($ac0d6a32e251a4a9$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($ac0d6a32e251a4a9$var$connectedGroups[chart.group] && chart[$ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY] !== $ac0d6a32e251a4a9$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $hzBt5.each)($ac0d6a32e251a4a9$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $ac0d6a32e251a4a9$var$CONNECT_STATUS_PENDING);
                        (0, $hzBt5.each)(otherCharts_1, function(otherChart) {
                            if (otherChart[$ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY] !== $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $1J7Ke.default));
var $ac0d6a32e251a4a9$var$echartsProto = $ac0d6a32e251a4a9$var$ECharts.prototype;
$ac0d6a32e251a4a9$var$echartsProto.on = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseECharts('on');
$ac0d6a32e251a4a9$var$echartsProto.off = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$ac0d6a32e251a4a9$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $6ds7H.deprecateLog)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2); // @ts-ignore
        self.off(eventName, wrapped);
    }
    this.on.call(this, eventName, wrapped, ctx);
}; // /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         let isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }
var $ac0d6a32e251a4a9$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $ac0d6a32e251a4a9$var$disposedWarning(id) {}
var $ac0d6a32e251a4a9$var$actions = {};
/**
 * Map eventType to actionType
 */ var $ac0d6a32e251a4a9$var$eventActionMap = {};
var $ac0d6a32e251a4a9$var$dataProcessorFuncs = [];
var $ac0d6a32e251a4a9$var$optionPreprocessorFuncs = [];
var $ac0d6a32e251a4a9$var$visualFuncs = [];
var $ac0d6a32e251a4a9$var$themeStorage = {};
var $ac0d6a32e251a4a9$var$loadingEffects = {};
var $ac0d6a32e251a4a9$var$instances = {};
var $ac0d6a32e251a4a9$var$connectedGroups = {};
var $ac0d6a32e251a4a9$var$idBase = +new Date() - 0;
var $ac0d6a32e251a4a9$var$groupIdBase = +new Date() - 0;
var $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $ac0d6a32e251a4a9$export$2cd8252107eb640b(dom, theme, opts) {
    var existInstance = $ac0d6a32e251a4a9$export$33b6fbccd4f643f8(dom);
    if (existInstance) return existInstance;
    var chart = new $ac0d6a32e251a4a9$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $ac0d6a32e251a4a9$var$idBase++;
    $ac0d6a32e251a4a9$var$instances[chart.id] = chart;
    $ckizb.setAttribute(dom, $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY, chart.id);
    $ac0d6a32e251a4a9$var$enableConnect(chart);
    (0, $3Vx2a.default).trigger('afterinit', chart);
    return chart;
}
function $ac0d6a32e251a4a9$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $hzBt5.isArray)(groupId)) {
        var charts = groupId;
        groupId = null; // If any chart has group
        (0, $hzBt5.each)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $ac0d6a32e251a4a9$var$groupIdBase++;
        (0, $hzBt5.each)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $ac0d6a32e251a4a9$var$connectedGroups[groupId] = true;
    return groupId;
}
function $ac0d6a32e251a4a9$export$87cd6834112ecb52(groupId) {
    $ac0d6a32e251a4a9$var$connectedGroups[groupId] = false;
}
var $ac0d6a32e251a4a9$export$37dfea93db2e14ed = $ac0d6a32e251a4a9$export$87cd6834112ecb52;
function $ac0d6a32e251a4a9$export$fcfbbcec2cb820d5(chart) {
    if (typeof chart === 'string') chart = $ac0d6a32e251a4a9$var$instances[chart];
    else if (!(chart instanceof $ac0d6a32e251a4a9$var$ECharts)) // Try to treat as dom
    chart = $ac0d6a32e251a4a9$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $ac0d6a32e251a4a9$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $ac0d6a32e251a4a9$export$33b6fbccd4f643f8(dom) {
    return $ac0d6a32e251a4a9$var$instances[$ckizb.getAttribute(dom, $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY)];
}
function $ac0d6a32e251a4a9$export$89b4be35062c4a3f(key) {
    return $ac0d6a32e251a4a9$var$instances[key];
}
function $ac0d6a32e251a4a9$export$f9c59eed5de5ff80(name, theme) {
    $ac0d6a32e251a4a9$var$themeStorage[name] = theme;
}
function $ac0d6a32e251a4a9$export$77095792a057b768(preprocessorFunc) {
    if ((0, $hzBt5.indexOf)($ac0d6a32e251a4a9$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $ac0d6a32e251a4a9$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $ac0d6a32e251a4a9$export$d575e6557ac1729f(priority, processor) {
    $ac0d6a32e251a4a9$var$normalizeRegister($ac0d6a32e251a4a9$var$dataProcessorFuncs, priority, processor, $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $ac0d6a32e251a4a9$export$c8c249911ee8c1ed(postInitFunc) {
    $ac0d6a32e251a4a9$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $ac0d6a32e251a4a9$export$99560909c18c76bb(postUpdateFunc) {
    $ac0d6a32e251a4a9$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $ac0d6a32e251a4a9$export$c9ec4b5faef04865(name, cb) {
    (0, $3Vx2a.default).on(name, cb);
}
function $ac0d6a32e251a4a9$export$408c24786cd729c6(actionInfo, eventName, action) {
    if (typeof eventName === 'function') {
        action = eventName;
        eventName = '';
    }
    var actionType = (0, $hzBt5.isObject)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0]; // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($ac0d6a32e251a4a9$var$eventActionMap[eventName]) // Already registered.
    return;
     // Validate action type and event name.
    (0, $hzBt5.assert)($ac0d6a32e251a4a9$var$ACTION_REG.test(actionType) && $ac0d6a32e251a4a9$var$ACTION_REG.test(eventName));
    if (!$ac0d6a32e251a4a9$var$actions[actionType]) $ac0d6a32e251a4a9$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $ac0d6a32e251a4a9$var$eventActionMap[eventName] = actionType;
}
function $ac0d6a32e251a4a9$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $gwjrp.default).register(type, coordSysCreator);
}
function $ac0d6a32e251a4a9$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $gwjrp.default).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $ac0d6a32e251a4a9$export$d768f97700ca6bea(priority, layoutTask) {
    $ac0d6a32e251a4a9$var$normalizeRegister($ac0d6a32e251a4a9$var$visualFuncs, priority, layoutTask, $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $ac0d6a32e251a4a9$export$5f32c1eb94c381bb(priority, visualTask) {
    $ac0d6a32e251a4a9$var$normalizeRegister($ac0d6a32e251a4a9$var$visualFuncs, priority, visualTask, $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $ac0d6a32e251a4a9$var$registeredTasks = [];
function $ac0d6a32e251a4a9$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $hzBt5.isFunction)(priority) || (0, $hzBt5.isObject)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    if ((0, $hzBt5.indexOf)($ac0d6a32e251a4a9$var$registeredTasks, fn) >= 0) return;
    $ac0d6a32e251a4a9$var$registeredTasks.push(fn);
    var stageHandler = (0, $86dkp.default).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $ac0d6a32e251a4a9$export$e06b68a82007c015(name, loadingFx) {
    $ac0d6a32e251a4a9$var$loadingEffects[name] = loadingFx;
}
function $ac0d6a32e251a4a9$export$10425ea7a243b114(creator) {
    (0, $hzBt5.$override)('createCanvas', creator);
}
function $ac0d6a32e251a4a9$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    (0, $lIsFn.default).registerMap(mapName, geoJson, specialAreas);
}
function $ac0d6a32e251a4a9$export$b8586192aead8a7e(mapName) {
    return (0, $lIsFn.default).getMapForUser(mapName);
}
var $ac0d6a32e251a4a9$export$f01d71dd0389d7e4 = (0, $jjR5M.registerExternalTransform);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Buitlin global visual
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL, (0, $4fAPP.seriesStyleTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $4fAPP.dataStyleTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $4fAPP.dataColorPaletteTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL, (0, $fTE3u.seriesSymbolTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $fTE3u.dataSymbolTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_DECAL, (0, $aXrNM.default));
$ac0d6a32e251a4a9$export$77095792a057b768((0, $7OS81.default));
$ac0d6a32e251a4a9$export$d575e6557ac1729f($ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DATASTACK, (0, $5kOH0.default));
$ac0d6a32e251a4a9$export$e06b68a82007c015('default', (0, $b0zNB.default)); // Default actions
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.HIGHLIGHT_ACTION_TYPE),
    event: (0, $51xyq.HIGHLIGHT_ACTION_TYPE),
    update: (0, $51xyq.HIGHLIGHT_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.DOWNPLAY_ACTION_TYPE),
    event: (0, $51xyq.DOWNPLAY_ACTION_TYPE),
    update: (0, $51xyq.DOWNPLAY_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.SELECT_ACTION_TYPE),
    event: (0, $51xyq.SELECT_ACTION_TYPE),
    update: (0, $51xyq.SELECT_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.UNSELECT_ACTION_TYPE),
    event: (0, $51xyq.UNSELECT_ACTION_TYPE),
    update: (0, $51xyq.UNSELECT_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.TOGGLE_SELECT_ACTION_TYPE),
    event: (0, $51xyq.TOGGLE_SELECT_ACTION_TYPE),
    update: (0, $51xyq.TOGGLE_SELECT_ACTION_TYPE)
}, (0, $hzBt5.noop)); // Default theme
$ac0d6a32e251a4a9$export$f9c59eed5de5ff80('light', (0, $dsS8i.default));
$ac0d6a32e251a4a9$export$f9c59eed5de5ff80('dark', (0, $85Dmy.default)); // For backward compatibility, where the namespace `dataTool` will
var $ac0d6a32e251a4a9$export$73cae5e090579589 = {};

});
parcelRegister("fK0Gs", function(module, exports) {

$parcel$export(module.exports, "init", () => $b75baeaa5b677679$export$2cd8252107eb640b);
$parcel$export(module.exports, "dispose", () => $b75baeaa5b677679$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "disposeAll", () => $b75baeaa5b677679$export$825f692fb04800ef);
$parcel$export(module.exports, "getInstance", () => $b75baeaa5b677679$export$8bedcca5bbd73999);
$parcel$export(module.exports, "registerPainter", () => $b75baeaa5b677679$export$a3e793ccb11823a5);
$parcel$export(module.exports, "version", () => $b75baeaa5b677679$export$83d89fbfd8236492);
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ 
var $gZXYp = parcelRequire("gZXYp");

var $hzBt5 = parcelRequire("hzBt5");

var $5W9iv = parcelRequire("5W9iv");

var $lfoBJ = parcelRequire("lfoBJ");

var $j4zsp = parcelRequire("j4zsp");

var $h7l6S = parcelRequire("h7l6S");

var $f7lrR = parcelRequire("f7lrR");

var $2MY1H = parcelRequire("2MY1H");

var $hXAsm = parcelRequire("hXAsm");
var $b75baeaa5b677679$var$useVML = !(0, $gZXYp.default).canvasSupported;
var $b75baeaa5b677679$var$painterCtors = {};
var $b75baeaa5b677679$var$instances = {};
function $b75baeaa5b677679$var$delInstance(id) {
    delete $b75baeaa5b677679$var$instances[id];
}
function $b75baeaa5b677679$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $f7lrR.lum)(backgroundColor, 1) < (0, $2MY1H.DARK_MODE_THRESHOLD);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $f7lrR.lum)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $2MY1H.DARK_MODE_THRESHOLD);
    }
    return false;
}
var $b75baeaa5b677679$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $lfoBJ.default)();
        var rendererType = opts.renderer || 'canvas';
        if ($b75baeaa5b677679$var$useVML) throw new Error('IE8 support has been dropped since 5.0');
        if (!$b75baeaa5b677679$var$painterCtors[rendererType]) rendererType = $hzBt5.keys($b75baeaa5b677679$var$painterCtors)[0];
        if (!$b75baeaa5b677679$var$painterCtors[rendererType]) throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $b75baeaa5b677679$var$painterCtors[rendererType](dom, storage, opts, id);
        this.storage = storage;
        this.painter = painter;
        var handerProxy = !(0, $gZXYp.default).node && !(0, $gZXYp.default).worker ? new (0, $h7l6S.default)(painter.getViewportRoot(), painter.root) : null;
        this.handler = new (0, $5W9iv.default)(storage, painter, handerProxy, painter.root);
        this.animation = new (0, $j4zsp.default)({
            stage: {
                update: function() {
                    return _this._flush(true);
                }
            }
        });
        this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (!el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (!el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $b75baeaa5b677679$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = new Date().getTime();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = new Date().getTime();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.addHover = function(el) {};
    ZRender.prototype.removeHover = function(el) {};
    ZRender.prototype.clearHover = function() {};
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        return this.painter.getHeight();
    };
    ZRender.prototype.pathToImage = function(e, dpr) {
        if (this.painter.pathToImage) return this.painter.pathToImage(e, dpr);
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $hXAsm.default)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        $b75baeaa5b677679$var$delInstance(this.id);
    };
    return ZRender;
}();
function $b75baeaa5b677679$export$2cd8252107eb640b(dom, opts) {
    var zr = new $b75baeaa5b677679$var$ZRender($hzBt5.guid(), dom, opts);
    $b75baeaa5b677679$var$instances[zr.id] = zr;
    return zr;
}
function $b75baeaa5b677679$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $b75baeaa5b677679$export$825f692fb04800ef() {
    for(var key in $b75baeaa5b677679$var$instances)if ($b75baeaa5b677679$var$instances.hasOwnProperty(key)) $b75baeaa5b677679$var$instances[key].dispose();
    $b75baeaa5b677679$var$instances = {};
}
function $b75baeaa5b677679$export$8bedcca5bbd73999(id) {
    return $b75baeaa5b677679$var$instances[id];
}
function $b75baeaa5b677679$export$a3e793ccb11823a5(name, Ctor) {
    $b75baeaa5b677679$var$painterCtors[name] = Ctor;
}
var $b75baeaa5b677679$export$83d89fbfd8236492 = '5.2.1';

});
parcelRegister("5W9iv", function(module, exports) {

$parcel$export(module.exports, "default", () => $011d92ea87e5dba5$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $ef5pP = parcelRequire("ef5pP");

var $apbEE = parcelRequire("apbEE");

var $1J7Ke = parcelRequire("1J7Ke");

var $kcVwz = parcelRequire("kcVwz");

var $kRPD1 = parcelRequire("kRPD1");
var $011d92ea87e5dba5$var$SILENT = 'silent';
function $011d92ea87e5dba5$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $011d92ea87e5dba5$var$stopEvent
    };
}
function $011d92ea87e5dba5$var$stopEvent() {
    $kcVwz.stop(this.event);
}
var $011d92ea87e5dba5$var$EmptyProxy = function(_super) {
    (0, $fKE23.__extends)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $1J7Ke.default));
var $011d92ea87e5dba5$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $011d92ea87e5dba5$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $011d92ea87e5dba5$var$Handler = function(_super) {
    (0, $fKE23.__extends)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot) {
        var _this = _super.call(this) || this;
        _this._hovered = new $011d92ea87e5dba5$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        proxy = proxy || new $011d92ea87e5dba5$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $apbEE.default)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $hzBt5.each($011d92ea87e5dba5$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $011d92ea87e5dba5$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $011d92ea87e5dba5$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $011d92ea87e5dba5$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $011d92ea87e5dba5$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $011d92ea87e5dba5$var$HoveredResult(x, y);
        for(var i = list.length - 1; i >= 0; i--){
            var hoverCheckResult = void 0;
            if (list[i] !== exclude && !list[i].ignore && (hoverCheckResult = $011d92ea87e5dba5$var$isHover(list[i], x, y))) {
                !out.topTarget && (out.topTarget = list[i]);
                if (hoverCheckResult !== $011d92ea87e5dba5$var$SILENT) {
                    out.target = list[i];
                    break;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $kRPD1.GestureMgr)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $011d92ea87e5dba5$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $1J7Ke.default));
$hzBt5.each([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $011d92ea87e5dba5$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $011d92ea87e5dba5$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $ef5pP.dist(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $011d92ea87e5dba5$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
                if (el.silent) isSilent = true;
            }
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $011d92ea87e5dba5$var$SILENT : true;
    }
    return false;
}
function $011d92ea87e5dba5$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $011d92ea87e5dba5$export$2e2bcd8739ae039 = $011d92ea87e5dba5$var$Handler;

});
parcelRegister("apbEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7935478a0fe49760$export$2e2bcd8739ae039);
var $7935478a0fe49760$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $7935478a0fe49760$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $7935478a0fe49760$export$2e2bcd8739ae039 = $7935478a0fe49760$var$Draggable;

});

parcelRegister("kRPD1", function(module, exports) {

$parcel$export(module.exports, "GestureMgr", () => $f310ce30087a842e$export$f7557d6f27e9503);

var $kcVwz = parcelRequire("kcVwz");
var $f310ce30087a842e$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $kcVwz.clientToLocal(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $f310ce30087a842e$var$recognizers)if ($f310ce30087a842e$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $f310ce30087a842e$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $f310ce30087a842e$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $f310ce30087a842e$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $f310ce30087a842e$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $f310ce30087a842e$var$dist(pinchEnd) / $f310ce30087a842e$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $f310ce30087a842e$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};

});


parcelRegister("lfoBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77e163c3eac4839$export$2e2bcd8739ae039);

var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $ishiy = parcelRequire("ishiy");

var $4rgPt = parcelRequire("4rgPt");
var $f77e163c3eac4839$var$invalidZErrorLogged = false;
function $f77e163c3eac4839$var$logInvalidZError() {
    if ($f77e163c3eac4839$var$invalidZErrorLogged) return;
    $f77e163c3eac4839$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $f77e163c3eac4839$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $f77e163c3eac4839$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $f77e163c3eac4839$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $gZXYp.default).canvasSupported && (0, $ishiy.default)(displayList, $f77e163c3eac4839$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $4rgPt.REDRAW_BIT);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $f77e163c3eac4839$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $f77e163c3eac4839$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $f77e163c3eac4839$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $hzBt5.indexOf(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $f77e163c3eac4839$export$2e2bcd8739ae039 = $f77e163c3eac4839$var$Storage;

});
parcelRegister("ishiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f8429c613e9f08$export$2e2bcd8739ae039);
var $d6f8429c613e9f08$var$DEFAULT_MIN_MERGE = 32;
var $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING = 7;
var $d6f8429c613e9f08$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
function $d6f8429c613e9f08$var$minRunLength(n) {
    var r = 0;
    while(n >= $d6f8429c613e9f08$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $d6f8429c613e9f08$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $d6f8429c613e9f08$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $d6f8429c613e9f08$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $d6f8429c613e9f08$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $d6f8429c613e9f08$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $d6f8429c613e9f08$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $d6f8429c613e9f08$var$TimSort(array, compare) {
    var minGallop = $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING;
    var length = 0;
    var tmpStorageLength = $d6f8429c613e9f08$var$DEFAULT_TMP_STORAGE_LENGTH;
    var stackLength = 0;
    var runStart;
    var runLength;
    var stackSize = 0;
    length = array.length;
    if (length < 2 * $d6f8429c613e9f08$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
    var tmp = [];
    stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $d6f8429c613e9f08$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $d6f8429c613e9f08$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $d6f8429c613e9f08$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $d6f8429c613e9f08$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING || count2 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $d6f8429c613e9f08$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $d6f8429c613e9f08$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING || count2 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $d6f8429c613e9f08$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $d6f8429c613e9f08$var$DEFAULT_MIN_MERGE) {
        runLength = $d6f8429c613e9f08$var$makeAscendingRun(array, lo, hi, compare);
        $d6f8429c613e9f08$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $d6f8429c613e9f08$var$TimSort(array, compare);
    var minRun = $d6f8429c613e9f08$var$minRunLength(remaining);
    do {
        runLength = $d6f8429c613e9f08$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $d6f8429c613e9f08$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}

});


parcelRegister("j4zsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $de29e51d8a0734e2$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $1J7Ke = parcelRequire("1J7Ke");

var $a1kVg = parcelRequire("a1kVg");

var $fyp5g = parcelRequire("fyp5g");
var $de29e51d8a0734e2$var$Animation = function(_super) {
    (0, $fKE23.__extends)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        _this.onframe = opts.onframe || function() {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._clipsHead) this._clipsHead = this._clipsTail = clip;
        else {
            this._clipsTail.next = clip;
            clip.prev = this._clipsTail;
            clip.next = null;
            this._clipsTail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._clipsHead = next;
        if (next) next.prev = prev;
        else this._clipsTail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = new Date().getTime() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy && clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.onframe(delta);
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $a1kVg.default)(step);
                !self._paused && self.update();
            }
        }
        (0, $a1kVg.default)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = new Date().getTime();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = new Date().getTime();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += new Date().getTime() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._clipsHead = this._clipsTail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._clipsHead == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $fyp5g.default)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $1J7Ke.default));
var $de29e51d8a0734e2$export$2e2bcd8739ae039 = $de29e51d8a0734e2$var$Animation;

});
parcelRegister("a1kVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ba3a2607959739$export$2e2bcd8739ae039);
var $74ba3a2607959739$var$requestAnimationFrame;
$74ba3a2607959739$var$requestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $74ba3a2607959739$export$2e2bcd8739ae039 = $74ba3a2607959739$var$requestAnimationFrame;

});


parcelRegister("h7l6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c763772147e79027$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $kcVwz = parcelRequire("kcVwz");

var $hzBt5 = parcelRequire("hzBt5");

var $1J7Ke = parcelRequire("1J7Ke");

var $gZXYp = parcelRequire("gZXYp");
var $c763772147e79027$var$TOUCH_CLICK_DELAY = 300;
var $c763772147e79027$var$globalEventSupported = (0, $gZXYp.default).domSupported;
var $c763772147e79027$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $hzBt5.map(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $c763772147e79027$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $c763772147e79027$var$wheelEventSupported = false;
function $c763772147e79027$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $c763772147e79027$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $c763772147e79027$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $c763772147e79027$var$normalizeGlobalEvent(instance, event) {
    return (0, $kcVwz.normalizeEvent)(instance.dom, new $c763772147e79027$var$FakeGlobalEvent(instance, event), true);
}
function $c763772147e79027$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $c763772147e79027$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $hzBt5.noop;
        this.stopImmediatePropagation = $hzBt5.noop;
        this.preventDefault = $hzBt5.noop;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $c763772147e79027$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$c763772147e79027$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $c763772147e79027$var$wheelEventSupported = true;
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($c763772147e79027$var$wheelEventSupported) return;
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        $c763772147e79027$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $c763772147e79027$var$localDOMHandlers.mousemove.call(this, event);
        $c763772147e79027$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        $c763772147e79027$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $c763772147e79027$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        $c763772147e79027$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $c763772147e79027$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $c763772147e79027$var$TOUCH_CLICK_DELAY) $c763772147e79027$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $c763772147e79027$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$c763772147e79027$var$isPointerFromTouch(event)) $c763772147e79027$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c763772147e79027$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$c763772147e79027$var$isPointerFromTouch(event)) $c763772147e79027$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$hzBt5.each([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $c763772147e79027$var$localDOMHandlers[name] = function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.trigger(name, event);
    };
});
var $c763772147e79027$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$c763772147e79027$var$isPointerFromTouch(event)) $c763772147e79027$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c763772147e79027$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $c763772147e79027$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $gZXYp.default).pointerEventsSupported) $hzBt5.each($c763772147e79027$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $gZXYp.default).touchEventsSupported) $hzBt5.each($c763772147e79027$var$localNativeListenerNames.touch, function(nativeEventName) {
            $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $c763772147e79027$var$setTouchTimer(scope);
            });
        });
        $hzBt5.each($c763772147e79027$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $kcVwz.getNativeEvent)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $c763772147e79027$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $gZXYp.default).pointerEventsSupported) $hzBt5.each($c763772147e79027$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $gZXYp.default).touchEventsSupported) $hzBt5.each($c763772147e79027$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $kcVwz.getNativeEvent)(event);
            if (!$c763772147e79027$var$isLocalEl(instance, event.target)) {
                event = $c763772147e79027$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $kcVwz.addEventListener)(scope.domTarget, nativeEventName, listener, opt);
}
function $c763772147e79027$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $kcVwz.removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $c763772147e79027$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $c763772147e79027$var$HandlerDomProxy = function(_super) {
    (0, $fKE23.__extends)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $c763772147e79027$var$DOMHandlerScope(dom, $c763772147e79027$var$localDOMHandlers);
        if ($c763772147e79027$var$globalEventSupported) _this._globalHandlerScope = new $c763772147e79027$var$DOMHandlerScope(document, $c763772147e79027$var$globalDOMHandlers);
        $c763772147e79027$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $c763772147e79027$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($c763772147e79027$var$globalEventSupported) $c763772147e79027$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($c763772147e79027$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $c763772147e79027$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $c763772147e79027$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $1J7Ke.default));
var $c763772147e79027$export$2e2bcd8739ae039 = $c763772147e79027$var$HandlerDomProxy;

});


parcelRegister("2dhmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ca430915a8c220$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $fR3z1 = parcelRequire("fR3z1");

var $6IEE1 = parcelRequire("6IEE1");

var $k23Xr = parcelRequire("k23Xr");

var $be33G = parcelRequire("be33G");

var $lmEWj = parcelRequire("lmEWj");

var $b7fr8 = parcelRequire("b7fr8");

var $6ds7H = parcelRequire("6ds7H");
// Internal method names:
// -----------------------
var $19ca430915a8c220$var$reCreateSeriesIndices;
var $19ca430915a8c220$var$assertSeriesInitialized;
var $19ca430915a8c220$var$initBase;
var $19ca430915a8c220$var$OPTION_INNER_KEY = '\0_ec_inner';
var $19ca430915a8c220$var$OPTION_INNER_VALUE = 1;
var $19ca430915a8c220$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $19ca430915a8c220$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $19ca430915a8c220$var$componetsMissingLogPrinted = {};
function $19ca430915a8c220$var$checkMissingComponents(option) {
    (0, $hzBt5.each)(option, function(componentOption, mainType) {
        if (!(0, $6IEE1.default).hasClass(mainType)) {
            var componentImportName = $19ca430915a8c220$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$19ca430915a8c220$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $6ds7H.error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $19ca430915a8c220$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $19ca430915a8c220$var$GlobalModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $fR3z1.default)(theme);
        this._locale = new (0, $fR3z1.default)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $19ca430915a8c220$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $19ca430915a8c220$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $19ca430915a8c220$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
         // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Becuase either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $hzBt5.each)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $hzBt5.createHashMap)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $be33G.resetSourceDefaulter)(this); // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $hzBt5.each)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $6IEE1.default).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $hzBt5.clone)(componentOption) : (0, $hzBt5.merge)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $6IEE1.default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $6IEE1.default).topologicalTravel(newCmptTypes, (0, $6IEE1.default).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $lmEWj.concatInternalOptions)(this, mainType, $ckizb.normalizeToArray(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $ckizb.mappingToExists(oldCmptList, newCmptOptionList, mergeMode); // Set mainType and complete subType.
            $ckizb.setComponentTypeToKeyInfo(mappingResult, mainType, (0, $6IEE1.default)); // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            (0, $hzBt5.each)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    } // If no both `resultItem.exist` and `resultItem.option`,
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $6IEE1.default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $hzBt5.extend)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt); // Assign `keyInfo`
                        (0, $hzBt5.extend)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this); // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType); // Backup series for filtering.
            if (mainType === 'series') $19ca430915a8c220$var$reCreateSeriesIndices(this);
        } // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $19ca430915a8c220$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $hzBt5.clone)(this.option);
        (0, $hzBt5.each)(option, function(optInMainType, mainType) {
            if ((0, $6IEE1.default).hasClass(mainType)) {
                var opts = $ckizb.normalizeToArray(optInMainType); // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$ckizb.isComponentIdInternal(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$19ca430915a8c220$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $hzBt5.each)($ckizb.normalizeToArray(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $19ca430915a8c220$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $19ca430915a8c220$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $hzBt5.filter)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $19ca430915a8c220$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) // Retrieve all non-empty components.
         : (0, $hzBt5.filter)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($19ca430915a8c220$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $hzBt5.filter)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $hzBt5.isFunction)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $hzBt5.isString)(mainType) ? componentsMap.get(mainType) : (0, $hzBt5.isObject)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $ckizb.convertOptionIdName(name, null);
        return (0, $hzBt5.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $hzBt5.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $hzBt5.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * frome raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        (0, $hzBt5.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $hzBt5.each)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * frome raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        (0, $hzBt5.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $hzBt5.each)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $hzBt5.each)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $hzBt5.createHashMap)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $19ca430915a8c220$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $6IEE1.default).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $6IEE1.default).topologicalTravel(componentTypes, (0, $6IEE1.default).getAllClassMainTypes(), function(componentType) {
            (0, $hzBt5.each)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$19ca430915a8c220$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $19ca430915a8c220$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $hzBt5.each)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $hzBt5.createHashMap)(seriesIndices);
        };
        $19ca430915a8c220$var$assertSeriesInitialized = function(ecModel) {};
        $19ca430915a8c220$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option can not be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
            ecModel.option = {};
            ecModel.option[$19ca430915a8c220$var$OPTION_INNER_KEY] = $19ca430915a8c220$var$OPTION_INNER_VALUE; // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $hzBt5.createHashMap)({
                series: []
            });
            ecModel._componentsCount = (0, $hzBt5.createHashMap)(); // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $hzBt5.isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $19ca430915a8c220$var$mergeTheme(baseOption, ecModel._theme.option); // TODO Needs clone when merging to the unexisted property
            (0, $hzBt5.merge)(baseOption, (0, $k23Xr.default), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $fR3z1.default));
function $19ca430915a8c220$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $19ca430915a8c220$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $hzBt5.each)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer) return;
         // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $6IEE1.default).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $hzBt5.clone)(themeItem) : (0, $hzBt5.merge)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $19ca430915a8c220$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $hzBt5.isArray)(idOrName)) {
        var keyMap_1 = (0, $hzBt5.createHashMap)();
        (0, $hzBt5.each)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $ckizb.convertOptionIdName(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $hzBt5.filter)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $ckizb.convertOptionIdName(idOrName, null);
        return (0, $hzBt5.filter)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $19ca430915a8c220$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $hzBt5.filter)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $19ca430915a8c220$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $hzBt5.createHashMap)();
    opts && (0, $hzBt5.each)($ckizb.normalizeToArray(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $hzBt5.mixin)($19ca430915a8c220$var$GlobalModel, (0, $b7fr8.PaletteMixin));
var $19ca430915a8c220$export$2e2bcd8739ae039 = $19ca430915a8c220$var$GlobalModel;

});
parcelRegister("k23Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e957107c4dffe14d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e957107c4dffe14d$var$platform = ''; // Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $e957107c4dffe14d$var$platform = navigator.platform || '';
var $e957107c4dffe14d$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $e957107c4dffe14d$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: [
        '#5470c6',
        '#91cc75',
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
    ],
    gradientColor: [
        '#f6efa6',
        '#d88273',
        '#bf444c'
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $e957107c4dffe14d$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};

});

parcelRegister("lmEWj", function(module, exports) {

$parcel$export(module.exports, "registerInternalOptionCreator", () => $f8db68cd66566bc9$export$5a90be4668898d38);
$parcel$export(module.exports, "concatInternalOptions", () => $f8db68cd66566bc9$export$c713a6a3b43f401d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $f8db68cd66566bc9$var$internalOptionCreatorMap = (0, $hzBt5.createHashMap)();
function $f8db68cd66566bc9$export$5a90be4668898d38(mainType, creator) {
    (0, $hzBt5.assert)($f8db68cd66566bc9$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $f8db68cd66566bc9$var$internalOptionCreatorMap.set(mainType, creator);
}
function $f8db68cd66566bc9$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $f8db68cd66566bc9$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}

});


parcelRegister("4npYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $32fd769e3cea974a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $32fd769e3cea974a$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    'getOption',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $32fd769e3cea974a$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $hzBt5.each($32fd769e3cea974a$var$availableMethods, function(methodName) {
            this[methodName] = $hzBt5.bind(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $32fd769e3cea974a$export$2e2bcd8739ae039 = $32fd769e3cea974a$var$ExtensionAPI;

});

parcelRegister("lphfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f959512fe28bc5bf$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $f959512fe28bc5bf$var$QUERY_REG = /^(min|max)?(.+)$/; // Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $f959512fe28bc5bf$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $hzBt5.each)((0, $ckizb.normalizeToArray)(rawOption.series), function(series) {
                series && series.data && (0, $hzBt5.isTypedArray)(series.data) && (0, $hzBt5.setAsPrimitive)(series.data);
            });
            (0, $hzBt5.each)((0, $ckizb.normalizeToArray)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $hzBt5.isTypedArray)(dataset.source) && (0, $hzBt5.setAsPrimitive)(dataset.source);
            });
        } // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $hzBt5.clone)(rawOption); // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $f959512fe28bc5bf$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, becuase in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline opitons will not be merged to the formers, but just substitude them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $hzBt5.clone)(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
         ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $hzBt5.clone)(timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = []; // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
         // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($f959512fe28bc5bf$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
         // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$f959512fe28bc5bf$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $hzBt5.map)(indices, function(index) {
            return (0, $hzBt5.clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
         // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $f959512fe28bc5bf$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption; // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption; // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $hzBt5.isArray)(mediaOnRoot)) (0, $hzBt5.each)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $hzBt5.each)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $hzBt5.each)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $hzBt5.each)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $f959512fe28bc5bf$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lowser case for convenientce.
    };
    var applicatable = true;
    (0, $hzBt5.each)(query, function(value, attr) {
        var matched = attr.match($f959512fe28bc5bf$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$f959512fe28bc5bf$var$compare(realMap[realAttr], value, operator)) applicatable = false;
    });
    return applicatable;
}
function $f959512fe28bc5bf$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $f959512fe28bc5bf$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$f959512fe28bc5bf$export$2e2bcd8739ae039 = $f959512fe28bc5bf$var$OptionManager;

});

parcelRegister("7OS81", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1730b18ead3c3c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $71SIS = parcelRequire("71SIS");

var $ckizb = parcelRequire("ckizb");

function $5b1730b18ead3c3c$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $5b1730b18ead3c3c$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $5b1730b18ead3c3c$var$compatLayoutProperties(option) {
    option && (0, $hzBt5.each)($5b1730b18ead3c3c$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $5b1730b18ead3c3c$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $5b1730b18ead3c3c$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $5b1730b18ead3c3c$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $5b1730b18ead3c3c$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $5b1730b18ead3c3c$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $5b1730b18ead3c3c$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $5b1730b18ead3c3c$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $5b1730b18ead3c3c$var$traverseTree(data[i].children, cb);
    }
}
function $5b1730b18ead3c3c$export$2e2bcd8739ae039(option, isTheme) {
    (0, $71SIS.default)(option, isTheme); // Make sure series array for model initialization.
    option.series = (0, $ckizb.normalizeToArray)(option.series);
    (0, $hzBt5.each)(option.series, function(seriesOpt) {
        if (!(0, $hzBt5.isObject)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $5b1730b18ead3c3c$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $hzBt5.isTypedArray)(data)) for(var i = 0; i < data.length; i++)$5b1730b18ead3c3c$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $5b1730b18ead3c3c$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $5b1730b18ead3c3c$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $5b1730b18ead3c3c$var$compatBarItemStyle(seriesOpt);
            $5b1730b18ead3c3c$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $5b1730b18ead3c3c$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $hzBt5.isTypedArray)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $5b1730b18ead3c3c$var$compatBarItemStyle(data[i]);
                    $5b1730b18ead3c3c$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $5b1730b18ead3c3c$var$compatSunburstState(seriesOpt);
            $5b1730b18ead3c3c$var$traverseTree(seriesOpt.data, $5b1730b18ead3c3c$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $5b1730b18ead3c3c$var$compatGraphFocus(seriesOpt); // TODO nodes, edges?
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $hzBt5.defaults)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $5b1730b18ead3c3c$var$compatLayoutProperties(seriesOpt);
    }); // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $hzBt5.each)($5b1730b18ead3c3c$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $hzBt5.isArray)(options)) options = [
                options
            ];
            (0, $hzBt5.each)(options, function(option) {
                $5b1730b18ead3c3c$var$compatLayoutProperties(option);
            });
        }
    });
}

});
parcelRegister("71SIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e31339493b497f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $51e31339493b497f$var$each = $hzBt5.each;
var $51e31339493b497f$var$isObject = $hzBt5.isObject;
var $51e31339493b497f$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $51e31339493b497f$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $51e31339493b497f$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $51e31339493b497f$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $hzBt5.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $hzBt5.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $51e31339493b497f$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $hzBt5.defaults(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt; // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $51e31339493b497f$var$removeEC3NormalStatus(opt) {
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'itemStyle');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'lineStyle');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'areaStyle');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'label');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'labelLine'); // treemap
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'upperLabel'); // graph
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $51e31339493b497f$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $51e31339493b497f$var$isObject(opt) && opt[propName];
    var textStyle = $51e31339493b497f$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $ckizb.TEXT_STYLE_OPTIONS.length; i < len; i++){
        var textPropName = $ckizb.TEXT_STYLE_OPTIONS[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $51e31339493b497f$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $51e31339493b497f$var$removeEC3NormalStatus(opt);
        $51e31339493b497f$var$compatTextStyle(opt, 'label');
        opt.emphasis && $51e31339493b497f$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $51e31339493b497f$var$processSeries(seriesOpt) {
    if (!$51e31339493b497f$var$isObject(seriesOpt)) return;
    $51e31339493b497f$var$compatEC2ItemStyle(seriesOpt);
    $51e31339493b497f$var$removeEC3NormalStatus(seriesOpt);
    $51e31339493b497f$var$compatTextStyle(seriesOpt, 'label'); // treemap
    $51e31339493b497f$var$compatTextStyle(seriesOpt, 'upperLabel'); // graph
    $51e31339493b497f$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $51e31339493b497f$var$compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
        $51e31339493b497f$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
        $51e31339493b497f$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $51e31339493b497f$var$compatEC2ItemStyle(markPoint);
        $51e31339493b497f$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $51e31339493b497f$var$compatEC2ItemStyle(markLine);
        $51e31339493b497f$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $51e31339493b497f$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$hzBt5.isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$51e31339493b497f$var$compatEC3CommonStyles(edgeData[i]);
        $hzBt5.each(seriesOpt.categories, function(opt) {
            $51e31339493b497f$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$hzBt5.isTypedArray(data)) for(var i = 0; i < data.length; i++)$51e31339493b497f$var$compatEC3CommonStyles(data[i]);
     // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$51e31339493b497f$var$compatEC3CommonStyles(mpData[i]);
    } // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($hzBt5.isArray(mlData[i])) {
            $51e31339493b497f$var$compatEC3CommonStyles(mlData[i][0]);
            $51e31339493b497f$var$compatEC3CommonStyles(mlData[i][1]);
        } else $51e31339493b497f$var$compatEC3CommonStyles(mlData[i]);
    } // Series
    if (seriesOpt.type === 'gauge') {
        $51e31339493b497f$var$compatTextStyle(seriesOpt, 'axisLabel');
        $51e31339493b497f$var$compatTextStyle(seriesOpt, 'title');
        $51e31339493b497f$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $51e31339493b497f$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $hzBt5.each(seriesOpt.levels, function(opt) {
            $51e31339493b497f$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $51e31339493b497f$var$removeEC3NormalStatus(seriesOpt.leaves);
     // sunburst starts from ec4, so it does not need to compat levels.
}
function $51e31339493b497f$var$toArr(o) {
    return $hzBt5.isArray(o) ? o : o ? [
        o
    ] : [];
}
function $51e31339493b497f$var$toObj(o) {
    return ($hzBt5.isArray(o) ? o[0] : o) || {};
}
function $51e31339493b497f$export$2e2bcd8739ae039(option, isTheme) {
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.series), function(seriesOpt) {
        $51e31339493b497f$var$isObject(seriesOpt) && $51e31339493b497f$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $51e31339493b497f$var$each(axes, function(axisName) {
        $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $51e31339493b497f$var$compatTextStyle(axisOpt, 'axisLabel');
                $51e31339493b497f$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $51e31339493b497f$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $51e31339493b497f$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.calendar), function(calendarOpt) {
        $51e31339493b497f$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $51e31339493b497f$var$compatTextStyle(calendarOpt, 'dayLabel');
        $51e31339493b497f$var$compatTextStyle(calendarOpt, 'monthLabel');
        $51e31339493b497f$var$compatTextStyle(calendarOpt, 'yearLabel');
    }); // radar.name.textStyle
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.radar), function(radarOpt) {
        $51e31339493b497f$var$compatTextStyle(radarOpt, 'name'); // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.geo), function(geoOpt) {
        if ($51e31339493b497f$var$isObject(geoOpt)) {
            $51e31339493b497f$var$compatEC3CommonStyles(geoOpt);
            $51e31339493b497f$var$each($51e31339493b497f$var$toArr(geoOpt.regions), function(regionObj) {
                $51e31339493b497f$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.timeline), function(timelineOpt) {
        $51e31339493b497f$var$compatEC3CommonStyles(timelineOpt);
        $51e31339493b497f$var$convertNormalEmphasis(timelineOpt, 'label');
        $51e31339493b497f$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $51e31339493b497f$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $hzBt5.isArray(data) && $hzBt5.each(data, function(item) {
            if ($hzBt5.isObject(item)) {
                $51e31339493b497f$var$convertNormalEmphasis(item, 'label');
                $51e31339493b497f$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.toolbox), function(toolboxOpt) {
        $51e31339493b497f$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $51e31339493b497f$var$each(toolboxOpt.feature, function(featureOpt) {
            $51e31339493b497f$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $51e31339493b497f$var$compatTextStyle($51e31339493b497f$var$toObj(option.axisPointer), 'label');
    $51e31339493b497f$var$compatTextStyle($51e31339493b497f$var$toObj(option.tooltip).axisPointer, 'label'); // Clean logs
// storedLogs = {};
}

});


parcelRegister("5kOH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e26247f8decc4fe$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");
function $3e26247f8decc4fe$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $hzBt5.createHashMap)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            }; // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($3e26247f8decc4fe$var$calculateStack);
}
function $3e26247f8decc4fe$var$calculateStack(stackInfoList) {
    (0, $hzBt5.each)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
             // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
                    if (sum >= 0 && val > 0 || // Positive stack
                    sum <= 0 && val < 0 // Negative stack
                    ) {
                        // The sum should be as less as possible to be effected
                        // by floating arithmetic problem. A wrong result probably
                        // filtered incorrectly by axis min/max.
                        sum = (0, $5BQXp.addSafe)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}

});

parcelRegister("4fAPP", function(module, exports) {

$parcel$export(module.exports, "seriesStyleTask", () => $318522c9f54512f0$export$7ce4d65f9b69240);
$parcel$export(module.exports, "dataStyleTask", () => $318522c9f54512f0$export$f7dcb66a065003d1);
$parcel$export(module.exports, "dataColorPaletteTask", () => $318522c9f54512f0$export$cf9758b0d6dc0aa9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $6CLz8 = parcelRequire("6CLz8");

var $9N9yS = parcelRequire("9N9yS");

var $5jmEk = parcelRequire("5jmEk");

var $fR3z1 = parcelRequire("fR3z1");

var $ckizb = parcelRequire("ckizb");
var $318522c9f54512f0$var$inner = (0, $ckizb.makeInner)();
var $318522c9f54512f0$var$defaultStyleMappers = {
    itemStyle: (0, $6CLz8.default)((0, $9N9yS.ITEM_STYLE_KEY_MAP), true),
    lineStyle: (0, $6CLz8.default)((0, $5jmEk.LINE_STYLE_KEY_MAP), true)
};
var $318522c9f54512f0$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $318522c9f54512f0$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $318522c9f54512f0$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return $318522c9f54512f0$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $318522c9f54512f0$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $318522c9f54512f0$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $318522c9f54512f0$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $318522c9f54512f0$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        } // TODO
        var colorKey = $318522c9f54512f0$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey]; // TODO style callback
        var colorCallback = (0, $hzBt5.isFunction)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto'; // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: if some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Bacause some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || typeof globalStyle.fill === 'function' ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || typeof globalStyle.stroke === 'function' ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey); // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $hzBt5.extend)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $318522c9f54512f0$var$sharedModel = new (0, $fR3z1.default)();
var $318522c9f54512f0$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var getStyle = $318522c9f54512f0$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $318522c9f54512f0$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($318522c9f54512f0$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $hzBt5.extend)(existsStyle, style);
                    if ($318522c9f54512f0$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $318522c9f54512f0$var$sharedModel.option.decal);
                        $318522c9f54512f0$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
}; // Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $318522c9f54512f0$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series use one scope.
        // Pie and funnel are using diferrent scopes
        var paletteScopeGroupByType = (0, $hzBt5.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $318522c9f54512f0$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $318522c9f54512f0$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $318522c9f54512f0$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            }); // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette'); // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};

});

parcelRegister("b0zNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $803b76b761cf12ca$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
parcelRequire("8q0E1");
var $iMbRE = parcelRequire("iMbRE");
var $aeCKo = parcelRequire("aeCKo");
var $hXAsm = parcelRequire("hXAsm");
var $kiooD = parcelRequire("kiooD");
var $803b76b761cf12ca$var$PI = Math.PI;
function $803b76b761cf12ca$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $hzBt5.defaults(opts, {
        text: 'loading',
        textColor: '#000',
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        showSpinner: true,
        color: '#5470c6',
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $hXAsm.default();
    var mask = new $aeCKo.default({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $kiooD.default({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $aeCKo.default({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $iMbRE.default({
            shape: {
                startAngle: -$803b76b761cf12ca$var$PI / 2,
                endAngle: -$803b76b761cf12ca$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $803b76b761cf12ca$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $803b76b761cf12ca$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    } // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2 // only show the text
        ) + (opts.showSpinner ? 0 : textWidth / 2 // only show the spinner
        ) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}

});

parcelRegister("86dkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5938f91d6a514e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $bw304 = parcelRequire("bw304");

var $9aOrz = parcelRequire("9aOrz");

var $2dhmo = parcelRequire("2dhmo");

var $4npYR = parcelRequire("4npYR");

var $ckizb = parcelRequire("ckizb");
var $5e5938f91d6a514e$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $hzBt5.createHashMap)();
        this.ecInstance = ecInstance;
        this.api = api; // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    }; // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $hzBt5.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $hzBt5.each)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $hzBt5.assert)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $hzBt5.each)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
                // if intending to decalare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because is a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operaions
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $hzBt5.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $bw304.createTask)({
                plan: $5e5938f91d6a514e$var$seriesTaskPlan,
                reset: $5e5938f91d6a514e$var$seriesTaskReset,
                count: $5e5938f91d6a514e$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
         || (0, $bw304.createTask)({
            reset: $5e5938f91d6a514e$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $hzBt5.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false; // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $hzBt5.assert)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $hzBt5.each)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $bw304.createTask)({
                reset: $5e5938f91d6a514e$var$stubReset,
                onDirty: $5e5938f91d6a514e$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress // FIXME:TS never used, so comment it
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $hzBt5.isFunction)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $5e5938f91d6a514e$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $9aOrz.getUID)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $5e5938f91d6a514e$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $5e5938f91d6a514e$var$stubReset(context) {
    return context.overallProgress && $5e5938f91d6a514e$var$stubProgress;
}
function $5e5938f91d6a514e$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $5e5938f91d6a514e$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $5e5938f91d6a514e$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $5e5938f91d6a514e$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $ckizb.normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $hzBt5.map)(resetDefines, function(v, idx) {
        return $5e5938f91d6a514e$var$makeSeriesTaskProgress(idx);
    }) : $5e5938f91d6a514e$var$singleSeriesTaskProgress;
}
var $5e5938f91d6a514e$var$singleSeriesTaskProgress = $5e5938f91d6a514e$var$makeSeriesTaskProgress(0);
function $5e5938f91d6a514e$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $5e5938f91d6a514e$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $5e5938f91d6a514e$var$detectSeriseType(legacyFunc) {
    $5e5938f91d6a514e$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($5e5938f91d6a514e$var$ecModelMock, $5e5938f91d6a514e$var$apiMock);
    } catch (e) {}
    return $5e5938f91d6a514e$var$seriesType;
}
var $5e5938f91d6a514e$var$ecModelMock = {};
var $5e5938f91d6a514e$var$apiMock = {};
var $5e5938f91d6a514e$var$seriesType;
$5e5938f91d6a514e$var$mockMethods($5e5938f91d6a514e$var$ecModelMock, (0, $2dhmo.default));
$5e5938f91d6a514e$var$mockMethods($5e5938f91d6a514e$var$apiMock, (0, $4npYR.default));
$5e5938f91d6a514e$var$ecModelMock.eachSeriesByType = $5e5938f91d6a514e$var$ecModelMock.eachRawSeriesByType = function(type) {
    $5e5938f91d6a514e$var$seriesType = type;
};
$5e5938f91d6a514e$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $5e5938f91d6a514e$var$seriesType = cond.subType;
};
function $5e5938f91d6a514e$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $hzBt5.noop);
/* eslint-enable */ }
var $5e5938f91d6a514e$export$2e2bcd8739ae039 = $5e5938f91d6a514e$var$Scheduler;

});

parcelRegister("dsS8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $02879c6959dcaf87$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $02879c6959dcaf87$var$colorAll = [
    '#37A2DA',
    '#32C5E9',
    '#67E0E3',
    '#9FE6B8',
    '#FFDB5C',
    '#ff9f7f',
    '#fb7293',
    '#E062AE',
    '#E690D1',
    '#e7bcf3',
    '#9d96f5',
    '#8378EA',
    '#96BFFF'
];
var $02879c6959dcaf87$export$2e2bcd8739ae039 = {
    color: $02879c6959dcaf87$var$colorAll,
    colorLayer: [
        [
            '#37A2DA',
            '#ffd85c',
            '#fd7b5f'
        ],
        [
            '#37A2DA',
            '#67E0E3',
            '#FFDB5C',
            '#ff9f7f',
            '#E062AE',
            '#9d96f5'
        ],
        [
            '#37A2DA',
            '#32C5E9',
            '#9FE6B8',
            '#FFDB5C',
            '#ff9f7f',
            '#fb7293',
            '#e7bcf3',
            '#8378EA',
            '#96BFFF'
        ],
        $02879c6959dcaf87$var$colorAll
    ]
};

});

parcelRegister("85Dmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3d52fa3989b456$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5e3d52fa3989b456$var$contrastColor = '#B9B8CE';
var $5e3d52fa3989b456$var$backgroundColor = '#100C2A';
var $5e3d52fa3989b456$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $5e3d52fa3989b456$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: '#484753'
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    'rgba(255,255,255,0.02)',
                    'rgba(255,255,255,0.05)'
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: '#20203B'
            }
        }
    };
};
var $5e3d52fa3989b456$var$colorPalette = [
    '#4992ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
];
var $5e3d52fa3989b456$var$theme = {
    darkMode: true,
    color: $5e3d52fa3989b456$var$colorPalette,
    backgroundColor: $5e3d52fa3989b456$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: '#817f91'
        },
        crossStyle: {
            color: '#817f91'
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: '#fff'
        }
    },
    legend: {
        textStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        }
    },
    textStyle: {
        color: $5e3d52fa3989b456$var$contrastColor
    },
    title: {
        textStyle: {
            color: '#EEF1FA'
        },
        subtextStyle: {
            color: '#B9B8CE'
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $5e3d52fa3989b456$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: '#71708A',
        textStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        brushStyle: {
            color: 'rgba(135,163,206,0.3)'
        },
        handleStyle: {
            color: '#353450',
            borderColor: '#C5CBE3'
        },
        moveHandleStyle: {
            color: '#B0B6C3',
            opacity: 0.3
        },
        fillerColor: 'rgba(135,163,206,0.2)',
        emphasis: {
            handleStyle: {
                borderColor: '#91B7F2',
                color: '#4D587D'
            },
            moveHandleStyle: {
                color: '#636D9A',
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: '#71708A',
                width: 1
            },
            areaStyle: {
                color: '#71708A'
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#87A3CE'
            },
            areaStyle: {
                color: '#87A3CE'
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        label: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        controlStyle: {
            color: $5e3d52fa3989b456$var$contrastColor,
            borderColor: $5e3d52fa3989b456$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $5e3d52fa3989b456$var$backgroundColor
        },
        dayLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        monthLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        yearLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        }
    },
    timeAxis: $5e3d52fa3989b456$var$axisCommon(),
    logAxis: $5e3d52fa3989b456$var$axisCommon(),
    valueAxis: $5e3d52fa3989b456$var$axisCommon(),
    categoryAxis: $5e3d52fa3989b456$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $5e3d52fa3989b456$var$colorPalette
    },
    gauge: {
        title: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        'rgba(207,212,219,0.2)'
                    ]
                ]
            }
        },
        axisLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        detail: {
            color: '#EEF1FA'
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92' // borderColor: '#ca2824',
        }
    }
};
$5e3d52fa3989b456$var$theme.categoryAxis.splitLine.show = false;
var $5e3d52fa3989b456$export$2e2bcd8739ae039 = $5e3d52fa3989b456$var$theme;

});

parcelRegister("9xw3H", function(module, exports) {

$parcel$export(module.exports, "ECEventProcessor", () => $6f20104e8ac2b01c$export$d0fd09f950257b52);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $jKrBG = parcelRequire("jKrBG");
/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $6f20104e8ac2b01c$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
        if ($hzBt5.isString(query)) {
            var condCptType = (0, $jKrBG.parseClassType)(query); // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $hzBt5.each(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view; // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo wont be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();

});

parcelRegister("fTE3u", function(module, exports) {

$parcel$export(module.exports, "seriesSymbolTask", () => $b92b10342c0e83bd$export$144ac3beded415d9);
$parcel$export(module.exports, "dataSymbolTask", () => $b92b10342c0e83bd$export$435b956f7f1071fb);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $b92b10342c0e83bd$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolType = seriesModel.get('symbol');
        var symbolSize = seriesModel.get('symbolSize');
        var keepAspect = seriesModel.get('symbolKeepAspect');
        var symbolRotate = seriesModel.get('symbolRotate');
        var symbolOffset = seriesModel.get('symbolOffset');
        var hasSymbolTypeCallback = (0, $hzBt5.isFunction)(symbolType);
        var hasSymbolSizeCallback = (0, $hzBt5.isFunction)(symbolSize);
        var hasSymbolRotateCallback = (0, $hzBt5.isFunction)(symbolRotate);
        var hasSymbolOffsetCallback = (0, $hzBt5.isFunction)(symbolOffset);
        var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback || hasSymbolOffsetCallback;
        var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : seriesModel.defaultSymbol;
        var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
        var seriesSymbolRotate = !hasSymbolRotateCallback ? symbolRotate : null;
        var seriesSymbolOffset = !hasSymbolOffsetCallback ? symbolOffset : null;
        data.setVisual({
            legendIcon: seriesModel.legendIcon || seriesSymbol,
            // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
            // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
            // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
            // some cases but generally it is not recommanded.
            symbol: seriesSymbol,
            symbolSize: seriesSymbolSize,
            symbolKeepAspect: keepAspect,
            symbolRotate: seriesSymbolRotate,
            symbolOffset: seriesSymbolOffset
        }); // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
            hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
            hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
            hasSymbolOffsetCallback && data.setItemVisual(idx, 'symbolOffset', symbolOffset(rawValue, params));
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $b92b10342c0e83bd$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
         // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var itemSymbolType = itemModel.getShallow('symbol', true);
            var itemSymbolSize = itemModel.getShallow('symbolSize', true);
            var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
            var itemSymbolOffset = itemModel.getShallow('symbolOffset', true);
            var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
            if (itemSymbolType != null) data.setItemVisual(idx, 'symbol', itemSymbolType);
            if (itemSymbolSize != null) // PENDING Transform symbolSize ?
            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
            if (itemSymbolRotate != null) data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
            if (itemSymbolOffset != null) data.setItemVisual(idx, 'symbolOffset', itemSymbolOffset);
            if (itemSymbolKeepAspect != null) data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};

});

parcelRegister("3uf7q", function(module, exports) {

$parcel$export(module.exports, "getItemVisualFromData", () => $289fe6b61c2cc1b6$export$91d919a86b2df624);
$parcel$export(module.exports, "getVisualFromData", () => $289fe6b61c2cc1b6$export$d76e333a86ea1a2);
$parcel$export(module.exports, "setItemVisualFromData", () => $289fe6b61c2cc1b6$export$3aab879e9d0e7c75);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $289fe6b61c2cc1b6$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $289fe6b61c2cc1b6$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $289fe6b61c2cc1b6$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value; // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}

});

parcelRegister("kPQAq", function(module, exports) {

$parcel$export(module.exports, "createLegacyDataSelectAction", () => $f2b15ca7d2e037ba$export$62942ba95693dbfc);
$parcel$export(module.exports, "handleLegacySelectEvents", () => $f2b15ca7d2e037ba$export$2575c83262e49d0c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");


var $ckizb = parcelRequire("ckizb");
function $f2b15ca7d2e037ba$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $hzBt5.each)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $hzBt5.extend)({}, payload);
            api.dispatchAction((0, $hzBt5.extend)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $ckizb.queryDataIndex)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $hzBt5.isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $hzBt5.extend)({}, seriesModel.option.selectedMap)
            });
        }
    });
}
function $f2b15ca7d2e037ba$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}

});

parcelRegister("1MZkk", function(module, exports) {

$parcel$export(module.exports, "findEventDispatcher", () => $14d9d861e24a3bd8$export$8a4fca9e04eb4df6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $14d9d861e24a3bd8$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}

});

parcelRegister("aXrNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa4faf409a9030d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7Y3oh = parcelRequire("7Y3oh");
function $7fa4faf409a9030d$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $7Y3oh.createOrUpdatePatternFromDecal)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $7Y3oh.createOrUpdatePatternFromDecal)(decal, api);
        }
    });
}

});
parcelRegister("7Y3oh", function(module, exports) {

$parcel$export(module.exports, "createOrUpdatePatternFromDecal", () => $5cd0c44c08f62803$export$a3ba048e1a648972);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lasoJ = parcelRequire("lasoJ");

var $lXNaK = parcelRequire("lXNaK");

var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $4TnMt = parcelRequire("4TnMt");

var $2Zzmo = parcelRequire("2Zzmo");
var $5cd0c44c08f62803$var$decalMap = new (0, $lasoJ.default)();
var $5cd0c44c08f62803$var$decalCache = new (0, $lXNaK.default)(100);
var $5cd0c44c08f62803$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $5cd0c44c08f62803$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $5cd0c44c08f62803$var$decalMap["delete"](decalObject);
    var oldPattern = $5cd0c44c08f62803$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $hzBt5.defaults)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $5cd0c44c08f62803$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $5cd0c44c08f62803$var$decalKeys.length; ++i){
            var value = decalOpt[$5cd0c44c08f62803$var$decalKeys[i]];
            var valueType = typeof value;
            if (value != null && !(0, $hzBt5.isArray)(value) && valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $5cd0c44c08f62803$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $5cd0c44c08f62803$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $5cd0c44c08f62803$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $5cd0c44c08f62803$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $5cd0c44c08f62803$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $5cd0c44c08f62803$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $hzBt5.createCanvas)();
        var svgRoot = isSVG && zr.painter.createSVGElement('g');
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $5cd0c44c08f62803$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minumum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minumum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $5BQXp.getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $5BQXp.getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                         // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $4TnMt.createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) svgRoot.appendChild(zr.painter.paintOne(symbol));
                else // Paint to canvas for all other renderers.
                (0, $2Zzmo.brushSingle)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $5cd0c44c08f62803$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if (typeof symbol === 'string') return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] !== 'string') {
        isAllString = false;
        break;
    }
    if (isAllString) return $5cd0c44c08f62803$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] === 'string') result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $5cd0c44c08f62803$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if (typeof dash === 'number') {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] !== 'number') {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $5cd0c44c08f62803$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] === 'number') {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $hzBt5.map)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $5cd0c44c08f62803$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if (typeof dash === 'number') {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $hzBt5.map)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash arrary of X or Y
 * @return {number[]} block length of each line
 */ function $5cd0c44c08f62803$var$getLineBlockLengthX(dash) {
    return (0, $hzBt5.map)(dash, function(line) {
        return $5cd0c44c08f62803$var$getLineBlockLengthY(line);
    });
}
function $5cd0c44c08f62803$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}

});
parcelRegister("lasoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6908f659109ff21$export$2e2bcd8739ae039);
var $f6908f659109ff21$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $f6908f659109ff21$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $f6908f659109ff21$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $f6908f659109ff21$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($f6908f659109ff21$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $f6908f659109ff21$export$2e2bcd8739ae039 = $f6908f659109ff21$var$WeakMap;

});

parcelRegister("2Zzmo", function(module, exports) {

$parcel$export(module.exports, "createCanvasPattern", () => $22dcb511a0158474$export$8eb5db6b7bc27903);
$parcel$export(module.exports, "brushSingle", () => $22dcb511a0158474$export$567881adfc3eb7f3);
$parcel$export(module.exports, "brush", () => $22dcb511a0158474$export$da5d6544e8c27bc1);

var $g1Uer = parcelRequire("g1Uer");

var $fvvgx = parcelRequire("fvvgx");

var $3RCXB = parcelRequire("3RCXB");

var $geJzd = parcelRequire("geJzd");

var $hMiip = parcelRequire("hMiip");

var $agXnr = parcelRequire("agXnr");

var $lm58d = parcelRequire("lm58d");

var $02NbV = parcelRequire("02NbV");

var $hzBt5 = parcelRequire("hzBt5");

var $jJSZho = parcelRequire("jJSZho");

var $4Nii9 = parcelRequire("4Nii9");

var $4rgPt = parcelRequire("4rgPt");
var $22dcb511a0158474$var$pathProxyForDraw = new (0, $fvvgx.default)(true);
function $22dcb511a0158474$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $22dcb511a0158474$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $22dcb511a0158474$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $22dcb511a0158474$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $22dcb511a0158474$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $22dcb511a0158474$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $3RCXB.createOrUpdateImage)(pattern.image, pattern.__image, el);
    if ((0, $3RCXB.isImageReady)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) / Math.PI * 180);
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $22dcb511a0158474$var$brushPath(ctx, el, style, inBatch) {
    var hasStroke = $22dcb511a0158474$var$styleHasStroke(style);
    var hasFill = $22dcb511a0158474$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $22dcb511a0158474$var$pathProxyForDraw;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = el.__dirty ? (0, $geJzd.getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = el.__dirty ? (0, $geJzd.getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = el.__dirty || !el.__canvasFillPattern ? $22dcb511a0158474$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = el.__dirty || !el.__canvasStrokePattern ? $22dcb511a0158474$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var lineDash = style.lineDash && style.lineWidth > 0 && (0, $jJSZho.normalizeLineDash)(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash;
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $hzBt5.map)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    var needsRebuild = true;
    if (firstDraw || el.__dirty & (0, $4rgPt.SHAPE_CHANGED_BIT) || lineDash && !ctxLineDash && hasStroke) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        if (lineDash && !ctxLineDash) {
            path.setLineDash(lineDash);
            path.setLineDashOffset(lineDashOffset);
        }
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash && ctxLineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $22dcb511a0158474$var$doStrokePath(ctx, style);
            if (hasFill) $22dcb511a0158474$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $22dcb511a0158474$var$doFillPath(ctx, style);
            if (hasStroke) $22dcb511a0158474$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash && ctxLineDash) ctx.setLineDash([]);
}
function $22dcb511a0158474$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $3RCXB.createOrUpdateImage)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $3RCXB.isImageReady)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $22dcb511a0158474$var$brushText(ctx, el, style) {
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $02NbV.DEFAULT_FONT);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var hasLineDash = void 0;
        if (ctx.setLineDash) {
            var lineDash = style.lineDash && style.lineWidth > 0 && (0, $jJSZho.normalizeLineDash)(style.lineDash, style.lineWidth);
            var lineDashOffset = style.lineDashOffset;
            if (lineDash) {
                var lineScale_2 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
                if (lineScale_2 && lineScale_2 !== 1) {
                    lineDash = (0, $hzBt5.map)(lineDash, function(rawVal) {
                        return rawVal / lineScale_2;
                    });
                    lineDashOffset /= lineScale_2;
                }
                ctx.setLineDash(lineDash);
                ctx.lineDashOffset = lineDashOffset;
                hasLineDash = true;
            }
        }
        if (style.strokeFirst) {
            if ($22dcb511a0158474$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($22dcb511a0158474$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($22dcb511a0158474$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($22dcb511a0158474$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (hasLineDash) ctx.setLineDash([]);
    }
}
var $22dcb511a0158474$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $22dcb511a0158474$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $22dcb511a0158474$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $g1Uer.DEFAULT_COMMON_STYLE).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $g1Uer.DEFAULT_COMMON_STYLE).blend;
    }
    for(var i = 0; i < $22dcb511a0158474$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $22dcb511a0158474$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $g1Uer.DEFAULT_COMMON_STYLE).shadowColor;
    }
    return styleChanged;
}
function $22dcb511a0158474$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $22dcb511a0158474$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $22dcb511a0158474$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $22dcb511a0158474$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $22dcb511a0158474$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $22dcb511a0158474$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $22dcb511a0158474$var$STROKE_PROPS.length; i++){
        var prop = $22dcb511a0158474$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $22dcb511a0158474$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $22dcb511a0158474$var$bindCommonProps(ctx, $22dcb511a0158474$var$getStyle(el, scope.inHover), prevEl && $22dcb511a0158474$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $22dcb511a0158474$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $22dcb511a0158474$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $22dcb511a0158474$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $22dcb511a0158474$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $22dcb511a0158474$var$DRAW_TYPE_PATH = 1;
var $22dcb511a0158474$var$DRAW_TYPE_IMAGE = 2;
var $22dcb511a0158474$var$DRAW_TYPE_TEXT = 3;
var $22dcb511a0158474$var$DRAW_TYPE_INCREMENTAL = 4;
function $22dcb511a0158474$var$canPathBatch(style) {
    var hasFill = $22dcb511a0158474$var$styleHasFill(style);
    var hasStroke = $22dcb511a0158474$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $22dcb511a0158474$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $22dcb511a0158474$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $22dcb511a0158474$export$567881adfc3eb7f3(ctx, el) {
    $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $4rgPt.REDRAW_BIT);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $geJzd.isClipPathChanged)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $22dcb511a0158474$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $hMiip.default) && el.autoBatch && $22dcb511a0158474$var$canPathBatch(el.style);
    if (forceSetTransform || $22dcb511a0158474$var$isTransformChanged(m, prevEl.transform)) {
        $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
        $22dcb511a0158474$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
    var style = $22dcb511a0158474$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $hMiip.default)) {
        if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_PATH;
        }
        $22dcb511a0158474$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $22dcb511a0158474$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $lm58d.default)) {
            if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_TEXT;
            }
            $22dcb511a0158474$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $22dcb511a0158474$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $agXnr.default)) {
            if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_IMAGE;
            }
            $22dcb511a0158474$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $22dcb511a0158474$var$brushImage(ctx, el, style);
        } else if (el instanceof (0, $4Nii9.default)) {
            if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_INCREMENTAL;
            }
            $22dcb511a0158474$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $22dcb511a0158474$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}

});
parcelRegister("geJzd", function(module, exports) {

$parcel$export(module.exports, "getCanvasGradient", () => $bd214cd252565598$export$3dab6afd018d48c7);
$parcel$export(module.exports, "isClipPathChanged", () => $bd214cd252565598$export$beeddc5150cb2e83);
function $bd214cd252565598$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = isNaN(x) ? 0 : x;
    x2 = isNaN(x2) ? 1 : x2;
    y = isNaN(y) ? 0 : y;
    y2 = isNaN(y2) ? 0 : y2;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $bd214cd252565598$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $bd214cd252565598$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $bd214cd252565598$export$57f098206d57a443(ctx, obj, rect) : $bd214cd252565598$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $bd214cd252565598$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}

});

parcelRegister("jJSZho", function(module, exports) {

$parcel$export(module.exports, "normalizeLineDash", () => $e5ecdfa291d5fe1b$export$9efb2ae8a603855d);

var $hzBt5 = parcelRequire("hzBt5");
function $e5ecdfa291d5fe1b$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    lineWidth = lineWidth || 1;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $hzBt5.isNumber)(lineType) ? [
        lineType
    ] : (0, $hzBt5.isArray)(lineType) ? lineType : null;
}

});




parcelRegister("lIsFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf3f197899e27c0$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $iHhub = parcelRequire("iHhub");

var $iDQ2S = parcelRequire("iDQ2S");
var $fcf3f197899e27c0$var$storage = (0, $hzBt5.createHashMap)();
var $fcf3f197899e27c0$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $iHhub.GeoSVGResource)(mapName, rawDef.svg);
            $fcf3f197899e27c0$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $iDQ2S.GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
            $fcf3f197899e27c0$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $fcf3f197899e27c0$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $fcf3f197899e27c0$var$storage.get(mapName); // Do not support return SVG until some real requirement come.
        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $fcf3f197899e27c0$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};

});
parcelRegister("iHhub", function(module, exports) {

$parcel$export(module.exports, "GeoSVGResource", () => $d9c9ce73bb397579$export$be52c950efae1f84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3mJ7S = parcelRequire("3mJ7S");

var $hXAsm = parcelRequire("hXAsm");

var $aeCKo = parcelRequire("aeCKo");

var $hzBt5 = parcelRequire("hzBt5");

var $lGSv6 = parcelRequire("lGSv6");

var $236og = parcelRequire("236og");

var $84Tkq = parcelRequire("84Tkq");
/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $d9c9ce73bb397579$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $hzBt5.createHashMap)([
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path',
    // but still need to trigger events or tooltip.
    'text',
    'tspan',
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    'g'
]);
var $d9c9ce73bb397579$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = 'geoSVG'; // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $hzBt5.createHashMap)(); // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName; // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $236og.parseXML)(svg);
    }
    GeoSVGResource.prototype.load = function() /* nameMap: NameMap */ {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic; // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone(); // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $d9c9ce73bb397579$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $3mJ7S.parseSVG)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $hzBt5.assert)(rootFromParse != null);
        } catch (e) {
            throw new Error('Invalid svg format\n' + e.message);
        } // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $hXAsm.default)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true; // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only suport `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            } // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $lGSv6.default)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $3mJ7S.makeViewBoxTransform)(viewBoxRect, boundingRect); // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        } // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $aeCKo.default)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $hzBt5.each)(result.named, function(namedItem) {
            if ($d9c9ce73bb397579$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $d9c9ce73bb397579$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() // use the first boundingRect to avoid duplicated boundingRect calculation.
         || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic); // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $d9c9ce73bb397579$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false; // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $d9c9ce73bb397579$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $hzBt5.createHashMap)(); // Create resions only for the first graphic.
    (0, $hzBt5.each)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $84Tkq.GeoSVGRegion)(namedItem.name, namedItem.el); // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region); // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }

});
parcelRegister("3mJ7S", function(module, exports) {

$parcel$export(module.exports, "makeViewBoxTransform", () => $27366e3eab380188$export$3e2db4420f14f50f);
$parcel$export(module.exports, "parseSVG", () => $27366e3eab380188$export$1919f5101c220601);

var $hXAsm = parcelRequire("hXAsm");

var $agXnr = parcelRequire("agXnr");

var $aYBv9 = parcelRequire("aYBv9");

var $aeCKo = parcelRequire("aeCKo");

var $gwELx = parcelRequire("gwELx");

var $15UDR = parcelRequire("15UDR");

var $cjY1b = parcelRequire("cjY1b");

var $9dsiU = parcelRequire("9dsiU");

var $crEgd = parcelRequire("crEgd");

var $lJlYD = parcelRequire("lJlYD");

var $hzBt5 = parcelRequire("hzBt5");

var $4kdki = parcelRequire("4kdki");

var $hkgm4 = parcelRequire("hkgm4");

var $lm58d = parcelRequire("lm58d");

var $236og = parcelRequire("236og");
var $27366e3eab380188$var$nodeParsers;
var $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $hzBt5.keys)($27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $hzBt5.keys)($27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP);
var $27366e3eab380188$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $236og.parseXML)(xml);
        if (!svg) throw new Error('Illegal svg');
        this._defsUsePending = [];
        var root = new (0, $hXAsm.default)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat(svg.getAttribute('width') || opt.width);
        var height = parseFloat(svg.getAttribute('height') || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $27366e3eab380188$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $27366e3eab380188$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $27366e3eab380188$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $27366e3eab380188$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $hXAsm.default)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $aeCKo.default)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') isInDefs = true;
        if (nodeName === 'text') isInText = true;
        if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $27366e3eab380188$var$nodeParsers[nodeName];
                if (parser_1 && (0, $hzBt5.hasOwn)($27366e3eab380188$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $27366e3eab380188$var$paintServerParsers[nodeName];
            if (parser && (0, $hzBt5.hasOwn)($27366e3eab380188$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $lm58d.default)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $27366e3eab380188$var$inheritStyle(parentGroup, text);
        $27366e3eab380188$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $27366e3eab380188$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $27366e3eab380188$var$nodeParsers = {
            'g': function(xmlNode, parentGroup) {
                var g = new (0, $hXAsm.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, g);
                $27366e3eab380188$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function(xmlNode, parentGroup) {
                var rect = new (0, $aeCKo.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, rect);
                $27366e3eab380188$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function(xmlNode, parentGroup) {
                var circle = new (0, $aYBv9.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, circle);
                $27366e3eab380188$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function(xmlNode, parentGroup) {
                var line = new (0, $15UDR.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, line);
                $27366e3eab380188$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function(xmlNode, parentGroup) {
                var ellipse = new (0, $gwELx.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, ellipse);
                $27366e3eab380188$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $27366e3eab380188$var$parsePoints(pointsStr);
                var polygon = new (0, $cjY1b.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $27366e3eab380188$var$inheritStyle(parentGroup, polygon);
                $27366e3eab380188$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $27366e3eab380188$var$parsePoints(pointsStr);
                var polyline = new (0, $9dsiU.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $27366e3eab380188$var$inheritStyle(parentGroup, polyline);
                $27366e3eab380188$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function(xmlNode, parentGroup) {
                var img = new (0, $agXnr.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, img);
                $27366e3eab380188$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $hXAsm.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, g);
                $27366e3eab380188$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new (0, $hXAsm.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, g);
                $27366e3eab380188$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = (0, $lJlYD.createFromString)(d);
                $27366e3eab380188$var$inheritStyle(parentGroup, path);
                $27366e3eab380188$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $27366e3eab380188$var$paintServerParsers = {
    'lineargradient': function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new (0, $4kdki.default)(x1, y1, x2, y2);
        $27366e3eab380188$var$parsePaintServerUnit(xmlNode, gradient);
        $27366e3eab380188$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new (0, $hkgm4.default)(cx, cy, r);
        $27366e3eab380188$var$parsePaintServerUnit(xmlNode, gradient);
        $27366e3eab380188$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $27366e3eab380188$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
}
function $27366e3eab380188$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $27366e3eab380188$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $27366e3eab380188$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $hzBt5.defaults)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $27366e3eab380188$var$parsePoints(pointsString) {
    var list = $27366e3eab380188$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $27366e3eab380188$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $27366e3eab380188$var$parseTransformAttribute(xmlNode, el);
        $27366e3eab380188$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $27366e3eab380188$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $27366e3eab380188$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $27366e3eab380188$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    (0, $hzBt5.each)([
        'lineWidth',
        'opacity',
        'fillOpacity',
        'strokeOpacity',
        'miterLimit',
        'fontSize'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $hzBt5.each)([
        'lineDashOffset',
        'lineCap',
        'lineJoin',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'textAlign'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $hzBt5.map)($27366e3eab380188$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
    if (inheritedStyle.display === 'none') disp.ignore = true;
}
function $27366e3eab380188$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
        else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') zrTextAlign = 'center';
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $27366e3eab380188$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $27366e3eab380188$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($27366e3eab380188$var$urlRegex);
    if (urlMatch) {
        var url = (0, $hzBt5.trim)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === 'none') str = null;
    return str;
}
function $27366e3eab380188$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $27366e3eab380188$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $27366e3eab380188$var$splitNumberSequence(rawStr) {
    return rawStr.match($27366e3eab380188$var$numberReg) || [];
}
var $27366e3eab380188$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $27366e3eab380188$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $27366e3eab380188$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace($27366e3eab380188$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $27366e3eab380188$var$splitNumberSequence(value);
            mt = mt || $crEgd.create();
            switch(type){
                case 'translate':
                    $crEgd.translate(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || '0')
                    ]);
                    break;
                case 'scale':
                    $crEgd.scale(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case 'rotate':
                    $crEgd.rotate(mt, mt, -parseFloat(valueArr[0]) * $27366e3eab380188$var$DEGREE_TO_ANGLE);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * $27366e3eab380188$var$DEGREE_TO_ANGLE);
                    $crEgd.mul(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * $27366e3eab380188$var$DEGREE_TO_ANGLE);
                    $crEgd.mul(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $27366e3eab380188$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $27366e3eab380188$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) return;
    $27366e3eab380188$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $27366e3eab380188$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $hzBt5.hasOwn)($27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $hzBt5.hasOwn)($27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $27366e3eab380188$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $27366e3eab380188$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $27366e3eab380188$export$1919f5101c220601(xml, opt) {
    var parser = new $27366e3eab380188$var$SVGParser();
    return parser.parse(xml, opt);
}

});
parcelRegister("236og", function(module, exports) {

$parcel$export(module.exports, "parseXML", () => $17e0d1955c2d9cc9$export$eacefc55fad2867e);

var $hzBt5 = parcelRequire("hzBt5");
function $17e0d1955c2d9cc9$export$eacefc55fad2867e(svg) {
    if ((0, $hzBt5.isString)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}

});


parcelRegister("84Tkq", function(module, exports) {

$parcel$export(module.exports, "GeoJSONRegion", () => $5e199d860f8f66fd$export$ee84fcb463f24b3d);
$parcel$export(module.exports, "GeoSVGRegion", () => $5e199d860f8f66fd$export$5f3d89e7254f3e69);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $lGSv6 = parcelRequire("lGSv6");

var $eVhyd = parcelRequire("eVhyd");

var $ef5pP = parcelRequire("ef5pP");

var $kb4w8 = parcelRequire("kb4w8");

var $crEgd = parcelRequire("crEgd");
var $5e199d860f8f66fd$var$TMP_TRANSFORM = [];
var $5e199d860f8f66fd$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        return;
    };
    return Region;
}();
var $5e199d860f8f66fd$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoJSON';
        _this.geometries = geometries;
        if (!cp) {
            var rect = _this.getBoundingRect();
            cp = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        } else cp = [
            cp[0],
            cp[1]
        ];
        _this._center = cp;
        return _this;
    }
    GeoJSONRegion.prototype.getBoundingRect = function() {
        var rect = this._rect;
        if (rect) return rect;
        var MAX_NUMBER = Number.MAX_VALUE;
        var min = [
            MAX_NUMBER,
            MAX_NUMBER
        ];
        var max = [
            -MAX_NUMBER,
            -MAX_NUMBER
        ];
        var min2 = [];
        var max2 = [];
        var geometries = this.geometries;
        var i = 0;
        for(; i < geometries.length; i++){
            // Only support polygon
            if (geometries[i].type !== 'polygon') continue;
             // Doesn't consider hole
            var exterior = geometries[i].exterior;
            $eVhyd.fromPoints(exterior, min2, max2);
            $ef5pP.min(min, min, min2);
            $ef5pP.max(max, max, max2);
        } // No data
        if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
        return this._rect = new (0, $lGSv6.default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            if ($kb4w8.contain(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($kb4w8.contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $lGSv6.default)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            for(var p = 0; p < exterior.length; p++)$ef5pP.applyTransform(exterior[p], exterior[p], transform);
            for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)$ef5pP.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
        rect = this._rect;
        rect.copy(target); // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    GeoJSONRegion.prototype.getCenter = function() {
        return this._center;
    };
    GeoJSONRegion.prototype.setCenter = function(center) {
        this._center = center;
    };
    return GeoJSONRegion;
}($5e199d860f8f66fd$export$b1f97c3099fc6872);
var $5e199d860f8f66fd$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoSVG';
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this._calculateCenter();
        return center;
    };
    GeoSVGRegion.prototype._calculateCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $crEgd.identity($5e199d860f8f66fd$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $crEgd.mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $crEgd.invert(mat, mat);
        $ef5pP.applyTransform(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($5e199d860f8f66fd$export$b1f97c3099fc6872);

});
parcelRegister("kb4w8", function(module, exports) {

$parcel$export(module.exports, "contain", () => $eb0856c310682b69$export$8893e2b90ba10d92);

var $j53mu = parcelRequire("j53mu");
var $eb0856c310682b69$var$EPSILON = 1e-8;
function $eb0856c310682b69$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $eb0856c310682b69$var$EPSILON;
}
function $eb0856c310682b69$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $j53mu.default)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$eb0856c310682b69$var$isAroundEqual(p[0], p0[0]) || !$eb0856c310682b69$var$isAroundEqual(p[1], p0[1])) w += (0, $j53mu.default)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}

});



parcelRegister("iDQ2S", function(module, exports) {

$parcel$export(module.exports, "GeoJSONResource", () => $d9243da321b85586$export$859cf85c67f2df51);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $7gQBi = parcelRequire("7gQBi");

var $h9nHC = parcelRequire("h9nHC");

var $hvA1X = parcelRequire("hvA1X");

var $22U1g = parcelRequire("22U1g");

var $5nz70 = parcelRequire("5nz70");

var $lGSv6 = parcelRequire("lGSv6");
var $d9243da321b85586$var$DEFAULT_NAME_PROPERTY = 'name';
var $d9243da321b85586$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = 'geoJSON';
        this._parsedMap = (0, $hzBt5.createHashMap)();
        this._mapName = mapName;
        this._specialAreas = specialAreas; // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $d9243da321b85586$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $d9243da321b85586$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $d9243da321b85586$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $hzBt5.createHashMap)();
        var finalRegions = [];
        (0, $hzBt5.each)(parsed.regions, function(region) {
            var regionName = region.name; // Try use the alias in geoNameMap
            if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $lGSv6.default)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions; // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $7gQBi.default)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error('Invalid geoJson format\n' + e.message);
        }
        (0, $h9nHC.default)(mapName, rawRegions);
        (0, $hzBt5.each)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $hvA1X.default)(mapName, region);
            (0, $22U1g.default)(mapName, region);
            (0, $5nz70.default)(mapName, region); // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $d9243da321b85586$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $d9243da321b85586$var$parseInput(source) {
    return !(0, $hzBt5.isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}

});
parcelRegister("7gQBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b2d45ff40edf24$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 
var $hzBt5 = parcelRequire("hzBt5");

var $84Tkq = parcelRequire("84Tkq");
function $54b2d45ff40edf24$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    for(var f = 0; f < features.length; f++){
        var feature = features[f];
        var geometry = feature.geometry;
        if (geometry.type === 'Polygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++)coordinates[c] = $54b2d45ff40edf24$var$decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
        } else if (geometry.type === 'MultiPolygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++){
                var coordinate = coordinates[c];
                for(var c2 = 0; c2 < coordinate.length; c2++)coordinate[c2] = $54b2d45ff40edf24$var$decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
            }
        }
    } // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $54b2d45ff40edf24$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1); // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y; // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $54b2d45ff40edf24$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $54b2d45ff40edf24$var$decode(geoJson);
    return $hzBt5.map($hzBt5.filter(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        if (geo.type === 'Polygon') {
            var coordinates = geo.coordinates;
            geometries.push({
                type: 'polygon',
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                exterior: coordinates[0],
                interiors: coordinates.slice(1)
            });
        }
        if (geo.type === 'MultiPolygon') {
            var coordinates = geo.coordinates;
            $hzBt5.each(coordinates, function(item) {
                if (item[0]) geometries.push({
                    type: 'polygon',
                    exterior: item[0],
                    interiors: item.slice(1)
                });
            });
        }
        var region = new (0, $84Tkq.GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}

});

parcelRegister("h9nHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c5a9c5e2acd596$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛

var $hzBt5 = parcelRequire("hzBt5");

var $84Tkq = parcelRequire("84Tkq");
var $c7c5a9c5e2acd596$var$geoCoord = [
    126,
    25
];
var $c7c5a9c5e2acd596$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $c7c5a9c5e2acd596$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $c7c5a9c5e2acd596$var$i = 0; $c7c5a9c5e2acd596$var$i < $c7c5a9c5e2acd596$var$points.length; $c7c5a9c5e2acd596$var$i++)for(var $c7c5a9c5e2acd596$var$k = 0; $c7c5a9c5e2acd596$var$k < $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i].length; $c7c5a9c5e2acd596$var$k++){
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][0] /= 10.5;
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][1] /= -14;
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][0] += $c7c5a9c5e2acd596$var$geoCoord[0];
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][1] += $c7c5a9c5e2acd596$var$geoCoord[1];
}
function $c7c5a9c5e2acd596$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === 'china') {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $c7c5a9c5e2acd596$var$nanhaiName) return;
        }
        regions.push(new (0, $84Tkq.GeoJSONRegion)($c7c5a9c5e2acd596$var$nanhaiName, $hzBt5.map($c7c5a9c5e2acd596$var$points, function(exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), $c7c5a9c5e2acd596$var$geoCoord));
    }
}

});

parcelRegister("hvA1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf147d6c100fd6e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $cbf147d6c100fd6e$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    //'北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $cbf147d6c100fd6e$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china') {
        var coordFix = $cbf147d6c100fd6e$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("22U1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d738f445a604e2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $17d738f445a604e2$var$geoCoordMap = {
    'Russia': [
        100,
        60
    ],
    'United States': [
        -99,
        38
    ],
    'United States of America': [
        -99,
        38
    ]
};
function $17d738f445a604e2$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'world') {
        var geoCoord = $17d738f445a604e2$var$geoCoordMap[region.name];
        if (geoCoord) {
            var cp = [
                geoCoord[0],
                geoCoord[1]
            ];
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("5nz70", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eaa563c9e4fe182$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $3eaa563c9e4fe182$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $3eaa563c9e4fe182$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: 'polygon',
        exterior: $3eaa563c9e4fe182$var$points[0]
    });
}

});



parcelRegister("3Vx2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc051d8dc36b810$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1J7Ke = parcelRequire("1J7Ke");
var $2dc051d8dc36b810$var$lifecycle = new (0, $1J7Ke.default)();
var $2dc051d8dc36b810$export$2e2bcd8739ae039 = $2dc051d8dc36b810$var$lifecycle;

});




parcelRegister("5vRmQ", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4RCLD = parcelRequire("4RCLD");
$parcel$exportWildcard(module.exports, $4RCLD);

});
parcelRegister("4RCLD", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Core API from echarts/src/echarts

var $eLPvY = parcelRequire("eLPvY");

var $6hcJs = parcelRequire("6hcJs");

var $lDnHX = parcelRequire("lDnHX");

var $kM74L = parcelRequire("kM74L");
(0, $lDnHX.use)((0, $kM74L.installLabelLayout));
$parcel$exportWildcard(module.exports, $eLPvY);
$parcel$exportWildcard(module.exports, $6hcJs);

});
parcelRegister("6hcJs", function(module, exports) {

$parcel$export(module.exports, "extendComponentModel", () => $491e34f747420328$export$4dd01020bb736662);
$parcel$export(module.exports, "extendComponentView", () => $491e34f747420328$export$a4336148da8ef02);
$parcel$export(module.exports, "extendSeriesModel", () => $491e34f747420328$export$fe6d3114e3fc260c);
$parcel$export(module.exports, "extendChartView", () => $491e34f747420328$export$c750883d1b603e83);
$parcel$export(module.exports, "zrender", () => (parcelRequire("fK0Gs")));
$parcel$export(module.exports, "matrix", () => (parcelRequire("crEgd")));
$parcel$export(module.exports, "vector", () => (parcelRequire("ef5pP")));
$parcel$export(module.exports, "zrUtil", () => (parcelRequire("hzBt5")));
$parcel$export(module.exports, "color", () => (parcelRequire("f7lrR")));
$parcel$export(module.exports, "throttle", () => (parcelRequire("7b8YY")).throttle);
$parcel$export(module.exports, "helper", () => (parcelRequire("86vkv")));
$parcel$export(module.exports, "use", () => (parcelRequire("lDnHX")).use);
$parcel$export(module.exports, "parseGeoJSON", () => (parcelRequire("7gQBi")).default);
$parcel$export(module.exports, "parseGeoJson", () => (parcelRequire("7gQBi")).default);
$parcel$export(module.exports, "number", () => (parcelRequire("1CMtG")));
$parcel$export(module.exports, "time", () => (parcelRequire("hq8bW")));
$parcel$export(module.exports, "graphic", () => (parcelRequire("eVazI")));
$parcel$export(module.exports, "format", () => (parcelRequire("bYXDT")));
$parcel$export(module.exports, "util", () => (parcelRequire("13Qhq")));
$parcel$export(module.exports, "env", () => (parcelRequire("gZXYp")).default);
$parcel$export(module.exports, "List", () => (parcelRequire("kyX7l")).default);
$parcel$export(module.exports, "Model", () => (parcelRequire("fR3z1")).default);
$parcel$export(module.exports, "Axis", () => (parcelRequire("ewaMj")).default);
$parcel$export(module.exports, "ComponentModel", () => (parcelRequire("6IEE1")).default);
$parcel$export(module.exports, "ComponentView", () => (parcelRequire("4uCJH")).default);
$parcel$export(module.exports, "SeriesModel", () => (parcelRequire("5vVec")).default);
$parcel$export(module.exports, "ChartView", () => (parcelRequire("azEx8")).default);
$parcel$export(module.exports, "innerDrawElementOnCanvas", () => (parcelRequire("2Zzmo")).brushSingle);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // These APIs are for more advanced usages
// For example extend charts and components, creating graphic elements, formatting.

var $6IEE1 = parcelRequire("6IEE1");

var $4uCJH = parcelRequire("4uCJH");

var $5vVec = parcelRequire("5vVec");

var $azEx8 = parcelRequire("azEx8");

var $kyX7l = parcelRequire("kyX7l");

var $fK0Gs = parcelRequire("fK0Gs");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");

var $7b8YY = parcelRequire("7b8YY");

var $86vkv = parcelRequire("86vkv");

var $lDnHX = parcelRequire("lDnHX");

var $7gQBi = parcelRequire("7gQBi");

var $1CMtG = parcelRequire("1CMtG");

var $hq8bW = parcelRequire("hq8bW");

var $eVazI = parcelRequire("eVazI");

var $bYXDT = parcelRequire("bYXDT");

var $13Qhq = parcelRequire("13Qhq");

var $gZXYp = parcelRequire("gZXYp");

var $fR3z1 = parcelRequire("fR3z1");

var $ewaMj = parcelRequire("ewaMj");

var $2Zzmo = parcelRequire("2Zzmo");
function $491e34f747420328$export$4dd01020bb736662(proto) {
    var Model = (0, $6IEE1.default).extend(proto);
    (0, $6IEE1.default).registerClass(Model);
    return Model;
}
function $491e34f747420328$export$a4336148da8ef02(proto) {
    var View = (0, $4uCJH.default).extend(proto);
    (0, $4uCJH.default).registerClass(View);
    return View;
}
function $491e34f747420328$export$fe6d3114e3fc260c(proto) {
    var Model = (0, $5vVec.default).extend(proto);
    (0, $5vVec.default).registerClass(Model);
    return Model;
}
function $491e34f747420328$export$c750883d1b603e83(proto) {
    var View = (0, $azEx8.default).extend(proto);
    (0, $azEx8.default).registerClass(View);
    return View;
}

});
parcelRegister("86vkv", function(module, exports) {

$parcel$export(module.exports, "createList", () => $5e672faeb355e945$export$5897d8d7c7a3d871);
$parcel$export(module.exports, "dataStack", () => $5e672faeb355e945$export$d6100971d5a3a0a7);
$parcel$export(module.exports, "createScale", () => $5e672faeb355e945$export$587d9c3c553380c6);
$parcel$export(module.exports, "mixinAxisModelCommonMethods", () => $5e672faeb355e945$export$4665cbe3470e4d57);
$parcel$export(module.exports, "createTextStyle", () => $5e672faeb355e945$export$f8998c3d0a13de59);
$parcel$export(module.exports, "getLayoutRect", () => (parcelRequire("e4mIu")).getLayoutRect);
$parcel$export(module.exports, "createDimensions", () => (parcelRequire("jrSv6")).createDimensions);
$parcel$export(module.exports, "createSymbol", () => (parcelRequire("4TnMt")).createSymbol);
$parcel$export(module.exports, "getECData", () => (parcelRequire("aly4X")).getECData);
$parcel$export(module.exports, "enableHoverEmphasis", () => (parcelRequire("51xyq")).enableHoverEmphasis);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * This module exposes helper functions for developing extensions.
 */ 
var $hzBt5 = parcelRequire("hzBt5");

var $3OWAv = parcelRequire("3OWAv");

var $ekDcz = parcelRequire("ekDcz");

var $kN6By = parcelRequire("kN6By");

var $fR3z1 = parcelRequire("fR3z1");

var $e4mIu = parcelRequire("e4mIu");

var $lljDt = parcelRequire("lljDt");

var $aly4X = parcelRequire("aly4X");

var $hcRXD = parcelRequire("hcRXD");

var $jrSv6 = parcelRequire("jrSv6");

var $4TnMt = parcelRequire("4TnMt");

var $51xyq = parcelRequire("51xyq");
function $5e672faeb355e945$export$5897d8d7c7a3d871(seriesModel) {
    return (0, $3OWAv.default)(null, seriesModel);
} // export function createGraph(seriesModel) {
var $5e672faeb355e945$export$d6100971d5a3a0a7 = {
    isDimensionStacked: (0, $lljDt.isDimensionStacked),
    enableDataStack: (0, $lljDt.enableDataStack),
    getStackedDimension: (0, $lljDt.getStackedDimension)
};
function $5e672faeb355e945$export$587d9c3c553380c6(dataExtent, option) {
    var axisModel = option;
    if (!(option instanceof (0, $fR3z1.default))) axisModel = new (0, $fR3z1.default)(option); // FIXME
    var scale = $ekDcz.createScaleByModel(axisModel);
    scale.setExtent(dataExtent[0], dataExtent[1]);
    $ekDcz.niceScaleExtent(scale, axisModel);
    return scale;
}
function $5e672faeb355e945$export$4665cbe3470e4d57(Model) {
    $hzBt5.mixin(Model, (0, $kN6By.AxisModelCommonMixin));
}
function $5e672faeb355e945$export$f8998c3d0a13de59(textStyleModel, opts) {
    opts = opts || {};
    return (0, $hcRXD.createTextStyle)(textStyleModel, null, null, opts.state !== 'normal');
}

});

parcelRegister("1CMtG", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => (parcelRequire("5BQXp")).linearMap);
$parcel$export(module.exports, "round", () => (parcelRequire("5BQXp")).round);
$parcel$export(module.exports, "asc", () => (parcelRequire("5BQXp")).asc);
$parcel$export(module.exports, "getPrecision", () => (parcelRequire("5BQXp")).getPrecision);
$parcel$export(module.exports, "getPrecisionSafe", () => (parcelRequire("5BQXp")).getPrecisionSafe);
$parcel$export(module.exports, "getPixelPrecision", () => (parcelRequire("5BQXp")).getPixelPrecision);
$parcel$export(module.exports, "getPercentWithPrecision", () => (parcelRequire("5BQXp")).getPercentWithPrecision);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => (parcelRequire("5BQXp")).MAX_SAFE_INTEGER);
$parcel$export(module.exports, "remRadian", () => (parcelRequire("5BQXp")).remRadian);
$parcel$export(module.exports, "isRadianAroundZero", () => (parcelRequire("5BQXp")).isRadianAroundZero);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("5BQXp")).parseDate);
$parcel$export(module.exports, "quantity", () => (parcelRequire("5BQXp")).quantity);
$parcel$export(module.exports, "quantityExponent", () => (parcelRequire("5BQXp")).quantityExponent);
$parcel$export(module.exports, "nice", () => (parcelRequire("5BQXp")).nice);
$parcel$export(module.exports, "quantile", () => (parcelRequire("5BQXp")).quantile);
$parcel$export(module.exports, "reformIntervals", () => (parcelRequire("5BQXp")).reformIntervals);
$parcel$export(module.exports, "isNumeric", () => (parcelRequire("5BQXp")).isNumeric);
$parcel$export(module.exports, "numericToNumber", () => (parcelRequire("5BQXp")).numericToNumber);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

});

parcelRegister("hq8bW", function(module, exports) {

$parcel$export(module.exports, "parse", () => (parcelRequire("5BQXp")).parseDate);
$parcel$export(module.exports, "format", () => (parcelRequire("24InP")).format);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

var $24InP = parcelRequire("24InP");

});

parcelRegister("eVazI", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => (parcelRequire("8q0E1")).extendShape);
$parcel$export(module.exports, "extendPath", () => (parcelRequire("8q0E1")).extendPath);
$parcel$export(module.exports, "makePath", () => (parcelRequire("8q0E1")).makePath);
$parcel$export(module.exports, "makeImage", () => (parcelRequire("8q0E1")).makeImage);
$parcel$export(module.exports, "mergePath", () => (parcelRequire("8q0E1")).mergePath);
$parcel$export(module.exports, "resizePath", () => (parcelRequire("8q0E1")).resizePath);
$parcel$export(module.exports, "createIcon", () => (parcelRequire("8q0E1")).createIcon);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("9ubot")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("9ubot")).initProps);
$parcel$export(module.exports, "getTransform", () => (parcelRequire("8q0E1")).getTransform);
$parcel$export(module.exports, "clipPointsByRect", () => (parcelRequire("8q0E1")).clipPointsByRect);
$parcel$export(module.exports, "clipRectByRect", () => (parcelRequire("8q0E1")).clipRectByRect);
$parcel$export(module.exports, "registerShape", () => (parcelRequire("8q0E1")).registerShape);
$parcel$export(module.exports, "getShapeClass", () => (parcelRequire("8q0E1")).getShapeClass);
$parcel$export(module.exports, "Group", () => (parcelRequire("hXAsm")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("agXnr")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("kiooD")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("aYBv9")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("gwELx")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("rnA7j")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("IXyXP")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("cjY1b")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("9dsiU")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("aeCKo")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("15UDR")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("6RZy2")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("iMbRE")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("4Nii9")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("juJV6")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("4kdki")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("hkgm4")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("lGSv6")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("8q0E1");
var $iMbRE = parcelRequire("iMbRE");
var $6RZy2 = parcelRequire("6RZy2");
var $aYBv9 = parcelRequire("aYBv9");
var $8q0E1 = parcelRequire("8q0E1");
var $gwELx = parcelRequire("gwELx");
var $agXnr = parcelRequire("agXnr");
var $15UDR = parcelRequire("15UDR");
var $cjY1b = parcelRequire("cjY1b");
var $9dsiU = parcelRequire("9dsiU");
var $aeCKo = parcelRequire("aeCKo");
var $IXyXP = parcelRequire("IXyXP");
var $rnA7j = parcelRequire("rnA7j");
var $9ubot = parcelRequire("9ubot");
var $lGSv6 = parcelRequire("lGSv6");
var $juJV6 = parcelRequire("juJV6");
var $hXAsm = parcelRequire("hXAsm");
var $4Nii9 = parcelRequire("4Nii9");
var $9ubot = parcelRequire("9ubot");
var $4kdki = parcelRequire("4kdki");
var $hkgm4 = parcelRequire("hkgm4");
var $kiooD = parcelRequire("kiooD");

});

parcelRegister("bYXDT", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => (parcelRequire("gyplX")).addCommas);
$parcel$export(module.exports, "toCamelCase", () => (parcelRequire("gyplX")).toCamelCase);
$parcel$export(module.exports, "normalizeCssArray", () => (parcelRequire("gyplX")).normalizeCssArray);
$parcel$export(module.exports, "encodeHTML", () => (parcelRequire("gyplX")).encodeHTML);
$parcel$export(module.exports, "formatTpl", () => (parcelRequire("gyplX")).formatTpl);
$parcel$export(module.exports, "getTooltipMarker", () => (parcelRequire("gyplX")).getTooltipMarker);
$parcel$export(module.exports, "formatTime", () => (parcelRequire("gyplX")).formatTime);
$parcel$export(module.exports, "capitalFirst", () => (parcelRequire("gyplX")).capitalFirst);
$parcel$export(module.exports, "truncateText", () => (parcelRequire("h0yya")).truncateText);
$parcel$export(module.exports, "getTextRect", () => (parcelRequire("iluMW")).getTextRect);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gyplX = parcelRequire("gyplX");
var $iluMW = parcelRequire("iluMW");
var $h0yya = parcelRequire("h0yya");

});

parcelRegister("13Qhq", function(module, exports) {

$parcel$export(module.exports, "map", () => (parcelRequire("hzBt5")).map);
$parcel$export(module.exports, "each", () => (parcelRequire("hzBt5")).each);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("hzBt5")).indexOf);
$parcel$export(module.exports, "inherits", () => (parcelRequire("hzBt5")).inherits);
$parcel$export(module.exports, "reduce", () => (parcelRequire("hzBt5")).reduce);
$parcel$export(module.exports, "filter", () => (parcelRequire("hzBt5")).filter);
$parcel$export(module.exports, "bind", () => (parcelRequire("hzBt5")).bind);
$parcel$export(module.exports, "curry", () => (parcelRequire("hzBt5")).curry);
$parcel$export(module.exports, "isArray", () => (parcelRequire("hzBt5")).isArray);
$parcel$export(module.exports, "isString", () => (parcelRequire("hzBt5")).isString);
$parcel$export(module.exports, "isObject", () => (parcelRequire("hzBt5")).isObject);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("hzBt5")).isFunction);
$parcel$export(module.exports, "extend", () => (parcelRequire("hzBt5")).extend);
$parcel$export(module.exports, "defaults", () => (parcelRequire("hzBt5")).defaults);
$parcel$export(module.exports, "clone", () => (parcelRequire("hzBt5")).clone);
$parcel$export(module.exports, "merge", () => (parcelRequire("hzBt5")).merge);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

});


parcelRegister("kM74L", function(module, exports) {

$parcel$export(module.exports, "installLabelLayout", () => $f1fdc76eb387316d$export$5320d1b3745c02a5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $989ab = parcelRequire("989ab");
var $f1fdc76eb387316d$var$getLabelManager = (0, $ckizb.makeInner)();
function $f1fdc76eb387316d$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $f1fdc76eb387316d$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $f1fdc76eb387316d$var$getLabelManager(api).labelManager = new (0, $989ab.default)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
        var labelManager = $f1fdc76eb387316d$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

});
parcelRegister("989ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a5bf80975ef2a5a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.

var $lGSv6 = parcelRequire("lGSv6");
var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");

var $aly4X = parcelRequire("aly4X");

var $5BQXp = parcelRequire("5BQXp");

var $kVlB5 = parcelRequire("kVlB5");

var $1n5dQ = parcelRequire("1n5dQ");

var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $hJQJ0 = parcelRequire("hJQJ0");

var $hcRXD = parcelRequire("hcRXD");
function $6a5bf80975ef2a5a$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $6a5bf80975ef2a5a$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $6a5bf80975ef2a5a$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $6a5bf80975ef2a5a$var$LABEL_OPTION_TO_STYLE_KEYS = [
    'align',
    'verticalAlign',
    'width',
    'height',
    'fontSize'
];
var $6a5bf80975ef2a5a$var$dummyTransformable = new (0, $kVlB5.default)();
var $6a5bf80975ef2a5a$var$labelLayoutInnerStore = (0, $ckizb.makeInner)();
var $6a5bf80975ef2a5a$var$labelLineAnimationStore = (0, $ckizb.makeInner)();
function $6a5bf80975ef2a5a$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS = [
    'x',
    'y',
    'rotation'
];
var $6a5bf80975ef2a5a$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {}; // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $lGSv6.default).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $6a5bf80975ef2a5a$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $6a5bf80975ef2a5a$var$dummyTransformable.x = $6a5bf80975ef2a5a$var$dummyTransformable.y = $6a5bf80975ef2a5a$var$dummyTransformable.rotation = $6a5bf80975ef2a5a$var$dummyTransformable.originX = $6a5bf80975ef2a5a$var$dummyTransformable.originY = 0;
            $6a5bf80975ef2a5a$var$dummyTransformable.scaleX = $6a5bf80975ef2a5a$var$dummyTransformable.scaleY = 1;
        }
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $lGSv6.default).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $6a5bf80975ef2a5a$var$dummyTransformable.x,
                y: $6a5bf80975ef2a5a$var$dummyTransformable.y,
                scaleX: $6a5bf80975ef2a5a$var$dummyTransformable.scaleX,
                scaleY: $6a5bf80975ef2a5a$var$dummyTransformable.scaleY,
                rotation: $6a5bf80975ef2a5a$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get('labelLayout');
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $hzBt5.isFunction)(layoutOption) || (0, $hzBt5.keys)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
             // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $aly4X.getECData)(child); // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $1n5dQ.updateLabelLinePoints)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0; // TODO A global layout option?
            if (typeof labelItem.layoutOption === 'function') layoutOption = labelItem.layoutOption($6a5bf80975ef2a5a$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180; // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $5BQXp.parsePercent)(layoutOption.x, width);
                label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle('x', defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $5BQXp.parsePercent)(layoutOption.y, height);
                label.setStyle('y', 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle('y', defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    }); // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $6a5bf80975ef2a5a$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $6a5bf80975ef2a5a$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $6a5bf80975ef2a5a$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = 'move';
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                }
            } else {
                // TODO Other drag functions?
                label.off('drag');
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $hJQJ0.prepareLayoutList)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $hzBt5.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftX';
        });
        var labelsNeedsAdjustOnY = (0, $hzBt5.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftY';
        });
        (0, $hJQJ0.shiftLayoutOnX)(labelsNeedsAdjustOnX, 0, width);
        (0, $hJQJ0.shiftLayoutOnY)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $hzBt5.filter)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $hJQJ0.hideOverlap)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $hzBt5.each)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $6a5bf80975ef2a5a$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent(); // Update label line style.
        var ecData = (0, $aly4X.getECData)(el);
        var dataIndex = ecData.dataIndex; // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, 'style');
            var visualType = data.getVisual('drawType'); // Default to be same with main color
            defaultStyle.stroke = visualStyle[visualType];
            var labelLineModel = itemModel.getModel('labelLine');
            (0, $1n5dQ.setLabelLineStyle)(el, (0, $1n5dQ.getLabelLineStatesModels)(itemModel), defaultStyle);
            (0, $1n5dQ.updateLabelLinePoints)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine(); // Animate
        if (textEl && !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $9ubot.isElementRemoved)(el)) {
            var layoutStore = $6a5bf80975ef2a5a$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $aly4X.getECData)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps); // Disable fade in animation if value animation is enabled.
                if (!(0, $hcRXD.labelInner)(textEl).valueAnimation) {
                    var oldOpacity = (0, $hzBt5.retrieve2)(textEl.style.opacity, 1); // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $9ubot.initProps)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout); // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $hzBt5.indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $hzBt5.indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $9ubot.updateProps)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutSelect, newProps, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutSelect, textEl.states.select, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutEmphasis, newProps, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
            }
            (0, $hcRXD.animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $6a5bf80975ef2a5a$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $9ubot.initProps)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $9ubot.updateProps)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $6a5bf80975ef2a5a$export$2e2bcd8739ae039 = $6a5bf80975ef2a5a$var$LabelManager;

});
parcelRegister("1n5dQ", function(module, exports) {

$parcel$export(module.exports, "updateLabelLinePoints", () => $0ffbfd715e97313b$export$cc93ba643cd97d83);
$parcel$export(module.exports, "limitTurnAngle", () => $0ffbfd715e97313b$export$ac52062003fbe6a);
$parcel$export(module.exports, "limitSurfaceAngle", () => $0ffbfd715e97313b$export$973e1fdb2708f71b);
$parcel$export(module.exports, "setLabelLineStyle", () => $0ffbfd715e97313b$export$c09e0b0574bdd2dc);
$parcel$export(module.exports, "getLabelLineStatesModels", () => $0ffbfd715e97313b$export$2979fdbf5ebce521);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("8q0E1");
var $hMiip = parcelRequire("hMiip");
var $9dsiU = parcelRequire("9dsiU");
var $4vVC3 = parcelRequire("4vVC3");

var $fvvgx = parcelRequire("fvvgx");

var $kqaXh = parcelRequire("kqaXh");

var $jEMPh = parcelRequire("jEMPh");

var $hzBt5 = parcelRequire("hzBt5");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $51xyq = parcelRequire("51xyq");
var $0ffbfd715e97313b$var$PI2 = Math.PI * 2;
var $0ffbfd715e97313b$var$CMD = (0, $fvvgx.default).CMD;
var $0ffbfd715e97313b$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $0ffbfd715e97313b$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $0ffbfd715e97313b$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d; // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $0ffbfd715e97313b$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kqaXh.normalizeRadian)(endAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kqaXh.normalizeRadian)(startAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $0ffbfd715e97313b$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $0ffbfd715e97313b$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $0ffbfd715e97313b$var$PI2 >= startAngle && angle + $0ffbfd715e97313b$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $0ffbfd715e97313b$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen; // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $0ffbfd715e97313b$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $0ffbfd715e97313b$var$tmpPt = [];
function $0ffbfd715e97313b$var$nearestPointOnRect(pt, rect, out) {
    var dist = $0ffbfd715e97313b$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $0ffbfd715e97313b$var$tmpPt);
    out.set($0ffbfd715e97313b$var$tmpPt[0], $0ffbfd715e97313b$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $0ffbfd715e97313b$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $0ffbfd715e97313b$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $0ffbfd715e97313b$var$CMD.L:
                d = $0ffbfd715e97313b$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $0ffbfd715e97313b$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $0ffbfd715e97313b$var$CMD.C:
                d = (0, $jEMPh.cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $0ffbfd715e97313b$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $0ffbfd715e97313b$var$CMD.Q:
                d = (0, $jEMPh.quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $0ffbfd715e97313b$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $0ffbfd715e97313b$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++]; // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $0ffbfd715e97313b$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $0ffbfd715e97313b$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $0ffbfd715e97313b$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $0ffbfd715e97313b$var$projectPointToRect(x0, y0, width, height, x, y, $0ffbfd715e97313b$var$tmpPt);
                break;
            case $0ffbfd715e97313b$var$CMD.Z:
                d = $0ffbfd715e97313b$var$projectPointToLine(xi, yi, x0, y0, x, y, $0ffbfd715e97313b$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($0ffbfd715e97313b$var$tmpPt[0], $0ffbfd715e97313b$var$tmpPt[1]);
        }
    }
    return minDist;
} // Temporal varible for intermediate usage.
var $0ffbfd715e97313b$var$pt0 = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$pt1 = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$pt2 = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$dir = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$dir2 = new (0, $4vVC3.default)();
function $0ffbfd715e97313b$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent(); // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $0ffbfd715e97313b$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $crEgd.invert)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $0ffbfd715e97313b$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $0ffbfd715e97313b$var$getCandidateAnchor(candidate, 0, labelRect, $0ffbfd715e97313b$var$pt0, $0ffbfd715e97313b$var$dir);
        (0, $4vVC3.default).scaleAndAdd($0ffbfd715e97313b$var$pt1, $0ffbfd715e97313b$var$pt0, $0ffbfd715e97313b$var$dir, len); // Transform to target coord space.
        $0ffbfd715e97313b$var$pt1.transform(targetInversedTransform); // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($0ffbfd715e97313b$var$pt1) : target instanceof (0, $hMiip.default) ? $0ffbfd715e97313b$var$nearestPointOnPath($0ffbfd715e97313b$var$pt1, target.path, $0ffbfd715e97313b$var$pt2) : $0ffbfd715e97313b$var$nearestPointOnRect($0ffbfd715e97313b$var$pt1, boundingRect, $0ffbfd715e97313b$var$pt2); // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist; // Transform back to global space.
            $0ffbfd715e97313b$var$pt1.transform(targetTransform);
            $0ffbfd715e97313b$var$pt2.transform(targetTransform);
            $0ffbfd715e97313b$var$pt2.toArray(points[0]);
            $0ffbfd715e97313b$var$pt1.toArray(points[1]);
            $0ffbfd715e97313b$var$pt0.toArray(points[2]);
        }
    }
    $0ffbfd715e97313b$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
} // Temporal variable for the limitTurnAngle function
var $0ffbfd715e97313b$var$tmpArr = [];
var $0ffbfd715e97313b$var$tmpProjPoint = new (0, $4vVC3.default)();
function $0ffbfd715e97313b$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI; // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $0ffbfd715e97313b$var$pt0.fromArray(linePoints[0]);
    $0ffbfd715e97313b$var$pt1.fromArray(linePoints[1]);
    $0ffbfd715e97313b$var$pt2.fromArray(linePoints[2]);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir, $0ffbfd715e97313b$var$pt0, $0ffbfd715e97313b$var$pt1);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir2, $0ffbfd715e97313b$var$pt2, $0ffbfd715e97313b$var$pt1);
    var len1 = $0ffbfd715e97313b$var$dir.len();
    var len2 = $0ffbfd715e97313b$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $0ffbfd715e97313b$var$dir.scale(1 / len1);
    $0ffbfd715e97313b$var$dir2.scale(1 / len2);
    var angleCos = $0ffbfd715e97313b$var$dir.dot($0ffbfd715e97313b$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $0ffbfd715e97313b$var$projectPointToLine($0ffbfd715e97313b$var$pt1.x, $0ffbfd715e97313b$var$pt1.y, $0ffbfd715e97313b$var$pt2.x, $0ffbfd715e97313b$var$pt2.y, $0ffbfd715e97313b$var$pt0.x, $0ffbfd715e97313b$var$pt0.y, $0ffbfd715e97313b$var$tmpArr, false);
        $0ffbfd715e97313b$var$tmpProjPoint.fromArray($0ffbfd715e97313b$var$tmpArr); // Calculate new projected length with limited minTurnAngle and get the new connect point
        $0ffbfd715e97313b$var$tmpProjPoint.scaleAndAdd($0ffbfd715e97313b$var$dir2, d / Math.tan(Math.PI - minTurnAngle)); // Limit the new calculated connect point between pt1 and pt2.
        var t = $0ffbfd715e97313b$var$pt2.x !== $0ffbfd715e97313b$var$pt1.x ? ($0ffbfd715e97313b$var$tmpProjPoint.x - $0ffbfd715e97313b$var$pt1.x) / ($0ffbfd715e97313b$var$pt2.x - $0ffbfd715e97313b$var$pt1.x) : ($0ffbfd715e97313b$var$tmpProjPoint.y - $0ffbfd715e97313b$var$pt1.y) / ($0ffbfd715e97313b$var$pt2.y - $0ffbfd715e97313b$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt1);
        else if (t > 1) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt2);
        $0ffbfd715e97313b$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $0ffbfd715e97313b$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $0ffbfd715e97313b$var$pt0.fromArray(linePoints[0]);
    $0ffbfd715e97313b$var$pt1.fromArray(linePoints[1]);
    $0ffbfd715e97313b$var$pt2.fromArray(linePoints[2]);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir, $0ffbfd715e97313b$var$pt1, $0ffbfd715e97313b$var$pt0);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir2, $0ffbfd715e97313b$var$pt2, $0ffbfd715e97313b$var$pt1);
    var len1 = $0ffbfd715e97313b$var$dir.len();
    var len2 = $0ffbfd715e97313b$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $0ffbfd715e97313b$var$dir.scale(1 / len1);
    $0ffbfd715e97313b$var$dir2.scale(1 / len2);
    var angleCos = $0ffbfd715e97313b$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $0ffbfd715e97313b$var$projectPointToLine($0ffbfd715e97313b$var$pt1.x, $0ffbfd715e97313b$var$pt1.y, $0ffbfd715e97313b$var$pt2.x, $0ffbfd715e97313b$var$pt2.y, $0ffbfd715e97313b$var$pt0.x, $0ffbfd715e97313b$var$pt0.y, $0ffbfd715e97313b$var$tmpArr, false);
        $0ffbfd715e97313b$var$tmpProjPoint.fromArray($0ffbfd715e97313b$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($0ffbfd715e97313b$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $0ffbfd715e97313b$var$tmpProjPoint.scaleAndAdd($0ffbfd715e97313b$var$dir2, d / Math.tan(Math.PI / 2 - newAngle)); // Limit the new calculated connect point between pt1 and pt2.
            var t = $0ffbfd715e97313b$var$pt2.x !== $0ffbfd715e97313b$var$pt1.x ? ($0ffbfd715e97313b$var$tmpProjPoint.x - $0ffbfd715e97313b$var$pt1.x) / ($0ffbfd715e97313b$var$pt2.x - $0ffbfd715e97313b$var$pt1.x) : ($0ffbfd715e97313b$var$tmpProjPoint.y - $0ffbfd715e97313b$var$pt1.y) / ($0ffbfd715e97313b$var$pt2.y - $0ffbfd715e97313b$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt1);
            else if (t > 1) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt2);
        }
        $0ffbfd715e97313b$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $0ffbfd715e97313b$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName); // Make sure display.
    stateObj.ignore = ignore; // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $0ffbfd715e97313b$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $ef5pP.dist(points[0], points[1]);
        var len2 = $ef5pP.dist(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $ef5pP.lerp([], points[1], points[0], moveLen / len1);
        var midPoint2 = $ef5pP.lerp([], points[1], points[2], moveLen / len2);
        var midPoint1 = $ef5pP.lerp([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $0ffbfd715e97313b$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $51xyq.DISPLAY_STATES).length; i++){
        var stateName = (0, $51xyq.DISPLAY_STATES)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $hzBt5.retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $hzBt5.retrieve2)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states.normal;
                if (stateObj) stateObj.ignore = true;
                continue;
            } // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $9dsiU.default)();
                targetEl.setTextGuideLine(labelLine); // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $0ffbfd715e97313b$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                 // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $0ffbfd715e97313b$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $hzBt5.defaults)(labelLine.style, defaultStyle); // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false; // Custom the buildPath.
        labelLine.buildPath = $0ffbfd715e97313b$var$buildLabelLinePath;
    }
}
function $0ffbfd715e97313b$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}

});





parcelRegister("63e1b", function(module, exports) {

$parcel$export(module.exports, "install", () => $467de59415ed5bb4$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $k5FG2 = parcelRequire("k5FG2");
function $467de59415ed5bb4$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $k5FG2.default));
}

});
parcelRegister("k5FG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea049a792f5a4e69$export$2e2bcd8739ae039);

var $jbiHB = parcelRequire("jbiHB");

var $hzBt5 = parcelRequire("hzBt5");

var $hMiip = parcelRequire("hMiip");

var $agXnr = parcelRequire("agXnr");

var $lm58d = parcelRequire("lm58d");

var $6pXHh = parcelRequire("6pXHh");

var $13Oy0 = parcelRequire("13Oy0");

var $dRKn1 = parcelRequire("dRKn1");

var $1g23U = parcelRequire("1g23U");

var $6rGIT = parcelRequire("6rGIT");

var $6hD7t = parcelRequire("6hD7t");
function $ea049a792f5a4e69$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $ea049a792f5a4e69$var$getSvgProxy(el) {
    if (el instanceof (0, $hMiip.default)) return 0, $6hD7t.path;
    else if (el instanceof (0, $agXnr.default)) return 0, $6hD7t.image;
    else if (el instanceof (0, $lm58d.default)) return 0, $6hD7t.text;
    else return 0, $6hD7t.path;
}
function $ea049a792f5a4e69$var$checkParentAvailable(parent, child) {
    return child && parent && child.parentNode !== parent;
}
function $ea049a792f5a4e69$var$insertAfter(parent, child, prevSibling) {
    if ($ea049a792f5a4e69$var$checkParentAvailable(parent, child) && prevSibling) {
        var nextSibling = prevSibling.nextSibling;
        nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
    }
}
function $ea049a792f5a4e69$var$prepend(parent, child) {
    if ($ea049a792f5a4e69$var$checkParentAvailable(parent, child)) {
        var firstChild = parent.firstChild;
        firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
    }
}
function $ea049a792f5a4e69$var$remove(parent, child) {
    if (child && parent && child.parentNode === parent) parent.removeChild(child);
}
function $ea049a792f5a4e69$var$removeFromMyParent(child) {
    if (child && child.parentNode) child.parentNode.removeChild(child);
}
function $ea049a792f5a4e69$var$getSvgElement(displayable) {
    return displayable.__svgEl;
}
var $ea049a792f5a4e69$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts, zrId) {
        this.type = 'svg';
        this.refreshHover = $ea049a792f5a4e69$var$createMethodNotSupport('refreshHover');
        this.pathToImage = $ea049a792f5a4e69$var$createMethodNotSupport('pathToImage');
        this.configLayer = $ea049a792f5a4e69$var$createMethodNotSupport('configLayer');
        this.root = root;
        this.storage = storage;
        this._opts = opts = $hzBt5.extend({}, opts || {});
        var svgDom = (0, $jbiHB.createElement)('svg');
        svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', 'http://www.w3.org/2000/svg');
        svgDom.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', 'http://www.w3.org/1999/xlink');
        svgDom.setAttribute('version', '1.1');
        svgDom.setAttribute('baseProfile', 'full');
        svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
        var bgRoot = (0, $jbiHB.createElement)('g');
        svgDom.appendChild(bgRoot);
        var svgRoot = (0, $jbiHB.createElement)('g');
        svgDom.appendChild(svgRoot);
        this._gradientManager = new (0, $13Oy0.default)(zrId, svgRoot);
        this._patternManager = new (0, $dRKn1.default)(zrId, svgRoot);
        this._clipPathManager = new (0, $1g23U.default)(zrId, svgRoot);
        this._shadowManager = new (0, $6rGIT.default)(zrId, svgRoot);
        var viewport = document.createElement('div');
        viewport.style.cssText = 'overflow:hidden;position:relative';
        this._svgDom = svgDom;
        this._svgRoot = svgRoot;
        this._backgroundRoot = bgRoot;
        this._viewport = viewport;
        root.appendChild(viewport);
        viewport.appendChild(svgDom);
        this.resize(opts.width, opts.height);
        this._visibleList = [];
    }
    SVGPainter.prototype.getType = function() {
        return 'svg';
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._svgRoot;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.refresh = function() {
        var list = this.storage.getDisplayList(true);
        this._paintList(list);
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._backgroundRoot && this._backgroundNode) this._backgroundRoot.removeChild(this._backgroundNode);
        var bgNode = (0, $jbiHB.createElement)('rect');
        bgNode.setAttribute('width', this.getWidth());
        bgNode.setAttribute('height', this.getHeight());
        bgNode.setAttribute('x', 0);
        bgNode.setAttribute('y', 0);
        bgNode.setAttribute('id', 0);
        var _a = (0, $jbiHB.normalizeColor)(backgroundColor), color = _a.color, opacity = _a.opacity;
        bgNode.setAttribute('fill', color);
        bgNode.setAttribute('fill-opacity', opacity);
        this._backgroundRoot.appendChild(bgNode);
        this._backgroundNode = bgNode;
    };
    SVGPainter.prototype.createSVGElement = function(tag) {
        return (0, $jbiHB.createElement)(tag);
    };
    SVGPainter.prototype.paintOne = function(el) {
        var svgProxy = $ea049a792f5a4e69$var$getSvgProxy(el);
        svgProxy && svgProxy.brush(el);
        return $ea049a792f5a4e69$var$getSvgElement(el);
    };
    SVGPainter.prototype._paintList = function(list) {
        var gradientManager = this._gradientManager;
        var patternManager = this._patternManager;
        var clipPathManager = this._clipPathManager;
        var shadowManager = this._shadowManager;
        gradientManager.markAllUnused();
        patternManager.markAllUnused();
        clipPathManager.markAllUnused();
        shadowManager.markAllUnused();
        var svgRoot = this._svgRoot;
        var visibleList = this._visibleList;
        var listLen = list.length;
        var newVisibleList = [];
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            var svgProxy = $ea049a792f5a4e69$var$getSvgProxy(displayable);
            var svgElement = $ea049a792f5a4e69$var$getSvgElement(displayable);
            if (!displayable.invisible) {
                if (displayable.__dirty || !svgElement) {
                    svgProxy && svgProxy.brush(displayable);
                    svgElement = $ea049a792f5a4e69$var$getSvgElement(displayable);
                    if (svgElement && displayable.style) {
                        gradientManager.update(displayable.style.fill);
                        gradientManager.update(displayable.style.stroke);
                        patternManager.update(displayable.style.fill);
                        patternManager.update(displayable.style.stroke);
                        shadowManager.update(svgElement, displayable);
                    }
                    displayable.__dirty = 0;
                }
                if (svgElement) newVisibleList.push(displayable);
            }
        }
        var diff = (0, $6pXHh.default)(visibleList, newVisibleList);
        var prevSvgElement;
        var topPrevSvgElement;
        for(var i = 0; i < diff.length; i++){
            var item = diff[i];
            if (item.removed) for(var k = 0; k < item.count; k++){
                var displayable = visibleList[item.indices[k]];
                var svgElement = $ea049a792f5a4e69$var$getSvgElement(displayable);
                (0, $1g23U.hasClipPath)(displayable) ? $ea049a792f5a4e69$var$removeFromMyParent(svgElement) : $ea049a792f5a4e69$var$remove(svgRoot, svgElement);
            }
        }
        var prevDisplayable;
        var currentClipGroup;
        for(var i = 0; i < diff.length; i++){
            var item = diff[i];
            if (item.removed) continue;
            for(var k = 0; k < item.count; k++){
                var displayable = newVisibleList[item.indices[k]];
                var clipGroup = clipPathManager.update(displayable, prevDisplayable);
                if (clipGroup !== currentClipGroup) {
                    prevSvgElement = topPrevSvgElement;
                    if (clipGroup) {
                        prevSvgElement ? $ea049a792f5a4e69$var$insertAfter(svgRoot, clipGroup, prevSvgElement) : $ea049a792f5a4e69$var$prepend(svgRoot, clipGroup);
                        topPrevSvgElement = clipGroup;
                        prevSvgElement = null;
                    }
                    currentClipGroup = clipGroup;
                }
                var svgElement = $ea049a792f5a4e69$var$getSvgElement(displayable);
                prevSvgElement ? $ea049a792f5a4e69$var$insertAfter(currentClipGroup || svgRoot, svgElement, prevSvgElement) : $ea049a792f5a4e69$var$prepend(currentClipGroup || svgRoot, svgElement);
                prevSvgElement = svgElement || prevSvgElement;
                if (!currentClipGroup) topPrevSvgElement = prevSvgElement;
                gradientManager.markUsed(displayable);
                gradientManager.addWithoutUpdate(svgElement, displayable);
                patternManager.markUsed(displayable);
                patternManager.addWithoutUpdate(svgElement, displayable);
                clipPathManager.markUsed(displayable);
                prevDisplayable = displayable;
            }
        }
        gradientManager.removeUnused();
        patternManager.removeUnused();
        clipPathManager.removeUnused();
        shadowManager.removeUnused();
        this._visibleList = newVisibleList;
    };
    SVGPainter.prototype.resize = function(width, height) {
        var viewport = this._viewport;
        viewport.style.display = 'none';
        var opts = this._opts;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        width = this._getSize(0);
        height = this._getSize(1);
        viewport.style.display = '';
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            var viewportStyle = viewport.style;
            viewportStyle.width = width + 'px';
            viewportStyle.height = height + 'px';
            var svgRoot = this._svgDom;
            svgRoot.setAttribute('width', width + '');
            svgRoot.setAttribute('height', height + '');
        }
        if (this._backgroundNode) {
            this._backgroundNode.setAttribute('width', width);
            this._backgroundNode.setAttribute('height', height);
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype._getSize = function(whIdx) {
        var opts = this._opts;
        var wh = [
            'width',
            'height'
        ][whIdx];
        var cwh = [
            'clientWidth',
            'clientHeight'
        ][whIdx];
        var plt = [
            'paddingLeft',
            'paddingTop'
        ][whIdx];
        var prb = [
            'paddingRight',
            'paddingBottom'
        ][whIdx];
        if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
        var root = this.root;
        var stl = document.defaultView.getComputedStyle(root);
        return (root[cwh] || $ea049a792f5a4e69$var$parseInt10(stl[wh]) || $ea049a792f5a4e69$var$parseInt10(root.style[wh])) - ($ea049a792f5a4e69$var$parseInt10(stl[plt]) || 0) - ($ea049a792f5a4e69$var$parseInt10(stl[prb]) || 0) | 0;
    };
    SVGPainter.prototype.dispose = function() {
        this.root.innerHTML = '';
        this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
    };
    SVGPainter.prototype.clear = function() {
        var viewportNode = this._viewport;
        if (viewportNode && viewportNode.parentNode) viewportNode.parentNode.removeChild(viewportNode);
    };
    SVGPainter.prototype.toDataURL = function() {
        this.refresh();
        var svgDom = this._svgDom;
        var outerHTML = svgDom.outerHTML || (svgDom.parentNode && svgDom.parentNode).innerHTML;
        var html = encodeURIComponent(outerHTML.replace(/></g, '>\n\r<'));
        return 'data:image/svg+xml;charset=UTF-8,' + html;
    };
    return SVGPainter;
}();
function $ea049a792f5a4e69$var$createMethodNotSupport(method) {
    return function() {
        $hzBt5.logError('In SVG mode painter not support method "' + method + '"');
    };
}
var $ea049a792f5a4e69$export$2e2bcd8739ae039 = $ea049a792f5a4e69$var$SVGPainter;

});
parcelRegister("jbiHB", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $df6d8d4c93c544d4$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "normalizeColor", () => $df6d8d4c93c544d4$export$4cde5df63f53f473);

var $f7lrR = parcelRequire("f7lrR");
function $df6d8d4c93c544d4$export$c8a8987d4410bf2d(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}
function $df6d8d4c93c544d4$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $f7lrR.parse)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}

});

parcelRegister("6pXHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac36277839b4318$export$2e2bcd8739ae039);
function $4ac36277839b4318$var$diff(oldArr, newArr, equals) {
    if (!equals) equals = function(a, b) {
        return a === b;
    };
    oldArr = oldArr.slice();
    newArr = newArr.slice();
    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var editLength = 1;
    var maxEditLength = newLen + oldLen;
    var bestPath = [
        {
            newPos: -1,
            components: []
        }
    ];
    var oldPos = $4ac36277839b4318$var$extractCommon(bestPath[0], newArr, oldArr, 0, equals);
    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
        var indices = [];
        for(var i = 0; i < newArr.length; i++)indices.push(i);
        return [
            {
                indices: indices,
                count: newArr.length,
                added: false,
                removed: false
            }
        ];
    }
    function execEditLength() {
        for(var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2){
            var basePath;
            var addPath = bestPath[diagonalPath - 1];
            var removePath = bestPath[diagonalPath + 1];
            var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
            if (addPath) bestPath[diagonalPath - 1] = undefined;
            var canAdd = addPath && addPath.newPos + 1 < newLen;
            var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
            if (!canAdd && !canRemove) {
                bestPath[diagonalPath] = undefined;
                continue;
            }
            if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
                basePath = $4ac36277839b4318$var$clonePath(removePath);
                $4ac36277839b4318$var$pushComponent(basePath.components, false, true);
            } else {
                basePath = addPath;
                basePath.newPos++;
                $4ac36277839b4318$var$pushComponent(basePath.components, true, false);
            }
            oldPos = $4ac36277839b4318$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals);
            if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) return $4ac36277839b4318$var$buildValues(basePath.components);
            else bestPath[diagonalPath] = basePath;
        }
        editLength++;
    }
    while(editLength <= maxEditLength){
        var ret = execEditLength();
        if (ret) return ret;
    }
}
function $4ac36277839b4318$var$extractCommon(basePath, newArr, oldArr, diagonalPath, equals) {
    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var newPos = basePath.newPos;
    var oldPos = newPos - diagonalPath;
    var commonCount = 0;
    while(newPos + 1 < newLen && oldPos + 1 < oldLen && equals(newArr[newPos + 1], oldArr[oldPos + 1])){
        newPos++;
        oldPos++;
        commonCount++;
    }
    if (commonCount) basePath.components.push({
        count: commonCount,
        added: false,
        removed: false,
        indices: []
    });
    basePath.newPos = newPos;
    return oldPos;
}
function $4ac36277839b4318$var$pushComponent(components, added, removed) {
    var last = components[components.length - 1];
    if (last && last.added === added && last.removed === removed) components[components.length - 1] = {
        count: last.count + 1,
        added: added,
        removed: removed,
        indices: []
    };
    else components.push({
        count: 1,
        added: added,
        removed: removed,
        indices: []
    });
}
function $4ac36277839b4318$var$buildValues(components) {
    var componentPos = 0;
    var componentLen = components.length;
    var newPos = 0;
    var oldPos = 0;
    for(; componentPos < componentLen; componentPos++){
        var component = components[componentPos];
        if (!component.removed) {
            var indices = [];
            for(var i = newPos; i < newPos + component.count; i++)indices.push(i);
            component.indices = indices;
            newPos += component.count;
            if (!component.added) oldPos += component.count;
        } else {
            for(var i = oldPos; i < oldPos + component.count; i++)component.indices.push(i);
            oldPos += component.count;
        }
    }
    return components;
}
function $4ac36277839b4318$var$clonePath(path) {
    return {
        newPos: path.newPos,
        components: path.components.slice(0)
    };
}
function $4ac36277839b4318$export$2e2bcd8739ae039(oldArr, newArr, equal) {
    return $4ac36277839b4318$var$diff(oldArr, newArr, equal);
}

});

parcelRegister("13Oy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5d47f59dc60f40$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $eXlKT = parcelRequire("eXlKT");

var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");
function $0c5d47f59dc60f40$var$isLinearGradient(value) {
    return value.type === 'linear';
}
function $0c5d47f59dc60f40$var$isRadialGradient(value) {
    return value.type === 'radial';
}
function $0c5d47f59dc60f40$var$isGradient(value) {
    return value && (value.type === 'linear' || value.type === 'radial');
}
var $0c5d47f59dc60f40$var$GradientManager = function(_super) {
    (0, $fKE23.__extends)(GradientManager, _super);
    function GradientManager(zrId, svgRoot) {
        return _super.call(this, zrId, svgRoot, [
            'linearGradient',
            'radialGradient'
        ], '__gradient_in_use__') || this;
    }
    GradientManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
        if (displayable && displayable.style) {
            var that_1 = this;
            $hzBt5.each([
                'fill',
                'stroke'
            ], function(fillOrStroke) {
                var value = displayable.style[fillOrStroke];
                if ($0c5d47f59dc60f40$var$isGradient(value)) {
                    var gradient = value;
                    var defs = that_1.getDefs(true);
                    var dom = void 0;
                    if (gradient.__dom) {
                        dom = gradient.__dom;
                        if (!defs.contains(gradient.__dom)) that_1.addDom(dom);
                    } else dom = that_1.add(gradient);
                    that_1.markUsed(displayable);
                    var id = dom.getAttribute('id');
                    svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                }
            });
        }
    };
    GradientManager.prototype.add = function(gradient) {
        var dom;
        if ($0c5d47f59dc60f40$var$isLinearGradient(gradient)) dom = this.createElement('linearGradient');
        else if ($0c5d47f59dc60f40$var$isRadialGradient(gradient)) dom = this.createElement('radialGradient');
        else {
            $hzBt5.logError('Illegal gradient type.');
            return null;
        }
        gradient.id = gradient.id || this.nextId++;
        dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
        this.updateDom(gradient, dom);
        this.addDom(dom);
        return dom;
    };
    GradientManager.prototype.update = function(gradient) {
        if (!$0c5d47f59dc60f40$var$isGradient(gradient)) return;
        var that = this;
        this.doUpdate(gradient, function() {
            var dom = gradient.__dom;
            if (!dom) return;
            var tagName = dom.tagName;
            var type = gradient.type;
            if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') that.updateDom(gradient, gradient.__dom);
            else {
                that.removeDom(gradient);
                that.add(gradient);
            }
        });
    };
    GradientManager.prototype.updateDom = function(gradient, dom) {
        if ($0c5d47f59dc60f40$var$isLinearGradient(gradient)) {
            dom.setAttribute('x1', gradient.x + '');
            dom.setAttribute('y1', gradient.y + '');
            dom.setAttribute('x2', gradient.x2 + '');
            dom.setAttribute('y2', gradient.y2 + '');
        } else if ($0c5d47f59dc60f40$var$isRadialGradient(gradient)) {
            dom.setAttribute('cx', gradient.x + '');
            dom.setAttribute('cy', gradient.y + '');
            dom.setAttribute('r', gradient.r + '');
        } else {
            $hzBt5.logError('Illegal gradient type.');
            return;
        }
        if (gradient.global) dom.setAttribute('gradientUnits', 'userSpaceOnUse');
        else dom.setAttribute('gradientUnits', 'objectBoundingBox');
        dom.innerHTML = '';
        var colors = gradient.colorStops;
        for(var i = 0, len = colors.length; i < len; ++i){
            var stop_1 = this.createElement('stop');
            stop_1.setAttribute('offset', colors[i].offset * 100 + '%');
            var color = colors[i].color;
            if (color.indexOf('rgba') > -1) {
                var opacity = $f7lrR.parse(color)[3];
                var hex = $f7lrR.toHex(color);
                stop_1.setAttribute('stop-color', '#' + hex);
                stop_1.setAttribute('stop-opacity', opacity + '');
            } else stop_1.setAttribute('stop-color', colors[i].color);
            dom.appendChild(stop_1);
        }
        gradient.__dom = dom;
    };
    GradientManager.prototype.markUsed = function(displayable) {
        if (displayable.style) {
            var gradient = displayable.style.fill;
            if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
            gradient = displayable.style.stroke;
            if (gradient && gradient.__dom) _super.prototype.markDomUsed.call(this, gradient.__dom);
        }
    };
    return GradientManager;
}((0, $eXlKT.default));
var $0c5d47f59dc60f40$export$2e2bcd8739ae039 = $0c5d47f59dc60f40$var$GradientManager;

});
parcelRegister("eXlKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae37738e60423a29$export$2e2bcd8739ae039);

var $jbiHB = parcelRequire("jbiHB");

var $hzBt5 = parcelRequire("hzBt5");

var $hMiip = parcelRequire("hMiip");

var $agXnr = parcelRequire("agXnr");

var $lm58d = parcelRequire("lm58d");

var $6hD7t = parcelRequire("6hD7t");
var $ae37738e60423a29$var$MARK_UNUSED = '0';
var $ae37738e60423a29$var$MARK_USED = '1';
var $ae37738e60423a29$var$Definable = function() {
    function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
        this.nextId = 0;
        this._domName = '_dom';
        this.createElement = (0, $jbiHB.createElement);
        this._zrId = zrId;
        this._svgRoot = svgRoot;
        this._tagNames = typeof tagNames === 'string' ? [
            tagNames
        ] : tagNames;
        this._markLabel = markLabel;
        if (domName) this._domName = domName;
    }
    Definable.prototype.getDefs = function(isForceCreating) {
        var svgRoot = this._svgRoot;
        var defs = this._svgRoot.getElementsByTagName('defs');
        if (defs.length === 0) {
            if (isForceCreating) {
                var defs_1 = svgRoot.insertBefore(this.createElement('defs'), svgRoot.firstChild);
                if (!defs_1.contains) defs_1.contains = function(el) {
                    var children = defs_1.children;
                    if (!children) return false;
                    for(var i = children.length - 1; i >= 0; --i){
                        if (children[i] === el) return true;
                    }
                    return false;
                };
                return defs_1;
            } else return null;
        } else return defs[0];
    };
    Definable.prototype.doUpdate = function(target, onUpdate) {
        if (!target) return;
        var defs = this.getDefs(false);
        if (target[this._domName] && defs.contains(target[this._domName])) {
            if (typeof onUpdate === 'function') onUpdate(target);
        } else {
            var dom = this.add(target);
            if (dom) target[this._domName] = dom;
        }
    };
    Definable.prototype.add = function(target) {
        return null;
    };
    Definable.prototype.addDom = function(dom) {
        var defs = this.getDefs(true);
        if (dom.parentNode !== defs) defs.appendChild(dom);
    };
    Definable.prototype.removeDom = function(target) {
        var defs = this.getDefs(false);
        if (defs && target[this._domName]) {
            defs.removeChild(target[this._domName]);
            target[this._domName] = null;
        }
    };
    Definable.prototype.getDoms = function() {
        var defs = this.getDefs(false);
        if (!defs) return [];
        var doms = [];
        $hzBt5.each(this._tagNames, function(tagName) {
            var tags = defs.getElementsByTagName(tagName);
            for(var i = 0; i < tags.length; i++)doms.push(tags[i]);
        });
        return doms;
    };
    Definable.prototype.markAllUnused = function() {
        var doms = this.getDoms();
        var that = this;
        $hzBt5.each(doms, function(dom) {
            dom[that._markLabel] = $ae37738e60423a29$var$MARK_UNUSED;
        });
    };
    Definable.prototype.markDomUsed = function(dom) {
        dom && (dom[this._markLabel] = $ae37738e60423a29$var$MARK_USED);
    };
    Definable.prototype.markDomUnused = function(dom) {
        dom && (dom[this._markLabel] = $ae37738e60423a29$var$MARK_UNUSED);
    };
    Definable.prototype.isDomUnused = function(dom) {
        return dom && dom[this._markLabel] !== $ae37738e60423a29$var$MARK_USED;
    };
    Definable.prototype.removeUnused = function() {
        var _this = this;
        var defs = this.getDefs(false);
        if (!defs) return;
        var doms = this.getDoms();
        $hzBt5.each(doms, function(dom) {
            if (_this.isDomUnused(dom)) defs.removeChild(dom);
        });
    };
    Definable.prototype.getSvgProxy = function(displayable) {
        if (displayable instanceof (0, $hMiip.default)) return 0, $6hD7t.path;
        else if (displayable instanceof (0, $agXnr.default)) return 0, $6hD7t.image;
        else if (displayable instanceof (0, $lm58d.default)) return 0, $6hD7t.text;
        else return 0, $6hD7t.path;
    };
    Definable.prototype.getSvgElement = function(displayable) {
        return displayable.__svgEl;
    };
    return Definable;
}();
var $ae37738e60423a29$export$2e2bcd8739ae039 = $ae37738e60423a29$var$Definable;

});
parcelRegister("6hD7t", function(module, exports) {

$parcel$export(module.exports, "path", () => $4932acea05f0a056$export$bb654e07daaf8c3a);
$parcel$export(module.exports, "image", () => $4932acea05f0a056$export$5c452ff88e35e47d);
$parcel$export(module.exports, "text", () => $4932acea05f0a056$export$6f093cfa640b7166);

var $jbiHB = parcelRequire("jbiHB");

var $agXnr = parcelRequire("agXnr");

var $02NbV = parcelRequire("02NbV");

var $hzBt5 = parcelRequire("hzBt5");

var $jJSZho = parcelRequire("jJSZho");
var $4932acea05f0a056$var$NONE = 'none';
var $4932acea05f0a056$var$mathRound = Math.round;
var $4932acea05f0a056$var$mathSin = Math.sin;
var $4932acea05f0a056$var$mathCos = Math.cos;
var $4932acea05f0a056$var$PI = Math.PI;
var $4932acea05f0a056$var$PI2 = Math.PI * 2;
var $4932acea05f0a056$var$degree = 180 / $4932acea05f0a056$var$PI;
var $4932acea05f0a056$var$EPSILON = 1e-4;
function $4932acea05f0a056$var$round3(val) {
    return $4932acea05f0a056$var$mathRound(val * 1e3) / 1e3;
}
function $4932acea05f0a056$var$round4(val) {
    return $4932acea05f0a056$var$mathRound(val * 1e4) / 1e4;
}
function $4932acea05f0a056$var$isAroundZero(val) {
    return val < $4932acea05f0a056$var$EPSILON && val > -$4932acea05f0a056$var$EPSILON;
}
function $4932acea05f0a056$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $4932acea05f0a056$var$NONE;
}
function $4932acea05f0a056$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $4932acea05f0a056$var$NONE;
}
function $4932acea05f0a056$var$setTransform(svgEl, m) {
    if (m) $4932acea05f0a056$var$attr(svgEl, 'transform', 'matrix(' + $4932acea05f0a056$var$round3(m[0]) + ',' + $4932acea05f0a056$var$round3(m[1]) + ',' + $4932acea05f0a056$var$round3(m[2]) + ',' + $4932acea05f0a056$var$round3(m[3]) + ',' + $4932acea05f0a056$var$round4(m[4]) + ',' + $4932acea05f0a056$var$round4(m[5]) + ')');
}
function $4932acea05f0a056$var$attr(el, key, val) {
    if (!val || val.type !== 'linear' && val.type !== 'radial') el.setAttribute(key, val);
}
function $4932acea05f0a056$var$attrXLink(el, key, val) {
    el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
}
function $4932acea05f0a056$var$attrXML(el, key, val) {
    el.setAttributeNS('http://www.w3.org/XML/1998/namespace', key, val);
}
function $4932acea05f0a056$var$bindStyle(svgEl, style, el) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $agXnr.default)) {
        $4932acea05f0a056$var$attr(svgEl, 'opacity', opacity + '');
        return;
    }
    if ($4932acea05f0a056$var$pathHasFill(style)) {
        var fill = (0, $jbiHB.normalizeColor)(style.fill);
        $4932acea05f0a056$var$attr(svgEl, 'fill', fill.color);
        $4932acea05f0a056$var$attr(svgEl, 'fill-opacity', (style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity) + '');
    } else $4932acea05f0a056$var$attr(svgEl, 'fill', $4932acea05f0a056$var$NONE);
    if ($4932acea05f0a056$var$pathHasStroke(style)) {
        var stroke = (0, $jbiHB.normalizeColor)(style.stroke);
        $4932acea05f0a056$var$attr(svgEl, 'stroke', stroke.color);
        var strokeWidth = style.lineWidth;
        var strokeScale_1 = style.strokeNoScale ? el.getLineScale() : 1;
        $4932acea05f0a056$var$attr(svgEl, 'stroke-width', (strokeScale_1 ? strokeWidth / strokeScale_1 : 0) + '');
        $4932acea05f0a056$var$attr(svgEl, 'paint-order', style.strokeFirst ? 'stroke' : 'fill');
        $4932acea05f0a056$var$attr(svgEl, 'stroke-opacity', (style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity) + '');
        var lineDash = style.lineDash && strokeWidth > 0 && (0, $jJSZho.normalizeLineDash)(style.lineDash, strokeWidth);
        if (lineDash) {
            var lineDashOffset = style.lineDashOffset;
            if (strokeScale_1 && strokeScale_1 !== 1) {
                lineDash = (0, $hzBt5.map)(lineDash, function(rawVal) {
                    return rawVal / strokeScale_1;
                });
                if (lineDashOffset) {
                    lineDashOffset /= strokeScale_1;
                    lineDashOffset = $4932acea05f0a056$var$mathRound(lineDashOffset);
                }
            }
            $4932acea05f0a056$var$attr(svgEl, 'stroke-dasharray', lineDash.join(','));
            $4932acea05f0a056$var$attr(svgEl, 'stroke-dashoffset', (lineDashOffset || 0) + '');
        } else $4932acea05f0a056$var$attr(svgEl, 'stroke-dasharray', $4932acea05f0a056$var$NONE);
        style.lineCap && $4932acea05f0a056$var$attr(svgEl, 'stroke-linecap', style.lineCap);
        style.lineJoin && $4932acea05f0a056$var$attr(svgEl, 'stroke-linejoin', style.lineJoin);
        style.miterLimit && $4932acea05f0a056$var$attr(svgEl, 'stroke-miterlimit', style.miterLimit + '');
    } else $4932acea05f0a056$var$attr(svgEl, 'stroke', $4932acea05f0a056$var$NONE);
}
var $4932acea05f0a056$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function() {
        this._d = [];
        this._str = '';
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var firstCmd = this._d.length === 0;
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = $4932acea05f0a056$var$isAroundZero(dThetaPositive - $4932acea05f0a056$var$PI2) || (clockwise ? dTheta >= $4932acea05f0a056$var$PI2 : -dTheta >= $4932acea05f0a056$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $4932acea05f0a056$var$PI2 : dTheta % $4932acea05f0a056$var$PI2 + $4932acea05f0a056$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ($4932acea05f0a056$var$isAroundZero(dThetaPositive)) large = false;
        else large = unifiedTheta >= $4932acea05f0a056$var$PI === !!clockwise;
        var x0 = $4932acea05f0a056$var$round4(cx + rx * $4932acea05f0a056$var$mathCos(startAngle));
        var y0 = $4932acea05f0a056$var$round4(cy + ry * $4932acea05f0a056$var$mathSin(startAngle));
        if (isCircle) {
            if (clockwise) dTheta = $4932acea05f0a056$var$PI2 - 1e-4;
            else dTheta = -$4932acea05f0a056$var$PI2 + 1e-4;
            large = true;
            if (firstCmd) this._d.push('M', x0, y0);
        }
        var x = $4932acea05f0a056$var$round4(cx + rx * $4932acea05f0a056$var$mathCos(startAngle + dTheta));
        var y = $4932acea05f0a056$var$round4(cy + ry * $4932acea05f0a056$var$mathSin(startAngle + dTheta));
        if (isNaN(x0) || isNaN(y0) || isNaN(rx) || isNaN(ry) || isNaN(psi) || isNaN($4932acea05f0a056$var$degree) || isNaN(x) || isNaN(y)) return '';
        this._d.push('A', $4932acea05f0a056$var$round4(rx), $4932acea05f0a056$var$round4(ry), $4932acea05f0a056$var$mathRound(psi * $4932acea05f0a056$var$degree), +large, +clockwise, x, y);
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('L', x + w, y);
        this._add('L', x + w, y + h);
        this._add('L', x, y + h);
        this._add('L', x, y);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        this._d.push(cmd);
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            this._d.push($4932acea05f0a056$var$round4(val));
        }
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join(' ');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $4932acea05f0a056$export$bb654e07daaf8c3a = {
    brush: function(el) {
        var style = el.style;
        var svgEl = el.__svgEl;
        if (!svgEl) {
            svgEl = (0, $jbiHB.createElement)('path');
            el.__svgEl = svgEl;
        }
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (el.shapeChanged()) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || el.style.strokePercent < 1) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new $4932acea05f0a056$var$SVGPathRebuilder();
            svgPathBuilder.reset();
            path.rebuildPath(svgPathBuilder, el.style.strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
        }
        $4932acea05f0a056$var$attr(svgEl, 'd', svgPathBuilder.getStr());
        $4932acea05f0a056$var$bindStyle(svgEl, style, el);
        $4932acea05f0a056$var$setTransform(svgEl, el.transform);
    }
};
var $4932acea05f0a056$export$5c452ff88e35e47d = {
    brush: function(el) {
        var style = el.style;
        var image = style.image;
        if (image instanceof HTMLImageElement) image = image.src;
        else if (image instanceof HTMLCanvasElement) image = image.toDataURL();
        if (!image) return;
        var x = style.x || 0;
        var y = style.y || 0;
        var dw = style.width;
        var dh = style.height;
        var svgEl = el.__svgEl;
        if (!svgEl) {
            svgEl = (0, $jbiHB.createElement)('image');
            el.__svgEl = svgEl;
        }
        if (image !== el.__imageSrc) {
            $4932acea05f0a056$var$attrXLink(svgEl, 'href', image);
            el.__imageSrc = image;
        }
        $4932acea05f0a056$var$attr(svgEl, 'width', dw + '');
        $4932acea05f0a056$var$attr(svgEl, 'height', dh + '');
        $4932acea05f0a056$var$attr(svgEl, 'x', x + '');
        $4932acea05f0a056$var$attr(svgEl, 'y', y + '');
        $4932acea05f0a056$var$bindStyle(svgEl, style, el);
        $4932acea05f0a056$var$setTransform(svgEl, el.transform);
    }
};
var $4932acea05f0a056$var$TEXT_ALIGN_TO_ANCHOR = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $4932acea05f0a056$var$adjustTextY(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
var $4932acea05f0a056$export$6f093cfa640b7166 = {
    brush: function(el) {
        var style = el.style;
        var text = style.text;
        text != null && (text += '');
        if (!text || isNaN(style.x) || isNaN(style.y)) return;
        var textSvgEl = el.__svgEl;
        if (!textSvgEl) {
            textSvgEl = (0, $jbiHB.createElement)('text');
            $4932acea05f0a056$var$attrXML(textSvgEl, 'xml:space', 'preserve');
            el.__svgEl = textSvgEl;
        }
        var font = style.font || (0, $02NbV.DEFAULT_FONT);
        var textSvgElStyle = textSvgEl.style;
        textSvgElStyle.font = font;
        textSvgEl.textContent = text;
        $4932acea05f0a056$var$bindStyle(textSvgEl, style, el);
        $4932acea05f0a056$var$setTransform(textSvgEl, el.transform);
        var x = style.x || 0;
        var y = $4932acea05f0a056$var$adjustTextY(style.y || 0, (0, $02NbV.getLineHeight)(font), style.textBaseline);
        var textAlign = $4932acea05f0a056$var$TEXT_ALIGN_TO_ANCHOR[style.textAlign] || style.textAlign;
        $4932acea05f0a056$var$attr(textSvgEl, 'dominant-baseline', 'central');
        $4932acea05f0a056$var$attr(textSvgEl, 'text-anchor', textAlign);
        $4932acea05f0a056$var$attr(textSvgEl, 'x', x + '');
        $4932acea05f0a056$var$attr(textSvgEl, 'y', y + '');
    }
};

});



parcelRegister("dRKn1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a18431c40bccf880$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $eXlKT = parcelRequire("eXlKT");

var $hzBt5 = parcelRequire("hzBt5");

var $3RCXB = parcelRequire("3RCXB");

var $lasoJ = parcelRequire("lasoJ");
function $a18431c40bccf880$var$isPattern(value) {
    return value && (!!value.image || !!value.svgElement);
}
var $a18431c40bccf880$var$patternDomMap = new (0, $lasoJ.default)();
var $a18431c40bccf880$var$PatternManager = function(_super) {
    (0, $fKE23.__extends)(PatternManager, _super);
    function PatternManager(zrId, svgRoot) {
        return _super.call(this, zrId, svgRoot, [
            'pattern'
        ], '__pattern_in_use__') || this;
    }
    PatternManager.prototype.addWithoutUpdate = function(svgElement, displayable) {
        if (displayable && displayable.style) {
            var that_1 = this;
            $hzBt5.each([
                'fill',
                'stroke'
            ], function(fillOrStroke) {
                var pattern = displayable.style[fillOrStroke];
                if ($a18431c40bccf880$var$isPattern(pattern)) {
                    var defs = that_1.getDefs(true);
                    var dom = $a18431c40bccf880$var$patternDomMap.get(pattern);
                    if (dom) {
                        if (!defs.contains(dom)) that_1.addDom(dom);
                    } else dom = that_1.add(pattern);
                    that_1.markUsed(displayable);
                    var id = dom.getAttribute('id');
                    svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
                }
            });
        }
    };
    PatternManager.prototype.add = function(pattern) {
        if (!$a18431c40bccf880$var$isPattern(pattern)) return;
        var dom = this.createElement('pattern');
        pattern.id = pattern.id == null ? this.nextId++ : pattern.id;
        dom.setAttribute('id', 'zr' + this._zrId + '-pattern-' + pattern.id);
        dom.setAttribute('x', '0');
        dom.setAttribute('y', '0');
        dom.setAttribute('patternUnits', 'userSpaceOnUse');
        this.updateDom(pattern, dom);
        this.addDom(dom);
        return dom;
    };
    PatternManager.prototype.update = function(pattern) {
        if (!$a18431c40bccf880$var$isPattern(pattern)) return;
        var that = this;
        this.doUpdate(pattern, function() {
            var dom = $a18431c40bccf880$var$patternDomMap.get(pattern);
            that.updateDom(pattern, dom);
        });
    };
    PatternManager.prototype.updateDom = function(pattern, patternDom) {
        var svgElement = pattern.svgElement;
        if (svgElement instanceof SVGElement) {
            if (svgElement.parentNode !== patternDom) {
                patternDom.innerHTML = '';
                patternDom.appendChild(svgElement);
                patternDom.setAttribute('width', pattern.svgWidth + '');
                patternDom.setAttribute('height', pattern.svgHeight + '');
            }
        } else {
            var img = void 0;
            var prevImage = patternDom.getElementsByTagName('image');
            if (prevImage.length) {
                if (pattern.image) img = prevImage[0];
                else {
                    patternDom.removeChild(prevImage[0]);
                    return;
                }
            } else if (pattern.image) img = this.createElement('image');
            if (img) {
                var imageSrc = void 0;
                var patternImage = pattern.image;
                if (typeof patternImage === 'string') imageSrc = patternImage;
                else if (patternImage instanceof HTMLImageElement) imageSrc = patternImage.src;
                else if (patternImage instanceof HTMLCanvasElement) imageSrc = patternImage.toDataURL();
                if (imageSrc) {
                    img.setAttribute('href', imageSrc);
                    img.setAttribute('x', '0');
                    img.setAttribute('y', '0');
                    var hostEl = {
                        dirty: function() {}
                    };
                    var createdImage = (0, $3RCXB.createOrUpdateImage)(imageSrc, img, hostEl, function(img) {
                        patternDom.setAttribute('width', img.width + '');
                        patternDom.setAttribute('height', img.height + '');
                    });
                    if (createdImage && createdImage.width && createdImage.height) {
                        patternDom.setAttribute('width', createdImage.width + '');
                        patternDom.setAttribute('height', createdImage.height + '');
                    }
                    patternDom.appendChild(img);
                }
            }
        }
        var x = pattern.x || 0;
        var y = pattern.y || 0;
        var rotation = (pattern.rotation || 0) / Math.PI * 180;
        var scaleX = pattern.scaleX || 1;
        var scaleY = pattern.scaleY || 1;
        var transform = "translate(" + x + ", " + y + ") rotate(" + rotation + ") scale(" + scaleX + ", " + scaleY + ")";
        patternDom.setAttribute('patternTransform', transform);
        $a18431c40bccf880$var$patternDomMap.set(pattern, patternDom);
    };
    PatternManager.prototype.markUsed = function(displayable) {
        if (displayable.style) {
            if ($a18431c40bccf880$var$isPattern(displayable.style.fill)) _super.prototype.markDomUsed.call(this, $a18431c40bccf880$var$patternDomMap.get(displayable.style.fill));
            if ($a18431c40bccf880$var$isPattern(displayable.style.stroke)) _super.prototype.markDomUsed.call(this, $a18431c40bccf880$var$patternDomMap.get(displayable.style.stroke));
        }
    };
    return PatternManager;
}((0, $eXlKT.default));
var $a18431c40bccf880$export$2e2bcd8739ae039 = $a18431c40bccf880$var$PatternManager;

});

parcelRegister("1g23U", function(module, exports) {

$parcel$export(module.exports, "hasClipPath", () => $0ea8e285d2cf2540$export$3918818844b1239b);
$parcel$export(module.exports, "default", () => $0ea8e285d2cf2540$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $eXlKT = parcelRequire("eXlKT");

var $hzBt5 = parcelRequire("hzBt5");

var $geJzd = parcelRequire("geJzd");
function $0ea8e285d2cf2540$var$generateClipPathsKey(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $0ea8e285d2cf2540$export$3918818844b1239b(displayable) {
    var clipPaths = displayable.__clipPaths;
    return clipPaths && clipPaths.length > 0;
}
var $0ea8e285d2cf2540$var$ClippathManager = function(_super) {
    (0, $fKE23.__extends)(ClippathManager, _super);
    function ClippathManager(zrId, svgRoot) {
        var _this = _super.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__') || this;
        _this._refGroups = {};
        _this._keyDuplicateCount = {};
        return _this;
    }
    ClippathManager.prototype.markAllUnused = function() {
        _super.prototype.markAllUnused.call(this);
        var refGroups = this._refGroups;
        for(var key in refGroups)if (refGroups.hasOwnProperty(key)) this.markDomUnused(refGroups[key]);
        this._keyDuplicateCount = {};
    };
    ClippathManager.prototype._getClipPathGroup = function(displayable, prevDisplayable) {
        if (!$0ea8e285d2cf2540$export$3918818844b1239b(displayable)) return;
        var clipPaths = displayable.__clipPaths;
        var keyDuplicateCount = this._keyDuplicateCount;
        var clipPathKey = $0ea8e285d2cf2540$var$generateClipPathsKey(clipPaths);
        if ((0, $geJzd.isClipPathChanged)(clipPaths, prevDisplayable && prevDisplayable.__clipPaths)) {
            keyDuplicateCount[clipPathKey] = keyDuplicateCount[clipPathKey] || 0;
            keyDuplicateCount[clipPathKey] && (clipPathKey += '-' + keyDuplicateCount[clipPathKey]);
            keyDuplicateCount[clipPathKey]++;
        }
        return this._refGroups[clipPathKey] || (this._refGroups[clipPathKey] = this.createElement('g'));
    };
    ClippathManager.prototype.update = function(displayable, prevDisplayable) {
        var clipGroup = this._getClipPathGroup(displayable, prevDisplayable);
        if (clipGroup) {
            this.markDomUsed(clipGroup);
            this.updateDom(clipGroup, displayable.__clipPaths);
        }
        return clipGroup;
    };
    ClippathManager.prototype.updateDom = function(parentEl, clipPaths) {
        if (clipPaths && clipPaths.length > 0) {
            var defs = this.getDefs(true);
            var clipPath = clipPaths[0];
            var clipPathEl = void 0;
            var id = void 0;
            if (clipPath._dom) {
                id = clipPath._dom.getAttribute('id');
                clipPathEl = clipPath._dom;
                if (!defs.contains(clipPathEl)) defs.appendChild(clipPathEl);
            } else {
                id = 'zr' + this._zrId + '-clip-' + this.nextId;
                ++this.nextId;
                clipPathEl = this.createElement('clipPath');
                clipPathEl.setAttribute('id', id);
                defs.appendChild(clipPathEl);
                clipPath._dom = clipPathEl;
            }
            var svgProxy = this.getSvgProxy(clipPath);
            svgProxy.brush(clipPath);
            var pathEl = this.getSvgElement(clipPath);
            clipPathEl.innerHTML = '';
            clipPathEl.appendChild(pathEl);
            parentEl.setAttribute('clip-path', 'url(#' + id + ')');
            if (clipPaths.length > 1) this.updateDom(clipPathEl, clipPaths.slice(1));
        } else if (parentEl) parentEl.setAttribute('clip-path', 'none');
    };
    ClippathManager.prototype.markUsed = function(displayable) {
        var _this = this;
        if (displayable.__clipPaths) $hzBt5.each(displayable.__clipPaths, function(clipPath) {
            if (clipPath._dom) _super.prototype.markDomUsed.call(_this, clipPath._dom);
        });
    };
    ClippathManager.prototype.removeUnused = function() {
        _super.prototype.removeUnused.call(this);
        var newRefGroupsMap = {};
        var refGroups = this._refGroups;
        for(var key in refGroups)if (refGroups.hasOwnProperty(key)) {
            var group = refGroups[key];
            if (!this.isDomUnused(group)) newRefGroupsMap[key] = group;
            else if (group.parentNode) group.parentNode.removeChild(group);
        }
        this._refGroups = newRefGroupsMap;
    };
    return ClippathManager;
}((0, $eXlKT.default));
var $0ea8e285d2cf2540$export$2e2bcd8739ae039 = $0ea8e285d2cf2540$var$ClippathManager;

});

parcelRegister("6rGIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b16679b11b5f075$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $eXlKT = parcelRequire("eXlKT");

var $jbiHB = parcelRequire("jbiHB");
var $4b16679b11b5f075$var$ShadowManager = function(_super) {
    (0, $fKE23.__extends)(ShadowManager, _super);
    function ShadowManager(zrId, svgRoot) {
        var _this = _super.call(this, zrId, svgRoot, [
            'filter'
        ], '__filter_in_use__', '_shadowDom') || this;
        _this._shadowDomMap = {};
        _this._shadowDomPool = [];
        return _this;
    }
    ShadowManager.prototype._getFromPool = function() {
        var shadowDom = this._shadowDomPool.pop();
        if (!shadowDom) {
            shadowDom = this.createElement('filter');
            shadowDom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + this.nextId++);
            var domChild = this.createElement('feDropShadow');
            shadowDom.appendChild(domChild);
            this.addDom(shadowDom);
        }
        return shadowDom;
    };
    ShadowManager.prototype.update = function(svgElement, displayable) {
        var style = displayable.style;
        if ($4b16679b11b5f075$var$hasShadow(style)) {
            var shadowKey = $4b16679b11b5f075$var$getShadowKey(displayable);
            var shadowDom = displayable._shadowDom = this._shadowDomMap[shadowKey];
            if (!shadowDom) {
                shadowDom = this._getFromPool();
                this._shadowDomMap[shadowKey] = shadowDom;
            }
            this.updateDom(svgElement, displayable, shadowDom);
        } else this.remove(svgElement, displayable);
    };
    ShadowManager.prototype.remove = function(svgElement, displayable) {
        if (displayable._shadowDom != null) {
            displayable._shadowDom = null;
            svgElement.removeAttribute('filter');
        }
    };
    ShadowManager.prototype.updateDom = function(svgElement, displayable, shadowDom) {
        var domChild = shadowDom.children[0];
        var style = displayable.style;
        var globalScale = displayable.getGlobalScale();
        var scaleX = globalScale[0];
        var scaleY = globalScale[1];
        if (!scaleX || !scaleY) return;
        var offsetX = style.shadowOffsetX || 0;
        var offsetY = style.shadowOffsetY || 0;
        var blur = style.shadowBlur;
        var normalizedColor = (0, $jbiHB.normalizeColor)(style.shadowColor);
        domChild.setAttribute('dx', offsetX / scaleX + '');
        domChild.setAttribute('dy', offsetY / scaleY + '');
        domChild.setAttribute('flood-color', normalizedColor.color);
        domChild.setAttribute('flood-opacity', normalizedColor.opacity + '');
        var stdDx = blur / 2 / scaleX;
        var stdDy = blur / 2 / scaleY;
        var stdDeviation = stdDx + ' ' + stdDy;
        domChild.setAttribute('stdDeviation', stdDeviation);
        shadowDom.setAttribute('x', '-100%');
        shadowDom.setAttribute('y', '-100%');
        shadowDom.setAttribute('width', '300%');
        shadowDom.setAttribute('height', '300%');
        displayable._shadowDom = shadowDom;
        var id = shadowDom.getAttribute('id');
        svgElement.setAttribute('filter', 'url(#' + id + ')');
    };
    ShadowManager.prototype.removeUnused = function() {
        var defs = this.getDefs(false);
        if (!defs) return;
        var shadowDomsPool = this._shadowDomPool;
        var shadowDomMap = this._shadowDomMap;
        for(var key in shadowDomMap)if (shadowDomMap.hasOwnProperty(key)) shadowDomsPool.push(shadowDomMap[key]);
        this._shadowDomMap = {};
    };
    return ShadowManager;
}((0, $eXlKT.default));
var $4b16679b11b5f075$export$2e2bcd8739ae039 = $4b16679b11b5f075$var$ShadowManager;
function $4b16679b11b5f075$var$hasShadow(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $4b16679b11b5f075$var$getShadowKey(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}

});



parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("8AIRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6151216f3344a48c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6151216f3344a48c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "business-summary.summary-view.breakdown-by-priority.title",
        "defaultMessage": "Priority breakdown"
    },
    description: {
        "id": "business-summary.summary-view.breakdown-by-priority.description",
        "defaultMessage": "Get a holistic view of how work is being prioritized. {linkStart}See what your team's been focusing on{linkEnd}"
    },
    descriptionWhenEmpty: {
        "id": "business-summary.summary-view.breakdown-by-priority.description-when-empty",
        "defaultMessage": "You'll need to create a few items before you can start prioritizing work."
    },
    noPriorityLabel: {
        "id": "business-summary.summary-view.breakdown-by-priority.no-priority-label",
        "defaultMessage": "None"
    },
    morePrioritiesLabel: {
        "id": "business-summary.summary-view.breakdown-by-priority.more-priorities-label",
        "defaultMessage": "More"
    }
});

});

parcelRegister("6mTfs", function(module, exports) {

$parcel$export(module.exports, "Description", () => $9271c91a0f9a53b8$export$393edc798c47379d);
$parcel$export(module.exports, "StyledSkeleton", () => $9271c91a0f9a53b8$export$e4ecddc59e33f387);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $liULw = parcelRequire("liULw");
const $9271c91a0f9a53b8$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $9271c91a0f9a53b8$export$e4ecddc59e33f387 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $liULw.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("liULw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4850662241fdd51$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $c4850662241fdd51$var$Skeleton = ({ className: className, testId: testId })=>{
    const skeletonColor = `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        fill: "none",
        preserveAspectRatio: "none",
        viewBox: "0 0 476 328",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "0",
        width: "476",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "16",
        width: "320",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "32",
        width: "48",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "72",
        width: "20",
        height: "20",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "81",
        width: "443",
        height: "2",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "120",
        width: "20",
        height: "20",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "129",
        width: "443",
        height: "2",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "168",
        width: "20",
        height: "20",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "177",
        width: "443",
        height: "2",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "216",
        width: "20",
        height: "20",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "225",
        width: "443",
        height: "2",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "264",
        width: "20",
        height: "20",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "273",
        width: "443",
        height: "2",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "50",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "106",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "162",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "218",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "274",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "330",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "386",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "442",
        y: "296",
        width: "32",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }));
};
var $c4850662241fdd51$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c4850662241fdd51$var$Skeleton);

});


parcelRegister("4a4D1", function(module, exports) {

$parcel$export(module.exports, "buildChartData", () => $d3f4a18d2e6d048c$export$bbcf2eea793fdd45);

var $eUqFw = parcelRequire("eUqFw");

var $g5xj8 = parcelRequire("g5xj8");

var $3WGNO = parcelRequire("3WGNO");



var $c9TLT = parcelRequire("c9TLT");


var $8AIRh = parcelRequire("8AIRh");
const $d3f4a18d2e6d048c$var$KNOWN_PRIORITY_BAR_COLORS = {
    Highest: (0, $73a5c9d720aa66e1$export$2010d0fb4295b346),
    High: (0, $73a5c9d720aa66e1$export$60847d42f9da92a6),
    Medium: (0, $73a5c9d720aa66e1$export$c6930421db9fa514),
    Low: (0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a),
    Lowest: (0, $73a5c9d720aa66e1$export$e62e8919cca44969),
    None: (0, $73a5c9d720aa66e1$export$d6447c357493214f)
};
const $d3f4a18d2e6d048c$var$OTHER_BAR_COLORS = [
    (0, $73a5c9d720aa66e1$export$940e1f69e873f202),
    (0, $73a5c9d720aa66e1$export$9dc1ef0f3f48059b),
    (0, $73a5c9d720aa66e1$export$b48405b95304b5a1),
    (0, $73a5c9d720aa66e1$export$4a7404f376229999)
];
const $d3f4a18d2e6d048c$var$MAX_BARS = 8;
const $d3f4a18d2e6d048c$var$createFilterUrlFromPriorities = (urlBuilder, ...priorities)=>{
    if (priorities.length === 0) return '';
    const escapedPriorities = priorities.map((priority)=>priority == null ? 'EMPTY' : `'${priority.split("'").join("\\'")}'`);
    let filter;
    if (priorities.length === 1) filter = encodeURIComponent(`${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)} AND priority = ${escapedPriorities[0]}`);
    else filter = encodeURIComponent(`${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)} AND priority in (${escapedPriorities.join(',')})`);
    return `${urlBuilder('breakdownByPriority', true)}?filter=${filter}`;
};
const $d3f4a18d2e6d048c$var$createYAxisPoint = (value, color)=>({
        itemStyle: {
            color: color
        },
        value: value
    });
const $d3f4a18d2e6d048c$export$bbcf2eea793fdd45 = (priorityGroupData, formatMessage, urlBuilder)=>{
    if (priorityGroupData == null) return null;
    const option = {
        // The positioning for the chart grid is quite generous, so override to allow the chart to take up more space.
        grid: {
            left: (0, $4454b732cd028e67$export$e6b9649c5bb30e80),
            right: 0,
            top: 30,
            bottom: 10
        },
        xAxis: {
            axisLabel: {
                interval: 0,
                show: false
            },
            axisLine: {
                show: false
            },
            axisTick: {
                // Removes the tick lines between each category.
                show: false
            },
            data: [],
            type: 'category'
        },
        yAxis: {
            axisLabel: {
                color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
                fontFamily: $c9TLT.fontFamily
            },
            max: undefined,
            min: undefined,
            minInterval: 1,
            splitLine: {
                lineStyle: {
                    color: `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
                    width: 2
                }
            },
            type: 'value'
        },
        series: [
            {
                animation: false,
                barWidth: '50%',
                data: [],
                type: 'bar',
                // Override the default hover/emphasis styling on bars to be more subtle.
                emphasis: {
                    itemStyle: {
                        color: 'inherit',
                        opacity: 0.9
                    }
                }
            }
        ]
    };
    const filterUrls = [];
    const xAxisPoints = [];
    const yAxisPoints = [];
    let colors = [
        ...$d3f4a18d2e6d048c$var$OTHER_BAR_COLORS
    ];
    let totalCount = 0;
    let priorityGroups;
    let otherGroups;
    if (priorityGroupData.length <= $d3f4a18d2e6d048c$var$MAX_BARS) priorityGroups = priorityGroupData;
    else {
        priorityGroups = priorityGroupData.slice(0, $d3f4a18d2e6d048c$var$MAX_BARS - 1);
        otherGroups = priorityGroupData.slice($d3f4a18d2e6d048c$var$MAX_BARS - 1);
    }
    priorityGroups.forEach((priorityGroup)=>{
        const { count: count, priority: { iconUrl: iconUrl, name: name } } = priorityGroup;
        if (colors.length === 0) colors = [
            ...$d3f4a18d2e6d048c$var$OTHER_BAR_COLORS
        ];
        // The filterUrls are pushed in the order that the bars are added.
        // This means we can use the index of each bar to get the filterLink for that bar.
        const filterUrl = $d3f4a18d2e6d048c$var$createFilterUrlFromPriorities(urlBuilder, name);
        filterUrls.push(filterUrl);
        // When issues don't have a priority, they come back in a group where the priority name and icon is null.
        // In this case we have a specific label and icon to show.
        const xAxisName = name || formatMessage((0, $8AIRh.default).noPriorityLabel);
        const noPriorityIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5xj8))), {
            label: "",
            size: "medium",
            primaryColor: "var(--ds-text-subtle, #7A869A)"
        });
        const xAxisPointIcon = iconUrl || noPriorityIcon;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const barColor = $d3f4a18d2e6d048c$var$KNOWN_PRIORITY_BAR_COLORS[xAxisName] || colors.pop();
        xAxisPoints.push({
            icon: xAxisPointIcon,
            filterUrl: filterUrl,
            name: xAxisName,
            count: count
        });
        yAxisPoints.push($d3f4a18d2e6d048c$var$createYAxisPoint(count, barColor));
        totalCount += count;
    });
    if (otherGroups) {
        const xAxisName = formatMessage((0, $8AIRh.default).morePrioritiesLabel);
        const barColor = (0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
        const otherCount = otherGroups.reduce((countSoFar, { count: count })=>countSoFar + count, 0);
        const priorities = otherGroups.map(({ priority: { name: name } })=>name);
        const filterUrl = $d3f4a18d2e6d048c$var$createFilterUrlFromPriorities(urlBuilder, ...priorities);
        filterUrls.push(filterUrl);
        xAxisPoints.push({
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3WGNO))), {
                label: "",
                size: "medium",
                primaryColor: "var(--ds-text-subtlest, #6b778c)"
            }),
            filterUrl: filterUrl,
            name: xAxisName,
            count: otherCount
        });
        yAxisPoints.push($d3f4a18d2e6d048c$var$createYAxisPoint(otherCount, barColor));
        totalCount += otherCount;
    }
    if (totalCount === 0) {
        const { yAxis: yAxis } = option;
        // Set a min and max so that the y axis doesn't default to only showing 0 and 1 split lines.
        // @ts-expect-error - TS2322 - Type '0' is not assignable to type 'undefined'.
        yAxis.min = 0;
        // @ts-expect-error - TS2322 - Type '5' is not assignable to type 'undefined'.
        yAxis.max = 5;
    }
    // We only have one series for this bar chart, so its safe to always mutate the data on the first item.
    // @ts-expect-error - TS2322 - Type 'YAxisDataPoint[]' is not assignable to type 'never[]'.
    option.series[0].data = yAxisPoints;
    return {
        filterUrls: filterUrls,
        option: option,
        totalCount: totalCount,
        xAxisPoints: xAxisPoints
    };
};

});
parcelRegister("g5xj8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb66f32670c9d5e0$var$_react = $bb66f32670c9d5e0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $bb66f32670c9d5e0$var$_minus = $bb66f32670c9d5e0$var$_interopRequireDefault((parcelRequire("dXcXo")));
function $bb66f32670c9d5e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bb66f32670c9d5e0$var$EditorHorizontalRuleIcon = (props)=>/*#__PURE__*/ $bb66f32670c9d5e0$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="2" x="5" y="11" fill="currentcolor" fill-rule="evenodd" rx="1"/></svg>`
    }, props, {
        newIcon: $bb66f32670c9d5e0$var$_minus.default
    }));
$bb66f32670c9d5e0$var$EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
var $bb66f32670c9d5e0$var$_default = module.exports.default = $bb66f32670c9d5e0$var$EditorHorizontalRuleIcon;

});
parcelRegister("dXcXo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fe233238226da2c28c4755e30d64d82>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a28ad60dcb9254af$var$_react = $a28ad60dcb9254af$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a28ad60dcb9254af$var$_UNSAFE_baseNew = $a28ad60dcb9254af$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a28ad60dcb9254af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a28ad60dcb9254af$var$MinusIcon = (props)=>/*#__PURE__*/ $a28ad60dcb9254af$var$_react.default.createElement($a28ad60dcb9254af$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2 8h12"/>`
    }, props));
$a28ad60dcb9254af$var$MinusIcon.displayName = 'MinusIcon';
var $a28ad60dcb9254af$var$_default = module.exports.default = $a28ad60dcb9254af$var$MinusIcon;

});


parcelRegister("3WGNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2df7fd8eb33c0a93$var$_react = $2df7fd8eb33c0a93$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $2df7fd8eb33c0a93$var$_showMoreHorizontal = $2df7fd8eb33c0a93$var$_interopRequireDefault((parcelRequire("7JXZ0")));
function $2df7fd8eb33c0a93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2df7fd8eb33c0a93$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $2df7fd8eb33c0a93$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $2df7fd8eb33c0a93$var$_showMoreHorizontal.default
    }));
$2df7fd8eb33c0a93$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $2df7fd8eb33c0a93$var$_default = module.exports.default = $2df7fd8eb33c0a93$var$EditorMoreIcon;

});

const $41d3054f19febaab$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $41d3054f19febaab$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $41d3054f19febaab$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $41d3054f19febaab$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $41d3054f19febaab$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $41d3054f19febaab$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $41d3054f19febaab$export$c0ecd9bd08a86184 = 8;
const $41d3054f19febaab$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $41d3054f19febaab$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;

const $4454b732cd028e67$export$e6b9649c5bb30e80 = 30;


parcelRegister("zfROv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd54580cf204fd99$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lB25E = parcelRequire("lB25E");

var $bWbSz = parcelRequire("bWbSz");
const $fd54580cf204fd99$var$XAxis = ({ points: points, onClick: onClick })=>{
    const { linksTarget: linksTarget } = (0, $bWbSz.useSummaryFeatures)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd54580cf204fd99$var$AxisWrapper, null, points.map(({ icon: icon, filterUrl: filterUrl, name: name, count: count }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd54580cf204fd99$var$AxisItem, {
            key: index
        }, typeof icon === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd54580cf204fd99$var$Image, {
            alt: "",
            src: icon
        }) : icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fd54580cf204fd99$var$PriorityLink, {
            href: filterUrl,
            target: linksTarget,
            onClick: ()=>onClick(count)
        }, name))));
};
var $fd54580cf204fd99$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($fd54580cf204fd99$var$XAxis);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd54580cf204fd99$var$AxisWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _1ejii47z _wij21bp4 _18u01ul9",
            __cmplp.className
        ])
    });
});
const $fd54580cf204fd99$var$AxisItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fd54580cf204fd99$var$PriorityLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq _y3gn1h6o _1bto1l2s _o5721q9c _1reo15vq _18m915vq _k48pbfng _1wyb1crf _19pkv77o",
            __cmplp.className
        ])
    });
});
const $fd54580cf204fd99$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dtGkG", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4d816a342fbd5c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $ek6sP = parcelRequire("ek6sP");

var $5xIu6 = parcelRequire("5xIu6");

var $lGiWG = parcelRequire("lGiWG");

var $kar7l = parcelRequire("kar7l");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dSJD5 = parcelRequire("dSJD5");
const $eb4d816a342fbd5c$var$FEEDBACK_GROUP_ID = 'jwm-feedback-summary';
const $eb4d816a342fbd5c$var$FeedbackBanner = ({ isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const openFeedbackModal = (0, $5xIu6.useFeedbackCollector)();
    const onSubmitFeedbackClick = (0, $eUqFw.useCallback)(()=>{
        openFeedbackModal($eb4d816a342fbd5c$var$FEEDBACK_GROUP_ID, (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), buttonRef);
    }, [
        openFeedbackModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb4d816a342fbd5c$var$FeedbackBannerWrapper, {
        isLoading: isLoading,
        "data-testid": "business-summary.ui.summary-view.feedback-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek6sP))), {
        LEGACY_size: "medium",
        LEGACY_primaryColor: (0, $kar7l.Tokens).COLOR_TEXT_SUBTLE,
        LEGACY_secondaryColor: (0, $kar7l.Tokens).COLOR_ELEVATION_SURFACE,
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb4d816a342fbd5c$var$ParagraphWrapper, null, formatMessage((0, $dSJD5.default).inviteFeedbackMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "link",
        spacing: "none",
        onClick: onSubmitFeedbackClick,
        ref: buttonRef
    }, formatMessage((0, $dSJD5.default).submitFeedbackCallToAction))));
};
var $eb4d816a342fbd5c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($eb4d816a342fbd5c$var$FeedbackBanner);
const $eb4d816a342fbd5c$var$FeedbackBannerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _18s8hzmq _syaz1c2q _11q71ml8 _1yt418iy _2rkoiti9 _1bsb1ns9",
            __cmplp.isLoading ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb4d816a342fbd5c$var$ParagraphWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8171m _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ek6sP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b478a4dfe0bf6ab262246b2cea3eb20f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d7f28dcbf6a858$var$_react = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6d7f28dcbf6a858$var$_information = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("h6FFs")));

var $a6d7f28dcbf6a858$var$_info = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("2bv8J")));
function $a6d7f28dcbf6a858$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6d7f28dcbf6a858$var$InformationIcon = (props)=>/*#__PURE__*/ $a6d7f28dcbf6a858$var$_react.default.createElement($a6d7f28dcbf6a858$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $a6d7f28dcbf6a858$var$_info.default
    }, props));
$a6d7f28dcbf6a858$var$InformationIcon.Name = 'InformationIconMigration';
var $a6d7f28dcbf6a858$var$_default = module.exports.default = $a6d7f28dcbf6a858$var$InformationIcon;

});

parcelRegister("lGiWG", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $3bf493f9be098b31$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");
const $3bf493f9be098b31$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, ...props }, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bf493f9be098b31$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf493f9be098b31$var$CustomButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex _fsjdky8x _z1i3tvsq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dSJD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8159ff4279fcb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0e8159ff4279fcb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteFeedbackMessage: {
        "id": "business-summary.summary-view.feedback-banner.invite-feedback-message",
        "defaultMessage": "Was the information shown in this page useful? "
    },
    submitFeedbackCallToAction: {
        "id": "business-summary.summary-view.feedback-banner.submit-feedback-call-to-action",
        "defaultMessage": "Give us feedback"
    }
});

});


parcelRegister("4Xy73", function(module, exports) {

$parcel$export(module.exports, "default", () => $634cacec9b2be4a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fDLFb = parcelRequire("fDLFb");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cWiVr = parcelRequire("cWiVr");

var $jK1pm = parcelRequire("jK1pm");

var $8rQuz = parcelRequire("8rQuz");

var $bWbSz = parcelRequire("bWbSz");

var $3aaDZ = parcelRequire("3aaDZ");

var $dvXaa = parcelRequire("dvXaa");

var $kC3Sk = parcelRequire("kC3Sk");

var $8CjgY = parcelRequire("8CjgY");
const $634cacec9b2be4a9$var$SummaryHeader = ({ isLoading: isLoading })=>{
    const { data: currentUserData, loading: isUserDataLoading } = (0, $cWiVr.useCurrentUser)();
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const { hasShareButton: hasShareButton } = (0, $bWbSz.useSummaryFeatures)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const userName = currentUserData?.user?.displayName;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { emoji: emoji, message: message } = (0, $8CjgY.getTimeBasedGreeting)();
    const isSkeleton = isLoading || isUserDataLoading;
    const greeting = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($634cacec9b2be4a9$var$SummaryTitle, null, `${formatMessage(message, {
        userName: userName
    })} ${emoji}`);
    const withShareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($634cacec9b2be4a9$var$SummaryTitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($634cacec9b2be4a9$var$SummaryTitleSideWrapper, null), greeting, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($634cacec9b2be4a9$var$SummaryTitleSideWrapper, null, hasShareButton && !(0, $8rQuz.isVisualRefreshEnabled)() && !(0, $eI5EY.fg)('common_project_actions_menu') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvXaa.default), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($634cacec9b2be4a9$var$SummaryHeaderWrapper, null, isSkeleton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kC3Sk.default), {
        testId: "business-summary.ui.summary-view.header.skeleton"
    }) : withShareButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($634cacec9b2be4a9$var$SummarySubTitle, {
        isSkeleton: isSkeleton
    }, formatMessage((0, $3aaDZ.default).description, {
        containerName: entity?.name
    }))));
};
var $634cacec9b2be4a9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($634cacec9b2be4a9$var$SummaryHeader);
const $634cacec9b2be4a9$var$SummaryHeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _otyr1b66 _kqswh2mm _1bsb1osq _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $634cacec9b2be4a9$var$SummaryTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _11c81p5s _y3gn1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug _19pkidpf",
            __cmplp.className
        ])
    });
});
const $634cacec9b2be4a9$var$SummarySubTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSkeleton: isSkeleton, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _18s8134w _p12f1fdn _vwz41ejb _2rko1y44",
            __cmplp.isSkeleton ? "_syaz3acm" : "_syaz1c2q",
            __cmplp.isSkeleton ? "_bfhktjc5" : "_bfhk18uv",
            __cmplp.className
        ])
    });
});
const $634cacec9b2be4a9$var$SummaryTitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _1bah1b1v _4cvr1h6o _1tkezwfg",
            __cmplp.className
        ])
    });
});
const $634cacec9b2be4a9$var$SummaryTitleSideWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91j4a _1e0c1txw _1bahh9n0 _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3aaDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $664cf89a99dd7d66$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $664cf89a99dd7d66$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    morningGreeting: {
        "id": "business-summary.summary-view.header.morning-greeting",
        "defaultMessage": "Good morning, {userName}"
    },
    afternoonGreeting: {
        "id": "business-summary.summary-view.header.afternoon-greeting",
        "defaultMessage": "Good afternoon, {userName}"
    },
    eveningGreeting: {
        "id": "business-summary.summary-view.header.evening-greeting",
        "defaultMessage": "Good evening, {userName}"
    },
    description: {
        "id": "business-summary.summary-view.header.description",
        "defaultMessage": "Here's where you'll view a summary of {containerName}'s status, priorities, workload, and more."
    }
});

});

parcelRegister("dvXaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e82172b4d1412f2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eCCst = parcelRequire("eCCst");

var $iSNkS = parcelRequire("iSNkS");

var $8W9e1 = parcelRequire("8W9e1");
const $5e82172b4d1412f2$var$ShareButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCCst.JWMShareButton), {
        shareTitle: (0, $8W9e1.default).shareTitle,
        integrationType: (0, $iSNkS.integrationTypes).SUMMARY,
        shareContentType: "summary"
    });
var $5e82172b4d1412f2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5e82172b4d1412f2$var$ShareButton);

});
parcelRegister("eCCst", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $7c9cba86062e6e6f$export$b326da26415fdf10);

var $eUqFw = parcelRequire("eUqFw");

var $dFWNP = parcelRequire("dFWNP");

var $bDUCT = parcelRequire("bDUCT");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $hfslX = parcelRequire("hfslX");

var $lxV3x = parcelRequire("lxV3x");

var $bPBzW = parcelRequire("bPBzW");

const $7c9cba86062e6e6f$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
    label: "",
    size: "small"
});
const $7c9cba86062e6e6f$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareIntegrations: shareIntegrations } = (0, $hfslX.useShareIntegrations)(shareContentType);
    const entityAri = (0, $bDUCT.useEntityAri)();
    const shareButtonRef = (0, $eUqFw.useRef)(null);
    const renderCustomTriggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $7c9cba86062e6e6f$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $bPBzW.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxV3x.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $bPBzW.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $bPBzW.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f4cb7ac67043f68$var$_share = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("ec2xp")));
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9f4cb7ac67043f68$var$_share.default
    }));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = module.exports.default = $9f4cb7ac67043f68$var$ShareIcon;

});
parcelRegister("ec2xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b1d38bd881e36a60e1d8f11863c2679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55427aa389adc57$var$_react = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a55427aa389adc57$var$_UNSAFE_baseNew = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a55427aa389adc57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a55427aa389adc57$var$ShareIcon = (props)=>/*#__PURE__*/ $a55427aa389adc57$var$_react.default.createElement($a55427aa389adc57$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a55427aa389adc57$var$ShareIcon.displayName = 'ShareIcon';
var $a55427aa389adc57$var$_default = module.exports.default = $a55427aa389adc57$var$ShareIcon;

});


parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");


var $8nUKh = parcelRequire("8nUKh");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lUmmJ")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("lUmmJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2xQrm")
]).then(()=>parcelRequire('iHQJU'));

});


parcelRegister("hfslX", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $b36423e50cabd739$export$58a9f7a7ab3466f4);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $8q0kG = parcelRequire("8q0kG");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $gWV0M = parcelRequire("gWV0M");

var $ljgr5 = parcelRequire("ljgr5");
const $b36423e50cabd739$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const ineligibilityReasons = (0, $eUqFw.useMemo)(()=>{
        const reasons = [];
        if ((0, $8q0kG.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $dfBCt.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $eUqFw.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $ljgr5.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWV0M.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("gWV0M", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $acb191acb45641f8$export$2cc56764fd9edb21);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $335P8 = parcelRequire("335P8");

const $acb191acb45641f8$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlack), props)));

});
parcelRegister("335P8", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $7cc4332b79a68bdd$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $7cc4332b79a68bdd$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $d3qIv = parcelRequire("d3qIv");
const $7cc4332b79a68bdd$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $d3qIv.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $7cc4332b79a68bdd$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4Bees.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3qIv", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $3114157f9b395570$export$24281652e6b89b3b);

var $7rh0R = parcelRequire("7rh0R");

const $3114157f9b395570$export$24281652e6b89b3b = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fAA0W")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("fAA0W", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("dPtit")
]).then(()=>parcelRequire('dZKRj'));

});




parcelRegister("ljgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f66b2d378eff6fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f66b2d378eff6fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});


parcelRegister("lxV3x", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $906cb1053f659eb0$export$d95995d6ca76620b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $906cb1053f659eb0$var$LazyShareProjectNudge = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("htJn2")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $906cb1053f659eb0$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($906cb1053f659eb0$var$LazyShareProjectNudge, null, children)));

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';
const $99a775c02d636a41$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("htJn2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("afZr6").then(()=>parcelRequire('16oN0'));

});


parcelRegister("bPBzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6735bf02b619f7cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6735bf02b619f7cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("8W9e1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c60cc1c1b24065f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4c60cc1c1b24065f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "business-summary.summary-view.header.share-button.share-title",
        "defaultMessage": "Summary"
    }
});

});


parcelRegister("kC3Sk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fddd8ef373971000$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kar7l = parcelRequire("kar7l");
const $fddd8ef373971000$var$SummaryHeaderSkeleton = ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "32px",
        width: "400px",
        viewBox: "0 0 400 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0",
        y: "0",
        width: "400px",
        height: "32px",
        rx: "4",
        fill: (0, $kar7l.Tokens).COLOR_SKELETON
    }));
var $fddd8ef373971000$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($fddd8ef373971000$var$SummaryHeaderSkeleton);

});

parcelRegister("8CjgY", function(module, exports) {

$parcel$export(module.exports, "getTimeBasedGreeting", () => $d62d29aee749e87c$export$1ca778b9c48306c7);

var $3aaDZ = parcelRequire("3aaDZ");
const $d62d29aee749e87c$export$1ca778b9c48306c7 = ()=>{
    const dateNow = new Date();
    const hourNow = dateNow.getHours();
    const minutesNow = dateNow.getMinutes();
    // Morning between 5:00am and 11:59am
    if (hourNow >= 5 && hourNow < 12) return {
        emoji: "\u2615\uFE0F",
        message: (0, $3aaDZ.default).morningGreeting
    };
    // Afternoon between 12:00pm and 7:29pm
    if (hourNow >= 12 && hourNow < 19 || hourNow === 19 && minutesNow < 30) return {
        emoji: "\u2600\uFE0F",
        message: (0, $3aaDZ.default).afternoonGreeting
    };
    // Evening between 7:30pm and 4:59am
    return {
        emoji: "\uD83C\uDF14",
        message: (0, $3aaDZ.default).eveningGreeting
    };
};

});


parcelRegister("4kds4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95a5c265ef7744c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d95a5c265ef7744c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    summaryHeading: {
        "id": "business-summary.summary-view.summary-heading",
        "defaultMessage": "Summary"
    }
});

});

parcelRegister("5STtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93070ef49d4a923$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jK1pm = parcelRequire("jK1pm");

var $cGyoW = parcelRequire("cGyoW");

var $gQa4E = parcelRequire("gQa4E");

const $d93070ef49d4a923$var$OverviewItems = ()=>{
    const { data: data, loading: loading } = (0, $cGyoW.useOverviewItems)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-overview-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d93070ef49d4a923$var$ListContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d93070ef49d4a923$var$CardsList, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQa4E.default), {
        count: data?.doneThisWeek,
        type: (0, $8be63d4b94780ed6$export$71efb3495f6084f2),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.overview-items.done-this-week"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQa4E.default), {
        count: data?.updatedThisWeek,
        type: (0, $8be63d4b94780ed6$export$cd8e68094cb5c3cb),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.overview-items.updated-this-week"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQa4E.default), {
        count: data?.createdThisWeek,
        type: (0, $8be63d4b94780ed6$export$ff39ebd4bb12b718),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.overview-items.created-this-week"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQa4E.default), {
        count: data?.dueThisWeek,
        type: (0, $8be63d4b94780ed6$export$ee74b0b7e193b0b0),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.overview-items.due-this-week"
    }))));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d93070ef49d4a923$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d93070ef49d4a923$var$OverviewItems);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d93070ef49d4a923$var$ListContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1yt41bpf _1bsb1osq _wij2j5tq _7cca15wb _1f38lz1g _hw6owxkt _1o11hkll",
            __cmplp.className
        ])
    });
});
const $d93070ef49d4a923$var$CardsList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1e0c11p5 _1bah1h6o _yv0e1ezz _gy1ppxbi _1p57pxbi _1ul9idpf _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gQa4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $1003db4bfb3347d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $95pVW = parcelRequire("95pVW");

var $k4G3U = parcelRequire("k4G3U");

var $a4veM = parcelRequire("a4veM");

var $55rBA = parcelRequire("55rBA");



var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lB25E = parcelRequire("lB25E");

var $apShl = parcelRequire("apShl");

var $bWbSz = parcelRequire("bWbSz");


var $6of26 = parcelRequire("6of26");
const $1003db4bfb3347d1$var$EMPTY_ICON_COLOR = `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;
const $1003db4bfb3347d1$var$EMPTY_BACKGROUND_COLOR = `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20A})`;
const $1003db4bfb3347d1$var$CARD_TYPES = {
    [(0, $8be63d4b94780ed6$export$71efb3495f6084f2)]: {
        color: `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        backgroundColor: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G50})`,
        getIcon: (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a4veM))), {
                label: "",
                color: color,
                LEGACY_primaryColor: color
            }),
        message: (0, $6of26.default).doneItems,
        getLink: (urlBuilder)=>`${urlBuilder('overviewCard', true)}?filter=${encodeURIComponent('statusCategory = Done AND statusCategoryChangedDate >= -1w')}&hideDone=false`
    },
    [(0, $8be63d4b94780ed6$export$cd8e68094cb5c3cb)]: {
        color: `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        backgroundColor: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B50})`,
        getIcon: (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($55rBA))), {
                label: "",
                color: color,
                LEGACY_primaryColor: color
            }),
        message: (0, $6of26.default).updatedItems,
        getLink: (urlBuilder)=>`${urlBuilder('overviewCard', true)}?filter=${encodeURIComponent('updatedDate >= -1w')}&hideDone=false`
    },
    [(0, $8be63d4b94780ed6$export$ff39ebd4bb12b718)]: {
        color: `var(--ds-text-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        backgroundColor: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P50})`,
        getIcon: (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($95pVW))), {
                label: "",
                color: color,
                LEGACY_primaryColor: color
            }),
        message: (0, $6of26.default).createdItems,
        getLink: (urlBuilder)=>`${urlBuilder('overviewCard', true)}?filter=${encodeURIComponent('createdDate >= -1w')}&hideDone=false`
    },
    [(0, $8be63d4b94780ed6$export$ee74b0b7e193b0b0)]: {
        color: `var(--ds-text-accent-red, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        backgroundColor: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R50})`,
        getIcon: (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k4G3U))), {
                label: "",
                color: color,
                LEGACY_primaryColor: color
            }),
        message: (0, $6of26.default).dueItems,
        getLink: (urlBuilder)=>`${urlBuilder('overviewCard', true)}?filter=${encodeURIComponent('statusCategory != Done AND (duedate >= 0d AND duedate < 1w)')}`
    }
};
const $1003db4bfb3347d1$var$OverviewCard = ({ type: type, testId: testId, count: count, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { linksTarget: linksTarget, urlBuilder: urlBuilder } = (0, $bWbSz.useSummaryFeatures)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isEmpty = count === 0;
    const card = $1003db4bfb3347d1$var$CARD_TYPES[type];
    const { message: message, color: color, backgroundColor: backgroundColor, getIcon: getIcon, getLink: getLink } = card;
    const cardColor = isEmpty ? null : color;
    const cardBackgroundColor = isEmpty ? $1003db4bfb3347d1$var$EMPTY_BACKGROUND_COLOR : backgroundColor;
    const icon = getIcon(isEmpty ? $1003db4bfb3347d1$var$EMPTY_ICON_COLOR : color);
    const celebrateEmoji = type === (0, $8be63d4b94780ed6$export$71efb3495f6084f2) && !isEmpty ? "  \uD83C\uDF89" : null;
    const onClick = (0, $eUqFw.useCallback)(()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'summaryOverviewCard', {
            type: type,
            count: count
        }), [
        type,
        count,
        createAnalyticsEvent
    ]);
    return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "overview-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$CardItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$SkeletonCardContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$Skeleton, {
        testId: "business-summary.ui.summary-view.overview-items.overview-card.skeleton"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$CardItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$CardContainer, {
        href: getLink(urlBuilder),
        target: linksTarget,
        "data-testid": testId,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$CardIconContainer, {
        color: cardBackgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$IconWrapper, null, icon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        message: formatMessage(message, {
            titleStart: '{titleStart}',
            titleEnd: '{titleEnd}',
            count: count
        }),
        componentsMapping: {
            // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type 'string | null' is not assignable to type 'string'.
            title: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1003db4bfb3347d1$var$Title, {
                    color: cardColor
                }, children)
        }
    }), celebrateEmoji)));
};
var $1003db4bfb3347d1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1003db4bfb3347d1$var$OverviewCard);
const $1003db4bfb3347d1$var$SkeletonSVG = ({ className: className, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 264 99",
        fill: "none",
        preserveAspectRatio: "none" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        ,
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "25",
        y: "25",
        width: "48",
        height: "48",
        rx: "24",
        fill: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "85",
        y: "29",
        width: "83",
        height: "24",
        rx: "4",
        fill: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "85",
        y: "61",
        width: "154",
        height: "8",
        rx: "4",
        fill: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`
    }))); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v5641ycq _t9ec157v",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$CardItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1ns9 _vchhusvi _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$CardIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ickbl _1bsbckbl _2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1cj8 _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $1003db4bfb3347d1$var$cardContainerBase = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$CardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i16xz _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _2rkoftgi _vchhusvi _bfhkhp5a _v564ds4c _16qs1os1 _15yoglyw _1yt41ejb _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _180dzotn _7ehizotn _1dbzzotn _1urc3swd _1jxp3swd _1me43swd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$SkeletonCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i16xz _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _2rkoftgi _vchhusvi _bfhkhp5a _v564ds4c _16qs1os1 _15yoglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _180dzotn _7ehizotn _1dbzzotn _1urc3swd _1jxp3swd _1me43swd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18u0utpp _syaz1rc1 _k48pbfng _19pkidpf _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$Skeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $1003db4bfb3347d1$var$SkeletonSVG, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1003db4bfb3347d1$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_hk0kyc": (0, $9t7rW.default)(__cmplp.color || `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazc59f _11c8o0gd _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("95pVW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8fa8c03af67652550265467b8ce6daa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69d8b28ae243fd2e$var$_react = $69d8b28ae243fd2e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $69d8b28ae243fd2e$var$_add = $69d8b28ae243fd2e$var$_interopRequireDefault((parcelRequire("cS2gQ")));

var $69d8b28ae243fd2e$var$_add2 = $69d8b28ae243fd2e$var$_interopRequireDefault((parcelRequire("bkIGg")));
function $69d8b28ae243fd2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69d8b28ae243fd2e$var$AddIcon = (props)=>/*#__PURE__*/ $69d8b28ae243fd2e$var$_react.default.createElement($69d8b28ae243fd2e$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $69d8b28ae243fd2e$var$_add2.default
    }, props));
$69d8b28ae243fd2e$var$AddIcon.Name = 'AddIconMigration';
var $69d8b28ae243fd2e$var$_default = module.exports.default = $69d8b28ae243fd2e$var$AddIcon;

});

parcelRegister("k4G3U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96850a015a84b74951faa873f3baecd2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9d4cf07b3523c99$var$_react = $e9d4cf07b3523c99$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e9d4cf07b3523c99$var$_calendar = $e9d4cf07b3523c99$var$_interopRequireDefault((parcelRequire("61UUs")));

var $e9d4cf07b3523c99$var$_calendar2 = $e9d4cf07b3523c99$var$_interopRequireDefault((parcelRequire("kMHOY")));
function $e9d4cf07b3523c99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9d4cf07b3523c99$var$CalendarIcon = (props)=>/*#__PURE__*/ $e9d4cf07b3523c99$var$_react.default.createElement($e9d4cf07b3523c99$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $e9d4cf07b3523c99$var$_calendar2.default
    }, props));
$e9d4cf07b3523c99$var$CalendarIcon.Name = 'CalendarIconMigration';
var $e9d4cf07b3523c99$var$_default = module.exports.default = $e9d4cf07b3523c99$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20cf79a37c55dc030e28f840f88e494b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});

parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f21a4850a620a60b$var$_calendar = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("61UUs")));
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $f21a4850a620a60b$var$_calendar.default
    }));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = module.exports.default = $f21a4850a620a60b$var$CalendarIcon;

});


parcelRegister("a4veM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e76285c05121d09b5530c84747e7dee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $755282378a541b7d$var$_react = $755282378a541b7d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $755282378a541b7d$var$_checkMark = $755282378a541b7d$var$_interopRequireDefault((parcelRequire("j52dF")));

var $755282378a541b7d$var$_done = $755282378a541b7d$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $755282378a541b7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $755282378a541b7d$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $755282378a541b7d$var$_react.default.createElement($755282378a541b7d$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $755282378a541b7d$var$_done.default
    }, props));
$755282378a541b7d$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $755282378a541b7d$var$_default = module.exports.default = $755282378a541b7d$var$CheckMarkIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43db9d99c93083272e0c42b874af3704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});


parcelRegister("55rBA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e7cbe01e7ce8ba6374c03599111e8e9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b42d5391ed5c1b6$var$_react = $3b42d5391ed5c1b6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3b42d5391ed5c1b6$var$_edit = $3b42d5391ed5c1b6$var$_interopRequireDefault((parcelRequire("e5yQJ")));

var $3b42d5391ed5c1b6$var$_editFilled = $3b42d5391ed5c1b6$var$_interopRequireDefault((parcelRequire("89sIt")));
function $3b42d5391ed5c1b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b42d5391ed5c1b6$var$EditIcon = (props)=>/*#__PURE__*/ $3b42d5391ed5c1b6$var$_react.default.createElement($3b42d5391ed5c1b6$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $3b42d5391ed5c1b6$var$_editFilled.default
    }, props));
$3b42d5391ed5c1b6$var$EditIcon.Name = 'EditIconMigration';
var $3b42d5391ed5c1b6$var$_default = module.exports.default = $3b42d5391ed5c1b6$var$EditIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32c191357b748545769418a2438f72bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9m-.75-4 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 8.979 9.521c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});

parcelRegister("89sIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef570750d61ee3c$var$_react = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5ef570750d61ee3c$var$_edit = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $5ef570750d61ee3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5ef570750d61ee3c$var$EditFilledIcon = (props)=>/*#__PURE__*/ $5ef570750d61ee3c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $5ef570750d61ee3c$var$_edit.default
    }));
$5ef570750d61ee3c$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $5ef570750d61ee3c$var$_default = module.exports.default = $5ef570750d61ee3c$var$EditFilledIcon;

});


const $8be63d4b94780ed6$export$71efb3495f6084f2 = 'done';
const $8be63d4b94780ed6$export$cd8e68094cb5c3cb = 'updated';
const $8be63d4b94780ed6$export$ff39ebd4bb12b718 = 'created';
const $8be63d4b94780ed6$export$ee74b0b7e193b0b0 = 'due';

parcelRegister("6of26", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0522185efafeba$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9d0522185efafeba$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    doneItems: {
        "id": "business-summary.summary-view.overview-items.overview-card.done-items",
        "defaultMessage": "{titleStart}{count} done{titleEnd} in the last 7 days"
    },
    updatedItems: {
        "id": "business-summary.summary-view.overview-items.overview-card.updated-items",
        "defaultMessage": "{titleStart}{count} updated{titleEnd} in the last 7 days"
    },
    createdItems: {
        "id": "business-summary.summary-view.overview-items.overview-card.created-items",
        "defaultMessage": "{titleStart}{count} created{titleEnd} in the last 7 days"
    },
    dueItems: {
        "id": "business-summary.summary-view.overview-items.overview-card.due-items",
        "defaultMessage": "{titleStart}{count} due{titleEnd} in the next 7 days"
    }
});

});



parcelRegister("3lpii", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bd1f6837ea232e1$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $2nj0g = parcelRequire("2nj0g");

var $5vRmQ = parcelRequire("5vRmQ");

var $63e1b = parcelRequire("63e1b");


var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");


var $RZsVl = parcelRequire("RZsVl");

var $71CzX = parcelRequire("71CzX");

var $105cx = parcelRequire("105cx");

var $6s7Z0 = parcelRequire("6s7Z0");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $apShl = parcelRequire("apShl");

var $a2EFr = parcelRequire("a2EFr");

var $izUon = parcelRequire("izUon");

var $jTuwe = parcelRequire("jTuwe");

var $6cwrM = parcelRequire("6cwrM");

var $bWbSz = parcelRequire("bWbSz");

var $cGyoW = parcelRequire("cGyoW");

var $aQb6f = parcelRequire("aQb6f");

var $adNiF = parcelRequire("adNiF");

var $1iSd9 = parcelRequire("1iSd9");

var $h2Twx = parcelRequire("h2Twx");
$5vRmQ.use([
    (0, $2nj0g.install),
    (0, $63e1b.install)
]);
const $2bd1f6837ea232e1$var$CHART_STYLE = {
    height: '240px'
};
const $2bd1f6837ea232e1$var$CHART_OPTIONS = {
    renderer: 'svg'
};
const $2bd1f6837ea232e1$var$calculatePercentage = (currentEntryCount, chartTotalCount)=>Math.round(currentEntryCount / (chartTotalCount === 0 ? 1 : chartTotalCount) * 100);
const $2bd1f6837ea232e1$var$ProgressByStatus = ({ position: position })=>{
    // Type of `EChartsInstance` is `any` within the `echarts-for-react` package.
    // Importing `EChartsInstance` from `echarts-for-react` introduces an additional 1.91MB to the bundle just to import an `any`.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [echartsInstance, setEchartsInstance] = (0, $eUqFw.useState)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, loading: loading } = (0, $cGyoW.useIssuesByStatus)();
    const { hasCreateItem: hasCreateItem, linksTarget: linksTarget, urlBuilder: urlBuilder } = (0, $bWbSz.useSummaryFeatures)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const isEnabledForTailoredOnboardingM2 = (0, $eI5EY.fg)('jira_tailored_onboarding_jtbd_feature_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $RZsVl.useIsTailoredOnboardingM2ForQuickstartEnabled)() : false;
    const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, $6cwrM.useSectionAnalytics)(position, 'progressByStatus');
    const chartData = (0, $eUqFw.useMemo)(()=>(0, $h2Twx.buildChartData)(data, urlBuilder), [
        data,
        urlBuilder
    ]);
    const chartEvents = (0, $eUqFw.useMemo)(()=>({
            click: ({ dataIndex: dataIndex })=>{
                if (chartData != null) {
                    const { value: value, categoryKey: categoryKey, link: link } = chartData.entries[dataIndex];
                    if (linksTarget === '_self') push(link);
                    else window.open(link, '_blank');
                    fireSectionAnalytics('viewWithFilter', {
                        count: value,
                        statusCategory: categoryKey
                    });
                }
            }
        }), [
        chartData,
        fireSectionAnalytics,
        push,
        linksTarget
    ]);
    const highlightEntry = (0, $eUqFw.useCallback)((dataIndex)=>{
        if (echartsInstance) {
            echartsInstance.dispatchAction({
                type: 'downplay'
            });
            echartsInstance.dispatchAction({
                type: 'highlight',
                dataIndex: dataIndex
            });
        }
    }, [
        echartsInstance
    ]);
    const handleAddStatusButtonClick = (0, $eUqFw.useCallback)(()=>{
        fireSectionAnalytics('addStatusInline');
    // TODO: trigger the platformised modal to add status
    }, [
        fireSectionAnalytics
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (echartsInstance && chartData) {
            highlightEntry(chartData.initialHighlight);
            // and set the mouse overed section to be highlighted after that
            echartsInstance.on('mouseover', 'series', ({ dataIndex: dataIndex })=>highlightEntry(dataIndex));
            return ()=>echartsInstance.off('mouseover');
        }
    }, [
        chartData,
        highlightEntry,
        echartsInstance
    ]);
    const viewAllLink = (0, $eUqFw.useMemo)(()=>`${urlBuilder('progressByStatus')}?filter=${encodeURIComponent((0, $41d3054f19febaab$export$8cca17e1017ba894))}&hideDone=false`, [
        urlBuilder
    ]);
    let content = null;
    if (!loading && chartData != null) {
        const isEmpty = chartData.totalCount === 0;
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.Description), null, isEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $adNiF.default).descriptionWhenEmpty), hasCreateItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTuwe.default), {
            href: `${urlBuilder('progressByStatus')}?inlineCreate=true`,
            onClick: ()=>fireSectionAnalytics('view', {
                    inlineCreate: true
                }),
            target: linksTarget
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            message: formatMessage((0, $adNiF.default).description, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            }),
            componentsMapping: {
                link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2EFr.default), {
                        href: viewAllLink,
                        target: linksTarget,
                        onClick: ()=>fireSectionAnalytics('view', {
                                inlineCreate: false
                            }),
                        "aria-label": formatMessage((0, $adNiF.default).viewAllItemsLabel)
                    }, children)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.ChartWrapper), null, isEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.EmptyChart), {
            testId: "business-summary.ui.summary-view.progress-by-status.empty-chart"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.Chart), {
            onChartReady: setEchartsInstance,
            echarts: $5vRmQ,
            option: chartData.option,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $2bd1f6837ea232e1$var$CHART_STYLE,
            opts: $2bd1f6837ea232e1$var$CHART_OPTIONS,
            onEvents: chartEvents
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.Legend), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendList), null, chartData.entries.map((entry, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendItem), {
                key: entry.name,
                onMouseEnter: ()=>highlightEntry(index)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendItemColor), {
                color: entry.itemStyle.color
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendItemName), null, entry.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendItemCount), {
                href: entry.link,
                target: linksTarget,
                onClick: ()=>fireSectionAnalytics('viewWithFilter', {
                        count: entry.value,
                        statusCategory: entry.categoryKey
                    }),
                onFocus: ()=>highlightEntry(index),
                "aria-label": formatMessage((0, $adNiF.default).tableCountersLabel, {
                    issuesCount: entry.value,
                    status: entry.name,
                    percentage: $2bd1f6837ea232e1$var$calculatePercentage(entry.value, chartData.totalCount)
                })
            }, entry.value)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendTotal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendItemName), null, formatMessage((0, $adNiF.default).total)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.LegendItemCount), {
            href: viewAllLink,
            target: linksTarget,
            onClick: ()=>fireSectionAnalytics('view', {
                    count: chartData.totalCount
                }),
            "aria-label": formatMessage((0, $adNiF.default).totalCountWithLabel, {
                issuesCount: chartData.totalCount
            })
        }, chartData.totalCount)), (0, $79xbN.expValEquals)('summary_page_inline_status', 'cohort', 'variation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQb6f.default), {
            onClick: handleAddStatusButtonClick
        }))));
    } else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "progress-by-status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1iSd9.CenteredSkeleton), {
        testId: "business-summary.ui.summary-view.progress-by-status.skeleton"
    }));
    if ((0, $71CzX.isUserEnrolledInTailoredOnboardingExperiment)() || isEnabledForTailoredOnboardingM2) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { ref: summaryViewNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $8379f5d78bf6fb5a$export$594d3436316492be), true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "business-summary-progress-by-status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.default), {
            ref: summaryViewNudgeRef,
            title: formatMessage((0, $adNiF.default).title),
            isLoading: loading,
            testId: "business-summary.ui.summary-view.progress-by-status",
            onPointerEnter: startHoverTimer,
            onPointerLeave: stopHoverTimer
        }, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6s7Z0.SummaryViewNudgeAsync), null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-progress-by-status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.default), {
        title: formatMessage((0, $adNiF.default).title),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.progress-by-status",
        onPointerEnter: startHoverTimer,
        onPointerLeave: stopHoverTimer
    }, content));
};
var $2bd1f6837ea232e1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2bd1f6837ea232e1$var$ProgressByStatus);

});
parcelRegister("2nj0g", function(module, exports) {

$parcel$export(module.exports, "install", () => $1bac786d22d308ff$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kPQAq = parcelRequire("kPQAq");

var $2Kh0U = parcelRequire("2Kh0U");

var $tMIqO = parcelRequire("tMIqO");

var $hzBt5 = parcelRequire("hzBt5");

var $fkHgv = parcelRequire("fkHgv");

var $jrFZl = parcelRequire("jrFZl");

var $ezwrl = parcelRequire("ezwrl");
function $1bac786d22d308ff$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $fkHgv.default));
    registers.registerSeriesModel((0, $jrFZl.default));
    (0, $kPQAq.createLegacyDataSelectAction)('pie', registers.registerAction);
    registers.registerLayout((0, $hzBt5.curry)((0, $2Kh0U.default), 'pie'));
    registers.registerProcessor((0, $tMIqO.default)('pie'));
    registers.registerProcessor((0, $ezwrl.default)('pie'));
}

});
parcelRegister("2Kh0U", function(module, exports) {

$parcel$export(module.exports, "getBasicPieLayout", () => $1ffd133346e2c15b$export$2a0d4d5b12383eb9);
$parcel$export(module.exports, "default", () => $1ffd133346e2c15b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

var $e4mIu = parcelRequire("e4mIu");

var $hzBt5 = parcelRequire("hzBt5");
var $1ffd133346e2c15b$var$PI2 = Math.PI * 2;
var $1ffd133346e2c15b$var$RADIAN = Math.PI / 180;
function $1ffd133346e2c15b$var$getViewRect(seriesModel, api) {
    return $e4mIu.getLayoutRect(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $1ffd133346e2c15b$export$2a0d4d5b12383eb9(seriesModel, api) {
    var viewRect = $1ffd133346e2c15b$var$getViewRect(seriesModel, api);
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');
    if (!$hzBt5.isArray(radius)) radius = [
        0,
        radius
    ];
    if (!$hzBt5.isArray(center)) center = [
        center,
        center
    ];
    var width = (0, $5BQXp.parsePercent)(viewRect.width, api.getWidth());
    var height = (0, $5BQXp.parsePercent)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var cx = (0, $5BQXp.parsePercent)(center[0], width) + viewRect.x;
    var cy = (0, $5BQXp.parsePercent)(center[1], height) + viewRect.y;
    var r0 = (0, $5BQXp.parsePercent)(radius[0], size / 2);
    var r = (0, $5BQXp.parsePercent)(radius[1], size / 2);
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r
    };
}
function $1ffd133346e2c15b$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var viewRect = $1ffd133346e2c15b$var$getViewRect(seriesModel, api);
        var _a = $1ffd133346e2c15b$export$2a0d4d5b12383eb9(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
        var startAngle = -seriesModel.get('startAngle') * $1ffd133346e2c15b$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $1ffd133346e2c15b$var$RADIAN;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim); // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get('clockwise');
        var roseType = seriesModel.get('roseType');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0; // In the case some sector angle is smaller than minAngle
        var restAngle = $1ffd133346e2c15b$var$PI2;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        var dir = clockwise ? 1 : -1;
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== 'area') angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = $1ffd133346e2c15b$var$PI2 / validDataCount;
            if (angle < minAngle) {
                angle = minAngle;
                restAngle -= minAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: currentAngle,
                endAngle: endAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $5BQXp.linearMap)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        }); // Some sector is constrained by minAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $1ffd133346e2c15b$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle
            if (restAngle <= 1e-3) {
                var angle_1 = $1ffd133346e2c15b$var$PI2 / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_1 = data.getItemLayout(idx);
                        layout_1.angle = angle_1;
                        layout_1.startAngle = startAngle + dir * idx * angle_1;
                        layout_1.endAngle = startAngle + dir * (idx + 1) * angle_1;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_2 = data.getItemLayout(idx);
                        var angle = layout_2.angle === minAngle ? minAngle : value * unitRadian;
                        layout_2.startAngle = currentAngle;
                        layout_2.endAngle = currentAngle + dir * angle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}

});

parcelRegister("tMIqO", function(module, exports) {

$parcel$export(module.exports, "default", () => $05987f7587021892$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $05987f7587021892$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: 'legend'
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx); // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}

});

parcelRegister("fkHgv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29a48d42c7d672b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $hXAsm = parcelRequire("hXAsm");
var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $9dsiU = parcelRequire("9dsiU");
var $rnA7j = parcelRequire("rnA7j");
var $9ubot = parcelRequire("9ubot");
var $kiooD = parcelRequire("kiooD");

var $51xyq = parcelRequire("51xyq");

var $azEx8 = parcelRequire("azEx8");

var $5dM9X = parcelRequire("5dM9X");

var $1n5dQ = parcelRequire("1n5dQ");

var $hcRXD = parcelRequire("hcRXD");

var $ioBbI = parcelRequire("ioBbI");

var $9ubot = parcelRequire("9ubot");

var $2Kh0U = parcelRequire("2Kh0U");
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $b29a48d42c7d672b$var$PiePiece = /** @class */ function(_super) {
    (0, $fKE23.__extends)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $kiooD.default();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = data.getItemLayout(idx); // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $hzBt5.extend)((0, $ioBbI.getSectorCornerRadius)(itemModel.getModel('itemStyle'), layout, true), layout); // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow('animationType');
            if (animationType === 'scale') {
                sector.shape.r = layout.r0;
                $9ubot.initProps(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $9ubot.initProps(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $9ubot.updateProps(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $9ubot.saveOldStyle)(sector); // Transition animation from the old shape
            $9ubot.updateProps(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, 'style'));
        (0, $51xyq.setStatesStylesFromModel)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get('selectedOffset');
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState('emphasis').shape = (0, $fKE23.__assign)({
            r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
        }, (0, $ioBbI.getSectorCornerRadius)(emphasisModel.getModel('itemStyle'), layout));
        (0, $hzBt5.extend)(sector.ensureState('select'), {
            x: dx,
            y: dy,
            shape: (0, $ioBbI.getSectorCornerRadius)(itemModel.getModel([
                'select',
                'itemStyle'
            ]), layout)
        });
        (0, $hzBt5.extend)(sector.ensureState('blur'), {
            shape: (0, $ioBbI.getSectorCornerRadius)(itemModel.getModel([
                'blur',
                'itemStyle'
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $hzBt5.extend)(labelLine.ensureState('select'), {
            x: dx,
            y: dy
        }); // TODO: needs dx, dy in zrender?
        (0, $hzBt5.extend)(labelText.ensureState('select'), {
            x: dx,
            y: dy
        });
        (0, $51xyq.enableHoverEmphasis)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel('labelLine');
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $hcRXD.setLabelStyle)(sector, (0, $hcRXD.getLabelStatesModels)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
        });
        var labelText = sector.getTextContent(); // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        }); // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = seriesModel.get([
            'label',
            'position'
        ]);
        if (labelPosition !== 'outside' && labelPosition !== 'outer') sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $9dsiU.default();
                this.setTextGuideLine(polyline);
            } // Default use item visual color
            (0, $1n5dQ.setLabelLineStyle)(this, (0, $1n5dQ.getLabelLineStatesModels)(itemModel), {
                stroke: visualColor,
                opacity: (0, $hzBt5.retrieve3)(labelLineModel.get([
                    'lineStyle',
                    'opacity'
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($rnA7j.default); // Pie view
var $b29a48d42c7d672b$var$PieView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.init = function() {
        var sectorGroup = new $hXAsm.default();
        this._sectorGroup = sectorGroup;
    };
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle; // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        } // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
         // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
            var sector = new $rnA7j.default({
                shape: (0, $2Kh0U.getBasicPieLayout)(seriesModel, api)
            });
            sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $b29a48d42c7d672b$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off('click');
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $9ubot.removeElementWithFadeOut(piePiece, seriesModel, idx);
        }).execute();
        (0, $5dM9X.default)(seriesModel); // Always use initial animation.
        if (seriesModel.get('animationTypeUpdate') !== 'expansion') this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = 'pie';
    return PieView;
}((0, $azEx8.default));
var $b29a48d42c7d672b$export$2e2bcd8739ae039 = $b29a48d42c7d672b$var$PieView;

});
parcelRegister("5dM9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cd386206c06fca8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position

var $5BQXp = parcelRequire("5BQXp");

var $4vVC3 = parcelRequire("4vVC3");

var $hzBt5 = parcelRequire("hzBt5");

var $1n5dQ = parcelRequire("1n5dQ");

var $hJQJ0 = parcelRequire("hJQJ0");
var $3cd386206c06fca8$var$RADIAN = Math.PI / 180;
function $3cd386206c06fca8$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy); // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA; // Use ellipse implicit function to calculate x
            var dx = Math.sqrt((1 - Math.abs(dy * dy / rB2)) * rA2);
            item.label.x = cx + (dx + item.len2) * dir;
        }
    } // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== 'none') continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy > semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir; // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len; // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $hJQJ0.shiftLayoutOnY)(list, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $3cd386206c06fca8$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($3cd386206c06fca8$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    $3cd386206c06fca8$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $3cd386206c06fca8$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        if ($3cd386206c06fca8$var$isPositionCenter(layout)) continue;
        var linePoints = layout.linePoints;
        if (linePoints) {
            var isAlignToEdge = layout.labelAlignTo === 'edge';
            var realTextWidth = layout.rect.width;
            var targetTextWidth = void 0;
            if (isAlignToEdge) {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            if (targetTextWidth < layout.rect.width) {
                // TODOTODO
                // layout.text = textContain.truncateText(layout.text, targetTextWidth, layout.font);
                layout.label.style.width = targetTextWidth;
                if (layout.labelAlignTo === 'edge') realTextWidth = targetTextWidth; // realTextWidth = textContain.getWidth(layout.text, layout.font);
            }
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
function $3cd386206c06fca8$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === 'center';
}
function $3cd386206c06fca8$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * $3cd386206c06fca8$var$RADIAN;
    var viewRect = data.getLayout('viewRect');
    var r = data.getLayout('r');
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis
        var labelPosition = labelModel.get('position') || itemModel.get([
            'emphasis',
            'label',
            'position'
        ]);
        var labelDistance = labelModel.get('distanceToLabelLine');
        var labelAlignTo = labelModel.get('alignTo');
        var edgeDistance = (0, $5BQXp.parsePercent)(labelModel.get('edgeDistance'), viewWidth);
        var bleedMargin = labelModel.get('bleedMargin');
        var labelLineModel = itemModel.getModel('labelLine');
        var labelLineLen = labelLineModel.get('length');
        labelLineLen = (0, $5BQXp.parsePercent)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get('length2');
        labelLineLen2 = (0, $5BQXp.parsePercent)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $hzBt5.each)(label.states, setNotShow);
            label.ignore = true;
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
        if (labelPosition === 'center') {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = 'center';
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === 'edge') // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
        }
        var labelRotate;
        var rotate = labelModel.get('rotate');
        if (typeof rotate === 'number') labelRotate = rotate * (Math.PI / 180);
        else if (labelPosition === 'center') labelRotate = 0;
        else {
            var radialAngle = nx < 0 ? -midAngle + Math.PI : -midAngle;
            if (rotate === 'radial' || rotate === true) labelRotate = radialAngle;
            else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
                labelRotate = radialAngle + Math.PI / 2;
                if (labelRotate > Math.PI / 2) labelRotate -= Math.PI;
            } else labelRotate = 0;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: 'middle'
        }); // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = label.getBoundingRect().clone();
            textRect.applyTransform(label.getComputedTransform()); // Text has a default 1px stroke. Exclude this.
            var margin = (label.style.margin || 0) + 2.1;
            textRect.y -= margin / 2;
            textRect.height += margin;
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get('minTurnAngle'),
                maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
                surfaceNormal: new (0, $4vVC3.default)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) $3cd386206c06fca8$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $hzBt5.each)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $hzBt5.each)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $1n5dQ.limitTurnAngle)(linePoints, layout.minTurnAngle);
                (0, $1n5dQ.limitSurfaceAngle)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                }); // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $4vVC3.default)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}

});

parcelRegister("ioBbI", function(module, exports) {

$parcel$export(module.exports, "getSectorCornerRadius", () => $d647509f55d0ee2b$export$b395eeeb2ad7cce5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");
function $d647509f55d0ee2b$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get('borderRadius');
    if (cornerRadius == null) return zeroIfNull ? {
        innerCornerRadius: 0,
        cornerRadius: 0
    } : null;
    if (!(0, $hzBt5.isArray)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius
    ];
    return {
        innerCornerRadius: (0, $02NbV.parsePercent)(cornerRadius[0], shape.r0),
        cornerRadius: (0, $02NbV.parsePercent)(cornerRadius[1], shape.r)
    };
}

});


parcelRegister("jrFZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2811bfb9c619e5f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $fTlmM = parcelRequire("fTlmM");

var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $5BQXp = parcelRequire("5BQXp");

var $be33G = parcelRequire("be33G");

var $4G1mx = parcelRequire("4G1mx");

var $5vVec = parcelRequire("5vVec");
var $e2811bfb9c619e5f$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $4G1mx.default)($hzBt5.bind(this.getData, this), $hzBt5.bind(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $fTlmM.default)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $hzBt5.curry((0, $be33G.makeSeriesEncodeForNameBased), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        var params = _super.prototype.getDataParams.call(this, dataIndex); // FIXME toFixed?
        var valueList = [];
        data.each(data.mapDimension('value'), function(value) {
            valueList.push(value);
        });
        params.percent = (0, $5BQXp.getPercentWithPrecision)(valueList, dataIndex, data.hostModel.get('percentPrecision'));
        params.$vars.push('percent');
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $ckizb.defaultEmphasis(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = 'series.pie';
    PieSeriesModel.defaultOption = {
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '75%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: 'truncate',
            // 'outer', 'inside', 'center'
            position: 'outer',
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: 'none',
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: '25%',
            // Works only position is 'outer' and alignTo is not 'edge'.
            bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 15,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: 'solid'
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: 'round'
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: 'lightgray',
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: 'expansion',
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: 'transition',
        animationEasingUpdate: 'cubicInOut',
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut'
    };
    return PieSeriesModel;
}((0, $5vVec.default));
var $e2811bfb9c619e5f$export$2e2bcd8739ae039 = $e2811bfb9c619e5f$var$PieSeriesModel;

});
parcelRegister("fTlmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91c91014c0fe7ce$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jrSv6 = parcelRequire("jrSv6");

var $kyX7l = parcelRequire("kyX7l");

var $hzBt5 = parcelRequire("hzBt5");
function $b91c91014c0fe7ce$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $hzBt5.isArray)(opt) && {
        coordDimensions: opt
    } || (0, $hzBt5.extend)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $jrSv6.default)(source, opt).dimensions;
    var list = new (0, $kyX7l.default)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}

});

parcelRegister("4G1mx", function(module, exports) {

$parcel$export(module.exports, "default", () => $367c243e4275fbaa$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $367c243e4275fbaa$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $367c243e4275fbaa$export$2e2bcd8739ae039 = $367c243e4275fbaa$var$LegendVisualProvider;

});


parcelRegister("ezwrl", function(module, exports) {

$parcel$export(module.exports, "default", () => $02bcdce5067afee8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $02bcdce5067afee8$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension('value');
                var curValue = data.get(valueDim, idx);
                if (typeof curValue === 'number' && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}

});


// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $8379f5d78bf6fb5a$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $8379f5d78bf6fb5a$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("RZsVl", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $c3486dd8f5cb43fa$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $c3486dd8f5cb43fa$export$c89644b13b6e777f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $c3486dd8f5cb43fa$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $c3486dd8f5cb43fa$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $c3486dd8f5cb43fa$export$6bc15f8ade1cf36);
$parcel$export(module.exports, "useFireExposureForTailoredOnboardingM2ForQuickstart", () => $c3486dd8f5cb43fa$export$369994803661d31);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $1R3n5 = parcelRequire("1R3n5");

var $WBLbN = parcelRequire("WBLbN");

var $3dMdu = parcelRequire("3dMdu");

var $d4w6a = parcelRequire("d4w6a");

var $2vErl = parcelRequire("2vErl");

var $l1u3T = parcelRequire("l1u3T");
const $c3486dd8f5cb43fa$var$store = (0, $WBLbN.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $3dMdu.initialCachedEndpointState),
    actions: $d4w6a.actions
});
const $c3486dd8f5cb43fa$export$5b1d43353c334c00 = (0, $WBLbN.createActionsHook)($c3486dd8f5cb43fa$var$store);
const $c3486dd8f5cb43fa$export$31a443426d101362 = (0, $WBLbN.createHook)($c3486dd8f5cb43fa$var$store);
const $c3486dd8f5cb43fa$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    return isSiteAdmin && (0, $eI5EY.fg)('jira_tailored_onboarding_jtbd_feature_gate');
};
const $c3486dd8f5cb43fa$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $c3486dd8f5cb43fa$export$31a443426d101362();
    (0, $eUqFw.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $c3486dd8f5cb43fa$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $c3486dd8f5cb43fa$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $c3486dd8f5cb43fa$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $eUqFw.useRef)(false);
    const { data: data, isReady: isReady } = $c3486dd8f5cb43fa$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $2vErl.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'useTailoredOnboardingPersonalisationM2',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        hasSentErrorOnce.current = true;
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $c3486dd8f5cb43fa$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const isEnabled = (0, $l1u3T.isTailoredOnboardingM2ExperimentFlagEnabled)();
    const { isReady: personalisationDataIsReady, data: personalisationData } = $c3486dd8f5cb43fa$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: (0, $7ZZxN.CORE_PROJECT)
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0 && isEnabled);
};
const $c3486dd8f5cb43fa$export$369994803661d31 = ({ projectType: projectType })=>{
    const fgAddExposure = (0, $eI5EY.fg)('tailored_onboarding_m2_content_exposure_adjust');
    const isEligibleForJtbdOnboarding = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const { isReady: personalisationDataIsReady, data: personalisationData } = $c3486dd8f5cb43fa$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding && fgAddExposure,
        additionalParameters: {
            projectType: (0, $7ZZxN.CORE_PROJECT)
        }
    });
    if (fgAddExposure && projectType === (0, $7ZZxN.CORE_PROJECT) && personalisationDataIsReady && personalisationData.matched && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0) (0, $79xbN.expVal)('jira_tailored_onboarding_jtbd', 'isEnabled', false);
};

});
parcelRegister("3dMdu", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $38ffeb975058cb36$export$aaed2d023c5dc2c);
const $38ffeb975058cb36$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("d4w6a", function(module, exports) {

$parcel$export(module.exports, "actions", () => $220ef4c26e2d16b0$export$e324594224ef24da);

var $879e1 = parcelRequire("879e1");

var $5kFcG = parcelRequire("5kFcG");
const $220ef4c26e2d16b0$var$fetchOnboardingPersonalisation = (0, $879e1.cachedEndpointCall)((args)=>(0, $5kFcG.fetchOnboardingPersonalisationWithRethrow)(args));
const $220ef4c26e2d16b0$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $5kFcG.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $220ef4c26e2d16b0$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $220ef4c26e2d16b0$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $220ef4c26e2d16b0$var$trackPersonalisationAction
};

});
parcelRegister("879e1", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $08a4c99d11c890ab$export$9ab04ab45a9b99da);
const $08a4c99d11c890ab$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});

parcelRegister("5kFcG", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $3e8409fd087376e0$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $3e8409fd087376e0$export$9835c32b78102887);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gs0Be = parcelRequire("gs0Be");
const $3e8409fd087376e0$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $3e8409fd087376e0$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $3e8409fd087376e0$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $3e8409fd087376e0$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $gs0Be.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $3e8409fd087376e0$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $lRmyA.performPostRequestWithRetry)($3e8409fd087376e0$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $gs0Be.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3e8409fd087376e0$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $lRmyA.performPostRequestWithRetry)($3e8409fd087376e0$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("gs0Be", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $37ad103b17c04430$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $37ad103b17c04430$export$dda9cd59669fc243);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");
const $37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $37ad103b17c04430$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira-onboarding-personalisation');
const $37ad103b17c04430$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $37ad103b17c04430$var$localStorage.get($37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $37ad103b17c04430$export$dda9cd59669fc243 = (response)=>{
    try {
        $37ad103b17c04430$var$localStorage.set($37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("2vErl", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $e5c071bf4b0b6576$export$1d38dc41bb005254);

var $4MMft = parcelRequire("4MMft");
const $e5c071bf4b0b6576$export$1d38dc41bb005254 = [
    (0, $4MMft.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $4MMft.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("4MMft", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $bea62c923aa19b28$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $bea62c923aa19b28$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $bea62c923aa19b28$export$517f94ab07724226);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");
// Roles defined in user segmentation
const $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $bea62c923aa19b28$export$572242e58bd07594 = 'customer-service';
const $bea62c923aa19b28$export$d7de553940261eba = 'it-support';
const $bea62c923aa19b28$export$4c29d0d04c15e55d = 'human-resources';
const $bea62c923aa19b28$export$3950f7f841bf94b6 = 'finance';
const $bea62c923aa19b28$export$881249b988b6030f = 'legal';
const $bea62c923aa19b28$export$e4824f74b9879164 = 'marketing';
const $bea62c923aa19b28$export$4f3cb0844009af52 = 'operations';
const $bea62c923aa19b28$export$1a65d50c4a641bb4 = 'sales';
const $bea62c923aa19b28$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $bea62c923aa19b28$export$2f3f9640393bd078 = 'unknown';
const $bea62c923aa19b28$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$bea62c923aa19b28$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$bea62c923aa19b28$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$bea62c923aa19b28$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$bea62c923aa19b28$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$bea62c923aa19b28$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$bea62c923aa19b28$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$bea62c923aa19b28$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$bea62c923aa19b28$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$bea62c923aa19b28$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES = [
    $bea62c923aa19b28$export$4c29d0d04c15e55d,
    $bea62c923aa19b28$export$3950f7f841bf94b6,
    $bea62c923aa19b28$export$881249b988b6030f,
    $bea62c923aa19b28$export$e4824f74b9879164,
    $bea62c923aa19b28$export$4f3cb0844009af52,
    $bea62c923aa19b28$export$1a65d50c4a641bb4,
    $bea62c923aa19b28$export$b8b1ac856ba1434b
];
const $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$bea62c923aa19b28$export$4c29d0d04c15e55d]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$3950f7f841bf94b6]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$881249b988b6030f]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$e4824f74b9879164]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$4f3cb0844009af52]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$1a65d50c4a641bb4]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$b8b1ac856ba1434b]: [
        $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $bea62c923aa19b28$var$getNormalizedEntryNew = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $bea62c923aa19b28$var$getNormalizedEntry = (value)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(([, translatedValues])=>translatedValues.includes(value));
const $bea62c923aa19b28$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $bea62c923aa19b28$export$4c9a72dac5ce80ae;
    const normalizedEntry = (0, $1ybV0.ff)('use-upaas-to-display-template-picker-if-user-seg-is-unknown') ? $bea62c923aa19b28$var$getNormalizedEntryNew(value) : $bea62c923aa19b28$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $bea62c923aa19b28$export$2f3f9640393bd078;
};
class $bea62c923aa19b28$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $bea62c923aa19b28$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $guiFP.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $bea62c923aa19b28$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $bea62c923aa19b28$export$b8b1ac856ba1434b;
};
const $bea62c923aa19b28$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $bea62c923aa19b28$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $bea62c923aa19b28$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});


parcelRegister("l1u3T", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingM2ExperimentFlagEnabled", () => $e0f085336195173f$export$4f4879e3b4202c87);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");
const $e0f085336195173f$export$4f4879e3b4202c87 = ()=>{
    const defaultValue = (0, $eI5EY.fg)('tailored_onboarding_m2_content_exposure_adjust') ? undefined : false;
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_tailored_onboarding_jtbd');
    return expConfig.get('isEnabled', defaultValue);
};

});


parcelRegister("105cx", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $4897a924f3a2c5b3$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $4897a924f3a2c5b3$export$74f8d45d75dfda4f);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9WJJx = parcelRequire("9WJJx");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $4897a924f3a2c5b3$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $4897a924f3a2c5b3$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $4897a924f3a2c5b3$var$useNudgeController = ()=>$4897a924f3a2c5b3$var$NudgeController.instance;
const $4897a924f3a2c5b3$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $4897a924f3a2c5b3$var$useHasNudgeTargetNode = (id)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $eUqFw.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $4897a924f3a2c5b3$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $eUqFw.useState)(null);
    const frameId = (0, $eUqFw.useRef)(null);
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $4897a924f3a2c5b3$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $4897a924f3a2c5b3$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $4897a924f3a2c5b3$var$usePortalContainer();
    const hasRefValue = $4897a924f3a2c5b3$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $4897a924f3a2c5b3$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $eUqFw.useRef)(innerRectangle);
    const spotlightRef = (0, $eUqFw.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $eUqFw.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("6s7Z0", function(module, exports) {

$parcel$export(module.exports, "SummaryViewNudgeAsync", () => $1fabaaf24e552390$export$b531a7d8bb8249e7);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");


var $5cLMB = parcelRequire("5cLMB");


var $gRdGC = parcelRequire("gRdGC");
const $1fabaaf24e552390$var$runtimeProps = {};
const $1fabaaf24e552390$var$entryPointParams = {};
const $1fabaaf24e552390$export$b531a7d8bb8249e7 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $gRdGC.summaryViewNudgeEntryPoint), $1fabaaf24e552390$var$entryPointParams);
    const [nudgeStep] = (0, $5cLMB.useNudgeStep)();
    const [hasNudgeActive] = (0, $5cLMB.useHasNudgeActive)();
    const firstLoadRef = (0, $eUqFw.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $8379f5d78bf6fb5a$export$594d3436316492be)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$cf1943561be3a3c2),
        packageName: "jiraSummaryViewOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $1fabaaf24e552390$var$runtimeProps
    });
};

});
parcelRegister("gRdGC", function(module, exports) {

$parcel$export(module.exports, "summaryViewNudgeEntryPoint", () => $974bc8c31f0da548$export$81d6d191a3f971f5);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $974bc8c31f0da548$export$81d6d191a3f971f5 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("9kpbT")), {
        moduleId: "46bfac13"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9kpbT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gSot7").then(()=>parcelRequire('PRjHQ'));

});



parcelRegister("aQb6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a752079dd3c03c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $lxfVR = parcelRequire("lxfVR");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i7uQc = parcelRequire("i7uQc");
const $25a752079dd3c03c$var$AddStatusIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $25a752079dd3c03c$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lxfVR))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))),
        LEGACY_size: "small",
        color: "var(--ds-icon, #44546F)"
    }));
const $25a752079dd3c03c$var$AddStatusButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $25a752079dd3c03c$var$dividerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: onClick,
        padding: "space.025",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $25a752079dd3c03c$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25a752079dd3c03c$var$AddStatusIcon, null), formatMessage((0, $i7uQc.default).addStatus)));
};
var $25a752079dd3c03c$export$2e2bcd8739ae039 = $25a752079dd3c03c$var$AddStatusButton;
const $25a752079dd3c03c$var$ICON_SIZE = 24;
const $25a752079dd3c03c$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    height: `${$25a752079dd3c03c$var$ICON_SIZE}px`,
    width: `${$25a752079dd3c03c$var$ICON_SIZE}px`,
    borderRadius: 'border.radius',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral',
    marginLeft: 'space.025',
    marginRight: 'space.050'
});
const $25a752079dd3c03c$var$dividerStyles = (0, $1ZAYh.xcss)({
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    paddingTop: 'space.100',
    marginTop: 'space.100'
});
const $25a752079dd3c03c$var$buttonStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'border.radius',
    borderWidth: '1px',
    marginBottom: 'space.100',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text'
    }
});

});
parcelRegister("i7uQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee77c66bc19ffe70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ee77c66bc19ffe70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addStatus: {
        "id": "business-summary.summary-view.progress-by-status.add-status-button.add-status",
        "defaultMessage": "Add status"
    }
});

});


parcelRegister("adNiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4162804c41c03066$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4162804c41c03066$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "business-summary.summary-view.progress-by-status.title",
        "defaultMessage": "Status overview"
    },
    description: {
        "id": "business-summary.summary-view.progress-by-status.description",
        "defaultMessage": "Get a snapshot of the status of your items. {linkStart}View all items{linkEnd}"
    },
    viewAllItemsLabel: {
        "id": "business-summary.summary-view.progress-by-status.view-all-items-label",
        "defaultMessage": "View all issues with the status listed in the chart"
    },
    descriptionWhenEmpty: {
        "id": "business-summary.summary-view.progress-by-status.description-when-empty",
        "defaultMessage": "You'll need to create a few items for your project to get a status overview on the team's progress."
    },
    tableCountersLabel: {
        "id": "business-summary.summary-view.progress-by-status.table-counters-label",
        "defaultMessage": "{issuesCount, number} {issuesCount, plural, one {issue} other {issues}}, {percentage}% with the {status} status"
    },
    totalCountWithLabel: {
        "id": "business-summary.summary-view.progress-by-status.total-count-with-label",
        "defaultMessage": "Total {issuesCount, number} {issuesCount, plural, one {issue} other {issues}}"
    },
    total: {
        "id": "business-summary.summary-view.progress-by-status.total",
        "defaultMessage": "Total"
    }
});

});

parcelRegister("1iSd9", function(module, exports) {

$parcel$export(module.exports, "CenteredSkeleton", () => $b03bd65277fd55ff$export$8faa72715fd79c70);
$parcel$export(module.exports, "Description", () => $b03bd65277fd55ff$export$393edc798c47379d);
$parcel$export(module.exports, "ChartWrapper", () => $b03bd65277fd55ff$export$b9dcbe7159acfdce);
$parcel$export(module.exports, "Chart", () => $b03bd65277fd55ff$export$acaa6426d77a227e);
$parcel$export(module.exports, "EmptyChart", () => $b03bd65277fd55ff$export$41a1e905224db08);
$parcel$export(module.exports, "Legend", () => $b03bd65277fd55ff$export$ed247974535929c7);
$parcel$export(module.exports, "LegendList", () => $b03bd65277fd55ff$export$837fa44b17e0c23);
$parcel$export(module.exports, "LegendItemColor", () => $b03bd65277fd55ff$export$3653d20b79249348);
$parcel$export(module.exports, "LegendItem", () => $b03bd65277fd55ff$export$590bd3a1b15e3e13);
$parcel$export(module.exports, "LegendItemName", () => $b03bd65277fd55ff$export$3457a2f79a1f9283);
$parcel$export(module.exports, "LegendItemCount", () => $b03bd65277fd55ff$export$3d82ef0a867249db);
$parcel$export(module.exports, "LegendTotal", () => $b03bd65277fd55ff$export$d95dac908204464);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $2JyHi = parcelRequire("2JyHi");


var $lB25E = parcelRequire("lB25E");

var $2koDI = parcelRequire("2koDI");
const $b03bd65277fd55ff$export$8faa72715fd79c70 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $2koDI.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$b9dcbe7159acfdce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1tkeidpf _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$acaa6426d77a227e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, (/*@__PURE__*/$parcel$interopDefault($2JyHi))), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1ssb",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$var$EmptyChartSvg = ({ className: className, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        viewBox: "0 0 100 100",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "50",
        cy: "50",
        r: "36",
        stroke: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`,
        strokeWidth: "22.5",
        fill: "none"
    }));
const $b03bd65277fd55ff$export$41a1e905224db08 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b03bd65277fd55ff$var$EmptyChartSvg, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1ssb _1bsbp3fh _4t3ip3fh",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$ed247974535929c7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1ssb _vchhusvi _1ul9idpf _c71l1osq _2hwxx0bf _u5f3u2gc _18m91wug _19bv1ejb _k48pbfng _syazc8hx",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$837fa44b17e0c23 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$3653d20b79249348 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1cj8 _16jlidpf _1o9zidpf _i0dl1wug _1bsb7vkz _4t3i7vkz _2hwxu2gc _2rko1l7b _16qs6u33 _tzy417j0",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$590bd3a1b15e3e13 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _otyr1b66 _1yt41xzv _2rko1l7b _zlc4kb7n _30l31fxt _irr3k6hx _1wnun8xv",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$3457a2f79a1f9283 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$3d82ef0a867249db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b03bd65277fd55ff$export$d95dac908204464 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _1yt4fnvl _k48p1fw0 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2koDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b00239e582c1b06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $6b00239e582c1b06$var$Skeleton = ({ className: className, testId: testId })=>{
    const skeletonColor = `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 476 296",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "476",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "16",
        width: "320",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M240 176C240 242.274 186.274 296 120 296C53.7258 296 0 242.274 0 176C0 109.726 53.7258 56 120 56C186.274 56 240 109.726 240 176ZM60 176C60 209.137 86.8629 236 120 236C153.137 236 180 209.137 180 176C180 142.863 153.137 116 120 116C86.8629 116 60 142.863 60 176Z",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M120 56C145.342 56 170.033 64.0226 190.534 78.918C211.036 93.8133 226.296 114.817 234.127 138.918C241.958 163.019 241.958 188.981 234.127 213.082C226.296 237.183 211.036 258.187 190.534 273.082C170.033 287.977 145.341 296 120 296C94.6585 296 69.9675 287.977 49.4658 273.082C28.964 258.187 13.7042 237.183 5.87321 213.082C-1.95774 188.981 -1.95774 163.019 5.87322 138.918L62.9366 157.459C59.0211 169.51 59.0211 182.49 62.9366 194.541C66.8521 206.592 74.482 217.093 84.7329 224.541C94.9837 231.989 107.329 236 120 236C132.671 236 145.016 231.989 155.267 224.541C165.518 217.093 173.148 206.592 177.063 194.541C180.979 182.49 180.979 169.51 177.063 157.459C173.148 145.408 165.518 134.907 155.267 127.459C145.016 120.011 132.671 116 120 116V56Z",
        fill: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M120 56C138.937 56 157.606 60.4819 174.479 69.0792C191.352 77.6765 205.951 90.1452 217.082 105.466C228.213 120.786 235.56 138.524 238.523 157.228C241.485 175.932 239.979 195.072 234.127 213.082L177.063 194.541C179.989 185.536 180.743 175.966 179.261 166.614C177.78 157.262 174.107 148.393 168.541 140.733C162.975 133.073 155.676 126.838 147.239 122.54C138.803 118.241 129.469 116 120 116L120 56Z",
        fill: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "280",
        y: "104",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "320",
        y: "112",
        width: "120",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "280",
        y: "144",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "320",
        y: "152",
        width: "120",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "280",
        y: "184",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "320",
        y: "192",
        width: "120",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "280",
        y: "224",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "320",
        y: "232",
        width: "120",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }));
};
var $6b00239e582c1b06$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6b00239e582c1b06$var$Skeleton);

});


parcelRegister("h2Twx", function(module, exports) {

$parcel$export(module.exports, "buildChartData", () => $35593d96f3ff92bd$export$bbcf2eea793fdd45);


var $c9TLT = parcelRequire("c9TLT");
const $35593d96f3ff92bd$var$NEUTRAL = [
    (0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb),
    `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`
];
const $35593d96f3ff92bd$var$BLUE = [
    (0, $73a5c9d720aa66e1$export$215b7063051591f1),
    (0, $73a5c9d720aa66e1$export$e62e8919cca44969)
];
const $35593d96f3ff92bd$var$GREEN = [
    (0, $73a5c9d720aa66e1$export$747d86715d4175de),
    (0, $73a5c9d720aa66e1$export$940e1f69e873f202)
];
const $35593d96f3ff92bd$var$YELLOW = [
    (0, $73a5c9d720aa66e1$export$5aae31392d72caaa),
    (0, $73a5c9d720aa66e1$export$c6930421db9fa514)
];
const $35593d96f3ff92bd$var$TEAL = [
    (0, $73a5c9d720aa66e1$export$69cb3ca10c1e330e),
    (0, $73a5c9d720aa66e1$export$9dc1ef0f3f48059b)
];
const $35593d96f3ff92bd$var$PURPLE = [
    (0, $73a5c9d720aa66e1$export$a7175d4e9206bc80),
    (0, $73a5c9d720aa66e1$export$b48405b95304b5a1)
];
const $35593d96f3ff92bd$var$RED = [
    (0, $73a5c9d720aa66e1$export$60847d42f9da92a6),
    (0, $73a5c9d720aa66e1$export$4a7404f376229999)
];
const $35593d96f3ff92bd$var$CATEGORY_COLORS = {
    new: $35593d96f3ff92bd$var$NEUTRAL,
    indeterminate: $35593d96f3ff92bd$var$BLUE,
    done: $35593d96f3ff92bd$var$GREEN
};
const $35593d96f3ff92bd$var$OTHER_COLORS = [
    $35593d96f3ff92bd$var$YELLOW,
    $35593d96f3ff92bd$var$TEAL,
    $35593d96f3ff92bd$var$PURPLE,
    $35593d96f3ff92bd$var$RED
];
const $35593d96f3ff92bd$var$StatusCategoryOrder = {
    new: 0,
    indeterminate: 1,
    done: 2
};
const $35593d96f3ff92bd$export$bbcf2eea793fdd45 = (data, urlBuilder)=>{
    if (data == null) return null;
    const categoryColors = {
        ...$35593d96f3ff92bd$var$CATEGORY_COLORS
    };
    let otherColors;
    let totalCount = 0;
    let largestDoneStatusCount = 0;
    let largestDoneStatusIndex = 0;
    const entries = [
        ...data
    ].sort((a, b)=>{
        const comparison = $35593d96f3ff92bd$var$StatusCategoryOrder[a.status.category.key] - $35593d96f3ff92bd$var$StatusCategoryOrder[b.status.category.key];
        if (comparison === 0) return a.status.name.localeCompare(b.status.name);
        return comparison;
    }).map((entry, index)=>{
        const categoryKey = entry.status.category.key;
        totalCount += entry.count;
        const isDone = categoryKey === 'done';
        if (isDone && entry.count > largestDoneStatusCount) {
            largestDoneStatusCount = entry.count;
            largestDoneStatusIndex = index;
        }
        if (!otherColors?.length) otherColors = [
            ...$35593d96f3ff92bd$var$OTHER_COLORS
        ];
        const [color, textColor] = categoryColors[categoryKey] || otherColors.pop();
        delete categoryColors[categoryKey];
        const escapedStatus = entry.status.name.split("'").join("\\'");
        const status = entry.status.jqlTerm ?? escapedStatus;
        const filter = isDone ? `status = '${status}' AND statusCategoryChangedDate >= -2w` : `status = '${status}'`;
        const link = `${urlBuilder('progressByStatus', true)}?filter=${encodeURIComponent(filter)}&hideDone=${isDone ? 'false' : 'true'}`;
        return {
            categoryKey: categoryKey,
            value: entry.count,
            name: entry.status.name,
            link: link,
            itemStyle: {
                color: color
            },
            emphasis: {
                label: {
                    rich: {
                        percent: {
                            color: textColor
                        }
                    }
                }
            }
        };
    });
    const option = {
        series: [
            {
                animation: false,
                type: 'pie',
                radius: [
                    '50%',
                    '95%'
                ],
                clockwise: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                emphasis: {
                    disabled: true,
                    scale: false,
                    label: {
                        show: true,
                        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`,
                        fontSize: 14,
                        fontFamily: $c9TLT.fontFamily,
                        fontWeight: 500,
                        overflow: 'truncate',
                        width: 100,
                        formatter: ({ name: name, value: value })=>`{percent|${Math.round(value / totalCount * 100)}%}\n${name}`,
                        rich: {
                            percent: {
                                fontSize: 36
                            }
                        }
                    },
                    itemStyle: {
                        color: 'inherit',
                        opacity: 0.9
                    }
                },
                data: entries
            }
        ]
    };
    return {
        option: option,
        entries: entries,
        totalCount: totalCount,
        initialHighlight: largestDoneStatusIndex
    };
};

});


parcelRegister("1aMZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $01356cd5cecce761$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $15zK8 = parcelRequire("15zK8");

var $4G5xU = parcelRequire("4G5xU");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jK1pm = parcelRequire("jK1pm");

var $apShl = parcelRequire("apShl");

var $h5SwL = parcelRequire("h5SwL");

var $fMfYs = parcelRequire("fMfYs");

var $bp5lX = parcelRequire("bp5lX");

var $gcDcg = parcelRequire("gcDcg");
const $01356cd5cecce761$var$ProjectDetailsInternal = ({ isSkeleton: isSkeleton })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $fMfYs.default)();
    const wasFetched = data != null || loading;
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(false);
    const toggleSection = (0, $eUqFw.useCallback)(()=>{
        if (!isExpanded && !wasFetched) fetch();
        setIsExpanded(!isExpanded);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'summaryProjectDetails', {
            expand: !isExpanded
        });
    }, [
        createAnalyticsEvent,
        fetch,
        isExpanded,
        wasFetched
    ]);
    const toggleIcon = (0, $eUqFw.useMemo)(()=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }), [
        isExpanded
    ]);
    if (isSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "project-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01356cd5cecce761$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01356cd5cecce761$var$Skeleton, {
        "data-testid": "business-summary.ui.summary-view.project-details.skeleton"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01356cd5cecce761$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        iconAfter: toggleIcon,
        appearance: "subtle-link",
        onClick: toggleSection,
        "aria-expanded": isExpanded,
        "aria-controls": "summary-project-details",
        testId: "business-summary.ui.summary-view.project-details.toggle"
    }, formatMessage((0, $gcDcg.default).projectDetails)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15zK8.Collapsible), {
        id: "summary-project-details",
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $h5SwL.PROJECT_DETAILS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bp5lX.default), {
        data: data,
        error: error,
        loading: loading
    })));
};
const $01356cd5cecce761$var$ProjectDetails = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-project-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $h5SwL.PROJECT_DETAILS_EXPERIENCE),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01356cd5cecce761$var$ProjectDetailsInternal, props)));
var $01356cd5cecce761$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($01356cd5cecce761$var$ProjectDetails);
const $01356cd5cecce761$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $01356cd5cecce761$var$Skeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1lit _2rko1y44 _18s8swc3 _4t3i1tcg _bfhktjc5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $40822fe6f5908262$var$_chevronUp = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("ibyhG")));
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $40822fe6f5908262$var$_chevronUp.default,
        iconType: "utility"
    }));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = module.exports.default = $40822fe6f5908262$var$ChevronUpIcon;

});

parcelRegister("fMfYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ccc29e862517a9a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $aT6tB = parcelRequire("aT6tB");
const $7ccc29e862517a9a$var$initialState = {
    data: undefined,
    loading: false,
    error: undefined
};
const $7ccc29e862517a9a$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $7ccc29e862517a9a$var$initialState;
        case 'fetch':
            return {
                ...$7ccc29e862517a9a$var$initialState,
                loading: true
            };
        case 'success':
            return {
                ...state,
                data: action.value,
                loading: false
            };
        case 'error':
            return {
                ...state,
                loading: false,
                error: action.value
            };
        default:
            return state;
    }
};
const $7ccc29e862517a9a$var$useProjectMeta = ()=>{
    const [{ data: data, loading: loading, error: error }, dispatch] = (0, $eUqFw.useReducer)($7ccc29e862517a9a$var$reducer, $7ccc29e862517a9a$var$initialState);
    const project = (0, $kQAZu.useProject)();
    const projectKey = project.key;
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        dispatch({
            type: 'fetch'
        });
        try {
            const response = await (0, $2OdyW.default)(`/rest/api/3/project/${projectKey}?expand=lead`);
            dispatch({
                type: 'success',
                value: (0, $aT6tB.transformData)(response)
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (restError) {
            dispatch({
                type: 'error',
                value: restError
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'ProjectMeta',
                    packageName: 'jiraBusinessSummary',
                    teamName: 'wanjel'
                },
                error: restError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        projectKey
    ]);
    (0, $eUqFw.useEffect)(()=>// reset the state when the project changes
        dispatch({
            type: 'init'
        }), [
        projectKey
    ]);
    return {
        fetch: fetch,
        data: data,
        loading: loading,
        error: error
    };
};
var $7ccc29e862517a9a$export$2e2bcd8739ae039 = $7ccc29e862517a9a$var$useProjectMeta;

});
parcelRegister("aT6tB", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $814be88617863e91$export$3ceb62baab058c6b);
const $814be88617863e91$export$3ceb62baab058c6b = ({ key: key, lead: lead })=>({
        key: key,
        lead: {
            displayName: lead.displayName,
            avatarUrl: lead.avatarUrls['48x48'] ?? '',
            accountId: lead.accountId
        }
    });

});


parcelRegister("bp5lX", function(module, exports) {

$parcel$export(module.exports, "default", () => $98915c9339a7e1fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $96IgR = parcelRequire("96IgR");


var $4G5xU = parcelRequire("4G5xU");

var $huu11 = parcelRequire("huu11");

var $90G8g = parcelRequire("90G8g");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $h5SwL = parcelRequire("h5SwL");

var $bWbSz = parcelRequire("bWbSz");

var $4IYP3 = parcelRequire("4IYP3");
const $98915c9339a7e1fd$var$Content = ({ data: data, error: error, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { linksTarget: linksTarget } = (0, $bWbSz.useSummaryFeatures)();
    const onProjectLeadClick = (0, $eUqFw.useCallback)(()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'summaryProjectLead'), [
        createAnalyticsEvent
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$LoadingPill, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), {
        size: "medium"
    }));
    if (error || data == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$ErrorPill, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$ErrorMessage, null, formatMessage((0, $4IYP3.default).errorMessage)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $h5SwL.PROJECT_DETAILS_EXPERIENCE),
        error: error
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$Pill, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$LeadSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: data.lead.avatarUrl,
        size: "large"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$LeadDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huu11.ThemedLink), {
        href: `/secure/ViewProfile.jspa?accountId=${data.lead.accountId}`,
        target: linksTarget,
        "data-testid": "business-summary.ui.summary-view.project-details.content.lead-profile-link",
        onClick: onProjectLeadClick
    }, data.lead.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$Heading, null, formatMessage((0, $4IYP3.default).projectLead)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$KeySection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98915c9339a7e1fd$var$Heading, null, formatMessage((0, $4IYP3.default).projectKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "business-summary.ui.summary-view.project-details.content.project-key"
    }, data.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $h5SwL.PROJECT_DETAILS_EXPERIENCE)
    }));
};
var $98915c9339a7e1fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($98915c9339a7e1fd$var$Content);
const $98915c9339a7e1fd$var$PILL_HEIGHT = 64;
const $98915c9339a7e1fd$var$AVATAR_BORDER_WIDTH = 2; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98915c9339a7e1fd$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazkwex _11c8qk37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98915c9339a7e1fd$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98915c9339a7e1fd$var$PillBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ivbgk _1e0c1txw _4cvr1h6o _1bah1h6o _2rkozwfg _vchhusvi _bfhk155y",
            __cmplp.className
        ])
    });
});
const $98915c9339a7e1fd$var$Pill = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $98915c9339a7e1fd$var$PillBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f31ylp _n3tdidpf _19bv1crf",
            __cmplp.className
        ])
    });
});
const $98915c9339a7e1fd$var$LeadSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $98915c9339a7e1fd$var$Section, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $98915c9339a7e1fd$var$LeadDetails = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $98915c9339a7e1fd$var$KeySection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $98915c9339a7e1fd$var$Section, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1kl71lpr _18u0pxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $98915c9339a7e1fd$var$LoadingPill = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $98915c9339a7e1fd$var$PillBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbvbgk",
            __cmplp.className
        ])
    });
});
const $98915c9339a7e1fd$var$ErrorPill = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $98915c9339a7e1fd$var$PillBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zdiv",
            __cmplp.className
        ])
    });
});
const $98915c9339a7e1fd$var$ErrorMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("huu11", function(module, exports) {

$parcel$export(module.exports, "ThemedLink", () => $a2480234e75ca020$export$4beb2d7caf878ce7);
/* ThemedLink.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lB25E = parcelRequire("lB25E");
const $a2480234e75ca020$export$4beb2d7caf878ce7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1u0u1y8w _17z21063",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4IYP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae19beacb121b0dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ae19beacb121b0dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectLead: {
        "id": "business-summary.summary-view.project-details.content.project-lead",
        "defaultMessage": "Project lead"
    },
    projectKey: {
        "id": "business-summary.summary-view.project-details.content.project-key",
        "defaultMessage": "Project key"
    },
    errorMessage: {
        "id": "business-summary.summary-view.project-details.content.error-message",
        "defaultMessage": "Could not retrieve project details."
    }
});

});


parcelRegister("gcDcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef59c2f3e886e0a7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ef59c2f3e886e0a7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectDetails: {
        "id": "business-summary.summary-view.project-details.project-details",
        "defaultMessage": "Project details"
    }
});

});


parcelRegister("9imnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4e0d48a9ae1424c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $8cU5f = parcelRequire("8cU5f");

var $ctuRV = parcelRequire("ctuRV");

var $4G5xU = parcelRequire("4G5xU");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lbttE = parcelRequire("lbttE");

var $2JncP = parcelRequire("2JncP");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $apShl = parcelRequire("apShl");

var $h5SwL = parcelRequire("h5SwL");

var $izUon = parcelRequire("izUon");

var $6cwrM = parcelRequire("6cwrM");

var $bWbSz = parcelRequire("bWbSz");

var $cGyoW = parcelRequire("cGyoW");

var $fDDwF = parcelRequire("fDDwF");

var $dH6Y5 = parcelRequire("dH6Y5");

var $8wNde = parcelRequire("8wNde");

var $ft1kr = parcelRequire("ft1kr");
const $e4e0d48a9ae1424c$var$PROJECT_CREATE_OPTIONS = (0, $ctuRV.getJwmCreateProjectDrawerOptions)('jwmSummaryPage');
const $e4e0d48a9ae1424c$var$RelatedProjects = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { loading: isSummaryDataLoading } = (0, $cGyoW.useSummaryContext)();
    const { linksTarget: linksTarget } = (0, $bWbSz.useSummaryFeatures)();
    const { data: data, loading: isRelatedProjectsLoading, error: error } = (0, $fDDwF.useRelatedProjects)();
    const { data: permissions } = (0, $2JncP.useProjectCreatePermissionsResource)();
    const isLoading = isSummaryDataLoading || isRelatedProjectsLoading;
    const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, $6cwrM.useSectionAnalytics)(position, 'relatedProjects');
    if (error != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.ErrorCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $h5SwL.RELATED_PROJECTS_EXPERIENCE),
        error: error
    }));
    const canCreateProject = Boolean(permissions?.canCreateProject);
    const createProjectRoute = `/jira/create-project?templateId=${$e4e0d48a9ae1424c$var$PROJECT_CREATE_OPTIONS.defaultSelectedTemplateKey}`;
    let content = null;
    if (isLoading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "related-projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$CenteredSkeleton, {
        testId: "business-summary.ui.summary-view.related-projects.skeleton"
    }));
    else if (data != null && data.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$Description, null, formatMessage((0, $8wNde.default).descriptionWhenEmpty)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$EmptyState, {
        withCreateProject: canCreateProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$EmptyStateIllustration, null), canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: ()=>{
                linksTarget === '_blank' ? window.open(createProjectRoute, '_blank') : open($e4e0d48a9ae1424c$var$PROJECT_CREATE_OPTIONS);
                fireSectionAnalytics('createProject', {
                    isEmpty: true
                });
            },
            testId: "business-summary.ui.summary-view.related-projects.create-project-button-empty"
        }, formatMessage((0, $8wNde.default).createProject))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: "/jira/projects",
        target: linksTarget,
        component: (0, $lB25E.Link),
        onClick: ()=>fireSectionAnalytics('projectDirectory', {
                isEmpty: true
            })
    }, formatMessage((0, $8wNde.default).viewAllProjects))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $h5SwL.RELATED_PROJECTS_EXPERIENCE)
    }));
    else if (data != null) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$Description, null, formatMessage((0, $8wNde.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$Grid, {
        "data-testid": "business-summary.ui.summary-view.related-projects.grid"
    }, canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$CreateProject, {
            onClick: ()=>{
                linksTarget === '_blank' ? window.open(createProjectRoute, '_blank') : open($e4e0d48a9ae1424c$var$PROJECT_CREATE_OPTIONS);
                fireSectionAnalytics('createProject', {
                    isEmpty: false
                });
            },
            "data-testid": "business-summary.ui.summary-view.related-projects.create-project-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$CreateProjectIcon, {
            "data-icon": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            label: ""
        })), formatMessage((0, $8wNde.default).createProject))), data.map(({ id: id, avatarUrl: avatarUrl, name: name, key: key, url: url, projectTypeKey: projectTypeKey }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$Project, {
            "data-testid": "business-summary.ui.summary-view.related-projects.project",
            href: url,
            target: linksTarget,
            key: id,
            onClick: ()=>fireSectionAnalytics('relatedProject', {
                    projectTypeKey: projectTypeKey,
                    // Ensure position count starts at 1
                    resultPosition: index + 1
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$ProjectAvatar, {
            src: `${avatarUrl}?size=xxlarge`,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$ProjectDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$ProjectName, null, name)), key)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e4e0d48a9ae1424c$var$AllProjects, {
        href: "/jira/projects",
        target: linksTarget,
        onClick: ()=>fireSectionAnalytics('projectDirectory', {
                isEmpty: false
            })
    }, formatMessage((0, $8wNde.default).viewAllProjects)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $h5SwL.RELATED_PROJECTS_EXPERIENCE)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-related-projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.default), {
        title: formatMessage((0, $8wNde.default).title),
        isLoading: isLoading,
        testId: "business-summary.ui.summary-view.related-projects",
        onPointerEnter: startHoverTimer,
        onPointerLeave: stopHoverTimer
    }, content));
};
var $e4e0d48a9ae1424c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e4e0d48a9ae1424c$var$RelatedProjects);
const $e4e0d48a9ae1424c$var$buttonStyles = null;
const $e4e0d48a9ae1424c$var$iconStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$CenteredSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $ft1kr.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$Grid = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _zulpu2gc _yv0ewxkt _18s817ik _1yt4u2gc _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e4e0d48a9ae1424c$var$CreateProject = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt4u2gc _2rko1l7b _1wybdlk8 _1ul9idpf _syaz1fxt _80omtlke _11q7glyw _19itglyw _k48pni7l _n3yiiw92 _1b3i2u25 _12dbfwzl _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1di6k6hx _jomrk6hx _irr3k6hx _u7j629zg _y6l529zg _1k1529zg _9tyi17uj _1opp17uj _m21a17uj _1w911edt _b14k1edt _4jwe1edt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e4e0d48a9ae1424c$var$CreateProjectIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3ickbl _1bsbckbl _2hwxutpp _syazkr0v _bfhk84zz _19it1owy _2rkoftgi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e4e0d48a9ae1424c$var$Project = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt4u2gc _2rko1l7b _1wybdlk8 _1ul9idpf _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1di6k6hx _jomrk6hx _irr3k6hx",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e4e0d48a9ae1424c$var$ProjectAvatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3ickbl _1bsbckbl _2hwxutpp _2rko1l7b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$ProjectDetails = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$ProjectName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _k48pni7l _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$AllProjects = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lB25E.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpz1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$EmptyState = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withCreateProject: withCreateProject, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1wpz1h6o _1e0c11p5 _zulp1tr9 _ae4v1h6o _6a6z1h6o",
            __cmplp.withCreateProject ? "_1lmcd2gs" : "_1lmc4osr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4e0d48a9ae1424c$var$EmptyStateIllustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $dH6Y5.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nd5l1gsw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fDDwF", function(module, exports) {

$parcel$export(module.exports, "useRelatedProjects", () => $591e533647c24a95$export$3ce5df02b255c535);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $gd0Sp = parcelRequire("gd0Sp");

var $2xRP6 = parcelRequire("2xRP6");
const $591e533647c24a95$var$QUERY_NAME = 'collaborationGraph';
const $591e533647c24a95$var$MAX_RESULTS = 5;
const $591e533647c24a95$var$initialState = {
    data: undefined,
    loading: true,
    error: undefined
};
const $591e533647c24a95$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $591e533647c24a95$var$initialState;
        case 'success':
            return {
                ...state,
                data: action.value,
                loading: false
            };
        case 'error':
            return {
                ...state,
                loading: false,
                error: action.value
            };
        default:
            return state;
    }
};
const $591e533647c24a95$export$3ce5df02b255c535 = ()=>{
    const [{ data: data, loading: loading, error: error }, dispatch] = (0, $eUqFw.useReducer)($591e533647c24a95$var$reducer, $591e533647c24a95$var$initialState);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const project = (0, $kQAZu.useProject)();
    const currentProjectId = String(project.id);
    (0, $eUqFw.useEffect)(()=>{
        dispatch({
            type: 'init'
        });
        (0, $2OdyW.default)('/gateway/api/collaboration/v2/recommend/container', {
            method: 'POST',
            body: JSON.stringify({
                context: {
                    userId: atlassianAccountId,
                    tenantId: cloudId,
                    containerId: currentProjectId,
                    product: 'jira'
                },
                modelRequestParams: {
                    experience: 'JiraContainerNearbyContainer',
                    caller: 'jira'
                },
                requestingUserId: atlassianAccountId,
                expand: 'existing',
                maxNumberOfResults: $591e533647c24a95$var$MAX_RESULTS
            })
        }).then((graphResponse)=>dispatch({
                type: 'success',
                value: (0, $2xRP6.transformData)(graphResponse, currentProjectId)
            })).catch((restError)=>{
            dispatch({
                type: 'error',
                value: restError
            });
            (0, $guiFP.default)({
                meta: {
                    id: $591e533647c24a95$var$QUERY_NAME,
                    packageName: 'jiraBusinessSummary',
                    teamName: 'wanjel'
                },
                error: restError,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        atlassianAccountId,
        cloudId,
        currentProjectId
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};

});
parcelRegister("2xRP6", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $da0ae7f2da178ca6$export$3ceb62baab058c6b);
const $da0ae7f2da178ca6$export$3ceb62baab058c6b = (graphResponse, currentProjectId)=>graphResponse.recommendedEntities.map(({ expand: { id: id, key: key, name: name, avatarUrl: avatarUrl, url: url, projectTypeKey: projectTypeKey } })=>({
            id: id,
            key: key,
            name: name,
            avatarUrl: avatarUrl,
            url: url,
            projectTypeKey: projectTypeKey
        })).filter(({ id: id })=>id !== currentProjectId);

});


parcelRegister("dH6Y5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c900b8d77dd35574$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $c900b8d77dd35574$var$EmptyIllustration = ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "140",
        viewBox: "0 0 270 197",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#related_proj_0_clip)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.1121 159.386L36.6245 161.141L73.9342 192.782L75.4219 191.027L38.1121 159.386Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.9727 98.5313L22.6646 100.811L73.6011 107.697L73.9092 105.418L22.9727 98.5313Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.1668 57.4796L67.4548 59.0156L94.3284 88.9667L96.0403 87.4307L69.1668 57.4796Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M174.162 69.7903L173.337 71.9375L222.285 90.7267L223.109 88.5795L174.162 69.7903Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M160.704 120.078L159.843 122.211L229.827 150.486L230.688 148.354L160.704 120.078Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M223.721 88.5916L221.444 88.8906L229.276 148.538L231.553 148.239L223.721 88.5916Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M67.4944 57.4183L22.0071 98.8086L23.5348 100.488L69.0221 59.0973L67.4944 57.4183Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.9733 99.3967L21.7368 99.9336L36.3085 160.629L38.5449 160.092L23.9733 99.3967Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M229.603 148.698L198.452 179.203L200.041 180.825L231.192 150.32L229.603 148.698Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M264.105 130.299L229.537 148.141L230.578 150.158L265.146 132.316L264.105 130.299Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M129.777 123.241L37.2278 158.953L38.045 161.071L130.594 125.359L129.777 123.241Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M222.268 88.5009L129.818 123.066L130.613 125.193L223.063 90.6272L222.268 88.5009Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M130.3 195.9C169.899 195.9 202 163.799 202 124.2C202 84.6012 169.899 52.5 130.3 52.5C90.701 52.5 58.5999 84.6012 58.5999 124.2C58.5999 163.799 90.701 195.9 130.3 195.9Z",
        fill: "url(#related_proj_0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M129 79.8008H99.7999C99.4999 80.6008 99.1 81.4008 98.7 82.3008H129V79.8008Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M73.9999 79.8008C73.3999 80.6008 72.6999 81.4008 72.0999 82.3008H96.2999C96.6058 81.442 96.9734 80.6065 97.3999 79.8008H73.9999Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M188.4 82.3008C187.823 81.426 187.188 80.5908 186.5 79.8008H164.7C165 80.6008 165.4 81.4008 165.7 82.3008H188.4Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 82.3008H163.3C162.9 81.4008 162.6 80.6008 162.2 79.8008H131.5V82.3008Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M129 166.1H97.2C97.6 166.9 97.8999 167.8 98.2999 168.6H129V166.1Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M72.0999 166.1L73.9999 168.6H95.7999L94.7999 166.1H72.0999Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M186.5 168.6C187.2 167.8 187.8 166.9 188.4 166.1H164.2C163.875 166.951 163.508 167.785 163.1 168.6H186.5Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 168.6H160.7C161.108 167.785 161.475 166.951 161.8 166.1H131.5V168.6Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M98.6998 82.3C99.0998 81.4 99.4998 80.6 99.7998 79.8C107 64.9 117.4 55 129 53.8V52.5H131.5V53.7H132.1C142.7 53.9 152.5 61.5 159.8 74.8C160.6 76.4 161.5 78.1 162.2 79.8C162.9 81.5 162.9 81.4 163.3 82.3C168.1 94 170.6 108.1 170.5 122.9H172.7C172.8 108.2 170.4 94.1 165.7 82.3C165.4 81.4 165 80.6 164.7 79.8C164.4 79 162.8 75.7 161.8 73.7C156.2 63.5 149.2 56.6 141.4 53.4C138.323 52.8926 135.216 52.5919 132.1 52.5C129 52.5 125.9 52.6 122.9 52.9C112.7 56.5 103.7 66.2 97.3998 79.8C96.9733 80.6057 96.6057 81.4412 96.2998 82.3C91.2998 93.8 88.1998 107.8 87.7998 122.9H90.0998C90.3473 108.942 93.2666 95.1599 98.6998 82.3Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M164.2 166.1C169.578 153.192 172.463 139.382 172.7 125.4H170.4C170.163 139.392 167.243 153.209 161.8 166.1C161.475 166.952 161.108 167.786 160.7 168.6C153.5 183.5 143.1 193.3 131.5 194.5V195.6H129V194.7H128.4C117.8 194.4 108 186.9 100.7 173.5L98.2999 168.6C97.8999 167.8 97.5999 166.9 97.1999 166.1C92.3999 154.3 89.8999 140.2 90.0999 125.4H87.7999C87.6999 140.2 90.0999 154.2 94.7999 166.1L95.7999 168.6C96.6999 170.7 97.6999 172.7 98.6999 174.6C104.3 184.8 111.3 191.8 119.1 195C122.2 195.4 125.2 195.7 128.4 195.8C131.506 195.917 134.616 195.783 137.7 195.4C147.8 191.9 156.8 182.1 163.1 168.6C163.508 167.786 163.875 166.952 164.2 166.1Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 79.8V53.7V52.5H129V53.8V79.8V82.3V122.9H131.5V82.3V79.8Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M131.5 166.1V125.4H129V166.1V168.6V194.7V195.6H131.5V194.5V168.6V166.1Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M129 125.4H131.5H170.4H172.7H201.9V122.9H172.7H170.5H131.5H129H90.0999H87.7999H58.8999V125.4H87.7999H90.0999H129Z",
        fill: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.4",
        d: "M78.1999 155C77.959 155.028 77.7148 154.997 77.4884 154.91C77.262 154.822 77.06 154.682 76.8999 154.5C76.7084 154.331 76.555 154.123 76.4499 153.89C76.3449 153.657 76.2905 153.405 76.2905 153.15C76.2905 152.894 76.3449 152.642 76.4499 152.409C76.555 152.176 76.7084 151.968 76.8999 151.8L128.9 99.7995C129.252 99.4691 129.717 99.2852 130.2 99.2852C130.683 99.2852 131.148 99.4691 131.5 99.7995C131.691 99.9684 131.845 100.176 131.95 100.409C132.055 100.642 132.109 100.894 132.109 101.15C132.109 101.405 132.055 101.657 131.95 101.89C131.845 102.123 131.691 102.331 131.5 102.5L79.4999 154.5C79.3398 154.682 79.1379 154.822 78.9115 154.91C78.6851 154.997 78.4409 155.028 78.1999 155Z",
        fill: "url(#related_proj_1_linear)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M200.9 55.4995C177.8 46.0995 154.6 64.8995 131.5 55.4995V3.29948C154.6 12.6995 177.8 -6.10052 200.9 3.29948V55.4995Z",
        fill: "url(#related_proj_2_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M130.2 102.9C129.739 102.901 129.296 102.725 128.961 102.409C128.626 102.092 128.425 101.66 128.4 101.2V3.3C128.4 2.82261 128.59 2.36477 128.927 2.02721C129.265 1.68964 129.723 1.5 130.2 1.5C130.677 1.5 131.135 1.68964 131.473 2.02721C131.81 2.36477 132 2.82261 132 3.3V101.2C131.974 101.66 131.773 102.092 131.439 102.409C131.104 102.725 130.66 102.901 130.2 102.9Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M166.8 15.4994L170.9 23.8994L180.1 25.0994C180.259 25.1278 180.408 25.1987 180.53 25.3045C180.653 25.4104 180.745 25.5473 180.796 25.7008C180.847 25.8544 180.856 26.0189 180.821 26.177C180.787 26.3351 180.71 26.4811 180.6 26.5994L174 33.2994L175.5 42.5994C175.546 42.756 175.544 42.923 175.492 43.0781C175.441 43.2331 175.344 43.3687 175.213 43.4667C175.082 43.5647 174.925 43.6203 174.762 43.6262C174.598 43.632 174.437 43.5878 174.3 43.4994L166 39.2994L157.8 43.7994C157.655 43.8723 157.494 43.9048 157.332 43.8936C157.171 43.8824 157.016 43.8279 156.882 43.7357C156.749 43.6436 156.644 43.5173 156.576 43.3701C156.509 43.2229 156.483 43.0603 156.5 42.8994L158.1 33.5994L151.4 27.0994C151.29 26.9811 151.213 26.8351 151.179 26.677C151.144 26.5189 151.153 26.3544 151.204 26.2008C151.255 26.0473 151.347 25.9104 151.469 25.8045C151.592 25.6987 151.741 25.6278 151.9 25.5994L161.1 24.0994L165.2 15.4994C165.276 15.3525 165.39 15.2293 165.531 15.1433C165.673 15.0572 165.835 15.0117 166 15.0117C166.165 15.0117 166.327 15.0572 166.468 15.1433C166.609 15.2293 166.724 15.3525 166.8 15.4994Z",
        fill: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M68.3 68.7996C74.1542 68.7996 78.9 64.0538 78.9 58.1996C78.9 52.3454 74.1542 47.5996 68.3 47.5996C62.4457 47.5996 57.7 52.3454 57.7 58.1996C57.7 64.0538 62.4457 68.7996 68.3 68.7996Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M199.2 190.6C205.054 190.6 209.8 185.855 209.8 180C209.8 174.146 205.054 169.4 199.2 169.4C193.346 169.4 188.6 174.146 188.6 180C188.6 185.855 193.346 190.6 199.2 190.6Z",
        fill: "url(#related_proj_3_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.3 170.899C43.1542 170.899 47.9 166.153 47.9 160.299C47.9 154.445 43.1542 149.699 37.3 149.699C31.4457 149.699 26.7 154.445 26.7 160.299C26.7 166.153 31.4457 170.899 37.3 170.899Z",
        fill: "url(#related_proj_4_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M230.4 154.3C233.106 154.3 235.3 152.106 235.3 149.4C235.3 146.694 233.106 144.5 230.4 144.5C227.694 144.5 225.5 146.694 225.5 149.4C225.5 152.106 227.694 154.3 230.4 154.3Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M222.7 94.5988C225.406 94.5988 227.6 92.405 227.6 89.6988C227.6 86.9926 225.406 84.7988 222.7 84.7988C219.994 84.7988 217.8 86.9926 217.8 89.6988C217.8 92.405 219.994 94.5988 222.7 94.5988Z",
        fill: "#505F79"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M264.4 136.4C267.106 136.4 269.3 134.206 269.3 131.5C269.3 128.793 267.106 126.6 264.4 126.6C261.694 126.6 259.5 128.793 259.5 131.5C259.5 134.206 261.694 136.4 264.4 136.4Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.04613 73.1738L4.15063 74.4766L21.8622 100.247L23.7576 98.9443L6.04613 73.1738Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.2999 78.4992C8.0061 78.4992 10.1999 76.3054 10.1999 73.5992C10.1999 70.893 8.0061 68.6992 5.2999 68.6992C2.59371 68.6992 0.399902 70.893 0.399902 73.5992C0.399902 76.3054 2.59371 78.4992 5.2999 78.4992Z",
        fill: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.7999 104.499C25.5061 104.499 27.6999 102.305 27.6999 99.5992C27.6999 96.893 25.5061 94.6992 22.7999 94.6992C20.0937 94.6992 17.8999 96.893 17.8999 99.5992C17.8999 102.305 20.0937 104.499 22.7999 104.499Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M74.5999 196.9C77.3061 196.9 79.4999 194.706 79.4999 192C79.4999 189.293 77.3061 187.1 74.5999 187.1C71.8937 187.1 69.7 189.293 69.7 192C69.7 194.706 71.8937 196.9 74.5999 196.9Z",
        fill: "#505F79"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "related_proj_0_linear",
        x1: "79.5799",
        y1: "174.85",
        x2: "180.94",
        y2: "73.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.67",
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.99",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "related_proj_1_linear",
        x1: "76.3199",
        y1: "127.16",
        x2: "132.09",
        y2: "127.16",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#0052CC",
        stopOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "related_proj_2_linear",
        x1: "135.77",
        y1: "59.8495",
        x2: "196.62",
        y2: "-1.00051",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.24",
        stopColor: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "related_proj_3_linear",
        x1: "191.7",
        y1: "187.46",
        x2: "206.69",
        y2: "172.47",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.05",
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.99",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "related_proj_4_linear",
        x1: "650.616",
        y1: "3695.4",
        x2: "968.404",
        y2: "3377.4",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.05",
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.99",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "related_proj_0_clip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.399902 0.599609H269.3V196.9H0.399902V0.599609Z",
        fill: "white"
    }))));
var $c900b8d77dd35574$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c900b8d77dd35574$var$EmptyIllustration);

});

parcelRegister("8wNde", function(module, exports) {

$parcel$export(module.exports, "default", () => $807625ab64c55c4a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $807625ab64c55c4a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "business-summary.summary-view.related-projects.title",
        "defaultMessage": "Related projects"
    },
    description: {
        "id": "business-summary.summary-view.related-projects.description",
        "defaultMessage": "Connect with other projects your team frequently contributes to and align with other project dependencies."
    },
    descriptionWhenEmpty: {
        "id": "business-summary.summary-view.related-projects.description-when-empty",
        "defaultMessage": "Use projects to manage all your work in one place and stay aligned with stakeholders."
    },
    createProject: {
        "id": "business-summary.summary-view.related-projects.create-project",
        "defaultMessage": "Create a project"
    },
    viewAllProjects: {
        "id": "business-summary.summary-view.related-projects.view-all-projects",
        "defaultMessage": "View all projects"
    }
});

});

parcelRegister("ft1kr", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dc0dff80ce5518$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $65dc0dff80ce5518$var$Skeleton = ({ className: className, testId: testId })=>{
    const skeletonColor = `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 476 312",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "476",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "16",
        width: "320",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "56",
        width: "48",
        height: "48",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "64",
        y: "68",
        width: "160",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "64",
        y: "84",
        width: "80",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "252",
        y: "56",
        width: "48",
        height: "48",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "316",
        y: "68",
        width: "160",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "316",
        y: "84",
        width: "80",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "136",
        width: "48",
        height: "48",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "64",
        y: "148",
        width: "160",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "64",
        y: "164",
        width: "80",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "252",
        y: "136",
        width: "48",
        height: "48",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "316",
        y: "148",
        width: "160",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "316",
        y: "164",
        width: "80",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "216",
        width: "48",
        height: "48",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "64",
        y: "228",
        width: "160",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "64",
        y: "244",
        width: "80",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "252",
        y: "216",
        width: "48",
        height: "48",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "316",
        y: "228",
        width: "160",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "316",
        y: "244",
        width: "80",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "296",
        width: "180",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }));
};
var $65dc0dff80ce5518$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($65dc0dff80ce5518$var$Skeleton);

});


parcelRegister("eCQJQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b681b7dc2f1345ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $79xbN = parcelRequire("79xbN");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jK1pm = parcelRequire("jK1pm");

var $apShl = parcelRequire("apShl");

var $a2EFr = parcelRequire("a2EFr");

var $izUon = parcelRequire("izUon");

var $jTuwe = parcelRequire("jTuwe");

var $7girh = parcelRequire("7girh");

var $dujdr = parcelRequire("dujdr");

var $6cwrM = parcelRequire("6cwrM");

var $bWbSz = parcelRequire("bWbSz");

var $kM2Ho = parcelRequire("kM2Ho");

var $iUoll = parcelRequire("iUoll");

var $ivAcl = parcelRequire("ivAcl");

var $6nUrX = parcelRequire("6nUrX");

var $4wbUc = parcelRequire("4wbUc");
const $b681b7dc2f1345ba$var$TypesOfWork = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data, loading: loading, fetchNext: fetchNext, loadingNext: loadingNext } = (0, $kM2Ho.default)();
    const { hasCreateItem: hasCreateItem, hasManageTypesButton: hasManageTypesButton, linksTarget: linksTarget, urlBuilder: urlBuilder } = (0, $bWbSz.useSummaryFeatures)();
    const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, $6cwrM.useSectionAnalytics)(position, 'typesOfWork');
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "types-of-work"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wbUc.CenteredSkeleton), {
        testId: "business-summary.ui.summary-view.types-of-work.skeleton"
    }));
    else {
        const headers = {
            identifier: formatMessage((0, $6nUrX.default).issueTypeColumnHeader),
            percentageBar: formatMessage((0, $6nUrX.default).issueDistributionColumnHeader),
            count: formatMessage((0, $6nUrX.default).countColumnHeader)
        };
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b681b7dc2f1345ba$var$Description, null, data?.totalUnresolvedIssues === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $6nUrX.default).descriptionWhenEmpty), hasCreateItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTuwe.default), {
            href: `${urlBuilder('typesOfWork')}?inlineCreate=true`,
            onClick: ()=>fireSectionAnalytics('view', {
                    inlineCreate: true
                }),
            target: linksTarget
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            message: formatMessage((0, $6nUrX.default).description, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            }),
            componentsMapping: {
                link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2EFr.default), {
                        href: `${urlBuilder('typesOfWork')}?direction=ASC&sortBy=issuetype`,
                        target: linksTarget,
                        onClick: ()=>fireSectionAnalytics('view', {
                                inlineCreate: false
                            }),
                        "aria-label": formatMessage((0, $6nUrX.default).viewAllItemsLabel)
                    }, children)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7girh.default), {
            loading: loadingNext,
            onScrollToEnd: fetchNext,
            headers: headers,
            label: formatMessage((0, $6nUrX.default).title)
        }, data && data.issueTypes.map(({ id: id, issueType: issueType, count: count })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dujdr.default), {
                key: id,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b681b7dc2f1345ba$var$IssueType, {
                    src: issueType.iconUrl,
                    alt: ""
                }),
                itemCount: count,
                totalCount: data.totalUnresolvedIssues,
                name: issueType.name,
                linkUrl: `${urlBuilder('typesOfWork', true)}?filter=${encodeURIComponent(`type = '${issueType.name.split("'").join("\\'")}' AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`)}`,
                onRowLinkClick: ()=>fireSectionAnalytics('viewWithFilter', {
                        count: count
                    }),
                linkTarget: linksTarget,
                actions: (0, $79xbN.expVal)('jwm_summary_page_inline_issue_types_change', 'isInlineIssueTypesEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null) : null
            }))), hasManageTypesButton && ((0, $79xbN.expVal)('jwm_summary_page_inline_issue_types_change', 'isInlineIssueTypesEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iUoll.default), {
            onClick: ()=>fireSectionAnalytics('addIssueTypes')
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivAcl.default), {
            onClick: ()=>fireSectionAnalytics('manageTypes')
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-types-of-work"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.default), {
        title: formatMessage((0, $6nUrX.default).title),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.types-of-work",
        onPointerEnter: startHoverTimer,
        onPointerLeave: stopHoverTimer
    }, content));
};
var $b681b7dc2f1345ba$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($b681b7dc2f1345ba$var$TypesOfWork);
const $b681b7dc2f1345ba$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b681b7dc2f1345ba$var$IssueType = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _2rkoglpi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7girh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4970bc6edb1086d1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $fJcKX = parcelRequire("fJcKX");
const $4970bc6edb1086d1$var$PercentageBarTable = ({ headers: headers, onScrollToEnd: onScrollToEnd, loading: loading, children: children, label: label })=>{
    const { onScroll: onScroll } = (0, $fJcKX.useScrollToEnd)({
        onScrollToEnd: onScrollToEnd,
        isDisabled: loading,
        options: {
            onEndReachedThreshold: 50
        }
    });
    const { identifier: identifier, percentageBar: percentageBar, count: count } = headers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4970bc6edb1086d1$var$ScrollableWrapper, {
        onScroll: onScroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", {
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4970bc6edb1086d1$var$TableHead, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4970bc6edb1086d1$var$IdentifierColumnHeader, null, identifier), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4970bc6edb1086d1$var$BarColumnHeader, null, percentageBar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4970bc6edb1086d1$var$CountColumnHeader, null, count))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4970bc6edb1086d1$var$TableBody, null, children)), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4970bc6edb1086d1$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "business-summary.common.ui.percentage-bar-table.spinner"
    })));
};
var $4970bc6edb1086d1$export$2e2bcd8739ae039 = $4970bc6edb1086d1$var$PercentageBarTable;
const $4970bc6edb1086d1$var$TABLE_HEADER_HEIGHT = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4970bc6edb1086d1$var$ScrollableWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8a2pq _1yt41e2i _18m91wug _16jlidpf _1o9zkb7n _i0dl1wug _11q71saz",
            __cmplp.className
        ])
    });
});
const $4970bc6edb1086d1$var$TableHead = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw",
            __cmplp.className
        ])
    });
});
const $4970bc6edb1086d1$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw",
            __cmplp.className
        ])
    });
});
const $4970bc6edb1086d1$var$BarColumnHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz47vkz _k48pbfng _syaz1wmz _kqsw1if8 _154iidpf _11q7hp5a _1pbykb7n _vchhusvi _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $4970bc6edb1086d1$var$IdentifierColumnHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $4970bc6edb1086d1$var$BarColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1lit",
            __cmplp.className
        ])
    });
});
const $4970bc6edb1086d1$var$CountColumnHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $4970bc6edb1086d1$var$BarColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1wqb _y3gnusic",
            __cmplp.className
        ])
    });
});
const $4970bc6edb1086d1$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _1bah1h6o _18s8utpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dujdr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6efab1bba29249bc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $79xbN = parcelRequire("79xbN");

var $lB25E = parcelRequire("lB25E");

var $faotv = parcelRequire("faotv");

var $eQc22 = parcelRequire("eQc22");
const $6efab1bba29249bc$var$PercentageBarRow = ({ iconBefore: iconBefore, itemCount: itemCount, totalCount: totalCount, barColor: barColor, name: name, linkUrl: linkUrl, onRowLinkClick: onRowLinkClick, linkTarget: linkTarget, actions: actions })=>{
    const percentage = (0, $eUqFw.useMemo)(()=>(0, $eQc22.calcPercentage)(totalCount, itemCount), [
        totalCount,
        itemCount
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6efab1bba29249bc$var$IdentifierCell, null, iconBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6efab1bba29249bc$var$IdentifierName, null, name), actions != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6efab1bba29249bc$var$ActionsWrapper, null, actions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $faotv.default), {
        percentage: percentage,
        color: barColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6efab1bba29249bc$var$CountCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
        href: linkUrl,
        target: linkTarget,
        onClick: onRowLinkClick
    }, itemCount)));
    return (0, $79xbN.expVal)('jwm_summary_page_inline_issue_types_change', 'isInlineIssueTypesEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6efab1bba29249bc$var$Row, null, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, content);
};
const $6efab1bba29249bc$export$95dd84bae798753c = 160;
const $6efab1bba29249bc$export$685f1c917853c2fc = 60;
var $6efab1bba29249bc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6efab1bba29249bc$var$PercentageBarRow);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6efab1bba29249bc$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1vchb3bt _vw87b3bt _1su61osq _1aum1osq _1wn1u2gc _16q2u2gc _13rbglpi _1yrjglpi _qybkglpi _oatjglpi _1yw4stnw _1wg6stnw _cvyhze3t _1fhpze3t _1d6vx0bf _gl8xx0bf _113b108i _1xqc108i _1wnsb3bt _1boqb3bt _iceo1osq _1kmz1osq _1j70u2gc _1uxru2gc _1svlglpi _14ovglpi _lsxsglpi _vbk1glpi _qa15stnw _ixiwstnw _1mhnze3t _l3jaze3t _1xpgx0bf _1j2wx0bf _8ve6108i _4tpu108i _10j7108i _irr3108i _11r3kb7n _39e3kb7n _179a1wug _1cso1wug",
            __cmplp.className
        ])
    });
});
const $6efab1bba29249bc$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _i0dlf1ug _tzy4fuy8 _1bsb15yu",
            __cmplp.className
        ])
    });
});
const $6efab1bba29249bc$var$IdentifierCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _4cvr1h6o _1bsb1lit _1tke14no",
            __cmplp.className
        ])
    });
});
const $6efab1bba29249bc$var$IdentifierName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $6efab1bba29249bc$var$CountCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1wqb _y3gnusic _k48pbfng",
            __cmplp.className
        ])
    });
});

});
parcelRegister("faotv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0d78d7feaa27f0c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $e0d78d7feaa27f0c$var$PercentageBar = ({ percentage: percentage, color: color = `var(--ds-background-neutral-bold, ${0, $73a5c9d720aa66e1$export$eece5f492e429f08})` })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0d78d7feaa27f0c$var$PercentageBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0d78d7feaa27f0c$var$BarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0d78d7feaa27f0c$var$Bar, {
        barColor: color,
        percentage: percentage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0d78d7feaa27f0c$var$PercentageWrapper, null, percentage, "%"));
var $e0d78d7feaa27f0c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e0d78d7feaa27f0c$var$PercentageBar);
const $e0d78d7feaa27f0c$var$BAR_HEIGHT = 12;
const $e0d78d7feaa27f0c$var$BAR_BORDER_RADIUS = $e0d78d7feaa27f0c$var$BAR_HEIGHT / 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0d78d7feaa27f0c$var$PercentageBarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e0d78d7feaa27f0c$var$BarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4t3i1crf _2rkoi2wt _bfhk134c",
            __cmplp.className
        ])
    });
});
const $e0d78d7feaa27f0c$var$Bar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { barColor: barColor, percentage: percentage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_96awuh": (0, $9t7rW.default)(__cmplp.barColor),
            "--_6wa3km": (0, $9t7rW.default)(__cmplp.percentage, "%")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkm9ld _2rkoi2wt",
            __cmplp.percentage > 0 ? "_1bsbge15" : "_1bsbidpf",
            __cmplp.className
        ])
    });
});
const $e0d78d7feaa27f0c$var$PercentageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1wqb _y3gnusic _k48pbfng",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eQc22", function(module, exports) {

$parcel$export(module.exports, "calcPercentage", () => $97f04dc2207203e6$export$e687d7efb14a396b);
const $97f04dc2207203e6$export$e687d7efb14a396b = (total, value)=>{
    if (total === 0) return total;
    return Math.round(value / total * 100);
};

});


parcelRegister("kM2Ho", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdc5f7617390ab9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kCIeX = parcelRequire("kCIeX");

var $21QI8 = parcelRequire("21QI8");

var $cGyoW = parcelRequire("cGyoW");
const $cdc5f7617390ab9d$var$usePagedIssuesByType = ()=>{
    const { data: initialData, loading: initialLoading, error: initialError } = (0, $cGyoW.useIssuesByType)();
    const fetchIssuesByType = (0, $21QI8.default)();
    const { data: issueTypes, error: nextPageError, hasNextPage: hasNextPage, loadingNext: loadingNext, fetchNext: fetchNext, reset: reset } = (0, $kCIeX.usePagination)(fetchIssuesByType);
    (0, $eUqFw.useEffect)(()=>{
        if (initialData != null) reset({
            data: initialData.data,
            pageInfo: initialData.pageInfo
        });
    }, [
        initialData,
        reset
    ]);
    const data = (0, $eUqFw.useMemo)(()=>initialData && issueTypes ? {
            issueTypes: issueTypes,
            totalUnresolvedIssues: initialData.totalUnresolvedIssues
        } : null, [
        issueTypes,
        initialData
    ]);
    return {
        data: data,
        loading: initialLoading,
        loadingNext: loadingNext,
        error: initialError || nextPageError,
        hasNextPage: hasNextPage,
        fetchNext: fetchNext
    };
};
var $cdc5f7617390ab9d$export$2e2bcd8739ae039 = $cdc5f7617390ab9d$var$usePagedIssuesByType;

});
parcelRegister("21QI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff51cf7a0d747b29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");


var $c2uS5 = parcelRequire("c2uS5");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $2oxjt = parcelRequire("2oxjt");
const $ff51cf7a0d747b29$var$QUERY_NAME = 'IssuesByTypeData';
const $ff51cf7a0d747b29$var$useFetchIssuesByType = ()=>{
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const handleError = (0, $eUqFw.useCallback)((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: $ff51cf7a0d747b29$var$QUERY_NAME,
                packageName: 'jiraBusinessSummary',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }, []);
    const fetch = (0, $eUqFw.useCallback)((after)=>(0, $lRmyA.performPostRequest)(`/rest/gira/1/?operation=${$ff51cf7a0d747b29$var$QUERY_NAME}`, {
            body: JSON.stringify({
                query: (0, $2oxjt.ISSUES_BY_TYPE_QUERY),
                variables: {
                    jql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                    pageSize: (0, $41d3054f19febaab$export$c0ecd9bd08a86184),
                    after: after
                }
            })
        }).then((response)=>{
            if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            return (0, $c2uS5.transformIssuesByTypeData)(response.data.issuesByType);
        }).catch(handleError), [
        handleError,
        jqlContext
    ]);
    return fetch;
};
var $ff51cf7a0d747b29$export$2e2bcd8739ae039 = $ff51cf7a0d747b29$var$useFetchIssuesByType;

});
parcelRegister("2oxjt", function(module, exports) {

$parcel$export(module.exports, "ISSUES_BY_TYPE_QUERY", () => $3be5eb7e21df2347$export$547a994d0ac40539);

const $3be5eb7e21df2347$export$547a994d0ac40539 = `
  query JiraBusinessIssuesByTypeData($jql: String!, $pageSize: Int!, $after: String) {
    issuesByType: jwmItemGroups(jql: $jql, first: $pageSize, after: $after, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${(0, $41d3054f19febaab$export$5b2a5373659a0414)}
`;

});



parcelRegister("iUoll", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c81c0c023a7ad32$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lxfVR = parcelRequire("lxfVR");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4RV3w = parcelRequire("4RV3w");
const $2c81c0c023a7ad32$var$AddIssueTypesButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: onClick,
        backgroundColor: "color.background.neutral.subtle",
        xcss: $2c81c0c023a7ad32$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2c81c0c023a7ad32$var$addIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lxfVR))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        weight: "medium"
    }, formatMessage((0, $4RV3w.default).addIssueTypes)));
};
var $2c81c0c023a7ad32$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2c81c0c023a7ad32$var$AddIssueTypesButton);
const $2c81c0c023a7ad32$var$addIconWrapperStyles = (0, $1ZAYh.xcss)({
    height: '24px',
    width: '24px',
    marginInlineEnd: 'space.075',
    paddingBlock: 'space.100',
    paddingInline: 'space.050',
    borderRadius: 'border.radius',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral'
});
const $2c81c0c023a7ad32$var$buttonStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025',
    marginBlock: 'space.100',
    color: 'color.text.subtlest',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    ':hover': {
        textDecoration: 'underline'
    }
});

});
parcelRegister("4RV3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9cd1e02e0937409$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f9cd1e02e0937409$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addIssueTypes: {
        "id": "business-summary.summary-view.types-of-work.add-issue-types-button.add-issue-types-non-final",
        "defaultMessage": "Add an issue type"
    }
});

});


parcelRegister("ivAcl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f361e39144d5315$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iw0Y6 = parcelRequire("iw0Y6");


var $kQAZu = parcelRequire("kQAZu");

var $hw2eW = parcelRequire("hw2eW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bWbSz = parcelRequire("bWbSz");

var $69cNI = parcelRequire("69cNI");

var $1E95H = parcelRequire("1E95H");
const $3f361e39144d5315$var$ManageTypesButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const project = (0, $kQAZu.useProject)();
    const projectKey = project.key;
    const { linksTarget: linksTarget } = (0, $bWbSz.useSummaryFeatures)();
    const href = (0, $hw2eW.getIssueTypesSettingsUrl)(projectKey, project.isSimplified);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1E95H.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
        label: "",
        size: "small",
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1E95H.StyledButton), {
        href: href,
        target: linksTarget,
        onClick: onClick,
        iconBefore: icon,
        appearance: "subtle-link",
        testId: "business-summary.ui.summary-view.types-of-work.manage-types-button"
    }, formatMessage((0, $69cNI.default).manageTypes));
};
var $3f361e39144d5315$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3f361e39144d5315$var$ManageTypesButton);

});
parcelRegister("hw2eW", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesSettingsUrl", () => $4a7674a4409ee541$export$b9500524016e18f0);
const $4a7674a4409ee541$export$b9500524016e18f0 = (projectKey, isSimplified)=>isSimplified ? `/jira/core/projects/${projectKey}/settings/issuetypes` : `/plugins/servlet/project-config/${projectKey}/issuetypes`;

});

parcelRegister("69cNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a359027b7a32290$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a359027b7a32290$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    manageTypes: {
        "id": "business-summary.summary-view.types-of-work.manage-types-button.manage-types",
        "defaultMessage": "Manage types"
    }
});

});

parcelRegister("1E95H", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $b43501f805565d6e$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "IconWrapper", () => $b43501f805565d6e$export$be58b4326e23250f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $b43501f805565d6e$export$91a15f1424900d33 = 24;
const $b43501f805565d6e$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpz1y6m _18u0x0bf _19pku2gc",
            __cmplp.className
        ])
    });
});
const $b43501f805565d6e$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _2rkoglpi _2hwx12x7 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk155y",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6nUrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13a11185a0bfb9c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f13a11185a0bfb9c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "business-summary.summary-view.types-of-work.title",
        "defaultMessage": "Types of work"
    },
    description: {
        "id": "business-summary.summary-view.types-of-work.description",
        "defaultMessage": "Get a breakdown of items by their types. {linkStart}View all items{linkEnd}"
    },
    descriptionWhenEmpty: {
        "id": "business-summary.summary-view.types-of-work.description-when-empty",
        "defaultMessage": "You'll need to create a few items for your project to get started."
    },
    issueTypeColumnHeader: {
        "id": "business-summary.summary-view.types-of-work.issue-type-column-header",
        "defaultMessage": "Type"
    },
    issueDistributionColumnHeader: {
        "id": "business-summary.summary-view.types-of-work.issue-distribution-column-header",
        "defaultMessage": "Distribution"
    },
    countColumnHeader: {
        "id": "business-summary.summary-view.types-of-work.count-column-header",
        "defaultMessage": "Count"
    },
    viewAllItemsLabel: {
        "id": "business-summary.summary-view.types-of-work.view-all-items-label",
        "defaultMessage": "View all issues with different types of work"
    }
});

});

parcelRegister("4wbUc", function(module, exports) {

$parcel$export(module.exports, "CenteredSkeleton", () => $e8829d6da3bbd12b$export$8faa72715fd79c70);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8gV8C = parcelRequire("8gV8C");
const $e8829d6da3bbd12b$export$8faa72715fd79c70 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8gV8C.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8gV8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $54c22f541ac060c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $54c22f541ac060c3$var$Skeleton = ({ className: className, testId: testId })=>{
    const skeletonColor = `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 476 296",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "476",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "16",
        width: "320",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "64",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "32",
        y: "68",
        width: "93",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "141",
        y: "68",
        width: "265",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "422",
        y: "68",
        width: "52",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "116",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "32",
        y: "120",
        width: "93",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "141",
        y: "120",
        width: "265",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "422",
        y: "120",
        width: "52",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "168",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "32",
        y: "172",
        width: "93",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "141",
        y: "172",
        width: "265",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "422",
        y: "172",
        width: "52",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "216",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "32",
        y: "220",
        width: "93",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "141",
        y: "220",
        width: "265",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "422",
        y: "220",
        width: "52",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "260",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "32",
        y: "264",
        width: "93",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "141",
        y: "264",
        width: "265",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "422",
        y: "264",
        width: "52",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "304",
        width: "24",
        height: "24",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "32",
        y: "308",
        width: "93",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "141",
        y: "308",
        width: "265",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "422",
        y: "308",
        width: "52",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }));
};
var $54c22f541ac060c3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($54c22f541ac060c3$var$Skeleton);

});



parcelRegister("iVxJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2b021a83a00ab4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");


var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jK1pm = parcelRequire("jK1pm");

var $apShl = parcelRequire("apShl");

var $a2EFr = parcelRequire("a2EFr");

var $izUon = parcelRequire("izUon");

var $jTuwe = parcelRequire("jTuwe");

var $7girh = parcelRequire("7girh");

var $dujdr = parcelRequire("dujdr");

var $6cwrM = parcelRequire("6cwrM");

var $bWbSz = parcelRequire("bWbSz");

var $6VbyE = parcelRequire("6VbyE");

var $gievl = parcelRequire("gievl");

var $28BoM = parcelRequire("28BoM");

var $6z2gZ = parcelRequire("6z2gZ");

var $wjxfJ = parcelRequire("wjxfJ");

var $epPRq = parcelRequire("epPRq");
const $3e2b021a83a00ab4$var$NO_ASSIGNEE_VALUE = 'EMPTY';
const $3e2b021a83a00ab4$var$getAssigneeFilterLink = (urlBuilder, user)=>`${urlBuilder('workloadByAssignee', true)}?filter=${encodeURIComponent(`assignee = ${user?.accountId ?? $3e2b021a83a00ab4$var$NO_ASSIGNEE_VALUE} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`)}`;
const $3e2b021a83a00ab4$var$WorkloadByAssignee = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { hasCreateItem: hasCreateItem, hasInviteTeammateButton: hasInviteTeammateButton, linksTarget: linksTarget, urlBuilder: urlBuilder } = (0, $bWbSz.useSummaryFeatures)();
    const { data: data, loading: loading, fetchNext: fetchNext, loadingNext: loadingNext } = (0, $6VbyE.default)();
    const { startHoverTimer: startHoverTimer, stopHoverTimer: stopHoverTimer, fireSectionAnalytics: fireSectionAnalytics } = (0, $6cwrM.useSectionAnalytics)(position, 'workloadByAssignee');
    const fireInviteUserAnalytics = (0, $eUqFw.useCallback)(()=>fireSectionAnalytics('inviteUser'), [
        fireSectionAnalytics
    ]);
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "workload-by-assignee"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6z2gZ.CenteredSkeleton), {
        testId: "business-summary.ui.summary-view.workload-by-assignee.skeleton"
    }));
    else {
        const isEmptyProject = data?.totalUnresolvedIssues === 0;
        const hasNoIssuesAssigned = data?.assignees.length === 1 && data?.assignees[0].user == null;
        const description = hasNoIssuesAssigned ? (0, $28BoM.default).descriptionWhenNoIssuesAssigned : (0, $28BoM.default).description;
        const headers = {
            identifier: formatMessage((0, $28BoM.default).assigneeColumnHeader),
            percentageBar: formatMessage((0, $28BoM.default).workloadColumnHeader),
            count: formatMessage((0, $28BoM.default).countColumnHeader)
        };
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $wjxfJ.Description), null, isEmptyProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $28BoM.default).descriptionWhenEmpty), hasCreateItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTuwe.default), {
            href: `${urlBuilder('workloadByAssignee')}?inlineCreate=true`,
            onClick: ()=>fireSectionAnalytics('view', {
                    inlineCreate: true
                }),
            target: linksTarget
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            message: formatMessage(description, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            }),
            componentsMapping: {
                link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2EFr.default), {
                        href: `${urlBuilder('workloadByAssignee')}?direction=ASC&sortBy=assignee`,
                        target: linksTarget,
                        onClick: ()=>fireSectionAnalytics('view', {
                                inlineCreate: false
                            })
                    }, children)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7girh.default), {
            loading: loadingNext,
            onScrollToEnd: fetchNext,
            headers: headers,
            label: formatMessage((0, $28BoM.default).title)
        }, data && data.assignees.map(({ id: id, user: user, count: count }, index)=>{
            const displayName = user?.displayName ?? formatMessage((0, $28BoM.default).unassigned);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dujdr.default), {
                key: id,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                    src: user?.avatarUrl,
                    name: displayName
                }),
                itemCount: count,
                totalCount: data.totalUnresolvedIssues,
                barColor: user ? (0, $epPRq.getColor)(index) : undefined,
                name: displayName,
                linkUrl: $3e2b021a83a00ab4$var$getAssigneeFilterLink(urlBuilder, user),
                onRowLinkClick: ()=>fireSectionAnalytics('viewWithFilter', {
                        count: count,
                        isUnassigned: !user
                    }),
                linkTarget: linksTarget
            });
        }), isEmptyProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dujdr.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                name: formatMessage((0, $28BoM.default).unassigned)
            }),
            itemCount: 0,
            totalCount: 0,
            name: formatMessage((0, $28BoM.default).unassigned),
            linkUrl: $3e2b021a83a00ab4$var$getAssigneeFilterLink(urlBuilder, null),
            onRowLinkClick: ()=>fireSectionAnalytics('viewWithFilter', {
                    count: 0,
                    isUnassigned: true
                }),
            linkTarget: linksTarget
        })), hasInviteTeammateButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gievl.default), {
            onClick: fireInviteUserAnalytics
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-summary-workload-by-assignee"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izUon.default), {
        title: formatMessage((0, $28BoM.default).title),
        isLoading: loading,
        testId: "business-summary.ui.summary-view.workload-by-assignee",
        onPointerEnter: startHoverTimer,
        onPointerLeave: stopHoverTimer
    }, content));
};
var $3e2b021a83a00ab4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3e2b021a83a00ab4$var$WorkloadByAssignee);

});
parcelRegister("6VbyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf7708e3c574356$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kCIeX = parcelRequire("kCIeX");

var $7hyiS = parcelRequire("7hyiS");

var $cGyoW = parcelRequire("cGyoW");
const $aaf7708e3c574356$var$usePagedIssuesByAssignee = ()=>{
    const { data: initialData, loading: initialLoading, error: initialError } = (0, $cGyoW.useIssuesByAssignee)();
    const fetchIssuesByAssignee = (0, $7hyiS.default)();
    const { data: assignees, error: nextPageError, hasNextPage: hasNextPage, loadingNext: loadingNext, fetchNext: fetchNext, reset: reset } = (0, $kCIeX.usePagination)(fetchIssuesByAssignee);
    (0, $eUqFw.useEffect)(()=>{
        if (initialData != null) reset({
            data: initialData.data,
            pageInfo: initialData.pageInfo
        });
    }, [
        initialData,
        reset
    ]);
    const data = (0, $eUqFw.useMemo)(()=>initialData && assignees ? {
            assignees: assignees,
            totalUnresolvedIssues: initialData.totalUnresolvedIssues
        } : null, [
        assignees,
        initialData
    ]);
    return {
        data: data,
        loading: initialLoading,
        loadingNext: loadingNext,
        error: initialError || nextPageError,
        hasNextPage: hasNextPage,
        fetchNext: fetchNext
    };
};
var $aaf7708e3c574356$export$2e2bcd8739ae039 = $aaf7708e3c574356$var$usePagedIssuesByAssignee;

});
parcelRegister("7hyiS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f26fa1a220c58f5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");


var $c2uS5 = parcelRequire("c2uS5");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $iEfxl = parcelRequire("iEfxl");
const $7f26fa1a220c58f5$var$QUERY_NAME = 'IssuesByAssigneeData';
const $7f26fa1a220c58f5$var$useFetchIssuesByAssignee = ()=>{
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const handleError = (0, $eUqFw.useCallback)((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: $7f26fa1a220c58f5$var$QUERY_NAME,
                packageName: 'jiraBusinessSummary',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }, []);
    const fetch = (0, $eUqFw.useCallback)((after)=>(0, $lRmyA.performPostRequest)(`/rest/gira/1/?operation=${$7f26fa1a220c58f5$var$QUERY_NAME}`, {
            body: JSON.stringify({
                query: (0, $iEfxl.ISSUES_BY_ASSIGNEE_QUERY),
                variables: {
                    jql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                    pageSize: (0, $41d3054f19febaab$export$c0ecd9bd08a86184),
                    after: after
                }
            })
        }).then((response)=>{
            if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            return (0, $c2uS5.transformIssuesByAssigneeData)(response.data.issuesByAssignee);
        }).catch(handleError), [
        handleError,
        jqlContext
    ]);
    return fetch;
};
var $7f26fa1a220c58f5$export$2e2bcd8739ae039 = $7f26fa1a220c58f5$var$useFetchIssuesByAssignee;

});
parcelRegister("iEfxl", function(module, exports) {

$parcel$export(module.exports, "ISSUES_BY_ASSIGNEE_QUERY", () => $a7b408549a2e9913$export$b50987cf704e54a4);

const $a7b408549a2e9913$export$b50987cf704e54a4 = `
  query JiraBusinessIssuesByAssigneeData($jql: String!, $pageSize: Int!, $after: String) {
    issuesByAssignee: jwmItemGroups(jql: $jql, first: $pageSize, after: $after, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
  }

  ${(0, $41d3054f19febaab$export$27f4fb65edc908d0)}
`;

});



parcelRegister("gievl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece8d8676a58970f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3f7Cz = parcelRequire("3f7Cz");

var $lN9KF = parcelRequire("lN9KF");
const $ece8d8676a58970f$var$InviteTeammate = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lN9KF.default), {
        onClick: onClick
    }));
var $ece8d8676a58970f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ece8d8676a58970f$var$InviteTeammate);

});
parcelRegister("3f7Cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5829e6ed86dc42e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5GxEP = parcelRequire("5GxEP");

var $bvGWz = parcelRequire("bvGWz");

var $3MjJX = parcelRequire("3MjJX");
const $5829e6ed86dc42e3$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $bvGWz.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MjJX.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $5829e6ed86dc42e3$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvGWz.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $5829e6ed86dc42e3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5829e6ed86dc42e3$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5829e6ed86dc42e3$var$InviteWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bvGWz", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $f3a4a647f29aa9d7$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $f3a4a647f29aa9d7$export$93ea361ec674cff6);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f3a4a647f29aa9d7$var$AddPeopleContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $f3a4a647f29aa9d7$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const triggerBtnRef = (0, $eUqFw.useRef)(null);
    const onCloseCallbackRef = (0, $eUqFw.useRef)();
    const openAddPeopleModal = (0, $eUqFw.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3a4a647f29aa9d7$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $f3a4a647f29aa9d7$export$93ea361ec674cff6 = ()=>(0, $eUqFw.useContext)($f3a4a647f29aa9d7$var$AddPeopleContext);

});

parcelRegister("3MjJX", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $1368af08b2bd60b0$export$6dfea89767cb5ac1);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $hlZx3 = parcelRequire("hlZx3");

var $66rnh = parcelRequire("66rnh");

var $d1I0W = parcelRequire("d1I0W");
const $1368af08b2bd60b0$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $hlZx3.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66rnh.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1I0W.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("hlZx3", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $72fe370f230f9c2c$export$f696e14fc423d0b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");


var $f90H0 = parcelRequire("f90H0");

var $bLjrh = parcelRequire("bLjrh");
const $72fe370f230f9c2c$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const projectData = (0, $kQAZu.useProject)();
    const handleAddSuccess = (0, $eUqFw.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $f90H0.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $bLjrh.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $bLjrh.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $eUqFw.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$4e427f77b64bbbed)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$20ef020abfaa9ec))) {
            showFlag((0, $bLjrh.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$a1d765adf759361e))) showFlag((0, $bLjrh.inviteFailBadRequestFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c7f012c6e67c4217))) showFlag((0, $bLjrh.inviteFailNetworkErrorFlagConfig));
        else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c8a538cf4ae41623)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$9bbcbc11675c1278)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$a51af3c30283d234))) showFlag((0, $bLjrh.inviteFailGenericFlagConfig));
        else showFlag((0, $bLjrh.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$14fb68f74ccc8b23)) || isClientError) return;
        (0, $guiFP.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $aa13349e4e2d4a46$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $aa13349e4e2d4a46$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $aa13349e4e2d4a46$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $aa13349e4e2d4a46$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $aa13349e4e2d4a46$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $aa13349e4e2d4a46$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $aa13349e4e2d4a46$export$20ef020abfaa9ec = 'Licence Exceeded';
const $aa13349e4e2d4a46$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("f90H0", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $2279512461e31f50$export$2e0a7d2dc28c9a18);
const $2279512461e31f50$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("bLjrh", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $493a4fc4ed3495fe$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $493a4fc4ed3495fe$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $493a4fc4ed3495fe$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $493a4fc4ed3495fe$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $493a4fc4ed3495fe$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $493a4fc4ed3495fe$export$251dc06b3962c565);

var $jMP2a = parcelRequire("jMP2a");

var $7Ya7f = parcelRequire("7Ya7f");
const $493a4fc4ed3495fe$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $493a4fc4ed3495fe$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $7Ya7f.default).inviteFailedMessageCta,
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ]
};
const $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedGenericMessageDescription
};
const $493a4fc4ed3495fe$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedBadRequestMessageDescription
};
const $493a4fc4ed3495fe$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedNetworkErrorMessageDescription
};
const $493a4fc4ed3495fe$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $7Ya7f.default).requestInviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
    return {
        type: 'success',
        title: (0, $7Ya7f.default).inviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
};
const $493a4fc4ed3495fe$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $7Ya7f.default).peopleAddedSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $7Ya7f.default).peopleAddedManageAccess,
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ]
    });
const $493a4fc4ed3495fe$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $7Ya7f.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $7Ya7f.default).userLimitInviteErrorDescriptionAdmin : (0, $7Ya7f.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $7Ya7f.default).upgradePlan,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $7Ya7f.default).viewUsers,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $7Ya7f.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ]
    });

});
parcelRegister("7Ya7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $97084d0fb7d00df5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97084d0fb7d00df5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("66rnh", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $0d2c4bae7dd02578$export$b28f48897cdf7241);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $kQAZu = parcelRequire("kQAZu");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $c7H0g = parcelRequire("c7H0g");

var $bvGWz = parcelRequire("bvGWz");


const $0d2c4bae7dd02578$export$a4917c848b5c6ce8 = (0, $7rh0R.lazy)(()=>(parcelRequire("jIcF2")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0d2c4bae7dd02578$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $aa13349e4e2d4a46$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $aa13349e4e2d4a46$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $aa13349e4e2d4a46$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $aa13349e4e2d4a46$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $aa13349e4e2d4a46$export$a51af3c30283d234
};
const $0d2c4bae7dd02578$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $bvGWz.useAddPeople)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleInviteSuccess = (0, $eUqFw.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($0d2c4bae7dd02578$var$userInviteErrorCodes)){
            const errorMessage = $0d2c4bae7dd02578$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $eUqFw.useCallback)((errors)=>{
        const userInviteErrorsWithCode = {};
        errors.forEach((error)=>{
            // Group all errors by known user invite error codes
            const errorCode = extractErrorCode(error.message);
            if (errorCode) {
                if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                userInviteErrorsWithCode[errorCode].push(error);
            }
        });
        // Join messages with the same error code
        const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
            const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
            const messages = group.map((obj)=>obj.message).join('\n');
            return {
                message: messages,
                statusCode: statusCode
            };
        });
        groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
            onInviteError({
                modalType: 'Project',
                errorMessage: groupedUserInviteError.message,
                statusCode: groupedUserInviteError.statusCode
            });
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d2c4bae7dd02578$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        baseUrl: "",
        analyticsPrefix: "",
        allowFlags: false,
        onStopPerfMetric: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    })));
});

});
parcelRegister("jIcF2", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("6HI0g")
]).then(()=>parcelRequire('4urEy'));

});


parcelRegister("d1I0W", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $c68f3c6d5279f8a1$export$e3ec81c4d0451f63);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aOw1G = parcelRequire("aOw1G");

var $kQAZu = parcelRequire("kQAZu");

var $kGQen = parcelRequire("kGQen");

var $exb0h = parcelRequire("exb0h");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $d6f6c = parcelRequire("d6f6c");

var $6Ua7e = parcelRequire("6Ua7e");

var $jD3pk = parcelRequire("jD3pk");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $dWLk9 = parcelRequire("dWLk9");

var $c7H0g = parcelRequire("c7H0g");

var $f90H0 = parcelRequire("f90H0");

const $c68f3c6d5279f8a1$export$cbfde4f653ce234 = (0, $7rh0R.lazy)(()=>(parcelRequire("4XnGF")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $c68f3c6d5279f8a1$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $f90H0.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $f90H0.InvitationStatusEnum).INVITED;
};
const $c68f3c6d5279f8a1$var$LIST_ROUTES = [
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST)
];
const $c68f3c6d5279f8a1$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $c68f3c6d5279f8a1$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onInviteCompleteHandler = (0, $eUqFw.useCallback)((response)=>{
        if ($c68f3c6d5279f8a1$var$isFailureResponse(response)) {
            const { message: message, status: status } = response.failure;
            onInviteError({
                modalType: 'Instance',
                errorMessage: message,
                statusCode: status
            });
            return;
        }
        const inviteStatus = $c68f3c6d5279f8a1$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $eUqFw.useMemo)(()=>$c68f3c6d5279f8a1$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c68f3c6d5279f8a1$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dhjVW")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("dhjVW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e1vXm")
]).then(()=>parcelRequire('bagiu'));

});


parcelRegister("4XnGF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("evBHV")
]).then(()=>parcelRequire('6SUBw'));

});




parcelRegister("lN9KF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2c111225ccf1aa1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $iisnK = parcelRequire("iisnK");


var $jGcn0 = parcelRequire("jGcn0");

var $bvGWz = parcelRequire("bvGWz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $bWbSz = parcelRequire("bWbSz");

var $haoko = parcelRequire("haoko");

var $22Bf8 = parcelRequire("22Bf8");
const $b2c111225ccf1aa1$var$InviteTeammateButton = ({ onClick: onClick })=>{
    const { openAddPeopleModal: openAddPeopleModal } = (0, $bvGWz.useAddPeople)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [inviteOpenParam, setInviteOpenParam] = (0, $lB25E.useQueryParam)((0, $jGcn0.INVITE_OPEN_PARAM));
    const hasInviteOpenParam = inviteOpenParam === 'true';
    const { linksTarget: linksTarget } = (0, $bWbSz.useSummaryFeatures)();
    const handleClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        openAddPeopleModal();
        onClick(event);
    }, [
        onClick,
        openAddPeopleModal
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasInviteOpenParam) openAddPeopleModal(()=>{
            setInviteOpenParam(undefined);
        });
    }, [
        hasInviteOpenParam,
        openAddPeopleModal,
        setInviteOpenParam
    ]);
    const inviteTeammateIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22Bf8.InviteTeammateIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
        label: "",
        size: "small",
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`
    }));
    const buttonProps = linksTarget === '_blank' ? {
        href: `${window.location.href.replace('/embed', '')}?${0, $jGcn0.INVITE_OPEN_PARAM}=true`,
        target: '_blank'
    } : {
        onClick: handleClick
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22Bf8.InviteTeammateButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...buttonProps,
        iconBefore: inviteTeammateIcon,
        appearance: "subtle-link",
        testId: "business-summary.ui.summary-view.workload-by-assignee.invite-teammate.invite-teammate-button"
    }, formatMessage((0, $haoko.default).inviteTeammateButton)));
};
var $b2c111225ccf1aa1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b2c111225ccf1aa1$var$InviteTeammateButton);

});
parcelRegister("iisnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d51fec82b4cf5254$var$_react = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d51fec82b4cf5254$var$_personAdd = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("kdBCz")));
function $d51fec82b4cf5254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d51fec82b4cf5254$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d51fec82b4cf5254$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d51fec82b4cf5254$var$_personAdd.default
    }));
$d51fec82b4cf5254$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d51fec82b4cf5254$var$_default = module.exports.default = $d51fec82b4cf5254$var$InviteTeamIcon;

});
parcelRegister("kdBCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1db644828b4f838ff6385efd15aa7229>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb823455dae27cb1$var$_react = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $eb823455dae27cb1$var$_UNSAFE_baseNew = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $eb823455dae27cb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb823455dae27cb1$var$PersonAddIcon = (props)=>/*#__PURE__*/ $eb823455dae27cb1$var$_react.default.createElement($eb823455dae27cb1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$eb823455dae27cb1$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $eb823455dae27cb1$var$_default = module.exports.default = $eb823455dae27cb1$var$PersonAddIcon;

});


parcelRegister("haoko", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb201fa711a17ec$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ebb201fa711a17ec$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteTeammateButton: {
        "id": "business-summary.summary-view.workload-by-assignee.invite-teammate.invite-teammate-button.invite-teammate-button",
        "defaultMessage": "Invite teammate"
    }
});

});

parcelRegister("22Bf8", function(module, exports) {

$parcel$export(module.exports, "InviteTeammateButtonContainer", () => $87134ef863069a73$export$4a485f895a272d98);
$parcel$export(module.exports, "InviteTeammateIconContainer", () => $87134ef863069a73$export$f131e5fdcf18ca2f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $87134ef863069a73$export$4a485f895a272d98 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0196n _19pk12x7",
            __cmplp.className
        ])
    });
});
const $87134ef863069a73$export$f131e5fdcf18ca2f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3izwfg _1bsbzwfg _2rko1ssb _2hwx12x7 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk155y",
            __cmplp.className
        ])
    });
});

});



parcelRegister("28BoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $04dcfba65cb1489e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $04dcfba65cb1489e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "business-summary.summary-view.workload-by-assignee.title",
        "defaultMessage": "Team workload"
    },
    description: {
        "id": "business-summary.summary-view.workload-by-assignee.description",
        "defaultMessage": "Oversee the capacity of your team. {linkStart}Re-assign tasks across your team{linkEnd}"
    },
    descriptionWhenNoIssuesAssigned: {
        "id": "business-summary.summary-view.workload-by-assignee.description-when-no-issues-assigned",
        "defaultMessage": "Assign and share the workload in your team. {linkStart}Go to the list view{linkEnd}."
    },
    descriptionWhenEmpty: {
        "id": "business-summary.summary-view.workload-by-assignee.description-when-empty",
        "defaultMessage": "You'll need to create a few items to assign work to the right people in your team."
    },
    assigneeColumnHeader: {
        "id": "business-summary.summary-view.workload-by-assignee.assignee-column-header",
        "defaultMessage": "Assignee"
    },
    workloadColumnHeader: {
        "id": "business-summary.summary-view.workload-by-assignee.workload-column-header",
        "defaultMessage": "Work distribution"
    },
    countColumnHeader: {
        "id": "business-summary.summary-view.workload-by-assignee.count-column-header",
        "defaultMessage": "Count"
    },
    unassigned: {
        "id": "business-summary.summary-view.workload-by-assignee.unassigned",
        "defaultMessage": "Unassigned"
    }
});

});

parcelRegister("6z2gZ", function(module, exports) {

$parcel$export(module.exports, "CenteredSkeleton", () => $033a7e9546ea55d2$export$8faa72715fd79c70);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $nuJOT = parcelRequire("nuJOT");
const $033a7e9546ea55d2$export$8faa72715fd79c70 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $nuJOT.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("nuJOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b454c3f50803a651$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $b454c3f50803a651$var$Skeleton = ({ className: className, testId: testId })=>{
    const skeletonColor = `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 476 296",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "476",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "16",
        width: "320",
        height: "8",
        rx: "4",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "72",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "40",
        y: "80",
        width: "170",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "80",
        width: "156",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "398",
        y: "80",
        width: "78",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "120",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "40",
        y: "128",
        width: "170",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "128",
        width: "156",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "398",
        y: "128",
        width: "78",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "168",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "40",
        y: "176",
        width: "170",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "176",
        width: "156",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "398",
        y: "176",
        width: "78",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "216",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "40",
        y: "224",
        width: "170",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "224",
        width: "156",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "398",
        y: "224",
        width: "78",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        y: "264",
        width: "32",
        height: "32",
        rx: "16",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "40",
        y: "272",
        width: "170",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "272",
        width: "156",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "398",
        y: "272",
        width: "78",
        height: "16",
        rx: "8",
        fill: skeletonColor
    }));
};
var $b454c3f50803a651$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b454c3f50803a651$var$Skeleton);

});


parcelRegister("wjxfJ", function(module, exports) {

$parcel$export(module.exports, "Description", () => $a80af64664315c08$export$393edc798c47379d);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $a80af64664315c08$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("epPRq", function(module, exports) {

$parcel$export(module.exports, "getColor", () => $ee5caabedc5c2664$export$5551a2d24ff40153);

const $ee5caabedc5c2664$var$COLORS = [
    (0, $73a5c9d720aa66e1$export$940e1f69e873f202),
    (0, $73a5c9d720aa66e1$export$c6930421db9fa514),
    (0, $73a5c9d720aa66e1$export$4a7404f376229999),
    (0, $73a5c9d720aa66e1$export$e62e8919cca44969),
    (0, $73a5c9d720aa66e1$export$b48405b95304b5a1),
    (0, $73a5c9d720aa66e1$export$9dc1ef0f3f48059b)
];
const $ee5caabedc5c2664$export$5551a2d24ff40153 = (index)=>$ee5caabedc5c2664$var$COLORS[index % $ee5caabedc5c2664$var$COLORS.length];

});




parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});




//# sourceMappingURL=async-business-summary.eb99b126.js.map
